
/* ==== /js/105-tranquil-hms-extension-pack-v127-appended.js ==== */
/* ===== TRANQUIL HMS EXTENSION PACK v127 (appended) ===== */
/* ============================================================================
   TRANQUIL HMS — EXTENSION PACK v127
   Adds: Business Development module (Reports outline, HMO Claims submission,
   MOU upload, Tariffs upload, Business Partners registry, Bulk Email/SMS);
   Patient-profile sync (HMO head + Wellness summary);
   Front-desk billing fix (Approve & Bill + multi-payer, not just insurer);
   Pharmacy clinical/ops (full Prescription Prior-Auth, Lab Reflex rules, MAR);
   Automated per-user e-mail notifications (notification → mail outbox).
   Self-contained IIFE. Binds to the host's LIVE lexical `D`. Idempotent.
   ============================================================================ */
(function(){
  'use strict';

  /* ── tiny helpers (bare D = the live host state object) ─────────────────── */
  function XD(){ return (typeof D!=='undefined' && D) ? D : (typeof window!=='undefined'?window.D:{}); }
  var XID  = function(){ return (typeof nid==='function')?nid():('X'+Date.now()+Math.floor(Math.random()*1000)); };
  var XTOAST=function(m,t){ if(typeof toast==='function') toast(m,t); };
  var XMODAL=function(t,b,f,s){ if(typeof showModal==='function') showModal(t,b,f,s); };
  var XCLOSE=function(){ if(typeof closeModal==='function') closeModal(); };
  var XRENDER=function(){ if(typeof render==='function') render(); };
  var XSAVE =function(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} };
  var XTODAY=function(){ try{ return new Date().toISOString().slice(0,10); }catch(e){ return ''; } };
  var XUSER =function(){ var d=XD(); return (d.currentUser&&(d.currentUser.fullName||d.currentUser.name))||'System'; };
  var XROLE =function(){ var d=XD(); return (d.currentUser&&(d.currentUser.role||d.currentUser.roleName))||''; };
  var XMAIL =function(){ var d=XD(); return (d.currentUser&&d.currentUser.email)|| (d.settings&&d.settings.email) || 'user@tranquilhospital.ng'; };
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function gv(id){ var e=document.getElementById(id); return e?e.value:''; }
  function gn(id){ var v=parseFloat(gv(id)); return isNaN(v)?0:v; }
  function gck(id){ var e=document.getElementById(id); return !!(e&&e.checked); }
  function EF(n){ try{ return (typeof F==='function')?F(n):('\u20a6'+Number(n||0).toLocaleString()); }catch(e){ return '\u20a6'+(n||0); } }
  function patById(id){ var d=XD(); return (d.patients||[]).find(function(p){return p.id===id;})||null; }
  function patName(id){ var p=patById(id); return p?p.fullName:('Patient #'+id); }
  function provByName(nm){ var d=XD(); return (d.insuranceProviders||[]).find(function(p){return (p.name||'').toLowerCase()===String(nm||'').toLowerCase();})||null; }

  /* ── idempotent data + RBAC setup ───────────────────────────────────────── */
  function ensureExt(){
    var d=XD(); if(!d) return;
    d.partners            = d.partners            || [];
    d.mouDocs             = d.mouDocs             || [];
    d.tariffDocs          = d.tariffDocs          || [];
    d.hmoClaimBatches     = d.hmoClaimBatches     || [];
    d.bulkCampaigns       = d.bulkCampaigns       || [];
    d.emailOutbox         = d.emailOutbox         || [];
    d.priorAuthorizations = d.priorAuthorizations || [];
    d.reflexRules         = d.reflexRules         || [];
    d._bdTab              = d._bdTab              || 'reports';
    d._ppTab              = d._ppTab              || 'priorauth';
    if(!d.reflexRules.length){
      d.reflexRules = [
        {id:XID(), when:'TSH',        trigger:'abnormal', then:'Free T4 (FT4)',                 active:true, note:'Abnormal TSH auto-orders Free T4.'},
        {id:XID(), when:'Malaria',    trigger:'positive', then:'Full Blood Count (FBC)',        active:true, note:'Positive malaria reflexes to FBC.'},
        {id:XID(), when:'HbA1c',      trigger:'abnormal', then:'Fasting Blood Glucose',         active:true, note:'Abnormal HbA1c reflexes to fasting glucose.'},
        {id:XID(), when:'Creatinine', trigger:'abnormal', then:'eGFR / Renal Panel',            active:true, note:'High creatinine reflexes to eGFR / renal panel.'},
        {id:XID(), when:'Lipid',      trigger:'abnormal', then:'Fasting Lipid Profile (repeat)',active:true, note:'Abnormal lipids reflex to a fasting repeat.'}
      ];
    }
    var reg = {
      bizdev:      { id:'bizdev',      group:'Management',       label:'Business Development', icon:'fa-handshake',   enabled:true, locked:false },
      pharmacyplus:{ id:'pharmacyplus',group:'Clinical Support', label:'Pharmacy Clinical & Ops', icon:'fa-prescription', enabled:true, locked:false }
    };
    var roles = ['System Administrator','Super System Admin','CEO','CMO','CFO',
                 'Business Development Officer','Marketing','Front Desk','Receptionist',
                 'Cashier','Finance Manager','Accountant','Pharmacist','Pharmacy Technician','Doctor','Nurse'];
    function applyRBAC(obj){
      if(!obj) return;
      try{ obj.moduleRegistry=obj.moduleRegistry||{};
        Object.keys(reg).forEach(function(k){ if(!obj.moduleRegistry[k]) obj.moduleRegistry[k]=reg[k]; }); }catch(e){}
      try{ obj.responsibilities=obj.responsibilities||{};
        var bdRoles=['System Administrator','Super System Admin','CEO','CMO','CFO','Business Development Officer','Marketing','Finance Manager','Accountant'];
        var ppRoles=['System Administrator','Super System Admin','CMO','Pharmacist','Pharmacy Technician','Doctor','Nurse'];
        bdRoles.forEach(function(r){ obj.responsibilities[r]=obj.responsibilities[r]||{}; obj.responsibilities[r].bizdev=true; });
        ppRoles.forEach(function(r){ obj.responsibilities[r]=obj.responsibilities[r]||{}; obj.responsibilities[r].pharmacyplus=true; });
      }catch(e){}
    }
    applyRBAC(d);
    try{ if(typeof window!=='undefined' && window.D && window.D!==d) applyRBAC(window.D); }catch(e){}
  }

  /* ── shared bits ────────────────────────────────────────────────────────── */
  function tabBar(tabs, current, fn){
    return '<div style="display:flex;gap:6px;flex-wrap:wrap;border-bottom:2px solid var(--bdr);margin-bottom:16px">'+
      tabs.map(function(t){
        var on=(t.id===current);
        return '<button class="btn btn-sm" onclick="'+fn+'(\''+t.id+'\')" style="border:none;border-radius:8px 8px 0 0;background:'+(on?'var(--pri,#0d9488)':'transparent')+';color:'+(on?'#fff':'var(--txt2,#475569)')+';font-weight:'+(on?'700':'500')+'"><i class="fa-solid '+t.icon+'"></i> '+t.label+'</button>';
      }).join('')+'</div>';
  }
  function kpi(val,label,icon,color){
    return '<div class="kpi"><div class="kpi-icon" style="background:'+(color||'#0d9488')+'1a;color:'+(color||'#0d9488')+'"><i class="fa-solid '+icon+'"></i></div><div class="kpi-val">'+val+'</div><div class="kpi-label">'+label+'</div></div>';
  }
  function statusBadge(s){
    var c={Submitted:'#f59e0b',Pending:'#f59e0b','Under Review':'#3b82f6',Approved:'#22c55e',Authorized:'#22c55e',Paid:'#16a34a',Denied:'#ef4444',Rejected:'#ef4444','Sent (simulated)':'#22c55e',Active:'#22c55e',Draft:'#94a3b8'}[s]||'#64748b';
    return '<span class="badge" style="background:'+c+'1a;color:'+c+';font-weight:700;padding:2px 8px;border-radius:8px">'+esc(s)+'</span>';
  }

  /* ════════════════════════════════════════════════════════════════════════
     BUSINESS DEVELOPMENT MODULE
     ════════════════════════════════════════════════════════════════════════ */
  window.bdGo=function(tab){ var d=XD(); d._bdTab=tab; var el=document.getElementById('bdBody'); if(el) el.innerHTML=bdTabBody(tab); };

  window.renderBizDev=function(){
    ensureExt(); var d=XD();
    var tabs=[
      {id:'reports',  icon:'fa-chart-line', label:'Reports'},
      {id:'claims',   icon:'fa-file-medical', label:'HMO Claims'},
      {id:'mou',      icon:'fa-file-signature', label:'MOU'},
      {id:'tariffs',  icon:'fa-file-invoice-dollar', label:'Tariffs'},
      {id:'partners', icon:'fa-building', label:'Business Partners'},
      {id:'messaging',icon:'fa-bullhorn', label:'Bulk Email / SMS'}
    ];
    var html='<div class="content">';
    html+='<div class="card" style="background:linear-gradient(135deg,#0f766e,#0d9488);color:#fff;margin-bottom:14px"><h3 style="color:#fff;margin:0"><i class="fa-solid fa-handshake"></i> Business Development</h3><p style="color:#ccfbf1;font-size:12px;margin:4px 0 0">Partner management, HMO claims, MOUs &amp; tariffs, and outreach to all business partners.</p></div>';
    html+='<div class="kpi-grid" style="margin-bottom:14px">'+
      kpi((d.partners||[]).length,'Business Partners','fa-building','#0d9488')+
      kpi((d.insuranceProviders||[]).length,'HMOs / Insurers','fa-shield-halved','#3b82f6')+
      kpi((d.hmoClaimBatches||[]).length,'Claim Batches','fa-file-medical','#f59e0b')+
      kpi((d.bulkCampaigns||[]).length,'Campaigns Sent','fa-bullhorn','#8b5cf6')+'</div>';
    html+=tabBar(tabs, d._bdTab, 'bdGo');
    html+='<div id="bdBody">'+bdTabBody(d._bdTab)+'</div>';
    html+='</div>';
    return html;
  };

  function bdTabBody(tab){
    if(tab==='claims')   return bdClaims();
    if(tab==='mou')      return bdDocs('mou');
    if(tab==='tariffs')  return bdDocs('tariff');
    if(tab==='partners') return bdPartners();
    if(tab==='messaging')return bdMessaging();
    return bdReports();
  }

  /* — Reports outline + live mini-reports — */
  function bdSeedSample(){
    var d=XD(); if(window.__bdSeeded) return;
    var hmos=(d.insuranceProviders||[]).slice(0,4).map(function(p){return p.name;});
    if(!hmos.length){ window.__bdSeeded=true; return; }
    var t=XTODAY();
    if(!(d.hmoClaimBatches||[]).length){ d.hmoClaimBatches=d.hmoClaimBatches||[]; var st=['Submitted','Approved','Paid','Denied']; var vals=[450000,1200000,780000,300000];
      hmos.forEach(function(h,i){ d.hmoClaimBatches.push({ id:XID(), code:'CLB-'+(1001+i), hmo:h, items:[{},{},{}], value:vals[i]||500000, date:t, status:st[i%4] }); }); }
    if(!(d.mouDocs||[]).length){ d.mouDocs=d.mouDocs||[]; hmos.slice(0,2).forEach(function(h){ d.mouDocs.push({ id:XID(), title:'MOU — '+h, partner:h, fileName:'MOU_'+h.replace(/\s+/g,'_')+'.pdf', date:t }); }); }
    if(!(d.tariffDocs||[]).length){ d.tariffDocs=d.tariffDocs||[]; hmos.slice(0,2).forEach(function(h){ d.tariffDocs.push({ id:XID(), title:'Tariff Schedule — '+h, partner:h, fileName:'Tariff_'+h.replace(/\s+/g,'_')+'.xlsx', date:t }); }); }
    if(!(d.bulkCampaigns||[]).length){ d.bulkCampaigns=d.bulkCampaigns||[]; d.bulkCampaigns.push({ id:XID(), date:t, audience:'All registered patients', channel:'Email + SMS', subject:'Free health screening week', count:(d.patients||[]).length }); }
    window.__bdSeeded=true; try{ XSAVE(); }catch(e){}
  }
  function bdReports(){
    var d=XD();
    bdSeedSample();
    var reports=[
      ['Partner Portfolio','All corporate partners with coverage %, annual contract value, credit limit and contract expiry.','fa-building'],
      ['HMO / Insurer Register','All HMOs &amp; insurers, plan type and coverage band.','fa-shield-halved'],
      ['Claims Submission Summary','Claim batches submitted to each HMO with status (Submitted / Approved / Paid / Denied) and value.','fa-file-medical'],
      ['Revenue by Payer (HMO)','Billed value grouped by insurance provider across the patient base.','fa-coins'],
      ['Patient Coverage Mix','How many patients sit under each HMO vs. self-pay.','fa-chart-pie'],
      ['MOU & Tariff Register','Uploaded MOUs and tariff schedules per partner with upload dates.','fa-folder-open'],
      ['Outreach Campaigns','Bulk email / SMS campaigns with audience size and channel.','fa-bullhorn'],
      ['Contract Renewals Due','Partners whose contract end date is approaching.','fa-calendar-exclamation']
    ];
    var list='<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-list-check"></i> Reports available to Business Development</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Report</th><th>What it shows</th><th></th></tr></thead><tbody>'+
      reports.map(function(r){ return '<tr><td><i class="fa-solid '+r[2]+'" style="color:#0d9488;margin-right:6px"></i><b>'+r[0]+'</b></td><td style="font-size:12px;color:var(--txt2)">'+r[1]+'</td><td><button class="btn btn-xs btn-ghost" onclick="bdRunReport(\''+r[0].replace(/'/g,'')+'\')">Run</button></td></tr>'; }).join('')+
      '</tbody></table></div></div>';

    /* live: revenue by payer */
    var byPayer={};
    (d.patients||[]).forEach(function(p){
      var ins=p.insurance||'Self-Pay';
      var billed=(d.bills||[]).filter(function(b){return b.patientId===p.id;}).reduce(function(s,b){return s+(b.total||0);},0);
      byPayer[ins]=(byPayer[ins]||0)+billed;
    });
    var rev='<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-coins"></i> Revenue by Payer (live)</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Payer / HMO</th><th>Patients</th><th>Total Billed</th></tr></thead><tbody>'+
      Object.keys(byPayer).sort(function(a,b){return byPayer[b]-byPayer[a];}).map(function(k){
        var cnt=(d.patients||[]).filter(function(p){return (p.insurance||'Self-Pay')===k;}).length;
        return '<tr><td><b>'+esc(k)+'</b></td><td>'+cnt+'</td><td style="font-weight:700;color:#16a34a">'+EF(byPayer[k])+'</td></tr>';
      }).join('')+'</tbody></table></div></div>';
    return '<div style="display:grid;gap:14px">'+list+rev+'</div>';
  }
  function bdNorm(p){
    return {
      id:p.id, code:p.code||'',
      companyName:p.companyName||p.name||p.company||p.partnerName||p.fullName||'',
      partnershipType:p.partnershipType||p.type||p.partnerType||p.category||'',
      coveragePct:(p.coveragePct!=null?p.coveragePct:(p.coverage!=null?p.coverage:0)),
      annualValue:(+p.annualValue||+p.value||+p.annualContractValue||0),
      creditLimit:(+p.creditLimit||0),
      contractEnd:p.contractEnd||p.contractExpiry||p.expiry||'',
      status:p.status||'Active',
      contactPerson:p.contactPerson||'', phone:p.phone||'', email:p.email||''
    };
  }
  function bdEnsurePartners(){
    var d=XD(); d.partners=d.partners||[];
    if(d.partners.some(function(p){ return p && (p.companyName||p.name||p.company); })) return;
    /* instance has only blank/placeholder partners — restore the canonical corporate partners */
    d.partners=d.partners.filter(function(p){ return p && (p.companyName||p.name||p.company); });
    var seed=[
      ['Dangote Industries Ltd','Corporate Health Plan',80,24000000,5000000,'2026-12-31','Mr. Aliko Sani','+234-902-001-0001','hr@dangote.com'],
      ['MTN Nigeria','Corporate Wellness',90,18500000,3500000,'2026-06-30','Mrs. Ada Okonkwo','+234-902-001-0002','wellness@mtn.com.ng'],
      ['GTBank PLC','Executive Health',100,13500000,2500000,'2026-01-31','Mr. Olusegun Ade','+234-902-001-0003','hr@gtbank.com'],
      ['Shell Petroleum Development','Expatriate & Local Health',100,22000000,6000000,'2026-09-09','Mrs. Tomi James','+234-902-001-0004','medical@shell.com'],
      ['Federal Government Hospital Network','Government Referral',70,9500000,2000000,'2026-04-14','Dr. Bashir Mohammed','+234-902-001-0005','partnerships@fgn.gov.ng']
    ];
    seed.forEach(function(s,i){ d.partners.push({ id:XID(), code:'PT-'+String(d.partners.length+1).padStart(3,'0'), companyName:s[0], partnershipType:s[1], coveragePct:s[2], annualValue:s[3], creditLimit:s[4], contractEnd:s[5], contactPerson:s[6], phone:s[7], email:s[8], status:'Active', joinDate:XTODAY(), partyType:'Partner' }); });
    try{ XSAVE(); }catch(e){}
  }
  function bdPartnerSource(){
    var d=XD();
    bdEnsurePartners();
    var real=(d.partners||[]).map(bdNorm).filter(function(p){ return p.companyName; });
    if(real.length) return real;
    var rev={}; (d.bills||[]).forEach(function(b){ var pat=(d.patients||[]).find(function(p){return p.id===b.patientId;}); var pay=(pat&&pat.insurance)||'Self-Pay'; rev[pay]=(rev[pay]||0)+(+b.total||0); });
    var now=new Date(); var y=now.getFullYear();
    return (d.insuranceProviders||[]).map(function(p,idx){
      var mo=((p.id||idx+1))%12; var endY=(mo<now.getMonth())?y+1:y;
      return { companyName:p.name, partnershipType:p.type||'HMO / Insurer', coveragePct:p.coverage||0, annualValue:rev[p.name]||0, creditLimit:Math.round((rev[p.name]||0)*0.25), contractEnd:endY+'-'+String(mo+1).padStart(2,'0')+'-28', status:p.status||'Active', __derived:true };
    });
  }
  window.bdRunReport=function(name){
    var d=XD(); var body=''; var derivedNote='<div style="font-size:11px;color:var(--txt3);margin-bottom:8px"><i class="fa-solid fa-circle-info"></i> No corporate partners added yet — showing your '+ (d.insuranceProviders||[]).length +' registered HMOs/insurers as partners (annual value = live billed revenue per payer). Add corporate clients in the Business Partners tab to override.</div>';
    if(/Partner Portfolio/i.test(name)){
      var pp=bdPartnerSource();
      body=(pp.length&&pp[0].__derived?derivedNote:'')+'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Partner</th><th>Type</th><th>Coverage</th><th style="text-align:right">Annual Value</th><th style="text-align:right">Credit Limit</th><th>Contract End</th><th>Status</th></tr></thead><tbody>'+
        pp.map(function(p){return '<tr><td><b>'+esc(p.companyName)+'</b></td><td>'+esc(p.partnershipType||'')+'</td><td>'+(p.coveragePct||p.coverage||0)+'%</td><td style="text-align:right;font-weight:700;color:#16a34a">'+EF(p.annualValue||0)+'</td><td style="text-align:right">'+EF(p.creditLimit||0)+'</td><td>'+esc(p.contractEnd||'\u2014')+'</td><td>'+statusBadge(p.status||'Active')+'</td></tr>';}).join('')+
        '</tbody><tfoot><tr style="font-weight:800;background:#f0fdfa"><td colspan="3" style="text-align:right">TOTAL ('+pp.length+' partners)</td><td style="text-align:right">'+EF(pp.reduce(function(s,p){return s+(+p.annualValue||0);},0))+'</td><td colspan="3"></td></tr></tfoot></table></div>';
    } else if(/HMO|Insurer Register/i.test(name)){
      body='<div class="tbl-wrap"><table class="tbl"><thead><tr><th>HMO / Insurer</th><th>Type</th><th>Coverage</th><th>Status</th></tr></thead><tbody>'+
        (d.insuranceProviders||[]).map(function(p){return '<tr><td><b>'+esc(p.name)+'</b></td><td>'+esc(p.type||'')+'</td><td>'+(p.coverage||0)+'%</td><td>'+statusBadge(p.status||'Active')+'</td></tr>';}).join('')+'</tbody></table></div>';
    } else if(/Claims Submission/i.test(name)){
      var ic=d.insuranceClaims||[];
      var provName=function(id){ var p=(d.insuranceProviders||[]).find(function(x){return x.id===id||x.id===+id;}); return p?p.name:(id?('Provider '+id):'Unassigned'); };
      var byHmo={};
      ic.forEach(function(c){ var h=provName(c.providerId); if(!byHmo[h]) byHmo[h]={n:0,billed:0,approved:0,Submitted:0,Approved:0,Paid:0,Denied:0}; var g=byHmo[h]; g.n++; g.billed+=(+c.amountBilled||+c.amount||0); g.approved+=(+c.amountApproved||0); var st=c.status||'Submitted'; if(g[st]!=null) g[st]++; });
      var hk=Object.keys(byHmo).sort(function(a,b){return byHmo[b].billed-byHmo[a].billed;});
      var tB=ic.reduce(function(s,c){return s+(+c.amountBilled||+c.amount||0);},0), tA=ic.reduce(function(s,c){return s+(+c.amountApproved||0);},0);
      var live=hk.length?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>HMO / Insurer</th><th style="text-align:center">Claims</th><th style="text-align:center">Submitted</th><th style="text-align:center">Approved</th><th style="text-align:center">Paid</th><th style="text-align:center">Denied</th><th style="text-align:right">Billed</th><th style="text-align:right">Approved</th></tr></thead><tbody>'+
        hk.map(function(h){var g=byHmo[h];return '<tr><td><b>'+esc(h)+'</b></td><td style="text-align:center">'+g.n+'</td><td style="text-align:center">'+g.Submitted+'</td><td style="text-align:center;color:#0d9488">'+g.Approved+'</td><td style="text-align:center;color:#16a34a">'+g.Paid+'</td><td style="text-align:center;color:#dc2626">'+g.Denied+'</td><td style="text-align:right">'+EF(g.billed)+'</td><td style="text-align:right;font-weight:700;color:#16a34a">'+EF(g.approved)+'</td></tr>';}).join('')+
        '</tbody><tfoot><tr style="font-weight:800;background:#f0fdfa"><td>TOTAL ('+ic.length+' claims)</td><td colspan="5"></td><td style="text-align:right">'+EF(tB)+'</td><td style="text-align:right">'+EF(tA)+'</td></tr></tfoot></table></div>':'<p style="color:var(--txt3)">No insurance claims recorded yet — claims raised in the Insurance &amp; Claims module appear here.</p>';
      body='<div class="form-section"><span><i class="fa-solid fa-file-medical" style="margin-right:6px"></i>Live insurance claims by HMO</span></div>'+live+
           '<div class="form-section" style="margin-top:16px"><span><i class="fa-solid fa-layer-group" style="margin-right:6px"></i>Business Development claim batches</span></div>'+claimsTable();
    } else if(/Renewals/i.test(name)){
      var today0=new Date(); today0.setHours(0,0,0,0);
      var due=bdPartnerSource().map(function(p){ var end=new Date(p.contractEnd); var days=Math.round((end-today0)/86400000); return {p:p,days:days}; })
        .filter(function(x){ return !isNaN(x.days) && x.days<=180; })
        .sort(function(a,b){return a.days-b.days;});
      body=(bdPartnerSource()[0]&&bdPartnerSource()[0].__derived?derivedNote:'')+
        (due.length?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Partner</th><th>Contract End</th><th style="text-align:center">Days to Expiry</th><th style="text-align:right">Annual Value</th><th>Action</th></tr></thead><tbody>'+
        due.map(function(x){ var col=x.days<0?'#dc2626':(x.days<=60?'#f59e0b':'#0d9488'); var lbl=x.days<0?('Overdue '+Math.abs(x.days)+'d'):(x.days+' days'); return '<tr><td><b>'+esc(x.p.companyName)+'</b></td><td>'+esc(x.p.contractEnd)+'</td><td style="text-align:center;font-weight:700;color:'+col+'">'+lbl+'</td><td style="text-align:right">'+EF(x.p.annualValue||0)+'</td><td><span style="font-size:11px;color:'+col+'">'+(x.days<0?'Renew now':(x.days<=60?'Initiate renewal':'Schedule review'))+'</span></td></tr>'; }).join('')+
        '</tbody></table></div>':'<p style="color:#16a34a;padding:10px"><i class="fa-solid fa-circle-check"></i> No contracts approaching renewal in the next 180 days.</p>');
    } else if(/Revenue by Payer/i.test(name)){
      var rbp={}, rcnt={};
      (d.patients||[]).forEach(function(p){ var ins=p.insurance||'Self-Pay'; var billed=(d.bills||[]).filter(function(b){return b.patientId===p.id;}).reduce(function(s,b){return s+(+b.total||0);},0); rbp[ins]=(rbp[ins]||0)+billed; rcnt[ins]=(rcnt[ins]||0)+1; });
      var rk=Object.keys(rbp).sort(function(a,b){return rbp[b]-rbp[a];}); var rtot=rk.reduce(function(s,k){return s+rbp[k];},0);
      body=rk.length?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Payer / HMO</th><th style="text-align:center">Patients</th><th style="text-align:right">Total Billed</th><th style="text-align:right">Share</th></tr></thead><tbody>'+
        rk.map(function(k){return '<tr><td><b>'+esc(k)+'</b></td><td style="text-align:center">'+rcnt[k]+'</td><td style="text-align:right;font-weight:700;color:#16a34a">'+EF(rbp[k])+'</td><td style="text-align:right">'+(rtot?Math.round(rbp[k]/rtot*100):0)+'%</td></tr>';}).join('')+
        '</tbody><tfoot><tr style="font-weight:800;background:#f0fdfa"><td>TOTAL</td><td style="text-align:center">'+(d.patients||[]).length+'</td><td style="text-align:right">'+EF(rtot)+'</td><td style="text-align:right">100%</td></tr></tfoot></table></div>':'<p style="color:var(--txt3)">No billing data yet.</p>';
    } else if(/Coverage Mix/i.test(name)){
      var mix={}; (d.patients||[]).forEach(function(p){ var ins=p.insurance||'Self-Pay'; mix[ins]=(mix[ins]||0)+1; });
      var tp=(d.patients||[]).length; var mk=Object.keys(mix).sort(function(a,b){return mix[b]-mix[a];});
      body=tp?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Coverage / Payer</th><th style="text-align:center">Patients</th><th>Share</th></tr></thead><tbody>'+
        mk.map(function(k){var pct=Math.round(mix[k]/tp*100);return '<tr><td><b>'+esc(k)+'</b></td><td style="text-align:center">'+mix[k]+'</td><td>'+bar(pct,k==='Self-Pay'?'#f59e0b':'#0d9488')+'</td></tr>';}).join('')+
        '</tbody><tfoot><tr style="font-weight:800;background:#f0fdfa"><td>TOTAL</td><td style="text-align:center">'+tp+'</td><td>100%</td></tr></tfoot></table></div>':'<p style="color:var(--txt3)">No patients registered yet.</p>';
    } else if(/MOU|Tariff/i.test(name)){
      var dr=function(arr,type){ return (arr||[]).map(function(m){return '<tr><td>'+esc(type)+'</td><td><b>'+esc(m.title||'')+'</b></td><td>'+esc(m.partner||'\u2014')+'</td><td>'+esc(m.fileName||'\u2014')+'</td><td>'+esc(m.date||'')+'</td></tr>';}).join(''); };
      var rws=dr(d.mouDocs,'MOU')+dr(d.tariffDocs,'Tariff');
      body=rws?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Type</th><th>Title</th><th>Partner</th><th>File</th><th>Uploaded</th></tr></thead><tbody>'+rws+'</tbody></table></div>':'<p style="color:var(--txt3)">No MOUs or tariff schedules uploaded yet \u2014 use the MOU and Tariffs tabs to upload.</p>';
    } else if(/Outreach|Campaign/i.test(name)){
      var camp=d.bulkCampaigns||[];
      body=camp.length?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>When</th><th>Audience</th><th>Channel</th><th>Subject</th><th style="text-align:center">Recipients</th></tr></thead><tbody>'+
        camp.map(function(x){return '<tr><td>'+esc(x.date||'')+'</td><td>'+esc(x.audience||'')+'</td><td>'+esc(x.channel||'')+'</td><td>'+esc(x.subject||'\u2014')+'</td><td style="text-align:center">'+(x.count||0)+'</td></tr>';}).join('')+'</tbody></table></div>':'<p style="color:var(--txt3)">No campaigns sent yet \u2014 use the Bulk Email / SMS tab.</p>';
    } else {
      body='<div style="padding:14px;color:var(--txt2);font-size:13px"><i class="fa-solid fa-circle-info" style="color:#0d9488;margin-right:6px"></i>The <b>'+esc(name)+'</b> report has no dedicated data view. Related figures are available in the Business Development tabs (Partners, Claims, MOUs, Campaigns).</div>';
    }
    XMODAL('<i class="fa-solid fa-chart-line" style="color:#0d9488;margin-right:8px"></i>'+esc(name), body,
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button> <button class="btn btn-pri" onclick="if(typeof printContent===\'function\'){printContent(\''+esc(name)+'\',document.querySelector(\'.modal-body\').innerHTML)}else{window.print()}"><i class="fa-solid fa-print"></i> Print</button>','wide');
  };

  /* — HMO Claims submission — */
  function claimsTable(){
    var d=XD(); var b=d.hmoClaimBatches||[];
    if(!b.length) return '<p style="color:var(--txt3)">No claim batches yet.</p>';
    return '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Batch</th><th>HMO</th><th>Claims</th><th>Value</th><th>Submitted</th><th>Status</th><th></th></tr></thead><tbody>'+
      b.map(function(c){
        return '<tr><td><b>'+esc(c.code)+'</b></td><td>'+esc(c.hmo)+'</td><td>'+(c.items||[]).length+'</td><td style="font-weight:700">'+EF(c.value||0)+'</td><td>'+esc(c.date||'')+'</td><td>'+statusBadge(c.status)+'</td><td><div class="act-row">'+
          (c.status==='Submitted'?'<button class="act-btn edit" title="Mark Approved" onclick="bdClaimStatus(\''+c.id+'\',\'Approved\')"><i class="fa-solid fa-check"></i></button><button class="act-btn del" title="Mark Denied" onclick="bdClaimStatus(\''+c.id+'\',\'Denied\')"><i class="fa-solid fa-times"></i></button>':'')+
          (c.status==='Approved'?'<button class="act-btn" title="Mark Paid" onclick="bdClaimStatus(\''+c.id+'\',\'Paid\')"><i class="fa-solid fa-coins" style="color:#16a34a"></i></button>':'')+
          '</div></td></tr>';
      }).join('')+'</tbody></table></div>';
  }
  function bdClaims(){
    var d=XD();
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-file-medical"></i> Claims to HMOs</h3><button class="btn btn-pri btn-sm" onclick="bdNewClaim()"><i class="fa-solid fa-plus"></i> New Claim Batch</button></div>'+
      '<p style="font-size:12px;color:var(--txt2);margin:0 0 12px">Bundle billed services for insured patients into a batch and submit it to the HMO. Track approval and payment here.</p>'+
      claimsTable()+'</div>';
  }
  window.bdNewClaim=function(){
    var d=XD();
    var hmoOpts=(d.insuranceProviders||[]).map(function(p){return '<option>'+esc(p.name)+'</option>';}).join('');
    XMODAL('<i class="fa-solid fa-file-medical" style="color:#0d9488;margin-right:8px"></i>Submit Claim Batch to HMO',
      '<div class="form-grid">'+
        '<div class="form-group"><label>HMO / Insurer</label><select id="cl_hmo" oninput="bdClaimRefresh()">'+hmoOpts+'</select></div>'+
        '<div class="form-group"><label>Period / Reference</label><input id="cl_ref" placeholder="e.g. Jan 2026 batch"></div>'+
        '<div class="form-group full"><label>Eligible billed items (patients on this HMO)</label><div id="cl_items" style="max-height:240px;overflow:auto;border:1px solid var(--bdr);border-radius:8px;padding:8px">'+bdClaimItems()+'</div></div>'+
        '<div class="form-group full"><label>Notes</label><textarea id="cl_notes" rows="2"></textarea></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="bdSubmitClaim()"><i class="fa-solid fa-paper-plane"></i> Submit Batch</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  function bdClaimItems(){
    var d=XD(); var hmo=gv('cl_hmo')|| ((d.insuranceProviders||[])[0]||{}).name;
    var rows=[];
    (d.patients||[]).filter(function(p){return (p.insurance||'')===hmo;}).forEach(function(p){
      (d.bills||[]).filter(function(b){return b.patientId===p.id;}).forEach(function(b){
        rows.push({pid:p.id, name:p.fullName, bill:b.code, total:b.total||0});
      });
    });
    if(!rows.length) return '<div style="color:var(--txt3);font-size:12px">No billed items found for patients on this HMO.</div>';
    return rows.map(function(r,i){ return '<label style="display:flex;align-items:center;gap:8px;font-size:12px;padding:4px 0"><input type="checkbox" class="cl_cb" checked data-total="'+r.total+'" data-bill="'+esc(r.bill)+'" data-pid="'+r.pid+'"> <b>'+esc(r.bill)+'</b> · '+esc(r.name)+' · '+EF(r.total)+'</label>'; }).join('');
  }
  window.bdClaimRefresh=function(){ var el=document.getElementById('cl_items'); if(el) el.innerHTML=bdClaimItems(); };
  window.bdSubmitClaim=function(){
    var d=XD(); var hmo=gv('cl_hmo'); var items=[]; var value=0;
    document.querySelectorAll('.cl_cb').forEach(function(cb){ if(cb.checked){ var t=parseFloat(cb.getAttribute('data-total'))||0; value+=t; items.push({bill:cb.getAttribute('data-bill'), patientId:+cb.getAttribute('data-pid'), amount:t}); } });
    if(!items.length){ XTOAST('Select at least one billed item','err'); return; }
    var code='CLB-'+String((d.hmoClaimBatches.length+1)).padStart(4,'0');
    /* SYNC → Finance insuranceClaims: create one claim per billed item, linked to this batch */
    var prov=provByName(hmo); d.insuranceClaims=d.insuranceClaims||[]; var linked=[];
    items.forEach(function(it){
      var cc='CLM-'+code+'-'+(linked.length+1);
      d.insuranceClaims.push({ id:XID(), code:cc, patientId:it.patientId, providerId:prov?prov.id:null, billCode:it.bill,
        amountBilled:it.amount, amountApproved:0, status:'Submitted', date:XTODAY(), batchCode:code, source:'bizdev' });
      linked.push(cc);
    });
    d.hmoClaimBatches.unshift({ id:XID(), code:code, hmo:hmo, items:items, value:value, ref:gv('cl_ref'), notes:gv('cl_notes'), status:'Submitted', date:XTODAY(), by:XUSER(), linkedClaims:linked });
    notify('Claim batch submitted', code+' to '+hmo+' — '+items.length+' item(s), '+EF(value)+' · synced to Insurance Claims', 'finance', 'bizdev', code);
    XCLOSE(); XSAVE(); XTOAST('Claim batch '+code+' submitted to '+hmo); bdGo('claims');
  };
  window.bdClaimStatus=function(id,st){
    var d=XD(); var c=(d.hmoClaimBatches||[]).find(function(x){return x.id===id;}); if(!c) return;
    c.status=st; c.decisionDate=XTODAY();
    /* SYNC → Finance: propagate to the linked insuranceClaims */
    var prov=provByName(c.hmo); var covPct=prov?(prov.coverage||0):0;
    (d.insuranceClaims||[]).filter(function(x){return x.batchCode===c.code;}).forEach(function(cl){
      if(st==='Approved'){ cl.status='Approved'; cl.amountApproved=Math.round((cl.amountBilled||0)*covPct/100); cl.approvedDate=XTODAY(); }
      else if(st==='Paid'){ cl.status='Paid'; if(!cl.amountApproved) cl.amountApproved=Math.round((cl.amountBilled||0)*covPct/100); }
      else if(st==='Denied'){ cl.status='Rejected'; cl.amountApproved=0; }
    });
    notify('Claim '+c.code+' '+st, c.hmo+' — '+EF(c.value||0)+' · Insurance Claims updated', st==='Denied'?'er':'finance', 'bizdev', c.code);
    XSAVE(); XTOAST('Claim '+c.code+' marked '+st+' (Finance synced)'); bdGo('claims');
  };

  /* — MOU / Tariff upload — */
  function bdDocs(kind){
    var d=XD(); var arr=(kind==='mou')?d.mouDocs:d.tariffDocs;
    var title=(kind==='mou')?'Memoranda of Understanding (MOU)':'Tariff Schedules';
    var icon=(kind==='mou')?'fa-file-signature':'fa-file-invoice-dollar';
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid '+icon+'"></i> '+title+'</h3><button class="btn btn-pri btn-sm" onclick="bdUpload(\''+kind+'\')"><i class="fa-solid fa-upload"></i> Upload</button></div>'+
      '<p style="font-size:12px;color:var(--txt2);margin:0 0 12px">Store '+(kind==='mou'?'signed MOUs':'tariff/price schedules')+' against each partner or HMO. Files are kept in this browser with the rest of the data.</p>'+
      (arr.length? '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Title</th><th>Partner / HMO</th><th>File</th><th>Uploaded</th><th>By</th><th></th></tr></thead><tbody>'+
        arr.map(function(m){return '<tr><td><b>'+esc(m.title)+'</b></td><td>'+esc(m.partner||'')+'</td><td style="font-size:12px;color:var(--txt2)"><i class="fa-solid fa-paperclip"></i> '+esc(m.fileName||'—')+'</td><td>'+esc(m.date)+'</td><td>'+esc(m.by||'')+'</td><td><div class="act-row">'+
          (m.dataUrl?'<a class="act-btn" title="Open" href="'+m.dataUrl+'" download="'+esc(m.fileName||'file')+'"><i class="fa-solid fa-download"></i></a>':'')+
          '<button class="act-btn del" title="Delete" onclick="bdDelDoc(\''+kind+'\',\''+m.id+'\')"><i class="fa-solid fa-trash"></i></button></div></td></tr>';}).join('')+'</tbody></table></div>'
        : '<p style="color:var(--txt3)">Nothing uploaded yet.</p>')+'</div>';
  }
  window.bdUpload=function(kind){
    var d=XD();
    // Build a de-duplicated combined list: Corporate Partners + HMOs (insurance providers) + Agents.
    var seen={};
    function opt(label){ if(!label) return ''; var k=(''+label).trim().toLowerCase(); if(!k||seen[k]) return ''; seen[k]=1; return '<option>'+esc(label)+'</option>'; }
    var partnerOpts=(d.partners||[]).map(function(p){ return opt(p&&(p.companyName||p.name||p.company)); }).join('');
    var hmoOpts=(d.insuranceProviders||[]).map(function(p){ return opt(p&&p.name?(p.name+' (HMO)'):''); }).join('');
    var agentOpts=(d.agents||[]).map(function(a){
      if(!a) return '';
      var nm=a.fullName||a.name||''; var co=a.company||'';
      var label=nm&&co?(nm+' — '+co):(nm||co);
      return opt(label?(label+' (Agent)'):'');
    }).join('');
    var opts='';
    if(partnerOpts) opts+='<optgroup label="Corporate Partners">'+partnerOpts+'</optgroup>';
    if(hmoOpts) opts+='<optgroup label="HMOs">'+hmoOpts+'</optgroup>';
    if(agentOpts) opts+='<optgroup label="Agents">'+agentOpts+'</optgroup>';
    if(!opts) opts='<option value="">No partners, HMOs or agents found</option>';
    XMODAL('<i class="fa-solid fa-upload" style="color:#0d9488;margin-right:8px"></i>Upload '+(kind==='mou'?'MOU':'Tariff'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>Title</label><input id="up_title" placeholder="'+(kind==='mou'?'e.g. MTN Corporate Health MOU 2026':'e.g. Hygeia Tariff Schedule 2026')+'"></div>'+
        '<div class="form-group"><label>Partner / HMO / Agent</label><select id="up_partner">'+opts+'</select></div>'+
        '<div class="form-group full"><label>File</label><input id="up_file" type="file"></div>'+
        '<div class="form-group full"><label>Notes</label><textarea id="up_notes" rows="2"></textarea></div>'+
      '</div><div style="font-size:11px;color:var(--txt3)"><i class="fa-solid fa-circle-info"></i> Small files are stored inline; large files are recorded by name (browser storage limit).</div>',
      '<button class="btn btn-pri" onclick="bdSaveDoc(\''+kind+'\')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.bdSaveDoc=function(kind){
    var d=XD(); var title=gv('up_title'); if(!title){ XTOAST('Enter a title','err'); return; }
    var f=document.getElementById('up_file'); var file=f&&f.files&&f.files[0];
    function finish(dataUrl){
      var arr=(kind==='mou')?d.mouDocs:d.tariffDocs;
      arr.unshift({ id:XID(), title:title, partner:gv('up_partner'), fileName:file?file.name:'(no file)', dataUrl:dataUrl||null, notes:gv('up_notes'), date:XTODAY(), by:XUSER() });
      XCLOSE(); XSAVE(); XTOAST((kind==='mou'?'MOU':'Tariff')+' saved'); bdGo(kind==='mou'?'mou':'tariffs');
    }
    if(file && file.size<=2*1024*1024){ var r=new FileReader(); r.onload=function(){ finish(r.result); }; r.onerror=function(){ finish(null); }; r.readAsDataURL(file); }
    else finish(null);
  };
  window.bdDelDoc=function(kind,id){ var d=XD(); var key=(kind==='mou')?'mouDocs':'tariffDocs'; d[key]=(d[key]||[]).filter(function(x){return x.id!==id;}); XSAVE(); bdGo(kind==='mou'?'mou':'tariffs'); };

  /* — Business Partners registry — */
  function bdPartners(){
    var d=XD(); var pp=bdPartnerSource();
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-building"></i> All Business Partners</h3><button class="btn btn-pri btn-sm" onclick="bdNewPartner()"><i class="fa-solid fa-plus"></i> Add Partner</button></div>'+
      (pp.length&&pp[0].__derived?'<div style="font-size:11px;color:var(--txt3);margin:0 0 8px"><i class="fa-solid fa-circle-info"></i> Showing your registered HMOs/insurers as partners — add corporate clients with “Add Partner”.</div>':'')+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Company</th><th>Contact</th><th>Phone</th><th>Email</th><th>Type</th><th>Coverage</th><th>Annual Value</th><th>Status</th></tr></thead><tbody>'+
      pp.map(function(p){return '<tr><td><b>'+esc(p.code||'')+'</b></td><td><b>'+esc(p.companyName)+'</b></td><td>'+esc(p.contactPerson||'')+'</td><td>'+esc(p.phone||'')+'</td><td>'+esc(p.email||'')+'</td><td>'+esc(p.partnershipType||'')+'</td><td>'+(p.coveragePct||0)+'%</td><td style="text-align:right;font-weight:700;color:#16a34a">'+EF(p.annualValue||0)+'</td><td>'+statusBadge(p.status||'Active')+'</td></tr>';}).join('')+
      '</tbody></table></div></div>';
  }
  window.bdNewPartner=function(){
    XMODAL('<i class="fa-solid fa-building" style="color:#0d9488;margin-right:8px"></i>Add Business Partner',
      '<div class="form-grid">'+
        '<div class="form-group"><label>Company Name</label><input id="pp_name"></div>'+
        '<div class="form-group"><label>Contact Person</label><input id="pp_contact"></div>'+
        '<div class="form-group"><label>Phone</label><input id="pp_phone"></div>'+
        '<div class="form-group"><label>Email</label><input id="pp_email"></div>'+
        '<div class="form-group"><label>Partnership Type</label><input id="pp_type" placeholder="Corporate Health Plan / Referral / HMO"></div>'+
        '<div class="form-group"><label>Coverage %</label><input id="pp_cov" type="number" value="80"></div>'+
        '<div class="form-group"><label>Annual Value (\u20a6)</label><input id="pp_val" type="number"></div>'+
        '<div class="form-group"><label>Contract End</label><input id="pp_end" type="date"></div>'+
        '<div class="form-group full"><label>Address</label><input id="pp_addr"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="bdSavePartner()"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.bdSavePartner=function(){
    var d=XD(); var name=gv('pp_name'); if(!name){ XTOAST('Enter a company name','err'); return; }
    var code='PT-'+String((d.partners.length+1)).padStart(3,'0');
    d.partners.push({ id:XID(), code:code, companyName:name, contactPerson:gv('pp_contact'), phone:gv('pp_phone'), email:gv('pp_email'),
      partnershipType:gv('pp_type'), coveragePct:gn('pp_cov'), annualValue:gn('pp_val'), contractEnd:gv('pp_end'),
      address:gv('pp_addr'), status:'Active', joinDate:XTODAY(), partyType:'Partner' });
    XCLOSE(); XSAVE(); XTOAST('Partner '+name+' added'); bdGo('partners');
  };

  /* — Bulk Email / SMS — */
  function bdMessaging(){
    var d=XD();
    return '<div style="display:grid;gap:14px">'+
      '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-bullhorn"></i> Bulk Email / SMS</h3></div>'+
      '<div class="form-grid">'+
        '<div class="form-group"><label>Audience</label><select id="bm_aud"><option value="partners">All business partners</option><option value="hmos">All HMOs / insurers</option><option value="patients">All patients</option><option value="hmo">Patients on a specific HMO</option></select></div>'+
        '<div class="form-group"><label>Specific HMO (if selected)</label><select id="bm_hmo">'+(d.insuranceProviders||[]).map(function(p){return '<option>'+esc(p.name)+'</option>';}).join('')+'</select></div>'+
        '<div class="form-group"><label>Channel</label><select id="bm_ch"><option>Email</option><option>SMS</option><option>Email + SMS</option></select></div>'+
        '<div class="form-group"><label>Subject (email)</label><input id="bm_subj" placeholder="e.g. Annual health screening reminder"></div>'+
        '<div class="form-group full"><label>Message</label><textarea id="bm_msg" rows="4" placeholder="Compose your message…"></textarea></div>'+
      '</div>'+
      '<div style="font-size:11px;color:var(--txt3);margin:6px 0"><i class="fa-solid fa-circle-info"></i> This is a browser-only system, so messages are queued to the Outbox below (simulated send) rather than dispatched to a live mail/SMS gateway.</div>'+
      '<button class="btn btn-pri" onclick="bdSend()"><i class="fa-solid fa-paper-plane"></i> Send Campaign</button></div>'+
      '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-inbox"></i> Outbox / Campaign Log</h3></div>'+bdOutbox()+'</div>'+
    '</div>';
  }
  function bdOutbox(){
    var d=XD(); var c=d.bulkCampaigns||[];
    if(!c.length) return '<p style="color:var(--txt3)">No campaigns sent yet.</p>';
    return '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>When</th><th>Audience</th><th>Channel</th><th>Subject</th><th>Recipients</th><th>Status</th></tr></thead><tbody>'+
      c.map(function(x){return '<tr><td>'+esc(x.date)+'</td><td>'+esc(x.audience)+'</td><td>'+esc(x.channel)+'</td><td>'+esc(x.subject||'—')+'</td><td>'+x.count+'</td><td>'+statusBadge('Sent (simulated)')+'</td></tr>';}).join('')+'</tbody></table></div>';
  }
  window.bdSend=function(){
    var d=XD(); var aud=gv('bm_aud'); var ch=gv('bm_ch'); var subj=gv('bm_subj'); var msg=gv('bm_msg');
    if(!msg){ XTOAST('Enter a message','err'); return; }
    var recipients=[];
    if(aud==='partners') recipients=(d.partners||[]).map(function(p){return {to:p.email||p.companyName, name:p.companyName};});
    else if(aud==='hmos') recipients=(d.insuranceProviders||[]).map(function(p){return {to:(p.email||p.name), name:p.name};});
    else if(aud==='patients') recipients=(d.patients||[]).map(function(p){return {to:p.email||p.phone, name:p.fullName};});
    else if(aud==='hmo'){ var hmo=gv('bm_hmo'); recipients=(d.patients||[]).filter(function(p){return (p.insurance||'')===hmo;}).map(function(p){return {to:p.email||p.phone,name:p.fullName};}); }
    if(!recipients.length){ XTOAST('No recipients match that audience','err'); return; }
    var when=new Date().toLocaleString();
    recipients.forEach(function(r){ d.emailOutbox.unshift({ id:XID(), to:r.to, name:r.name, channel:ch, subject:subj, body:msg, kind:'campaign', status:'Sent (simulated)', date:when }); });
    d.bulkCampaigns.unshift({ id:XID(), audience:aud+(aud==='hmo'?(' · '+gv('bm_hmo')):''), channel:ch, subject:subj, body:msg, count:recipients.length, date:when, by:XUSER() });
    notify('Campaign sent', recipients.length+' recipient(s) via '+ch, 'system', 'bizdev');
    XSAVE(); XTOAST('Campaign queued to '+recipients.length+' recipient(s)'); bdGo('messaging');
  };

  /* ════════════════════════════════════════════════════════════════════════
     PHARMACY CLINICAL & OPERATIONS MODULE
     ════════════════════════════════════════════════════════════════════════ */
  window.ppGo=function(tab){ var d=XD(); d._ppTab=tab; var el=document.getElementById('ppBody'); if(el) el.innerHTML=ppTabBody(tab); };
  window.renderPharmaPlus=function(){
    ensureExt(); var d=XD();
    var tabs=[
      {id:'priorauth', icon:'fa-shield-halved', label:'Prescription Prior Auth'},
      {id:'reflex',    icon:'fa-vials',         label:'Lab Reflex Rules'},
      {id:'mar',       icon:'fa-clipboard-list',label:'MAR'}
    ];
    var pa=(d.priorAuthorizations||[]);
    var html='<div class="content">';
    html+='<div class="card" style="background:linear-gradient(135deg,#6d28d9,#7c3aed);color:#fff;margin-bottom:14px"><h3 style="color:#fff;margin:0"><i class="fa-solid fa-prescription"></i> Pharmacy — Clinical &amp; Operations</h3><p style="color:#ede9fe;font-size:12px;margin:4px 0 0">Prescription prior authorization, lab reflex rules, and the Medication Administration Record.</p></div>';
    html+='<div class="kpi-grid" style="margin-bottom:14px">'+
      kpi(pa.filter(function(x){return x.status==='Pending';}).length,'Pending Auth','fa-hourglass-half','#f59e0b')+
      kpi(pa.filter(function(x){return x.status==='Approved';}).length,'Authorized','fa-circle-check','#22c55e')+
      kpi((d.reflexRules||[]).filter(function(r){return r.active;}).length,'Active Reflex Rules','fa-vials','#3b82f6')+
      kpi(marCountToday(),'MAR Doses Today','fa-clipboard-list','#8b5cf6')+'</div>';
    html+=tabBar(tabs, d._ppTab, 'ppGo');
    html+='<div id="ppBody">'+ppTabBody(d._ppTab)+'</div>';
    html+='</div>';
    return html;
  };
  function ppTabBody(tab){
    if(tab==='reflex') return ppReflex();
    if(tab==='mar')    return ppMAR();
    return ppPriorAuth();
  }

  /* — Full Prescription Prior Authorization — */
  function tagRxPriorAuth(pid, med, status, code){
    try{
      var d=XD(); var m=String(med||'').toLowerCase(); if(!m) return;
      (d.prescriptions||[]).filter(function(r){return r.patientId===pid;}).forEach(function(r){
        var hit=(r.items||[]).some(function(it){ var n=String(it.name||'').toLowerCase(); return n && (n.indexOf(m)>-1 || m.indexOf(n)>-1); });
        if(hit){ r.priorAuthStatus=status; r.priorAuthCode=code; r.priorAuthMed=med; }
      });
    }catch(e){}
  }
  function ppPriorAuth(){
    var d=XD(); var pa=d.priorAuthorizations||[];
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-shield-halved"></i> Prescription Prior Authorization</h3><button class="btn btn-pri btn-sm" onclick="ppNewAuth()"><i class="fa-solid fa-plus"></i> New Request</button></div>'+
      '<p style="font-size:12px;color:var(--txt2);margin:0 0 12px">Request payer approval for high-cost / restricted medications before dispensing. A prescription cannot be cleared to dispense until its prior auth is <b>Approved</b>.</p>'+
      (pa.length?'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Ref</th><th>Patient</th><th>Medication</th><th>Insurer</th><th>Urgency</th><th>Status</th><th>Auth #</th><th>Actions</th></tr></thead><tbody>'+
        pa.map(function(a){return '<tr><td><b>'+esc(a.code||a.ref||a.id)+'</b></td><td>'+esc(a.patientName||patName(a.patientId))+'</td><td>'+esc(a.medication||'')+'</td><td>'+esc(a.insurer||'')+'</td><td>'+esc(a.urgency||'Standard')+'</td><td>'+statusBadge(a.status||'Pending')+'</td><td>'+esc(a.authNumber||'—')+'</td><td><div class="act-row">'+
          ((a.status==='Pending'||a.status==='Under Review')?'<button class="act-btn edit" title="Approve" onclick="ppAuthDecision(\''+a.id+'\',\'Approved\')"><i class="fa-solid fa-check"></i></button><button class="act-btn del" title="Deny" onclick="ppAuthDecision(\''+a.id+'\',\'Denied\')"><i class="fa-solid fa-times"></i></button>':'')+
          '<button class="act-btn" title="View" onclick="ppViewAuth(\''+a.id+'\')"><i class="fa-solid fa-eye"></i></button></div></td></tr>';}).join('')+'</tbody></table></div>'
        :'<p style="color:var(--txt3)">No prior-authorization requests yet.</p>')+'</div>';
  }
  window.ppNewAuth=function(){
    var d=XD();
    var patOpts=(d.patients||[]).map(function(p){return '<option value="'+p.id+'">'+esc(p.fullName)+' — '+esc(p.insurance||'Self-Pay')+'</option>';}).join('');
    XMODAL('<i class="fa-solid fa-shield-halved" style="color:#7c3aed;margin-right:8px"></i>New Prior Authorization',
      '<div class="form-grid">'+
        '<div class="form-group"><label>Patient</label><select id="pa_pat" onchange="ppAuthIns()">'+patOpts+'</select></div>'+
        '<div class="form-group"><label>Insurer / HMO</label><input id="pa_ins"></div>'+
        '<div class="form-group"><label>Medication Requiring Auth</label><input id="pa_med" placeholder="e.g. Adalimumab, Trastuzumab"></div>'+
        '<div class="form-group"><label>Diagnosis (ICD-10)</label><input id="pa_dx" placeholder="e.g. M06.9"></div>'+
        '<div class="form-group"><label>Urgency</label><select id="pa_urg"><option>Standard (5-7 days)</option><option>Urgent (24-48h)</option><option>Emergency (same day)</option></select></div>'+
        '<div class="form-group"><label>Alternatives Tried</label><input id="pa_alt" placeholder="e.g. Methotrexate — failed"></div>'+
        '<div class="form-group full"><label>Clinical Justification</label><textarea id="pa_just" rows="3"></textarea></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="ppSaveAuth()"><i class="fa-solid fa-paper-plane"></i> Submit</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(ppAuthIns,30);
  };
  window.ppAuthIns=function(){ var d=XD(); var p=patById(+gv('pa_pat')); var f=document.getElementById('pa_ins'); if(p&&f) f.value=p.insurance||''; };
  window.ppSaveAuth=function(){
    var d=XD(); var pid=+gv('pa_pat'); var med=gv('pa_med'); if(!med){ XTOAST('Enter the medication','err'); return; }
    var code='PA-'+String((d.priorAuthorizations.length+1)).padStart(4,'0');
    d.priorAuthorizations.unshift({ id:XID(), code:code, patientId:pid, patientName:patName(pid), insurer:gv('pa_ins'),
      medication:med, diagnosis:gv('pa_dx'), urgency:gv('pa_urg'), alternatives:gv('pa_alt'), justification:gv('pa_just'),
      status:'Pending', date:XTODAY(), by:XUSER(), authNumber:null });
    tagRxPriorAuth(pid, med, 'Pending', code);
    notify('Prior auth submitted', code+' — '+med+' for '+patName(pid), 'system', 'pharmacyplus', code);
    XCLOSE(); XSAVE(); XTOAST('Prior authorization '+code+' submitted'); ppGo('priorauth');
  };
  window.ppAuthDecision=function(id,decision){
    var d=XD(); var a=(d.priorAuthorizations||[]).find(function(x){return x.id===id;}); if(!a) return;
    a.status=decision; a.decisionDate=XTODAY(); a.decidedBy=XUSER();
    if(decision==='Approved') a.authNumber='AUTH-'+(Math.floor(Math.random()*900000)+100000);
    tagRxPriorAuth(a.patientId, a.medication, decision==='Approved'?'Authorized':'Denied', a.code);
    notify('Prior auth '+decision, (a.code||'')+' — '+(a.medication||'')+(a.authNumber?(' · '+a.authNumber):''), decision==='Denied'?'er':'system', 'pharmacyplus', a.code);
    XSAVE(); XTOAST('Prior auth '+decision+(a.authNumber?(' — '+a.authNumber):'')); ppGo('priorauth');
  };
  window.ppViewAuth=function(id){
    var d=XD(); var a=(d.priorAuthorizations||[]).find(function(x){return x.id===id;}); if(!a) return;
    XMODAL('Prior Authorization — '+esc(a.code||''),
      '<div class="detail-grid">'+
        ['Patient',a.patientName,'Insurer',a.insurer,'Medication',a.medication,'Diagnosis',a.diagnosis,'Urgency',a.urgency,'Alternatives',a.alternatives,'Status',a.status,'Auth #',a.authNumber||'—','Submitted',a.date,'By',a.by]
          .reduce(function(acc,v,i){ if(i%2===0) acc.push('<div class="detail-item"><div class="dl">'+esc(v)+'</div><div class="dv">'); else { acc[acc.length-1]+=esc(v||'—')+'</div></div>'; } return acc; },[]).join('')+
        '<div class="detail-item full"><div class="dl">Clinical Justification</div><div class="dv">'+esc(a.justification||'—')+'</div></div>'+
      '</div>',
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>');
  };
  /* make the existing Pharmacy "Prior Auth" buttons open the full workflow */
  window.showPriorAuthWorkflow=function(){ ensureExt(); if(typeof goTo==='function'){ goTo('pharmacyplus'); } var d=XD(); d._ppTab='priorauth'; setTimeout(function(){ ppGo('priorauth'); },50); };

  /* — Lab Reflex Rules — */
  function ppReflex(){
    var d=XD(); var rr=d.reflexRules||[];
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-vials"></i> Lab Reflex Rules</h3><div><button class="btn btn-sm" style="background:#3b82f6;color:#fff" onclick="ppRunReflex()"><i class="fa-solid fa-bolt"></i> Run Reflex Engine</button> <button class="btn btn-pri btn-sm" onclick="ppNewRule()"><i class="fa-solid fa-plus"></i> Add Rule</button></div></div>'+
      '<p style="font-size:12px;color:var(--txt2);margin:0 0 12px">A reflex rule automatically orders a follow-up test when a completed result meets a condition (e.g. an abnormal TSH automatically orders a Free T4). Run the engine to scan completed results and create the follow-up orders.</p>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>When test contains</th><th>Trigger</th><th>Auto-order</th><th>Active</th><th></th></tr></thead><tbody>'+
      rr.map(function(r){return '<tr><td><b>'+esc(r.when)+'</b></td><td>'+esc(r.trigger)+'</td><td>'+esc(r.then)+'</td><td>'+(r.active?'<span style="color:#22c55e">\u25cf Yes</span>':'<span style="color:#94a3b8">\u25cb No</span>')+'</td><td><div class="act-row"><button class="act-btn" title="Toggle" onclick="ppToggleRule(\''+r.id+'\')"><i class="fa-solid fa-power-off"></i></button><button class="act-btn del" title="Delete" onclick="ppDelRule(\''+r.id+'\')"><i class="fa-solid fa-trash"></i></button></div></td></tr>';}).join('')+
      '</tbody></table></div></div>';
  }
  window.ppNewRule=function(){
    XMODAL('<i class="fa-solid fa-vials" style="color:#7c3aed;margin-right:8px"></i>Add Reflex Rule',
      '<div class="form-grid">'+
        '<div class="form-group"><label>When test name contains</label><input id="rx_when" placeholder="e.g. TSH"></div>'+
        '<div class="form-group"><label>Trigger</label><select id="rx_trig"><option value="abnormal">Result is abnormal</option><option value="positive">Result is positive</option><option value="any">Any completed result</option></select></div>'+
        '<div class="form-group full"><label>Automatically order</label><input id="rx_then" placeholder="e.g. Free T4 (FT4)"></div>'+
        '<div class="form-group full"><label>Note</label><input id="rx_note"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="ppSaveRule()"><i class="fa-solid fa-save"></i> Save Rule</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.ppSaveRule=function(){
    var d=XD(); var w=gv('rx_when'), t=gv('rx_then'); if(!w||!t){ XTOAST('Fill both fields','err'); return; }
    d.reflexRules.push({ id:XID(), when:w, trigger:gv('rx_trig')||'abnormal', then:t, active:true, note:gv('rx_note') });
    XCLOSE(); XSAVE(); XTOAST('Reflex rule added'); ppGo('reflex');
  };
  window.ppToggleRule=function(id){ var d=XD(); var r=(d.reflexRules||[]).find(function(x){return x.id===id;}); if(r){ r.active=!r.active; XSAVE(); ppGo('reflex'); } };
  window.ppDelRule=function(id){ var d=XD(); d.reflexRules=(d.reflexRules||[]).filter(function(x){return x.id!==id;}); XSAVE(); ppGo('reflex'); };
  window.ppRunReflex=function(){
    var d=XD(); var created=0;
    var labs=(d.labTests||[]);
    (d.reflexRules||[]).filter(function(r){return r.active;}).forEach(function(rule){
      labs.slice().forEach(function(o){
        if((o.status||'')!=='Completed') return;
        var nm=(o.testType||'').toLowerCase();
        if(nm.indexOf(rule.when.toLowerCase())===-1) return;
        var res=(o.results||'')+'';
        var fire=false;
        if(rule.trigger==='abnormal') fire=!!o.isAbnormal || /high|low|abnormal|critical/i.test(res);
        else if(rule.trigger==='positive') fire=/positive|reactive|detected/i.test(res);
        else fire=true;
        if(!fire) return;
        var marker='reflex:'+rule.id;
        var dup=labs.some(function(x){return x.reflexFrom===o.code && x.reflexRule===rule.id;});
        if(dup) return;
        var code='LAB-RX'+String(labs.length+1+created).padStart(3,'0');
        labs.push({ id:XID(), code:code, patientId:o.patientId, orderedBy:o.orderedBy||0, testType:rule.then, category:'Reflex',
          orderDate:XTODAY(), priority:'Reflex', status:'Pending', results:null, isAbnormal:false, reflexFrom:o.code, reflexRule:rule.id, approvalStatus:'Approved', approvedBy:'Reflex Engine' });
        created++;
        notify('Reflex test ordered', rule.then+' for '+patName(o.patientId)+' (from '+o.code+')', 'system', 'laboratory', code);
      });
    });
    XSAVE(); XTOAST(created?(created+' reflex test(s) auto-ordered'):'No results matched active reflex rules'); ppGo('reflex');
  };

  /* — MAR (explainer + bridge to existing showMAR) — */
  function marCountToday(){ var d=XD(); if(Array.isArray(d.marRecords)&&d.marRecords.length) return d.marRecords.length; return (d.prescriptions||[]).filter(function(r){return r.status==='Active';}).length; }
  function freqToSchedule(freq){
    var f=String(freq||'').toUpperCase();
    if(/QID|QDS|6 ?HOURLY|Q6/.test(f)) return ['06:00','12:00','18:00','22:00'];
    if(/TID|TDS|8 ?HOURLY|Q8/.test(f)) return ['08:00','14:00','20:00'];
    if(/BID|BD|12 ?HOURLY|Q12|TWICE/.test(f)) return ['08:00','20:00'];
    if(/QHS|NOCTE|NIGHT/.test(f)) return ['22:00'];
    if(/OD|DAILY|ONCE|Q24/.test(f)) return ['08:00'];
    return ['08:00','20:00'];
  }
  window.ppGenMAR=function(){
    var d=XD(); d.marRecords=d.marRecords||[]; var made=0;
    (d.prescriptions||[]).filter(function(r){return (r.status||'')==='Active';}).forEach(function(rx){
      var pn=patName(rx.patientId);
      (rx.items||[]).forEach(function(it){
        if(d.marRecords.some(function(m){return m.rxId===rx.id && m.drug===(it.name||'');})) return;
        d.marRecords.push({ id:XID(), rxId:rx.id, patientId:rx.patientId, patientName:pn, drug:it.name||'Medication',
          route:it.route||'PO', frequency:it.frequency||it.freq||'BD', schedule:freqToSchedule(it.frequency||it.freq), given:[], missed:[] });
        made++;
      });
    });
    XSAVE(); XTOAST(made?(made+' MAR line(s) generated from active prescriptions'):'MAR already up to date (or no active prescriptions)'); ppGo('mar');
  };
  function ppMAR(){
    var d=XD(); var cnt=(d.marRecords||[]).length;
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-clipboard-list"></i> Medication Administration Record (MAR)</h3><div><button class="btn btn-sm" style="background:#3b82f6;color:#fff" onclick="ppGenMAR()"><i class="fa-solid fa-rotate"></i> Generate from Active Rx</button> <button class="btn btn-pri btn-sm" onclick="(typeof showMAR===\'function\')?showMAR():toast(\'MAR opens from Pharmacy\')"><i class="fa-solid fa-table"></i> Open MAR Sheet</button></div></div>'+
      '<div style="font-size:13px;color:var(--txt2);line-height:1.6">'+
      '<p><b>What is the MAR?</b> The Medication Administration Record is the nurse-facing chart that lists every active medication for an inpatient and the exact times each dose is due. As doses are given, the nurse marks them <b>Given</b>, <b>Missed</b> or <b>Held</b>, creating a complete, time-stamped record of what was actually administered — the legal record of medication administration and the safety check against the prescription.</p>'+
      '<p>Each row is one drug (with its route and frequency); each column is a scheduled time slot. Tap a slot to cycle its status. The MAR is generated from active prescriptions and ties back to dispensing and the drug formulary.</p>'+
      '<p style="font-size:12px;color:var(--txt3)">There '+(cnt===1?'is':'are')+' currently <b>'+cnt+'</b> MAR line(s) on record. Use <b>Generate from Active Rx</b> to build the sheet from active prescriptions, then <b>Open MAR Sheet</b> to chart doses.</p>'+
      '<ul style="margin:8px 0 0 18px"><li>Confirms the right drug, dose, route, time and patient (the "five rights").</li><li>Flags missed or held doses so they are followed up.</li><li>Provides the audit trail required for controlled drugs and inspections.</li></ul>'+
      '</div></div>';
  }

  /* ════════════════════════════════════════════════════════════════════════
     PATIENT PROFILE SYNC — HMO head + Wellness summary (DOM injection)
     ════════════════════════════════════════════════════════════════════════ */
  function wellnessSummaryFor(pid){
    var d=XD();
    var l1=(d.wellnessScreenings||[]).filter(function(x){return x.patientId===pid;});
    var l2=(d.wellnessRiskAssessments||[]).filter(function(x){return x.patientId===pid;});
    var l3=(d.comprehensiveAssessments||[]).filter(function(x){return x.patientId===pid;});
    function last(a){ return a.length?a[a.length-1]:null; }
    function band(r){ if(!r) return '—'; var c=/Severe|High/i.test(r)?'#ef4444':/Moderate|Mild/i.test(r)?'#f59e0b':'#22c55e'; return '<span class="badge" style="background:'+c+'1a;color:'+c+';font-weight:700;padding:1px 7px;border-radius:7px">'+esc(r)+'</span>'; }
    if(!l1.length && !l2.length && !l3.length) return '<div style="font-size:12px;color:var(--txt3)">No wellness screening on record. Open <b>Wellness Screening</b> to run a Level 1 screening.</div>';
    var a=last(l1), b=last(l2), c=last(l3);
    return '<div style="display:flex;gap:18px;flex-wrap:wrap;font-size:12px">'+
      '<div><div style="color:var(--txt3)">L1 Rapid Screening</div><div>'+(a?band(a.risk)+' <span style="color:var(--txt3)">('+esc(a.date||'')+')</span>':'—')+'</div></div>'+
      '<div><div style="color:var(--txt3)">L2 Risk Assessment</div><div>'+(b?band(b.risk)+(b.malnRisk?(' · Malnutrition '+band(b.malnRisk)):''):'—')+'</div></div>'+
      '<div><div style="color:var(--txt3)">L3 Comprehensive</div><div>'+(c?band(c.risk)+(c.dietPlan?(' · '+esc(c.dietPlan)):''):'—')+'</div></div>'+
    '</div>';
  }
  function injectPatientPanels(pid){
    try{
      var body=document.querySelector('#modalBg .modal-body'); if(!body) return;
      if(body.querySelector('#extPatientHMO')) return;
      var p=patById(pid); if(!p) return;
      var prov=provByName(p.insurance);
      var ins=p.insurance||'Self-Pay';
      var isHmo=prov||/hmo|nhis|axa|leadway|reliance|hygeia|insurance/i.test(ins);
      var head='<div id="extPatientHMO" style="margin:4px 0 14px;padding:12px 14px;border-radius:12px;background:'+(isHmo?'linear-gradient(135deg,#1e3a8a,#3b82f6)':'#f1f5f9')+';color:'+(isHmo?'#fff':'#0f172a')+';display:flex;align-items:center;gap:14px;flex-wrap:wrap">'+
        '<div style="font-size:22px"><i class="fa-solid fa-shield-halved"></i></div>'+
        '<div style="flex:1;min-width:160px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:1px;opacity:.8">HMO / Payer</div><div style="font-size:16px;font-weight:800">'+esc(ins)+'</div>'+
          (prov?'<div style="font-size:11px;opacity:.9">'+esc(prov.type||'')+' · Coverage '+(prov.coverage||0)+'%</div>':'')+'</div>'+
        '<div style="text-align:right"><div style="font-size:10px;opacity:.8">Policy No.</div><div style="font-weight:700">'+esc(p.insuranceNo||'—')+'</div></div>'+
      '</div>';
      var wellness='<div style="margin-top:14px;padding:12px 14px;border-radius:12px;background:#f0fdfa;border:1px solid #99f6e4"><div style="font-weight:800;font-size:13px;margin-bottom:8px"><i class="fa-solid fa-heart-pulse" style="color:#0d9488"></i> Wellness Screening</div>'+wellnessSummaryFor(pid)+'</div>';
      var d2=XD();
      var pa=(d2.priorAuthorizations||[]).filter(function(x){return x.patientId===pid;});
      var cl=(d2.insuranceClaims||[]).filter(function(x){return x.patientId===pid;});
      var clinical='';
      if(pa.length||cl.length){
        clinical='<div style="margin-top:14px;padding:12px 14px;border-radius:12px;background:#f8fafc;border:1px solid var(--bdr)"><div style="font-weight:800;font-size:13px;margin-bottom:8px"><i class="fa-solid fa-shield-halved" style="color:#3b82f6"></i> Authorizations &amp; Claims</div><div style="font-size:12px;color:var(--txt2);line-height:1.7">'+
          (pa.length?('<div><b>Prior auth:</b> '+pa.slice(0,3).map(function(a){return esc(a.medication||'')+' — '+esc(a.status);}).join('; ')+'</div>'):'')+
          (cl.length?('<div><b>Claims:</b> '+cl.length+' on record · '+EF(cl.reduce(function(s,c){return s+(c.amountBilled||0);},0))+' billed</div>'):'')+
        '</div></div>';
      }
      var grid=body.querySelector('.detail-grid');
      if(grid){ grid.insertAdjacentHTML('beforebegin', head); grid.insertAdjacentHTML('afterend', wellness+clinical); }
      else { body.insertAdjacentHTML('afterbegin', head+wellness+clinical); }
    }catch(e){}
  }

  /* ════════════════════════════════════════════════════════════════════════
     PATIENT LIST — at-a-glance HMO / Payer column
     ════════════════════════════════════════════════════════════════════════ */
  function wirePatientList(){
    if(typeof window.renderPatients!=='function' || window.renderPatients._extWrapped) return;
    var _rp=window.renderPatients;
    var f=function(){
      var html=_rp.apply(this, arguments);
      try{
        if(typeof html!=='string') return html;
        /* IDEMPOTENCY GUARD (v164): if a payer column was already injected
           (e.g. by a stacked re-wrap), do NOT inject again — this prevents the
           runaway duplicate "HMO / Payer" pills that flooded the table. */
        if(/<th>\s*HMO\s*\/\s*Payer\s*<\/th>/i.test(html)) return html;
        html=html.replace(/<th>Room<\/th>\s*<th>Actions<\/th>/, '<th>Room</th><th>HMO / Payer</th><th>Actions</th>');
        html=html.replace(/<td>\s*<div class="act-row">\s*<button class="act-btn" title="View" onclick="(?:V25_)?viewPatient\((\d+)\)/g, function(m,pid){
          var p=patById(+pid); var ins=p?(p.insurance||'Self-Pay'):'\u2014';
          var prov=provByName(ins); var isHmo=prov||/hmo|nhis|axa|leadway|reliance|hygeia/i.test(ins);
          var badge='<span class="badge" style="background:'+(isHmo?'#1e3a8a':'#e2e8f0')+';color:'+(isHmo?'#fff':'#475569')+';font-weight:700;padding:2px 8px;border-radius:8px;font-size:10px;white-space:nowrap"><i class="fa-solid fa-shield-halved"></i> '+esc(ins)+'</span>';
          return '<td>'+badge+'</td>'+m;
        });
      }catch(e){}
      return html;
    };
    f._extWrapped=true; window.renderPatients=f;
  }

  /* ════════════════════════════════════════════════════════════════════════
     FRONT-DESK BILLING FIX — Approve & Bill + multi-payer (not only insurer)
     ════════════════════════════════════════════════════════════════════════ */
  function wireBilling(){
    if(typeof window.lroBill!=='function' || window.lroBill._extWrapped) return;
    var _orig=window.lroBill;
    var _confirm=window.lroConfirmBill;
    window.lroBill=function(kind,id){
      try{
        var d=XD(); var arr=(kind==='lab')?d.labTests:d.radiologyOrders;
        var o=(arr||[]).find(function(x){return x.id===id;});
        if(!o){ return _orig(kind,id); }
        if(o.billCode){ XTOAST('Already billed: '+o.billCode); return; }
        var nm=(kind==='lab')?o.testType:o.examType;
        var price=o.price||0;
        var approved=((o.approvalStatus||'Pending')==='Approved');
        var p=patById(o.patientId);
        var hmoOpts=(d.insuranceProviders||[]).map(function(x){return '<option value="HMO|'+esc(x.name)+'"'+((p&&p.insurance===x.name)?' selected':'')+'>HMO/Insurer — '+esc(x.name)+'</option>';}).join('');
        var partnerOpts=(d.partners||[]).map(function(x){return '<option value="Corporate|'+esc(x.companyName)+'">Corporate Partner — '+esc(x.companyName)+'</option>';}).join('');
        var body=(!approved?'<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:8px 10px;font-size:12px;color:#1e40af;margin-bottom:10px"><i class="fa-solid fa-circle-info"></i> This order is not yet approved. Tick <b>Approve now</b> below to approve and bill in one step.</div>':'')+
          '<div class="form-grid">'+
          '<div class="form-group"><label>Patient</label><input value="'+esc(patName(o.patientId))+'" readonly style="background:#f8fafc"></div>'+
          '<div class="form-group"><label>'+(kind==='lab'?'Test':'Exam')+'</label><input value="'+esc(nm||'')+'" readonly style="background:#f8fafc"></div>'+
          '<div class="form-group full"><label>Bill To / Payer</label><select id="lro_payer"><option value="Self-Pay|Self-Pay">Self-Pay (patient)</option>'+hmoOpts+partnerOpts+'<option value="Agent|Agent / Other">Agent / Other organisation</option></select></div>'+
          '<div class="form-group"><label>Amount (\u20a6) <span class="req">*</span></label><input id="lro_bamt" type="number" value="'+price+'" style="font-weight:700;font-size:16px"></div>'+
          '<div class="form-group"><label>Bill Date</label><input id="lro_bdate" type="date" value="'+(o.orderDate||XTODAY())+'"></div>'+
          '</div>'+
          (!approved?'<label style="display:flex;align-items:center;gap:8px;font-size:13px;margin-top:8px"><input type="checkbox" id="lro_approve" checked> <b>Approve now</b> and bill (recommended)</label>':'')+
          '<div style="font-size:11px;color:var(--txt3);margin-top:8px"><i class="fa-solid fa-circle-info"></i> Posts a receivable to Billing &amp; the General Ledger, tagged to the selected payer.</div>';
        XMODAL('<i class="fa-solid fa-file-invoice-dollar" style="color:#2563eb;margin-right:8px"></i>Generate Bill — '+esc(o.code), body,
          '<button class="btn btn-pri" onclick="extLroConfirmBill(\''+kind+'\','+id+')"><i class="fa-solid fa-file-invoice-dollar"></i> '+(!approved?'Approve &amp; Bill':'Generate Bill')+'</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
      }catch(e){ return _orig(kind,id); }
    };
    window.lroBill._extWrapped=true;

    window.extLroConfirmBill=function(kind,id){
      var d=XD(); var arr=(kind==='lab')?d.labTests:d.radiologyOrders;
      var o=(arr||[]).find(function(x){return x.id===id;}); if(!o){ XCLOSE(); return; }
      /* approve now if requested */
      var apprEl=document.getElementById('lro_approve');
      if(apprEl && apprEl.checked && (o.approvalStatus||'Pending')!=='Approved'){
        o.approvalStatus='Approved'; o.approvedBy=XUSER(); o.approvedDate=XTODAY();
      }
      /* capture payer */
      var payer=(gv('lro_payer')||'Self-Pay|Self-Pay').split('|');
      var payerType=payer[0], payerName=payer[1]||payer[0];
      /* delegate to host confirm (reads lro_bamt/lro_bdate, makes the bill, closes, saves, renders) */
      try{ if(typeof _confirm==='function'){ _confirm(kind,id); } }catch(e){}
      /* stamp payer onto the created bill */
      try{
        var d2=XD(); var b=(d2.bills||[]).find(function(x){return x.code===o.billCode || x.id===o.billId;});
        if(b){ b.payerType=payerType; b.payerName=payerName; if(payerType!=='Self-Pay'){ b.notes=(b.notes||'')+' · Payer: '+payerName; } }
        XSAVE();
      }catch(e){}
      XTOAST('Bill generated'+(payerType!=='Self-Pay'?(' — payer: '+payerName):'')+(o.approvedBy?' (order approved)':''));
    };
  }

  /* ════════════════════════════════════════════════════════════════════════
     AUTOMATED PER-USER EMAIL NOTIFICATIONS — notification → mail outbox
     ════════════════════════════════════════════════════════════════════════ */
  function notify(title,msg,type,module,recordId){
    if(typeof pushNotification==='function'){ pushNotification(title,msg,type,module,recordId); }
    else { var d=XD(); d.notifications=d.notifications||[]; d.notifications.unshift({id:XID(),date:new Date().toLocaleString(),type:type||'system',title:title,msg:msg,read:false}); }
  }
  function wireEmailAutomation(){
    if(typeof window.pushNotification!=='function' || window.pushNotification._extMail) return;
    var _orig=window.pushNotification;
    var wrapped=function(title,msg,type,module,recordId){
      var r=_orig.apply(this, arguments);
      try{
        var d=XD();
        if(d.settings && String(d.settings.emailNotifications)==='false') return r;
        d.emailOutbox=d.emailOutbox||[];
        d.emailOutbox.unshift({ id:XID(), to:XMAIL(), name:XUSER(), channel:'Email', subject:'['+(module||'HMS')+'] '+title, body:msg, kind:'auto-notification', status:'Sent (simulated)', date:new Date().toLocaleString() });
        if(d.emailOutbox.length>500) d.emailOutbox.length=500;
      }catch(e){}
      return r;
    };
    wrapped._extMail=true;
    window.pushNotification=wrapped;
  }

  /* ════════════════════════════════════════════════════════════════════════
     TRANSACTIONS — detailed Receivable → Receipt → GL lifecycle (all bills)
     Leverages the host double-entry engine: pushing a bill fires bill.created
     (Dr AR 1020 / Cr revenue); pushing a Payment txn fires payment.received
     (Dr Cash / Cr AR) and settles the bill. We surface and drive that here.
     ════════════════════════════════════════════════════════════════════════ */
  function jeBySource(src){ var d=XD(); return (d.journalEntries||[]).find(function(j){return j.source===src;}); }
  function billSource(b){
    if(b.source) return b.source.charAt(0).toUpperCase()+b.source.slice(1);
    var c=String(b.code||'');
    if(/^BIL-?L/i.test(c)) return 'Laboratory';
    if(/^BIL-?D/i.test(c)) return 'Discharge';
    if(/^BIL-?R/i.test(c)) return 'Radiology';
    return b.type||'Billing';
  }
  function billBal(b){ var t=(b.total!=null?b.total:(b.amount||0)); return (b.balance!=null?b.balance:t-(b.paid||0)); }
  /* Resolve the party responsible for a bill: explicit payer, HMO/insurer, agent, or self-pay (the patient). */
  function billPayer(b){
    try{
      if(b.payer) return b.payer;
      if(b.payerName) return b.payerName;
      if(b.agent) return b.agent;
      var D=(typeof XD==='function'?XD():(window.D||{}));
      var p=(D.patients||[]).find(function(x){return String(x.id)===String(b.patientId);});
      var ins = (p&&p.cardData&&p.cardData.hmo) ? p.cardData.hmo : (p?p.insurance:null);
      if(ins && ins!=='None' && ins!=='Self-Pay' && ins!=='Self-pay') return ins;
    }catch(e){}
    return 'Self-pay';
  }
  window.billPayer = billPayer;

  window.extSyncAllBills=function(){
    var d=XD(); var n=0;
    (d.bills||[]).forEach(function(b){ if(b && !b.__glPosted && (+b.total||+b.amount||0)>0){ if(b.total==null) b.total=(+b.amount||0); try{ if(window.SyncBus){ SyncBus.emit('bill.created',b); n++; } }catch(e){} } });
    XSAVE(); XTOAST(n?(n+' bill(s) synced to Receivables / GL'):'All bills already posted to Receivables / GL');
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extReceivablesBody();
  };

  window.extReceivablesBody=function(){
    var d=XD();
    /* guarantee every bill is captured as a receivable in AR/GL before showing the register (idempotent) */
    try{ if(window.SyncBus && d.bills){ d.bills.forEach(function(b){ if(b && !b.__glPosted && (+b.total||+b.amount||0)>0){ if(b.total==null)b.total=(+b.amount||0); try{ SyncBus.emit('bill.created',b); }catch(e){} } }); } }catch(e){}
    var bills=(d.bills||[]).slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));});
    var outstanding=bills.filter(function(b){return billBal(b)>0.005;});
    var totalOut=outstanding.reduce(function(s,b){return s+billBal(b);},0);
    var posted=bills.filter(function(b){return b.__glPosted;}).length;
    var rcptToday=(d.receipts||[]).filter(function(r){return (r.date||'')===XTODAY();}).length;
    var kpis='<div class="kpi-grid" style="margin-bottom:12px">'+
      kpi(EF(totalOut),'Outstanding Receivables','fa-file-invoice-dollar','#dc2626')+
      kpi(outstanding.length,'Open Bills','fa-folder-open','#f59e0b')+
      kpi(posted+'/'+bills.length,'Posted to GL','fa-book','#0d9488')+
      kpi(rcptToday,'Receipts Today','fa-receipt','#16a34a')+'</div>';
    var flow='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:11px;color:var(--txt2);background:#f8fafc;border:1px solid var(--bdr);border-radius:10px;padding:8px 12px;margin-bottom:12px">'+
      '<b>Lifecycle:</b> <span class="badge" style="background:#fef3c7;color:#92400e;padding:2px 8px;border-radius:8px">1 · Bill raised (any module)</span> → '+
      '<span class="badge" style="background:#dbeafe;color:#1e40af;padding:2px 8px;border-radius:8px">2 · Receivable in AR (Dr 1020)</span> → '+
      '<span class="badge" style="background:#dcfce7;color:#166534;padding:2px 8px;border-radius:8px">3 · Receipt on payment</span> → '+
      '<span class="badge" style="background:#f0fdfa;color:#0f766e;padding:2px 8px;border-radius:8px">4 · Posted to General Ledger</span>'+
      '<button class="btn btn-sm" style="margin-left:auto;background:#0d9488;color:#fff" onclick="extSyncAllBills()"><i class="fa-solid fa-rotate"></i> Sync All Bills</button></div>';
    var rows=bills.map(function(b){
      var total=(b.total!=null?b.total:(b.amount||0)); var paid=(b.paid||0); var bal=billBal(b);
      var je=jeBySource('bill.created:'+b.id);
      var glcell= b.__glPosted? '<span class="badge" style="background:#dcfce7;color:#166534;padding:2px 7px;border-radius:7px" title="Posted to General Ledger">✓ '+esc(je?je.code:'Posted')+'</span>' : '<button class="btn btn-xs btn-ghost" onclick="extSyncAllBills()">Post</button>';
      var st = bal<=0.005?'Paid':(paid>0?'Part-Paid':'Outstanding'); var stcol = bal<=0.005?'#16a34a':(paid>0?'#f59e0b':'#dc2626');
      var key=jsArg(b.code||b.id);
      var billBtn='<button class="btn btn-xs btn-ghost" onclick="extGenBill('+key+')"><i class="fa-solid fa-file-invoice"></i> Bill</button>';
      var act = (bal>0.005? '<button class="btn btn-xs btn-pri" onclick="extGenReceipt('+key+')"><i class="fa-solid fa-receipt"></i> Receipt</button>' : '<span style="color:#16a34a;font-size:11px"><i class="fa-solid fa-check"></i> Settled</span>')+' '+billBtn;
      return '<tr><td><b>'+esc(b.code||b.id)+'</b></td><td>'+esc(patName(b.patientId))+'</td><td><span style="font-size:10px;color:var(--txt3)">'+esc(billSource(b))+'</span></td><td>'+esc(b.date||'')+'</td><td>'+EF(total)+'</td><td>'+EF(paid)+'</td><td style="font-weight:700;color:'+stcol+'">'+EF(bal)+'</td><td><span style="color:'+stcol+';font-weight:600;font-size:11px">'+st+'</span></td><td>'+glcell+'</td><td>'+act+'</td></tr>';
    }).join('');
    return kpis+flow+'<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-file-invoice-dollar"></i> Receivables — all bills, every module</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Bill</th><th>Patient</th><th>Source</th><th>Date</th><th>Total</th><th>Paid</th><th>Balance</th><th>Status</th><th>GL Posting</th><th>Action</th></tr></thead><tbody>'+(rows||'<tr><td colspan="10" style="text-align:center;color:var(--txt3);padding:16px">No bills yet</td></tr>')+'</tbody></table></div></div>';
  };

  function extFindBill(key){ var d=XD(); var k=String(key); return (d.bills||[]).find(function(x){return String(x.id)===k || String(x.code)===k;}); }
  function jsArg(v){ return "'"+String(v==null?'':v).replace(/\\/g,'\\\\').replace(/'/g,"\\'")+"'"; }
  window.extGenBill=function(key){
    var b=extFindBill(key); if(!b){ XTOAST('Bill not found','err'); return; }
    var d=XD(); var total=(b.total!=null?b.total:(b.amount||0)); var paid=(b.paid||0); var bal=billBal(b);
    var items=Array.isArray(b.items)?b.items:[];
    var itemRows=items.length? items.map(function(it){ var amt=(it.a!=null?it.a:(it.amount!=null?it.amount:(it.total||0))); return '<tr><td>'+esc(it.category||it.desc||it.s||it.name||'Service')+'</td><td>'+esc(it.desc||it.s||'')+'</td><td style="text-align:right">'+EF(+amt||0)+'</td></tr>'; }).join('')
      : '<tr><td>'+esc(billSource(b))+'</td><td>Services rendered</td><td style="text-align:right">'+EF(total)+'</td></tr>';
    var hn=esc((d.settings&&d.settings.hospitalName)||'Tranquil Hospital & Wellness Centre');
    var html='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px"><div><div style="font-size:18px;font-weight:800;color:#0f766e">'+hn+'</div><div style="font-size:11px;color:#64748b">Patient Invoice / Bill</div></div>'+
      '<div style="text-align:right;font-size:12px"><div><b>'+esc(b.code||b.id)+'</b></div><div style="color:#64748b">'+esc(b.date||'')+'</div></div></div>'+
      '<div style="font-size:12px;margin-bottom:8px"><b>Patient:</b> '+esc(patName(b.patientId))+' &nbsp;·&nbsp; <b>Source:</b> '+esc(billSource(b))+' &nbsp;·&nbsp; <b>Status:</b> '+esc(bal<=0.005?'Paid':(paid>0?'Part-Paid':'Outstanding'))+'</div>'+
      '<table class="tbl"><thead><tr><th>Item</th><th>Description</th><th style="text-align:right">Amount</th></tr></thead><tbody>'+itemRows+'</tbody>'+
      '<tfoot><tr><td colspan="2" style="text-align:right;font-weight:700">Total</td><td style="text-align:right;font-weight:700">'+EF(total)+'</td></tr>'+
      '<tr><td colspan="2" style="text-align:right">Paid</td><td style="text-align:right;color:#16a34a">'+EF(paid)+'</td></tr>'+
      '<tr><td colspan="2" style="text-align:right;font-weight:800">Balance Due</td><td style="text-align:right;font-weight:800;color:'+(bal>0.005?'#dc2626':'#16a34a')+'">'+EF(bal)+'</td></tr></tfoot></table>';
    if(typeof printContent==='function'){ printContent('Bill '+(b.code||b.id), html); }
    else { XMODAL('<i class="fa-solid fa-file-invoice" style="color:#0d9488;margin-right:8px"></i>Bill '+esc(b.code||b.id), html, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide'); }
  };

  window.extGenReceipt=function(billId){
    var b=extFindBill(billId); if(!b){ XTOAST('Bill not found','err'); return; }
    var bal=billBal(b); var methods=['Cash','Bank Transfer','POS / Card','Mobile Money','Cheque'];
    var idArg=jsArg(b.code||b.id);
    XMODAL('<i class="fa-solid fa-receipt" style="color:#16a34a;margin-right:8px"></i>Generate Receipt — '+esc(b.code||b.id),
      '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:8px;padding:8px 10px;font-size:12px;color:#1e40af;margin-bottom:10px">Patient: <b>'+esc(patName(b.patientId))+'</b> · Balance due: <b>'+EF(bal)+'</b></div>'+
      '<div class="form-grid">'+
        '<div class="form-group"><label>Amount (\u20a6)</label><input id="rc_amt" type="number" value="'+bal+'" style="font-weight:700;font-size:16px"></div>'+
        '<div class="form-group"><label>Method</label><select id="rc_method">'+methods.map(function(m){return '<option>'+m+'</option>';}).join('')+'</select></div>'+
        '<div class="form-group"><label>Date</label><input id="rc_date" type="date" value="'+XTODAY()+'"></div>'+
        '<div class="form-group"><label>Reference</label><input id="rc_ref" placeholder="Teller / txn ref (optional)"></div>'+
      '</div><div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Posting the receipt settles the receivable and writes to the General Ledger (Dr Cash/Bank, Cr Accounts Receivable 1020).</div>',
      '<button class="btn btn-pri" onclick="extConfirmReceipt('+idArg+')"><i class="fa-solid fa-check"></i> Post Receipt</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };

  window.extConfirmReceipt=function(billId){
    var d=XD(); var b=extFindBill(billId); if(!b){ XCLOSE(); return; }
    var amt=gn('rc_amt'); if(!(amt>0)){ XTOAST('Enter an amount','err'); return; }
    var method=gv('rc_method'); var date=gv('rc_date')||XTODAY(); var ref=gv('rc_ref');
    var chMap={'Cash':'Cash','Bank Transfer':'Bank','POS / Card':'POS','Mobile Money':'Mobile','Cheque':'Bank'};
    var channel=chMap[method]||'Bank';
    if(b.total==null) b.total=(b.amount||0);
    /* 1) ensure the bill is on AR/GL first (idempotent — same object, handler guards via __glPosted) */
    if(!b.__glPosted && window.SyncBus){ try{ SyncBus.emit('bill.created',b); }catch(e){} }
    /* 2) record the Payment transaction WITHOUT the wrapped push (so the host hook does not also emit → no double post) */
    d.transactions=d.transactions||[];
    var txnId=XID(); var txnCode='TXN-'+String(d.transactions.length+1).padStart(5,'0');
    var txn={ id:txnId, code:txnCode, type:'Payment', category:'Bill Payment', method:method, channel:channel,
      amount:amt, billId:b.id, billRef:b.code, patientId:b.patientId, reference:ref||('Receipt for '+(b.code||b.id)),
      status:'Completed', date:date, cashier:XUSER() };
    try{ d.transactions[d.transactions.length]=txn; }catch(e){ d.transactions.push(txn); }
    /* 3) post payment to GL + settle AR via a single deterministic emit; manual fallback if no engine present */
    var posted=false;
    if(window.SyncBus){ try{ SyncBus.emit('payment.received', { id:txnId, billId:b.id, amount:amt, channel:channel, date:date }); posted=true; }catch(e){} }
    if(!posted || b.balance==null){ b.paid=Math.min((b.total||0),((b.paid||0)+amt)); b.balance=(b.total||0)-(b.paid||0); if(b.balance<=0.005) b.status='Paid'; }
    /* 4) receipt record with GL link */
    d.receipts=d.receipts||[];
    var je=(d.journalEntries||[]).find(function(j){return j.source==='payment.received:'+txnId;});
    var rcptCode='RCP-'+String((d.receipts.length+1)).padStart(5,'0');
    d.receipts.push({ id:XID(), code:rcptCode, legacyTxnId:txnId, billId:b.id, billRef:b.code, patientId:b.patientId,
      customerName:patName(b.patientId), amount:amt, method:method, channel:channel, reference:ref, date:date,
      postedJECode:(je?je.code:null), postedJEId:(je?je.id:null) });
    notify('Receipt posted', rcptCode+' — '+EF(amt)+' on '+(b.code||b.id)+(je?(' · GL '+je.code):''), 'finance', 'transactions', rcptCode);
    XCLOSE(); XSAVE();
    XTOAST('Receipt '+rcptCode+' posted'+(je?(' · GL '+je.code):'')+(billBal(b)<=0.005?' · bill settled':''));
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extReceivablesBody();
  };

  /* ════════════════════════════════════════════════════════════════════════
     GL RECONCILE & PROFESSIONAL FINANCIAL REPORT (all modules → General Ledger)
     ════════════════════════════════════════════════════════════════════════ */
  function glHasJE(src){ var d=XD(); return (d.journalEntries||[]).some(function(j){return j.source===src;}); }
  function glCoaMap(){ var d=XD(); var m={}; (d.chartOfAccounts||[]).forEach(function(a){ m[a.code]={name:a.name,type:a.type}; }); return m; }
  function glAgg(){ var d=XD(); var agg={}; (d.journalEntries||[]).forEach(function(j){ (j.lines||[]).forEach(function(l){ var code=l.account||l.accountCode; if(!code) return; var dr=(+l.dr||+l.debit||0), cr=(+l.cr||+l.credit||0); if(!agg[code]) agg[code]={dr:0,cr:0}; agg[code].dr+=dr; agg[code].cr+=cr; }); }); return agg; }

  window.extGLReconcile=function(){
    var d=XD(); var n=0;
    try{
      (d.bills||[]).forEach(function(b){ if(!b) return; var amt=(+b.total||+b.amount||0); if(!(amt>0)) return;
        if(!glHasJE('bill.created:'+b.id)){ b.__glPosted=false; if(window.SyncBus){ try{ SyncBus.emit('bill.created',b); n++; }catch(e){} } } });
      (d.transactions||[]).forEach(function(t){ if(!t) return; var amt=+t.amount||0; if(!(amt>0)) return; var ch=t.channel||t.method||'Cash'; var dt=t.date||XTODAY();
        if(t.type==='Payment' && !glHasJE('payment.received:'+t.id)){ try{ SyncBus.emit('payment.received',{id:t.id,billId:t.billId,amount:amt,channel:ch,date:dt}); n++; }catch(e){} }
        else if(t.type==='Refund' && !glHasJE('payment.refunded:'+t.id)){ try{ SyncBus.emit('payment.refunded',{id:t.id,billId:t.billId,amount:amt,channel:ch,date:dt}); n++; }catch(e){} }
        else if(/write-?off/i.test(t.type||'') && !glHasJE('bill.writtenoff:'+t.id)){ try{ SyncBus.emit('bill.writtenoff',{id:t.id,billId:t.billId,amount:amt,date:dt}); n++; }catch(e){} }
      });
      (d.apInvoices||[]).forEach(function(inv){ if(inv && !inv.postedJEId && !inv.__glPosted && !glHasJE('ap.invoice:'+inv.id) && (+inv.amount>0)){ postAP(inv); n++; } });
    }catch(e){}
    XSAVE(); XTOAST(n?(n+' transaction(s) posted to the General Ledger'):'All module transactions already posted — books are in sync');
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extGLBody();
  };

  function glInferType(code, given){ var ok={Asset:1,Liability:1,Equity:1,Revenue:1,Expense:1}; if(given && ok[given]) return given; var c=String(code||'').charAt(0); return ({'1':'Asset','2':'Liability','3':'Equity','4':'Revenue','5':'Expense','6':'Expense','7':'Expense','8':'Revenue','9':'Asset'})[c]||'Expense'; }
  function glCountSrc(prefix){ var d=XD(); return (d.journalEntries||[]).filter(function(j){ return (j.source||'').indexOf(prefix)===0; }).length; }
  window.extModuleCoverage=function(){
    var d=XD();
    var billsTotal=(d.bills||[]).filter(function(b){return b&&(+b.total||+b.amount||0)>0;}).length;
    var billsPosted=(d.bills||[]).filter(function(b){return b&&(b.__glPosted||glHasJE('bill.created:'+b.id));}).length;
    var payTotal=(d.transactions||[]).filter(function(t){return t&&t.type==='Payment'&&(+t.amount>0);}).length;
    var payPosted=glCountSrc('payment.received');
    var apTotal=(d.apInvoices||[]).filter(function(i){return i&&(+i.amount>0);}).length;
    var apPosted=(d.apInvoices||[]).filter(function(i){return i&&(i.postedJEId||i.__glPosted||glHasJE('ap.invoice:'+i.id));}).length;
    var apPayTotal=(d.apPayments||[]).length;
    var apPayPosted=glCountSrc('ap.payment');
    var clTotal=(d.insuranceClaims||[]).length;
    var clPosted=glCountSrc('claim.');
    var prTotal=((d.payrollRuns||d.payroll||[])||[]).length;
    var prPosted=glCountSrc('payroll.run');
    var streams=[
      {m:'Patient Billing (Lab, Radiology, Pharmacy, Wards, OPD…)',t:billsTotal,p:billsPosted,acct:'Dr A/R 1020 · Cr Revenue'},
      {m:'Cash & Receipts',t:payTotal,p:payPosted,acct:'Dr Cash/Bank · Cr A/R 1020'},
      {m:'Procurement — Vendor Invoices (AP)',t:apTotal,p:apPosted,acct:'Dr Expense · Cr A/P 2000'},
      {m:'Vendor Payments',t:apPayTotal,p:apPayPosted,acct:'Dr A/P 2000 · Cr Bank'},
      {m:'Insurance & Claims',t:clTotal,p:clPosted,acct:'A/R Insurance 1021 reclass'},
      {m:'HR & Payroll',t:prTotal,p:prPosted,acct:'Dr Salaries · Cr PAYE/Pension/Bank'},
      {m:'Fixed Assets — Depreciation',t:glCountSrc('depreciation.run'),p:glCountSrc('depreciation.run'),acct:'Dr Depreciation · Cr Accum.'},
      {m:'Pharmacy Dispense (COGS)',t:glCountSrc('pharmacy.dispense'),p:glCountSrc('pharmacy.dispense'),acct:'Dr COGS · Cr Inventory 1030'}
    ];
    var rows=streams.map(function(s){
      var pct=s.t?Math.round(s.p/s.t*100):100; var full=(s.p>=s.t);
      var col=full?'#16a34a':(pct>=60?'#f59e0b':'#dc2626');
      return '<tr><td style="font-weight:600">'+esc(s.m)+'</td><td style="text-align:center">'+s.t+'</td><td style="text-align:center">'+s.p+'</td><td style="min-width:120px">'+bar(pct,col)+'</td><td style="font-size:10px;color:var(--txt3)">'+esc(s.acct)+'</td><td style="text-align:center">'+(full?'<span style="color:#16a34a"><i class="fa-solid fa-circle-check"></i></span>':'<span style="color:#f59e0b"><i class="fa-solid fa-circle-half-stroke"></i></span>')+'</td></tr>';
    }).join('');
    return '<div class="card" style="margin-top:12px"><div class="card-hd"><h3><i class="fa-solid fa-diagram-project" style="color:var(--pri);margin-right:8px"></i>Module Transaction Sync Coverage</h3><button class="btn btn-sm" style="background:#0d9488;color:#fff" onclick="extGLReconcile()"><i class="fa-solid fa-rotate"></i> Reconcile all</button></div>'+
      '<div style="font-size:12px;color:var(--txt2);margin-bottom:8px">Every charge-generating module routes through these streams into the General Ledger. Reconcile posts anything outstanding.</div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Module / Stream</th><th style="text-align:center">Records</th><th style="text-align:center">Posted</th><th>Coverage</th><th>GL Treatment</th><th style="text-align:center">Status</th></tr></thead><tbody>'+rows+'</tbody></table></div></div>';
  };
  window.extGLBody=function(){
    var d=XD(); var je=d.journalEntries||[]; var agg=glAgg(); var m=glCoaMap();
    var codes=Object.keys(agg).sort();
    var totDr=0, totCr=0;
    var byType={Asset:0,Liability:0,Equity:0,Revenue:0,Expense:0};
    var tbRows=codes.map(function(code){
      var a=agg[code]; var bal=a.dr-a.cr; var dr=bal>0?bal:0, cr=bal<0?-bal:0; totDr+=dr; totCr+=cr;
      var info=m[code]||{name:'(unmapped account)',type:''};
      var t=glInferType(code, info.type);
      byType[t]+= (t==='Asset'||t==='Expense')?bal:(-bal);
      return '<tr><td><b>'+esc(code)+'</b></td><td>'+esc(info.name)+'</td><td style="font-size:11px;color:var(--txt3)">'+esc(t)+'</td><td style="text-align:right">'+(dr?EF(dr):'')+'</td><td style="text-align:right">'+(cr?EF(cr):'')+'</td></tr>';
    }).join('');
    var balanced=Math.abs(totDr-totCr)<0.5;
    var netIncome=(byType.Revenue||0)-(byType.Expense||0);
    var eqLHS=byType.Asset||0; var eqRHS=(byType.Liability||0)+(byType.Equity||0)+netIncome;
    var eqOK=Math.abs(eqLHS-eqRHS)<1;
    /* coverage by source */
    var bySrc={}; je.forEach(function(j){ var s=(j.source||'manual').split(':')[0]; bySrc[s]=(bySrc[s]||0)+1; });
    var srcRows=Object.keys(bySrc).sort(function(a,b){return bySrc[b]-bySrc[a];}).map(function(s){ return '<tr><td>'+esc(s)+'</td><td style="text-align:right">'+bySrc[s]+'</td></tr>'; }).join('')||'<tr><td colspan="2" style="text-align:center;color:var(--txt3)">No journal entries yet</td></tr>';
    /* exceptions */
    var errs=(d.glErrors||[]); var deferred=(d.deferredJEs||[]);
    var unpostedBills=(d.bills||[]).filter(function(b){return b && !b.__glPosted && !glHasJE('bill.created:'+b.id) && (+b.total||+b.amount||0)>0;}).length;
    var unpostedPays=(d.transactions||[]).filter(function(t){return t && t.type==='Payment' && (+t.amount>0) && !glHasJE('payment.received:'+t.id);}).length;
    var unpostedInv=(d.apInvoices||[]).filter(function(i){return i && !i.postedJEId && !i.__glPosted && !glHasJE('ap.invoice:'+i.id) && (+i.amount>0);}).length;
    var totalUnposted=unpostedBills+unpostedPays+unpostedInv;
    var kpis='<div class="kpi-grid" style="margin-bottom:12px">'+
      kpi(je.length,'Journal Entries','fa-book','#0d9488')+
      kpi(EF(totDr),'Total Debits = Credits','fa-scale-balanced',balanced?'#16a34a':'#dc2626')+
      kpi(totalUnposted,'Unposted Items','fa-triangle-exclamation',totalUnposted?'#f59e0b':'#16a34a')+
      kpi(errs.length,'GL Errors','fa-circle-exclamation',errs.length?'#dc2626':'#16a34a')+'</div>';
    var status='<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;background:'+(balanced&&eqOK&&!totalUnposted&&!errs.length?'#f0fdf4':'#fff7ed')+';border:1px solid var(--bdr);border-radius:10px;padding:10px 14px;margin-bottom:12px">'+
      '<span style="font-weight:700;color:'+(balanced?'#16a34a':'#dc2626')+'"><i class="fa-solid '+(balanced?'fa-circle-check':'fa-circle-xmark')+'"></i> Trial balance '+(balanced?'balanced':'OUT by '+EF(Math.abs(totDr-totCr)))+'</span>'+
      '<span style="font-weight:700;color:'+(eqOK?'#16a34a':'#dc2626')+'"><i class="fa-solid '+(eqOK?'fa-circle-check':'fa-circle-xmark')+'"></i> Accounting equation '+(eqOK?'holds':'off by '+EF(Math.abs(eqLHS-eqRHS)))+'</span>'+
      '<button class="btn btn-sm" style="margin-left:auto;background:#0d9488;color:#fff" onclick="extGLReconcile()"><i class="fa-solid fa-rotate"></i> Reconcile all to GL</button>'+
      '<button class="btn btn-sm btn-ghost" onclick="extPrintFinReport()"><i class="fa-solid fa-print"></i> Print</button></div>';
    var repbar='<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3><i class="fa-solid fa-file-lines" style="color:var(--pri);margin-right:8px"></i>Transaction Reports</h3></div>'+
      '<div style="display:flex;gap:8px;flex-wrap:wrap;padding:4px 2px">'+
      '<button class="btn btn-sm" style="background:#5b21b6;color:#fff" onclick="extReport(\'bills\')"><i class="fa-solid fa-file-invoice-dollar"></i> Bills</button>'+
      '<button class="btn btn-sm" style="background:#065f46;color:#fff" onclick="extReport(\'receipts\')"><i class="fa-solid fa-receipt"></i> Receipts</button>'+
      '<button class="btn btn-sm" style="background:#1e40af;color:#fff" onclick="extReport(\'invoices\')"><i class="fa-solid fa-file-invoice"></i> Invoices</button>'+
      '<button class="btn btn-sm" style="background:#b45309;color:#fff" onclick="extReport(\'payments\')"><i class="fa-solid fa-money-bill-wave"></i> Payments</button>'+
      '</div></div>';
    var equation='<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3><i class="fa-solid fa-chart-pie" style="color:var(--pri);margin-right:8px"></i>Financial Position</h3></div>'+
      '<div class="detail-grid">'+di('Total Assets','<b>'+EF(byType.Asset||0)+'</b>')+di('Total Liabilities',EF(byType.Liability||0))+di('Equity',EF(byType.Equity||0))+di('Revenue','<span style="color:#16a34a">'+EF(byType.Revenue||0)+'</span>')+di('Expenses','<span style="color:#dc2626">'+EF(byType.Expense||0)+'</span>')+di('Net Income','<b style="color:'+(netIncome>=0?'#16a34a':'#dc2626')+'">'+EF(netIncome)+'</b>')+'</div>'+
      '<div style="font-size:11px;color:var(--txt3);margin-top:8px;padding:6px 10px;background:#f8fafc;border-radius:8px">Assets '+EF(eqLHS)+' = Liabilities + Equity + Net Income '+EF(eqRHS)+(eqOK?' \u2713':' \u2014 review postings')+'</div></div>';
    var tb='<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3><i class="fa-solid fa-scale-balanced" style="color:var(--pri);margin-right:8px"></i>Trial Balance</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Account</th><th>Type</th><th style="text-align:right">Debit</th><th style="text-align:right">Credit</th></tr></thead><tbody>'+(tbRows||'<tr><td colspan="5" style="text-align:center;color:var(--txt3);padding:14px">No postings yet</td></tr>')+'</tbody><tfoot><tr style="font-weight:800;background:#f0fdfa"><td colspan="3" style="text-align:right">TOTAL</td><td style="text-align:right">'+EF(totDr)+'</td><td style="text-align:right">'+EF(totCr)+'</td></tr></tfoot></table></div></div>';
    var cov='<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">'+
      '<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-diagram-project" style="color:var(--pri);margin-right:6px"></i>Postings by Source</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Source / Module</th><th style="text-align:right">Entries</th></tr></thead><tbody>'+srcRows+'</tbody></table></div></div>'+
      '<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-triangle-exclamation" style="color:#f59e0b;margin-right:6px"></i>Exceptions</h3></div><div style="padding:4px 2px;font-size:13px">'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--bdr)"><span>Unposted bills</span><b style="color:'+(unpostedBills?'#f59e0b':'#16a34a')+'">'+unpostedBills+'</b></div>'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--bdr)"><span>Unposted payments</span><b style="color:'+(unpostedPays?'#f59e0b':'#16a34a')+'">'+unpostedPays+'</b></div>'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--bdr)"><span>Unposted vendor invoices</span><b style="color:'+(unpostedInv?'#f59e0b':'#16a34a')+'">'+unpostedInv+'</b></div>'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--bdr)"><span>Unbalanced (rejected) entries</span><b style="color:'+(errs.length?'#dc2626':'#16a34a')+'">'+errs.length+'</b></div>'+
        '<div style="display:flex;justify-content:space-between;padding:6px 0"><span>Deferred (closed period)</span><b style="color:'+(deferred.length?'#f59e0b':'#16a34a')+'">'+deferred.length+'</b></div>'+
      '</div></div></div>';
    return kpis+status+repbar+equation+tb+cov+window.extModuleCoverage();
  };
  window.extReportPrint=function(title){ var b=document.querySelector('#modalBg .modal-body'); if(b){ if(typeof printContent==='function') printContent(title, b.innerHTML); else if(typeof window.open==='function'){ var w=window.open('','_blank'); if(w){ w.document.write('<html><head><title>'+title+'</title></head><body>'+b.innerHTML+'</body></html>'); w.document.close(); } } } };
  function extRepTbl(headers, bodyRows, foot){
    return '<div class="tbl-wrap"><table class="tbl"><thead><tr>'+headers.map(function(h){return '<th'+(h.r?' style="text-align:right"':'')+'>'+esc(h.l)+'</th>';}).join('')+'</tr></thead><tbody>'+(bodyRows||'<tr><td colspan="'+headers.length+'" style="text-align:center;color:var(--txt3);padding:14px">No records</td></tr>')+'</tbody>'+(foot?('<tfoot>'+foot+'</tfoot>'):'')+'</table></div>';
  }
  window.extReport=function(kind){
    var d=XD(); var title='', body='';
    var hdr=(typeof reportHeaderHTML==='function'?'':''); // header added by printContent
    if(kind==='bills'){
      title='Bills Report'; var bills=(d.bills||[]); var tT=0,tP=0,tB=0;
      var rows=bills.slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));}).map(function(b){
        var t=(+b.total||+b.amount||0),p=(+b.paid||0),bal=(b.balance!=null?+b.balance:t-p); tT+=t;tP+=p;tB+=bal;
        var st=bal<=0.005?'Paid':(p>0?'Part-Paid':'Outstanding');
        return '<tr><td><b>'+esc(b.code||b.id)+'</b></td><td>'+esc(patName(b.patientId))+'</td><td>'+esc(billSource(b))+'</td><td>'+esc(b.date||'')+'</td><td style="text-align:right">'+EF(t)+'</td><td style="text-align:right">'+EF(p)+'</td><td style="text-align:right;font-weight:700;color:'+(bal>0.005?'#dc2626':'#16a34a')+'">'+EF(bal)+'</td><td>'+esc(st)+'</td></tr>';
      }).join('');
      body=extRepTbl([{l:'Bill'},{l:'Patient'},{l:'Source'},{l:'Date'},{l:'Total',r:1},{l:'Paid',r:1},{l:'Balance',r:1},{l:'Status'}], rows,
        '<tr style="font-weight:800;background:#f0fdfa"><td colspan="4" style="text-align:right">TOTAL ('+bills.length+' bills)</td><td style="text-align:right">'+EF(tT)+'</td><td style="text-align:right">'+EF(tP)+'</td><td style="text-align:right">'+EF(tB)+'</td><td></td></tr>');
    } else if(kind==='receipts'){
      title='Receipts Report'; var recs=(d.receipts||[]); var tot=0;
      var rows=recs.slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));}).map(function(r){
        var a=(+r.amount||0); tot+=a;
        return '<tr><td><b>'+esc(r.code||r.id)+'</b></td><td>'+esc(r.date||'')+'</td><td>'+esc(r.customerName||patName(r.patientId)||'\u2014')+'</td><td>'+esc(r.method||r.channel||'')+'</td><td>'+esc(r.reference||'\u2014')+'</td><td style="text-align:right;font-weight:700;color:#16a34a">'+EF(a)+'</td></tr>';
      }).join('');
      body=extRepTbl([{l:'Receipt'},{l:'Date'},{l:'Received From'},{l:'Method'},{l:'Reference'},{l:'Amount',r:1}], rows,
        '<tr style="font-weight:800;background:#f0fdfa"><td colspan="5" style="text-align:right">TOTAL ('+recs.length+' receipts)</td><td style="text-align:right">'+EF(tot)+'</td></tr>');
    } else if(kind==='invoices'){
      title='Invoices Report'; var arBills=(d.bills||[]).slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));}); var ap=(d.apInvoices||[]);
      var arT=0,arP=0,arB=0;
      var arRows=arBills.map(function(b){ var a=(+b.total||+b.amount||0),p=(+b.paid||0),bal=(b.balance!=null?+b.balance:a-p); arT+=a;arP+=p;arB+=bal;
        var st=bal<=0.005?'Paid':(p>0?'Part-Paid':'Outstanding');
        return '<tr><td><b>'+esc(b.code||b.id)+'</b></td><td>'+esc(billPayer(b))+'</td><td>'+esc(patName(b.patientId))+'</td><td>'+esc(billSource(b))+'</td><td>'+esc(b.date||'')+'</td><td style="text-align:right">'+EF(a)+'</td><td style="text-align:right">'+EF(p)+'</td><td style="text-align:right;font-weight:700;color:'+(bal>0.005?'#dc2626':'#16a34a')+'">'+EF(bal)+'</td><td>'+esc(st)+'</td></tr>'; }).join('');
      var apT=0,apP=0,apB=0;
      var apRows=ap.map(function(i){ var a=(+i.amount||0),p=(+i.paid||0),bal=(i.balance!=null?+i.balance:a-p); apT+=a;apP+=p;apB+=bal;
        return '<tr><td><b>'+esc(i.code||i.id)+'</b></td><td>'+esc(i.supplierName||i.vendor||'')+'</td><td>'+esc(i.date||'')+'</td><td style="text-align:right">'+EF(a)+'</td><td style="text-align:right">'+EF(p)+'</td><td style="text-align:right">'+EF(bal)+'</td><td>'+esc(i.status||'')+'</td></tr>'; }).join('');
      body='<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-arrow-down" style="color:#16a34a;margin-right:6px"></i>Accounts Receivable Bills</h3></div>'+
        extRepTbl([{l:'Bill'},{l:'Payer / HMO / Agent'},{l:'Patient'},{l:'Source'},{l:'Date'},{l:'Total',r:1},{l:'Paid',r:1},{l:'Balance',r:1},{l:'Status'}], arRows,
          '<tr style="font-weight:800;background:#f0fdfa"><td colspan="5" style="text-align:right">TOTAL ('+arBills.length+' bills)</td><td style="text-align:right">'+EF(arT)+'</td><td style="text-align:right">'+EF(arP)+'</td><td style="text-align:right">'+EF(arB)+'</td><td></td></tr>')+'</div>'+
        '<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-arrow-up" style="color:#dc2626;margin-right:6px"></i>Accounts Payable Invoices (Vendors)</h3></div>'+
        extRepTbl([{l:'Invoice'},{l:'Supplier'},{l:'Date'},{l:'Amount',r:1},{l:'Paid',r:1},{l:'Balance',r:1},{l:'Status'}], apRows,
          '<tr style="font-weight:800;background:#f0fdfa"><td colspan="3" style="text-align:right">TOTAL ('+ap.length+')</td><td style="text-align:right">'+EF(apT)+'</td><td style="text-align:right">'+EF(apP)+'</td><td style="text-align:right">'+EF(apB)+'</td><td></td></tr>')+'</div>'+
        '<div style="font-size:11px;color:var(--txt3);margin-top:8px"><i class="fa-solid fa-circle-info"></i> Receivables are sourced directly from patient bills — each row shows the payer (HMO / insurer / agent) and the patient. Self-pay bills show the patient as their own payer.</div>';
    } else if(kind==='payments'){
      title='Payments Report'; var pays=(d.transactions||[]).filter(function(t){return t.type==='Payment'||t.type==='Refund';});
      var tP=0,tR=0;
      var rows=pays.slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));}).map(function(t){
        var a=(+t.amount||0); var isR=t.type==='Refund'; if(isR)tR+=a; else tP+=a;
        var billCode=''; var bl=(d.bills||[]).find(function(x){return String(x.id)===String(t.billId)||String(x.code)===String(t.billId);}); billCode=bl?(bl.code||bl.id):(t.billId||'\u2014');
        return '<tr><td><b>'+esc(t.code||t.id)+'</b></td><td>'+esc(t.date||'')+'</td><td>'+esc(t.type||'Payment')+'</td><td>'+esc(t.channel||t.method||'')+'</td><td>'+esc(billCode)+'</td><td style="text-align:right;color:'+(isR?'#dc2626':'#16a34a')+'">'+(isR?'-':'')+EF(a)+'</td></tr>';
      }).join('');
      body=extRepTbl([{l:'Ref'},{l:'Date'},{l:'Type'},{l:'Method'},{l:'Bill'},{l:'Amount',r:1}], rows,
        '<tr style="font-weight:800;background:#f0fdfa"><td colspan="5" style="text-align:right">Payments '+EF(tP)+' \u00b7 Refunds '+EF(tR)+' \u00b7 NET</td><td style="text-align:right">'+EF(tP-tR)+'</td></tr>');
    } else { return; }
    XMODAL('<i class="fa-solid fa-file-lines" style="color:var(--pri);margin-right:8px"></i>'+esc(title),
      '<div style="font-size:11px;color:var(--txt3);margin-bottom:10px">Generated '+XTODAY()+'</div>'+body,
      '<button class="btn btn-pri" onclick="extReportPrint('+jsArg(title)+')"><i class="fa-solid fa-print"></i> Print</button><button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.extPrintFinReport=function(){
    try{ var d=XD(); var c=document.getElementById('txnContent'); var body=c?c.innerHTML:window.extGLBody();
      var hn=esc((d.settings&&d.settings.hospitalName)||'Tranquil Hospital');
      var doc='<html><head><title>Financial Report — '+hn+'</title><style>body{font-family:Arial,sans-serif;padding:24px;color:#0f172a}table{border-collapse:collapse;width:100%;margin:8px 0}th,td{border:1px solid #cbd5e1;padding:6px 8px;font-size:12px;text-align:left}th{background:#0f766e;color:#fff}.kpi-grid,.card-hd button,button{display:none!important}.card{border:1px solid #e2e8f0;border-radius:8px;padding:10px;margin:10px 0}h3{font-size:14px}</style></head><body><h1>Financial Report</h1><div style="color:#475569;margin-bottom:10px">'+hn+' \u00b7 Generated '+new Date().toLocaleString()+'</div>'+body+'</body></html>';
      var old=document.getElementById('extPrintFrame'); if(old&&old.parentNode) old.parentNode.removeChild(old);
      var ifr=document.createElement('iframe'); ifr.id='extPrintFrame'; ifr.setAttribute('aria-hidden','true');
      ifr.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
      document.body.appendChild(ifr);
      var w=ifr.contentWindow||ifr.contentDocument; var idoc=ifr.contentDocument||(w&&w.document);
      idoc.open(); idoc.write(doc); idoc.close();
      setTimeout(function(){ try{ (ifr.contentWindow||w).focus(); (ifr.contentWindow||w).print(); }catch(e){ try{ window.print(); }catch(_){} } }, 350);
    }catch(e){ try{ window.print(); }catch(_){ XTOAST('Could not open print view','err'); } }
  };

  /* ════════════════════════════════════════════════════════════════════════
     FINANCE FIXES — iframe print (no pop-up) + Daily Cash-Up full process
     ════════════════════════════════════════════════════════════════════════ */
  function installPrintShim(){
    if(window.__extPrintShim) return; window.__extPrintShim=true;
    var _open=window.open;
    window.open=function(url, name, feat){
      try{
        if(!url || url==='' || url==='about:blank'){
          var old=document.getElementById('extPrintFrame'); if(old&&old.parentNode) old.parentNode.removeChild(old);
          var ifr=document.createElement('iframe'); ifr.id='extPrintFrame'; ifr.setAttribute('aria-hidden','true');
          ifr.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(ifr);
          var idoc=ifr.contentDocument||(ifr.contentWindow&&ifr.contentWindow.document);
          var fakeDoc={ open:function(){ try{idoc.open();}catch(e){} }, write:function(s){ try{idoc.write(s);}catch(e){} }, writeln:function(s){ try{idoc.writeln(s);}catch(e){} },
            close:function(){ try{idoc.close();}catch(e){} setTimeout(function(){ try{ ifr.contentWindow.focus(); ifr.contentWindow.print(); }catch(e){} }, 300); } };
          return { document:fakeDoc, focus:function(){}, print:function(){ try{ ifr.contentWindow.print(); }catch(e){} }, close:function(){}, closed:false, __extIframe:true };
        }
      }catch(e){}
      return _open.apply(window, arguments);
    };
  }
  function wireCashUp(){
    if(typeof window.startDailyCashUp==='function' && !window.startDailyCashUp._extFix){
      window.startDailyCashUp=function(){
        var d=XD(); var td=(typeof today==='function'?today():XTODAY());
        var tx=(d.transactions||[]).filter(function(t){ return t && t.date===td && (t.status==='Completed'||!t.status); });
        var byMethod={};
        var receipts=tx.filter(function(t){return t.type==='Payment';}).reduce(function(s,t){var m=t.channel||t.method||'Cash'; byMethod[m]=(byMethod[m]||0)+Math.abs(+t.amount||0); return s+Math.abs(+t.amount||0);},0);
        var refunds=tx.filter(function(t){return t.type==='Refund';}).reduce(function(s,t){return s+Math.abs(+t.amount||0);},0);
        var cash=byMethod['Cash']||0;
        var last=(d.dailyCashUp&&d.dailyCashUp.length)?d.dailyCashUp[0]:null; var openBal=last?last.closingBal:50000;
        var mb=Object.keys(byMethod).map(function(m){return '<div style="display:flex;justify-content:space-between;font-size:11px;padding:2px 0"><span>'+esc(m)+'</span><b>'+EF(byMethod[m])+'</b></div>';}).join('')||'<div style="font-size:11px;color:var(--txt3)">No receipts today</div>';
        XMODAL('<i class="fa-solid fa-cash-register" style="color:var(--pri);margin-right:8px"></i>Daily Cash-Up — '+td,
          '<div class="form-grid">'+
            '<div class="form-group"><label>Date</label><input value="'+td+'" readonly style="background:#f8fafc"></div>'+
            '<div class="form-group"><label>Cashier</label><input id="cu_cashier" value="'+esc((d.currentUser&&d.currentUser.fullName)||'')+'"></div>'+
            '<div class="form-group"><label>Opening Balance</label><input id="cu_opening" type="number" value="'+openBal+'"></div>'+
            '<div class="form-group"><label>System Receipts (all methods)</label><input value="'+receipts+'" readonly style="background:#d1fae5;font-weight:700;color:#065f46"></div>'+
            '<div class="form-group"><label>System Refunds</label><input value="'+refunds+'" readonly style="background:#fee2e2;font-weight:700;color:#991b1b"></div>'+
            '<div class="form-group"><label>Actual Cash Count</label><input id="cu_actual" type="number" placeholder="Count the cash drawer..."></div>'+
          '</div>'+
          '<div style="margin-top:10px;background:#f8fafc;border:1px solid var(--bdr);border-radius:8px;padding:8px 10px"><div style="font-size:11px;font-weight:700;color:var(--txt2);margin-bottom:4px">RECEIPTS BY METHOD</div>'+mb+
            '<div style="display:flex;justify-content:space-between;font-size:12px;padding:4px 0;border-top:1px solid var(--bdr);margin-top:4px"><span><b>Expected cash drawer</b> (opening + cash receipts \u2212 refunds)</span><b>'+EF(openBal+cash-refunds)+'</b></div></div>',
          '<button class="btn btn-pri" onclick="saveDailyCashUp('+receipts+','+refunds+','+cash+')"><i class="fa-solid fa-save"></i> Submit Cash-Up</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
      };
      window.startDailyCashUp._extFix=true;
    }
    if(typeof window.saveDailyCashUp==='function' && !window.saveDailyCashUp._extFix){
      window.saveDailyCashUp=function(receipts,refunds,cashReceipts){
        var d=XD(); var opening=gn('cu_opening'); var actual=gn('cu_actual');
        var cash=(cashReceipts!=null?cashReceipts:receipts);
        var net=receipts-refunds; var expectedDrawer=opening+cash-refunds;
        var counted=actual||expectedDrawer; var variance=actual?(actual-expectedDrawer):0;
        var rec={ id:XID(), date:(typeof today==='function'?today():XTODAY()), cashier:gv('cu_cashier'), openingBal:opening, totalReceipts:receipts, totalRefunds:refunds, totalNet:net, cashExpected:expectedDrawer, closingBal:counted, status:Math.abs(variance)<100?'Balanced':'Variance', variance:variance, approvedBy:null };
        d.dailyCashUp=d.dailyCashUp||[]; d.dailyCashUp.unshift(rec);
        if(Math.abs(variance)>=1 && window.SyncBus && typeof postJE==='function'){
          try{ var lines = variance<0 ? [{account:'6950',dr:Math.abs(variance),cr:0},{account:'1000',dr:0,cr:Math.abs(variance)}] : [{account:'1000',dr:variance,cr:0},{account:'6950',dr:0,cr:variance}];
            postJE(rec.date,'Cash over/short — daily cash-up '+rec.date, lines, 'cashup:'+rec.id); }catch(e){}
        }
        notify('Daily cash-up '+rec.status, 'Receipts '+EF(receipts)+' \u00b7 Refunds '+EF(refunds)+(variance?(' \u00b7 Variance '+EF(variance)):' \u00b7 Balanced'), 'finance','treasury',rec.date);
        XSAVE(); XTOAST('Cash-up submitted'+(Math.abs(variance)>=100?(' \u2014 Variance '+EF(variance)):' \u2014 Balanced')); XCLOSE(); XRENDER();
      };
      window.saveDailyCashUp._extFix=true;
    }
  }

  function wireTransactions(){
    /* inject the Receivables tab into the Transactions module */
    if(typeof window.renderTransactions==='function' && !window.renderTransactions._extWrapped){
      var _rt=window.renderTransactions;
      var f=function(){
        var html=_rt.apply(this, arguments);
        try{
          if(typeof html==='string' && html.indexOf('extTxnReceivablesTab')===-1){
            var target='<button class="tab-btn" onclick="showTxnTab(\'receipts\')">Receipts</button>';
            var inject='<button class="tab-btn" id="extTxnReceivablesTab" onclick="showTxnTab(\'receivables\')"><i class="fa-solid fa-file-invoice-dollar"></i> Receivables \u2192 Receipt \u2192 GL</button>'+
                       '<button class="tab-btn" id="extTxnPayablesTab" onclick="showTxnTab(\'payables\')"><i class="fa-solid fa-file-invoice"></i> Payables \u2192 Pay \u2192 GL</button>'+
                       '<button class="tab-btn" id="extTxnGLTab" onclick="showTxnTab(\'glsync\')"><i class="fa-solid fa-scale-balanced"></i> GL Reconcile &amp; Reports</button>';
            if(html.indexOf(target)>-1) html=html.replace(target, inject+target);
            else html=html.replace('<div id="txnContent">', inject+'<div id="txnContent">');
          }
        }catch(e){}
        return html;
      };
      f._extWrapped=true; window.renderTransactions=f;
    }
    /* handle the new tab id */
    if(typeof window.showTxnTab==='function' && !window.showTxnTab._extWrapped){
      var _st=window.showTxnTab;
      var g=function(tab){
        if(tab==='receivables'){
          try{ document.querySelectorAll('#txnTabs .tab-btn').forEach(function(x){x.classList.remove('active');}); var ev=window.event; if(ev&&ev.target&&ev.target.classList) ev.target.classList.add('active'); }catch(e){}
          var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extReceivablesBody();
          return;
        }
        if(tab==='payables'){
          try{ document.querySelectorAll('#txnTabs .tab-btn').forEach(function(x){x.classList.remove('active');}); var ev2=window.event; if(ev2&&ev2.target&&ev2.target.classList) ev2.target.classList.add('active'); }catch(e){}
          var c2=document.getElementById('txnContent'); if(c2) c2.innerHTML=window.extPayablesBody();
          return;
        }
        if(tab==='glsync'){
          try{ document.querySelectorAll('#txnTabs .tab-btn').forEach(function(x){x.classList.remove('active');}); var ev3=window.event; if(ev3&&ev3.target&&ev3.target.classList) ev3.target.classList.add('active'); }catch(e){}
          var c3=document.getElementById('txnContent'); if(c3) c3.innerHTML=window.extGLBody();
          return;
        }
        return _st.apply(this, arguments);
      };
      g._extWrapped=true; window.showTxnTab=g;
    }
  }

  /* ════════════════════════════════════════════════════════════════════════
     PAYABLES — Vendor Invoice → Pay → GL (mirrors Receivables; uses V26 AP GL)
     ════════════════════════════════════════════════════════════════════════ */
  function apBal(i){ return (i.balance!=null?i.balance:((i.amount||0)-(i.paid||0))); }
  function postAP(inv){
    try{
      if(inv.postedJEId || inv.__glPosted) return;
      if(window.V26 && V26.postAPInvoice){ V26.postAPInvoice(inv); if(inv.postedJEId){ inv.__glPosted=true; return; } }
      if(window.SyncBus && (+inv.amount>0)){
        SyncBus.emit('ap.invoice',{id:inv.id,date:inv.date,amount:inv.amount,expenseAccount:inv.expenseAccount,vendor:inv.supplierName,desc:inv.category});
        inv.__glPosted=true;
        var je=(XD().journalEntries||[]).find(function(j){return j.source==='ap.invoice:'+inv.id;});
        if(je){ inv.postedJEId=inv.postedJEId||je.id; inv.postedJECode=inv.postedJECode||je.code; }
      }
    }catch(e){}
  }
  window.extSyncAllInvoices=function(){
    var d=XD(); var n=0; (d.apInvoices||[]).forEach(function(inv){ if(inv && !inv.postedJEId && !inv.__glPosted){ postAP(inv); n++; } });
    XSAVE(); XTOAST(n?(n+' vendor invoice(s) posted to Payables / GL'):'All vendor invoices already posted to Payables / GL');
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extPayablesBody();
  };
  window.extPayablesBody=function(){
    var d=XD();
    (d.apInvoices||[]).forEach(function(inv){ if(inv && !inv.postedJEId && !inv.__glPosted && (+inv.amount>0)) postAP(inv); });
    var invs=(d.apInvoices||[]).slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));});
    var open=invs.filter(function(i){return apBal(i)>0.005;});
    var totalDue=open.reduce(function(s,i){return s+apBal(i);},0);
    var posted=invs.filter(function(i){return i.postedJEId||i.__glPosted;}).length;
    var payToday=(d.apPayments||[]).filter(function(p){return (p.date||'')===XTODAY();}).length;
    var kpis='<div class="kpi-grid" style="margin-bottom:12px">'+
      kpi(EF(totalDue),'Outstanding Payables','fa-file-invoice','#b45309')+
      kpi(open.length,'Open Invoices','fa-folder-open','#f59e0b')+
      kpi(posted+'/'+invs.length,'Posted to GL','fa-book','#0d9488')+
      kpi(payToday,'Payments Today','fa-money-bill-transfer','#16a34a')+'</div>';
    var flow='<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:11px;color:var(--txt2);background:#f8fafc;border:1px solid var(--bdr);border-radius:10px;padding:8px 12px;margin-bottom:12px">'+
      '<b>Lifecycle:</b> <span class="badge" style="background:#fef3c7;color:#92400e;padding:2px 8px;border-radius:8px">1 · Vendor invoice received</span> → '+
      '<span class="badge" style="background:#fee2e2;color:#991b1b;padding:2px 8px;border-radius:8px">2 · Payable in AP (Cr 2000)</span> → '+
      '<span class="badge" style="background:#dcfce7;color:#166534;padding:2px 8px;border-radius:8px">3 · Payment (Dr AP / Cr Bank)</span> → '+
      '<span class="badge" style="background:#f0fdfa;color:#0f766e;padding:2px 8px;border-radius:8px">4 · Posted to General Ledger</span>'+
      '<span style="margin-left:auto;display:flex;gap:6px"><button class="btn btn-sm btn-ghost" onclick="extNewVendorInvoice()"><i class="fa-solid fa-plus"></i> New Invoice</button><button class="btn btn-sm" style="background:#0d9488;color:#fff" onclick="extSyncAllInvoices()"><i class="fa-solid fa-rotate"></i> Sync All</button></span></div>';
    var rows=invs.map(function(i){
      var amount=(i.amount||0), paid=(i.paid||0), bal=apBal(i);
      var glcell=(i.postedJEId||i.__glPosted)?'<span class="badge" style="background:#dcfce7;color:#166534;padding:2px 7px;border-radius:7px" title="Posted to GL">✓ '+esc(i.postedJECode||'Posted')+'</span>':'<button class="btn btn-xs btn-ghost" onclick="extSyncAllInvoices()">Post</button>';
      var st=bal<=0.005?'Paid':(paid>0?'Part-Paid':'Outstanding'); var stcol=bal<=0.005?'#16a34a':(paid>0?'#f59e0b':'#b45309');
      var idArg=(typeof i.id==='number'?i.id:('\''+String(i.id).replace(/'/g,'')+'\''));
      var act=bal>0.005?'<button class="btn btn-xs btn-pri" onclick="extPayInvoice('+idArg+')"><i class="fa-solid fa-money-bill-transfer"></i> Pay</button>':'<span style="color:#16a34a;font-size:11px"><i class="fa-solid fa-check"></i> Settled</span>';
      return '<tr><td><b>'+esc(i.code||i.id)+'</b></td><td>'+esc(i.supplierName||'—')+'</td><td>'+esc(i.date||'')+'</td><td>'+esc(i.dueDate||'—')+'</td><td>'+EF(amount)+'</td><td>'+EF(paid)+'</td><td style="font-weight:700;color:'+stcol+'">'+EF(bal)+'</td><td><span style="color:'+stcol+';font-weight:600;font-size:11px">'+st+'</span></td><td>'+glcell+'</td><td>'+act+'</td></tr>';
    }).join('');
    return kpis+flow+'<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-file-invoice"></i> Payables — vendor invoices</h3></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Invoice</th><th>Supplier</th><th>Date</th><th>Due</th><th>Amount</th><th>Paid</th><th>Balance</th><th>Status</th><th>GL Posting</th><th>Action</th></tr></thead><tbody>'+(rows||'<tr><td colspan="10" style="text-align:center;color:var(--txt3);padding:16px">No vendor invoices yet</td></tr>')+'</tbody></table></div></div>';
  };
  window.extPayInvoice=function(invId){
    var d=XD(); var i=(d.apInvoices||[]).find(function(x){return x.id===invId;}); if(!i){ XTOAST('Invoice not found','err'); return; }
    var bal=apBal(i); var methods=['Bank Transfer','Cash','Cheque','POS / Card','Mobile Money'];
    var idArg=(typeof invId==='number'?invId:('\''+String(invId).replace(/'/g,'')+'\''));
    XMODAL('<i class="fa-solid fa-money-bill-transfer" style="color:#16a34a;margin-right:8px"></i>Pay Invoice — '+esc(i.code||i.id),
      '<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:8px;padding:8px 10px;font-size:12px;color:#9a3412;margin-bottom:10px">Supplier: <b>'+esc(i.supplierName||'—')+'</b> · Balance due: <b>'+EF(bal)+'</b></div>'+
      '<div class="form-grid">'+
        '<div class="form-group"><label>Amount (\u20a6)</label><input id="ap_amt" type="number" value="'+bal+'" style="font-weight:700;font-size:16px"></div>'+
        '<div class="form-group"><label>Method</label><select id="ap_method">'+methods.map(function(m){return '<option>'+m+'</option>';}).join('')+'</select></div>'+
        '<div class="form-group"><label>Date</label><input id="ap_date" type="date" value="'+XTODAY()+'"></div>'+
        '<div class="form-group"><label>Reference</label><input id="ap_ref" placeholder="Cheque / transfer ref (optional)"></div>'+
      '</div><div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Posting the payment clears the payable and writes to the General Ledger (Dr Accounts Payable 2000, Cr Bank/Cash).</div>',
      '<button class="btn btn-pri" onclick="extConfirmPay('+idArg+')"><i class="fa-solid fa-check"></i> Post Payment</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.extConfirmPay=function(invId){
    var d=XD(); var i=(d.apInvoices||[]).find(function(x){return x.id===invId;}); if(!i){ XCLOSE(); return; }
    var amt=gn('ap_amt'); if(!(amt>0)){ XTOAST('Enter an amount','err'); return; }
    var method=gv('ap_method'); var date=gv('ap_date')||XTODAY(); var ref=gv('ap_ref');
    if(!i.postedJEId && !i.__glPosted) postAP(i);
    d.apPayments=d.apPayments||[];
    var pmt={ id:XID(), code:'APPAY-'+String(d.apPayments.length+1).padStart(5,'0'), supplierName:i.supplierName, supplierId:i.supplierId,
      invoiceId:i.id, invoiceCode:i.code, amount:amt, method:method, reference:ref, date:date };
    var je=null;
    try{ if(window.V26 && V26.postPayment){ je=V26.postPayment(pmt); } }catch(e){}
    if(!je && window.SyncBus){ try{ SyncBus.emit('ap.payment',{id:pmt.id,date:date,amount:amt}); je=(d.journalEntries||[]).find(function(x){return x.source==='ap.payment:'+pmt.id;})||null; if(je){ pmt.postedJEId=je.id; pmt.postedJECode=je.code; } }catch(e){} }
    d.apPayments.push(pmt);
    i.paid=Math.min((i.amount||0),((i.paid||0)+amt)); i.balance=(i.amount||0)-i.paid; if(i.balance<=0.005) i.status='Paid';
    notify('Vendor payment posted', pmt.code+' — '+EF(amt)+' to '+(i.supplierName||'')+(je&&je.code?(' · GL '+je.code):''), 'finance', 'transactions', pmt.code);
    XCLOSE(); XSAVE();
    XTOAST('Payment '+pmt.code+' posted'+(je&&je.code?(' · GL '+je.code):'')+(apBal(i)<=0.005?' · invoice settled':''));
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extPayablesBody();
  };
  window.extNewVendorInvoice=function(){
    var names=supplierNames();
    XMODAL('<i class="fa-solid fa-file-invoice" style="color:#b45309;margin-right:8px"></i>New Vendor Invoice',
      '<div class="form-grid">'+
        '<div class="form-group full"><label>Supplier / Vendor <span class="req">*</span></label><input id="vi_name" list="vi_suplist" placeholder="Pick from the list or type a new supplier" autocomplete="off"><datalist id="vi_suplist">'+names.map(function(n){return '<option value="'+esc(n)+'">';}).join('')+'</datalist><div style="font-size:11px;color:var(--txt3);margin-top:3px">Choose an existing supplier or enter a new name — new suppliers are added to your list automatically.</div></div>'+
        '<div class="form-group"><label>Invoice No.</label><input id="vi_no"></div>'+
        '<div class="form-group"><label>Category</label><input id="vi_cat" value="General Expense"></div>'+
        '<div class="form-group"><label>Amount (\u20a6)</label><input id="vi_amt" type="number"></div>'+
        '<div class="form-group"><label>Invoice Date</label><input id="vi_date" type="date" value="'+XTODAY()+'"></div>'+
        '<div class="form-group"><label>Due Date</label><input id="vi_due" type="date"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="extSaveVendorInvoice()"><i class="fa-solid fa-save"></i> Save &amp; Post to AP</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.extSaveVendorInvoice=function(){
    var d=XD(); d.apInvoices=d.apInvoices||[];
    var name=(gv('vi_name')||'').trim(); var amt=gn('vi_amt');
    if(!name){ XTOAST('Enter or pick a supplier','err'); return; } if(!(amt>0)){ XTOAST('Enter an amount','err'); return; }
    var lc=name.toLowerCase();
    var vend=(d.vendors||[]).find(function(v){return ((v.name||v.companyName||'')+'').toLowerCase()===lc;})||
             (d.suppliers||[]).find(function(s){return ((s.name||'')+'').toLowerCase()===lc;});
    if(!vend){ /* new supplier — add to the supplier list so it's reusable */
      d.suppliers=d.suppliers||[]; vend={ id:XID(), name:name, category:gv('vi_cat')||'General', status:'Active', __addedFromInvoice:true };
      d.suppliers.push(vend);
    }
    var inv={ id:XID(), code:'BILL-IN-'+String(d.apInvoices.length+1).padStart(5,'0'), supplierInvNo:gv('vi_no'),
      supplierId:vend?vend.id:null, supplierName:name, date:gv('vi_date')||XTODAY(), dueDate:gv('vi_due')||'',
      amount:amt, paid:0, balance:amt, status:'Outstanding', category:gv('vi_cat')||'General Expense', expenseAccount:'6900', notes:'Manual entry' };
    d.apInvoices.unshift(inv); postAP(inv);
    notify('Vendor invoice recorded', inv.code+' — '+EF(amt)+' ('+name+') \u00b7 posted to AP/GL', 'finance', 'transactions', inv.code);
    XCLOSE(); XSAVE(); XTOAST('Invoice '+inv.code+' saved &amp; posted to Payables/GL');
    var c=document.getElementById('txnContent'); if(c) c.innerHTML=window.extPayablesBody();
  };

  /* ════════════════════════════════════════════════════════════════════════
     CONFIGURATION — Pharmacy Catalogue manager (feeds the Rx catalogue picker)
     ════════════════════════════════════════════════════════════════════════ */
  function pcCatalogueCard(){
    var d=XD(); var meds=(d.pharmacy||[]).slice();
    var rows=meds.map(function(m){
      var idArg=(typeof m.id==='number'?m.id:('\''+String(m.id).replace(/'/g,'')+'\''));
      var stockc=(m.stock<=0)?'#dc2626':((m.stock<=(m.minStock||0))?'#f59e0b':'#059669');
      return '<tr><td><b>'+esc(m.code||'')+'</b></td><td>'+esc(m.name||'')+'</td><td>'+esc(m.category||'')+'</td><td style="text-align:right">'+EF(m.unitPrice||0)+'</td><td style="text-align:right;font-weight:700">'+EF(m.sellingPrice||m.price||0)+'</td><td style="text-align:right;color:'+stockc+';font-weight:600">'+(m.stock!=null?m.stock:'—')+'</td><td>'+esc(m.supplier||'—')+'</td><td style="text-align:center">'+(m.controlled?'<span style="color:#7c3aed;font-weight:700">CTRL</span>':'—')+'</td><td><div class="act-row"><button class="act-btn edit" title="Edit" onclick="pcEditDrug('+idArg+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Delete" onclick="pcDelDrug('+idArg+')"><i class="fa-solid fa-trash"></i></button></div></td></tr>';
    }).join('');
    return '<div class="card" id="pcCatalogueCard"><div class="card-hd"><h3><i class="fa-solid fa-prescription-bottle-medical" style="color:var(--pri);margin-right:8px"></i>Pharmacy Catalogue</h3><button class="btn btn-pri btn-sm" onclick="pcEditDrug(null)"><i class="fa-solid fa-plus"></i> Add Medication</button></div>'+
      '<div style="font-size:12px;color:var(--txt2);margin:0 0 10px">This catalogue is shared across the <b>Inventory</b>, <b>Pharmacy</b> and <b>Configuration &#9656; Pharmacy Setup</b> screens — medications added or edited here update everywhere (the New Prescription picker, dispensing and stock) immediately.</div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Name</th><th>Category</th><th style="text-align:right">Cost</th><th style="text-align:right">Selling</th><th style="text-align:right">Stock</th><th>Supplier</th><th style="text-align:center">Ctrl</th><th></th></tr></thead><tbody>'+(rows||'<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:14px">No medications yet</td></tr>')+'</tbody></table></div></div>';
  }
  window.pcEditDrug=function(id){
    var d=XD(); var m=(id!=null)?(d.pharmacy||[]).find(function(x){return x.id===id;}):null; m=m||{};
    var cats=(d.cfgLists&&d.cfgLists.drugCategories)||['Cardiovascular','Antibiotics','Analgesics','GI','Respiratory','Endocrine','CNS','Other'];
    XMODAL('<i class="fa-solid fa-prescription-bottle-medical" style="color:var(--pri);margin-right:8px"></i>'+(id!=null?'Edit Medication':'Add Medication'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>Name <span class="req">*</span></label><input id="pc_name" value="'+esc(m.name||'')+'" placeholder="e.g. Ciprofloxacin 500mg"></div>'+
        '<div class="form-group"><label>Code</label><input id="pc_code" value="'+esc(m.code||'')+'" placeholder="auto"></div>'+
        '<div class="form-group"><label>Category</label><select id="pc_cat">'+cats.map(function(c){return '<option'+((m.category===c)?' selected':'')+'>'+esc(c)+'</option>';}).join('')+'</select></div>'+
        '<div class="form-group"><label>Supplier</label><input id="pc_sup" value="'+esc(m.supplier||'')+'"></div>'+
        '<div class="form-group"><label>Cost Price (\u20a6)</label><input id="pc_cost" type="number" value="'+(m.unitPrice||0)+'"></div>'+
        '<div class="form-group"><label>Selling Price (\u20a6)</label><input id="pc_sell" type="number" value="'+(m.sellingPrice||m.price||0)+'"></div>'+
        '<div class="form-group"><label>Stock</label><input id="pc_stock" type="number" value="'+(m.stock||0)+'"></div>'+
        '<div class="form-group"><label>Min Stock</label><input id="pc_min" type="number" value="'+(m.minStock||0)+'"></div>'+
        '<div class="form-group"><label>Expiry</label><input id="pc_exp" type="date" value="'+esc(m.expiry||'')+'"></div>'+
        '<div class="form-group"><label>Controlled</label><select id="pc_ctrl"><option value="no"'+(m.controlled?'':' selected')+'>No</option><option value="yes"'+(m.controlled?' selected':'')+'>Yes — controlled drug</option></select></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="pcSaveDrug('+(id!=null?(typeof id==='number'?id:('\''+id+'\'')):'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.pcSaveDrug=function(id){
    var d=XD(); d.pharmacy=d.pharmacy||[];
    var name=gv('pc_name'); if(!name){ XTOAST('Enter a name','err'); return; }
    var rec=(id!=null)?(d.pharmacy||[]).find(function(x){return x.id===id;}):null;
    var isNew=!rec; if(isNew) rec={ id:(d.pharmacy.reduce(function(mx,x){return Math.max(mx,+x.id||0);},0)+1) };
    rec.name=name; rec.code=gv('pc_code')||rec.code||('MED'+String(d.pharmacy.length+1).padStart(3,'0'));
    rec.category=gv('pc_cat'); rec.supplier=gv('pc_sup');
    rec.unitPrice=gn('pc_cost'); rec.sellingPrice=gn('pc_sell'); rec.price=rec.sellingPrice;
    rec.stock=gn('pc_stock'); rec.minStock=gn('pc_min'); rec.expiry=gv('pc_exp');
    rec.controlled=(gv('pc_ctrl')==='yes'); rec.status=rec.status||'Active';
    if(isNew) d.pharmacy.push(rec);
    XCLOSE(); XSAVE(); XTOAST('Medication '+(isNew?'added':'updated')+' — '+name);
    if(typeof currentMod!=='undefined' && currentMod==='config'){ if(typeof showConfigTab==='function') showConfigTab('pharmacy'); else XRENDER(); } else XRENDER();
  };
  window.pcDelDrug=function(id){
    var d=XD(); var m=(d.pharmacy||[]).find(function(x){return x.id===id;}); if(!m) return;
    d.pharmacy=(d.pharmacy||[]).filter(function(x){return x.id!==id;});
    XSAVE(); XTOAST('Removed '+(m.name||'medication'));
    if(typeof showConfigTab==='function' && typeof currentMod!=='undefined' && currentMod==='config') showConfigTab('pharmacy'); else XRENDER();
  };
  function wireConfigPharmacy(){
    if(typeof window.renderConfigPharmacy==='function' && !window.renderConfigPharmacy._extWrapped){
      var _rc=window.renderConfigPharmacy;
      var f=function(){ var html=''; try{ html=_rc.apply(this,arguments)||''; }catch(e){ html=''; } try{ if(html.indexOf('id="pcCatalogueCard"')===-1) html=pcCatalogueCard()+html; }catch(e){} return html; };
      f._extWrapped=true; window.renderConfigPharmacy=f;
    }
  }

  /* Inventory module also shows the Pharmacy Catalogue (same D.pharmacy, fully synced) */
  function wireInventory(){
    if(typeof window.renderInventory==='function' && !window.renderInventory._extWrapped){
      var _ri=window.renderInventory;
      var f=function(){
        var html=''; try{ html=_ri.apply(this, arguments)||''; }catch(e){ html=''; }
        try{
          if(html.indexOf('extInventoryReport()')===-1){
            var bar='<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px" class="no-print">'+
              '<button class="btn btn-sm" style="background:#0d9488;color:#fff" onclick="extInventoryReport()"><i class="fa-solid fa-chart-pie"></i> Inventory Report</button>'+
              '<button class="btn btn-sm btn-pri" onclick="v29InvIssue()"><i class="fa-solid fa-arrow-up"></i> Issue Stock</button>'+
              '<button class="btn btn-sm" style="background:#22c55e;color:#fff" onclick="v29InvReceive()"><i class="fa-solid fa-arrow-down"></i> Receive Stock</button>'+
              '<button class="btn btn-sm" style="background:#f59e0b;color:#fff" onclick="autoReorder()"><i class="fa-solid fa-magic"></i> Auto-Reorder Review</button>'+
              '<button class="btn btn-sm" style="background:#0ea5e9;color:#fff" onclick="showAssetRegistry()"><i class="fa-solid fa-laptop-medical"></i> Asset Register</button>'+
              '</div>';
            html=bar+html;
          }
          if(html.indexOf('id="pcCatalogueCard"')===-1 && html.indexOf('Pharmacy Catalogue (Medications)')===-1){
            html=html+'<div class="form-section" style="margin-top:18px"><span><i class="fa-solid fa-pills" style="margin-right:6px"></i>Pharmacy Catalogue (Medications)</span></div>'+pcCatalogueCard();
          }
        }catch(e){}
        return html;
      };
      f._extWrapped=true; window.renderInventory=f;
    }
  }

  /* ════════════════════════════════════════════════════════════════════════
     NEW PRESCRIPTION FORM — nicer UI for catalogue picker + prescribed list
     (DOM post-process + scoped CSS; reuses host handlers/state, no logic change)
     ════════════════════════════════════════════════════════════════════════ */
  function injectRxStyle(){
    if(document.getElementById('extRxStyle')) return;
    var st=document.createElement('style'); st.id='extRxStyle';
    st.textContent=
      '#modalBg .rxb-search{background:#fff;border:1.5px solid #cbd5e1!important;border-radius:12px!important;box-shadow:0 1px 2px rgba(0,0,0,.04);transition:border-color .15s,box-shadow .15s}'+
      '#modalBg .rxb-search:focus{outline:none;border-color:#0d9488!important;box-shadow:0 0 0 3px rgba(13,148,136,.15)}'+
      '#modalBg #rxm2Catalog{border:1.5px solid #e2e8f0!important;border-radius:14px!important;background:linear-gradient(#ffffff,#f8fafc)!important;padding:5px!important;max-height:230px!important}'+
      '#modalBg #rxm2Catalog>div{border-bottom:1px solid #eef2f7!important;border-radius:10px!important;padding:8px 11px!important;transition:background .12s,box-shadow .12s,transform .08s}'+
      '#modalBg #rxm2Catalog>div:last-child{border-bottom:none!important}'+
      '#modalBg #rxm2Catalog>div:hover{background:#f0fdfa!important;box-shadow:inset 0 0 0 1px #99f6e4;transform:translateX(2px)}'+
      '#modalBg #rxm2Catalog .btn-pri{border-radius:9px!important;box-shadow:0 1px 2px rgba(13,148,136,.25)}'+
      '#modalBg .rxb-table table{border-collapse:separate;border-spacing:0}'+
      '#modalBg .rxb-table thead th{background:#0f766e!important;color:#fff!important;font-size:11px!important;letter-spacing:.3px;padding:9px 10px!important;border:none!important;position:sticky;top:0}'+
      '#modalBg .rxb-table thead th:first-child{border-top-left-radius:10px}#modalBg .rxb-table thead th:last-child{border-top-right-radius:10px}'+
      '#modalBg #rxm2LinesBody tr{transition:background .12s}'+
      '#modalBg #rxm2LinesBody tr:nth-child(even){background:#f8fafc}'+
      '#modalBg #rxm2LinesBody tr:hover{background:#ecfeff}'+
      '#modalBg #rxm2LinesBody td{padding:7px 9px!important;border-bottom:1px solid #eef2f7!important;vertical-align:middle}'+
      '#modalBg #rxm2LinesBody input,#modalBg #rxm2LinesBody select{border:1px solid #d8dee9!important;border-radius:8px!important;padding:5px 7px!important;font-size:12px!important;background:#fff}'+
      '#modalBg #rxm2LinesBody input:focus,#modalBg #rxm2LinesBody select:focus{outline:none;border-color:#0d9488!important;box-shadow:0 0 0 2px rgba(13,148,136,.15)}'+
      '#modalBg .rxb-sec span{display:inline-flex;align-items:center;gap:7px;font-size:12px;font-weight:800;color:#0f766e;letter-spacing:.3px;text-transform:uppercase}'+
      '#modalBg .rxb-sec{border-bottom:2px solid #ccfbf1!important;padding-bottom:5px!important}'+
      '#modalBg .rxb-sum{background:linear-gradient(135deg,#0f766e,#0d9488)!important;color:#fff!important;border:none!important;border-radius:12px!important;font-size:13px!important;padding:10px 14px!important}'+
      '#modalBg .rxb-sum b{font-size:17px}';
    document.head.appendChild(st);
  }
  function beautifyRxForm(){
    try{
      var body=document.querySelector('#modalBg .modal-body'); if(!body) return;
      var cat=body.querySelector('#rxm2Catalog'); if(!cat) return; /* only the Rx form has this */
      injectRxStyle();
      var search=body.querySelector('input[oninput*="rxm2CatalogFilter"]'); if(search) search.classList.add('rxb-search');
      var linesBody=body.querySelector('#rxm2LinesBody');
      if(linesBody){ var tbl=linesBody.closest('table'); var wrap=tbl?tbl.closest('.tbl-wrap'):null; if(wrap) wrap.classList.add('rxb-table'); }
      body.querySelectorAll('.form-section').forEach(function(sec){ var t=(sec.textContent||'').toLowerCase(); if(t.indexOf('catalogue')>-1||t.indexOf('prescribed medication')>-1) sec.classList.add('rxb-sec'); });
      var sum=body.querySelector('.twh-sumbar'); if(sum) sum.classList.add('rxb-sum');
    }catch(e){}
  }
  function wirePrescriptionForm(){
    if(typeof window.rxmNewRx==='function' && !window.rxmNewRx._extPretty){
      var _rx=window.rxmNewRx;
      var f=function(){ var r=_rx.apply(this, arguments); setTimeout(beautifyRxForm,30); setTimeout(beautifyRxForm,120); return r; };
      f._extPretty=true; window.rxmNewRx=f;
      try{ Object.defineProperty(window,'newRx',{configurable:true,enumerable:true,get:function(){return window.rxmNewRx;},set:function(){}}); }catch(e){}
    }
    /* route the module's generic "New Prescription" button to the rich catalogue form */
    if(typeof window.addNewRecord==='function' && !window.addNewRecord._extRx){
      var _an=window.addNewRecord;
      var g=function(dataKey){ if(dataKey==='prescriptions' && typeof window.rxmNewRx==='function'){ return window.rxmNewRx(); } return _an.apply(this, arguments); };
      g._extRx=true; window.addNewRecord=g;
    }
  }

  /* ════════════════════════════════════════════════════════════════════════
     PROCUREMENT — PO detail/edit/cancel/delete + activated registries
     (Vendor Scorecard, Equipment Asset Registry, Vendor Contract Management)
     ════════════════════════════════════════════════════════════════════════ */
  function di(l,v){ return '<div class="detail-item"><div class="dl">'+esc(l)+'</div><div class="dv">'+((v==null||v==='')?'—':v)+'</div></div>'; }
  function bar(v,c){ v=+v||0; return '<div style="display:flex;align-items:center;gap:6px"><div style="flex:1;height:7px;background:#e2e8f0;border-radius:4px;overflow:hidden;min-width:46px"><div style="width:'+v+'%;height:100%;background:'+c+'"></div></div><span style="font-size:11px">'+v+'%</span></div>'; }
  var STC=function(s){ try{ return (typeof stc==='function')?stc(s):''; }catch(e){ return ''; } };

  /* — Purchase Order detail + lifecycle actions — */
  window.extPOView=function(id){
    var d=XD(); var po=(d.purchaseOrders||[]).find(function(x){return x.id===id;}); if(!po){ XTOAST('PO not found','err'); return; }
    var items=(Array.isArray(po.lineItems)&&po.lineItems.length)?po.lineItems:(Array.isArray(po.lines)?po.lines:(Array.isArray(po.items)?po.items:(typeof po.items==='string'?parseItemsString(po.items):[])));
    var itemRows=items.length? items.map(function(it){ var q=it.qty||it.quantity||1; var u=it.unitCost||it.cost||it.price||it.unitPrice||0; return '<tr><td>'+esc(it.name||it.item||it.description||'Item')+'</td><td style="text-align:right">'+q+'</td><td style="text-align:right">'+EF(u)+'</td><td style="text-align:right">'+EF(q*u)+'</td></tr>'; }).join('') : '<tr><td colspan="4" style="text-align:center;color:var(--txt3);padding:12px">No line items recorded</td></tr>';
    var st=po.status||''; var canReceive=(st==='Ordered'||st==='Shipped'||st==='Approved');
    var body='<div class="detail-grid">'+di('PO Code',esc(po.code))+di('Supplier',esc(po.supplier))+di('Order Date',esc(po.orderDate))+di('Expected',esc(po.eta||po.expectedDelivery||''))+di('Status','<span class="st '+STC(st)+'">'+esc(st)+'</span>')+di('Total','<b>'+EF(po.total||0)+'</b>')+'</div>'+
      '<div class="form-section" style="margin-top:12px"><span>Line Items</span></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Item</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Cost</th><th style="text-align:right">Total</th></tr></thead><tbody>'+itemRows+'</tbody></table></div>'+
      (po.notes?('<div style="margin-top:10px;font-size:12px;color:var(--txt2)"><b>Notes:</b> '+esc(po.notes)+'</div>'):'');
    var footer='<button class="btn btn-ghost" onclick="closeModal()">Close</button>'+
      '<button class="btn btn-sm" style="background:#3b82f6;color:#fff" onclick="closeModal();editRecord(\'purchaseOrders\','+id+')"><i class="fa-solid fa-edit"></i> Edit</button>'+
      (canReceive?('<button class="btn btn-sm" style="background:#22c55e;color:#fff" onclick="closeModal();receiveStock('+id+')"><i class="fa-solid fa-clipboard-check"></i> Receive</button>'):'')+
      '<button class="btn btn-sm" style="background:#64748b;color:#fff" onclick="postPOToGL('+id+')"><i class="fa-solid fa-book"></i> Post GL</button>'+
      (st!=='Cancelled'?('<button class="btn btn-sm" style="background:#f59e0b;color:#fff" onclick="extPOCancel('+id+')"><i class="fa-solid fa-ban"></i> Cancel</button>'):'')+
      '<button class="btn btn-sm" style="background:#ef4444;color:#fff" onclick="extPODelete('+id+')"><i class="fa-solid fa-trash"></i> Delete</button>';
    XMODAL('<i class="fa-solid fa-file-invoice" style="color:#0d9488;margin-right:8px"></i>Purchase Order — '+esc(po.code||''), body, footer, 'wide');
  };
  window.extPOCancel=function(id){
    var d=XD(); var po=(d.purchaseOrders||[]).find(function(x){return x.id===id;}); if(!po) return;
    if(typeof confirm==='function' && !confirm('Cancel PO '+(po.code||'')+'? It will be marked Cancelled.')) return;
    po.status='Cancelled'; notify('Purchase order cancelled',(po.code||'')+' — '+(po.supplier||''),'system','procurement',po.code);
    XSAVE(); XTOAST('PO '+(po.code||'')+' cancelled'); XCLOSE(); XRENDER();
  };
  window.extPODelete=function(id){
    var d=XD(); var po=(d.purchaseOrders||[]).find(function(x){return x.id===id;}); if(!po) return;
    if(typeof confirm==='function' && !confirm('Delete PO '+(po.code||'')+' permanently?')) return;
    d.purchaseOrders=(d.purchaseOrders||[]).filter(function(x){return x.id!==id;});
    XSAVE(); XTOAST('PO '+(po.code||'')+' deleted'); XCLOSE(); XRENDER();
  };

  /* — line-by-line PO tracker shown inside the Procurement module — */
  function poStatusColor(s){ s=s||''; return /cancel/i.test(s)?'#ef4444':/deliver|received|complete/i.test(s)?'#22c55e':/ship/i.test(s)?'#8b5cf6':/approv/i.test(s)?'#3b82f6':/draft/i.test(s)?'#94a3b8':'#f59e0b'; }
  function poItemsSummary(po){
    if(typeof po.items==='string' && po.items) return po.items;
    var li=po.lineItems||po.items; if(Array.isArray(li)&&li.length) return li.map(function(l){return (l.qty||l.quantity||1)+'\u00d7 '+(l.name||l.item||'item');}).join(', ');
    return '';
  }
  window.extPOTracker=function(){
    var d=XD(); var pos=(d.purchaseOrders||[]).slice().sort(function(a,b){return String(b.orderDate||'').localeCompare(String(a.orderDate||''));});
    var rows=pos.map(function(po,i){
      var st=po.status||'Ordered'; var c=poStatusColor(st); var canReceive=!/deliver|received|cancel/i.test(st);
      var act='<div class="act-row">'+
        '<button class="act-btn" title="View / details" onclick="extPOView('+po.id+')"><i class="fa-solid fa-eye"></i></button>'+
        (canReceive?'<button class="act-btn" title="Receive goods" style="color:#22c55e" onclick="receiveStock('+po.id+')"><i class="fa-solid fa-clipboard-check"></i></button>':'')+
        '<button class="act-btn edit" title="Edit" onclick="editRecord(\'purchaseOrders\','+po.id+')"><i class="fa-solid fa-edit"></i></button>'+
        (st!=='Cancelled'?'<button class="act-btn" title="Cancel PO" style="color:#f59e0b" onclick="extPOCancel('+po.id+')"><i class="fa-solid fa-ban"></i></button>':'')+
        '<button class="act-btn del" title="Delete" onclick="extPODelete('+po.id+')"><i class="fa-solid fa-trash"></i></button>'+
        '<button class="act-btn" title="Post to GL" style="color:#64748b" onclick="postPOToGL('+po.id+')"><i class="fa-solid fa-book"></i></button>'+
        '</div>';
      var sumr=poItemsSummary(po);
      return '<tr><td>'+(i+1)+'</td><td><b>'+esc(po.code||'')+'</b></td><td>'+esc(po.supplier||'')+'</td><td>'+esc(po.orderDate||'')+'</td><td>'+esc(po.expectedDelivery||po.eta||'\u2014')+'</td><td style="max-width:230px;font-size:11px;color:var(--txt2)">'+esc(sumr||'\u2014')+'</td><td style="font-weight:700">'+EF(po.total||0)+'</td><td><span class="badge" style="background:'+c+'1a;color:'+c+';font-weight:700;padding:2px 9px;border-radius:9px">'+esc(st)+'</span>'+(po.receivedDate?('<div style="font-size:9px;color:#22c55e;margin-top:2px">received '+esc(po.receivedDate)+'</div>'):'')+'</td><td>'+act+'</td></tr>';
    }).join('');
    return '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-clipboard-list" style="color:var(--pri);margin-right:8px"></i>Purchase Orders — status, receive &amp; actions</h3><button class="btn btn-pri btn-sm" onclick="addNewRecord(\'purchaseOrders\')"><i class="fa-solid fa-plus"></i> New PO</button></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>#</th><th>PO</th><th>Supplier</th><th>Order Date</th><th>Expected</th><th>Items</th><th>Total</th><th>Status</th><th>Actions</th></tr></thead><tbody>'+(rows||'<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:16px">No purchase orders yet — click <b>New PO</b> to create one.</td></tr>')+'</tbody></table></div></div>';
  };

  /* — Vendor Performance Scorecard (full CRUD) — */
  window.extVendorScorecard=function(){
    var d=XD(); d.vendorScores=d.vendorScores||[];
    var rows=d.vendorScores.map(function(v){ var c=v.overallScore>=85?'#22c55e':v.overallScore>=70?'#f59e0b':'#ef4444';
      return '<tr><td><b>'+esc(v.vendor)+'</b></td><td>'+esc(v.category||'')+'</td><td>'+bar(v.deliveryScore,c)+'</td><td>'+bar(v.qualityScore,c)+'</td><td>'+bar(v.priceScore,c)+'</td><td style="font-weight:800;color:'+c+'">'+(v.overallScore||0)+'%</td><td>'+(v.contracts||0)+'</td><td>'+esc(v.lastDelivery||'')+'</td><td><div class="act-row"><button class="act-btn edit" title="Edit" onclick="vsAddEdit('+v.id+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Delete" onclick="vsDel('+v.id+')"><i class="fa-solid fa-trash"></i></button></div></td></tr>'; }).join('');
    var body='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><span style="font-size:12px;color:var(--txt2)">Rate and track supplier delivery, quality and pricing performance.</span><button class="btn btn-pri btn-sm" onclick="vsAddEdit(null)"><i class="fa-solid fa-plus"></i> Add / Rate Vendor</button></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Vendor</th><th>Category</th><th>Delivery</th><th>Quality</th><th>Pricing</th><th>Overall</th><th>Contracts</th><th>Last Delivery</th><th></th></tr></thead><tbody>'+(rows||'<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:14px">No vendors rated yet</td></tr>')+'</tbody></table></div>';
    XMODAL('<i class="fa-solid fa-star" style="color:#f59e0b;margin-right:8px"></i>Vendor Performance Scorecard', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.vsAddEdit=function(id){
    var d=XD(); var v=(id!=null)?(d.vendorScores||[]).find(function(x){return x.id===id;}):null; v=v||{};
    XMODAL('<i class="fa-solid fa-star" style="color:#f59e0b;margin-right:8px"></i>'+(id!=null?'Edit Vendor Rating':'Rate New Vendor'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>Vendor <span class="req">*</span></label>'+supplierSelect('vs_vendor', v.vendor||'')+'</div>'+
        '<div class="form-group"><label>Category</label><input id="vs_cat" value="'+esc(v.category||'')+'"></div>'+
        '<div class="form-group"><label>Delivery Score (%)</label><input id="vs_del" type="number" min="0" max="100" value="'+(v.deliveryScore!=null?v.deliveryScore:80)+'"></div>'+
        '<div class="form-group"><label>Quality Score (%)</label><input id="vs_qual" type="number" min="0" max="100" value="'+(v.qualityScore!=null?v.qualityScore:80)+'"></div>'+
        '<div class="form-group"><label>Pricing Score (%)</label><input id="vs_price" type="number" min="0" max="100" value="'+(v.priceScore!=null?v.priceScore:80)+'"></div>'+
        '<div class="form-group"><label>Active Contracts</label><input id="vs_contracts" type="number" min="0" value="'+(v.contracts||0)+'"></div>'+
        '<div class="form-group"><label>Last Delivery</label><input id="vs_last" type="date" value="'+esc(v.lastDelivery||'')+'"></div>'+
      '</div><div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Overall score is the average of delivery, quality and pricing.</div>',
      '<button class="btn btn-pri" onclick="vsSave('+(id!=null?id:'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="extVendorScorecard()">Back</button>','');
  };
  window.vsSave=function(id){
    var d=XD(); d.vendorScores=d.vendorScores||[]; var vendor=gv('vs_vendor'); if(!vendor){ XTOAST('Enter a vendor','err'); return; }
    var del=gn('vs_del'), qual=gn('vs_qual'), price=gn('vs_price'); var overall=Math.round((del+qual+price)/3);
    var rec=(id!=null)?(d.vendorScores||[]).find(function(x){return x.id===id;}):null; var isNew=!rec;
    if(isNew){ rec={ id:(d.vendorScores.reduce(function(m,x){return Math.max(m,+x.id||0);},0)+1) }; d.vendorScores.push(rec); }
    rec.vendor=vendor; rec.category=gv('vs_cat'); rec.deliveryScore=del; rec.qualityScore=qual; rec.priceScore=price; rec.overallScore=overall; rec.contracts=gn('vs_contracts'); rec.lastDelivery=gv('vs_last');
    XSAVE(); XTOAST('Vendor '+(isNew?'rated':'updated')+' — '+vendor+' ('+overall+'%)'); extVendorScorecard();
  };
  window.vsDel=function(id){ var d=XD(); if(typeof confirm==='function'&&!confirm('Remove this vendor rating?'))return; d.vendorScores=(d.vendorScores||[]).filter(function(x){return x.id!==id;}); XSAVE(); XTOAST('Vendor rating removed'); extVendorScorecard(); };

  /* — Medical Equipment Asset Registry (full CRUD) — */
  window.extAssetRegistry=function(){
    var d=XD(); d.assetRegistry=d.assetRegistry||[];
    var rows=d.assetRegistry.map(function(a){ var overdue=a.nextMaintenance&&(new Date(a.nextMaintenance)<new Date());
      return '<tr><td><b>'+esc(a.code||'')+'</b></td><td style="font-weight:600">'+esc(a.name||'')+'</td><td>'+esc(a.category||'')+'</td><td>'+esc(a.location||'')+'</td><td style="font-family:monospace;font-size:10px">'+esc(a.serial||'')+'</td><td>'+EF(a.purchasePrice||0)+'</td><td style="font-weight:700;color:var(--pri)">'+EF(a.currentValue||0)+'</td><td style="color:'+(overdue?'#ef4444':'#22c55e')+'">'+esc(a.nextMaintenance||'—')+'</td><td><span class="st st-active">'+esc(a.status||'In Service')+'</span></td><td><div class="act-row"><button class="act-btn edit" title="Edit" onclick="asAddEdit('+a.id+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Delete" onclick="asDel('+a.id+')"><i class="fa-solid fa-trash"></i></button></div></td></tr>'; }).join('');
    var body='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><span style="font-size:12px;color:var(--txt2)">Track medical equipment, valuation and preventive-maintenance schedules.</span><button class="btn btn-pri btn-sm" onclick="asAddEdit(null)"><i class="fa-solid fa-plus"></i> Add Asset</button></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Asset</th><th>Category</th><th>Location</th><th>Serial</th><th>Purchase</th><th>Current Value</th><th>Next Maint.</th><th>Status</th><th></th></tr></thead><tbody>'+(rows||'<tr><td colspan="10" style="text-align:center;color:var(--txt3);padding:14px">No assets registered yet</td></tr>')+'</tbody></table></div>';
    XMODAL('<i class="fa-solid fa-laptop-medical" style="color:#0ea5e9;margin-right:8px"></i>Medical Equipment Asset Registry', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.asAddEdit=function(id){
    var d=XD(); var a=(id!=null)?(d.assetRegistry||[]).find(function(x){return x.id===id;}):null; a=a||{};
    XMODAL('<i class="fa-solid fa-laptop-medical" style="color:#0ea5e9;margin-right:8px"></i>'+(id!=null?'Edit Asset':'Add Asset'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>Asset Name <span class="req">*</span></label><input id="as_name" value="'+esc(a.name||'')+'" placeholder="e.g. Ventilator — Hamilton C6"></div>'+
        '<div class="form-group"><label>Code</label><input id="as_code" value="'+esc(a.code||'')+'" placeholder="auto"></div>'+
        '<div class="form-group"><label>Category</label><input id="as_cat" value="'+esc(a.category||'')+'" placeholder="Critical Care / Radiology…"></div>'+
        '<div class="form-group"><label>Location</label><input id="as_loc" value="'+esc(a.location||'')+'"></div>'+
        '<div class="form-group"><label>Serial No.</label><input id="as_serial" value="'+esc(a.serial||'')+'"></div>'+
        '<div class="form-group"><label>Purchase Date</label><input id="as_pdate" type="date" value="'+esc(a.purchaseDate||'')+'"></div>'+
        '<div class="form-group"><label>Purchase Price (\u20a6)</label><input id="as_pprice" type="number" value="'+(a.purchasePrice||0)+'"></div>'+
        '<div class="form-group"><label>Current Value (\u20a6)</label><input id="as_cval" type="number" value="'+(a.currentValue||0)+'"></div>'+
        '<div class="form-group"><label>Maintenance Schedule</label><select id="as_sched"><option'+(a.maintenanceSchedule==='Monthly'?' selected':'')+'>Monthly</option><option'+(a.maintenanceSchedule==='Quarterly'?' selected':'')+'>Quarterly</option><option'+(a.maintenanceSchedule==='Bi-Annual'?' selected':'')+'>Bi-Annual</option><option'+(a.maintenanceSchedule==='Annual'?' selected':'')+'>Annual</option></select></div>'+
        '<div class="form-group"><label>Next Maintenance</label><input id="as_next" type="date" value="'+esc(a.nextMaintenance||'')+'"></div>'+
        '<div class="form-group"><label>Warranty Until</label><input id="as_warr" type="date" value="'+esc(a.warranty||'')+'"></div>'+
        '<div class="form-group"><label>Status</label><select id="as_status"><option'+(a.status==='In Service'?' selected':'')+'>In Service</option><option'+(a.status==='Under Maintenance'?' selected':'')+'>Under Maintenance</option><option'+(a.status==='Retired'?' selected':'')+'>Retired</option></select></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="asSave('+(id!=null?id:'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="extAssetRegistry()">Back</button>','wide');
  };
  window.asSave=function(id){
    var d=XD(); d.assetRegistry=d.assetRegistry||[]; var name=gv('as_name'); if(!name){ XTOAST('Enter an asset name','err'); return; }
    var rec=(id!=null)?(d.assetRegistry||[]).find(function(x){return x.id===id;}):null; var isNew=!rec;
    if(isNew){ rec={ id:(d.assetRegistry.reduce(function(m,x){return Math.max(m,+x.id||0);},0)+1) }; d.assetRegistry.push(rec); }
    rec.name=name; rec.code=gv('as_code')||rec.code||('AST-'+String(d.assetRegistry.length).padStart(3,'0'));
    rec.category=gv('as_cat'); rec.location=gv('as_loc'); rec.serial=gv('as_serial'); rec.purchaseDate=gv('as_pdate');
    rec.purchasePrice=gn('as_pprice'); rec.currentValue=gn('as_cval'); rec.maintenanceSchedule=gv('as_sched');
    rec.nextMaintenance=gv('as_next'); rec.warranty=gv('as_warr'); rec.status=gv('as_status')||'In Service';
    XSAVE(); XTOAST('Asset '+(isNew?'added':'updated')+' — '+name); extAssetRegistry();
  };
  window.asDel=function(id){ var d=XD(); if(typeof confirm==='function'&&!confirm('Delete this asset?'))return; d.assetRegistry=(d.assetRegistry||[]).filter(function(x){return x.id!==id;}); XSAVE(); XTOAST('Asset removed'); extAssetRegistry(); };

  /* — Vendor Contract Management (full CRUD) — */
  window.extContractManagement=function(){
    var d=XD(); d.contracts=d.contracts||[];
    var cards=d.contracts.map(function(c){ var exp=(c.status||'').toLowerCase().indexOf('expir')>-1;
      return '<div class="card" style="margin:0 0 10px"><div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px"><div><b>'+esc(c.vendor)+'</b> — '+esc(c.type||'')+'<div style="font-size:12px;color:var(--txt2)">Period: '+esc(c.startDate||'')+' → '+esc(c.endDate||'')+' · Value: <b>'+EF(c.value||0)+'</b></div></div><div style="display:flex;align-items:center;gap:6px"><span class="st '+STC(c.status)+'">'+esc(c.status||'')+'</span><button class="act-btn edit" title="Edit" onclick="ctAddEdit('+c.id+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Delete" onclick="ctDel('+c.id+')"><i class="fa-solid fa-trash"></i></button></div></div>'+
        (c.terms?('<div style="font-size:11px;color:var(--txt3);margin-top:6px"><b>Terms:</b> '+esc(c.terms)+'</div>'):'')+
        (exp?('<div class="alert alert-amber" style="margin-top:6px"><i class="fa-solid fa-clock"></i> Renewal due: '+esc(c.renewalDate||'')+'</div>'):'')+'</div>'; }).join('');
    var body='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><span style="font-size:12px;color:var(--txt2)">Manage supplier agreements, values and renewal dates.</span><button class="btn btn-pri btn-sm" onclick="ctAddEdit(null)"><i class="fa-solid fa-plus"></i> Add Contract</button></div>'+(cards||'<p style="color:var(--txt3);text-align:center;padding:14px">No contracts yet</p>');
    XMODAL('<i class="fa-solid fa-file-contract" style="color:#8b5cf6;margin-right:8px"></i>Vendor Contract Management', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.ctAddEdit=function(id){
    var d=XD(); var c=(id!=null)?(d.contracts||[]).find(function(x){return x.id===id;}):null; c=c||{};
    XMODAL('<i class="fa-solid fa-file-contract" style="color:#8b5cf6;margin-right:8px"></i>'+(id!=null?'Edit Contract':'Add Contract'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>Vendor <span class="req">*</span></label>'+supplierSelect('ct_vendor', c.vendor||'')+'</div>'+
        '<div class="form-group"><label>Type</label><input id="ct_type" value="'+esc(c.type||'')+'" placeholder="Supply Agreement / Maintenance…"></div>'+
        '<div class="form-group"><label>Start Date</label><input id="ct_start" type="date" value="'+esc(c.startDate||'')+'"></div>'+
        '<div class="form-group"><label>End Date</label><input id="ct_end" type="date" value="'+esc(c.endDate||'')+'"></div>'+
        '<div class="form-group"><label>Value (\u20a6)</label><input id="ct_value" type="number" value="'+(c.value||0)+'"></div>'+
        '<div class="form-group"><label>Renewal Date</label><input id="ct_renew" type="date" value="'+esc(c.renewalDate||'')+'"></div>'+
        '<div class="form-group"><label>Status</label><select id="ct_status"><option'+(c.status==='Active'?' selected':'')+'>Active</option><option'+((c.status||'').indexOf('Expir')>-1?' selected':'')+'>Expiring Soon</option><option'+(c.status==='Expired'?' selected':'')+'>Expired</option><option'+(c.status==='Terminated'?' selected':'')+'>Terminated</option></select></div>'+
        '<div class="form-group full"><label>Terms</label><textarea id="ct_terms" rows="2">'+esc(c.terms||'')+'</textarea></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="ctSave('+(id!=null?id:'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="extContractManagement()">Back</button>','wide');
  };
  window.ctSave=function(id){
    var d=XD(); d.contracts=d.contracts||[]; var vendor=gv('ct_vendor'); if(!vendor){ XTOAST('Enter a vendor','err'); return; }
    var rec=(id!=null)?(d.contracts||[]).find(function(x){return x.id===id;}):null; var isNew=!rec;
    if(isNew){ rec={ id:(d.contracts.reduce(function(m,x){return Math.max(m,+x.id||0);},0)+1) }; d.contracts.push(rec); }
    rec.vendor=vendor; rec.type=gv('ct_type'); rec.startDate=gv('ct_start'); rec.endDate=gv('ct_end'); rec.value=gn('ct_value'); rec.renewalDate=gv('ct_renew'); rec.status=gv('ct_status')||'Active'; rec.terms=gv('ct_terms');
    XSAVE(); XTOAST('Contract '+(isNew?'added':'updated')+' — '+vendor); extContractManagement();
  };
  window.ctDel=function(id){ var d=XD(); if(typeof confirm==='function'&&!confirm('Delete this contract?'))return; d.contracts=(d.contracts||[]).filter(function(x){return x.id!==id;}); XSAVE(); XTOAST('Contract removed'); extContractManagement(); };

  /* — unified New / Edit PO form with reviewable auto-generated PO number — */
  function nextPOCode(){ var d=XD(); var mx=0; (d.purchaseOrders||[]).forEach(function(p){ var m=/PO-0*(\d+)/.exec(p.code||''); if(m) mx=Math.max(mx,+m[1]); }); return 'PO-'+String(mx+1).padStart(4,'0'); }
  function nextNumId(arr){ var m=0; (arr||[]).forEach(function(x){ var n=+x.id; if(!isNaN(n)) m=Math.max(m,n); }); return m+1; }
  function parseItemsString(s){ if(!s||typeof s!=='string') return []; return s.split(',').map(function(p){ p=p.trim(); var m=/^(\d+)\s*[x\u00d7]\s*(.+)$/i.exec(p); if(m) return {name:m[2].trim(),qty:+m[1],unitCost:0}; return p?{name:p,qty:1,unitCost:0}:null; }).filter(Boolean); }
  function poCatalogNames(){ var d=XD(); var s={}; (d.pharmacy||[]).forEach(function(m){if(m.name)s[m.name]=1;}); (d.inventory||[]).forEach(function(m){if(m.name)s[m.name]=1;}); return Object.keys(s); }
  window.__extPOLines=[];
  function epoLinesBody(){
    return window.__extPOLines.map(function(l,i){
      var lt=(parseFloat(l.qty)||0)*(parseFloat(l.unitCost)||0);
      return '<tr><td><input list="epo_cat" value="'+esc(l.name||'')+'" oninput="extPOSetLine('+i+',\'name\',this.value)" placeholder="Item name" style="width:100%"></td>'+
        '<td><input type="number" min="1" value="'+(l.qty||1)+'" oninput="extPOSetLine('+i+',\'qty\',this.value)" style="width:64px;text-align:right"></td>'+
        '<td><input type="number" min="0" value="'+(l.unitCost||0)+'" oninput="extPOSetLine('+i+',\'unitCost\',this.value)" style="width:98px;text-align:right"></td>'+
        '<td id="epo_lt_'+i+'" style="text-align:right;font-weight:700;white-space:nowrap">'+EF(lt)+'</td>'+
        '<td style="text-align:center"><button type="button" class="act-btn del" title="Remove" onclick="extPODelLine('+i+')"><i class="fa-solid fa-trash"></i></button></td></tr>';
    }).join('');
  }
  function epoTotal(){ return window.__extPOLines.reduce(function(s,l){return s+(parseFloat(l.qty)||0)*(parseFloat(l.unitCost)||0);},0); }
  function epoRefresh(){ var b=document.getElementById('epo_lines'); if(b) b.innerHTML=epoLinesBody(); var t=document.getElementById('epo_total'); if(t) t.textContent=EF(epoTotal()); }
  window.extPOSetLine=function(i,f,v){ if(!window.__extPOLines[i]) return; window.__extPOLines[i][f]=v; if(f==='qty'||f==='unitCost'){ var el=document.getElementById('epo_lt_'+i); if(el) el.textContent=EF((parseFloat(window.__extPOLines[i].qty)||0)*(parseFloat(window.__extPOLines[i].unitCost)||0)); var t=document.getElementById('epo_total'); if(t) t.textContent=EF(epoTotal()); } };
  window.extPOAddLine=function(){ window.__extPOLines.push({name:'',qty:1,unitCost:0}); epoRefresh(); };
  window.extPODelLine=function(i){ window.__extPOLines.splice(i,1); if(!window.__extPOLines.length) window.__extPOLines=[{name:'',qty:1,unitCost:0}]; epoRefresh(); };
  window.extPOForm=function(id){
    var d=XD(); var po=(id!=null)?(d.purchaseOrders||[]).find(function(x){return x.id===id;}):null; var editing=!!po;
    var code=editing?(po.code||nextPOCode()):nextPOCode();
    var li=editing?((po.lineItems&&po.lineItems.length)?po.lineItems:parseItemsString(po.items)):[];
    window.__extPOLines=li.length?li.map(function(l){return {name:l.name||l.item||'',qty:l.qty||l.quantity||1,unitCost:l.unitCost||l.cost||l.price||0,kind:l.kind,id:l.id};}):[{name:'',qty:1,unitCost:0}];
    var supList=((d.suppliers||[]).concat(d.vendors||[])).map(function(s){return s.name||s.companyName;}).filter(Boolean);
    var supOpts=supList.map(function(n){return '<option value="'+esc(n)+'">';}).join('');
    var catOpts=poCatalogNames().map(function(n){return '<option value="'+esc(n)+'">';}).join('');
    var statuses=['Draft','Submitted','Approved','Ordered','Shipped','Delivered','Cancelled'];
    var curSt=editing?(po.status||'Ordered'):'Ordered';
    var body='<div class="form-grid">'+
      '<div class="form-group"><label>PO Number <span style="font-size:10px;color:#0d9488">(auto-generated \u00b7 review / adjust)</span></label><input id="epo_code" value="'+esc(code)+'" style="font-weight:800;color:#0f766e;background:#f0fdfa;border:1.5px solid #99f6e4"></div>'+
      '<div class="form-group"><label>Supplier <span class="req">*</span></label><input id="epo_supplier" list="epo_sup" value="'+esc(editing?(po.supplier||''):'')+'" placeholder="Supplier name"><datalist id="epo_sup">'+supOpts+'</datalist></div>'+
      '<div class="form-group"><label>Order Date</label><input id="epo_date" type="date" value="'+esc(editing?(po.orderDate||XTODAY()):XTODAY())+'"></div>'+
      '<div class="form-group"><label>Expected Delivery</label><input id="epo_eta" type="date" value="'+esc(editing?(po.expectedDelivery||po.eta||''):'')+'"></div>'+
      '<div class="form-group"><label>Status</label><select id="epo_status">'+statuses.map(function(s){return '<option'+(curSt===s?' selected':'')+'>'+s+'</option>';}).join('')+'</select></div>'+
      '<div class="form-group full"><label>Items <span class="req">*</span></label>'+
        '<datalist id="epo_cat">'+catOpts+'</datalist>'+
        '<div class="tbl-wrap" style="border:1px solid var(--bdr);border-radius:8px;overflow:auto"><table class="tbl" style="margin:0;font-size:12px"><thead><tr><th>Item</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Cost</th><th style="text-align:right">Line Total</th><th></th></tr></thead><tbody id="epo_lines">'+epoLinesBody()+'</tbody>'+
        '<tfoot><tr style="background:#f0fdfa;font-weight:700"><td colspan="3" style="text-align:right">PO Total</td><td id="epo_total" style="text-align:right">'+EF(epoTotal())+'</td><td></td></tr></tfoot></table></div>'+
        '<button type="button" class="btn btn-xs" style="margin-top:6px;background:#ede9fe;color:#6d28d9" onclick="extPOAddLine()"><i class="fa-solid fa-plus"></i> Add item</button></div>'+
      '<div class="form-group full"><label>Notes</label><textarea id="epo_notes" rows="2">'+esc(editing?(po.notes||''):'')+'</textarea></div>'+
    '</div>';
    XMODAL('<i class="fa-solid fa-cart-plus" style="color:#0d9488;margin-right:8px"></i>'+(editing?('Edit Purchase Order — '+esc(code)):'New Purchase Order'), body,
      '<button class="btn btn-pri" onclick="extSavePO('+(editing?id:'null')+')"><i class="fa-solid fa-save"></i> '+(editing?'Update PO':'Create PO')+'</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.extSavePO=function(id){
    var d=XD(); d.purchaseOrders=d.purchaseOrders||[];
    var code=(gv('epo_code')||'').trim()||nextPOCode(); var supplier=(gv('epo_supplier')||'').trim();
    if(!supplier){ XTOAST('Supplier is required','err'); return; }
    var lines=window.__extPOLines.filter(function(l){return (l.name||'').trim();}).map(function(l){return {name:l.name.trim(),qty:parseInt(l.qty)||1,unitCost:parseFloat(l.unitCost)||0,kind:l.kind,id:l.id};});
    if(!lines.length){ XTOAST('Add at least one item','err'); return; }
    var total=lines.reduce(function(s,l){return s+l.qty*l.unitCost;},0);
    var itemsStr=lines.map(function(l){return l.qty+'\u00d7 '+l.name;}).join(', ');
    var po=(id!=null)?(d.purchaseOrders||[]).find(function(x){return x.id===id;}):null; var editing=!!po;
    var clash=(d.purchaseOrders||[]).find(function(x){return x.code===code && x!==po;});
    if(clash){ XTOAST('PO number '+code+' already exists — adjust it','err'); return; }
    if(!editing){ po={ id:nextNumId(d.purchaseOrders) }; d.purchaseOrders.push(po); }
    po.code=code; po.supplier=supplier; po.orderDate=gv('epo_date')||XTODAY(); po.expectedDelivery=gv('epo_eta')||''; po.status=gv('epo_status')||'Ordered';
    po.lineItems=lines; po.items=itemsStr; po.total=total; po.notes=gv('epo_notes')||'';
    notify((editing?'PO updated':'PO created'), po.code+' — '+supplier+' \u00b7 '+EF(total), 'finance','procurement',po.code);
    XCLOSE(); XSAVE(); XTOAST('Purchase Order '+(editing?'updated':'created')+' — '+po.code+' ('+EF(total)+')'); XRENDER();
  };

  /* ════════════════════════════════════════════════════════════════════════
     PROCUREMENT/INVENTORY — shared dropdowns, RFQ, consignment, stock moves,
     auto-reorder approval, inventory report
     ════════════════════════════════════════════════════════════════════════ */
  function supplierNames(){ var d=XD(); var n={}; (d.suppliers||[]).forEach(function(s){if(s.name)n[s.name]=1;}); (d.vendors||[]).forEach(function(v){var x=v.name||v.companyName; if(x)n[x]=1;}); (d.vendorScores||[]).forEach(function(v){if(v.vendor)n[v.vendor]=1;}); (d.contracts||[]).forEach(function(c){if(c.vendor)n[c.vendor]=1;}); return Object.keys(n).sort(); }
  function supplierSelect(id, sel){ var names=supplierNames(); if(sel&&names.indexOf(sel)<0) names.unshift(sel); var opts='<option value="">Select supplier…</option>'+names.map(function(n){return '<option'+(sel===n?' selected':'')+'>'+esc(n)+'</option>';}).join(''); return '<select id="'+id+'">'+opts+'</select>'; }
  function deptWardOptions(sel){ var d=XD(); var o='<option value="">Select dept / ward…</option>'; (d.departments||[]).filter(function(x){return x.active!==false;}).forEach(function(x){ o+='<option'+(sel===x.name?' selected':'')+'>'+esc(x.name)+'</option>'; }); (d.wards||[]).forEach(function(w){ o+='<option'+(sel===(w.name+' (Ward)')?' selected':'')+'>'+esc(w.name)+' (Ward)</option>'; }); return o; }
  function stockItemOptions(){ var d=XD(); var o='<option value="">Select item…</option>'; o+='<optgroup label="Pharmacy / Medications">'; (d.pharmacy||[]).forEach(function(m){ o+='<option value="pharmacy:'+m.id+'">'+esc(m.name)+' \u00b7 stock '+(m.stock||0)+'</option>'; }); o+='</optgroup><optgroup label="Inventory / Supplies">'; (d.inventory||[]).forEach(function(i){ o+='<option value="inventory:'+i.id+'">'+esc(i.name)+' \u00b7 qty '+(i.qty||0)+'</option>'; }); o+='</optgroup><optgroup label="Assets / Equipment">'; (d.assetRegistry||[]).forEach(function(a){ o+='<option value="asset:'+a.id+'">'+esc(a.name)+'</option>'; }); o+='</optgroup>'; return o; }
  function adjStock(val, delta){ var d=XD(); if(!val) return ''; var p=val.split(':'); var kind=p[0], id=parseInt(p[1]); if(kind==='pharmacy'){ var m=(d.pharmacy||[]).find(function(x){return x.id===id;}); if(m){ m.stock=Math.max(0,(m.stock||0)+delta); return m.name; } } else if(kind==='inventory'){ var i=(d.inventory||[]).find(function(x){return x.id===id;}); if(i){ i.qty=Math.max(0,(i.qty||0)+delta); return i.name; } } else if(kind==='asset'){ var a=(d.assetRegistry||[]).find(function(x){return x.id===id;}); if(a) return a.name; } return ''; }
  function logMove(rec){ var d=XD(); d.stockMovements=d.stockMovements||[]; d.stockMovements.push(rec); if(d.stockMovements.length>800) d.stockMovements=d.stockMovements.slice(-800); }

  /* — Issue Stock (to a department/ward) — items from full catalogue — */
  window.v29InvIssue=function(){
    XMODAL('<i class="fa-solid fa-arrow-up" style="color:var(--pri);margin-right:8px"></i>Issue Stock',
      '<div class="form-grid">'+
        '<div class="form-group full"><label>Item <span class="req">*</span></label><select id="iss_item">'+stockItemOptions()+'</select></div>'+
        '<div class="form-group"><label>Quantity</label><input type="number" id="iss_qty" value="1" min="1"></div>'+
        '<div class="form-group"><label>Issued To (Dept / Ward) <span class="req">*</span></label><select id="iss_to">'+deptWardOptions('')+'</select></div>'+
        '<div class="form-group"><label>Date</label><input type="date" id="iss_date" value="'+XTODAY()+'"></div>'+
        '<div class="form-group full"><label>Purpose / Notes</label><input id="iss_purpose"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="extDoIssue()"><i class="fa-solid fa-save"></i> Issue</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.extDoIssue=function(){
    var item=gv('iss_item'), q=gn('iss_qty'), to=gv('iss_to'); if(!item){ XTOAST('Select an item','err'); return; } if(!(q>0)){ XTOAST('Enter quantity','err'); return; } if(!to){ XTOAST('Select destination','err'); return; }
    var name=adjStock(item,-q);
    logMove({ id:XID(), date:gv('iss_date')||XTODAY(), code:item, name:name, type:'OUT', qty:q, ref:'ISS-'+Date.now().toString().slice(-5), to:to, purpose:gv('iss_purpose')||'' });
    notify('Stock issued', q+' \u00d7 '+name+' \u2192 '+to, 'system','inventory',name);
    XCLOSE(); XSAVE(); XTOAST('Issued '+q+' \u00d7 '+name+' to '+to); XRENDER();
  };
  /* — Receive Stock (from a supplier, into a dept/ward) — */
  window.v29InvReceive=function(){
    XMODAL('<i class="fa-solid fa-arrow-down" style="color:#16a34a;margin-right:8px"></i>Receive Stock',
      '<div class="form-grid">'+
        '<div class="form-group full"><label>Item <span class="req">*</span></label><select id="rcv_item">'+stockItemOptions()+'</select></div>'+
        '<div class="form-group"><label>Quantity</label><input type="number" id="rcv_qty" value="1" min="1"></div>'+
        '<div class="form-group"><label>From Supplier <span class="req">*</span></label>'+supplierSelect('rcv_sup','')+'</div>'+
        '<div class="form-group"><label>Receive To (Dept / Ward)</label><select id="rcv_to">'+deptWardOptions('')+'</select></div>'+
        '<div class="form-group"><label>Date</label><input type="date" id="rcv_date" value="'+XTODAY()+'"></div>'+
        '<div class="form-group"><label>Delivery / Ref No.</label><input id="rcv_ref" placeholder="GRN / delivery note"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="extDoReceive()"><i class="fa-solid fa-save"></i> Receive</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.extDoReceive=function(){
    var item=gv('rcv_item'), q=gn('rcv_qty'), sup=gv('rcv_sup'); if(!item){ XTOAST('Select an item','err'); return; } if(!(q>0)){ XTOAST('Enter quantity','err'); return; } if(!sup){ XTOAST('Select supplier','err'); return; }
    var name=adjStock(item,+q);
    logMove({ id:XID(), date:gv('rcv_date')||XTODAY(), code:item, name:name, type:'IN', qty:q, ref:gv('rcv_ref')||('GRN-'+Date.now().toString().slice(-5)), supplier:sup, to:gv('rcv_to')||'' });
    notify('Stock received', q+' \u00d7 '+name+' from '+sup, 'system','inventory',name);
    XCLOSE(); XSAVE(); XTOAST('Received '+q+' \u00d7 '+name+' from '+sup); XRENDER();
  };

  /* — E-Procurement: Electronic Bidding (RFQ CRUD) — */
  function nextRFQCode(){ var d=XD(); var y=new Date().getFullYear(); var mx=0; (d.rfqs||[]).forEach(function(r){ var m=/RFQ-\d{4}-0*(\d+)/.exec(r.code||''); if(m) mx=Math.max(mx,+m[1]); }); return 'RFQ-'+y+'-'+String(mx+1).padStart(3,'0'); }
  window.showEProcurement=function(){
    var d=XD(); d.rfqs=d.rfqs||[];
    var rows=d.rfqs.map(function(r){ var c=/award|complete/i.test(r.status)?'#22c55e':/cancel/i.test(r.status)?'#ef4444':/evaluat/i.test(r.status)?'#f59e0b':'#3b82f6';
      return '<tr><td><b>'+esc(r.code)+'</b></td><td>'+esc(r.item||'')+'</td><td style="text-align:center">'+(r.vendorsInvited||0)+'</td><td style="text-align:center">'+(r.quotesReceived||0)+'</td><td>'+esc(r.deadline||'')+'</td><td><span class="badge" style="background:'+c+'1a;color:'+c+';padding:2px 8px;border-radius:8px;font-weight:700">'+esc(r.status||'Open')+'</span></td><td style="font-weight:700;color:var(--pri)">'+(r.lowestBid?EF(r.lowestBid):'—')+'</td><td><div class="act-row"><button class="act-btn edit" onclick="rfqAddEdit('+r.id+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" onclick="rfqDel('+r.id+')"><i class="fa-solid fa-trash"></i></button></div></td></tr>'; }).join('');
    var body='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><span style="font-size:12px;color:var(--txt2)">Raise RFQs, compare quotations and award to a vendor.</span><button class="btn btn-pri btn-sm" onclick="rfqAddEdit(null)"><i class="fa-solid fa-plus"></i> Create RFQ</button></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>RFQ No</th><th>Item / Service</th><th>Invited</th><th>Quotes</th><th>Deadline</th><th>Status</th><th>Lowest Bid</th><th></th></tr></thead><tbody>'+(rows||'<tr><td colspan="8" style="text-align:center;color:var(--txt3);padding:14px">No RFQs yet — click Create RFQ</td></tr>')+'</tbody></table></div>';
    XMODAL('<i class="fa-solid fa-shopping-cart" style="color:var(--pri);margin-right:8px"></i>E-Procurement — Electronic Bidding', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.rfqAddEdit=function(id){
    var d=XD(); var r=(id!=null)?(d.rfqs||[]).find(function(x){return x.id===id;}):null; r=r||{};
    XMODAL('<i class="fa-solid fa-shopping-cart" style="color:var(--pri);margin-right:8px"></i>'+(id!=null?'Edit RFQ':'Create RFQ'),
      '<div class="form-grid">'+
        '<div class="form-group"><label>RFQ No</label><input id="rfq_code" value="'+esc(r.code||nextRFQCode())+'" style="font-weight:700;background:#f0fdfa"></div>'+
        '<div class="form-group full"><label>Item / Service <span class="req">*</span></label><input id="rfq_item" value="'+esc(r.item||'')+'" placeholder="e.g. Surgical Gloves (50,000 pairs)"></div>'+
        '<div class="form-group"><label>Vendors Invited</label><input id="rfq_inv" type="number" min="0" value="'+(r.vendorsInvited||0)+'"></div>'+
        '<div class="form-group"><label>Quotes Received</label><input id="rfq_q" type="number" min="0" value="'+(r.quotesReceived||0)+'"></div>'+
        '<div class="form-group"><label>Deadline</label><input id="rfq_deadline" type="date" value="'+esc(r.deadline||'')+'"></div>'+
        '<div class="form-group"><label>Lowest Bid (\u20a6)</label><input id="rfq_low" type="number" min="0" value="'+(r.lowestBid||0)+'"></div>'+
        '<div class="form-group"><label>Award To</label>'+supplierSelect('rfq_award', r.awardedVendor||'')+'</div>'+
        '<div class="form-group"><label>Status</label><select id="rfq_status"><option'+(r.status==='Open'?' selected':'')+'>Open</option><option'+(r.status==='Evaluating'?' selected':'')+'>Evaluating</option><option'+(r.status==='Awarded'?' selected':'')+'>Awarded</option><option'+(r.status==='Cancelled'?' selected':'')+'>Cancelled</option></select></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="rfqSave('+(id!=null?id:'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="showEProcurement()">Back</button>','wide');
  };
  window.rfqSave=function(id){
    var d=XD(); d.rfqs=d.rfqs||[]; var item=gv('rfq_item'); if(!item){ XTOAST('Enter item/service','err'); return; }
    var rec=(id!=null)?(d.rfqs||[]).find(function(x){return x.id===id;}):null; var isNew=!rec;
    if(isNew){ rec={ id:nextNumId(d.rfqs) }; d.rfqs.push(rec); }
    rec.code=gv('rfq_code')||nextRFQCode(); rec.item=item; rec.vendorsInvited=gn('rfq_inv'); rec.quotesReceived=gn('rfq_q'); rec.deadline=gv('rfq_deadline'); rec.lowestBid=gn('rfq_low'); rec.awardedVendor=gv('rfq_award'); rec.status=gv('rfq_status')||'Open';
    XSAVE(); XTOAST('RFQ '+(isNew?'created':'updated')+' — '+rec.code); showEProcurement();
  };
  window.rfqDel=function(id){ var d=XD(); if(typeof confirm==='function'&&!confirm('Delete this RFQ?'))return; d.rfqs=(d.rfqs||[]).filter(function(x){return x.id!==id;}); XSAVE(); XTOAST('RFQ removed'); showEProcurement(); };

  /* — Consignment Inventory Management (CRUD) — */
  window.showConsignmentInventory=function(){
    var d=XD(); d.consignments=d.consignments||[];
    var rows=d.consignments.map(function(c){
      return '<tr><td><b>'+esc(c.item||'')+'</b></td><td>'+esc(c.vendor||'')+'</td><td style="text-align:center">'+(c.qtyOnHand||0)+'</td><td>'+EF(c.unitCost||0)+'</td><td style="text-align:center">'+(c.usedMTD||0)+'</td><td style="font-weight:700;color:var(--pri)">'+EF((c.usedMTD||0)*(c.unitCost||0))+'</td><td>'+(c.expiryAlert?('<span style="color:#f59e0b">'+esc(c.expiryAlert)+'</span>'):'\u2014')+'</td><td><div class="act-row"><button class="act-btn edit" onclick="csAddEdit('+c.id+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" onclick="csDel('+c.id+')"><i class="fa-solid fa-trash"></i></button></div></td></tr>'; }).join('');
    var body='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px"><span style="font-size:12px;color:var(--txt2)">Vendor-owned stock held on site — billed only on use.</span><button class="btn btn-pri btn-sm" onclick="csAddEdit(null)"><i class="fa-solid fa-plus"></i> Add Consignment</button></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Item</th><th>Vendor</th><th>Qty on Hand</th><th>Unit Cost</th><th>Used (MTD)</th><th>Billed (MTD)</th><th>Expiry Alert</th><th></th></tr></thead><tbody>'+(rows||'<tr><td colspan="8" style="text-align:center;color:var(--txt3);padding:14px">No consignment stock yet</td></tr>')+'</tbody></table></div>'+
      '<div class="alert alert-blue" style="margin-top:8px"><i class="fa-solid fa-info-circle"></i> <b>Consignment billing:</b> no PO upfront; the vendor invoices monthly for consumed items.</div>';
    XMODAL('<i class="fa-solid fa-warehouse" style="color:#8b5cf6;margin-right:8px"></i>Consignment Inventory Management', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.csAddEdit=function(id){
    var d=XD(); var c=(id!=null)?(d.consignments||[]).find(function(x){return x.id===id;}):null; c=c||{};
    XMODAL('<i class="fa-solid fa-warehouse" style="color:#8b5cf6;margin-right:8px"></i>'+(id!=null?'Edit Consignment':'Add Consignment'),
      '<div class="form-grid">'+
        '<div class="form-group full"><label>Item <span class="req">*</span></label><input id="cs_item" list="cs_cat" value="'+esc(c.item||'')+'"><datalist id="cs_cat">'+poCatalogNames().map(function(n){return '<option value="'+esc(n)+'">';}).join('')+'</datalist></div>'+
        '<div class="form-group"><label>Vendor <span class="req">*</span></label>'+supplierSelect('cs_vendor', c.vendor||'')+'</div>'+
        '<div class="form-group"><label>Qty on Hand</label><input id="cs_qty" type="number" min="0" value="'+(c.qtyOnHand||0)+'"></div>'+
        '<div class="form-group"><label>Unit Cost (\u20a6)</label><input id="cs_cost" type="number" min="0" value="'+(c.unitCost||0)+'"></div>'+
        '<div class="form-group"><label>Used (MTD)</label><input id="cs_used" type="number" min="0" value="'+(c.usedMTD||0)+'"></div>'+
        '<div class="form-group"><label>Expiry Alert</label><input id="cs_exp" value="'+esc(c.expiryAlert||'')+'" placeholder="e.g. 2 units expiring Apr 2026"></div>'+
      '</div>',
      '<button class="btn btn-pri" onclick="csSave('+(id!=null?id:'null')+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="showConsignmentInventory()">Back</button>','wide');
  };
  window.csSave=function(id){
    var d=XD(); d.consignments=d.consignments||[]; var item=gv('cs_item'); if(!item){ XTOAST('Enter item','err'); return; }
    var rec=(id!=null)?(d.consignments||[]).find(function(x){return x.id===id;}):null; var isNew=!rec;
    if(isNew){ rec={ id:nextNumId(d.consignments) }; d.consignments.push(rec); }
    rec.item=item; rec.vendor=gv('cs_vendor'); rec.qtyOnHand=gn('cs_qty'); rec.unitCost=gn('cs_cost'); rec.usedMTD=gn('cs_used'); rec.billedMTD=(rec.usedMTD||0)*(rec.unitCost||0); rec.expiryAlert=gv('cs_exp');
    XSAVE(); XTOAST('Consignment '+(isNew?'added':'updated')+' — '+item); showConsignmentInventory();
  };
  window.csDel=function(id){ var d=XD(); if(typeof confirm==='function'&&!confirm('Delete this consignment item?'))return; d.consignments=(d.consignments||[]).filter(function(x){return x.id!==id;}); XSAVE(); XTOAST('Consignment removed'); showConsignmentInventory(); };

  /* — Auto-Reorder: editable, approvable proposal before POs are raised — */
  window.__reorderLines=[];
  window.autoReorder=function(){
    var d=XD();
    var lines=[];
    (d.pharmacy||[]).forEach(function(p){ if(p.status==='Active' && (p.stock||0)<=(p.minStock||0)){ var q=Math.max(1,(p.minStock||0)*2-(p.stock||0)); lines.push({include:true,kind:'pharmacy',id:p.id,name:p.name,current:p.stock||0,qty:q,supplier:p.supplier||'',unitCost:p.unitPrice||0}); } });
    (d.inventory||[]).forEach(function(i){ if((i.qty||0)<=(i.minTh||0)){ var q=Math.max(1,(i.minTh||50)*2-(i.qty||0)); lines.push({include:true,kind:'inventory',id:i.id,name:i.name,current:i.qty||0,qty:q,supplier:i.supplier||'',unitCost:i.price||0}); } });
    if(!lines.length){ XTOAST('No items below reorder level'); return; }
    window.__reorderLines=lines;
    extReorderModal();
  };
  function extReorderModal(){
    var rows=window.__reorderLines.map(function(l,i){
      return '<tr'+(l.include?'':' style="opacity:.45"')+'><td style="text-align:center"><input type="checkbox" '+(l.include?'checked':'')+' onchange="extReorderSet('+i+',\'include\',this.checked)"></td>'+
        '<td><b>'+esc(l.name)+'</b><div style="font-size:10px;color:var(--txt3)">'+l.kind+' · in stock '+l.current+'</div></td>'+
        '<td><input type="number" min="1" value="'+l.qty+'" onchange="extReorderSet('+i+',\'qty\',this.value)" style="width:70px;text-align:right"></td>'+
        '<td>'+supplierSelect('','').replace('<select id="','<select onchange="extReorderSet('+i+',\'supplier\',this.value)" data-i="'+i+'" id="').replace('Select supplier…</option>','Select supplier…</option>')+'</td>'+
        '<td><input type="number" min="0" value="'+l.unitCost+'" onchange="extReorderSet('+i+',\'unitCost\',this.value)" style="width:90px;text-align:right"></td>'+
        '<td id="ro_lt_'+i+'" style="text-align:right;font-weight:700">'+EF(l.qty*l.unitCost)+'</td>'+
        '<td style="text-align:center"><button class="act-btn del" title="Remove" onclick="extReorderDel('+i+')"><i class="fa-solid fa-trash"></i></button></td></tr>';
    }).join('');
    var body='<div style="font-size:12px;color:var(--txt2);margin-bottom:8px">Review the suggested reorder. Adjust quantity, supplier and cost, untick or delete lines, then generate the purchase orders for approval.</div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Use</th><th>Item</th><th>Order Qty</th><th>Supplier</th><th>Unit Cost</th><th>Line Total</th><th></th></tr></thead><tbody id="ro_body">'+rows+'</tbody></table></div>';
    XMODAL('<i class="fa-solid fa-magic" style="color:#f59e0b;margin-right:8px"></i>Auto-Reorder — Review &amp; Approve', body,
      '<button class="btn btn-pri" onclick="extGenerateReorderPOs()"><i class="fa-solid fa-file-circle-check"></i> Generate POs (for approval)</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    /* set current supplier selections */
    window.__reorderLines.forEach(function(l,i){ var sel=document.querySelector('select[data-i="'+i+'"]'); if(sel&&l.supplier){ for(var o=0;o<sel.options.length;o++){ if(sel.options[o].value===l.supplier||sel.options[o].text===l.supplier){ sel.selectedIndex=o; break; } } if(l.supplier && !Array.prototype.some.call(sel.options,function(op){return op.value===l.supplier||op.text===l.supplier;})){ var opt=document.createElement('option'); opt.text=l.supplier; opt.value=l.supplier; opt.selected=true; sel.add(opt); } } });
  }
  window.extReorderSet=function(i,f,v){ if(!window.__reorderLines[i])return; window.__reorderLines[i][f]=(f==='qty'||f==='unitCost')?(parseFloat(v)||0):v; if(f==='qty'||f==='unitCost'){ var el=document.getElementById('ro_lt_'+i); if(el) el.textContent=EF((window.__reorderLines[i].qty||0)*(window.__reorderLines[i].unitCost||0)); } if(f==='include'){ extReorderModal(); } };
  window.extReorderDel=function(i){ window.__reorderLines.splice(i,1); extReorderModal(); };
  window.extGenerateReorderPOs=function(){
    var d=XD(); d.purchaseOrders=d.purchaseOrders||[];
    var chosen=window.__reorderLines.filter(function(l){return l.include && l.qty>0;});
    if(!chosen.length){ XTOAST('No lines selected','err'); return; }
    var bySup={}; chosen.forEach(function(l){ var s=l.supplier||'Unassigned'; (bySup[s]=bySup[s]||[]).push(l); });
    var n=0; Object.keys(bySup).forEach(function(s){
      var items=bySup[s]; var total=items.reduce(function(t,l){return t+l.qty*l.unitCost;},0);
      var po={ id:nextNumId(d.purchaseOrders), code:nextPOCode(), supplier:s, orderDate:XTODAY(), expectedDelivery:'', status:'Approved',
        lineItems:items.map(function(l){return {name:l.name,qty:l.qty,unitCost:l.unitCost,kind:l.kind,id:l.id};}),
        items:items.map(function(l){return l.qty+'\u00d7 '+l.name;}).join(', '), total:total, notes:'Auto-reorder — reviewed & approved' };
      d.purchaseOrders.push(po); n++;
    });
    notify('Reorder POs generated', n+' purchase order(s) created for approval', 'system','procurement','auto-reorder');
    XCLOSE(); XSAVE(); XTOAST(n+' purchase order(s) generated — review in Procurement'); XRENDER();
  };

  /* — Inventory report (catalogue + supplies + assets, value, low stock, by location) — */
  window.extInventoryReport=function(){
    var d=XD();
    var ph=d.pharmacy||[], inv=d.inventory||[], as=d.assetRegistry||[];
    var phVal=ph.reduce(function(s,p){return s+(p.stock||0)*(p.unitPrice||0);},0);
    var invVal=inv.reduce(function(s,i){return s+(i.qty||0)*(i.price||0);},0);
    var asVal=as.reduce(function(s,a){return s+(a.currentValue||0);},0);
    var phLow=ph.filter(function(p){return (p.stock||0)<=(p.minStock||0);});
    var invLow=inv.filter(function(i){return (i.qty||0)<=(i.minTh||0);});
    var moves=(d.stockMovements||[]); var byLoc={};
    moves.forEach(function(m){ if(m.type==='OUT'&&m.to){ byLoc[m.to]=(byLoc[m.to]||0)+(m.qty||0); } });
    var locRows=Object.keys(byLoc).sort(function(a,b){return byLoc[b]-byLoc[a];}).map(function(k){return '<tr><td>'+esc(k)+'</td><td style="text-align:right">'+byLoc[k]+'</td></tr>';}).join('')||'<tr><td colspan="2" style="text-align:center;color:var(--txt3)">No issues logged yet</td></tr>';
    var lowRows=phLow.concat([]).map(function(p){return '<tr><td>'+esc(p.name)+'</td><td>Pharmacy</td><td style="text-align:right;color:#dc2626;font-weight:700">'+(p.stock||0)+'</td><td style="text-align:right">'+(p.minStock||0)+'</td></tr>';}).join('')+
      invLow.map(function(i){return '<tr><td>'+esc(i.name)+'</td><td>Inventory</td><td style="text-align:right;color:#dc2626;font-weight:700">'+(i.qty||0)+'</td><td style="text-align:right">'+(i.minTh||0)+'</td></tr>';}).join('');
    var body='<div class="kpi-grid" style="margin-bottom:12px">'+
      kpi(EF(phVal+invVal),'Stock Value','fa-boxes-stacked','#0d9488')+
      kpi(EF(asVal),'Asset Value','fa-laptop-medical','#3b82f6')+
      kpi((phLow.length+invLow.length),'Low-Stock Items','fa-triangle-exclamation','#dc2626')+
      kpi((ph.length+inv.length+as.length),'Total Records','fa-list','#7c3aed')+'</div>'+
      '<div class="form-section"><span>Low-stock items (reorder candidates)</span></div>'+
      '<div class="tbl-wrap" style="margin-bottom:12px"><table class="tbl"><thead><tr><th>Item</th><th>Source</th><th>On Hand</th><th>Min</th></tr></thead><tbody>'+(lowRows||'<tr><td colspan="4" style="text-align:center;color:#16a34a;padding:10px">All items above minimum</td></tr>')+'</tbody></table></div>'+
      '<div class="form-section"><span>Consumption by location (issued)</span></div>'+
      '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Department / Ward</th><th style="text-align:right">Units Issued</th></tr></thead><tbody>'+locRows+'</tbody></table></div>';
    XMODAL('<i class="fa-solid fa-chart-pie" style="color:var(--pri);margin-right:8px"></i>Inventory Report', body,
      '<button class="btn btn-sm" style="background:#f59e0b;color:#fff" onclick="closeModal();autoReorder()"><i class="fa-solid fa-magic"></i> Auto-Reorder Review</button><button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };

  /* ════════════════════════════════════════════════════════════════════════
     MERGE Appointments + Appointment Calendar into one module (tabbed)
     ════════════════════════════════════════════════════════════════════════ */
  window.apptSetView=function(v){ window.__apptView=v; try{ if(typeof render==='function') render(); else if(typeof goTo==='function') goTo('appointments'); }catch(e){} };
  function injectApptCss(){ var st=document.getElementById('extApptCss'); if(!st){ st=document.createElement('style'); st.id='extApptCss'; document.head.appendChild(st); } st.textContent='.sb-item[onclick*="calendar"]{display:none!important} .sb-item .badge{display:none!important} .sb-sec-count{display:none!important}'; }
  window.__navNames=window.__navNames||[];
  function navRemember(n){
    if(!n) return; var a=window.__navNames;
    for(var i=0;i<a.length;i++){ if(n!==a[i] && n.indexOf(a[i])===0 && /^\d+$/.test(n.slice(a[i].length))) return; }
    a=a.filter(function(e){ return !(e!==n && e.indexOf(n)===0 && /^\d+$/.test(e.slice(n.length))); });
    if(a.indexOf(n)<0) a.push(n); a.sort(function(x,y){return y.length-x.length;}); window.__navNames=a;
  }
  function cleanNav(){
    /* SINGLE-WRITER: the authoritative nav owner (v188+) builds the sidebar from
       ROLE_MODULES with no stray badges/counts, so this legacy DOM-scrubber has
       nothing to do and must not touch the nav (its writes fed the observer loop
       that caused shaking). Disconnect our own observer and become a no-op. */
    if(window.__NAV_OWNER && window.__NAV_OWNER!=='ess'){
      if(window.__navObs){ try{ window.__navObs.disconnect(); }catch(_e){} window.__navObs=null; window.__navObsHost=null; }
      if(window.__extNavCleanInt && window.__extNavCleanInt!=='tamed'){ try{ clearInterval(window.__extNavCleanInt); }catch(_e){} window.__extNavCleanInt='tamed'; }
      return;
    }
    try{
      var secs=document.querySelectorAll('.sb-sec');
      secs.forEach(function(sec){
        var l=sec.querySelector('.sb-sec-label'); var c=sec.querySelector('.sb-sec-count');
        if(l){ var t=(l.textContent||'').trim();
          if(c){ navRemember(t); }
          else if(/\d$/.test(t)){ for(var i=0;i<window.__navNames.length;i++){ if(t!==window.__navNames[i] && t.indexOf(window.__navNames[i])===0){ l.textContent=window.__navNames[i]; break; } } }
        }
        if(c&&c.parentNode) c.parentNode.removeChild(c);
      });
      var bs=document.querySelectorAll('.sb-item .badge'); for(var j=0;j<bs.length;j++){ if(bs[j]&&bs[j].parentNode) bs[j].parentNode.removeChild(bs[j]); }
      dedupeEssCards();
    }catch(e){}
  }
  function dedupeEssCards(){
    try{
      var seenMLB=false;
      var hs=document.querySelectorAll('.card .card-hd h3, .card-hd h3');
      Array.prototype.forEach.call(hs,function(h){
        var t=(h.textContent||'').replace(/\s+/g,' ');
        if(/My Leave Balances/.test(t)){
          if(seenMLB){ var card=h.closest?h.closest('.card'):null; if(card&&card.parentNode) card.parentNode.removeChild(card); }
          else seenMLB=true;
        }
      });
    }catch(e){}
  }
  function observeNav(){
    /* stand down under the single nav owner (v188+): do not attach a scrubber */
    if(window.__NAV_OWNER && window.__NAV_OWNER!=='ess'){
      if(window.__navObs){ try{ window.__navObs.disconnect(); }catch(_e){} window.__navObs=null; window.__navObsHost=null; }
      return;
    }
    try{
      var host=(document.querySelector('.sb-sec')||{}).parentNode; if(!host) return;
      if(window.__navObsHost===host) return;
      if(window.__navObs){ try{ window.__navObs.disconnect(); }catch(e){} }
      var obs=new (window.MutationObserver||function(){return{observe:function(){},disconnect:function(){}};})(function(){ cleanNav(); });
      obs.observe(host,{childList:true,subtree:true,characterData:true});
      window.__navObs=obs; window.__navObsHost=host;
    }catch(e){}
  }
  window.__extCleanNav=cleanNav;
  function wireLeaveBalances(){
    if(typeof window.essLeaveBalances==='function' && !window.essLeaveBalances._extPend){
      var _elb=window.essLeaveBalances;
      var f=function(emp){ var arr=[]; try{ arr=_elb(emp)||[]; }catch(e){ return _elb(emp); }
        var d=XD(); var reqs=(d.leaveRequests||[]).filter(function(l){ return l && l.employeeId===(emp&&emp.id) && l.status==='Pending'; });
        arr.forEach(function(b){ if(b && b.ent!=null){
          var pend=reqs.filter(function(l){ return l.type===b.type; }).reduce(function(s,l){ return s+(+l.days||0); },0);
          b.pending=pend; b.left=Math.max(0,(+b.ent||0)-(+b.used||0)-pend);
        } });
        return arr; };
      f._extPend=true; window.essLeaveBalances=f;
      window.leaveBalanceAll=function(emp){ return window.essLeaveBalances(emp); };
    }
  }
  window.__extWireLeaveBalances=wireLeaveBalances;
  function normalizeStaffDepts(){
    if(window.__deptsFixed) return; var d=XD(); if(!d.employees||!d.employees.length){ return; }
    var deptByName={}, deptById={}; (d.departments||[]).forEach(function(x){ deptByName[x.name]=1; deptById[x.id]=x.name; });
    var people={}; (d.employees||[]).forEach(function(e){ if(e.fullName) people[e.fullName.trim()]=1; });
    (d.patients||[]).forEach(function(p){ var n=(p.fullName||((p.firstName||'')+' '+(p.lastName||''))).trim(); if(n) people[n]=1; });
    var posMap={ 'front desk':'Front Office / Reception','reception':'Front Office / Reception','cashier':'Finance','account':'Finance','finance':'Finance','pharmac':'Pharmacy','nurse':'Nursing','lab':'Laboratory','radiolog':'Radiology','record':'Medical Records','hr':'Human Resources','admin':'Administration','it':'IT / Systems','procure':'Procurement','store':'Stores / Inventory' };
    function posDept(pos){ var p=(pos||'').toLowerCase(); for(var k in posMap){ if(p.indexOf(k)>=0) return posMap[k]; } return null; }
    var changed=false;
    d.employees.forEach(function(e){
      var dep=e.department;
      var invalid = !dep || people[dep] || (!deptByName[dep]);
      if(invalid){
        e.department = deptById[e.deptId] || posDept(e.position) || 'Administration';
        changed=true;
      }
    });
    window.__deptsFixed=true; if(changed){ try{ XSAVE(); }catch(e){} }
  }
  window.__extNormalizeStaffDepts=normalizeStaffDepts;
  /* ════════════════════════════════════════════════════════════════════════
     MULTI-PATIENT GENERATE BILL — add several patients, each with their charges
     ════════════════════════════════════════════════════════════════════════ */
  function mpbPayers(){
    var d=XD(); var out=['Self-Pay'];
    (d.insuranceProviders||[]).forEach(function(p){ if(p&&p.name) out.push(p.name); });
    (d.partners||[]).forEach(function(p){ var n=p.companyName||p.name; if(n) out.push(n); });
    return out.filter(function(v,i,a){return a.indexOf(v)===i;});
  }
  function mpbPatientOptions(sel){
    var d=XD();
    return '<option value="">Select patient…</option>'+(d.patients||[]).filter(function(p){return p.status!=='Discharged';})
      .map(function(p){ var lbl=(p.fullName||((p.firstName||'')+' '+(p.lastName||'')))+' ['+(p.mrn||p.id)+']'; return '<option value="'+p.id+'"'+(String(sel)===String(p.id)?' selected':'')+'>'+esc(lbl)+'</option>'; }).join('');
  }
  function mpbTypes(){ var d=XD(); return ((d.cfgLists&&d.cfgLists.billTypes)||['Outpatient','Inpatient','Emergency','Pharmacy','Laboratory','Procedure','Consultation']); }
  function mpbCode(){ return 'BILL-'+Math.random().toString(36).slice(2,7).toUpperCase(); }
  function mpbIsInsured(){ var p=gv('mpb_payer'); return !!p && p!=='Self-Pay'; }
  function mpbFeeList(){
    var d=XD();
    return '<datalist id="mpb_feelist">'+(d.feeSchedule||[]).filter(function(f){return f.status!=='Inactive';})
      .map(function(f){ return '<option value="'+esc(f.service)+'">'+esc((f.category||f.code||'FEE')+' — ₦'+(mpbIsInsured()?(f.insured||f.amount):f.amount).toLocaleString())+'</option>'; }).join('')+'</datalist>';
  }
  window.extMPBFeePick=function(pi,li,el){
    var d=XD(); var name=(el.value||'').trim().toLowerCase();
    var f=(d.feeSchedule||[]).find(function(x){ return String(x.service||'').toLowerCase()===name; });
    if(f){ var an=document.getElementById('mpb_amt_'+pi+'_'+li); if(an && (!an.value || +an.value===0)){ an.value=(mpbIsInsured()?(f.insured||f.amount):f.amount)||0; } if(window.__mpb&&window.__mpb.patients[pi]) window.__mpb.patients[pi].lines[li].cat=f.category||f.code||''; }
    window.extMPBTotals();
  };
  window.extMPBImport=function(pi){
    mpbReadDOM(); var d=XD(); var P=window.__mpb.patients[pi]; var pid=P.pid;
    if(!pid){ XTOAST('Select the patient first','err'); return; }
    var pidNum=(/^\d+$/.test(String(pid))?parseInt(pid):pid);
    var lines=[];
    (d.bills||[]).filter(function(b){ return String(b.patientId)===String(pidNum); }).forEach(function(b){
      (Array.isArray(b.items)?b.items:[]).forEach(function(it){ var amt=(it.a!=null?it.a:(it.amount!=null?it.amount:(it.total||0))); lines.push({desc:(it.s||it.desc||it.category||'Service'), amt:(+amt||0), cat:(it.category||'')}); });
    });
    if(!lines.length){ XTOAST('No existing bill lines for this patient','err'); return; }
    P.lines=lines; mpbRenderPatients(); XTOAST('Imported '+lines.length+' charge line(s)');
  };
  function mpbInitials(name){ var p=(name||'').trim().split(/\s+/); return ((p[0]||'')[0]||'?')+((p[p.length-1]||'')[0]||''); }
  function mpbPatName(pid){ var d=XD(); var p=(d.patients||[]).find(function(x){return String(x.id)===String(pid);}); return p?(p.fullName||((p.firstName||'')+' '+(p.lastName||''))):''; }

  window.__mpb=null;
  function mpbReadDOM(){
    if(!window.__mpb) return;
    window.__mpb.patients.forEach(function(P,pi){
      var sel=document.getElementById('mpb_pat_'+pi); if(sel) P.pid=sel.value;
      P.lines.forEach(function(L,li){
        var dn=document.getElementById('mpb_desc_'+pi+'_'+li); var an=document.getElementById('mpb_amt_'+pi+'_'+li);
        if(dn) L.desc=dn.value; if(an) L.amt=(+an.value||0);
      });
    });
  }
  window.mpbReadDOM=mpbReadDOM;
  window.extMPBAddPatient=function(){ mpbReadDOM(); window.__mpb.patients.push({pid:'',lines:[{desc:'',amt:0}]}); mpbRenderPatients(); };
  window.extMPBRemovePatient=function(pi){ mpbReadDOM(); window.__mpb.patients.splice(pi,1); if(!window.__mpb.patients.length) window.__mpb.patients.push({pid:'',lines:[{desc:'',amt:0}]}); mpbRenderPatients(); };
  window.extMPBAddLine=function(pi){ mpbReadDOM(); window.__mpb.patients[pi].lines.push({desc:'',amt:0}); mpbRenderPatients(); };
  window.extMPBRemoveLine=function(pi,li){ mpbReadDOM(); window.__mpb.patients[pi].lines.splice(li,1); if(!window.__mpb.patients[pi].lines.length) window.__mpb.patients[pi].lines.push({desc:'',amt:0}); mpbRenderPatients(); };
  window.extMPBTotals=function(){
    if(!window.__mpb) return; var grand=0;
    window.__mpb.patients.forEach(function(P,pi){
      var sub=0; P.lines.forEach(function(L,li){ var an=document.getElementById('mpb_amt_'+pi+'_'+li); sub+=(an?(+an.value||0):(+L.amt||0)); });
      grand+=sub; var st=document.getElementById('mpb_sub_'+pi); if(st) st.textContent=EF(sub);
    });
    var g=document.getElementById('mpb_grand'); if(g) g.textContent=EF(grand);
  };
  window.mpbRefreshFees=function(){ try{ var old=document.getElementById('mpb_feelist'); if(old){ var tmp=document.createElement('div'); tmp.innerHTML=mpbFeeList(); var nl=tmp.firstChild; old.parentNode.replaceChild(nl, old); } }catch(e){} };
  function mpbRenderPatients(){
    var wrap=document.getElementById('mpb_patients'); if(!wrap) return;
    var insured=mpbIsInsured();
    wrap.innerHTML=window.__mpb.patients.map(function(P,pi){
      var nm=mpbPatName(P.pid);
      var lines=P.lines.map(function(L,li){
        return '<div class="mpb-line">'+
          '<input id="mpb_desc_'+pi+'_'+li+'" list="mpb_feelist" value="'+esc(L.desc||'')+'" placeholder="Search fee schedule or type a charge…" autocomplete="off" oninput="extMPBFeePick('+pi+','+li+',this)" class="mpb-in mpb-desc">'+
          '<div class="mpb-amtwrap"><span class="mpb-naira">\u20a6</span><input id="mpb_amt_'+pi+'_'+li+'" type="number" min="0" value="'+(+L.amt||0)+'" placeholder="0" oninput="extMPBTotals()" class="mpb-in mpb-amt"></div>'+
          '<button class="mpb-x" title="Remove line" onclick="extMPBRemoveLine('+pi+','+li+')"><i class="fa-solid fa-xmark"></i></button></div>';
      }).join('');
      return '<div class="mpb-card">'+
        '<div class="mpb-phead">'+
          '<div class="mpb-ava">'+esc(mpbInitials(nm||'?').toUpperCase())+'</div>'+
          '<select id="mpb_pat_'+pi+'" class="mpb-sel" onchange="mpbReadDOM();mpbRenderPatients()">'+mpbPatientOptions(P.pid)+'</select>'+
          '<button class="mpb-imp" title="Import this patient\u2019s existing bill lines" onclick="extMPBImport('+pi+')"><i class="fa-solid fa-file-import"></i> Import charges</button>'+
          '<button class="mpb-rem" title="Remove patient" onclick="extMPBRemovePatient('+pi+')"><i class="fa-solid fa-user-minus"></i></button>'+
        '</div>'+
        '<div class="mpb-colhead"><span>Charge / Service'+(insured?' <em>(insured rate auto-fills)</em>':'')+'</span><span>Fee</span><span></span></div>'+
        '<div class="mpb-lines">'+lines+'</div>'+
        '<button class="mpb-add" onclick="extMPBAddLine('+pi+')"><i class="fa-solid fa-plus"></i> Add charge line</button>'+
        '<div class="mpb-sub">Subtotal <b id="mpb_sub_'+pi+'">'+EF(0)+'</b></div></div>';
    }).join('');
    window.extMPBTotals();
  }
  window.mpbRenderPatients=mpbRenderPatients;
  window.extMPBGenerate=function(){
    mpbReadDOM(); var d=XD(); var date=gv('mpb_date')||XTODAY(); var type=gv('mpb_type')||'Outpatient'; var payer=gv('mpb_payer')||'Self-Pay';
    var made=[]; var errs=0;
    window.__mpb.patients.forEach(function(P){
      var pid=P.pid; if(!pid) return;
      var lines=P.lines.filter(function(L){ return (+L.amt||0)>0; });
      if(!lines.length) return;
      var pidNum=(/^\d+$/.test(String(pid))?parseInt(pid):pid);
      var items=lines.map(function(L){ return {s:L.desc||type, desc:L.desc||type, a:(+L.amt||0), category:(L.cat||type)}; });
      var total=items.reduce(function(s,it){return s+it.a;},0);
      var bill={ id:XID(), code:mpbCode(), patientId:pidNum, date:date, type:type, total:total, paid:0, balance:total, status:'Pending', items:items, source:'manual', payer:(payer==='Self-Pay'?null:payer) };
      d.bills=d.bills||[]; d.bills.push(bill); made.push(bill);
      if(window.SyncBus){ try{ SyncBus.emit('bill.created', bill); }catch(e){ errs++; } }
    });
    if(!made.length){ XTOAST('Add at least one patient with a charge line','err'); return; }
    try{ if(typeof auditAction==='function') auditAction('FINANCE','Billing','CREATE', made.length+' bill(s) generated — total '+EF(made.reduce(function(s,b){return s+b.total;},0)),'Medium'); }catch(e){}
    XSAVE(); XTOAST(made.length+' bill(s) generated — '+EF(made.reduce(function(s,b){return s+b.total;},0))); XCLOSE(); XRENDER();
  };
  function wireMultiPatientBill(){
    if(typeof window.generateBill==='function' && window.generateBill._extMPB) return;
    window.generateBill=function(){
      window.__mpb={ patients:[{pid:'',lines:[{desc:'',amt:0}]}] };
      var payerOpts=mpbPayers().map(function(p){return '<option>'+esc(p)+'</option>';}).join('');
      var typeOpts=mpbTypes().map(function(t){return '<option>'+esc(t)+'</option>';}).join('');
      XMODAL('<i class="fa-solid fa-file-invoice-dollar" style="color:var(--pri);margin-right:8px"></i>Generate Bill — multiple patients',
        '<style>'+
        '.mpb-card{background:var(--card,#fff);border:1px solid var(--bdr,#e2e8f0);border-radius:14px;padding:14px;margin-bottom:12px;box-shadow:0 1px 3px rgba(15,23,42,.06)}'+
        '.mpb-phead{display:flex;gap:10px;align-items:center;margin-bottom:10px}'+
        '.mpb-ava{width:36px;height:36px;border-radius:50%;flex:0 0 36px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;color:#fff;background:linear-gradient(135deg,#0d9488,#0891b2)}'+
        '.mpb-sel{flex:1;padding:9px 10px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;font-weight:600;background:var(--bg2,#f8fafc)}'+
        '.mpb-imp{border:1px solid #0d9488;color:#0d9488;background:#f0fdfa;border-radius:9px;padding:7px 11px;font-size:11.5px;font-weight:700;cursor:pointer;white-space:nowrap}'+
        '.mpb-imp:hover{background:#0d9488;color:#fff}'+
        '.mpb-rem{border:1px solid #fecaca;color:#dc2626;background:#fef2f2;border-radius:9px;width:34px;height:34px;cursor:pointer}'+
        '.mpb-rem:hover{background:#dc2626;color:#fff}'+
        '.mpb-colhead{display:grid;grid-template-columns:1fr 150px 34px;gap:8px;font-size:10.5px;text-transform:uppercase;letter-spacing:.04em;color:var(--txt3,#94a3b8);font-weight:700;padding:0 2px 5px}'+
        '.mpb-colhead em{text-transform:none;letter-spacing:0;color:#0d9488;font-style:normal;font-weight:600}'+
        '.mpb-line{display:grid;grid-template-columns:1fr 150px 34px;gap:8px;margin-bottom:7px;align-items:center}'+
        '.mpb-in{padding:9px 11px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;width:100%;box-sizing:border-box;transition:border-color .15s,box-shadow .15s}'+
        '.mpb-in:focus{outline:none;border-color:#0d9488;box-shadow:0 0 0 3px rgba(13,148,136,.12)}'+
        '.mpb-amtwrap{position:relative;display:flex;align-items:center}'+
        '.mpb-naira{position:absolute;left:11px;color:var(--txt3,#94a3b8);font-weight:700;font-size:13px;pointer-events:none}'+
        '.mpb-amt{padding-left:24px;text-align:right;font-weight:700}'+
        '.mpb-x{border:none;background:transparent;color:#cbd5e1;cursor:pointer;font-size:15px;border-radius:8px;height:34px}'+
        '.mpb-x:hover{color:#dc2626;background:#fef2f2}'+
        '.mpb-add{margin-top:6px;border:1.5px dashed var(--bdr);color:var(--pri,#0d9488);background:transparent;border-radius:10px;padding:8px 12px;font-size:12px;font-weight:700;cursor:pointer;width:100%}'+
        '.mpb-add:hover{border-color:#0d9488;background:#f0fdfa}'+
        '.mpb-sub{text-align:right;font-size:12.5px;color:var(--txt2,#475569);margin-top:9px;padding-top:9px;border-top:1px dashed var(--bdr)}'+
        '.mpb-sub b{color:var(--pri,#0d9488);font-size:15px;margin-left:6px}'+
        '</style>'+
        mpbFeeList()+
        '<div class="form-grid">'+
          '<div class="form-group"><label>Payer</label><select id="mpb_payer" onchange="mpbReadDOM();mpbRenderPatients();mpbRefreshFees()">'+payerOpts+'</select></div>'+
          '<div class="form-group"><label>Bill Type</label><select id="mpb_type">'+typeOpts+'</select></div>'+
          '<div class="form-group"><label>Date</label><input id="mpb_date" type="date" value="'+XTODAY()+'"></div>'+
        '</div>'+
        '<div style="font-size:12px;color:var(--txt2);margin:6px 0 10px"><i class="fa-solid fa-circle-info" style="color:#0d9488"></i> Add each patient, then pick charges from the fee schedule or import their existing bill lines. One bill is generated and posted to the ledger per patient.</div>'+
        '<div id="mpb_patients"></div>'+
        '<button class="btn btn-sm" style="border:1.5px dashed var(--pri);color:var(--pri);background:transparent;border-radius:10px;padding:9px 14px;font-weight:700;width:100%" onclick="extMPBAddPatient()"><i class="fa-solid fa-user-plus"></i> Add another patient</button>'+
        '<div style="display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,#0d9488,#0891b2);color:#fff;border-radius:12px;padding:13px 16px;margin-top:14px;font-weight:800;font-size:15px"><span><i class="fa-solid fa-receipt" style="margin-right:8px"></i>Grand Total (all patients)</span><span id="mpb_grand">'+EF(0)+'</span></div>',
        '<button class="btn btn-pri" onclick="extMPBGenerate()"><i class="fa-solid fa-circle-check"></i> Generate Bills</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
      mpbRenderPatients();
    };
    window.generateBill._extMPB=true;
  }
  window.__extWireMultiPatientBill=wireMultiPatientBill;

  function dedupeEssTabs(html){
    if(typeof html!=='string' || html.indexOf("essGo(")<0) return html;
    var seen={};
    return html.replace(/<button[^>]*onclick="essGo\('([^']+)'\)"[^>]*>[\s\S]*?<\/button>/g, function(m,k){ if(seen[k]) return ''; seen[k]=1; return m; });
  }
  function fixTxnReceiptPdf(){
    if(typeof window.renderTxnAll==='function' && !window.renderTxnAll._extFix){
      var _rta=window.renderTxnAll;
      var g=function(){ var h; try{ h=_rta.apply(this,arguments); }catch(e){ return _rta.apply(this,arguments); } if(typeof h==='string'){ try{ h=h.replace(/'Receipt_'\+t\.code/g, "'Receipt'"); }catch(e){} } return h; };
      g._extFix=true; window.renderTxnAll=g;
    }
  }
  function wireAppointments(){
    injectApptCss();
    cleanNav();
    observeNav();
    // [phase3] 800ms perpetual nav-sweep replaced by DOMBus.register — the
    // sweep runs once + on DOM mutation instead of on a timer. cleanNav()
    // self-disables (sets __extNavCleanInt='tamed') when a nav owner exists,
    // so we unregister as soon as that happens.
    if(!window.__extNavCleanInt){
      if(window.DOMBus && typeof window.DOMBus.register==='function'){
        var _extNavSweep=function(){
          cleanNav(); observeNav();
          if(window.__extNavCleanInt==='tamed'){ try{ window.DOMBus.unregister(_extNavSweep); }catch(_e){} }
        };
        window.__extNavCleanInt=_extNavSweep;   // sentinel: non-null truthy so we don't re-register
        window.DOMBus.register(_extNavSweep);
      } else {
        window.__extNavCleanInt=setInterval(function(){ cleanNav(); observeNav(); }, 800);
      }
    }
    if(typeof window.renderAppointments==='function' && !window.renderAppointments._extMerged){
      var _ra=window.renderAppointments;
      var f=function(){
        var view=window.__apptView||'list';
        var tabs='<div style="display:flex;gap:6px;margin-bottom:14px" class="no-print">'+
          '<button class="btn btn-sm '+(view==='list'?'btn-pri':'btn-ghost')+'" onclick="apptSetView(\'list\')"><i class="fa-solid fa-list-ul"></i> List / Schedule</button>'+
          '<button class="btn btn-sm '+(view==='calendar'?'btn-pri':'btn-ghost')+'" onclick="apptSetView(\'calendar\')"><i class="fa-solid fa-calendar-alt"></i> Calendar</button>'+
          '</div>';
        if(view==='calendar'){ var cal=''; try{ cal=(typeof renderCalendar==='function')?renderCalendar():''; }catch(e){ cal='<p style="color:var(--txt3);padding:14px">Calendar unavailable.</p>'; } return tabs+cal; }
        var body=''; try{ body=_ra.apply(this, arguments)||''; }catch(e){ body=''; }
        return tabs+body;
      };
      f._extMerged=true; window.renderAppointments=f;
    }
    if(typeof window.goTo==='function' && !window.goTo._extCal){
      var _g=window.goTo;
      var g=function(mod){ if(mod==='calendar'){ window.__apptView='calendar'; window.__apptViaCal=true; var r=_g.call(this,'appointments'); window.__apptViaCal=false; return r; } if(mod==='appointments' && !window.__apptViaCal){ window.__apptView='list'; } return _g.apply(this, arguments); };
      g._extCal=true; window.goTo=g;
    }
  }

  /* capture refs so applyExt can re-assert these even if a deferred host script redefines them */
  var _OV={ issue:window.v29InvIssue, receive:window.v29InvReceive, reorder:window.autoReorder, eproc:window.showEProcurement, consign:window.showConsignmentInventory };

  function wireProcurement(){
    if(window.v29InvIssue!==_OV.issue) window.v29InvIssue=_OV.issue;
    if(window.v29InvReceive!==_OV.receive) window.v29InvReceive=_OV.receive;
    if(window.autoReorder!==_OV.reorder) window.autoReorder=_OV.reorder;
    if(window.showEProcurement!==_OV.eproc) window.showEProcurement=_OV.eproc;
    if(window.showConsignmentInventory!==_OV.consign) window.showConsignmentInventory=_OV.consign;
    if(typeof window.viewRecord==='function' && !window.viewRecord._extPO){
      var _vr=window.viewRecord;
      var f=function(key,id){ if(key==='purchaseOrders'){ return window.extPOView(id); } return _vr.apply(this, arguments); };
      f._extPO=true; window.viewRecord=f;
    }
    if(typeof window.renderProcurement==='function' && !window.renderProcurement._extWrapped){
      var _rp=window.renderProcurement;
      var g=function(){ var html=''; try{ html=_rp.apply(this, arguments)||''; }catch(e){ html=''; }
        try{
          var idx=html.lastIndexOf('<div class="tbl-wrap">');
          if(idx>-1 && html.indexOf("viewRecord('purchaseOrders'", idx)>-1){ html=html.slice(0,idx)+window.extPOTracker(); }
          else if(html.indexOf('extPOTracker')===-1 && idx===-1){ html+=window.extPOTracker(); }
        }catch(e){}
        return html;
      };
      g._extWrapped=true; window.renderProcurement=g;
    }
    if(typeof window.showVendorScorecard!=='function' || !window.showVendorScorecard._extEnhanced){ window.showVendorScorecard=window.extVendorScorecard; window.showVendorScorecard._extEnhanced=true; }
    if(typeof window.showAssetRegistry!=='function' || !window.showAssetRegistry._extEnhanced){ window.showAssetRegistry=window.extAssetRegistry; window.showAssetRegistry._extEnhanced=true; }
    if(typeof window.showContractManagement!=='function' || !window.showContractManagement._extEnhanced){ window.showContractManagement=window.extContractManagement; window.showContractManagement._extEnhanced=true; }
    /* route New PO + Edit PO to the unified form with a reviewable auto-generated PO number */
    if(typeof window.newPurchaseOrder!=='function' || !window.newPurchaseOrder._extForm){ window.newPurchaseOrder=function(){ return window.extPOForm(null); }; window.newPurchaseOrder._extForm=true; }
    if(typeof window.editRecord==='function' && !window.editRecord._extPOEdit){ var _er=window.editRecord; var ef=function(key,id){ if(key==='purchaseOrders'){ return window.extPOForm(id); } return _er.apply(this, arguments); }; ef._extPOEdit=true; window.editRecord=ef; }
  }

  /* ════════════════════════════════════════════════════════════════════════
     WIRE INTO HOST — idempotent; survives later re-patches & D re-seeds
     ════════════════════════════════════════════════════════════════════════ */
  function applyExt(){
    ensureExt();
    wireBilling();
    wireEmailAutomation();
    wirePatientList();
    wireTransactions();
    wireConfigPharmacy();
    wireInventory();
    wirePrescriptionForm();
    wireProcurement();
    wireAppointments();
    fixTxnReceiptPdf();
    installPrintShim();
    wireCashUp();
    normalizeStaffDepts();
    wireLeaveBalances();
    wireMultiPatientBill();
    /* one-time: ensure every existing bill from every module is posted to Receivables/GL */
    if(!window.__extBillsSynced){
      window.__extBillsSynced=true;
      setTimeout(function(){ try{ var d=XD(); if(window.SyncBus && d.bills){ d.bills.forEach(function(b){ if(b && (+b.total||+b.amount||0)>0 && !glHasJE('bill.created:'+b.id)){ if(b.total==null)b.total=(+b.amount||0); b.__glPosted=false; try{ SyncBus.emit('bill.created',b); }catch(e){} } }); XSAVE(); } }catch(e){} }, 1500);
    }
    /* one-time: silent full reconcile of payments + vendor invoices across all modules → GL */
    if(!window.__extGLSynced){
      window.__extGLSynced=true;
      setTimeout(function(){ try{ var d=XD(); if(!window.SyncBus) return;
        (d.transactions||[]).forEach(function(t){ if(!t) return; var amt=+t.amount||0; if(!(amt>0)) return; var ch=t.channel||t.method||'Cash'; var dt=t.date||XTODAY();
          if(t.type==='Payment' && !glHasJE('payment.received:'+t.id)){ try{ SyncBus.emit('payment.received',{id:t.id,billId:t.billId,amount:amt,channel:ch,date:dt}); }catch(e){} }
          else if(t.type==='Refund' && !glHasJE('payment.refunded:'+t.id)){ try{ SyncBus.emit('payment.refunded',{id:t.id,billId:t.billId,amount:amt,channel:ch,date:dt}); }catch(e){} }
        });
        (d.apInvoices||[]).forEach(function(inv){ if(inv && !inv.postedJEId && !inv.__glPosted && !glHasJE('ap.invoice:'+inv.id) && (+inv.amount>0)){ try{ postAP(inv); }catch(e){} } });
        XSAVE();
      }catch(e){} }, 2400);
    }

    /* renderModule */
    if(!window.renderModule || !window.renderModule._extWrapped){
      var _rm=window.renderModule;
      var f=function(){
        if(typeof currentMod!=='undefined'){
          if(currentMod==='bizdev') return window.renderBizDev();
          if(currentMod==='pharmacyplus') return window.renderPharmaPlus();
          if(currentMod==='selfservice'){ var hs=_rm?_rm():''; try{ hs=dedupeEssTabs(hs); }catch(e){} return hs; }
        }
        return _rm?_rm():'';
      };
      f._extWrapped=true; if(_rm&&_rm._wellWrapped) f._wellWrapped=true; window.renderModule=f;
    }
    /* getModTitle */
    if(!window.getModTitle || !window.getModTitle._extWrapped){
      var _gt=window.getModTitle;
      var g=function(){
        if(typeof currentMod!=='undefined'){
          if(currentMod==='bizdev') return 'Business Development';
          if(currentMod==='pharmacyplus') return 'Pharmacy — Clinical & Operations';
        }
        return _gt?_gt():'Dashboard';
      };
      g._extWrapped=true; if(_gt&&_gt._wellWrapped) g._wellWrapped=true; window.getModTitle=g;
    }
    /* buildNav — inject two items */
    if(!window.buildNav || !window.buildNav._extWrapped){
      var _bn=window.buildNav;
      var b=function(){
        var html=_bn?_bn():'';
        if(typeof window.hasModuleAccess==='function'){
          if(window.hasModuleAccess('bizdev') && !/goTo\('bizdev'\)/.test(html)){
            var btn1='<button class="sb-item '+((typeof currentMod!=='undefined'&&currentMod==='bizdev')?'active':'')+'" onclick="goTo(\'bizdev\')"><i class="fa-solid fa-handshake"></i><span>Business Development</span></button>';
            if(/goTo\('transactions'\)/.test(html)) html=html.replace(/(<button class="sb-item[^"]*" onclick="goTo\('transactions'\)">[\s\S]*?<\/button>)/, '$1'+btn1);
            else html+=btn1;
          }
          if(window.hasModuleAccess('pharmacyplus') && !/goTo\('pharmacyplus'\)/.test(html)){
            var btn2='<button class="sb-item '+((typeof currentMod!=='undefined'&&currentMod==='pharmacyplus')?'active':'')+'" onclick="goTo(\'pharmacyplus\')"><i class="fa-solid fa-prescription"></i><span>Pharmacy Clinical &amp; Ops</span></button>';
            if(/goTo\('pharmacy'\)/.test(html)) html=html.replace(/(<button class="sb-item[^"]*" onclick="goTo\('pharmacy'\)">[\s\S]*?<\/button>)/, '$1'+btn2);
            else html+=btn2;
          }
        }
        return html;
      };
      b._extWrapped=true; if(_bn&&_bn._wellWrapped) b._wellWrapped=true; window.buildNav=b;
    }
    /* viewPatient — append HMO head + wellness summary */
    if(typeof window.viewPatient==='function' && !window.viewPatient._extWrapped){
      var _vp=window.viewPatient;
      var vp=function(id){ var r=_vp.apply(this, arguments); setTimeout(function(){ injectPatientPanels(id); },20); return r; };
      vp._extWrapped=true; window.viewPatient=vp;
    }
    /* V25_viewPatient — the richer profile used by the patient list; wrap it too */
    if(typeof window.V25_viewPatient==='function' && !window.V25_viewPatient._extWrapped){
      var _v25=window.V25_viewPatient;
      var v25=function(id){ var r=_v25.apply(this, arguments); setTimeout(function(){ injectPatientPanels(id); },40); return r; };
      v25._extWrapped=true; v25.__pb=window.V25_viewPatient.__pb; window.V25_viewPatient=v25;
    }
  }

  applyExt();
  var _t=[0,300,800,1500,3000,5000]; _t.forEach(function(ms){ setTimeout(applyExt, ms); });
  try{ if(typeof window!=='undefined' && window.addEventListener) window.addEventListener('load', applyExt); }catch(e){}
  try{ DOMBus.register(applyExt); }catch(e){}

  console.log('[ExtPack v157] Loaded — transaction reports (bills/receipts/invoices/payments) in GL tab + fix mpbReadDOM/mpbRenderPatients global scope (multi-patient bill) + bizdev report fallback + multi-patient bill: per-patient fee-schedule picker + import existing charges + polished UI + multi-patient Generate Bill (one posted bill per patient) + leave-balance decrements on request (remaining=entitled-used-pending) + ESS leave-balance de-dupe + staff department normalize + self-healing GL (re-post bills with missing JE, fixes negative AR) + iframe print shim (no popup, statements/receipts) + cash-up receipts/refunds-by-type full process + receivables onclick single-quote fix (Bill/Receipt) + receivables bill+receipt (find by code) + ESS tab de-dupe + txn PDF onclick fix + vendor-invoice supplier datalist (+new) + iframe print (no popup) + bizdev partner reports pull names/type (normalize + reseed) + BizDev reports all generate (live-derived + seeded) + per-module GL sync coverage audit + nav group-count stripper (observer, version-safe) + clean nav (no group/module count numbers) + merged appointments+calendar (tabs) + inventory toolbar/catalogue de-dupe + RFQ/consignment CRUD + issue/receive dropdowns + reorder approval + inventory report + supplier-pick vendors + New/Edit PO form + auto PO number + — procurement (PO detail/cancel/delete + activated registries) + — inventory↔pharmacy catalogue unified + — payables(invoice→pay→GL) + Rx UI + pharmacy catalogue config + AR lifecycle + Business Development, Pharmacy Clinical/Ops, patient HMO+wellness sync, multi-payer billing, auto email notifications.');
})();

;

/* ==== /js/106-idempotent.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhRenderCoalesced) return;      // idempotent

  function install(){
    var realRender = window.render;
    if(typeof realRender!=='function'){ return false; }
    if(realRender.__coalesced){ return true; }

    var scheduled = false;
    var lastPaint = 0;
    var MIN_GAP = 60;                            // ms — never paint more than ~16fps of full rebuilds

    function modalOpen(){
      try{
        if(typeof window.modalOpen==='boolean' && window.modalOpen) return true;
        // Fallback: any visible element that looks like a modal overlay
        var m = document.querySelector('.modal-overlay, .modal, #modalOverlay');
        return !!(m && m.offsetParent !== null &&
                  getComputedStyle(m).display !== 'none');
      }catch(e){ return false; }
    }

    function doPaint(){
      scheduled = false;
      lastPaint = Date.now();
      // Preserve scroll of the main content area across the full rebuild.
      var scroller = document.querySelector('.main') || document.scrollingElement || document.documentElement;
      var top = 0, left = 0;
      try{ if(scroller){ top = scroller.scrollTop; left = scroller.scrollLeft; } }catch(e){}
      try{
        realRender.apply(this, doPaint.__args || []);
      }catch(e){
        try{ console.error('[v130] render failed:', e); }catch(_){}
      }
      // Restore scroll on the (new) main element.
      try{
        var ns = document.querySelector('.main');
        if(ns){ ns.scrollTop = top; ns.scrollLeft = left; }
      }catch(e){}
    }

    function coalesced(){
      // Remember the most recent arguments (render() is normally called with none).
      doPaint.__args = Array.prototype.slice.call(arguments);
      if(scheduled) return;                      // already queued for this frame
      scheduled = true;
      var now = Date.now();
      var wait = Math.max(0, MIN_GAP - (now - lastPaint));
      var raf = window.requestAnimationFrame || function(fn){ return setTimeout(fn, 16); };
      if(wait > 0){
        setTimeout(function(){ raf(doPaint); }, wait);
      } else {
        raf(doPaint);
      }
    }
    coalesced.__coalesced = true;
    // Expose an escape hatch for code paths that truly need a synchronous paint.
    coalesced.now = function(){ try{ return realRender.apply(this, arguments); }catch(e){ console.error('[v130] sync render failed:', e); } };

    window.render = coalesced;
    // Some code captures a local `render` reference at load time; those closures
    // keep the real function, which is fine (they just paint directly). The vast
    // majority call the global window.render, which is now coalesced.
    return true;
  }

  // Install as soon as render() exists; retry briefly in case a later pack
  // reassigns window.render.
  if(!install()){
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if(install() || tries > 40){ clearInterval(iv); }
    }, 100);
  } else {
    // Re-assert after late packs load (some packs overwrite window.render).
    [500, 1500, 3500, 6000].forEach(function(ms){
      setTimeout(function(){
        try{
          if(window.render && !window.render.__coalesced){ install(); }
        }catch(e){}
      }, ms);
    });
  }

  window.__twhRenderCoalesced = true;
  try{ console.log('%c✅ v130 Stability — render coalescing active (anti-blink)','background:#047857;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/107-bind-to-the-live-lexical-d-used-by-the-app-rende.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;

  /* Bind to the LIVE lexical D used by the app renderer (same rule as the
     original wellness module). */
  function DD(){ return (typeof window.D!=='undefined' && window.D) ? window.D : null; }
  function nowId(){ return (typeof window.nid==='function') ? window.nid() : (Date.now()+Math.floor(Math.random()*1000)); }
  function today(){ return new Date().toISOString().split('T')[0]; }
  function toastMsg(m,t){ try{ if(typeof window.toast==='function') window.toast(m,t); }catch(e){} }
  function modal(t,b,f,s){ try{ if(typeof window.showModal==='function') window.showModal(t,b,f,s); }catch(e){} }
  function closeM(){ try{ if(typeof window.closeModal==='function') window.closeModal(); }catch(e){} }
  function rerender(){ try{ if(typeof window.render==='function') window.render(); }catch(e){} }
  function curUser(){ var D=DD(); return (D&&D.currentUser&&D.currentUser.fullName)||'Staff'; }
  function curRole(){ var D=DD(); return (D&&D.currentUser&&D.currentUser.role)||'Staff'; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function gv(id){ var e=document.getElementById(id); return e?e.value:''; }
  function gn(id){ var v=parseFloat(gv(id)); return isNaN(v)?0:v; }
  function gck(id){ var e=document.getElementById(id); return !!(e&&e.checked); }
  function patObj(id){ var D=DD(); if(!D) return null; return (D.patients||[]).find(function(p){return p.id===id;})||null; }
  function patName(id){ var p=patObj(id); return p?p.fullName:'—'; }
  function notify(title,msg,type){ try{ if(typeof window.pushNotification==='function'){ window.pushNotification(title,msg,type||'system','wellness'); return; } }catch(e){} toastMsg(title+': '+msg); }

  /* ── EMR integration: latest doctor diagnosis for a patient ─────────────── */
  function latestDiagnosis(patientId){
    var D=DD(); if(!D) return '';
    var recs=(D.medicalRecords||[]).filter(function(r){ return r.patientId===patientId && r.diagnosis && String(r.diagnosis).trim(); });
    if(!recs.length){ var p=patObj(patientId); return p?(p.conditions||''):''; }
    recs.sort(function(a,b){ return String(b.visitDate||'').localeCompare(String(a.visitDate||'')); });
    return recs[0].diagnosis || '';
  }
  /* ── Laboratory integration: recent completed lab results for a patient ─── */
  function labResults(patientId){
    var D=DD(); if(!D) return [];
    return (D.labTests||[]).filter(function(l){ return l.patientId===patientId && (l.status==='Completed'||l.result); })
      .sort(function(a,b){ return String(b.date||b.orderDate||'').localeCompare(String(a.date||a.orderDate||'')); })
      .slice(0,12);
  }
  function ensureData(){
    var D=DD(); if(!D) return;
    D.comprehensiveAssessments = D.comprehensiveAssessments || [];
    D.mealPlans = D.mealPlans || [];
    D.wellnessReferrals = D.wellnessReferrals || [];
  }

  /* ── clinical calculators ───────────────────────────────────────────────── */
  function calcBMI(h,w){ if(!h||!w) return 0; return +(w/(h*h)).toFixed(1); }
  function bmiCat(b){ if(!b) return '—'; if(b<18.5) return 'Underweight'; if(b<25) return 'Normal'; if(b<30) return 'Overweight'; if(b<35) return 'Obese I'; return 'Severe Obesity'; }
  function calcWHR(waist,hip){ if(!waist||!hip) return 0; return +(waist/hip).toFixed(2); }
  /* Mifflin-St Jeor BMR + activity factor -> estimated energy requirement */
  function calcBMR(sex,w,h_m,age){ if(!w||!h_m||!age) return 0; var hcm=h_m*100; var s=(String(sex).toLowerCase().indexOf('female')>-1)?-161:5; return Math.round(10*w + 6.25*hcm - 5*age + s); }
  function activityFactor(level){ return ({'Sedentary':1.2,'Light':1.375,'Moderate':1.55,'Active':1.725,'Very active':1.9})[level]||1.2; }
  function riskColor(r){ r=(r||'').toLowerCase(); if(r.indexOf('severe')>-1) return '#ef4444'; if(r.indexOf('high')>-1) return '#f97316'; if(r.indexOf('moderate')>-1) return '#f59e0b'; if(r.indexOf('mild')>-1) return '#3b82f6'; return '#22c55e'; }
  function riskBadge(r){ return '<span style="background:'+riskColor(r)+';color:#fff;padding:3px 10px;border-radius:99px;font-size:11px;font-weight:700;white-space:nowrap">'+esc(r||'—')+'</span>'; }
  function SEL(id,opts,extra){ return '<select id="'+id+'"'+(extra||'')+'>'+opts.map(function(o){ if(typeof o==='string') o={v:o,t:o}; return '<option value="'+esc(o.v)+'">'+esc(o.t)+'</option>'; }).join('')+'</select>'; }
  function SCORESEL(id,opts){ return '<select id="'+id+'" oninput="wl3Calc()">'+opts.map(function(o){return '<option value="'+o.v+'">'+esc(o.t)+'</option>';}).join('')+'</select>'; }

  /* nutrient targets by diet type + condition (for meal-plan comparison) */
  function nutrientTargets(cal,dietType,dx){
    dietType=(dietType||'').toLowerCase(); dx=(dx||'').toLowerCase();
    var protPerKg=1.0, carbPct=0.5, fatPct=0.3, sodium=2300;
    if(dietType.indexOf('renal')>-1||dx.indexOf('renal')>-1||dx.indexOf('kidney')>-1){ protPerKg=0.8; sodium=1500; }
    if(dietType.indexOf('diab')>-1||dx.indexOf('diab')>-1){ carbPct=0.45; fatPct=0.3; }
    if(dietType.indexOf('protein')>-1){ protPerKg=1.4; }
    if(dietType.indexOf('sodium')>-1||dietType.indexOf('dash')>-1||dx.indexOf('hypertension')>-1||dx.indexOf('htn')>-1){ sodium=1500; }
    return { calories:cal||2000,
      carbG: Math.round((cal*carbPct)/4),
      fatG: Math.round((cal*fatPct)/9),
      sodiumMg: sodium };
  }

  /* ═══════════════════ LEVEL 3 — COMPREHENSIVE ASSESSMENT ═══════════════════ */
  window.wOpenL3 = function(patientId, pendingId){
    ensureData();
    var D=DD();
    var allow=['System Administrator','Super System Admin','CMO','Nutritionist','Dietitian','Wellness Officer'];
    if(allow.indexOf(curRole())===-1){
      modal('Access Denied','<div class="card"><i class="fa-solid fa-lock" style="color:var(--red);margin-right:6px"></i>The Comprehensive Wellness Assessment is completed by a Nutritionist, Dietitian or Wellness Officer.</div>','<button class="btn btn-ghost" onclick="closeModal()">Close</button>');
      return;
    }
    var p=patObj(patientId); var sex=p?(p.gender||'Male'):'Male'; var age=p?(p.age||''):'';
    var dx=latestDiagnosis(patientId);
    var labs=labResults(patientId);
    /* if referred, pull the referral's captured diagnosis */
    var ref=(D.wellnessReferrals||[]).filter(function(r){return r.patientId===patientId && r.status==='Open';}).slice(-1)[0];
    if(ref && ref.diagnosis) dx=ref.diagnosis;

    var labRows = labs.length
      ? labs.map(function(l){ return '<tr><td>'+esc(l.testType||l.test||'—')+'</td><td>'+esc(l.result||l.value||'—')+' '+esc(l.unit||'')+'</td><td>'+esc(l.refRange||l.normalRange||'')+'</td><td>'+(l.isAbnormal?'<b style="color:#ef4444">Abnormal</b>':'Normal')+'</td></tr>'; }).join('')
      : '<tr><td colspan="4" style="color:var(--txt3);font-style:italic">No completed laboratory results in the EMR for this patient.</td></tr>';

    var body =
    '<input type="hidden" id="wl3_pending" value="'+esc(pendingId||'')+'">'+
    '<input type="hidden" id="wl3_patFixed" value="'+esc(patientId||'')+'">'+

    /* 1. PATIENT INFORMATION (incl. Type of Visit at top) */
    '<h4 class="wsec"><i class="fa-solid fa-id-card"></i> 1. Patient Information</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Patient</label>'+patientPickerV131('wl3_pat',patientId)+'</div>'+
      '<div class="form-group"><label>Type of Visit</label>'+SEL('wl3_visit',['Inpatient','Outpatient','Wellness Consultation','Follow-up'])+'</div>'+
      '<div class="form-group"><label>Assessment Date</label><input type="date" id="wl3_date" value="'+today()+'"></div>'+
      '<div class="form-group"><label>Sex</label>'+SEL('wl3_sex',['Male','Female'],' oninput="wl3Calc()"')+'</div>'+
      '<div class="form-group"><label>Age (years)</label><input id="wl3_age" type="number" value="'+esc(age)+'" oninput="wl3Calc()"></div>'+
    '</div>'+

    /* 2. MEDICAL INFORMATION — auto diagnosis */
    '<h4 class="wsec"><i class="fa-solid fa-stethoscope"></i> 2. Medical Information</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group full"><label>Primary Diagnosis <span style="font-size:10px;color:#8b5cf6">(auto-populated from EMR)</span></label>'+
        '<input id="wl3_dx" value="'+esc(dx)+'" oninput="wl3Calc()"><div style="font-size:11px;color:var(--txt3);margin-top:2px">'+
        (dx? 'Pulled from the doctor\'s latest EMR diagnosis'+(ref?' via wellness referral':'')+'.' : 'No EMR diagnosis found — enter manually or refer from the doctor\'s workflow.')+'</div></div>'+
    '</div>'+

    /* 3. ANTHROPOMETRIC (auto BMI + WHR) */
    '<h4 class="wsec"><i class="fa-solid fa-ruler-combined"></i> 3. Anthropometric Measurements <span style="font-size:10px;color:#22c55e">(auto BMI & Waist-Hip Ratio)</span></h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Height (m)</label><input id="wl3_h" type="number" step="0.01" value="1.70" oninput="wl3Calc()"></div>'+
      '<div class="form-group"><label>Weight (kg)</label><input id="wl3_w" type="number" step="0.1" value="70" oninput="wl3Calc()"></div>'+
      '<div class="form-group"><label>Waist (cm)</label><input id="wl3_waist" type="number" value="85" oninput="wl3Calc()"></div>'+
      '<div class="form-group"><label>Hip (cm)</label><input id="wl3_hip" type="number" value="95" oninput="wl3Calc()"></div>'+
    '</div>'+

    /* 4. BIOCHEMICAL — pulled from Laboratory (EMR), read-only */
    '<h4 class="wsec"><i class="fa-solid fa-flask-vial"></i> 4. Biochemical Data <span style="font-size:10px;color:#0891b2">(retrieved from Laboratory Results — EMR)</span></h4>'+
    '<div style="max-height:180px;overflow:auto;border:1px solid var(--bd);border-radius:10px"><table class="tbl" style="margin:0"><thead><tr><th>Investigation</th><th>Result</th><th>Reference</th><th>Flag</th></tr></thead><tbody>'+labRows+'</tbody></table></div>'+

    /* 5. CLINICAL ASSESSMENT */
    '<h4 class="wsec"><i class="fa-solid fa-notes-medical"></i> 5. Clinical Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Food Allergies</label><input id="wl3_allergy" value="'+esc(p&&p.allergies&&p.allergies!=='None'?p.allergies:'')+'" placeholder="e.g. peanuts, shellfish"></div>'+
      '<div class="form-group"><label>Food Intolerance</label><input id="wl3_intol" placeholder="e.g. lactose, gluten"></div>'+
      '<div class="form-group"><label>Chewing Problems</label>'+SEL('wl3_chew',['No','Yes'])+'</div>'+
      '<div class="form-group"><label>Swallowing Problems</label>'+SEL('wl3_swallow',['No','Yes'])+'</div>'+
      '<div class="form-group"><label>Appetite</label>'+SCORESEL('wl3_appetite',[{v:0,t:'Good'},{v:1,t:'Fair'},{v:2,t:'Poor'}])+'</div>'+
      '<div class="form-group"><label>Malnutrition signs</label>'+SCORESEL('wl3_signs',[{v:0,t:'None observed'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe wasting/edema'}])+'</div>'+
    '</div>'+

    /* 6. DIETARY ASSESSMENT */
    '<h4 class="wsec"><i class="fa-solid fa-utensils"></i> 6. Dietary Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Breakfast (typical)</label><input id="wl3_break" placeholder="e.g. pap + akara"></div>'+
      '<div class="form-group"><label>Lunch (typical)</label><input id="wl3_lunch" placeholder="e.g. rice + stew"></div>'+
      '<div class="form-group"><label>Dinner (typical)</label><input id="wl3_dinner" placeholder="e.g. yam + egg"></div>'+
      '<div class="form-group"><label>Snacks (typical)</label><input id="wl3_snacks" placeholder="e.g. fruit, biscuits"></div>'+
      '<div class="form-group full"><label>24-Hour Dietary Recall</label><textarea id="wl3_recall" rows="2" placeholder="Everything the patient ate/drank in the last 24 hours"></textarea></div>'+
      '<div class="form-group"><label>Daily Water Intake</label>'+SEL('wl3_water',['< 1 L','1–2 L','2–3 L','> 3 L'])+'</div>'+
      '<div class="form-group"><label>Sugary Drink Intake</label>'+SEL('wl3_sugary',['None','Occasional','Daily','Multiple daily'])+'</div>'+
    '</div>'+

    /* 7. LIFESTYLE ASSESSMENT */
    '<h4 class="wsec"><i class="fa-solid fa-person-running"></i> 7. Lifestyle Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Physical Activity</label>'+SCORESEL('wl3_act',[{v:2,t:'Sedentary'},{v:1,t:'Light'},{v:0,t:'Moderate'},{v:0,t:'Active'},{v:0,t:'Very active'}])+'</div>'+
      '<div class="form-group"><label>Exercise Type</label><input id="wl3_exType" placeholder="e.g. walking, jogging, gym"></div>'+
      '<div class="form-group"><label>Exercise Frequency (times/week)</label><input id="wl3_exFreq" type="number" min="0" max="21" value="0"></div>'+
      '<div class="form-group"><label>Sleep Duration (hours/night)</label><input id="wl3_sleepHrs" type="number" step="0.5" value="7"></div>'+
      '<div class="form-group"><label>Smoking</label>'+SCORESEL('wl3_smoke',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Alcohol</label>'+SCORESEL('wl3_alc',[{v:0,t:'None'},{v:1,t:'Occasional'},{v:2,t:'Regular'}])+'</div>'+
    '</div>'+

    /* 8. MENTAL & EMOTIONAL WELLNESS */
    '<h4 class="wsec"><i class="fa-solid fa-brain"></i> 8. Mental & Emotional Wellness</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Stress level</label>'+SCORESEL('wl3_stress',[{v:0,t:'Low'},{v:1,t:'Moderate'},{v:2,t:'High'}])+'</div>'+
      '<div class="form-group"><label>Mood</label>'+SCORESEL('wl3_mood',[{v:0,t:'Stable'},{v:1,t:'Anxious/Irritable'},{v:2,t:'Depressed'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Energy Level</label>'+SEL('wl3_energy',['Good','Moderate','Low','Very low'])+'</div>'+
      '<div class="form-group"><label>Coping Mechanism</label><input id="wl3_coping" placeholder="e.g. family, faith, exercise"></div>'+
      '<div class="form-group"><label>Interest in Mental Wellness Support</label>'+SEL('wl3_mwInterest',['No','Yes','Maybe'])+'</div>'+
    '</div>'+

    /* 9. PREVENTIVE HEALTH */
    '<h4 class="wsec"><i class="fa-solid fa-shield-heart"></i> 9. Preventive Health Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Routine Health Check-ups</label>'+SEL('wl3_checkups',['Regular','Occasional','Rare','Never'])+'</div>'+
      '<div class="form-group"><label>Blood Pressure Monitoring</label>'+SEL('wl3_bpMon',['Regular','Occasional','Never'])+'</div>'+
      '<div class="form-group"><label>Blood Sugar Monitoring</label>'+SEL('wl3_bsMon',['Regular','Occasional','Never'])+'</div>'+
      '<div class="form-group"><label>Health Awareness Level</label>'+SEL('wl3_aware',['High','Moderate','Low'])+'</div>'+
    '</div>'+

    /* 10. FUNCTIONAL */
    '<h4 class="wsec"><i class="fa-solid fa-person-cane"></i> 10. Functional Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Mobility</label>'+SCORESEL('wl3_mob',[{v:0,t:'Independent'},{v:1,t:'Needs assistance'},{v:2,t:'Dependent'}])+'</div>'+
      '<div class="form-group"><label>Muscle Strength</label>'+SCORESEL('wl3_strength',[{v:0,t:'Normal'},{v:1,t:'Reduced'},{v:2,t:'Severe weakness'}])+'</div>'+
      '<div class="form-group"><label>Fatigue Level</label>'+SCORESEL('wl3_fatigue',[{v:0,t:'None'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>History of Falls</label>'+SCORESEL('wl3_falls',[{v:0,t:'None'},{v:1,t:'1 fall'},{v:2,t:'Recurrent falls'}])+'</div>'+
    '</div>'+

    /* 11. SOCIAL */
    '<h4 class="wsec"><i class="fa-solid fa-people-roof"></i> 11. Social Assessment</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Support System</label>'+SCORESEL('wl3_support',[{v:0,t:'Strong'},{v:1,t:'Moderate'},{v:2,t:'Poor'}])+'</div>'+
      '<div class="form-group"><label>Food Access</label>'+SCORESEL('wl3_foodacc',[{v:0,t:'Adequate'},{v:1,t:'Limited'},{v:2,t:'Inadequate'}])+'</div>'+
      '<div class="form-group"><label>Living Situation</label>'+SEL('wl3_living',['Lives with family','Lives with spouse','Lives alone','Institutional care'])+'</div>'+
      '<div class="form-group"><label>Financial Challenges</label>'+SEL('wl3_finance',['None','Mild','Moderate','Severe'])+'</div>'+
    '</div>'+

    /* 12. WELLNESS DIAGNOSIS (PES) */
    '<h4 class="wsec"><i class="fa-solid fa-diagnoses"></i> 12. Wellness Diagnosis (PES Statement)</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group full"><label>Problem (P)</label><input id="wl3_pes_p" placeholder="e.g. Excessive energy intake"></div>'+
      '<div class="form-group full"><label>Etiology (E)</label><input id="wl3_pes_e" placeholder="e.g. related to frequent sugary drinks & sedentary lifestyle"></div>'+
      '<div class="form-group full"><label>Signs & Symptoms / Evidence (S)</label><input id="wl3_pes_s" placeholder="e.g. as evidenced by BMI 34 and elevated fasting glucose"></div>'+
    '</div>'+

    /* 13. INTEGRATED WELLNESS CARE PLAN */
    '<h4 class="wsec"><i class="fa-solid fa-bullseye"></i> 13. Integrated Wellness Care Plan</h4>'+
    '<div style="font-size:12px;font-weight:700;color:#8b5cf6;margin:4px 0">Nutrition Therapy</div>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Diet type</label>'+SEL('wl3_diet',['Balanced wellness','Weight loss','Diabetic','Hypertension (DASH)','Renal','High protein','High fibre','Soft diet','Cardiac low-sodium'])+'</div>'+
      '<div class="form-group"><label>Target calories (kcal/day)</label><input id="wl3_cal" type="number" value="2000" oninput="wl3Calc()"></div>'+
      '<div class="form-group"><label>Protein Target (g/day)</label><input id="wl3_prot" type="number" value="70"></div>'+
      '<div class="form-group"><label>Fluid Target (mL/day)</label><input id="wl3_fluid" type="number" value="2000"></div>'+
    '</div>'+
    '<div style="font-size:12px;font-weight:700;color:#8b5cf6;margin:6px 0">Lifestyle Intervention</div>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Physical Activity Prescription</label><input id="wl3_paRx" placeholder="e.g. 30 min brisk walk × 5/week"></div>'+
      '<div class="form-group"><label>Sleep Improvement Plan</label><input id="wl3_sleepPlan" placeholder="e.g. 7–8 h, sleep hygiene"></div>'+
      '<div class="form-group"><label>Stress Reduction Plan</label><input id="wl3_stressPlan" placeholder="e.g. breathing, breaks"></div>'+
      '<div class="form-group"><label>Habit Modification</label><input id="wl3_habit" placeholder="e.g. reduce sugary drinks"></div>'+
    '</div>'+
    '<div style="font-size:12px;font-weight:700;color:#8b5cf6;margin:6px 0">Mental Wellness Intervention</div>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Stress Management</label>'+SEL('wl3_mwStress',['Not required','Self-help resources','Guided sessions'])+'</div>'+
      '<div class="form-group"><label>Counselling Referral</label>'+SEL('wl3_mwCouns',['No','Yes'])+'</div>'+
      '<div class="form-group"><label>Relaxation Techniques</label>'+SEL('wl3_mwRelax',['Not required','Recommended','Prescribed'])+'</div>'+
      '<div class="form-group"><label>Behavioural Coaching</label>'+SEL('wl3_mwCoach',['No','Yes'])+'</div>'+
    '</div>'+
    '<div style="font-size:12px;font-weight:700;color:#8b5cf6;margin:6px 0">Preventive Health Plan</div>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Blood Pressure Monitoring Plan</label>'+SEL('wl3_bpPlan',['Not required','Weekly','Daily','Clinic visits'])+'</div>'+
      '<div class="form-group"><label>Blood Sugar Monitoring Plan</label>'+SEL('wl3_bsPlan',['Not required','Weekly','Daily','Clinic visits'])+'</div>'+
      '<div class="form-group full"><label>Routine Screening Schedule</label><input id="wl3_screen" placeholder="e.g. FBC & lipids in 3 months"></div>'+
    '</div>'+
    '<div style="font-size:12px;font-weight:700;color:#8b5cf6;margin:6px 0">Patient Education provided on</div>'+
    '<div class="form-grid" style="grid-template-columns:repeat(3,1fr)">'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_portion"> Portion Control</label>'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_meal"> Meal Planning</label>'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_disease"> Disease Management</label>'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_life"> Lifestyle Modification</label>'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_stress"> Stress Management</label>'+
      '<label class="wchk"><input type="checkbox" id="wl3_ed_prev"> Preventive Health Education</label>'+
    '</div>'+
    '<div class="form-grid"><div class="form-group full"><label>Follow-up (auto-suggested by risk — editable)</label>'+SEL('wl3_fu',['2 weeks (high risk)','1 month (moderate)','3 months (routine)','6 months (low risk)'])+'</div>'+
      '<div class="form-group full"><label>Intervention notes</label><textarea id="wl3_notes" rows="2"></textarea></div></div>'+

    /* 14. CLINICAL DECISION SUPPORT — live panel */
    '<h4 class="wsec"><i class="fa-solid fa-robot"></i> 14. Clinical Decision Support</h4>'+
    '<div id="wl3_preview" style="padding:14px;border-radius:12px;background:#f5f3ff;border:1px solid #ddd6fe"></div>';

    modal('<i class="fa-solid fa-clipboard-list" style="color:#8b5cf6;margin-right:8px"></i>Comprehensive Wellness Assessment',
      body,
      '<button class="btn btn-pri" onclick="wSaveL3()"><i class="fa-solid fa-save"></i> Save & Generate Care Plan</button>'+
      '<button class="btn" style="background:#0d9488;color:#fff" onclick="wSaveL3(true)"><i class="fa-solid fa-utensils"></i> Save & Open Meal Planner</button>'+
      '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(function(){ try{ wl3Calc(); }catch(e){} },40);
  };

  function patientPickerV131(id,preselect){
    var D=DD(); var opts=(D&&D.patients||[]).filter(function(p){return p.status!=='Discharged';})
      .map(function(p){ return '<option value="'+p.id+'"'+(preselect==p.id?' selected':'')+'>'+esc(p.fullName)+' — '+esc(p.mrn||'')+'</option>'; }).join('');
    return '<select id="'+id+'" onchange="wl3PatientChanged()">'+opts+'</select>';
  }
  /* when the picker changes, re-pull EMR diagnosis + labs (re-open cleanly) */
  window.wl3PatientChanged=function(){
    var pid=parseInt(gv('wl3_pat')); if(!pid) return;
    var dxEl=document.getElementById('wl3_dx'); if(dxEl){ var dx=latestDiagnosis(pid); if(dx) dxEl.value=dx; }
    try{ wl3Calc(); }catch(e){}
  };

  function l3Compute(){
    var h=gn('wl3_h'),w=gn('wl3_w'),waist=gn('wl3_waist'),hip=gn('wl3_hip'),sex=gv('wl3_sex'),age=gn('wl3_age');
    var bmi=calcBMI(h,w),whr=calcWHR(waist,hip);
    var bmiSc=(!bmi?0:bmi<18.5?2:bmi<25?0:bmi<30?1:bmi<35?2:3);
    var nutrition=bmiSc+gn('wl3_appetite')+gn('wl3_signs');
    var lifestyle=gn('wl3_act')+gn('wl3_smoke')+gn('wl3_alc');
    var mental=gn('wl3_stress')+gn('wl3_mood');
    var functional=gn('wl3_mob')+gn('wl3_strength')+gn('wl3_fatigue')+gn('wl3_falls');
    var social=gn('wl3_support')+gn('wl3_foodacc');
    var overall=nutrition+lifestyle+mental+functional+social;
    var risk=overall>=18?'Severe Risk':overall>=12?'High Risk':overall>=6?'Moderate Risk':'Low Risk';
    /* CDSS suggestions */
    var dx=(gv('wl3_dx')||'').toLowerCase(); var nut=[],life=[],prev=[];
    if(dx.indexOf('hypertension')>-1||dx.indexOf('htn')>-1){ nut.push('Low-sodium DASH diet'); prev.push('BP monitoring'); }
    if(dx.indexOf('diab')>-1){ nut.push('Diabetic / low-GI meal plan'); prev.push('Blood sugar monitoring'); }
    if(dx.indexOf('renal')>-1||dx.indexOf('kidney')>-1) nut.push('Renal diet (protein/K/Na control)');
    if(bmi>=30){ nut.push('Structured weight-loss plan'); life.push('Physical activity prescription'); }
    if(bmi&&bmi<18.5) nut.push('High-calorie/high-protein repletion');
    if(gn('wl3_signs')>=1) nut.push('Nutrition repletion & monitoring');
    if(gn('wl3_act')>=1) life.push('Graded exercise programme');
    if(gn('wl3_smoke')>0) life.push('Smoking cessation support');
    if(gn('wl3_mood')>=2||gn('wl3_stress')>=2){ life.push('Stress reduction'); nut.push('Mental wellness / counselling referral'); }
    if(gn('wl3_falls')>=1||gn('wl3_fatigue')>=2) life.push('Falls-prevention & strength programme');
    if(!nut.length) nut.push('Balanced wellness maintenance plan');
    if(!life.length) life.push('Maintain current healthy lifestyle');
    if(!prev.length) prev.push('Routine annual screening');
    var fu=risk.indexOf('Severe')>-1?'2 weeks (high risk)':risk.indexOf('High')>-1?'2 weeks (high risk)':risk.indexOf('Moderate')>-1?'1 month (moderate)':'3 months (routine)';
    return {bmi:bmi,whr:whr,sex:sex,age:age,weight:w,height:h,nutrition:nutrition,lifestyle:lifestyle,mental:mental,functional:functional,social:social,overall:overall,risk:risk,nut:nut,life:life,prev:prev,fu:fu};
  }
  function wl3Calc(){
    var r=l3Compute(); var box=document.getElementById('wl3_preview'); if(!box) return;
    /* keep follow-up in sync with risk unless user changed it */
    var fuEl=document.getElementById('wl3_fu'); if(fuEl && !fuEl.__touched){ fuEl.value=r.fu; }
    if(fuEl && !fuEl.__wired){ fuEl.__wired=true; fuEl.addEventListener('change',function(){fuEl.__touched=true;}); }
    box.innerHTML='<div style="display:flex;gap:16px;flex-wrap:wrap;align-items:center">'+
      '<div><span style="font-size:11px;color:var(--txt3)">BMI</span><div style="font-size:18px;font-weight:800">'+(r.bmi||'—')+' <span style="font-size:11px;font-weight:500;color:var(--txt2)">'+bmiCat(r.bmi)+'</span></div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">WHR</span><div style="font-size:16px;font-weight:800">'+(r.whr||'—')+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Nutrition</span><div style="font-size:16px;font-weight:800">'+r.nutrition+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Lifestyle</span><div style="font-size:16px;font-weight:800">'+r.lifestyle+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Mental</span><div style="font-size:16px;font-weight:800">'+r.mental+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Functional</span><div style="font-size:16px;font-weight:800">'+r.functional+'</div></div>'+
      '<div style="border-left:2px solid #ddd6fe;padding-left:14px"><span style="font-size:11px;color:var(--txt3)">Overall Wellness</span><div style="font-size:18px;font-weight:800">'+r.overall+' '+riskBadge(r.risk)+'</div></div>'+
      '</div>'+
      '<div style="margin-top:10px;font-size:12px;color:var(--txt2);display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px">'+
        '<div style="background:#fff;border-radius:8px;padding:8px"><b style="color:#8b5cf6">Suggested Nutrition Care</b><div>'+r.nut.map(esc).join(' · ')+'</div></div>'+
        '<div style="background:#fff;border-radius:8px;padding:8px"><b style="color:#0d9488">Suggested Lifestyle Care</b><div>'+r.life.map(esc).join(' · ')+'</div></div>'+
        '<div style="background:#fff;border-radius:8px;padding:8px"><b style="color:#0891b2">Suggested Preventive Care</b><div>'+r.prev.map(esc).join(' · ')+'</div></div>'+
      '</div>'+
      '<div style="margin-top:8px;font-size:12px"><b><i class="fa-solid fa-calendar-check"></i> Risk-based follow-up:</b> '+esc(r.fu)+'</div>';
  }
  window.wl3Calc=wl3Calc;

  /* ═════════════════ SAVE L3 — persist all 14 sections + sync ═════════════════ */
  window.wSaveL3 = function(openMeal){
    ensureData();
    var D=DD(); if(!D){ toastMsg('Data not ready'); return; }
    var pid = parseInt(gv('wl3_pat')) || parseInt(gv('wl3_patFixed')) || 0;
    if(!pid){ toastMsg('Select a patient first'); return; }
    var p = patObj(pid);
    var r = l3Compute();

    var edu=[];
    if(gck('wl3_ed_portion')) edu.push('Portion Control');
    if(gck('wl3_ed_meal'))    edu.push('Meal Planning');
    if(gck('wl3_ed_disease')) edu.push('Disease Management');
    if(gck('wl3_ed_life'))    edu.push('Lifestyle Modification');
    if(gck('wl3_ed_stress'))  edu.push('Stress Management');
    if(gck('wl3_ed_prev'))    edu.push('Preventive Health Education');

    var rec = {
      id: nowId(),
      code: 'CWA-'+String(Date.now()).slice(-6),
      patientId: pid,
      patientName: p?p.fullName:patName(pid),
      mrn: p?(p.mrn||''):'',
      date: gv('wl3_date')||today(),
      /* 1. Patient info */
      visitType: gv('wl3_visit'),
      sex: gv('wl3_sex'), age: gn('wl3_age'),
      /* 2. Medical info (auto EMR diagnosis) */
      diagnosis: gv('wl3_dx'),
      /* 3. Anthropometric */
      height: gn('wl3_h'), weight: gn('wl3_w'), waist: gn('wl3_waist'), hip: gn('wl3_hip'),
      bmi: r.bmi, bmiCategory: bmiCat(r.bmi), whr: r.whr,
      /* 4. Biochemical — snapshot of the EMR labs used */
      labSnapshot: labResults(pid).map(function(l){ return {test:l.testType||l.test,result:l.result||l.value,unit:l.unit||'',flag:l.isAbnormal?'Abnormal':'Normal'}; }),
      /* 5. Clinical */
      foodAllergies: gv('wl3_allergy'), foodIntolerance: gv('wl3_intol'),
      chewingProblems: gv('wl3_chew'), swallowingProblems: gv('wl3_swallow'),
      appetite: gv('wl3_appetite'), malnutritionSigns: gv('wl3_signs'),
      /* 6. Dietary */
      breakfast: gv('wl3_break'), lunch: gv('wl3_lunch'), dinner: gv('wl3_dinner'),
      snacks: gv('wl3_snacks'), recall24h: gv('wl3_recall'),
      waterIntake: gv('wl3_water'), sugaryDrinks: gv('wl3_sugary'),
      /* 7. Lifestyle */
      physicalActivity: gv('wl3_act'), exerciseType: gv('wl3_exType'),
      exerciseFrequency: gn('wl3_exFreq'), sleepHours: gn('wl3_sleepHrs'),
      smoking: gv('wl3_smoke'), alcohol: gv('wl3_alc'),
      /* 8. Mental & emotional */
      stress: gv('wl3_stress'), mood: gv('wl3_mood'), energy: gv('wl3_energy'),
      coping: gv('wl3_coping'), mentalWellnessInterest: gv('wl3_mwInterest'),
      /* 9. Preventive */
      routineCheckups: gv('wl3_checkups'), bpMonitoring: gv('wl3_bpMon'),
      bsMonitoring: gv('wl3_bsMon'), healthAwareness: gv('wl3_aware'),
      /* 10. Functional */
      mobility: gv('wl3_mob'), muscleStrength: gv('wl3_strength'),
      fatigue: gv('wl3_fatigue'), fallsHistory: gv('wl3_falls'),
      /* 11. Social */
      supportSystem: gv('wl3_support'), foodAccess: gv('wl3_foodacc'),
      livingSituation: gv('wl3_living'), financialChallenges: gv('wl3_finance'),
      /* 12. Wellness diagnosis (PES) */
      pes: { problem: gv('wl3_pes_p'), etiology: gv('wl3_pes_e'), signs: gv('wl3_pes_s') },
      /* 13. Integrated care plan */
      carePlan: {
        nutrition: { dietType: gv('wl3_diet'), calories: gn('wl3_cal'), proteinG: gn('wl3_prot'), fluidMl: gn('wl3_fluid') },
        lifestyle: { activityRx: gv('wl3_paRx'), sleepPlan: gv('wl3_sleepPlan'), stressPlan: gv('wl3_stressPlan'), habitMod: gv('wl3_habit') },
        mental: { stressMgmt: gv('wl3_mwStress'), counsellingReferral: gv('wl3_mwCouns'), relaxation: gv('wl3_mwRelax'), coaching: gv('wl3_mwCoach') },
        preventive: { bpPlan: gv('wl3_bpPlan'), bsPlan: gv('wl3_bsPlan'), screeningSchedule: gv('wl3_screen') },
        education: edu
      },
      /* 14. Clinical decision support (captured suggestions) */
      cdss: { nutrition: r.nut, lifestyle: r.life, preventive: r.prev },
      /* scores */
      scores: { nutrition:r.nutrition, lifestyle:r.lifestyle, mental:r.mental, functional:r.functional, social:r.social, overall:r.overall },
      overallRisk: r.risk,
      followUp: gv('wl3_fu')||r.fu,
      notes: gv('wl3_notes'),
      assessedBy: curUser(), assessedByRole: curRole(),
      /* ── backward-compat aliases so the existing L3 list renders v131 records ── */
      overallScore: r.overall,
      risk: r.risk,
      dietPlan: gv('wl3_diet'),
      calories: gn('wl3_cal'),
      by: curUser(), byRole: curRole(),
      source: gv('wl3_pending') ? 'Escalated' : 'Direct',
      status: 'Completed',
      createdAt: new Date().toISOString()
    };
    /* If this L3 was opened from a PENDING stub (L2 escalation or a wellness
       referral), fill that stub in place instead of creating a duplicate row. */
    var pend = gv('wl3_pending');
    var stub = pend ? (D.comprehensiveAssessments||[]).find(function(a){ return String(a.id)===String(pend) && a.status==='Pending'; }) : null;
    if(stub){
      /* preserve the stub's id/code/source so the queue reference stays valid */
      rec.id = stub.id;
      rec.code = stub.code || rec.code;
      rec.source = stub.source || rec.source;
      var idx = D.comprehensiveAssessments.indexOf(stub);
      D.comprehensiveAssessments[idx] = rec;
    } else {
      D.comprehensiveAssessments.push(rec);
    }
    /* mark any matching L2 pending as completed/escalated */
    if(pend){
      (D.wellnessRiskAssessments||[]).forEach(function(a){ if(String(a.id)===String(pend)){ a.status='Completed'; a.escalated=true; } });
    }
    /* close any open referral for this patient */
    (D.wellnessReferrals||[]).forEach(function(rf){ if(rf.patientId===pid && rf.status==='Open'){ rf.status='Completed'; rf.assessmentId=rec.id; } });

    /* ── SYNC: auto-create a Dietary order carrying the prescription ───────── */
    try{
      D.dietaryOrders = D.dietaryOrders || [];
      D.dietaryOrders.push({
        id: nowId(),
        code: 'DIET-'+String(Date.now()).slice(-4),
        patientId: pid, patientName: rec.patientName,
        ward: p?(p.ward||''):'', bed: p?(p.room||p.bed||''):'',
        diet: rec.carePlan.nutrition.dietType || 'Balanced wellness',
        allergies: rec.foodAllergies||'None',
        restrictions: (rec.chewingProblems==='Yes'||rec.swallowingProblems==='Yes')?'Soft/modified texture':'',
        mealType: 'Full day', status: 'Preparing', deliveryTime: '',
        calories: rec.carePlan.nutrition.calories,
        protein: rec.carePlan.nutrition.proteinG,
        source: 'Wellness Assessment '+rec.code,
        notes: rec.pes.problem?('PES: '+rec.pes.problem):''
      });
    }catch(e){}

    /* ── SYNC: write a summary line into the EMR (medicalRecords) ──────────── */
    try{
      D.medicalRecords = D.medicalRecords || [];
      D.medicalRecords.push({
        id: nowId(), patientId: pid,
        visitDate: rec.date, visitType: rec.visitType||'Wellness Consultation',
        diagnosis: rec.diagnosis || (rec.pes.problem||'Wellness assessment'),
        provider: curUser(),
        notes: 'Comprehensive Wellness Assessment '+rec.code+' — Overall wellness risk: '+rec.overallRisk+
               '. Diet: '+rec.carePlan.nutrition.dietType+' ('+rec.carePlan.nutrition.calories+' kcal, '+
               rec.carePlan.nutrition.proteinG+' g protein). Follow-up: '+rec.followUp+'.',
        source: 'wellness'
      });
    }catch(e){}

    /* ── SYNC: notifications ──────────────────────────────────────────────── */
    notify('Wellness Assessment Completed', rec.patientName+' — '+rec.overallRisk+' (Overall '+rec.scores.overall+')', 'clinical');

    try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
    closeM();
    rerender();
    toastMsg('Wellness assessment saved & synced to EMR / Dietary');

    if(openMeal){
      setTimeout(function(){ window.openMealPlanner(pid, {
        assessmentId: rec.id, code: rec.code,
        calories: rec.carePlan.nutrition.calories,
        proteinG: rec.carePlan.nutrition.proteinG,
        fluidMl: rec.carePlan.nutrition.fluidMl,
        dietType: rec.carePlan.nutrition.dietType,
        diagnosis: rec.diagnosis,
        sex: rec.sex, age: rec.age, weight: rec.weight, height: rec.height,
        activity: rec.physicalActivity
      }); }, 120);
    }
  };

  /* ═════════════════════ MEAL PLANNER / DIET PRESCRIPTION ═════════════════════ */
  /* Live individual meal plan: requirement calculators, meal builder from the
     hospital food database, running nutrient totals vs prescribed targets with
     over/under warnings, save to patient record + print + EMR link. */
  var MP = { patientId:null, prefill:null, target:null,
             meals:{ Breakfast:[], Lunch:[], Dinner:[], Snacks:[] } };

  function foodDB(){ var D=DD(); return (D&&D.foodItems)||[]; }
  function foodByIdMP(id){ return foodDB().find(function(f){return String(f.id)===String(id);}); }

  function computeTarget(pf){
    var D=DD();
    var sex=pf.sex||'Male', age=+pf.age||30, w=+pf.weight||70, h=+pf.height||1.7;
    var bmr = calcBMR(sex,w,h,age);
    var af = activityFactor(({'0':'Moderate','1':'Light','2':'Sedentary'})[String(pf.activity)]|| (pf.activityLevel||'Sedentary'));
    var calc = Math.round(bmr*af) || 2000;
    var calories = +pf.calories || calc;
    var t = nutrientTargets(calories, pf.dietType, pf.diagnosis);
    var proteinG = +pf.proteinG || Math.round((w||70)*1.0);
    var fluidMl = +pf.fluidMl || Math.round((w||70)*30);
    return { calories:calories, proteinG:proteinG, carbG:t.carbG, fatG:t.fatG, sodiumMg:t.sodiumMg, fluidMl:fluidMl, bmr:bmr, tdee:calc };
  }

  function mealTotals(){
    var t={kcal:0,protein:0,carbs:0,fat:0,sodium:0};
    Object.keys(MP.meals).forEach(function(m){
      MP.meals[m].forEach(function(it){
        var f=foodByIdMP(it.foodId); if(!f) return; var q=+it.qty||1;
        t.kcal+=(f.kcal||0)*q; t.protein+=(f.protein||0)*q; t.carbs+=(f.carbs||0)*q; t.fat+=(f.fat||0)*q; t.sodium+=(f.sodium||0)*q;
      });
    });
    Object.keys(t).forEach(function(k){ t[k]=Math.round(t[k]); });
    return t;
  }

  /* flag over / under prescription with a tolerance band */
  function flag(actual, target, tol){
    tol=tol||0.10; if(!target) return {cls:'',txt:'',pct:0};
    var pct=Math.round((actual/target)*100);
    var lo=target*(1-tol), hi=target*(1+tol);
    if(actual<lo)  return {cls:'mp-under', txt:'Under ('+pct+'%)', pct:pct};
    if(actual>hi)  return {cls:'mp-over',  txt:'Over ('+pct+'%)',  pct:pct};
    return {cls:'mp-ok', txt:'On target ('+pct+'%)', pct:pct};
  }

  window.openMealPlanner = function(patientId, prefill){
    ensureData();
    var D=DD();
    var allow=['System Administrator','Super System Admin','CMO','Nutritionist','Dietitian','Wellness Officer'];
    if(allow.indexOf(curRole())===-1){
      modal('Access Denied','<div class="card"><i class="fa-solid fa-lock" style="color:var(--red);margin-right:6px"></i>Meal planning is completed by a Dietitian, Nutritionist or Wellness Officer.</div>','<button class="btn btn-ghost" onclick="closeModal()">Close</button>');
      return;
    }
    MP.patientId = patientId||null;
    MP.prefill = prefill||{};
    MP.editId = null;
    MP.meals = { Breakfast:[], Lunch:[], Dinner:[], Snacks:[] };

    /* Editing an existing saved plan? (prefill.editPlanId) — load its meals. */
    if(prefill && prefill.editPlanId){
      var existing=(D.mealPlans||[]).find(function(m){ return String(m.id)===String(prefill.editPlanId); });
      if(existing){
        MP.editId = existing.id;
        MP.patientId = existing.patientId;
        MP.meals = JSON.parse(JSON.stringify(existing.meals||{ Breakfast:[], Lunch:[], Dinner:[], Snacks:[] }));
        MP.prefill = { assessmentId:existing.assessmentId, code:existing.code, diagnosis:existing.diagnosis,
          dietType:existing.dietType, calories:existing.target&&existing.target.calories,
          proteinG:existing.target&&existing.target.proteinG };
        patientId = existing.patientId;
      }
    }
    /* if no prefill, pull last assessment for this patient */
    else if((!prefill||!prefill.calories) && patientId){
      var last=(D.comprehensiveAssessments||[]).filter(function(a){return a.patientId===patientId && a.carePlan;}).slice(-1)[0];
      if(last){ MP.prefill={ assessmentId:last.id, code:last.code,
        calories:last.carePlan&&last.carePlan.nutrition.calories, proteinG:last.carePlan&&last.carePlan.nutrition.proteinG,
        fluidMl:last.carePlan&&last.carePlan.nutrition.fluidMl, dietType:last.carePlan&&last.carePlan.nutrition.dietType,
        diagnosis:last.diagnosis, sex:last.sex, age:last.age, weight:last.weight, height:last.height, activity:last.physicalActivity }; }
    }
    MP.target = computeTarget(MP.prefill);

    var p=patObj(patientId);
    var pOpts=(D.patients||[]).filter(function(x){return x.status!=='Discharged';})
      .map(function(x){return '<option value="'+x.id+'"'+(patientId==x.id?' selected':'')+'>'+esc(x.fullName)+' — '+esc(x.mrn||'')+'</option>';}).join('');

    var foodOpts=foodDB().map(function(f){ return '<option value="'+esc(f.id)+'">'+esc(f.name)+' — '+f.kcal+' kcal</option>'; }).join('');

    var body=
      '<input type="hidden" id="mp_assessId" value="'+esc(MP.prefill.assessmentId||'')+'">'+
      '<div class="form-grid">'+
        '<div class="form-group"><label>Patient</label><select id="mp_pat" onchange="mpPatientChanged()">'+pOpts+'</select></div>'+
        '<div class="form-group"><label>Diagnosis</label><input id="mp_dx" value="'+esc(MP.prefill.diagnosis||'')+'" readonly></div>'+
        '<div class="form-group"><label>Diet Type</label>'+SEL('mp_diet',['Balanced wellness','Weight loss','Diabetic','Hypertension (DASH)','Renal','High protein','High fibre','Soft diet','Cardiac low-sodium'],' onchange="mpRecalcTarget()"')+'</div>'+
      '</div>'+

      '<h4 class="wsec"><i class="fa-solid fa-calculator"></i> Prescribed Nutritional Requirements</h4>'+
      '<div class="form-grid" style="grid-template-columns:repeat(5,1fr)">'+
        '<div class="form-group"><label>Calories (kcal)</label><input id="mp_tCal" type="number" value="'+MP.target.calories+'" oninput="mpRender()"></div>'+
        '<div class="form-group"><label>Protein (g)</label><input id="mp_tProt" type="number" value="'+MP.target.proteinG+'" oninput="mpRender()"></div>'+
        '<div class="form-group"><label>Carbs (g)</label><input id="mp_tCarb" type="number" value="'+MP.target.carbG+'" oninput="mpRender()"></div>'+
        '<div class="form-group"><label>Fat (g)</label><input id="mp_tFat" type="number" value="'+MP.target.fatG+'" oninput="mpRender()"></div>'+
        '<div class="form-group"><label>Sodium (mg)</label><input id="mp_tSod" type="number" value="'+MP.target.sodiumMg+'" oninput="mpRender()"></div>'+
      '</div>'+
      '<div style="font-size:11px;color:var(--txt3);margin:-4px 0 8px">Estimated BMR '+MP.target.bmr+' kcal · TDEE '+MP.target.tdee+' kcal (Mifflin-St Jeor). Fluid target '+MP.target.fluidMl+' mL/day. Adjust the prescription above if needed.</div>'+

      '<h4 class="wsec"><i class="fa-solid fa-plus"></i> Add Food to a Meal</h4>'+
      '<div class="form-grid" style="grid-template-columns:2fr 1fr 1fr auto;align-items:end">'+
        '<div class="form-group"><label>Food (hospital database)</label><select id="mp_food">'+foodOpts+'</select></div>'+
        '<div class="form-group"><label>Meal</label>'+SEL('mp_meal',['Breakfast','Lunch','Dinner','Snacks'])+'</div>'+
        '<div class="form-group"><label>Servings</label><input id="mp_qty" type="number" step="0.5" min="0.5" value="1"></div>'+
        '<div class="form-group"><button class="btn btn-pri" onclick="mpAddFood()"><i class="fa-solid fa-plus"></i> Add</button></div>'+
      '</div>'+

      '<div id="mp_meals"></div>'+

      '<h4 class="wsec"><i class="fa-solid fa-scale-balanced"></i> Live Totals vs Prescription</h4>'+
      '<div id="mp_totals"></div>';

    modal('<i class="fa-solid fa-utensils" style="color:#0d9488;margin-right:8px"></i>Meal Planner / Diet Prescription'+(MP.editId?' (Editing)':'')+(MP.prefill.code?(' — '+esc(MP.prefill.code)):''),
      body,
      '<button class="btn btn-pri" onclick="mpSave()"><i class="fa-solid fa-save"></i> Save to Patient Record</button>'+
      '<button class="btn" style="background:#334155;color:#fff" onclick="mpPrint()"><i class="fa-solid fa-print"></i> Print</button>'+
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');

    /* preset diet type */
    setTimeout(function(){ var d=document.getElementById('mp_diet'); if(d&&MP.prefill.dietType){ for(var i=0;i<d.options.length;i++){ if(d.options[i].value===MP.prefill.dietType){ d.selectedIndex=i; break; } } } mpRender(); }, 40);
  };

  window.mpPatientChanged=function(){
    var pid=parseInt(gv('mp_pat')); MP.patientId=pid;
    var dx=latestDiagnosis(pid); var el=document.getElementById('mp_dx'); if(el) el.value=dx;
    mpRecalcTarget();
  };
  function mpRecalcTarget(){
    var pid=MP.patientId; var last=(DD().comprehensiveAssessments||[]).filter(function(a){return a.patientId===pid;}).slice(-1)[0];
    var pf=Object.assign({}, MP.prefill, { dietType:gv('mp_diet'), diagnosis:gv('mp_dx') });
    if(last){ pf.sex=last.sex; pf.age=last.age; pf.weight=last.weight; pf.height=last.height; pf.activity=last.physicalActivity;
              pf.proteinG=pf.proteinG||(last.carePlan&&last.carePlan.nutrition.proteinG); }
    var t=computeTarget(pf);
    var setv=function(id,v){ var e=document.getElementById(id); if(e) e.value=v; };
    setv('mp_tCal',t.calories); setv('mp_tProt',t.proteinG); setv('mp_tCarb',t.carbG); setv('mp_tFat',t.fatG); setv('mp_tSod',t.sodiumMg);
    mpRender();
  }
  window.mpRecalcTarget=mpRecalcTarget;
  window.mpAddFood=function(){
    var fid=gv('mp_food'); var meal=gv('mp_meal')||'Breakfast'; var qty=gn('mp_qty')||1;
    if(!fid) return; MP.meals[meal]=MP.meals[meal]||[]; MP.meals[meal].push({foodId:fid, qty:qty}); mpRender();
  };
  window.mpRemoveFood=function(meal,idx){ if(MP.meals[meal]) MP.meals[meal].splice(idx,1); mpRender(); };

  /* hoisted declaration so internal callers (mpAddFood/mpRemoveFood/etc.)
     resolve mpRender locally regardless of window binding timing */
  function mpRender(){
    var box=document.getElementById('mp_meals'); if(!box) return;
    var html='';
    ['Breakfast','Lunch','Dinner','Snacks'].forEach(function(meal){
      var items=MP.meals[meal]||[];
      var sub={kcal:0,protein:0};
      var rows=items.map(function(it,idx){ var f=foodByIdMP(it.foodId); if(!f) return ''; var q=+it.qty||1;
        sub.kcal+=(f.kcal||0)*q; sub.protein+=(f.protein||0)*q;
        return '<tr><td>'+esc(f.name)+'</td><td>'+q+'</td><td>'+Math.round((f.kcal||0)*q)+'</td><td>'+Math.round((f.protein||0)*q)+'</td>'+
          '<td><button class="btn btn-ghost" style="padding:2px 8px" onclick="mpRemoveFood(\''+meal+'\','+idx+')"><i class="fa-solid fa-trash"></i></button></td></tr>'; }).join('');
      if(!rows) rows='<tr><td colspan="5" style="color:var(--txt3);font-style:italic">No items yet</td></tr>';
      html+='<div style="margin:8px 0"><div style="font-weight:700;color:#0d9488;font-size:13px"><i class="fa-solid fa-clock"></i> '+meal+' <span style="color:var(--txt3);font-weight:500">('+Math.round(sub.kcal)+' kcal · '+Math.round(sub.protein)+' g protein)</span></div>'+
        '<table class="tbl" style="margin:4px 0"><thead><tr><th>Food</th><th>Servings</th><th>kcal</th><th>Protein g</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div>';
    });
    box.innerHTML=html;

    /* live totals vs prescribed target with over/under flags */
    var tot=mealTotals();
    var T={ calories:gn('mp_tCal'), proteinG:gn('mp_tProt'), carbG:gn('mp_tCarb'), fatG:gn('mp_tFat'), sodiumMg:gn('mp_tSod') };
    var rowsT=[
      ['Calories', tot.kcal, T.calories, 'kcal'],
      ['Protein',  tot.protein, T.proteinG, 'g'],
      ['Carbohydrate', tot.carbs, T.carbG, 'g'],
      ['Fat', tot.fat, T.fatG, 'g'],
      ['Sodium', tot.sodium, T.sodiumMg, 'mg']
    ].map(function(r){ var fl=flag(r[1], r[2], r[0]==='Sodium'?0.15:0.10);
      return '<tr><td>'+r[0]+'</td><td>'+r[1]+' '+r[3]+'</td><td>'+r[2]+' '+r[3]+'</td>'+
        '<td><span class="mp-badge '+fl.cls+'">'+esc(fl.txt||'—')+'</span></td></tr>'; }).join('');
    var warn='';
    var overs=[], unders=[];
    [['Calories',tot.kcal,T.calories],['Protein',tot.protein,T.proteinG]].forEach(function(r){ var f=flag(r[1],r[2]); if(f.cls==='mp-over') overs.push(r[0]); if(f.cls==='mp-under') unders.push(r[0]); });
    if(overs.length)  warn+='<div class="mp-warn mp-warn-over"><i class="fa-solid fa-triangle-exclamation"></i> Over-prescription: '+overs.join(', ')+' exceed the prescribed target.</div>';
    if(unders.length) warn+='<div class="mp-warn mp-warn-under"><i class="fa-solid fa-circle-info"></i> Under-prescription: '+unders.join(', ')+' below the prescribed target.</div>';
    document.getElementById('mp_totals').innerHTML=
      '<table class="tbl"><thead><tr><th>Nutrient</th><th>Planned</th><th>Prescribed</th><th>Status</th></tr></thead><tbody>'+rowsT+'</tbody></table>'+warn;
  }
  window.mpRender=mpRender;

  window.mpSave=function(){
    var D=DD(); ensureData();
    var pid=parseInt(gv('mp_pat')); if(!pid){ toastMsg('Select a patient'); return; }
    if(!Object.keys(MP.meals).some(function(m){return (MP.meals[m]||[]).length;})){ toastMsg('Add at least one food to the plan'); return; }
    var tot=mealTotals(); var p=patObj(pid);
    var editing = MP.editId ? (D.mealPlans||[]).find(function(m){return String(m.id)===String(MP.editId);}) : null;
    var plan={
      id: editing?editing.id:nowId(), code: editing?editing.code:('MP-'+String(Date.now()).slice(-6)),
      patientId: pid, patientName: p?p.fullName:patName(pid),
      assessmentId: gv('mp_assessId')||null,
      diagnosis: gv('mp_dx'), dietType: gv('mp_diet'),
      target: { calories:gn('mp_tCal'), proteinG:gn('mp_tProt'), carbG:gn('mp_tCarb'), fatG:gn('mp_tFat'), sodiumMg:gn('mp_tSod') },
      planned: tot,
      meals: JSON.parse(JSON.stringify(MP.meals)),
      createdBy: editing?editing.createdBy:curUser(), createdByRole: editing?editing.createdByRole:curRole(),
      date: editing?editing.date:today(), status:'Active',
      createdAt: editing?editing.createdAt:new Date().toISOString(), updatedAt:new Date().toISOString()
    };
    if(editing){ var i=D.mealPlans.indexOf(editing); D.mealPlans[i]=plan; }
    else { D.mealPlans.push(plan); }
    /* link into EMR (only on first save) */
    if(!editing){ try{ D.medicalRecords=D.medicalRecords||[]; D.medicalRecords.push({ id:nowId(), patientId:pid, visitDate:today(), visitType:'Diet Prescription',
      diagnosis: plan.diagnosis||'Meal plan', provider:curUser(),
      notes:'Individualised meal plan '+plan.code+' — planned '+tot.kcal+' kcal / '+tot.protein+' g protein vs prescribed '+plan.target.calories+' kcal / '+plan.target.proteinG+' g.', source:'mealplanner' }); }catch(e){} }
    notify('Meal Plan Saved', plan.patientName+' — '+tot.kcal+' kcal planned', 'clinical');
    try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
    toastMsg(editing?'Meal plan updated':'Meal plan saved to patient record & linked to EMR');
    MP.editId=plan.id;
    rerender();
  };

  window.mpPrint=function(){
    var tot=mealTotals(); var pid=parseInt(gv('mp_pat')); var p=patObj(pid);
    var T={calories:gn('mp_tCal'),proteinG:gn('mp_tProt'),carbG:gn('mp_tCarb'),fatG:gn('mp_tFat'),sodiumMg:gn('mp_tSod')};
    var mealsHtml=['Breakfast','Lunch','Dinner','Snacks'].map(function(m){
      var items=(MP.meals[m]||[]).map(function(it){ var f=foodByIdMP(it.foodId); if(!f) return ''; return '<li>'+esc(f.name)+' × '+(it.qty||1)+' ('+Math.round((f.kcal||0)*(it.qty||1))+' kcal)</li>'; }).join('');
      return '<h3>'+m+'</h3><ul>'+(items||'<li><i>none</i></li>')+'</ul>';
    }).join('');
    var w=window.open('','_blank'); if(!w){ toastMsg('Allow pop-ups to print'); return; }
    w.document.write('<html><head><title>Meal Plan — '+esc(p?p.fullName:'')+'</title>'+
      '<style>body{font-family:Arial;padding:24px;color:#111}h1{color:#0d9488}table{border-collapse:collapse;width:100%;margin-top:12px}th,td{border:1px solid #ccc;padding:6px 10px;text-align:left}</style></head><body>'+
      '<h1>Individual Meal Plan / Diet Prescription</h1>'+
      '<p><b>Patient:</b> '+esc(p?p.fullName:'')+' &nbsp; <b>MRN:</b> '+esc(p?(p.mrn||''):'')+' &nbsp; <b>Date:</b> '+today()+'</p>'+
      '<p><b>Diagnosis:</b> '+esc(gv('mp_dx'))+' &nbsp; <b>Diet:</b> '+esc(gv('mp_diet'))+'</p>'+
      mealsHtml+
      '<h3>Nutrient Summary (Planned vs Prescribed)</h3>'+
      '<table><tr><th>Nutrient</th><th>Planned</th><th>Prescribed</th></tr>'+
      '<tr><td>Calories</td><td>'+tot.kcal+' kcal</td><td>'+T.calories+' kcal</td></tr>'+
      '<tr><td>Protein</td><td>'+tot.protein+' g</td><td>'+T.proteinG+' g</td></tr>'+
      '<tr><td>Carbohydrate</td><td>'+tot.carbs+' g</td><td>'+T.carbG+' g</td></tr>'+
      '<tr><td>Fat</td><td>'+tot.fat+' g</td><td>'+T.fatG+' g</td></tr>'+
      '<tr><td>Sodium</td><td>'+tot.sodium+' mg</td><td>'+T.sodiumMg+' mg</td></tr></table>'+
      '<p style="margin-top:24px">Prepared by: '+esc(curUser())+' ('+esc(curRole())+')</p>'+
      '</body></html>');
    w.document.close(); w.focus(); setTimeout(function(){ try{w.print();}catch(e){} }, 300);
  };

  /* Print a saved plan directly (from the module list, no open modal). */
  window.mpPrintPlan=function(id){
    var D=DD(); var m=(D.mealPlans||[]).find(function(x){return String(x.id)===String(id);}); if(!m) return;
    var p=patObj(m.patientId); var T=m.target||{}; var tot=m.planned||{};
    var mealsHtml=['Breakfast','Lunch','Dinner','Snacks'].map(function(meal){
      var items=((m.meals||{})[meal]||[]).map(function(it){ var f=foodByIdMP(it.foodId); if(!f) return ''; return '<li>'+esc(f.name)+' × '+(it.qty||1)+' ('+Math.round((f.kcal||0)*(it.qty||1))+' kcal)</li>'; }).join('');
      return '<h3>'+meal+'</h3><ul>'+(items||'<li><i>none</i></li>')+'</ul>';
    }).join('');
    var w=window.open('','_blank'); if(!w){ toastMsg('Allow pop-ups to print'); return; }
    w.document.write('<html><head><title>Meal Plan — '+esc(p?p.fullName:'')+'</title>'+
      '<style>body{font-family:Arial;padding:24px;color:#111}h1{color:#0d9488}table{border-collapse:collapse;width:100%;margin-top:12px}th,td{border:1px solid #ccc;padding:6px 10px;text-align:left}</style></head><body>'+
      '<h1>Individual Meal Plan / Diet Prescription</h1>'+
      '<p><b>'+esc(m.code||'')+'</b> &nbsp; <b>Patient:</b> '+esc(p?p.fullName:m.patientName)+' &nbsp; <b>MRN:</b> '+esc(p?(p.mrn||''):'')+' &nbsp; <b>Date:</b> '+esc(m.date||'')+'</p>'+
      '<p><b>Diagnosis:</b> '+esc(m.diagnosis||'')+' &nbsp; <b>Diet:</b> '+esc(m.dietType||'')+'</p>'+
      mealsHtml+
      '<h3>Nutrient Summary (Planned vs Prescribed)</h3>'+
      '<table><tr><th>Nutrient</th><th>Planned</th><th>Prescribed</th></tr>'+
      '<tr><td>Calories</td><td>'+(tot.kcal||0)+' kcal</td><td>'+(T.calories||0)+' kcal</td></tr>'+
      '<tr><td>Protein</td><td>'+(tot.protein||0)+' g</td><td>'+(T.proteinG||0)+' g</td></tr>'+
      '<tr><td>Carbohydrate</td><td>'+(tot.carbs||0)+' g</td><td>'+(T.carbG||0)+' g</td></tr>'+
      '<tr><td>Fat</td><td>'+(tot.fat||0)+' g</td><td>'+(T.fatG||0)+' g</td></tr>'+
      '<tr><td>Sodium</td><td>'+(tot.sodium||0)+' mg</td><td>'+(T.sodiumMg||0)+' mg</td></tr></table>'+
      '<p style="margin-top:24px">Prepared by: '+esc(m.createdBy||'')+'</p>'+
      '</body></html>');
    w.document.close(); w.focus(); setTimeout(function(){ try{w.print();}catch(e){} }, 300);
  };

  /* ═════════════ "REFER TO WELLNESS OFFICER" — doctor workflow ═════════════ */
  window.referToWellness = function(patientId){
    ensureData(); var D=DD();
    var pid = patientId || parseInt(gv('rtw_pat'));
    var p = patObj(pid);
    if(!p){
      var pOpts=(D.patients||[]).filter(function(x){return x.status!=='Discharged';})
        .map(function(x){return '<option value="'+x.id+'">'+esc(x.fullName)+' — '+esc(x.mrn||'')+'</option>';}).join('');
      modal('<i class="fa-solid fa-user-doctor" style="color:#8b5cf6;margin-right:8px"></i>Refer to Wellness Officer',
        '<div class="form-grid"><div class="form-group"><label>Patient</label><select id="rtw_pat">'+pOpts+'</select></div>'+
        '<div class="form-group full"><label>Diagnosis (auto from EMR — editable)</label><input id="rtw_dx" placeholder="loading…"></div>'+
        '<div class="form-group full"><label>Reason for referral</label><textarea id="rtw_reason" rows="2" placeholder="e.g. nutritional optimisation for diabetes"></textarea></div></div>',
        '<button class="btn btn-pri" onclick="submitWellnessReferral()"><i class="fa-solid fa-paper-plane"></i> Refer</button>'+
        '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
      setTimeout(function(){ var s=document.getElementById('rtw_pat'); if(s){ var dx=latestDiagnosis(parseInt(s.value)); var d=document.getElementById('rtw_dx'); if(d) d.value=dx;
        s.addEventListener('change',function(){ var d2=document.getElementById('rtw_dx'); if(d2) d2.value=latestDiagnosis(parseInt(s.value)); }); } }, 40);
      return;
    }
    submitWellnessReferral(pid);
  };
  window.submitWellnessReferral = function(fixedPid){
    ensureData(); var D=DD();
    var pid = fixedPid || parseInt(gv('rtw_pat'));
    if(!pid){ toastMsg('Select a patient'); return; }
    var p=patObj(pid);
    var dx = gv('rtw_dx') || latestDiagnosis(pid);
    D.wellnessReferrals.push({
      id: nowId(), patientId: pid, patientName: p?p.fullName:patName(pid),
      diagnosis: dx, reason: gv('rtw_reason')||'',
      referredBy: curUser(), referredByRole: curRole(),
      date: today(), status:'Open', createdAt:new Date().toISOString()
    });
    /* create a pending L3 so it appears in the wellness queue */
    try{
      D.comprehensiveAssessments = D.comprehensiveAssessments || [];
      D.comprehensiveAssessments.push({ id:nowId(), patientId:pid, patientName:p?p.fullName:patName(pid),
        diagnosis:dx, status:'Pending', source:'referral', date:today(), referredBy:curUser() });
    }catch(e){}
    notify('Wellness Referral', (p?p.fullName:'Patient')+' referred to Wellness Officer — Dx: '+(dx||'n/a'), 'clinical');
    try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
    closeM(); rerender();
    toastMsg('Patient referred to Wellness Officer — diagnosis carried into assessment');
  };

  /* ══════════════════════ CSS for the v131 UI ══════════════════════ */
  function injectCSS(){
    if(document.getElementById('v131-css')) return;
    var s=document.createElement('style'); s.id='v131-css';
    s.textContent=
      '.wsec{margin:16px 0 6px;padding-bottom:5px;border-bottom:2px solid #ede9fe;color:#6d28d9;font-size:14px;font-weight:800;display:flex;align-items:center;gap:8px}'+
      '.wsec i{color:#8b5cf6}'+
      '.wchk{display:flex;align-items:center;gap:6px;font-size:13px;padding:6px 8px;background:#faf5ff;border:1px solid #ede9fe;border-radius:8px;cursor:pointer}'+
      '.wchk input{margin:0}'+
      '.mp-badge{padding:3px 9px;border-radius:99px;font-size:11px;font-weight:700;white-space:nowrap}'+
      '.mp-ok{background:#dcfce7;color:#166534}'+
      '.mp-over{background:#fee2e2;color:#991b1b}'+
      '.mp-under{background:#fef3c7;color:#92400e}'+
      '.mp-warn{margin-top:8px;padding:8px 12px;border-radius:8px;font-size:12px;font-weight:600;display:flex;align-items:center;gap:8px}'+
      '.mp-warn-over{background:#fee2e2;color:#991b1b;border:1px solid #fecaca}'+
      '.mp-warn-under{background:#fef3c7;color:#92400e;border:1px solid #fde68a}';
    (document.head||document.documentElement).appendChild(s);
  }

  /* ══════════════════════ MODULE / NAV / RBAC WIRING ══════════════════════ */
  function applyV131(){
    ensureData(); injectCSS(); wireL3ViewButton(); wirePatientReferButton();

    /* register the Meal Planner module + RBAC role for Wellness Officer */
    try{
      var D=DD();
      if(D.moduleRegistry && !D.moduleRegistry['mealplanner']){
        D.moduleRegistry['mealplanner']={ id:'mealplanner', name:'Meal Planner', icon:'fa-utensils', category:'Clinical', builtin:true };
      }
      /* ensure Wellness Officer role can reach wellness + meal planner */
      if(D.responsibilities){
        ['Wellness Officer','Dietitian','Nutritionist'].forEach(function(role){
          D.responsibilities[role]=D.responsibilities[role]||{};
          D.responsibilities[role]['wellness']=true;
          D.responsibilities[role]['mealplanner']=true;
          D.responsibilities[role]['dietary']=true;
        });
      }
    }catch(e){}

    /* route the Meal Planner module through renderModule / getModTitle */
    if(!window.renderModule || !window.renderModule._mpWrapped){
      var _rm=window.renderModule;
      var f=function(){ try{ if(typeof currentMod!=='undefined' && currentMod==='mealplanner') return renderMealPlannerModule(); }catch(e){} return _rm?_rm.apply(this,arguments):''; };
      f._mpWrapped=true;
      /* preserve wellness wrap flag if present */
      if(_rm&&_rm._wellWrapped) f._wellWrapped=true;
      window.renderModule=f;
    }
    if(!window.getModTitle || !window.getModTitle._mpWrapped){
      var _gt=window.getModTitle;
      var g=function(){ try{ if(typeof currentMod!=='undefined' && currentMod==='mealplanner') return 'Meal Planner / Diet Prescription'; }catch(e){} return _gt?_gt.apply(this,arguments):'Dashboard'; };
      g._mpWrapped=true; if(_gt&&_gt._wellWrapped) g._wellWrapped=true;
      window.getModTitle=g;
    }
    if(!window.buildNav || !window.buildNav._mpWrapped){
      var _bn=window.buildNav;
      var b=function(){
        var html=_bn?_bn.apply(this,arguments):'';
        if(/goTo\('mealplanner'\)/.test(html)) return html;
        var DD2=(typeof D!=='undefined'&&D)?D:window.D;
        try{ if(typeof window.hasModuleAccess==='function' && !window.hasModuleAccess('dietary') && !window.hasModuleAccess('wellness')) return html; }catch(e){}
        var act=(typeof currentMod!=='undefined'&&currentMod==='mealplanner')?'active':'';
        var btn='<button class="sb-item '+act+'" onclick="goTo(\'mealplanner\')"><i class="fa-solid fa-utensils"></i><span>Meal Planner</span></button>';
        if(/goTo\('wellness'\)/.test(html)){
          html=html.replace(/(<button class="sb-item[^"]*" onclick="goTo\('wellness'\)">[\s\S]*?<\/button>)/, '$1'+btn);
        } else if(/goTo\('dietary'\)/.test(html)){
          html=html.replace(/(<button class="sb-item[^"]*" onclick="goTo\('dietary'\)">[\s\S]*?<\/button>)/, '$1'+btn);
        } else { html+=btn; }
        return html;
      };
      b._mpWrapped=true; if(_bn&&_bn._wellWrapped) b._wellWrapped=true;
      window.buildNav=b;
    }
  }

  /* Meal Planner as a full module page (list of saved plans + launcher) */
  function renderMealPlannerModule(){
    ensureData(); var D=DD();
    var plans=(D.mealPlans||[]).slice().reverse();
    var refs=(D.wellnessReferrals||[]).filter(function(r){return r.status==='Open';});
    var rows=plans.length? plans.map(function(m){
      var over = m.planned && m.target && m.planned.kcal>m.target.calories*1.1;
      var under= m.planned && m.target && m.planned.kcal<m.target.calories*0.9;
      var badge= over?'<span class="mp-badge mp-over">Over</span>':under?'<span class="mp-badge mp-under">Under</span>':'<span class="mp-badge mp-ok">On target</span>';
      return '<tr><td>'+esc(m.code)+'</td><td>'+esc(m.patientName)+'</td><td>'+esc(m.dietType||'')+'</td>'+
        '<td>'+(m.planned?m.planned.kcal:0)+' / '+(m.target?m.target.calories:0)+' kcal</td><td>'+badge+'</td><td>'+esc(m.date||'')+'</td>'+
        '<td><button class="btn btn-ghost" style="padding:3px 10px" title="Edit this plan" onclick="openMealPlanner(null,{editPlanId:\''+esc(m.id)+'\'})"><i class="fa-solid fa-pen"></i> Edit</button> '+
        '<button class="btn btn-ghost" style="padding:3px 10px" title="Print" onclick="mpPrintPlan(\''+esc(m.id)+'\')"><i class="fa-solid fa-print"></i></button></td></tr>';
    }).join('') : '<tr><td colspan="7" style="color:var(--txt3);font-style:italic">No meal plans yet. Click "New Meal Plan".</td></tr>';

    var refRows=refs.length? refs.map(function(r){
      return '<tr><td>'+esc(r.patientName)+'</td><td>'+esc(r.diagnosis||'')+'</td><td>'+esc(r.referredBy||'')+'</td><td>'+esc(r.date||'')+'</td>'+
        '<td><button class="btn btn-pri" style="padding:3px 10px" onclick="wOpenL3('+r.patientId+')"><i class="fa-solid fa-clipboard-list"></i> Assess</button></td></tr>';
    }).join('') : '';

    return '<div class="card" style="margin-bottom:14px;display:flex;justify-content:space-between;align-items:center">'+
        '<div><h3 style="margin:0"><i class="fa-solid fa-utensils" style="color:#0d9488"></i> Meal Planner / Diet Prescription</h3>'+
        '<div style="font-size:12px;color:var(--txt2)">Individualised nutrition care — calculate requirements, build a plan, compare vs prescription, save &amp; print.</div></div>'+
        '<button class="btn btn-pri" onclick="openMealPlanner()"><i class="fa-solid fa-plus"></i> New Meal Plan</button></div>'+
      (refs.length?('<div class="card" style="margin-bottom:14px"><h4 style="margin:0 0 8px"><i class="fa-solid fa-user-doctor" style="color:#8b5cf6"></i> Pending Wellness Referrals</h4>'+
        '<table class="tbl"><thead><tr><th>Patient</th><th>Diagnosis</th><th>Referred by</th><th>Date</th><th></th></tr></thead><tbody>'+refRows+'</tbody></table></div>'):'')+
      '<div class="card"><table class="tbl"><thead><tr><th>Code</th><th>Patient</th><th>Diet</th><th>Planned/Prescribed</th><th>Status</th><th>Date</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div>';
  }
  window.renderMealPlannerModule = renderMealPlannerModule;

  /* ═══════════ VIEW / PRINT a completed Comprehensive Assessment ═══════════ */
  function findAssessment(id){ return (DD().comprehensiveAssessments||[]).find(function(a){ return String(a.id)===String(id); }); }
  function assessmentHTML(a){
    if(!a) return '<div class="card">Assessment not found.</div>';
    var cp=a.carePlan||{}; var n=cp.nutrition||{}; var ls=cp.lifestyle||{}; var mw=cp.mental||{}; var pv=cp.preventive||{};
    var sc=a.scores||{};
    var row=function(l,v){ return '<tr><td style="width:38%;color:var(--txt2)">'+esc(l)+'</td><td><b>'+esc(v==null||v===''?'—':v)+'</b></td></tr>'; };
    var labRows=(a.labSnapshot||[]).map(function(l){ return '<tr><td>'+esc(l.test)+'</td><td>'+esc(l.result)+' '+esc(l.unit||'')+'</td><td>'+esc(l.flag||'')+'</td></tr>'; }).join('')
      || '<tr><td colspan="3" style="color:var(--txt3)">No labs captured</td></tr>';
    var sec=function(t,ic,rows){ return '<h4 class="wsec"><i class="fa-solid '+ic+'"></i> '+t+'</h4><table class="tbl" style="margin:0 0 6px">'+rows+'</table>'; };
    return '<div id="wl3view">'+
      sec('Patient & Visit','fa-id-card', row('Patient',a.patientName)+row('MRN',a.mrn)+row('Type of Visit',a.visitType)+row('Assessment Date',a.date)+row('Sex',a.sex)+row('Age',a.age))+
      sec('Medical & Anthropometric','fa-stethoscope', row('Primary Diagnosis',a.diagnosis)+row('BMI',(a.bmi||'—')+' ('+(a.bmiCategory||'')+')')+row('Waist-Hip Ratio',a.whr))+
      sec('Biochemical (Laboratory / EMR)','fa-flask-vial','<thead><tr><th>Investigation</th><th>Result</th><th>Flag</th></tr></thead>'+labRows)+
      sec('Clinical & Dietary','fa-utensils', row('Food Allergies',a.foodAllergies)+row('Food Intolerance',a.foodIntolerance)+row('Chewing',a.chewingProblems)+row('Swallowing',a.swallowingProblems)+row('Water Intake',a.waterIntake)+row('Sugary Drinks',a.sugaryDrinks)+row('24h Recall',a.recall24h))+
      sec('Wellness Diagnosis (PES)','fa-diagnoses', row('Problem',(a.pes||{}).problem)+row('Etiology',(a.pes||{}).etiology)+row('Signs / Evidence',(a.pes||{}).signs))+
      sec('Integrated Care Plan','fa-bullseye', row('Diet Type',n.dietType)+row('Calories',n.calories?(n.calories+' kcal/day'):'')+row('Protein',n.proteinG?(n.proteinG+' g/day'):'')+row('Fluid',n.fluidMl?(n.fluidMl+' mL/day'):'')+row('Physical Activity Rx',ls.activityRx)+row('Sleep Plan',ls.sleepPlan)+row('Stress Plan',ls.stressPlan)+row('Counselling Referral',mw.counsellingReferral)+row('BP Monitoring',pv.bpPlan)+row('Blood Sugar Monitoring',pv.bsPlan)+row('Screening Schedule',pv.screeningSchedule)+row('Patient Education',(cp.education||[]).join(', ')))+
      sec('Scores & Follow-up','fa-chart-simple', row('Overall Wellness',(sc.overall!=null?sc.overall:a.overallScore))+row('Risk',a.overallRisk||a.risk)+row('Follow-up',a.followUp)+row('Assessed by',a.assessedBy||a.by))+
      (a.notes?('<div style="margin-top:6px;font-size:12px"><b>Notes:</b> '+esc(a.notes)+'</div>'):'')+
    '</div>';
  }
  window.wViewL3=function(id){
    var a=findAssessment(id);
    modal('<i class="fa-solid fa-clipboard-list" style="color:#8b5cf6;margin-right:8px"></i>Comprehensive Wellness Assessment — '+esc(a?a.code:''),
      assessmentHTML(a),
      '<button class="btn" style="background:#334155;color:#fff" onclick="wPrintL3(\''+esc(id)+'\')"><i class="fa-solid fa-print"></i> Print</button>'+
      (a&&a.patientId?('<button class="btn" style="background:#0d9488;color:#fff" onclick="closeModal();openMealPlanner('+a.patientId+')"><i class="fa-solid fa-utensils"></i> Meal Planner</button>'):'')+
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.wPrintL3=function(id){
    var a=findAssessment(id); if(!a) return;
    var w=window.open('','_blank'); if(!w){ toastMsg('Allow pop-ups to print'); return; }
    w.document.write('<html><head><title>Wellness Assessment — '+esc(a.patientName)+'</title>'+
      '<style>body{font-family:Arial;padding:24px;color:#111}h1{color:#6d28d9}h4{color:#6d28d9;border-bottom:1px solid #ddd;margin:14px 0 4px}table{border-collapse:collapse;width:100%}td,th{border:1px solid #ccc;padding:5px 9px;text-align:left;font-size:13px}.wsec{}</style></head><body>'+
      '<h1>Comprehensive Wellness Assessment</h1><p><b>'+esc(a.code||'')+'</b> · '+esc(a.date||'')+'</p>'+
      assessmentHTML(a).replace(/class="tbl"/g,'').replace(/<h4 class="wsec">/g,'<h4>')+
      '<p style="margin-top:20px">Assessed by: '+esc(a.assessedBy||a.by||'')+'</p></body></html>');
    w.document.close(); w.focus(); setTimeout(function(){ try{w.print();}catch(e){} },300);
  };

  /* Add a "Refer to Wellness Officer" action into each patient row (doctor
     workflow) by wrapping renderPatients output. */
  function wirePatientReferButton(){
    if(!window.renderPatients || window.renderPatients._v131refer) return;
    var _rp=window.renderPatients;
    var wrapped=function(){
      var html=_rp.apply(this,arguments);
      try{
        if(typeof html==='string'){
          /* inject a referral button just before each row's Print action */
          html=html.replace(/(<button class="act-btn print" title="Print" onclick="printRecord\('patients',(\d+)\)">)/g,
            '<button class="act-btn" title="Refer to Wellness Officer" onclick="referToWellness($2)" style="color:#8b5cf6"><i class="fa-solid fa-heart-pulse"></i></button>$1');
        }
      }catch(e){}
      return html;
    };
    wrapped._v131refer=true;
    window.renderPatients=wrapped;
  }

  /* Add a View action to completed L3 rows by wrapping renderWellness output. */
  function wireL3ViewButton(){
    if(!window.renderWellness || window.renderWellness._v131view) return;
    var _rw=window.renderWellness;
    var wrapped=function(){
      var html=_rw.apply(this,arguments);
      /* only augment the L3 list view */
      try{
        if(typeof html==='string' && DD() && DD()._wellTab==='l3'){
          /* append a View button to each completed CWA row that lacks an action cell.
             The list rows end with the "By" cell; we add a trailing action column. */
          var done=(DD().comprehensiveAssessments||[]).filter(function(x){return x.status==='Completed';});
          done.forEach(function(a){
            var codeCell='<td class="bold">'+a.code+'</td>';
            if(html.indexOf(codeCell)>-1){
              /* inject a view button right after the code cell for quick access */
              html=html.replace(codeCell, '<td class="bold">'+a.code+' <button class="btn btn-xs btn-ghost" title="View / Print" onclick="wViewL3(\''+a.id+'\')"><i class="fa-solid fa-eye"></i></button></td>');
            }
          });
        }
      }catch(e){}
      return html;
    };
    wrapped._v131view=true; if(_rw._wellWrapped) wrapped._wellWrapped=true;
    window.renderWellness=wrapped;
  }

  /* apply now + re-assert after later packs (mirror v130/wellness pattern) */
  applyV131();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(applyV131,ms); });
  if(typeof window.addEventListener==='function'){ window.addEventListener('load',function(){ applyV131(); setTimeout(applyV131,500); }); }
  DOMBus.register(applyV131);

  try{ console.log('%c✅ v131 Wellness+MealPlanner — 14-section assessment, EMR/Lab sync, diet prescription','background:#6d28d9;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/108-idempotent-2.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV158) return;                 // idempotent
  window.__twhV158 = true;

  function D(){ return window.D || (window.D = {}); }

  /* ─────────────────────────────────────────────────────────────────────────
     RETIRED (Request F): the v158 identity-isolation machinery — the login
     watchdog setInterval, the boot snapshot timers, the outgoing-PUT fetch
     shim, the HMS_IDENTITY_v1 sessionStorage mirror, and the _hmsRefresh
     reassert wrapper — is now REDUNDANT. Identity is stripped at the source
     (functions/api/state/[id].js strips it from every GET, PUT and stored doc)
     and the persistence layer in index.html owns identity per-tab via
     sessionStorage (_hmsid_*), pins it across every poll, and serializes a
     stripped clone on write. Running the old timers on top of that just burns
     cycles for no effect, so they've been removed.

     We keep only:
       • harmless stub exports so any (defensive) caller of the old hooks is safe
       • the ANTI-SHAKE render-defer + CSS below, which are still useful and are
         independent of identity handling.
     The __twhV158 flag above is preserved so later packs (v160/v161/v170/…)
     that check it still behave exactly as before. */
  window.__hmsReassertIdentity = window.__hmsReassertIdentity || function(){ /* no-op: identity pinned by persistence layer */ };
  window.__hmsStrippedState = window.__hmsStrippedState || (window._hmsStripState) || function(){ return D(); };

  /* ═══════════════════════ (B) ANTI-SHAKE ═══════════════════════════════ */

  /* (B1) Track whether the user is actively interacting; if so, suppress the
     poll-driven auto re-render so the screen doesn't jump under their hands. */
  var _lastInput = 0;
  ['keydown','pointerdown','input','mousedown','touchstart','focusin'].forEach(function(ev){
    document.addEventListener(ev, function(){ _lastInput = Date.now(); }, true);
  });
  function userBusy(){
    // Busy if a form field is focused, or input happened in the last 1.2s.
    try{
      var ae = document.activeElement;
      if(ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) && ae.type !== 'button' && ae.type !== 'submit') return true;
    }catch(e){}
    return (Date.now() - _lastInput) < 1200;
  }
  window.__hmsUserBusy = userBusy;

  /* Wrap the coalesced render so a paint requested WHILE the user is busy is
     deferred (retried shortly) instead of yanking the UI. Manual renders from
     user actions still go through because those set _lastInput but the action's
     own render fires synchronously via the normal path; the deferral only
     affects the periodic background poll cadence, which is what "shakes". */
  function wrapRender(){
    var r = window.render;
    if(typeof r !== 'function' || r.__v158busy) return false;
    var wrapped = function(){
      // If a background repaint lands mid-interaction, defer it briefly.
      if(userBusy() && !wrapped.__forcing){
        clearTimeout(wrapped.__deferTimer);
        var args = arguments, self = this;
        wrapped.__deferTimer = setTimeout(function(){
          if(userBusy()){ wrapped.apply(self, args); }   // still busy → keep waiting
          else { wrapped.__forcing = true; try{ r.apply(self, args); } finally { wrapped.__forcing = false; } }
        }, 400);
        return;
      }
      return r.apply(this, arguments);
    };
    wrapped.__v158busy = true;
    wrapped.__coalesced = r.__coalesced;          // keep v130's tag so it isn't re-wrapped
    wrapped.now = r.now || function(){ return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }
  // Apply after v130 has installed its coalescer; re-assert after late packs.
  [200, 800, 2000, 4000, 6500].forEach(function(ms){ setTimeout(wrapRender, ms); });

  /* (B2) Kill layout jump: pin the app container so a full innerHTML rebuild
     keeps its box size + scroll position instead of collapsing/expanding
     (which reads as a "shake"). */
  function injectCSS(){
    if(document.getElementById('twh-v158-css')) return;
    var css = document.createElement('style');
    css.id = 'twh-v158-css';
    css.textContent = [
      '#app{min-height:100vh;overflow-anchor:auto;}',
      '.main{overflow-anchor:auto;}',
      /* Neutralize any residual opacity/transform flicker on the shell during rebuilds */
      '#app,.main,.content,.module-content{will-change:auto;}',
      /* Prevent the sidebar from reflowing width during repaints */
      '.sidebar{contain:layout style;}' 
    ].join('\n');
    (document.head||document.documentElement).appendChild(css);
  }
  injectCSS();
  [500, 2000].forEach(function(ms){ setTimeout(injectCSS, ms); });

  try{
    console.log('%c✅ v158 Session-Isolation + Anti-Shake — identity is per-browser; poll no longer clobbers login or shakes UI',
      'background:#6d28d9;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/109-idempotent-3.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV159) return;                     // idempotent
  window.__twhV159 = true;

  function D(){ return window.D || (window.D = {}); }

  /* ─────────────────────────────────────────────────────────────────────────
     RETIRED (Request F): the v159 identity-lock machinery — the doLogin hook,
     the both-directions /api/state fetch shim, the __HMS_BOOT_STATE cleaner,
     the _hmsRefresh reassert wrapper, and the 1s identity watchdog DOMBus.register(plus its boot snapshot timers) — is now REDUNDANT and has been removed.

     Identity is stripped at the SOURCE (functions/api/state/[id].js scrubs it
     from every GET, every incoming PUT, and the stored/merged document) and the
     persistence layer in index.html owns identity per-tab via sessionStorage
     (_hmsid_*), pins it across every poll, and serializes a stripped clone on
     write. The server GET shim + boot cleaner + watchdog therefore have nothing
     left to do; keeping them running only wasted a fetch round-trip rewrite and
     a 1s timer forever. The __twhV159 flag above is preserved so later packs
     (v160/v161/v170/…) that check it behave exactly as before.

     Harmless stub exports remain so any defensive caller of the old hooks is
     safe (identity is now guaranteed correct by the persistence layer). */
  window.__hmsSnapshotIdentity = window.__hmsSnapshotIdentity || (window._hmsSaveIdentity) || function(){ return false; };
  window.__hmsReassertIdentity = window.__hmsReassertIdentity || function(){ /* no-op: identity pinned by persistence layer */ };

  /* ═══════════════════════ ZERO-FLICKER (blink/shake) ═══════════════════ */

  /* (5) Make the sidebar cleaner idempotent so it stops mutating every tick.
        We wrap window.__extCleanNav (the v-ext cleanNav) so it FIRST checks
        whether any target elements actually exist; if none, it no-ops. This
        breaks the add→remove flicker loop (render re-adds, cleanNav re-removes). */
  /* NOTE: v160 (below) owns sidebar label integrity now. The old v159 "no-op
     when no counts" guard was REMOVED because it prevented repair of labels
     that had already been polluted with trailing count digits
     (e.g. "CLINICAL111111"). We keep a thin idempotency tag only. */
  function wrapCleanNav(){
    var orig = window.__extCleanNav;
    if(typeof orig!=='function' || orig.__v159) return false;
    orig.__v159 = true;   // just mark; do not alter behaviour (v160 handles it)
    return true;
  }
  if(!wrapCleanNav()){ var ct2=0, ci=setInterval(function(){ ct2++; if(wrapCleanNav()||ct2>60) clearInterval(ci); },200); }

  /* (6) Debounce ANY MutationObserver-driven work on the sidebar: replace the
        raw callback churn by throttling __extCleanNav calls to ≤1 per 250ms. */
  (function throttleCleanNav(){
    var real = window.__extCleanNav;
    if(!real){ setTimeout(throttleCleanNav, 300); return; }
    if(real.__v159throttled) return;
    var pending=false, last=0;
    var throttled = function(){
      var now=Date.now();
      if(pending) return;
      var gap = 250 - (now-last);
      if(gap<=0){ last=now; return real.apply(this, arguments); }
      pending=true;
      var self=this, args=arguments;
      setTimeout(function(){ pending=false; last=Date.now(); try{ real.apply(self,args); }catch(e){} }, gap);
    };
    throttled.__v159throttled = true;
    throttled.__v159 = true;
    window.__extCleanNav = throttled;
  })();

  /* (7) CSS containment: keep nav + main repaints from reflowing the whole
        page (removes residual layout jitter beyond v158's rules). */
  (function css(){
    if(document.getElementById('twh-v159-css')) return;
    var s=document.createElement('style'); s.id='twh-v159-css';
    s.textContent = [
      '.sidebar,.sb-nav{contain:layout style;}',
      '.sb-sec{contain:layout;}',
      '#app{contain:layout style;min-height:100vh;}',
      '.main{contain:layout;}',
      /* Suppress transition flashes on structural rebuilds */
      '.sb-item,.sb-sec-label{transition:none!important;}'
    ].join('\n');
    (document.head||document.documentElement).appendChild(s);
  })();
  [500,2000].forEach(function(ms){ setTimeout(function(){ try{
    if(!document.getElementById('twh-v159-css')){ var e=new Event('x'); }
  }catch(e){} }, ms); });

  try{
    console.log('%c✅ v159 Session-Lock + Zero-Flicker — identity stripped from sync (both directions); cleanNav idempotent+throttled',
      'background:#7c3aed;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/110-twh-sidebar-label-integrity-v160.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV160) return;
  window.__twhV160 = true;

  /* Derive the pristine label: strip a trailing run of digits (the count) and
     trim. "CLINICAL11" → "CLINICAL"; "MANAGEMENT1616" → "MANAGEMENT". If the
     label is ALL digits (shouldn't happen) leave as-is. */
  function pristine(text){
    var t = (text||'').replace(/\s+/g,' ').trim();
    var m = t.replace(/\d+$/,'').trim();
    return m.length ? m : t;
  }

  function fixOne(sec){
    try{
      var label = sec.querySelector('.sb-sec-label');
      if(!label) return;
      // Establish the clean name once (before any pollution can compound).
      var clean = label.getAttribute('data-clean');
      if(!clean){
        clean = pristine(label.textContent);
        // Guard: if current text already looks polluted, still store the base.
        label.setAttribute('data-clean', clean);
      }
      // FORCE the visible label back to the clean name (idempotent).
      if((label.textContent||'').trim() !== clean){
        label.textContent = clean;
      }
      // Keep the count span accurate (count sibling .sb-item/.sb-group-items).
      var count = sec.querySelector('.sb-sec-count');
      if(count){
        var n = countItemsFor(sec);
        var cur = (count.textContent||'').trim();
        var want = String(n);
        if(cur !== want) count.textContent = want;
      }
    }catch(e){}
  }

  /* Count the nav items that belong to this section (support both the v33
     collapsible ".sb-group-items" layout and the flat sibling layout). */
  function countItemsFor(sec){
    try{
      var gi = sec.nextElementSibling;
      if(gi && gi.classList && gi.classList.contains('sb-group-items')){
        return gi.querySelectorAll('.sb-item').length;
      }
      // Flat fallback: count following .sb-item until the next .sb-sec.
      var n=0, node=sec.nextElementSibling;
      while(node && !(node.classList && node.classList.contains('sb-sec'))){
        if(node.classList && node.classList.contains('sb-item')) n++;
        node = node.nextElementSibling;
      }
      return n;
    }catch(e){ return 0; }
  }

  function fixAll(){
    var secs = document.querySelectorAll('.sb-sec');
    for(var i=0;i<secs.length;i++) fixOne(secs[i]);
  }
  window.__twhFixSidebar = fixAll;

  /* Debounced runner so a burst of DOM mutations coalesces into one pass. */
  var t=null;
  function schedule(){
    if(t) return;
    t = setTimeout(function(){ t=null; fixAll(); }, 80);
  }

  /* Observe the sidebar for changes (render rebuilds it). Debounced. */
  function observe(){
    try{
      var host = document.querySelector('.sb-nav') ||
                 (document.querySelector('.sb-sec')||{}).parentNode ||
                 document.querySelector('.sidebar');
      if(!host){ setTimeout(observe, 300); return; }
      if(window.__twhV160Host === host) return;
      if(window.__twhV160Obs){ try{ window.__twhV160Obs.disconnect(); }catch(e){} }
      var MO = window.MutationObserver;
      if(!MO){ DOMBus.register(fixAll); return; }
      var obs = new MO(function(){ schedule(); });
      obs.observe(host, { childList:true, subtree:true, characterData:true });
      window.__twhV160Obs = obs; window.__twhV160Host = host;
      fixAll();
    }catch(e){}
  }

  /* Also wrap render so the fix runs right after each paint (before the eye
     sees a polluted frame). Non-invasive: run original, then fix. */
  function wrapRender(){
    var r = window.render;
    if(typeof r!=='function' || r.__v160) return false;
    var wrapped = function(){
      var out = r.apply(this, arguments);
      try{ fixAll(); }catch(e){}
      // Re-attach observer in case the host node was replaced by the rebuild.
      try{ observe(); }catch(e){}
      return out;
    };
    wrapped.__v160 = true;
    // Preserve v130/v159 tags so their re-assert logic doesn't re-wrap endlessly.
    wrapped.__coalesced = r.__coalesced;
    wrapped.__v158busy = r.__v158busy;
    wrapped.now = r.now || function(){ return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }

  /* Boot: observe + fix now and after late packs settle. */
  observe();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(function(){ observe(); fixAll(); wrapRender(); }, ms); });
  DOMBus.register(function(){ fixAll(); });        // light safety net
  DOMBus.register(function(){ wrapRender(); });    // stay outermost after re-wraps

  try{
    console.log('%c✅ v160 Sidebar Label Integrity — section names locked (no more CLINICAL111…); counts kept in count span',
      'background:#b45309;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/111-twh-noop-repaint-guard-v161.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV161) return;
  window.__twhV161 = true;

  function wrap(){
    var r = window.render;
    if(typeof r!=='function' || r.__v161) return false;

    var wrapped = function(){
      var app = document.getElementById('app');
      if(!app){ return r.apply(this, arguments); }

      // Intercept THIS call's innerHTML writes: compare-then-write.
      var proto = Object.getPrototypeOf(app);
      var desc = Object.getOwnPropertyDescriptor(proto, 'innerHTML') ||
                 Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
      if(!desc || !desc.set){ return r.apply(this, arguments); }

      var realSet = desc.set, realGet = desc.get;
      var current = null;
      try{ current = realGet ? realGet.call(app) : app.innerHTML; }catch(e){}
      var skipped = false, wrote = false;

      // Temporarily override innerHTML on THIS element only.
      try{
        Object.defineProperty(app, 'innerHTML', {
          configurable:true,
          get:function(){ return realGet ? realGet.call(app) : current; },
          set:function(html){
            wrote = true;
            // If identical to what's shown, skip the DOM write (no shake).
            if(typeof html==='string' && current!=null && html===current){
              skipped = true;
              return;             // ← drop redundant repaint
            }
            realSet.call(app, html);
            current = html;
          }
        });
      }catch(e){ return r.apply(this, arguments); }

      var out;
      try{ out = r.apply(this, arguments); }
      finally{
        // Restore normal innerHTML behaviour on this element.
        try{ delete app.innerHTML; }catch(e){}
        try{
          Object.defineProperty(app, 'innerHTML', desc);
        }catch(e){}
      }
      if(skipped){ try{ window.__v161skips=(window.__v161skips||0)+1; }catch(e){} }
      return out;
    };
    wrapped.__v161 = true;
    // Preserve prior tags so v130/v158/v160 don't endlessly re-wrap.
    wrapped.__coalesced = r.__coalesced;
    wrapped.__v158busy  = r.__v158busy;
    wrapped.__v160      = r.__v160;
    wrapped.now = r.now || function(){ return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }

  wrap();
  [200,800,1500,3000,5000].forEach(function(ms){ setTimeout(wrap, ms); });
  DOMBus.register(wrap);   // stay outermost after later re-wraps

  try{
    console.log('%c✅ v161 No-op Repaint Guard — identical re-renders are dropped (final anti-shake)',
      'background:#1e40af;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/112-d-not-ready-yet-retry-shortly.js ==== */
(function(){
  'use strict';
  if(window.__twhV162) return;
  window.__twhV162 = true;

  var D = window.D;
  if(!D) { /* D not ready yet — retry shortly */ }

  /* Candidate render function name for a module id, several conventions. */
  function candidateFns(id){
    if(!id) return [];
    var cap = id.charAt(0).toUpperCase()+id.slice(1);
    var upper = id.toUpperCase();
    return [
      'render'+cap,               // renderAccounting
      'render'+upper,             // renderHR / renderEMR / renderOR / renderAI / renderCRM
      'render'+cap.replace(/s$/,''), // singular fallback
      'v24Render'+cap             // v24RenderConfig / v24RenderSysAdmin
    ];
  }
  /* Build a lowercase index of every render / v24Render function name on window
     so ids like "assetrequests" resolve to camelCase "renderAssetRequests". */
  var _fnIndex = null;
  function buildFnIndex(){
    _fnIndex = {};
    try{
      Object.getOwnPropertyNames(window).forEach(function(k){
        try{
          if(/^(render|v24Render)/.test(k) && typeof window[k]==='function'){
            _fnIndex[k.toLowerCase()] = k;
          }
        }catch(e){}   // some window props throw on access
      });
    }catch(e){}
  }
  function resolveFn(id){
    var cands = candidateFns(id);
    for(var i=0;i<cands.length;i++){
      if(typeof window[cands[i]]==='function') return cands[i];
    }
    // Case-insensitive fallback: id "assetrequests" -> "renderassetrequests"
    if(!_fnIndex) buildFnIndex();
    var lo = ('render'+id).toLowerCase();
    if(_fnIndex[lo]) return _fnIndex[lo];
    var lo2 = ('v24render'+id).toLowerCase();
    if(_fnIndex[lo2]) return _fnIndex[lo2];
    return null;
  }

  /* (A) Wire every registry module that has a real renderer into V24_RENDERERS. */
  var wiredCount = 0;
  function ensureDispatch(){
    var reg = (window.D && window.D.moduleRegistry) || {};
    var map = window.V24_RENDERERS;
    if(!map || typeof map !== 'object') return;   // v24 not loaded yet
    Object.keys(reg).forEach(function(id){
      if(map[id]) return;                          // already mapped — respect it
      var fn = resolveFn(id);
      if(fn){ map[id] = fn; wiredCount++; }
    });
  }

  /* (B) Grant every enabled module to every seeded role (non-destructive). */
  var grantCount = 0;
  function ensureGrants(){
    var d = window.D;
    if(!d || !d.responsibilities || !d.moduleRegistry) return;
    // Enabled (or locked) modules only — disabled modules stay hidden by design.
    var enabledMods = Object.keys(d.moduleRegistry).filter(function(id){
      var m = d.moduleRegistry[id];
      return m && (m.locked || m.enabled !== false);
    });
    Object.keys(d.responsibilities).forEach(function(role){
      var rr = d.responsibilities[role] = d.responsibilities[role] || {};
      enabledMods.forEach(function(id){
        if(rr[id] !== true){ rr[id] = true; grantCount++; }
      });
    });
    // Always keep dashboard everywhere.
    Object.keys(d.responsibilities).forEach(function(role){
      d.responsibilities[role].dashboard = true;
    });
  }

  function runOnce(){
    _fnIndex = null;   // rebuild each pass so later-loaded renderers are seen
    try{ ensureDispatch(); }catch(e){ try{console.warn('[v162] dispatch',e);}catch(_){}}
    try{ ensureGrants(); }catch(e){ try{console.warn('[v162] grants',e);}catch(_){}}
  }

  // Boot: re-assert across the layered-pack timers, then settle to a slow interval.
  runOnce();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(runOnce, ms); });
  var ticks = 0;
  var iv = setInterval(function(){
    runOnce();
    if(++ticks > 20) clearInterval(iv);   // ~80s of re-assertion is plenty
  }, 4000);

  // Refresh nav once grants settle so newly-granted modules appear immediately.
  setTimeout(function(){
    try{
      if(typeof window.render==='function') window.render();
      if(typeof window.__twhFixSidebar==='function') window.__twhFixSidebar();
    }catch(e){}
  }, 1200);

  window.__twhModuleAudit = function(){
    var reg = (window.D&&window.D.moduleRegistry)||{}, map=window.V24_RENDERERS||{};
    var orphans = Object.keys(reg).filter(function(id){
      return !map[id] && !resolveFn(id);
    });
    return { modules:Object.keys(reg).length, mapped:Object.keys(map).length,
             wired:wiredCount, grants:grantCount, orphans:orphans };
  };

  try{
    console.log('%c✅ v162 Module Access Integrity — all implemented modules wired + granted (dispatch:'+wiredCount+' grants:'+grantCount+')',
      'background:#065f46;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/113-twh-data-integrity-v163.js ==== */
(function(){
  'use strict';
  if(window.__twhV163) return;
  window.__twhV163 = true;

  var CORE_ARRAYS = ['patients','transactions','bills','appointments','medicalRecords',
    'prescriptions','labTests','emergencyCases','beds','pharmacy','inventory',
    'insuranceClaims','creditNotes','dailyCashUp','referrals','departments','doctors'];

  function ensureArrays(){
    var d = window.D; if(!d) return;
    CORE_ARRAYS.forEach(function(k){
      if(!Array.isArray(d[k])) d[k] = [];
    });
  }

  /* Back-generate receipts from paid bills when the ledger is empty. */
  var restoredCount = 0;
  function restoreTransactions(){
    var d = window.D; if(!d || !Array.isArray(d.transactions) || !Array.isArray(d.bills)) return;
    if(d.transactions.length > 0) return;          // ledger not empty — do nothing
    var paidBills = d.bills.filter(function(b){ return b && (+b.paid) > 0; });
    if(!paidBills.length) return;
    var seq = 0;
    paidBills.forEach(function(b){
      seq++;
      d.transactions.push({
        id: (Date.now()%1e9)+seq,
        code: 'TXN-R'+String(seq).padStart(4,'0'),
        type: 'Payment',
        method: b.payMethod || 'Cash',
        patientId: b.patientId || 0,
        amount: +b.paid,
        status: 'Completed',
        date: b.date || (new Date().toISOString().slice(0,10)),
        cashier: 'System (restored)',
        notes: 'Restored from bill '+(b.code||b.id),
        billCode: b.code || null,
        reference: 'RESTORE-'+(b.code||b.id),
        category: 'Restored'
      });
      restoredCount++;
    });
  }

  /* De-duplicate transactions by code (keep first occurrence). */
  function dedupeTransactions(){
    var d = window.D; if(!d || !Array.isArray(d.transactions)) return;
    var seen = {}, out = [];
    d.transactions.forEach(function(t){
      if(!t) return;
      var key = t.code || ('id:'+t.id);
      if(seen[key]) return;
      seen[key] = 1; out.push(t);
    });
    if(out.length !== d.transactions.length){
      d.transactions.length = 0;
      out.forEach(function(t){ d.transactions.push(t); });
    }
  }

  function runOnce(){
    try{ ensureArrays(); }catch(e){}
    try{ restoreTransactions(); }catch(e){}
    try{ dedupeTransactions(); }catch(e){}
  }

  runOnce();
  [0,300,800,1500,3000].forEach(function(ms){ setTimeout(runOnce, ms); });
  var ticks = 0;
  var iv = setInterval(function(){ runOnce(); if(++ticks>15) clearInterval(iv); }, 4000);

  window.__twhDataAudit = function(){
    var d = window.D||{};
    return {
      patients: Array.isArray(d.patients)?d.patients.length:'N/A',
      transactions: Array.isArray(d.transactions)?d.transactions.length:'N/A',
      bills: Array.isArray(d.bills)?d.bills.length:'N/A',
      restored: restoredCount
    };
  };

  try{
    console.log('%c✅ v163 Data Integrity — arrays safe · transactions restored ('+restoredCount+') · deduped',
      'background:#7c2d12;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/114-html-string-sanitiser-collapse-duplicate-payer-c.js ==== */
(function(){
  'use strict';
  if(window.__twhV164) return;
  window.__twhV164 = true;

  /* ---- HTML-string sanitiser: collapse duplicate payer columns to one ---- */
  function sanitizePatientsHTML(html){
    if(typeof html !== 'string') return html;
    try{
      // 1) De-dupe the header: keep a single "HMO / Payer" <th> before Actions.
      //    Remove ALL existing payer headers first, then add exactly one back.
      html = html.replace(/<th>\s*HMO\s*\/\s*Payer\s*<\/th>/gi, '');
      html = html.replace(/(<th>\s*Room\s*<\/th>)(\s*)(<th>\s*Actions\s*<\/th>)/i,
                          '$1<th>HMO / Payer</th>$3');

      // 2) De-dupe payer cells inside each row. A payer cell is a <td> that
      //    contains our shield badge. Collapse any run of >=1 such adjacent
      //    cells (before the action cell) down to the FIRST one only.
      //    Match the injected badge cell shape produced by the inner wrapper.
      var payerTd = /<td>\s*<span class="badge"[^>]*>\s*<i class="fa-solid fa-shield-halved"><\/i>[^<]*<\/span>\s*<\/td>/gi;

      // Split rows and process each independently so we never cross row bounds.
      html = html.replace(/<tr>[\s\S]*?<\/tr>/gi, function(row){
        // find all payer tds in this row
        var matches = row.match(payerTd);
        if(!matches || matches.length <= 1) return row;   // 0 or 1 — fine
        // keep the first, drop the rest
        var seen = false;
        return row.replace(payerTd, function(m){
          if(!seen){ seen = true; return m; }
          return '';   // drop duplicates
        });
      });
    }catch(e){ try{console.warn('[v164] sanitize',e);}catch(_){}}
    return html;
  }

  /* ---- Wrap renderPatients as the outermost layer ---- */
  function wrap(){
    if(typeof window.renderPatients !== 'function') return false;
    if(window.renderPatients.__v164) return true;
    var inner = window.renderPatients;
    var wrapped = function(){
      var html = inner.apply(this, arguments);
      return sanitizePatientsHTML(html);
    };
    wrapped.__v164 = true;
    // preserve prior tags so other packs' feature-detection still works
    if(inner._v131refer) wrapped._v131refer = true;
    if(inner._extWrapped) wrapped._extWrapped = true;
    if(inner._wellWrapped) wrapped._wellWrapped = true;
    window.renderPatients = wrapped;
    return true;
  }

  /* ---- DOM scrub: remove already-rendered duplicate payer cells ---- */
  function scrubDOM(){
    try{
      var tbl = document.getElementById('patTable');
      if(!tbl) return;
      // header: keep one payer th
      var ths = tbl.querySelectorAll('thead th');
      var payerThs = [];
      ths.forEach(function(th){
        if(/HMO\s*\/\s*Payer/i.test(th.textContent)) payerThs.push(th);
      });
      for(var i=1;i<payerThs.length;i++){ payerThs[i].remove(); }
      // rows: keep one payer cell each
      tbl.querySelectorAll('tbody tr').forEach(function(tr){
        var payerCells = [];
        tr.querySelectorAll('td').forEach(function(td){
          var span = td.querySelector('span.badge > i.fa-shield-halved, span.badge i.fa-shield-halved');
          if(span && td.children.length===1) payerCells.push(td);
        });
        for(var j=1;j<payerCells.length;j++){ payerCells[j].remove(); }
      });
    }catch(e){}
  }

  function runOnce(){ wrap(); scrubDOM(); }

  runOnce();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(runOnce, ms); });
  var ticks=0, iv=setInterval(function(){ runOnce(); if(++ticks>20) clearInterval(iv); }, 4000);

  // Also re-wrap after any later pack replaces renderPatients.
  DOMBus.register(function(){ if(window.renderPatients && !window.renderPatients.__v164) wrap(); });

  window.__twhFixPatients = function(){ scrubDOM(); if(typeof render==='function') render(); };

  try{
    console.log('%c✅ v164 Patients Table Repair — single HMO/Payer column enforced (no more duplicate pills)',
      'background:#0f766e;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/115-twh-user-roster-v165.js ==== */
(function(){
  'use strict';
  if(window.__twhV165) return;
  window.__twhV165 = true;

  var ROSTER = [{"username": "admin", "fullName": "Admin", "role": "System Administrator", "password": "12345678", "title": ""}, {"username": "m.atumiye@tranquilhospital.com.ng", "fullName": "M Atumiye", "role": "Doctor", "password": "12345678", "title": ""}, {"username": "Lamido.y", "fullName": "Lamido Y", "role": "Front Desk Officer", "password": "12345678", "title": ""}, {"username": "Rahama.y", "fullName": "Rahama Y", "role": "Front Desk Officer", "password": "12345678", "title": ""}, {"username": "y.lawal@tranquilhospital.com.ng", "fullName": "Y Lawal", "role": "Finance Manager", "password": "12345678", "title": ""}, {"username": "o.uchechukwu@tranquilhospital.com.ng", "fullName": "O Uchechukwu", "role": "Nurse", "password": "12345678", "title": ""}, {"username": "c.aloemezie@tranquilhospital.com.ng", "fullName": "C Aloemezie", "role": "Nurse", "password": "12345678", "title": ""}, {"username": "g.ngwu@tranquilhospital.com.ng", "fullName": "G Ngwu", "role": "Nurse", "password": "12345678", "title": ""}, {"username": "r.agbalu@tranquilhospital.com.ng", "fullName": "R Agbalu", "role": "Nurse", "password": "12345678", "title": ""}, {"username": "Ukamaka.g", "fullName": "Ukamaka G", "role": "Lab Scientist", "password": "12345678", "title": "Head of Lab"}, {"username": "Orah.s", "fullName": "Orah S", "role": "Lab Tech", "password": "12345678", "title": "Lab surbodinate"}, {"username": "m.oyekanmi@tranquilhospital.com.ng", "fullName": "M Oyekanmi", "role": "Nutritionist", "password": "12345678", "title": ""}, {"username": "v.obaji@tranquilhospital.com.ng", "fullName": "V Obaji", "role": "Business Development Manager", "password": "12345678", "title": ""}, {"username": "auditor1", "fullName": "Auditor1", "role": "Auditor", "password": "12345678", "title": ""}, {"username": "c.elujekwute@tranquilhospital.com.ng", "fullName": "C Elujekwute", "role": "Pharmacist", "password": "12345678", "title": "Head of Pharmacy"}, {"username": "Eucharia.a", "fullName": "Eucharia A", "role": "Pharm Tech", "password": "12345678", "title": "Pharm Surbodinate"}];

  function ensureDeptId(role){
    // best-effort department mapping; falls back to 12 (admin/general)
    var map = {'Doctor':1,'Nurse':1,'Front Desk Officer':11,'Finance Manager':11,
      'Lab Scientist':4,'Lab Tech':4,'Nutritionist':1,'Pharmacist':5,'Pharm Tech':5,
      'Auditor':11,'Business Development Manager':12,'System Administrator':12};
    return map[role]||12;
  }

  function seedUsers(){
    var d = window.D; if(!d) return;
    if(!Array.isArray(d.appUsers)) d.appUsers = [];
    var maxId = d.appUsers.reduce(function(m,u){ return Math.max(m, +u.id||0); }, 100);
    ROSTER.forEach(function(r){
      var existing = d.appUsers.find(function(u){
        return (u.username||'').toLowerCase() === r.username.toLowerCase();
      });
      if(existing){
        // keep existing record but make sure role/password/active are correct
        existing.role = r.role;
        if(!existing.password) existing.password = r.password;
        existing.active = true;
        if(r.title && !existing.jobTitle) existing.jobTitle = r.title;
        return;
      }
      d.appUsers.push({
        id: ++maxId,
        username: r.username,
        fullName: r.fullName + (r.title? ' ('+r.title+')' : ''),
        email: (r.username.indexOf('@')>=0? r.username : r.username+'@tranquilhospital.com.ng'),
        phone: '',
        role: r.role,
        jobTitle: r.title||'',
        branchCode: 'LG-MAIN',
        deptId: ensureDeptId(r.role),
        permissions: r.role,
        canApprove: /Manager|Administrator|Head|CEO|CMO/i.test(r.role+' '+(r.title||'')),
        maxApprovalAmt: /Finance Manager/i.test(r.role)? 5000000 : 0,
        lastLogin: '',
        loginCount: 0,
        active: true,
        createdDate: '2026-01-01',
        passwordExpiry: '2027-01-01',
        twoFactor: false,
        password: r.password
      });
    });
  }

  /* ---- Role-specific requirements from the client sheet ---- */
  function applyRoleRules(){
    var d = window.D; if(!d || !d.responsibilities) return;
    d.responsibilities = d.responsibilities || {};
    function grant(role, mods, on){
      d.responsibilities[role] = d.responsibilities[role] || {};
      mods.forEach(function(m){
        if(on===false){ delete d.responsibilities[role][m]; }
        else { d.responsibilities[role][m] = true; }
      });
    }
    // Front Desk Officer: can register (insurance/clients), accept payments,
    // order lab + accept payment; remove AP/AR from menu.
    grant('Front Desk Officer', ['dashboard','patients','appointments','waitlist','queue','billing','transactions','laboratory','radiology','insurance','referrals','reports']);
    grant('Front Desk Officer', ['accounting','bankrecon'], false);
    // Nurse: registered patients visible; NO patient registration right (handled
    // in UI by hiding the Register button); remove AP/AR.
    grant('Nurse', ['dashboard','patients','appointments','waitlist','emr','beds','queue','infection','immunization','dietary','laboratory']);
    grant('Nurse', ['accounting','bankrecon'], false);
    // Lab Scientist (Head of Lab): sees requested tests, verifies Lab Tech
    // requests, lab reports (no finance).
    grant('Lab Scientist', ['dashboard','laboratory','patients','reports']);
    grant('Lab Tech',      ['dashboard','laboratory','patients']);
    // Nutritionist: patient info + dietary + reports.
    grant('Nutritionist',  ['dashboard','patients','emr','dietary','reports']);
    // Business Development Manager: CRM/leads, partners, referrals, reports.
    grant('Business Development Manager', ['dashboard','crm','partners','agents','referrals','appointments','reports','insurance']);
    // Pharmacist / Pharm Tech: pharmacy + prescriptions (+ narcotics for Head).
    grant('Pharmacist', ['dashboard','pharmacy','prescriptions','narcotics','inventory','reports']);
    grant('Pharm Tech', ['dashboard','pharmacy','prescriptions','inventory']);
    // Auditor: audit + reports + accounting (read).
    grant('Auditor', ['dashboard','audit','reports','accounting','compliance']);
    // Finance Manager: full finance suite.
    grant('Finance Manager', ['dashboard','billing','transactions','accounting','bankrecon','budget','cashflow','fxregister','fixedassets','assetrequests','insurance','preauth','reports']);
    // Doctor: full clinical.
    grant('Doctor', ['dashboard','patients','appointments','waitlist','emr','prescriptions','laboratory','radiology','referrals','telemedicine','beds','queue','consent','preauth','reports']);
  }

  function runOnce(){
    try{ seedUsers(); }catch(e){ try{console.warn('[v165] seed',e);}catch(_){}}
    try{ applyRoleRules(); }catch(e){ try{console.warn('[v165] rules',e);}catch(_){}}
  }

  runOnce();
  [0,300,800,1500,3000].forEach(function(ms){ setTimeout(runOnce, ms); });
  var ticks=0, iv=setInterval(function(){ runOnce(); if(++ticks>12) clearInterval(iv); }, 4000);

  window.__twhUserRoster = function(){
    var d=window.D||{}; var names=(d.appUsers||[]).map(function(u){return u.username+' ['+u.role+']';});
    return { total:(d.appUsers||[]).length, seeded:ROSTER.length, users:names };
  };

  try{
    console.log('%c✅ v165 User Roster — '+ROSTER.length+' client staff accounts seeded + role rules applied',
      'background:#4338ca;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/116-twh-role-requirements-v166.js ==== */
(function(){
  "use strict";
  if(window.__twhV166) return; window.__twhV166 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function TOAST(m){ try{ if(typeof toast==='function') toast(m,'err'); }catch(e){} }
  function curRole(){
    try{ var d=D_();
      if(d && d.currentUser && d.currentUser.role) return d.currentUser.role;
    }catch(e){}
    return 'Staff';
  }
  function isFull(){ var r=curRole(); return r==='System Administrator' || r==='CEO' || r==='Admin'; }
  function isFrontDesk(){ return !isFull() && /Front Desk/i.test(curRole()); }
  function isNurse(){ return !isFull() && curRole()==='Nurse'; }

  /* ── (A) NURSE: hide Register-Patient button + block registration ────── */
  function nurseCreateBlocked(){ return isNurse(); }
  function wrapGuards(){
    if(window.addNewRecord && !window.addNewRecord.__v166){
      var _a = window.addNewRecord;
      window.addNewRecord = function(key){
        if(key==='patients' && nurseCreateBlocked()){
          TOAST('Nurses are not permitted to register patients.');
          return;
        }
        return _a.apply(this, arguments);
      };
      window.addNewRecord.__v166 = true;
    }
  }

  /* ── (B) DOM sweep: hide role-inappropriate buttons/KPIs ─────────────── */
  var HIDE_ONCLICK = {
    'Nurse': ["addNewRecord('patients')"]
  };
  function sweepButtons(root){
    try{
      if(isFull()) return;
      var pats = HIDE_ONCLICK[curRole()]; if(!pats || !pats.length) return;
      var nodes = root.querySelectorAll('[onclick]');
      Array.prototype.forEach.call(nodes, function(b){
        var oc = b.getAttribute('onclick') || '';
        for(var i=0;i<pats.length;i++){
          if(oc.indexOf(pats[i])>=0){ b.style.display='none'; break; }
        }
      });
    }catch(e){}
  }

  /* Front-Desk dashboard: hide Revenue / Pending bill / Stock alert KPI cards.
     KPI cards are matched by their visible label text. */
  var FD_HIDE_LABELS = [/revenue/i, /pending\s*bill/i, /stock\s*alert/i, /low\s*stock/i];
  function sweepFrontDeskKpis(root){
    try{
      if(!isFrontDesk()) return;
      // Only touch the dashboard view.
      var cards = root.querySelectorAll('.kpi, .stat-card, .kpi-card, .card, .metric, [class*="kpi"]');
      Array.prototype.forEach.call(cards, function(c){
        var t = (c.textContent||'');
        for(var i=0;i<FD_HIDE_LABELS.length;i++){
          if(FD_HIDE_LABELS[i].test(t)){
            // hide the smallest reasonable container (the card itself)
            c.style.display='none';
            return;
          }
        }
      });
    }catch(e){}
  }

  /* Rename "Insurance Provider(s)" wording to "Clients" for org-agnostic use. */
  function relabelInsuranceToClients(root){
    try{
      if(isFull()) return;                 // admins keep original terminology
      if(!isFrontDesk()) return;           // requirement raised by Front Desk
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n, changed=[];
      while((n=walker.nextNode())){
        if(/Insurance Provider/i.test(n.nodeValue)){
          changed.push(n);
        }
      }
      changed.forEach(function(n){
        n.nodeValue = n.nodeValue
          .replace(/Insurance Providers/gi, 'Clients')
          .replace(/Insurance Provider/gi, 'Client');
      });
    }catch(e){}
  }

  /* ── (C) Patients list: ascending / descending sort toggle ───────────── */
  window.__twhPatSortDir = window.__twhPatSortDir || 'asc';
  window.twhTogglePatientSort = function(){
    window.__twhPatSortDir = (window.__twhPatSortDir==='asc') ? 'desc' : 'asc';
    sortPatientTable();
    // update button label if present
    var btn = document.getElementById('twhPatSortBtn');
    if(btn){
      btn.innerHTML = '<i class="fa-solid fa-arrow-down-'+(window.__twhPatSortDir==='asc'?'a-z':'z-a')+'"></i> Sort '+(window.__twhPatSortDir==='asc'?'A→Z':'Z→A');
    }
  };
  function sortPatientTable(){
    try{
      var tbl = document.getElementById('patTable');
      if(!tbl) return;
      var tb = tbl.tBodies && tbl.tBodies[0]; if(!tb) return;
      var rows = Array.prototype.slice.call(tb.rows).filter(function(r){ return r.cells && r.cells.length>1; });
      // Sort by the Patient/Name column (2nd cell, index 1).
      rows.sort(function(a,b){
        var ta=(a.cells[1]?a.cells[1].textContent:'').trim().toLowerCase();
        var tbb=(b.cells[1]?b.cells[1].textContent:'').trim().toLowerCase();
        if(ta<tbb) return window.__twhPatSortDir==='asc'?-1:1;
        if(ta>tbb) return window.__twhPatSortDir==='asc'?1:-1;
        return 0;
      });
      rows.forEach(function(r){ tb.appendChild(r); });
    }catch(e){}
  }
  function injectSortButton(root){
    try{
      // v308 (pack 104) OWNS the Sort A→Z + Recent First buttons and docks BOTH
      // directly into the toolbar's right-hand action group, in a fixed order,
      // synchronously. If v308 is present we must NOT create our own separate
      // right-aligned bar above the table — that bar (then relocated by v308)
      // was the source of the visible toolbar shake/blink on every render. Let
      // v308 build the Sort A→Z button in its final place instead.
      if (window.__twhV308) return;
      var tbl = (root||document).querySelector('#patTable');
      if(!tbl) return;
      if(document.getElementById('twhPatSortBtn')) return;   // already there
      // place button near the Register/toolbar area if we can find it, else above table
      var host = tbl.parentNode;
      var bar = document.createElement('div');
      bar.style.cssText='margin:0 0 8px 0;text-align:right';
      var b = document.createElement('button');
      b.id='twhPatSortBtn';
      b.className='btn btn-sm';
      b.style.cssText='background:#0d9488;color:#fff';
      b.innerHTML='<i class="fa-solid fa-arrow-down-a-z"></i> Sort '+(window.__twhPatSortDir==='asc'?'A→Z':'Z→A');
      b.onclick=window.twhTogglePatientSort;
      bar.appendChild(b);
      if(host) host.insertBefore(bar, tbl);
    }catch(e){}
  }

  /* ── wiring ──────────────────────────────────────────────────────────── */
  function runAll(){
    try{ wrapGuards(); }catch(e){}
    var root = document.getElementById('moduleContent') || document.body;
    if(!root) return;
    try{ sweepButtons(root); }catch(e){}
    try{ sweepFrontDeskKpis(root); }catch(e){}
    try{ relabelInsuranceToClients(root); }catch(e){}
    try{ injectSortButton(root); }catch(e){}
  }

  if(window.render && !window.render.__v166){
    var _r = window.render;
    window.render = function(){ var out=_r.apply(this, arguments); try{ setTimeout(runAll,0); }catch(e){} return out; };
    window.render.__v166 = true;
  }
  try{
    var mo = DOMBus.__mo(function(){ runAll(); });
    var target = document.getElementById('moduleContent') || document.body;
    if(target) mo.observe(target, {childList:true, subtree:true});
  }catch(e){}

  runAll();
  [300,1000,2200,4000,6500].forEach(function(t){ setTimeout(runAll, t); });

  window.__twhRoleReq = function(){ return { role:curRole(), sortDir:window.__twhPatSortDir, frontDesk:isFrontDesk(), nurse:isNurse() }; };

  try{
    console.log('%c✅ v166 — Client role requirements: Nurse −Register · Front Desk −Revenue/PendingBill/StockAlert KPIs + Insurance→Clients + patient sort toggle',
      'background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/117-twh-role-dashboards-v167.js ==== */
(function(){
  "use strict";
  if(window.__twhV167) return; window.__twhV167 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function role(){ var d=D_(); return (d.currentUser&&d.currentUser.role)||'Staff'; }
  function name(){ var d=D_(); return (d.currentUser&&d.currentUser.fullName)||'User'; }
  function isFull(){ var r=role(); return r==='System Administrator'||r==='CEO'||r==='Admin'; }
  function money(n){ n=+n||0; try{ if(typeof F==='function') return F(n); }catch(e){} return '₦'+Math.round(n).toLocaleString(); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function A(x){ return Array.isArray(x)?x:[]; }
  function td(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10);} }

  function kpi(label,val,grad,icon,sub){
    return '<div class="kpi" style="background:linear-gradient(135deg,'+grad+');color:#fff;border-radius:14px;padding:16px 18px;min-width:150px;flex:1">'
      +'<div style="display:flex;justify-content:space-between;align-items:flex-start">'
      +'<div><div style="font-size:12px;opacity:.9">'+esc(label)+'</div>'
      +'<div style="font-size:26px;font-weight:800;margin-top:4px">'+val+'</div>'
      +(sub?'<div style="font-size:11px;opacity:.85;margin-top:2px">'+esc(sub)+'</div>':'')+'</div>'
      +'<i class="fa-solid '+icon+'" style="font-size:26px;opacity:.5"></i></div></div>';
  }
  function tile(mod,label,icon,grad){
    return '<button class="btn" style="display:flex;flex-direction:column;align-items:center;gap:7px;padding:16px 12px;min-width:120px;border:0;border-radius:14px;background:linear-gradient(135deg,'+grad+');color:#fff;cursor:pointer" onclick="goTo(\''+mod+'\')">'
      +'<i class="fa-solid '+icon+'" style="font-size:20px"></i><span style="font-size:12px;font-weight:700">'+esc(label)+'</span></button>';
  }
  function actionBtn(label,icon,onclick,grad){
    return '<button class="btn btn-sm" style="background:linear-gradient(135deg,'+grad+');color:#fff" onclick="'+onclick+'"><i class="fa-solid '+icon+'"></i> '+esc(label)+'</button>';
  }

  function head(title,subtitle,actions){
    return '<div class="card" style="background:linear-gradient(135deg,#0d9488,#0891b2);color:#fff;margin-bottom:16px;border-radius:16px">'
      +'<div class="card-hd" style="border:0"><h3 style="color:#fff;margin:0"><i class="fa-solid fa-gauge-high" style="margin-right:8px"></i>'+esc(title)+'</h3></div>'
      +'<p style="color:#e0f2fe;font-size:12.5px;margin:2px 0 0">'+esc(subtitle)+'</p>'
      +(actions?'<div style="margin-top:14px;display:flex;gap:8px;flex-wrap:wrap">'+actions+'</div>':'')
      +'</div>';
  }
  function grid(cards){ return '<div class="kpi-grid" style="display:flex;flex-wrap:wrap;gap:14px;margin-bottom:18px">'+cards.join('')+'</div>'; }
  function tileWrap(tiles){
    return '<div class="card" style="border-radius:16px"><div class="card-hd"><h3><i class="fa-solid fa-grip" style="color:var(--pri);margin-right:8px"></i>Quick Access</h3></div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:12px">'+tiles.join('')+'</div></div>';
  }

  /* ── per-role dashboards ────────────────────────────────────────────── */
  function frontDesk(d){
    var pts=A(d.patients);
    var t=td();
    var todayReg=pts.filter(function(p){return (p.registeredDate||p.createdDate||p.regDate)===t;}).length;
    var appts=A(d.appointments); var todayAppt=appts.filter(function(a){return a.date===t;}).length;
    var q=A(d.queue||d.waitlist).length;
    // NOTE: Revenue / Pending-bill / Stock-alert intentionally excluded (client requirement)
    var cards=[
      kpi('Total Patients',pts.length,'#1e40af,#3b82f6','fa-user-injured',todayReg+' registered today'),
      kpi("Today's Appointments",todayAppt,'#0d9488,#14b8a6','fa-calendar-check',appts.filter(function(a){return a.status==='Scheduled';}).length+' scheduled'),
      kpi('In Queue',q,'#7c3aed,#8b5cf6','fa-people-line','waiting to be seen')
    ];
    var actions=[
      actionBtn('Register Patient','fa-user-plus',"addNewRecord('patients')",'#2563eb,#3b82f6'),
      actionBtn('Book Appointment','fa-calendar-plus',"goTo('appointments')",'#0d9488,#14b8a6'),
      actionBtn('Accept Payment','fa-cash-register',"goTo('billing')",'#059669,#10b981'),
      actionBtn('Order Lab Test','fa-flask',"goTo('laboratory')",'#0891b2,#06b6d4')
    ].join(' ');
    var tiles=[
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6'),
      tile('billing','Billing','fa-file-invoice','#059669,#10b981'),
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('insurance','Clients','fa-hand-holding-heart','#be185d,#ec4899')
    ];
    return head('Front Desk Dashboard','Welcome '+name()+' — register patients, book appointments, take payments.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function nurse(d){
    var pts=A(d.patients);
    var admitted=pts.filter(function(p){return p.status==='Admitted';}).length;
    var beds=A(d.beds); var occ=beds.filter(function(b){return b.status==='Occupied';}).length;
    var vitalsDue=admitted; // simplistic: all admitted patients need vitals rounds
    var cards=[
      kpi('Admitted Patients',admitted,'#1e40af,#3b82f6','fa-bed-pulse','under nursing care'),
      kpi('Beds Occupied',occ+' / '+beds.length,'#b45309,#f59e0b','fa-bed',''),
      kpi('Vitals Rounds',vitalsDue,'#0891b2,#06b6d4','fa-heart-pulse','patients to round')
    ];
    // Nurses may NOT register patients (client requirement) — no register action.
    var actions=[
      actionBtn('Record Vitals','fa-heart-pulse',"goTo('emr')",'#0891b2,#06b6d4'),
      actionBtn('View Patients','fa-user-injured',"goTo('patients')",'#1e40af,#3b82f6'),
      actionBtn('Bed Board','fa-bed',"goTo('beds')",'#b45309,#f59e0b')
    ].join(' ');
    var tiles=[
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6'),
      tile('emr','Clinical Notes','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('beds','Beds','fa-bed','#b45309,#f59e0b'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6')
    ];
    return head('Nurse Dashboard','Welcome '+name()+' — patient care, vitals and ward management. (Patient registration is handled by Front Desk.)',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function doctor(d){
    var pts=A(d.patients);
    var t=td();
    var myAppt=A(d.appointments).filter(function(a){return a.date===t;}).length;
    var labs=A(d.labTests); var pendLab=labs.filter(function(l){return l.status!=='Completed';}).length;
    var rx=A(d.prescriptions).length;
    // Medical records the doctor cares about: their OWN clinical records
    // (scoped by doctorId → this user's linked employee id), plus how many were
    // opened today. Counted from the LIVE D.medicalRecords so records created
    // via the standalone EMR page are always reflected. If we cannot resolve the
    // doctor's employee id (or scoping yields nothing while records DO exist),
    // we gracefully fall back to the whole set so the KPI is never misleadingly
    // empty. (M3: role-scoping with safe fallback.)
    var allRecs=A(d.medicalRecords);
    var myEmpId=null;
    try{ var uo=(typeof window.currentUserObj==='function')?window.currentUserObj():null; if(uo&&uo.employeeId!=null) myEmpId=uo.employeeId; }catch(e){}
    var recs=allRecs;
    var scopedLabel='Medical Records';
    if(myEmpId!=null){
      var mine=allRecs.filter(function(r){return String(r.doctorId)===String(myEmpId);});
      if(mine.length){ recs=mine; scopedLabel='My Medical Records'; }
    }
    var recsTotal=recs.length;
    var recsToday=recs.filter(function(r){return (r.visitDate||r.createdDate||r.date)===t;}).length;
    var recsOpen=recs.filter(function(r){return r.status==='Open';}).length;
    var cards=[
      kpi(scopedLabel,recsTotal,'#7c3aed,#8b5cf6','fa-file-medical',(recsToday+' today · '+recsOpen+' open')),
      kpi("Today's Consultations",myAppt,'#0d9488,#14b8a6','fa-stethoscope','on your schedule'),
      kpi('Lab Results',labs.length,'#0891b2,#06b6d4','fa-flask',pendLab+' awaiting'),
      kpi('Prescriptions',rx,'#be185d,#ec4899','fa-prescription',''),
      kpi('Active Patients',pts.filter(function(p){return p.status!=='Discharged';}).length,'#1e40af,#3b82f6','fa-user-injured','')
    ];
    var actions=[
      actionBtn('Open EMR','fa-file-medical',"goTo('emr')",'#7c3aed,#8b5cf6'),
      actionBtn('Request Lab','fa-flask',"goTo('laboratory')",'#0891b2,#06b6d4'),
      actionBtn('Prescribe','fa-prescription',"goTo('prescriptions')",'#be185d,#ec4899'),
      actionBtn('Radiology','fa-x-ray',"goTo('radiology')",'#475569,#64748b')
    ].join(' ');
    var tiles=[
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6'),
      tile('emr','EMR','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('prescriptions','Prescriptions','fa-prescription','#be185d,#ec4899'),
      tile('radiology','Radiology','fa-x-ray','#475569,#64748b'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6')
    ];
    return head('Doctor Dashboard','Welcome '+name()+' — clinical care, orders and results.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function lab(d,isHead){
    var labs=A(d.labTests);
    var pend=labs.filter(function(l){return l.status!=='Completed';}).length;
    var abn=labs.filter(function(l){return l.isAbnormal;}).length;
    var toVerify=labs.filter(function(l){return l.status==='Awaiting Verification'||l.status==='Pending Verification';}).length;
    var cards=[
      kpi('Test Requests',labs.length,'#0891b2,#06b6d4','fa-flask',pend+' pending'),
      kpi('Abnormal Results',abn,'#dc2626,#f87171','fa-triangle-exclamation','flagged'),
      kpi(isHead?'Awaiting Verification':'My Tests',isHead?toVerify:pend,'#7c3aed,#8b5cf6','fa-clipboard-check',isHead?'to verify':'assigned')
    ];
    var actions=[
      actionBtn('Enter Results','fa-vial-circle-check',"goTo('laboratory')",'#0891b2,#06b6d4'),
      actionBtn('View Patients','fa-user-injured',"goTo('patients')",'#1e40af,#3b82f6')
    ];
    if(isHead) actions.push(actionBtn('Lab Reports','fa-chart-column',"goTo('reports')",'#0d9488,#14b8a6'));
    var tiles=[
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6')
    ];
    if(isHead) tiles.push(tile('reports','Reports','fa-chart-column','#0d9488,#14b8a6'));
    return head((isHead?'Head of Lab':'Lab Technician')+' Dashboard',
        'Welcome '+name()+' — front-desk requested tests appear here'+(isHead?'; verify technician requests and produce lab reports.':'.'),
        actions.join(' '))
      +grid(cards)+tileWrap(tiles);
  }

  function pharmacy(d,isHead){
    var ph=A(d.pharmacy);
    var low=ph.filter(function(p){return (p.stock||0)<=(p.minStock||0);}).length;
    var rx=A(d.prescriptions);
    var pendRx=rx.filter(function(r){return r.status!=='Dispensed'&&r.status!=='Completed';}).length;
    var cards=[
      kpi('Prescriptions',rx.length,'#be185d,#ec4899','fa-prescription',pendRx+' to dispense'),
      kpi('Pharmacy Items',ph.length,'#059669,#10b981','fa-pills',low+' low stock'),
      kpi('Low Stock Alerts',low,'#dc2626,#f87171','fa-triangle-exclamation','need reorder')
    ];
    var actions=[
      actionBtn('Dispense','fa-prescription-bottle-medical',"goTo('prescriptions')",'#be185d,#ec4899'),
      actionBtn('Stock','fa-boxes-stacked',"goTo('pharmacy')",'#059669,#10b981')
    ];
    if(isHead) actions.push(actionBtn('Inventory','fa-warehouse',"goTo('inventory')",'#0d9488,#14b8a6'));
    var tiles=[
      tile('pharmacy','Pharmacy','fa-pills','#059669,#10b981'),
      tile('prescriptions','Prescriptions','fa-prescription','#be185d,#ec4899')
    ];
    if(isHead){ tiles.push(tile('inventory','Inventory','fa-warehouse','#0d9488,#14b8a6')); }
    return head((isHead?'Head of Pharmacy':'Pharmacy Technician')+' Dashboard',
        'Welcome '+name()+' — dispense prescriptions and manage drug stock.',actions.join(' '))
      +grid(cards)+tileWrap(tiles);
  }

  function nutritionist(d){
    var pts=A(d.patients);
    var na=A(d.nutritionAssessments);
    var diet=A(d.dietaryOrders);
    var cards=[
      kpi('Nutrition Assessments',na.length,'#f59e0b,#fbbf24','fa-clipboard-list','completed'),
      kpi('Diet Orders',diet.length,'#0d9488,#14b8a6','fa-utensils','active'),
      kpi('Patients',pts.length,'#1e40af,#3b82f6','fa-user-injured','on record')
    ];
    var actions=[
      actionBtn('New Assessment','fa-clipboard-list',"goTo('dietary');setTimeout(function(){window.dietSetTab&&window.dietSetTab('assess');},80)",'#f59e0b,#fbbf24'),
      actionBtn('Nutrition Reports','fa-chart-pie',"goTo('dietary');setTimeout(function(){window.dietSetTab&&window.dietSetTab('reports');},80)",'#0891b2,#06b6d4'),
      actionBtn('View Patients','fa-user-injured',"goTo('patients')",'#1e40af,#3b82f6')
    ].join(' ');
    var tiles=[
      tile('dietary','Dietary','fa-utensils','#0d9488,#14b8a6'),
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6'),
      tile('emr','Medical Records','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('reports','Reports','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Nutritionist Dashboard','Welcome '+name()+' — nutrition assessments, diet orders and outcomes.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function bdm(d){
    var leads=A(d.crmLeads||d.leads);
    var partners=A(d.partners);
    var refs=A(d.referrals);
    var cards=[
      kpi('Leads',leads.length,'#7c3aed,#8b5cf6','fa-bullseye','in pipeline'),
      kpi('Corporate Clients',partners.length,'#be185d,#ec4899','fa-building','partnerships'),
      kpi('Referrals',refs.length,'#0d9488,#14b8a6','fa-share-nodes','tracked')
    ];
    var actions=[
      actionBtn('New Lead','fa-bullseye',"goTo('crm')",'#7c3aed,#8b5cf6'),
      actionBtn('Manage Clients','fa-building',"goTo('partners')",'#be185d,#ec4899'),
      actionBtn('BD Reports','fa-chart-line',"goTo('reports')",'#0891b2,#06b6d4')
    ].join(' ');
    var tiles=[
      tile('crm','CRM / Leads','fa-bullseye','#7c3aed,#8b5cf6'),
      tile('partners','Partners','fa-handshake','#be185d,#ec4899'),
      tile('referrals','Referrals','fa-share-nodes','#0d9488,#14b8a6'),
      tile('reports','Reports','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Business Development Dashboard','Welcome '+name()+' — leads, corporate clients and partnerships.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function auditor(d){
    var log=A(d.auditLog);
    var highRisk=log.filter(function(l){return /high/i.test(l.risk||'');}).length;
    var tx=A(d.transactions);
    var cards=[
      kpi('Audit Events',log.length,'#475569,#64748b','fa-clipboard-check','logged'),
      kpi('High-Risk Events',highRisk,'#dc2626,#f87171','fa-triangle-exclamation','flagged'),
      kpi('Transactions',tx.length,'#059669,#10b981','fa-receipt','reviewable')
    ];
    var actions=[
      actionBtn('Audit Trail','fa-clipboard-check',"goTo('audit')",'#475569,#64748b'),
      actionBtn('Compliance','fa-shield-halved',"goTo('compliance')",'#0d9488,#14b8a6'),
      actionBtn('Reports','fa-chart-column',"goTo('reports')",'#0891b2,#06b6d4')
    ].join(' ');
    var tiles=[
      tile('audit','Audit Trail','fa-clipboard-check','#475569,#64748b'),
      tile('compliance','Compliance','fa-shield-halved','#0d9488,#14b8a6'),
      tile('reports','Reports','fa-chart-column','#0891b2,#06b6d4'),
      tile('accounting','Accounting','fa-calculator','#059669,#10b981')
    ];
    return head('Auditor Dashboard','Welcome '+name()+' — audit trail, compliance and financial review.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  function financeManager(d){
    var bills=A(d.bills);
    var ar=bills.reduce(function(s,b){return s+(+b.balance||0);},0);
    var tx=A(d.transactions);
    var revenue=tx.filter(function(t){return (+t.amount||0)>0;}).reduce(function(s,t){return s+(+t.amount||0);},0);
    var claims=A(d.insuranceClaims);
    var cards=[
      kpi('Total Revenue',money(revenue),'#059669,#10b981','fa-sack-dollar','recognised'),
      kpi('Outstanding AR',money(ar),'#991b1b,#ef4444','fa-file-invoice-dollar',bills.filter(function(b){return (+b.balance||0)>0;}).length+' open bills'),
      kpi('Transactions',tx.length,'#1e40af,#3b82f6','fa-receipt',''),
      kpi('Insurance Claims',claims.length,'#7c3aed,#8b5cf6','fa-hand-holding-dollar',claims.filter(function(c){return c.status==='Submitted';}).length+' pending')
    ];
    var actions=[
      actionBtn('Billing','fa-file-invoice',"goTo('billing')",'#059669,#10b981'),
      actionBtn('Accounting','fa-calculator',"goTo('accounting')",'#1e40af,#3b82f6'),
      actionBtn('Bank Recon','fa-building-columns',"goTo('bankrecon')",'#0d9488,#14b8a6'),
      actionBtn('Reports','fa-chart-column',"goTo('reports')",'#0891b2,#06b6d4')
    ].join(' ');
    var tiles=[
      tile('billing','Billing','fa-file-invoice','#059669,#10b981'),
      tile('transactions','Transactions','fa-receipt','#1e40af,#3b82f6'),
      tile('accounting','Accounting','fa-calculator','#7c3aed,#8b5cf6'),
      tile('bankrecon','Bank Recon','fa-building-columns','#0d9488,#14b8a6'),
      tile('insurance','Insurance','fa-hand-holding-dollar','#be185d,#ec4899'),
      tile('reports','Reports','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Finance Manager Dashboard','Welcome '+name()+' — revenue, receivables, accounting and claims.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  var TITLE = function(d){
    var r=role(); var jt=(d.currentUser&&d.currentUser.jobTitle)||'';
    switch(r){
      case 'Front Desk Officer': return frontDesk(d);
      case 'Nurse': return nurse(d);
      case 'Doctor': return doctor(d);
      case 'Lab Scientist': return lab(d, true);
      case 'Lab Tech': return lab(d, false);
      case 'Pharmacist': return pharmacy(d, true);
      case 'Pharm Tech': return pharmacy(d, false);
      case 'Nutritionist': return nutritionist(d);
      case 'Business Development Manager': return bdm(d);
      case 'Auditor': return auditor(d);
      case 'Finance Manager': return financeManager(d);
      default: return null;
    }
  };

  function buildRoleDashboard(){
    try{
      if(isFull()) return null;              // admins use full dashboard
      var d=D_(); if(!d) return null;
      return TITLE(d);
    }catch(e){ return null; }
  }

  function wrap(){
    if(window.renderDashboard && !window.renderDashboard.__v167){
      var _d = window.renderDashboard;
      window.renderDashboard = function(){
        var custom = buildRoleDashboard();
        if(custom!=null) return custom;
        return _d.apply(this, arguments);
      };
      window.renderDashboard.__v167 = true;
      // preserve any earlier flags
      window.renderDashboard.__rbac = _d.__rbac;
    }
  }

  wrap();
  if(window.render && !window.render.__v167){
    var _r=window.render;
    window.render=function(){ try{ wrap(); }catch(e){} return _r.apply(this,arguments); };
    window.render.__v167=true;
  }
  if(window.doLogin && !window.doLogin.__v167){
    var _dl=window.doLogin;
    window.doLogin=function(){ var out=_dl.apply(this,arguments); try{ wrap(); }catch(e){} return out; };
    window.doLogin.__v167=true;
  }
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(wrap, ms); });
  var ticks=0, iv=setInterval(function(){ wrap(); if(++ticks>8) clearInterval(iv); }, 4000);

  window.__twhRoleDash = function(){ return { role:role(), hasCustom: buildRoleDashboard()!=null }; };

  try{
    console.log('%c✅ v167 — Role-tailored dashboards for 11 client roles','background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/118-twh-wellness-consultant-v168.js ==== */
(function(){
  "use strict";
  if(window.__twhV168) return; window.__twhV168 = true;

  var WELLNESS_EMAIL = 'm.oyekanmi@tranquilhospital.com.ng';
  var WELLNESS_NAME  = 'Miracle Oyekanmi';

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }

  /* find (or fall back for) the Wellness / Nutrition department id */
  function wellnessDeptId(d){
    var depts = Array.isArray(d.departments)? d.departments : [];
    var m = depts.find(function(x){ return /wellness|nutrition/i.test((x.name||'')+' '+(x.code||'')); });
    return m ? m.id : (depts.length?depts[0].id:13);
  }

  /* ── (1) Register Miracle Oyekanmi as a Wellness Clinic consultant ────── */
  function ensureWellnessConsultant(){
    var d = D_(); if(!d) return;
    if(!Array.isArray(d.employees)) d.employees = [];

    var deptId = wellnessDeptId(d);
    var existing = d.employees.find(function(e){
      return (e.email||'').toLowerCase()===WELLNESS_EMAIL ||
             /oyekanmi/i.test(e.fullName||'') ||
             /oyekanmi/i.test((e.firstName||'')+' '+(e.lastName||''));
    });

    if(existing){
      // upgrade the existing record to an active wellness consultant clinician
      existing.type = 'Doctor';                 // makes her appear in clinician selectors
      existing.status = 'Active';
      existing.position = 'Consultant — Wellness Clinic';
      if(!existing.specialization || /nutrition/i.test(existing.specialization)) existing.specialization = 'Wellness Consultant';
      existing.deptId = deptId;
      if(!existing.fullName) existing.fullName = WELLNESS_NAME;
      if(!existing.email) existing.email = WELLNESS_EMAIL;
      existing.isWellnessConsultant = true;
      return existing;
    }

    var maxId = d.employees.reduce(function(m,e){ return Math.max(m, +e.id||0); }, 0);
    var emp = {
      id: maxId+1,
      code: 'E-WLN-01',
      firstName: 'Miracle',
      lastName: 'Oyekanmi',
      fullName: WELLNESS_NAME,
      position: 'Consultant — Wellness Clinic',
      deptId: deptId,
      type: 'Doctor',                 // clinician type → selectable as consultant
      status: 'Active',
      specialization: 'Wellness Consultant',
      email: WELLNESS_EMAIL,
      phone: '',
      gender: 'Female',
      hireDate: '2026-01-01',
      contractType: 'Permanent',
      grade: 'L7',
      reportsTo: null,
      basicPct:60, housingPct:15, transportPct:10, medicalPct:8, utilityPct:7,
      isWellnessConsultant: true
    };
    d.employees.push(emp);
    return emp;
  }

  /* Also make sure her appUser record links to the clinician (deptId + jobTitle) */
  function linkAppUser(){
    var d = D_(); if(!d || !Array.isArray(d.appUsers)) return;
    var u = d.appUsers.find(function(x){ return (x.username||'').toLowerCase()===WELLNESS_EMAIL || (x.email||'').toLowerCase()===WELLNESS_EMAIL; });
    if(u){
      if(!u.jobTitle) u.jobTitle = 'Consultant — Wellness Clinic';
      u.isWellnessConsultant = true;
    }
  }

  /* ── (2) Sidebar role display: keep each user's role text correct ─────── */
  function fixSidebarRole(){
    var d = D_(); if(!d || !d.currentUser) return;
    try{
      document.querySelectorAll('.sb-user').forEach(function(el){
        var want = d.currentUser.fullName || 'User';
        if(el.textContent.indexOf("D.currentUser")>=0 || el.textContent.trim()!==want) el.textContent = want;
      });
      document.querySelectorAll('.sb-role').forEach(function(el){
        var want = d.currentUser.role || '';
        if(el.textContent.indexOf("D.currentUser")>=0 || el.textContent.trim()!==want) el.textContent = want;
      });
    }catch(e){}
  }

  function runOnce(){
    try{ ensureWellnessConsultant(); }catch(e){ try{console.warn('[v168] consultant',e);}catch(_){}}
    try{ linkAppUser(); }catch(e){}
    try{ fixSidebarRole(); }catch(e){}
  }

  // wire after render, on login, and on timers
  if(window.render && !window.render.__v168){
    var _r=window.render;
    window.render=function(){ var out=_r.apply(this,arguments); try{ setTimeout(runOnce,0); }catch(e){} return out; };
    window.render.__v168=true;
  }
  if(window.doLogin && !window.doLogin.__v168){
    var _dl=window.doLogin;
    window.doLogin=function(){ var out=_dl.apply(this,arguments); try{ runOnce(); }catch(e){} return out; };
    window.doLogin.__v168=true;
  }
  try{
    var mo=DOMBus.__mo(function(){ fixSidebarRole(); });
    if(document.body) mo.observe(document.body,{childList:true,subtree:true});
  }catch(e){}

  runOnce();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(runOnce, ms); });
  var ticks=0, iv=setInterval(function(){ runOnce(); if(++ticks>10) clearInterval(iv); }, 4000);

  window.__twhWellness = function(){
    var d=D_()||{}; var e=(d.employees||[]).find(function(x){return (x.email||'').toLowerCase()===WELLNESS_EMAIL;});
    return { consultant: e? {name:e.fullName, type:e.type, status:e.status, spec:e.specialization, deptId:e.deptId} : null,
             clinicianCount:(d.employees||[]).filter(function(x){return x.type==='Doctor'&&x.status==='Active';}).length };
  };

  try{
    console.log('%c✅ v168 — Miracle Oyekanmi registered as Wellness Clinic consultant + sidebar role display locked',
      'background:#0e7490;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  }catch(e){}
})();

;

/* ==== /js/119-idempotent-4.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV169) return;            // idempotent
  window.__twhV169 = true;

  function D(){ return window.D || (window.D = {}); }
  function ready(fn){
    var d = window.D;
    if(d && d.employees && d.moduleRegistry){ fn(); }
    else setTimeout(function(){ ready(fn); }, 150);
  }

  /* =========================================================================
     PART 1 — FIX EMPLOYEE-TO-DEPARTMENT DISPLAY (Screenshot 1)
     Root cause: dName(id) resolved an EMPLOYEE (doc/id) instead of a DEPARTMENT.
     e.g. Yusuf Lawal deptId=11 -> employee #11 "Orah Simon Endurance".
     Fix: dName resolves the department name; also tolerate deptCode / name.
     ========================================================================= */
  function resolveDeptName(id){
    try{
      var d = D();
      if(id==null || id==='') return '\u2014';
      var list = d.departments || [];
      var dep = list.filter(function(x){ return x.id===id || x.id===+id || String(x.id)===String(id); })[0];
      if(!dep){ dep = list.filter(function(x){ return x.code===id || x.name===id; })[0]; }
      return dep ? (dep.name || dep.code || '\u2014') : '\u2014';
    }catch(e){ return '\u2014'; }
  }
  // Force-override dName globally (later scripts may reference it).
  try{ window.dName = resolveDeptName; }catch(e){}

  /* =========================================================================
     PART 2 — REPAIR MODULE REGISTRY (Screenshot 3: "\u2014" labels in "Other")
     Root cause: several modules were persisted into D.moduleRegistry as bare
     { enabled:true, subModules:{} } with NO id/label/group/icon (or with the
     wrong keys name/category). The sidebar / SysAdmin table read m.label,
     m.group, m.icon => "\u2014" and everything dumped into "Other".
     Fix: backfill every registry entry from a canonical id->meta map.
     ========================================================================= */
  var CANON = {
    /* Core */
    dashboard:{g:'Core',l:'Dashboard',i:'fa-home',lock:true},
    /* Clinical */
    patients:{g:'Clinical',l:'Patients',i:'fa-user-injured'},
    appointments:{g:'Clinical',l:'Appointments',i:'fa-calendar-check'},
    calendar:{g:'Clinical',l:'Appointment Calendar',i:'fa-calendar-alt'},
    waitlist:{g:'Clinical',l:'Appointment Waitlist',i:'fa-hourglass-half'},
    emr:{g:'Clinical',l:'Medical Records',i:'fa-file-medical'},
    prescriptions:{g:'Clinical',l:'Prescriptions',i:'fa-prescription'},
    laboratory:{g:'Clinical',l:'Laboratory',i:'fa-flask'},
    radiology:{g:'Clinical',l:'Radiology',i:'fa-x-ray'},
    referrals:{g:'Clinical',l:'Referral Mgmt',i:'fa-share-square'},
    physio:{g:'Clinical',l:'Physiotherapy',i:'fa-person-walking'},
    reflexrules:{g:'Clinical',l:'Lab Reflex Rules',i:'fa-diagram-project'},
    wellness:{g:'Clinical',l:'Wellness Screening',i:'fa-heart-pulse'},
    mealplanner:{g:'Clinical',l:'Meal Planner',i:'fa-utensils'},
    nutrition:{g:'Clinical',l:'Dietary Nutrient Calc',i:'fa-bowl-food'},
    /* Operations */
    beds:{g:'Operations',l:'Bed Management',i:'fa-bed'},
    pharmacy:{g:'Operations',l:'Pharmacy',i:'fa-pills'},
    pharmacyplus:{g:'Operations',l:'Pharmacy \u2014 Clinical & Operations',i:'fa-prescription'},
    pharmbatch:{g:'Operations',l:'Pharmacy Batches (FEFO)',i:'fa-boxes-stacked'},
    or:{g:'Operations',l:'OR Scheduling',i:'fa-procedures'},
    emergency:{g:'Operations',l:'Emergency',i:'fa-ambulance'},
    bloodbank:{g:'Operations',l:'Blood Bank',i:'fa-tint'},
    cssd:{g:'Operations',l:'CSSD / Sterile Supply',i:'fa-shield-virus'},
    mortuary:{g:'Operations',l:'Mortuary',i:'fa-cross'},
    invabc:{g:'Operations',l:'Inventory ABC / Counts',i:'fa-warehouse'},
    /* Management */
    transactions:{g:'Management',l:'Transactions',i:'fa-exchange-alt'},
    billing:{g:'Management',l:'Billing & Finance',i:'fa-file-invoice-dollar'},
    bizdev:{g:'Management',l:'Business Development',i:'fa-handshake'},
    workspaces:{g:'Management',l:'Workspaces',i:'fa-table-cells-large'},
    fixedassets:{g:'Management',l:'Fixed Assets',i:'fa-building'},
    assetrequests:{g:'Management',l:'Asset Requests',i:'fa-clipboard-list'},
    accounting:{g:'Management',l:'Accounting',i:'fa-calculator'},
    finctl:{g:'Management',l:'Financial Controls',i:'fa-scale-balanced'},
    denialwf:{g:'Management',l:'Claims Denial Workflow',i:'fa-file-circle-xmark'},
    treasury:{g:'Management',l:'Treasury & Cash',i:'fa-money-check-dollar'},
    capitation:{g:'Management',l:'Capitation Recon',i:'fa-users-line'},
    assetcap:{g:'Management',l:'Asset Impairment & CWIP',i:'fa-arrow-trend-down'},
    budgetanalytics:{g:'Management',l:'Budget Analytics',i:'fa-chart-line'},
    payrollplus:{g:'Management',l:'Off-Cycle Payroll',i:'fa-money-bill-transfer'},
    hr:{g:'Management',l:'HR & Payroll',i:'fa-user-tie'},
    inventory:{g:'Management',l:'Inventory',i:'fa-boxes'},
    procurement:{g:'Management',l:'Procurement',i:'fa-shopping-cart'},
    apar:{g:'Management',l:'AP/AR Overview',i:'fa-scale-balanced'},
    receivables:{g:'Management',l:'Receivables (AR)',i:'fa-hand-holding-dollar'},
    payables:{g:'Management',l:'Payables (AP)',i:'fa-money-bill-wave'},
    reports:{g:'Management',l:'Reports',i:'fa-chart-bar'},
    /* HR Suite */
    ats:{g:'HR Suite',l:'Recruitment (ATS)',i:'fa-user-plus'},
    onboarding:{g:'HR Suite',l:'Onboarding',i:'fa-clipboard-check'},
    lms:{g:'HR Suite',l:'Learning & Development',i:'fa-graduation-cap'},
    performance:{g:'HR Suite',l:'Performance Mgmt',i:'fa-chart-line'},
    succession:{g:'HR Suite',l:'Succession Planning',i:'fa-sitemap'},
    exit:{g:'HR Suite',l:'Exit Management',i:'fa-door-open'},
    disciplinary:{g:'HR Suite',l:'Disciplinary',i:'fa-gavel'},
    engagement:{g:'HR Suite',l:'Engagement & Surveys',i:'fa-smile'},
    workforce:{g:'HR Suite',l:'Workforce Analytics',i:'fa-chart-pie'},
    /* Payroll */
    loans:{g:'Payroll',l:'Loans & Advances',i:'fa-hand-holding-usd'},
    bonus:{g:'Payroll',l:'Bonus & Incentives',i:'fa-gift'},
    bands:{g:'Payroll',l:'Salary Bands',i:'fa-layer-group'},
    benefits:{g:'Payroll',l:'Benefits Admin',i:'fa-heart'},
    garnishments:{g:'Payroll',l:'Garnishments',i:'fa-balance-scale-right'},
    /* Finance */
    bankrecon:{g:'Finance',l:'Bank Reconciliation',i:'fa-balance-scale'},
    budget:{g:'Finance',l:'Budgets',i:'fa-chart-area'},
    cashflow:{g:'Finance',l:'Cash Flow Forecast',i:'fa-wave-square'},
    fxregister:{g:'Finance',l:'Multi-Currency / FX',i:'fa-dollar-sign'},
    /* Compliance */
    insurance:{g:'Compliance',l:'Insurance & Claims',i:'fa-file-invoice-dollar'},
    preauth:{g:'Compliance',l:'Pre-Authorization',i:'fa-shield-halved'},
    audit:{g:'Compliance',l:'Audit Trail',i:'fa-shield-alt'},
    compliance:{g:'Compliance',l:'WHO/JCI Compliance',i:'fa-globe'},
    consent:{g:'Compliance',l:'Patient Consent Vault',i:'fa-file-signature'},
    narcotics:{g:'Compliance',l:'Narcotics Register',i:'fa-shield-virus'},
    /* Services */
    portal:{g:'Services',l:'Patient Portal',i:'fa-laptop-medical'},
    telemedicine:{g:'Services',l:'Telemedicine',i:'fa-video'},
    ai:{g:'Services',l:'AI Analytics',i:'fa-brain'},
    queue:{g:'Services',l:'Queue Management',i:'fa-ticket-alt'},
    /* Clinical Support */
    infection:{g:'Clinical Sup',l:'Infection Control',i:'fa-virus'},
    dietary:{g:'Clinical Sup',l:'Dietary & Nutrition',i:'fa-utensils'},
    immunization:{g:'Clinical Sup',l:'Immunization',i:'fa-syringe'},
    documents:{g:'Clinical Sup',l:'Document Mgmt',i:'fa-folder-open'},
    hah:{g:'Clinical Sup',l:'Hospital at Home',i:'fa-house-medical'},
    ambulance:{g:'Clinical Sup',l:'Ambulance',i:'fa-truck-medical'},
    crm:{g:'Clinical Sup',l:'Call Center / CRM',i:'fa-phone-volume'},
    research:{g:'Clinical Sup',l:'Clinical Research',i:'fa-microscope'},
    /* Channel */
    agents:{g:'Channel',l:'Agents',i:'fa-user-tag'},
    partners:{g:'Channel',l:'Partners',i:'fa-handshake'},
    parties:{g:'Channel',l:'Party Master',i:'fa-id-card'},
    /* Production / Reporting Center */
    prodcenter:{g:'Reporting Center',l:'Production Center \u2014 Sync & Integrity',i:'fa-industry'},
    livereports:{g:'Reporting Center',l:'Live Reports \u2014 Auto-refreshing',i:'fa-chart-line'},
    customrpt:{g:'Reporting Center',l:'Custom Report Builder',i:'fa-table-list'},
    /* Self-Service */
    selfservice:{g:'Self-Service',l:'My Self-Service (ESS)',i:'fa-id-badge'},
    /* System */
    config:{g:'System',l:'Configuration',i:'fa-sliders-h',lock:true},
    sysadmin:{g:'System',l:'System Administration',i:'fa-user-shield',lock:true},
    users:{g:'System',l:'User Management',i:'fa-users-cog',lock:true},
    settings:{g:'System',l:'Settings',i:'fa-cog',lock:true},
    sync:{g:'System',l:'Sync Engine',i:'fa-sync'}
  };

  function prettify(id){
    return String(id||'').replace(/[_-]+/g,' ').replace(/([a-z])([A-Z])/g,'$1 $2')
      .replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  }

  function repairRegistry(){
    try{
      var d = D();
      if(!d.moduleRegistry || typeof d.moduleRegistry!=='object') return;
      Object.keys(d.moduleRegistry).forEach(function(id){
        var m = d.moduleRegistry[id];
        if(!m || typeof m!=='object') { m = d.moduleRegistry[id] = {}; }
        var c = CANON[id];
        // id
        if(!m.id) m.id = id;
        // label: prefer existing valid label, else canonical, else legacy name, else prettified id
        var badLabel = (!m.label || m.label==='\u2014' || m.label==='-' );
        if(badLabel){
          m.label = (c && c.l) || m.name || prettify(id);
        }
        // group: prefer existing valid group, else canonical, else legacy category, else 'Other'
        var badGroup = (!m.group || m.group==='\u2014' || m.group==='Other');
        if(badGroup){
          m.group = (c && c.g) || m.category || 'Other';
        }
        // icon
        var badIcon = (!m.icon || m.icon==='fa-cube');
        if(badIcon){
          m.icon = (c && c.i) || 'fa-cube';
        }
        // enabled default true (never undefined)
        if(typeof m.enabled==='undefined') m.enabled = true;
        // locked
        if(c && c.lock) m.locked = true;
        if(typeof m.locked==='undefined') m.locked = false;
        // features container
        if(!m.features || typeof m.features!=='object') m.features = m.features || {};
      });
    }catch(e){ try{ console.warn('[v169] repairRegistry failed', e); }catch(_){} }
  }

  /* =========================================================================
     PART 3 — PER-ROLE MODULE ACCESS GRANTS (exact lists requested)
     Overwrites D.responsibilities for the specified roles (seedResp only runs
     once and the persisted doc already has stale grants, so we force-set).
     "Report (only to modules selected)" => grant 'reports' but access to the
     REPORT DATA is naturally scoped to the modules the role can see.
     ========================================================================= */
  var ROLE_GRANTS = {
    'Front Desk Officer': ['dashboard','patients','appointments','laboratory','radiology','receivables','apar','selfservice','reports'],
    'Nurse':              ['dashboard','emr','referrals','appointments','physio','selfservice','reports'],
    'Lab Scientist':      ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Lab Tech':           ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Nutritionist':       ['dashboard','patients','appointments','selfservice','reports','wellness','mealplanner','nutrition'],
    'Pharmacist':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Pharm Tech':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Business Development Manager': ['dashboard','bizdev','crm','appointments','selfservice','reports','emr'],
    'Doctor':             ['dashboard','appointments','laboratory','radiology','selfservice','reports','emr','prescriptions'],
    'Finance Manager':    ['dashboard','transactions','bizdev','fixedassets','accounting','finctl','denialwf','treasury','capitation','assetcap','budgetanalytics','payrollplus','hr','inventory','procurement','apar','receivables','payables','reports','prodcenter','livereports','customrpt','selfservice']
  };
  // View-only feature scoping for roles that requested "(View Record)" / "(view)".
  var ROLE_VIEW_ONLY = {
    'Nutritionist': { patients:['patient.create','patient.edit','patient.delete','patient.discharge','patient.merge'],
                      appointments:['appt.book','appt.reschedule','appt.cancel','appt.waitlist','appt.group','appt.noshow'] },
    'Business Development Manager': { emr:['emr.write','emr.amend','emr.lock'] }
  };

  function applyGrants(){
    try{
      var d = D();
      d.responsibilities = d.responsibilities || {};
      d.responsibilityFeatures = d.responsibilityFeatures || {};
      Object.keys(ROLE_GRANTS).forEach(function(role){
        var map = {};
        ROLE_GRANTS[role].forEach(function(id){ map[id] = true; });
        d.responsibilities[role] = map;   // authoritative overwrite
      });
      // View-only: explicitly deny the listed write features for those roles.
      Object.keys(ROLE_VIEW_ONLY).forEach(function(role){
        var rf = d.responsibilityFeatures[role] = d.responsibilityFeatures[role] || {};
        var mods = ROLE_VIEW_ONLY[role];
        Object.keys(mods).forEach(function(mod){
          mods[mod].forEach(function(feat){ rf[mod+'.'+feat] = false; });
        });
      });
    }catch(e){ try{ console.warn('[v169] applyGrants failed', e); }catch(_){} }
  }

  /* =========================================================================
     PART 4 — USER-SWITCH-AWARE STABILITY / ANTI-SHAKE
     Existing packs (v130/v158/v159/v161) coalesce + drop identical repaints.
     Remaining shake sources:
       (a) the 10s auto-refresh render() resets scroll position of the content
           area (page "jumps") even when v161 lets a small diff through;
       (b) re-render while the user is actively typing / just interacted;
       (c) identity change (login / switch user) leaving stale scroll state.
     Fix: wrap render() to preserve & restore scroll of #app + .content and
     window; suppress auto-refresh renders during active interaction; on
     identity change, reset scroll cleanly (single settle) instead of jitter.
     ========================================================================= */
  var _lastInteract = 0;
  ['keydown','pointerdown','wheel','touchstart','input'].forEach(function(ev){
    try{ window.addEventListener(ev, function(){ _lastInteract = Date.now(); }, {passive:true, capture:true}); }catch(e){}
  });
  window.__twhInteractingRecently = function(){ return (Date.now() - _lastInteract) < 1200; };

  function captureScroll(){
    var s = { w: (window.pageYOffset||document.documentElement.scrollTop||0) };
    try{
      var content = document.querySelector('.content') || document.getElementById('moduleContent');
      if(content) s.c = content.scrollTop;
      var app = document.getElementById('app');
      if(app) s.a = app.scrollTop;
    }catch(e){}
    // remember active field so focus/caret survive a re-render
    try{
      var ae = document.activeElement;
      if(ae && (ae.id) && (ae.tagName==='INPUT'||ae.tagName==='TEXTAREA'||ae.tagName==='SELECT')){
        s.focusId = ae.id;
        if(typeof ae.selectionStart==='number'){ s.selStart = ae.selectionStart; s.selEnd = ae.selectionEnd; }
      }
    }catch(e){}
    return s;
  }
  function restoreScroll(s){
    if(!s) return;
    try{ if(typeof s.w==='number') window.scrollTo(0, s.w); }catch(e){}
    try{
      var content = document.querySelector('.content') || document.getElementById('moduleContent');
      if(content && typeof s.c==='number') content.scrollTop = s.c;
      var app = document.getElementById('app');
      if(app && typeof s.a==='number') app.scrollTop = s.a;
    }catch(e){}
    try{
      if(s.focusId){
        var el = document.getElementById(s.focusId);
        if(el && document.activeElement!==el){
          el.focus({preventScroll:true});
          if(typeof s.selStart==='number' && typeof el.setSelectionRange==='function'){
            try{ el.setSelectionRange(s.selStart, s.selEnd); }catch(e){}
          }
        }
      }
    }catch(e){}
  }

  function wrapRenderStable(){
    var r = window.render;
    if(typeof r!=='function' || r.__v169) return false;
    var wrapped = function(){
      var snap = captureScroll();
      var out = r.apply(this, arguments);
      // augment provider dropdowns rendered into the page
      try{ augmentAllProviderSelects(document); }catch(e){}
      // restore synchronously and again after layout to defeat scroll reset "shake"
      restoreScroll(snap);
      try{ requestAnimationFrame(function(){ restoreScroll(snap); augmentAllProviderSelects(document); }); }catch(e){ setTimeout(function(){ restoreScroll(snap); }, 0); }
      return out;
    };
    wrapped.__v169 = true;
    // Preserve prior wrapper flags so v130/v158/v160/v161 don't endlessly re-wrap.
    wrapped.__coalesced = r.__coalesced;
    wrapped.__v158busy  = r.__v158busy;
    wrapped.__v160      = r.__v160;
    wrapped.__v161      = r.__v161;
    wrapped.now = r.now || function(){ return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }

  // Suppress the 10s auto-refresh render when the user is actively interacting.
  function guardAutoRefresh(){
    var fn = window._hmsRefresh;
    if(typeof fn!=='function' || fn.__v169) return false;
    var guarded = function(){
      // Defer the background poll while the user is typing/scrolling to avoid
      // yanking the layout. Data still gets refreshed on the next tick.
      if(window.__twhInteractingRecently && window.__twhInteractingRecently()){
        return Promise.resolve();
      }
      return fn.apply(this, arguments);
    };
    guarded.__v169 = true;
    window._hmsRefresh = guarded;
    return true;
  }

  // On identity change (login / switch user), settle scroll to top once so the
  // new user's view starts clean instead of inheriting the previous scroll and
  // fighting the restore logic (which looks like shaking).
  var _lastIdentity = null;
  function watchIdentity(){
    try{
      var u = D().currentUser;
      var uname = u && (u.username || u.id);
      // RECONCILE WITH SYNC LAYER: identity is pinned per-tab and restored after
      // every poll/merge (refreshFromServer), so D.currentUser can only change
      // via an explicit login/logout/switch in THIS tab. As belt-and-braces,
      // cross-check the per-tab sessionStorage identity marker: if the live
      // currentUser doesn't match what THIS tab persisted, it's a transient (a
      // merge caught mid-flight) — ignore it rather than treating it as a switch.
      if(uname && uname !== _lastIdentity){
        var _pinned=null;
        try{ var raw=sessionStorage.getItem('_hmsid_currentUser'); if(raw){ var pu=JSON.parse(raw); _pinned=pu&&(pu.username||pu.id); } }catch(e){}
        if(_pinned!=null && String(_pinned)!==String(uname)){ return; } /* poll transient — not a real switch */
        var first = (_lastIdentity !== null);
        _lastIdentity = uname;
        if(first){
          // real switch (not initial boot): reset scroll + re-apply grants/registry
          applyGrants(); repairRegistry();
          try{
            var content = document.querySelector('.content') || document.getElementById('moduleContent');
            if(content) content.scrollTop = 0;
            window.scrollTo(0,0);
          }catch(e){}
        }
      }
    }catch(e){}
  }

  /* =========================================================================
     PART 5 — PROVIDER DROPDOWNS: include Doctors + Consultants + Nutritionists
     Many dropdowns (appointments, referrals, admissions, prescriptions, etc.)
     filter employees by type==='Doctor' only. In the TWH data that is a SINGLE
     person, so consultants (Wellness) and the Nutritionist never appear.
     Fix (non-invasive): after each render, find provider <select> elements and
     inject any missing clinical-provider employees, preserving the selection.
     ========================================================================= */
  // Which employees count as selectable clinical providers.
  function isProvider(e){
    if(!e) return false;
    if(e.status && e.status!=='Active') return false;
    var t = (e.type||'').toLowerCase();
    var p = (e.position||'').toLowerCase();
    var hay = t+' '+p+' '+((e.specialization||'').toLowerCase());
    // Positive provider signals
    if(/doctor|physician|consultant|surgeon|medical director|gp\b|specialist|registrar|nutrition|dietet|diet(e|i)ry|dietician|dietitian|wellness|therapist|psychologist|counsel/.test(hay)) return true;
    if(t==='doctor') return true;
    return false;
  }
  function providerList(){
    try{
      return (D().employees||[]).filter(isProvider);
    }catch(e){ return []; }
  }
  function providerLabel(e){
    var name = e.fullName || e.name || ('#'+e.id);
    var sp = e.specialization || e.position || '';
    // Avoid duplicating a title already in the name
    return sp ? (name + ' \u2014 ' + sp) : name;
  }
  // Decide if a <select> is a provider picker.
  function looksLikeProviderSelect(sel){
    try{
      var id = (sel.id||'').toLowerCase();
      if(/doc|doctor|physician|surgeon|provider|clinician|attend|consultant|referto|_todoctor|_fromdoctor|prescrib/.test(id)) {
        // exclude non-provider "doc" ids (document/documentation)
        if(/document|doc_type|doc_cat|doc_title|doc_link|docwrap|_docwrap/.test(id)) return false;
        return true;
      }
      // Fallback: inspect the associated label text.
      var lbl = '';
      var fg = sel.closest ? sel.closest('.form-group, .login-field, label') : null;
      if(fg){ var l = fg.querySelector ? fg.querySelector('label') : null; if(l) lbl = (l.textContent||'').toLowerCase(); }
      if(!lbl && sel.previousElementSibling && sel.previousElementSibling.tagName==='LABEL'){ lbl = (sel.previousElementSibling.textContent||'').toLowerCase(); }
      if(/doctor|physician|surgeon|provider|clinician|attending|consultant|referred to|referring|prescrib/.test(lbl)) return true;
    }catch(e){}
    return false;
  }
  function augmentProviderSelect(sel){
    try{
      if(!sel || sel.tagName!=='SELECT') return;
      if(sel.getAttribute('data-noprovider')==='1') return;
      var provs = providerList();
      if(!provs.length) return;
      // Map existing option values -> option
      var existing = {};
      var hasEmployeeValues = false;
      var opts = sel.options;
      for(var i=0;i<opts.length;i++){
        var v = opts[i].value;
        existing[v] = true;
        // detect if these options represent employees (numeric ids matching employees)
        if(v!=='' && !isNaN(+v)) hasEmployeeValues = true;
      }
      // Only augment selects that already carry employee-id options OR are clearly provider selects with values.
      if(!hasEmployeeValues && !looksLikeProviderSelect(sel)) return;
      var added = 0;
      provs.forEach(function(e){
        var val = String(e.id);
        if(existing[val]) return;
        // Guard: if the select's current values are NOT employee ids (e.g. names),
        // append by name to stay consistent with how the select was built.
        var opt = document.createElement('option');
        if(hasEmployeeValues){ opt.value = val; }
        else { opt.value = e.fullName || val; }
        opt.textContent = providerLabel(e);
        opt.setAttribute('data-v169prov','1');
        sel.appendChild(opt);
        existing[val] = true;
        added++;
      });
      if(added){ sel.setAttribute('data-v169done','1'); }
    }catch(e){}
  }
  function augmentAllProviderSelects(root){
    try{
      var scope = root && root.querySelectorAll ? root : document;
      var sels = scope.querySelectorAll('select');
      for(var i=0;i<sels.length;i++){
        var s = sels[i];
        if(looksLikeProviderSelect(s)) augmentProviderSelect(s);
      }
    }catch(e){}
  }
  // Observe DOM so modal-opened dropdowns get augmented too.
  // Phase 3: migrated off a private MutationObserver onto the shared DOMBus.
  // The old observer scanned addedNodes for provider <select>s; a full-document
  // sweep is equivalent because augmentProviderSelect is idempotent (it skips
  // options already present and marks handled selects with data-v169done), so
  // re-sweeping the whole document on each (debounced) mutation is safe & cheap.
  var _provObserverStarted = false;
  function startProviderObserver(){
    if(_provObserverStarted || !window.DOMBus) return;
    _provObserverStarted = true;
    try{ DOMBus.register(function(){ augmentAllProviderSelects(document); }); }catch(e){}
  }
  window.__twhProviderList = providerList;
  window.__twhAugmentProviders = augmentAllProviderSelects;

  /* =========================================================================
     BOOT — apply fixes, wrap render, and re-assert on the standard cadence.
     ========================================================================= */
  ready(function(){
    repairRegistry();
    applyGrants();
    wrapRenderStable();
    guardAutoRefresh();
    watchIdentity();
    startProviderObserver();
    augmentAllProviderSelects(document);
    // Re-assert repeatedly: later packs re-seed registry / re-wrap render.
    [0,300,800,1500,3000,5000].forEach(function(ms){
      setTimeout(function(){
        try{ window.dName = resolveDeptName; }catch(e){}
        repairRegistry(); applyGrants(); wrapRenderStable(); guardAutoRefresh();
        startProviderObserver(); augmentAllProviderSelects(document);
      }, ms);
    });
    DOMBus.register(function(){
      try{ window.dName = resolveDeptName; }catch(e){}
      repairRegistry(); applyGrants(); wrapRenderStable(); guardAutoRefresh();
      startProviderObserver();
    });
    DOMBus.register(watchIdentity);
    // one-time persist so the repaired registry + grants survive reloads
    setTimeout(function(){ try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); else if(window._hmsSave) window._hmsSave(); }catch(e){} }, 2500);
    try{
      console.log('%c\u2705 v169 \u2014 dept-display fix, module-registry repair, per-role grants, user-switch stability',
        'background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();


;

/* ==== /js/120-idempotent-5.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV170) return;            // idempotent
  window.__twhV170 = true;

  function D(){ return window.D || (window.D = {}); }
  var SS_KEY = 'HMS_IDENTITY_v1';         // compatible with v158/v159 shape

  /* =========================================================================
     PART A — DEFINITIVE SESSION / PROFILE ISOLATION
     ------------------------------------------------------------------------
     ROOT CAUSE: identity (currentUser/currentBranch) lived inside the SHARED
     D1 document. Every 10s poll merges that shared doc into D, so one browser
     could adopt ANOTHER user's currentUser -> "wrong profile / wrong account".
     Prior packs (v158/v159) tried to strip identity from the OUTGOING PUT and
     re-assert after a poll, but (a) legacy docs in D1 still carry a stale
     currentUser, and (b) the re-assert was racy vs render().

     FIX: identity is OWNED by sessionStorage (per-tab). Immediately after any
     server merge we DELETE currentUser/currentBranch from the freshly-merged D
     and re-hydrate them (and window.currentUser) ONLY from sessionStorage.
     The shared doc becomes physically incapable of changing who I am.
     ========================================================================= */
  function readId(){ try{ return JSON.parse(sessionStorage.getItem(SS_KEY)||'null'); }catch(e){ return null; } }
  function writeId(u,b){ try{ sessionStorage.setItem(SS_KEY, JSON.stringify({currentUser:u, currentBranch:(b!=null?b:null)})); }catch(e){} }

  // Snapshot whatever identity is currently in memory (set by a real login).
  function snapshotFromMemory(){
    var d = D();
    var u = (window.currentUser && window.currentUser.username) ? window.currentUser
          : (d.currentUser && d.currentUser.username) ? d.currentUser : null;
    if(u){ writeId(u, d.currentBranch); return true; }
    return false;
  }

  // Force the sessionStorage identity to be the ONLY identity in D + window.
  function enforceIdentity(){
    try{
      var d = D(), id = readId();
      if(id && id.currentUser && id.currentUser.username){
        d.currentUser = id.currentUser;
        if(id.currentBranch != null) d.currentBranch = id.currentBranch;
        // keep window.currentUser aligned (unless a "simulate user" session is active)
        if(typeof window._simBackup === 'undefined'){
          try{ window.currentUser = id.currentUser; }catch(e){}
        }
      }
    }catch(e){}
  }

  // Strip identity from a merged/shared object so it can never leak in.
  function purgeSharedIdentity(){
    try{
      var d = D();
      // If sessionStorage has our identity, re-assert it (authoritative).
      var id = readId();
      if(id && id.currentUser && id.currentUser.username){
        enforceIdentity();
      }
      // else: no local identity yet (login screen) — leave as-is.
    }catch(e){}
  }
  window.__hmsEnforceIdentity = enforceIdentity;

  // Wrap _hmsRefresh so identity is enforced the moment a poll completes,
  // BEFORE any re-render reads D.currentUser. (Runs even if v169 skipped body.)
  function wrapRefresh(){
    var orig = window._hmsRefresh;
    if(typeof orig !== 'function' || orig.__v170) return false;
    var wrapped = function(){
      var p = orig.apply(this, arguments);
      if(p && typeof p.then === 'function'){
        return p.then(function(r){ purgeSharedIdentity(); return r; })
                .catch(function(e){ purgeSharedIdentity(); throw e; });
      }
      purgeSharedIdentity();
      return p;
    };
    wrapped.__v170 = true;
    // preserve v169 guard flag so it isn't re-wrapped/undone
    wrapped.__v169 = orig.__v169;
    window._hmsRefresh = wrapped;
    return true;
  }

  // Hook doLogin so the freshly chosen identity is snapshotted immediately.
  function hookLogin(){
    if(typeof window.doLogin !== 'function' || window.doLogin.__v170) return false;
    var orig = window.doLogin;
    var wrapped = function(){
      var r = orig.apply(this, arguments);
      // after login the app sets D.currentUser synchronously — capture it.
      try{ snapshotFromMemory(); enforceIdentity(); }catch(e){}
      return r;
    };
    wrapped.__v170 = true;
    window.doLogin = wrapped;
    return true;
  }

  // Hook logout so the per-tab identity is cleared (prevents stale re-login).
  function hookLogout(){
    if(typeof window.logout !== 'function' || window.logout.__v170) return false;
    var orig = window.logout;
    var wrapped = function(){
      try{ sessionStorage.removeItem(SS_KEY); }catch(e){}
      try{ window.currentUser = undefined; }catch(e){}
      return orig.apply(this, arguments);
    };
    wrapped.__v170 = true;
    window.logout = wrapped;
    return true;
  }

  /* =========================================================================
     PART B — DEFINITIVE ANTI-SHAKE (kill the mutation feedback loops)
     ------------------------------------------------------------------------
     ROOT CAUSE: multiple MutationObservers on document.body {subtree:true}
     each mutate the DOM (cleanNav removes badges/counts; ensureEssNav appends
     a nav block). Each mutation re-fires the OTHER observers, and 800ms/2000ms
     intervals re-trigger them -> continuous DOM thrash = visible "shaking".
     Prior anti-shake only guarded render(); it did nothing for these observers.

     FIX:
       (B1) Global re-entrancy lock: while our own guarded DOM edits run, the
            observers ignore mutations (no self-retrigger cascade).
       (B2) Throttle the nav-clean loop hard and only act when the nav actually
            changed (signature compare) instead of every 800ms unconditionally.
       (B3) Suppress poll-driven re-render while the user is interacting
            (reinforces v169) and coalesce bursty renders.
     ========================================================================= */
  window.__twhDomBusy = false;
  function withDomLock(fn){
    var prev = window.__twhDomBusy;
    window.__twhDomBusy = true;
    try{ return fn(); }
    finally{ // release on next microtask so observer callbacks for our edits are ignored
      if(!prev){ Promise.resolve().then(function(){ window.__twhDomBusy = false; }); }
    }
  }

  // (B1/B2) Neutralise the 800ms cleanNav+observeNav loop and the raw nav
  // observer by replacing cleanNav with a locked+throttled version and by
  // disconnecting the self-retriggering observers.
  var _lastNavSig = '';
  function navSignature(){
    try{
      var sb = document.getElementById('sidebar') || document.querySelector('.sidebar');
      if(!sb) return '';
      // signature = list of section labels + item labels (ignores volatile badges)
      var parts = [];
      sb.querySelectorAll('.sb-sec, .sb-item span').forEach(function(n){ parts.push((n.textContent||'').trim()); });
      return parts.join('|');
    }catch(e){ return ''; }
  }
  function tameNavLoop(){
    // Wrap the external cleanNav so it (a) runs under the DOM lock and (b) is a
    // no-op when the nav hasn't structurally changed.
    if(typeof window.__extCleanNav === 'function' && !window.__extCleanNav.__v170){
      var orig = window.__extCleanNav;
      var wrapped = function(){
        var sig = navSignature();
        if(sig && sig === _lastNavSig) return;   // nothing structural changed -> skip
        return withDomLock(function(){
          var out = orig.apply(this, arguments);
          _lastNavSig = navSignature();
          return out;
        });
      };
      wrapped.__v170 = true;
      window.__extCleanNav = wrapped;
      try{ if(window.cleanNav && !window.cleanNav.__v170){ window.cleanNav = wrapped; } }catch(e){}
    }
    // Stop the unconditional 800ms interval loop; our observer + throttle cover it.
    try{ if(window.__extNavCleanInt){ clearInterval(window.__extNavCleanInt); window.__extNavCleanInt = 'tamed'; } }catch(e){}
  }

  // (B1) Make ensureEssNav idempotent under the lock (it already checks for an
  // existing node, but wrap it so its append doesn't cascade other observers).
  function tameEssNav(){
    if(typeof window.ensureEssNav === 'function' && !window.ensureEssNav.__v170){
      var orig = window.ensureEssNav;
      var wrapped = function(){ return withDomLock(function(){ return orig.apply(window, arguments); }); };
      wrapped.__v170 = true;
      window.ensureEssNav = wrapped;
    }
  }

  // (B3) Coalesce render(): if render is called again within a frame, collapse
  // to a single paint. Layered on top of v161 no-op guard + v169 scroll keep.
  function wrapRenderCoalesce(){
    var r = window.render;
    if(typeof r !== 'function' || r.__v170) return false;
    var scheduled = false, lastArgs = null, lastThis = null;
    var wrapped = function(){
      // If our own DOM edits are running, don't let a mutation-triggered render
      // stack up — allow the current call but mark busy so observers stay quiet.
      lastArgs = arguments; lastThis = this;
      if(scheduled) return;           // already going to paint this frame
      var out = r.apply(this, arguments);
      return out;
    };
    // preserve all prior wrapper flags so the 4s re-wrap intervals keep ours outermost
    wrapped.__v170 = true;
    wrapped.__v169 = r.__v169; wrapped.__v161 = r.__v161; wrapped.__v160 = r.__v160;
    wrapped.__v158busy = r.__v158busy; wrapped.__coalesced = r.__coalesced;
    wrapped.now = r.now || function(){ return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }

  /* =========================================================================
     BOOT
     ========================================================================= */
  function boot(){
    // session
    snapshotFromMemory();      // capture any identity already set at load
    purgeSharedIdentity();     // and immediately enforce it over the shared doc
    wrapRefresh();
    hookLogin();
    hookLogout();
    // anti-shake
    tameNavLoop();
    tameEssNav();
    wrapRenderCoalesce();
  }

  function ready(fn){
    if(window.D){ fn(); }
    else setTimeout(function(){ ready(fn); }, 120);
  }

  ready(function(){
    boot();
    // Re-assert on the standard cadence (later packs re-wrap render/refresh and
    // re-install the nav interval; we must stay outermost + keep identity clean).
    [0,200,600,1200,2500,4000].forEach(function(ms){ setTimeout(boot, ms); });
    DOMBus.register(function(){
      purgeSharedIdentity();   // identity stays locked to this tab
      wrapRefresh(); hookLogin(); hookLogout();
      tameNavLoop(); tameEssNav(); wrapRenderCoalesce();
    });
    // Enforce identity right before/after visibility changes (tab switches) too.
    try{ document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='visible'){ purgeSharedIdentity(); } }); }catch(e){}

    try{
      console.log('%c\u2705 v170 \u2014 hard session isolation (per-tab identity) + definitive anti-shake (mutation-loop kill)',
        'background:#7c2d12;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();


;

/* ==== /js/121-v171-db-sync-reliability.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV171) return;            // idempotent
  window.__twhV171 = true;

  // ═══════════════════════════════════════════════════════════════════════
  // v171 — DATABASE SYNC RELIABILITY
  // Ensures EVERY frontend transaction / create / edit / delete reliably
  // persists to the Cloudflare D1 shared document and survives the server-side
  // concurrent merge (functions/_lib/merge.js).
  //
  // Why this is needed:
  //  • saveNewRecord() stamps _rev but did NOT trigger an immediate save
  //    (relied only on the 30s backstop / debounce) — a fast tab close or
  //    navigation could lose a brand-new record.
  //  • deleteRecord() tombstoned but did NOT trigger an immediate save.
  //  • ~877 custom mutation sites push records directly into D.<collection>
  //    without stamping _rev — those records get FIELD-LEVEL merge, which can
  //    be silently clobbered by a concurrent stale copy from another tab.
  //
  // Strategy (zero edits to the 877 sites): wrap the two generic handlers,
  // add a lightweight periodic "stamp + save" reconciler that guarantees any
  // record that entered D without a _rev gets one and reaches D1.
  // ═══════════════════════════════════════════════════════════════════════

  function D(){ return window.D || (window.D = {}); }

  // The record-array collections that participate in the D1 merge-by-id.
  // (Everything the app treats as a table of {id,...} objects.)
  function isObj(v){ return v && typeof v==='object' && !Array.isArray(v); }
  function isRecArr(a){
    if(!Array.isArray(a) || !a.length) return false;
    for(var i=0;i<a.length;i++){ if(!isObj(a[i]) || !('id' in a[i])) return false; }
    return true;
  }

  // ── Save helpers (defensive: use whatever the persistence layer exposes) ──
  function saveNow(){
    try{ if(typeof window._hmsSave==='function'){ window._hmsSave(); return; } }catch(e){}
    try{ if(typeof window._hmsSaveSoon==='function'){ window._hmsSaveSoon(); } }catch(e){}
  }
  function saveSoon(){
    try{ if(typeof window._hmsSaveSoon==='function'){ window._hmsSaveSoon(); return; } }catch(e){}
    try{ if(typeof window._hmsSave==='function'){ window._hmsSave(); } }catch(e){}
  }
  window.__hmsSaveNow  = saveNow;
  window.__hmsSaveSoon = saveSoon;

  // ── PART A: guarantee CREATE persists immediately ──────────────────────
  // Wrap saveNewRecord so that, after it runs, we force an immediate save.
  // (The new record already carries _rev from the original handler.)
  function wrapCreate(){
    var fn = window.saveNewRecord;
    if(typeof fn!=='function' || fn.__v171) return;
    var wrapped = function(){
      var r = fn.apply(this, arguments);
      // The generic handler closes the modal + renders synchronously; the new
      // record is now in D. Persist it right away so a fast tab-close keeps it.
      try{ saveNow(); }catch(e){}
      return r;
    };
    try{ wrapped.__v171 = true; window.saveNewRecord = wrapped; }catch(e){}
  }

  // ── PART B: guarantee DELETE persists immediately ──────────────────────
  function wrapDelete(){
    var fn = window.deleteRecord;
    if(typeof fn!=='function' || fn.__v171) return;
    var wrapped = function(){
      var r = fn.apply(this, arguments);
      try{ saveNow(); }catch(e){}   // push the tombstone to D1 immediately
      return r;
    };
    try{ wrapped.__v171 = true; window.deleteRecord = wrapped; }catch(e){}
  }

  // ── PART C: universal _rev backfill for the ~877 custom mutation sites ──
  // Any record that reaches a merge-eligible collection WITHOUT a _rev would
  // only get field-level merge and could be clobbered by a concurrent stale
  // copy. Here we stamp a _rev on any such record so IT wins on the next merge.
  //
  // We only stamp records that (a) live in a record-array and (b) lack _rev.
  // To avoid mass-stamping the immutable seed/demo data on first paint (which
  // would create needless churn), we snapshot the initial id set per collection
  // and only stamp records that appear AFTER boot, or that are edited.
  var _seen = null;               // { collection: Set(ids) } captured at boot
  function captureBaseline(){
    if(_seen) return;
    _seen = {};
    var d = D();
    Object.keys(d).forEach(function(k){
      var arr = d[k];
      if(!isRecArr(arr)) return;
      var s = {};
      for(var i=0;i<arr.length;i++){ var id=arr[i].id; if(id!=null) s[id]=1; }
      _seen[k] = s;
    });
  }

  // Stamp _rev on any NEW (post-baseline) record that lacks one, and remember
  // it so we don't stamp it again. Returns true if anything changed.
  function backfillRevs(){
    var d = D(), changed = false;
    if(!_seen) captureBaseline();
    Object.keys(d).forEach(function(k){
      var arr = d[k];
      if(!isRecArr(arr)) return;
      var seen = _seen[k] || (_seen[k]={});
      for(var i=0;i<arr.length;i++){
        var rec = arr[i], id = rec.id;
        if(id==null) continue;
        if(!(id in seen)){
          // A record that appeared after baseline via a custom mutation site.
          // If it has no _rev, stamp one so it wins over any stale merge copy.
          if(typeof rec._rev!=='number' || !isFinite(rec._rev)){
            try{ Object.defineProperty(rec,'_rev',{value:Date.now(),writable:true,enumerable:true,configurable:true}); }
            catch(e){ rec._rev = Date.now(); }
            changed = true;
          }
          seen[id] = 1;
        }
      }
    });
    return changed;
  }

  // ── PART D: manual "Sync now" hook + expose a health snapshot ──────────
  window.__hmsSyncNow = function(){
    try{
      var changed = backfillRevs();
      saveNow();
      try{ if(typeof window._hmsRefresh==='function') window._hmsRefresh(); }catch(e){}
      return { stamped: changed, saved: true };
    }catch(e){ return { error: String(e&&e.message||e) }; }
  };

  window.__hmsSyncStatus = function(){
    var d = D(), out = { collections:{}, endpoint:(window.HMS_DB&&window.HMS_DB.endpoint)||null, lastError:(window.HMS_DB&&window.HMS_DB.lastError)||null };
    Object.keys(d).forEach(function(k){
      var arr = d[k];
      if(!isRecArr(arr)) return;
      var withRev=0;
      for(var i=0;i<arr.length;i++){ if(typeof arr[i]._rev==='number') withRev++; }
      out.collections[k] = { total:arr.length, revStamped:withRev };
    });
    return out;
  };

  // ── Boot / periodic enforcement ────────────────────────────────────────
  function boot(){
    captureBaseline();
    wrapCreate();
    wrapDelete();
  }

  function tick(){
    // Re-wrap in case a later pack replaced the handlers, then backfill+save
    // any newly-created records that slipped in without a _rev.
    wrapCreate();
    wrapDelete();
    var changed = backfillRevs();
    if(changed) saveSoon();   // debounced — coalesce with other writes
  }

  function ready(fn){ if(window.D){ fn(); } else setTimeout(function(){ ready(fn); },120); }

  ready(function(){
    boot();
    [0,300,900,1800,3500].forEach(function(ms){ setTimeout(boot, ms); });
    // Steady-state reconciler: cheap, only saves when it actually stamps.
    DOMBus.register(tick);
    // Belt-and-braces: flush any pending stamps when the tab is hidden/closed.
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState==='hidden'){ try{ if(backfillRevs() && window._hmsFlush) window._hmsFlush(); }catch(e){} }
    });
    try{
      console.log('%c\u2705 v171 \u2014 DB sync reliability: immediate save on create/delete + universal _rev backfill (transactions & edits now persist to Cloudflare D1)',
        'background:#065f46;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();

;

/* ==== /js/122-v172-rbac-hardening.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV172) return;            // idempotent
  window.__twhV172 = true;

  // ═══════════════════════════════════════════════════════════════════════
  // v172 — RBAC HARDENING
  //  1. Full, unrestricted access for Admin / Superadmin / System Administrator.
  //  2. Superadmin can see every transaction in the system (transactions module
  //     already lists all D.transactions, so this is granted via full access).
  //  3. Strict sidebar: users see ONLY the modules attached to their role —
  //     everything else is hidden (already enforced by buildNav→hasModuleAccess,
  //     here we make grants authoritative so no stray module leaks through).
  //  4. Front Desk Officer keeps a Register-Patient link + view/edit/delete/print
  //     (the patients module already provides these; we guarantee the grant and
  //     add a Delete action for non-admitted patients).
  // ═══════════════════════════════════════════════════════════════════════

  function D(){ return window.D || (window.D = {}); }

  // Roles that get everything. Case-insensitive match on these canonical names.
  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator'];
  function isSuperRole(role){
    if(!role) return false;
    return SUPER_ROLES.indexOf(String(role).trim().toLowerCase()) >= 0;
  }
  window.__hmsIsSuperRole = isSuperRole;

  // ── PART 1: full-access short-circuit in the access helpers ─────────────
  function patchAccessHelpers(){
    try{
      var d = D();
      // hasModuleAccess: grant everything to super roles (respect enabled flag).
      var origMod = window.hasModuleAccess;
      if(typeof origMod==='function' && !origMod.__v172){
        var wrappedMod = function(modId){
          try{
            var u = (typeof currentUserObj==='function') ? currentUserObj() : (d.currentUser||null);
            var role = u && u.role;
            if(isSuperRole(role)){
              // still respect a hard-disabled module, but never role-restrict.
              try{ if(typeof isModuleEnabled==='function' && !isModuleEnabled(modId)){
                     var m=d.moduleRegistry&&d.moduleRegistry[modId];
                     if(!(m&&m.locked)) return false;
                   } }catch(e){}
              return true;
            }
          }catch(e){}
          return origMod.apply(this, arguments);
        };
        wrappedMod.__v172 = true;
        window.hasModuleAccess = wrappedMod;
      }
      // hasFeatureAccess: super roles get every feature.
      var origFeat = window.hasFeatureAccess;
      if(typeof origFeat==='function' && !origFeat.__v172){
        var wrappedFeat = function(modId, featKey){
          try{
            var u = (typeof currentUserObj==='function') ? currentUserObj() : (d.currentUser||null);
            if(isSuperRole(u && u.role)) return true;
          }catch(e){}
          return origFeat.apply(this, arguments);
        };
        wrappedFeat.__v172 = true;
        window.hasFeatureAccess = wrappedFeat;
      }
    }catch(e){ try{ console.warn('[v172] patchAccessHelpers failed', e); }catch(_){} }
  }

  // ── PART 2: authoritative grants ───────────────────────────────────────
  // Grant ALL modules to the super roles, and guarantee Front Desk keeps the
  // patient-registration module + its supporting screens.
  var FRONT_DESK = ['dashboard','patients','appointments','laboratory','radiology',
                    'billing','receivables','apar','transactions','selfservice','reports'];

  function applyGrants(){
    try{
      var d = D();
      d.responsibilities = d.responsibilities || {};
      if(!d.moduleRegistry) return;
      var ALL = Object.keys(d.moduleRegistry);
      var allMap = {};
      ALL.forEach(function(id){ allMap[id] = true; });

      // Full access for the super roles (authoritative overwrite).
      ['System Administrator','Admin','Superadmin','Super Admin','Administrator'].forEach(function(role){
        var m = {};
        ALL.forEach(function(id){ m[id] = true; });
        d.responsibilities[role] = m;
      });

      // Front Desk Officer: guarantee patient registration + supporting modules.
      var fd = d.responsibilities['Front Desk Officer'] || {};
      FRONT_DESK.forEach(function(id){ if(id in allMap) fd[id] = true; });
      d.responsibilities['Front Desk Officer'] = fd;
      // legacy alias
      var rec = d.responsibilities['Reception'] || {};
      FRONT_DESK.forEach(function(id){ if(id in allMap) rec[id] = true; });
      d.responsibilities['Reception'] = rec;
    }catch(e){ try{ console.warn('[v172] applyGrants failed', e); }catch(_){} }
  }

  // ── PART 3: make Superadmin selectable + a recognised system role ───────
  function registerRole(){
    try{
      var d = D();
      d.settings = d.settings || {};
      if(Array.isArray(d.settings.systemRoles)){
        ['Superadmin','Admin'].forEach(function(r){
          if(d.settings.systemRoles.indexOf(r)<0) d.settings.systemRoles.push(r);
        });
      }
      // Add Superadmin to the login role <select> if present and missing.
      var sel = document.getElementById('loginRole');
      if(sel && !Array.prototype.some.call(sel.options,function(o){return o.value==='Superadmin';})){
        var opt = document.createElement('option');
        opt.value = 'Superadmin'; opt.textContent = 'Superadmin';
        sel.insertBefore(opt, sel.firstChild);
      }
    }catch(e){}
  }

  // ── PART 4: Front Desk — ensure a Delete action on patient rows ─────────
  // The patients table already renders View/Edit/Print and Discharge (for
  // admitted). Add a plain Delete for non-admitted patients so Front Desk can
  // remove erroneous registrations, using the standard deleteRecord path
  // (which tombstones + persists to D1).
  function addPatientDelete(){
    try{
      if(!document.getElementById('__v172_patDelStyle')){
        // nothing to style; guard flag only
        var s=document.createElement('style'); s.id='__v172_patDelStyle'; document.head.appendChild(s);
      }
      // v200: Front Desk Officers / Reception must NOT be able to delete a
      // patient. Never inject a patient Delete button for those roles.
      try{
        var _u = (typeof currentUserObj==='function') ? currentUserObj() : ((window.D&&window.D.currentUser)||null);
        var _role = (_u && _u.role ? String(_u.role) : '').trim().toLowerCase();
        var _blocked = ['front desk officer','front desk','front-desk officer','reception','receptionist'];
        if(_blocked.indexOf(_role) >= 0) return;
      }catch(e){}
      var rows = document.querySelectorAll('#content .tbl tbody tr, .tbl tbody tr');
      // Only act on the patients module to avoid touching other tables.
      if(typeof currentMod!=='undefined' && currentMod!=='patients') return;
      rows.forEach(function(tr){
        var actRow = tr.querySelector('.act-row');
        if(!actRow) return;
        if(actRow.querySelector('.__v172_del')) return;               // already added
        var editBtn = actRow.querySelector('button[onclick*="editRecord(\'patients\'"]');
        if(!editBtn) return;
        var m = editBtn.getAttribute('onclick').match(/editRecord\('patients',\s*(\d+)\)/);
        if(!m) return;
        var pid = m[1];
        // skip if a discharge/delete already exists for this admitted patient
        var btn = document.createElement('button');
        btn.className = 'act-btn del __v172_del';
        btn.title = 'Delete';
        btn.setAttribute('onclick', "deleteRecord('patients',"+pid+")");
        btn.innerHTML = '<i class="fa-solid fa-trash"></i>';
        actRow.appendChild(btn);
      });
    }catch(e){}
  }

  // ── Boot / periodic enforcement ────────────────────────────────────────
  function boot(){
    patchAccessHelpers();
    applyGrants();
    registerRole();
  }

  function ready(fn){ if(window.D){ fn(); } else setTimeout(function(){ ready(fn); },120); }

  ready(function(){
    boot();
    [0,300,900,1800,3500].forEach(function(ms){ setTimeout(boot, ms); });
    DOMBus.register(function(){ patchAccessHelpers(); applyGrants(); });
    // Add the Front-Desk delete button after each render of the patients module.
    if(typeof window.render==='function'){
      var _r = window.render;
      if(!_r.__v172){
        var wrapped = function(){ var out=_r.apply(this,arguments); try{ setTimeout(addPatientDelete,0); }catch(e){} return out; };
        // preserve prior flags set by other packs
        ['__v161','__v160','__v169','__v170'].forEach(function(f){ if(_r[f]) wrapped[f]=_r[f]; });
        wrapped.__v172 = true;
        window.render = wrapped;
      }
    }
    DOMBus.register(addPatientDelete);
    try{
      console.log('%c\u2705 v172 \u2014 RBAC: full access for Admin/Superadmin \u00b7 strict role-scoped sidebar \u00b7 Front Desk register+CRUD \u00b7 Superadmin sees all transactions',
        'background:#4338ca;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();

;

/* ==== /js/123-v173-sidebar-sub-module-scoping.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV173) return;            // idempotent
  window.__twhV173 = true;

  // ═══════════════════════════════════════════════════════════════════════
  // v173 — SIDEBAR MODULE + SUB-MODULE SCOPING (per role)
  //
  // Requirement: a user must see ONLY the modules AND the sub-modules attached
  // to their role. Everything else is hidden.
  //
  //  • Modules (top-level sidebar items) are already filtered by hasModuleAccess
  //    (v24 buildNav) + made authoritative by v172. v173 re-asserts and also
  //    prunes any stray sidebar item whose module the role can't access.
  //  • Sub-modules are the TABS inside a module page (Config, HR, Reports,
  //    Transactions, Billing, Accounting, Pharmacy, Inventory, Procurement,
  //    Dietary, System Admin, ...). These were only toggled GLOBALLY before.
  //    v173 adds PER-ROLE sub-module gating via D.responsibilitySubs and hides
  //    ungranted tab buttons after every render.
  //
  // Storage: D.responsibilitySubs = { role: { "mod.sub": true|false } }
  //   - Super roles (Admin/Superadmin/System Administrator) => all subs.
  //   - A role with NO entry for a module => sees ALL that module's subs
  //     (backward compatible) UNLESS a curated default scopes it down.
  //   - A role WITH an entry => sees ONLY subs explicitly set true.
  // ═══════════════════════════════════════════════════════════════════════

  function D(){ return window.D || (window.D = {}); }

  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator'];
  function isSuperRole(role){
    if(!role) return false;
    return SUPER_ROLES.indexOf(String(role).trim().toLowerCase()) >= 0;
  }
  function curRole(){
    try{
      var u = (typeof currentUserObj==='function') ? currentUserObj() : (D().currentUser||null);
      return u && u.role;
    }catch(e){ return null; }
  }

  // ── Map of every tabbed module: container id + the sub-module → tab keys.
  //    "keyFn" extracts the sub-key from a tab button's onclick attribute.
  var TAB_MODULES = {
    config:       { container:'configTabs', fn:'showConfigTab' },
    reports:      { container:'reportTabs', fn:'showReportTab' },
    hr:           { container:'hrTabs',     fn:'showHRTab' },
    transactions: { container:'txnTabs',    fn:'showTxnTab' },
    billing:      { container:'billTabs',   fn:'showBillTab' },
    accounting:   { container:'acctTabs',   fn:'showAcctTab' },
    pharmacy:     { container:'pharmTabs',  fn:'showPharmTab' },
    inventory:    { container:'invTabs',    fn:'showInvTab' },
    procurement:  { container:'procTabs',   fn:'showProcTab' },
    dietary:      { container:'dietTabs',   fn:'showDietTab' }
  };

  // ── Curated per-role sub-module defaults (only for roles that need scoping).
  //    Format: role -> { mod -> [allowed sub keys] }. Anything not listed here
  //    for a given (role, mod) means "see all subs of that module".
  var SUB_DEFAULTS = {
    'Front Desk Officer': {
      reports: ['standard','financial','operations']
    },
    'Nurse': {
      reports: ['standard','clinical','operations']
    },
    'Doctor': {
      reports: ['standard','clinical']
    },
    'Lab Scientist':  { reports: ['standard','clinical'] },
    'Lab Tech':       { reports: ['standard','clinical'] },
    'Pharmacist':     { reports: ['standard','financial','operations'] },
    'Pharm Tech':     { reports: ['standard','operations'] },
    'Nutritionist':   { reports: ['standard','clinical'] },
    'Business Development Manager': { reports: ['standard','financial'] },
    'Finance Manager': {
      hr:      ['claims','payroll'],
      reports: ['standard','financial','operations','compliance']
    },
    'HR Manager': {
      hr:      ['employees','attendance','leave','claims','payroll'],
      reports: ['standard','hr','operations']
    },
    'Auditor': {
      reports: ['standard','financial','compliance']
    }
  };

  // Seed D.responsibilitySubs from the curated defaults (idempotent, only for
  // roles/modules not already configured by an admin).
  function seedSubGrants(){
    try{
      var d = D();
      d.responsibilitySubs = d.responsibilitySubs || {};
      Object.keys(SUB_DEFAULTS).forEach(function(role){
        var rs = d.responsibilitySubs[role] = d.responsibilitySubs[role] || {};
        var mods = SUB_DEFAULTS[role];
        Object.keys(mods).forEach(function(mod){
          // Only seed if this role has NO explicit sub entries for this module yet.
          var hasAny = Object.keys(rs).some(function(k){ return k.indexOf(mod+'.')===0; });
          if(hasAny) return;
          mods[mod].forEach(function(sub){ rs[mod+'.'+sub] = true; });
        });
      });
    }catch(e){}
  }

  // ── Core check: can the current role see (mod, sub)?
  function hasSubAccess(mod, sub){
    try{
      var role = curRole();
      if(!role) return true;                 // login screen / framework
      if(isSuperRole(role)) return true;     // Admin/Superadmin see everything
      var d = D();
      var rs = d.responsibilitySubs && d.responsibilitySubs[role];
      if(!rs) return true;                    // no scoping for this role => all
      // Does this role have ANY explicit entry for this module?
      var prefix = mod+'.';
      var keys = Object.keys(rs).filter(function(k){ return k.indexOf(prefix)===0; });
      if(!keys.length) return true;           // module not scoped => all subs
      return rs[prefix+sub] === true;         // scoped => only explicit trues
    }catch(e){ return true; }
  }
  window.hasSubAccess = hasSubAccess;

  // Extract the sub-key from a tab button's onclick, e.g.
  // showConfigTab('departments')  -> "departments"
  function subKeyOf(btn, fnName){
    try{
      var oc = btn.getAttribute('onclick') || '';
      var re = new RegExp(fnName.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+"\\(\\s*['\"]([^'\"]+)['\"]");
      var m = oc.match(re);
      return m ? m[1] : null;
    }catch(e){ return null; }
  }

  // ── Hide ungranted sub-module tabs in whatever tabbed module is showing.
  var _filtering = false;
  function filterSubTabs(){
    if(_filtering) return;
    _filtering = true;
    try{
      var role = curRole();
      var superUser = isSuperRole(role);
      Object.keys(TAB_MODULES).forEach(function(mod){
        var cfg = TAB_MODULES[mod];
        var cont = document.getElementById(cfg.container);
        if(!cont) return;
        var btns = cont.querySelectorAll('.tab-btn, button');
        var firstVisible = null, activeHidden = false;
        Array.prototype.forEach.call(btns, function(btn){
          var sub = subKeyOf(btn, cfg.fn);
          if(sub===null) return;              // not a sub-tab button (leave it)
          var allow = superUser ? true : hasSubAccess(mod, sub);
          if(allow){
            btn.style.display = '';
            if(!firstVisible) firstVisible = btn;
          }else{
            if(btn.classList.contains('active')) activeHidden = true;
            btn.style.display = 'none';
          }
        });
        // If the active tab got hidden, click the first visible tab instead.
        if(activeHidden && firstVisible){
          try{ firstVisible.click(); }catch(e){}
        }
      });
    }catch(e){}
    _filtering = false;
  }
  window.__hmsFilterSubTabs = filterSubTabs;

  // ── Guard the showXTab functions so a hidden sub can't be reached via code.
  function guardTabFns(){
    Object.keys(TAB_MODULES).forEach(function(mod){
      var cfg = TAB_MODULES[mod];
      var fn = window[cfg.fn];
      if(typeof fn!=='function' || fn.__v173) return;
      var wrapped = function(tab){
        try{
          var role = curRole();
          if(!isSuperRole(role) && tab && !hasSubAccess(mod, tab)){
            if(typeof toast==='function') toast('You do not have access to this section.','err');
            return;
          }
        }catch(e){}
        return fn.apply(this, arguments);
      };
      // preserve any prior wrapper flags (e.g. v30 config guard)
      wrapped.__v173 = true;
      window[cfg.fn] = wrapped;
    });
  }

  // ── Re-assert module-level scoping (belt & braces with v172/v24 buildNav).
  function rebuildSidebar(){
    try{
      if(typeof window.buildNav==='function'){
        var sb = document.getElementById('sidebarNav') || document.querySelector('.sb-nav') || document.getElementById('navItems');
        // buildNav is invoked by render(); we just make sure grants are fresh.
      }
    }catch(e){}
  }

  // ── Boot ────────────────────────────────────────────────────────────────
  function boot(){
    seedSubGrants();
    guardTabFns();
  }

  function afterRender(){
    guardTabFns();
    setTimeout(filterSubTabs, 0);
    setTimeout(filterSubTabs, 120);
  }

  function ready(fn){ if(window.D){ fn(); } else setTimeout(function(){ ready(fn); },120); }

  ready(function(){
    boot();
    [0,300,900,1800,3500].forEach(function(ms){ setTimeout(boot, ms); });

    // Wrap render so sub-tabs are filtered after every repaint.
    if(typeof window.render==='function'){
      var _r = window.render;
      if(!_r.__v173){
        var wrapped = function(){ var out=_r.apply(this,arguments); try{ afterRender(); }catch(e){} return out; };
        ['__v161','__v160','__v169','__v170','__v172'].forEach(function(f){ if(_r[f]) wrapped[f]=_r[f]; });
        wrapped.__v173 = true;
        window.render = wrapped;
      }
    }

    // Also filter on click within a tab row (tabs can be re-rendered inline).
    document.addEventListener('click', function(ev){
      try{
        var t = ev.target;
        while(t && t!==document.body){
          if(t.id && /Tabs$/.test(t.id)){ setTimeout(filterSubTabs, 0); break; }
          t = t.parentNode;
        }
      }catch(e){}
    }, true);

    DOMBus.register(function(){ seedSubGrants(); guardTabFns(); filterSubTabs(); });
    filterSubTabs();

    try{
      console.log('%c\u2705 v173 \u2014 Sidebar module + per-role SUB-MODULE scoping: users now see only the sub-modules attached to their role',
        'background:#7c2d12;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();

;

/* ==== /js/124-v174-dynamic-role-based-sidebar.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v174 — DYNAMIC ROLE-BASED SIDEBAR (authoritative)
   ---------------------------------------------------------------------------
   Implements the exact role → module map requested by the product owner:
     • Sidebar shows ONLY the modules attached to the authenticated role.
       Everything else is completely OMITTED from the DOM (not just disabled).
     • Each visible item routes to the correct page and highlights when active
       (buildNav already applies the `active` class on currentMod — preserved).
     • Role-aware LABELS: the same module can display a role-specific label
       (e.g. "Register Patients" for Front Desk, "Patients (View Record)" for
       Nutritionist) via a per-role label override map.
     • VIEW-ONLY modules ("(View Record)" / "(view)"): the sidebar link is shown
       but the page is forced read-only — Create/Edit/Delete/Discharge/etc.
       controls are hidden via a DOM sweep + a read-only banner.
     • Single "Reports" link → the Reports page is already role-filtered by the
       v56 pack; v174 aligns its super-role check and guarantees the tab exists.
     • Admin / Superadmin (all super roles, case-insensitive) get EVERY module
       and sub-module, fully functional.
     • Centralised, maintainable config: getModulesForRole(role) returns
       [{ id, label, access }] so new roles/modules are one-line edits.

   Idempotent, self-contained IIFE. Binds to live window.D. Re-asserts on boot
   timers + a low-freq interval + MutationObserver so it survives re-renders.
   =========================================================================== */
(function(){
  if (window.__twhV174) return;
  window.__twhV174 = true;

  function D(){ return (typeof window.D!=='undefined') ? window.D : (typeof D!=='undefined'?D:null); }

  /* ───────────────────────── super-role helpers ───────────────────────── */
  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator'];
  function isSuperRole(role){
    return !!role && SUPER_ROLES.indexOf(String(role).trim().toLowerCase()) >= 0;
  }
  function curRole(){
    try {
      var d = D();
      if (window.currentUserObj) { var u = window.currentUserObj(); if (u && u.role) return u.role; }
      if (d && d.currentUser && d.currentUser.role) return d.currentUser.role;
    } catch(e){}
    return 'Staff';
  }

  /* ═══════════════════ PART 1 — CANONICAL MODULE REGISTRY ═══════════════════
     Backfill any module the grants reference but that is missing / malformed in
     D.moduleRegistry. Mirrors the app's CANON so labels/groups/icons are right. */
  var CANON = {
    dashboard:{g:'Core',l:'Dashboard',i:'fa-home',lock:true},
    /* Clinical */
    patients:{g:'Clinical',l:'Patients',i:'fa-user-injured'},
    appointments:{g:'Clinical',l:'Appointments',i:'fa-calendar-check'},
    calendar:{g:'Clinical',l:'Appointment Calendar',i:'fa-calendar-alt'},
    emr:{g:'Clinical',l:'Medical Records',i:'fa-file-medical'},
    prescriptions:{g:'Clinical',l:'Prescriptions',i:'fa-prescription'},
    laboratory:{g:'Clinical',l:'Laboratory',i:'fa-flask'},
    radiology:{g:'Clinical',l:'Radiology',i:'fa-x-ray'},
    referrals:{g:'Clinical',l:'Referral Mgmt',i:'fa-share-square'},
    physio:{g:'Clinical',l:'Physiotherapy',i:'fa-person-walking'},
    reflexrules:{g:'Clinical',l:'Lab Reflex Rules',i:'fa-diagram-project'},
    wellness:{g:'Clinical',l:'Wellness Screening',i:'fa-heart-pulse'},
    mealplanner:{g:'Clinical',l:'Meal Planner',i:'fa-utensils'},
    nutrition:{g:'Clinical',l:'Dietary Nutrient Calc',i:'fa-bowl-food'},
    /* Operations */
    pharmacy:{g:'Operations',l:'Pharmacy',i:'fa-pills'},
    pharmacyplus:{g:'Operations',l:'Pharmacy \u2014 Clinical & Operations',i:'fa-prescription'},
    invabc:{g:'Operations',l:'Inventory ABC / Counts',i:'fa-warehouse'},
    /* Management */
    transactions:{g:'Management',l:'Transactions',i:'fa-exchange-alt'},
    billing:{g:'Management',l:'Billing & Finance',i:'fa-file-invoice-dollar'},
    bizdev:{g:'Management',l:'Business Development',i:'fa-handshake'},
    fixedassets:{g:'Management',l:'Fixed Assets',i:'fa-building'},
    accounting:{g:'Management',l:'Accounting',i:'fa-calculator'},
    finctl:{g:'Management',l:'Financial Controls',i:'fa-scale-balanced'},
    denialwf:{g:'Management',l:'Claims Denial Workflow',i:'fa-file-circle-xmark'},
    treasury:{g:'Management',l:'Treasury & Cash',i:'fa-money-check-dollar'},
    capitation:{g:'Management',l:'Capitation Recon',i:'fa-users-line'},
    assetcap:{g:'Management',l:'Asset Impairment & CWIP',i:'fa-arrow-trend-down'},
    budgetanalytics:{g:'Management',l:'Budget Analytics',i:'fa-chart-line'},
    payrollplus:{g:'Management',l:'Off-Cycle Payroll',i:'fa-money-bill-transfer'},
    hr:{g:'Management',l:'HR & Payroll',i:'fa-user-tie'},
    inventory:{g:'Management',l:'Inventory',i:'fa-boxes'},
    procurement:{g:'Management',l:'Procurement',i:'fa-shopping-cart'},
    apar:{g:'Management',l:'AP/AR Overview',i:'fa-scale-balanced'},
    receivables:{g:'Management',l:'Receivables (AR)',i:'fa-hand-holding-dollar'},
    payables:{g:'Management',l:'Payables (AP)',i:'fa-money-bill-wave'},
    reports:{g:'Management',l:'Reports',i:'fa-chart-bar'},
    /* Clinical Support */
    crm:{g:'Clinical Support',l:'Call Center / CRM',i:'fa-phone-volume'},
    /* Reporting Center */
    prodcenter:{g:'Reporting Center',l:'Production Center \u2014 Sync & Integrity',i:'fa-industry'},
    livereports:{g:'Reporting Center',l:'Live Reports \u2014 Auto-refreshing',i:'fa-chart-line'},
    customrpt:{g:'Reporting Center',l:'Custom Report Builder',i:'fa-table-list'},
    /* Services */
    ai:{g:'Services',l:'Tranquil AI',i:'fa-wand-magic-sparkles'},
    /* Self-Service */
    selfservice:{g:'Self-Service',l:'My Self-Service (ESS)',i:'fa-id-badge'}
  };

  function ensureRegistry(){
    try {
      var d = D(); if (!d) return;
      d.moduleRegistry = d.moduleRegistry || {};
      Object.keys(CANON).forEach(function(id){
        var c = CANON[id];
        var m = d.moduleRegistry[id];
        if (!m || typeof m!=='object') {
          d.moduleRegistry[id] = { id:id, label:c.l, group:c.g, icon:c.i,
            enabled:true, locked:!!c.lock, features:{}, subModules:{} };
          return;
        }
        if (!m.id) m.id = id;
        if (!m.label || m.label==='\u2014' || m.label==='-') m.label = c.l;
        if (!m.group || m.group==='\u2014' || m.group==='Other') m.group = c.g;
        if (!m.icon  || m.icon==='fa-cube') m.icon = c.i;
        if (typeof m.enabled==='undefined') m.enabled = true;
        if (c.lock) m.locked = true;
        if (typeof m.locked==='undefined') m.locked = false;
        if (!m.features || typeof m.features!=='object') m.features = {};
      });
    } catch(e){ try{console.warn('[v174] ensureRegistry',e);}catch(_){} }
  }

  /* ═══════════════════ PART 2 — ROLE → MODULE MAP (exact spec) ═══════════════
     access: 'full' | 'view'.  View modules show the sidebar link but the page
     is forced read-only.  Order here = order preference within each group. */
  var ROLE_MODULES = {
    'Front Desk Officer': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'patients',     label:'Patient',                access:'full'},
      {id:'appointments', label:'Appointment',            access:'full'},
      {id:'laboratory',   label:'Laboratory',             access:'full'},
      {id:'radiology',    label:'Radiology',              access:'full'},
      {id:'receivables',  label:'Receivable (AR)',        access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'}
    ],
    'Nurse': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'emr',          label:'Create Medical Records', access:'full'},
      {id:'referrals',    label:'Referral Mgmt',          access:'full'},
      {id:'appointments', label:'Appointments',           access:'full'},
      {id:'physio',       label:'Physiotherapy',          access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'}
    ],
    'Lab Scientist': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'emr',          label:'Medical Records',        access:'full'},
      {id:'referrals',    label:'Referral Mgmt',          access:'full'},
      {id:'laboratory',   label:'Laboratory',             access:'full'},
      {id:'reflexrules',  label:'Lab Reflex Rules',       access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'}
    ],
    'Nutritionist': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'patients',     label:'Patients (View Record)', access:'view'},
      {id:'appointments', label:'Appointments (View Record)', access:'view'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'},
      {id:'wellness',     label:'Wellness Screening',     access:'full'},
      {id:'mealplanner',  label:'Meal Planner',           access:'full'},
      {id:'nutrition',    label:'Dietary Nutrient Calc',  access:'full'}
    ],
    'Pharmacist': [
      {id:'dashboard',    label:'Dashboard',                        access:'full'},
      {id:'emr',          label:'Medical Records',                  access:'full'},
      {id:'referrals',    label:'Referral Mgmt',                    access:'full'},
      {id:'appointments', label:'Appointments',                     access:'full'},
      {id:'prescriptions',label:'Prescriptions',                    access:'full'},
      {id:'pharmacyplus', label:'Pharmacy \u2014 Clinical & Operations', access:'full'},
      {id:'pharmacy',     label:'Pharmacy',                         access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',            access:'full'},
      {id:'reports',      label:'Reports',                          access:'full'}
    ],
    'Business Development Manager': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'bizdev',       label:'Business Development',   access:'full'},
      {id:'crm',          label:'Call Center / CRM',      access:'full'},
      {id:'appointments', label:'Appointments',           access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'},
      {id:'emr',          label:'Medical Record (view)',  access:'view'}
    ],
    'Doctor': [
      {id:'dashboard',    label:'Dashboard',              access:'full'},
      {id:'appointments', label:'Appointments',           access:'full'},
      {id:'laboratory',   label:'Laboratory',             access:'full'},
      {id:'radiology',    label:'Radiology',              access:'full'},
      {id:'selfservice',  label:'My Self-Service (ESS)',  access:'full'},
      {id:'reports',      label:'Reports',                access:'full'},
      {id:'emr',          label:'Medical Record',         access:'full'},
      {id:'prescriptions',label:'Prescriptions',          access:'full'}
    ],
    'Finance Manager': [
      {id:'dashboard',       label:'Dashboard',                          access:'full'},
      {id:'transactions',    label:'Transactions',                       access:'full'},
      {id:'bizdev',          label:'Business Development',               access:'full'},
      {id:'fixedassets',     label:'Fixed Assets',                       access:'full'},
      {id:'accounting',      label:'Accounting',                         access:'full'},
      {id:'finctl',          label:'Financial Controls',                 access:'full'},
      {id:'denialwf',        label:'Claims Denial Workflow',             access:'full'},
      {id:'treasury',        label:'Treasury & Cash',                    access:'full'},
      {id:'capitation',      label:'Capitation Recon',                   access:'full'},
      {id:'assetcap',        label:'Asset Impairment & CWIP',            access:'full'},
      {id:'budgetanalytics', label:'Budget Analytics',                   access:'full'},
      {id:'payrollplus',     label:'Off-Cycle Payroll',                  access:'full'},
      {id:'hr',              label:'HR & Payroll',                        access:'full'},
      {id:'inventory',       label:'Inventory',                          access:'full'},
      {id:'procurement',     label:'Procurement',                        access:'full'},
      {id:'apar',            label:'AP/AR Overview',                     access:'full'},
      {id:'receivables',     label:'Receivables (AR)',                   access:'full'},
      {id:'payables',        label:'Payables (AP)',                      access:'full'},
      {id:'reports',         label:'Reports',                            access:'full'},
      {id:'prodcenter',      label:'Production Center \u2014 Sync & Integrity', access:'full'},
      {id:'livereports',     label:'Live Reports \u2014 Auto-refreshing',     access:'full'},
      {id:'customrpt',       label:'Custom Report Builder',              access:'full'},
      {id:'selfservice',     label:'My Self-Service (ESS)',              access:'full'}
    ]
  };
  /* Lab Tech / Pharm Tech mirror their senior roles */
  ROLE_MODULES['Lab Tech']  = ROLE_MODULES['Lab Scientist'];
  ROLE_MODULES['Pharm Tech'] = ROLE_MODULES['Pharmacist'];

  /* ── Grant Tranquil AI to EVERY role (role-scoped) ──────────────────────────
     User request: "Grant access to all users for the Tranquil AI but should be
     based on the roles and Responsibilities." Every mapped role gets the `ai`
     module appended to its allow-list (so the sidebar link appears and
     hasModuleAccess('ai') passes) — but each role STILL only sees the rest of
     its own module set, so access remains role/responsibility scoped. Super
     roles already get every module including `ai`. Idempotent: only appends
     when the role does not already list `ai`. */
  (function grantAIToAllRoles(){
    Object.keys(ROLE_MODULES).forEach(function(role){
      var list = ROLE_MODULES[role];
      if (!Array.isArray(list)) return;
      var has = list.some(function(m){ return m && m.id === 'ai'; });
      if (!has) list.push({ id:'ai', label:'Tranquil AI', access:'full' });
    });
  })();

  /* Public, centralised accessor.  Super roles → EVERY module, full access. */
  window.getModulesForRole = function(role){
    if (isSuperRole(role)) {
      var d = D(); var out = [];
      if (d && d.moduleRegistry) {
        Object.keys(d.moduleRegistry).forEach(function(id){
          var m = d.moduleRegistry[id];
          out.push({ id:id, label:(m&&m.label)||id, access:'full' });
        });
      }
      return out;
    }
    return (ROLE_MODULES[role] || ROLE_MODULES[String(role||'').trim()] ||
            [{id:'dashboard',label:'Dashboard',access:'full'},
             {id:'selfservice',label:'My Self-Service (ESS)',access:'full'}]).slice();
  };
  window.__ROLE_MODULES = ROLE_MODULES; /* expose for tests / debugging */

  /* Canonical short labels the UX spec pins for EVERY role (incl. super/admin).
     Sidebar "Register Patient" → "Patient", "Create an Appointment" → "Appointment". */
  var LABEL_OVERRIDE = { patients:'Patient', appointments:'Appointment' };

  /* Role-aware label lookup for the sidebar (module id → label for curRole). */
  function labelFor(role, id){
    if (LABEL_OVERRIDE.hasOwnProperty(id)) return LABEL_OVERRIDE[id];
    if (isSuperRole(role)) { var d=D(); var m=d&&d.moduleRegistry&&d.moduleRegistry[id]; return (m&&m.label)||id; }
    var list = ROLE_MODULES[role] || [];
    for (var i=0;i<list.length;i++){ if (list[i].id===id) return list[i].label; }
    var d2=D(); var m2=d2&&d2.moduleRegistry&&d2.moduleRegistry[id]; return (m2&&m2.label)||id;
  }
  /* access mode ('full'|'view') for a module under a role. */
  function accessFor(role, id){
    if (isSuperRole(role)) return 'full';
    var list = ROLE_MODULES[role] || [];
    for (var i=0;i<list.length;i++){ if (list[i].id===id) return list[i].access||'full'; }
    return 'full';
  }
  window.moduleAccessMode = accessFor; /* e.g. moduleAccessMode(role,'emr') */

  /* ═══════════════════ PART 3 — APPLY GRANTS AUTHORITATIVELY ════════════════ */
  function applyGrants(){
    try {
      var d = D(); if (!d) return;
      d.responsibilities = d.responsibilities || {};
      /* Every mapped role: EXACT module set, no extras leak. */
      Object.keys(ROLE_MODULES).forEach(function(role){
        var map = {};
        ROLE_MODULES[role].forEach(function(m){ map[m.id] = true; });
        d.responsibilities[role] = map;
      });
      /* Super roles: ALL modules. */
      if (d.moduleRegistry) {
        var all = {};
        Object.keys(d.moduleRegistry).forEach(function(id){ all[id] = true; });
        ['System Administrator','Admin','Superadmin','Super Admin','Administrator'].forEach(function(r){
          d.responsibilities[r] = Object.assign({}, all);
        });
      }
    } catch(e){ try{console.warn('[v174] applyGrants',e);}catch(_){} }
  }

  /* ═══════════════════ PART 4 — ROLE-AWARE SIDEBAR LABELS ═══════════════════
     buildNav renders m.label. We wrap it so labels reflect the current role,
     then keep the DOM in sync (in case buildNav is re-wrapped by later packs). */
  function relabelSidebar(){
    try {
      var role = curRole();
      var host = document.querySelector('.sidebar') || document.getElementById('sidebar') || document;
      var btns = host.querySelectorAll('.sb-item[onclick]');
      Array.prototype.forEach.call(btns, function(b){
        var oc = b.getAttribute('onclick')||'';
        var m = /goTo\(['"]([a-zA-Z0-9_]+)['"]\)/.exec(oc);
        if (!m) return;
        var id = m[1];
        var span = b.querySelector('span');
        if (!span) return;
        var want = labelFor(role, id);
        if (want && span.textContent !== want) span.textContent = want;
      });
    } catch(e){}
  }

  /* ═══════════════════ PART 5 — VIEW-ONLY PAGE ENFORCEMENT ══════════════════
     When the current module is 'view' for the current role, hide every
     create/edit/delete/discharge control on the page and show a banner. */
  var VIEW_HIDE_SELECTORS = [
    '.act-btn.edit', '.act-btn.del',
    'button[onclick*="addNewRecord"]', 'button[onclick*="editRecord"]',
    'button[onclick*="deleteRecord"]', 'button[onclick*="showDischargeWorkflow"]',
    'button[onclick*="showAdmissionWorkflow"]', 'button[onclick*="showPatientMerge"]',
    'button[onclick*="showDuplicateCheck"]', 'button[onclick*="bookAppointment"]',
    'button[onclick*="addAppointment"]', 'button[onclick*="rescheduleAppt"]',
    'button[onclick*="cancelAppt"]', 'button[onclick*="openBulkImport"]',
    'button[onclick*="showPatientSelfRegistration"]', 'button[onclick*="setPatientCategory"]',
    'button[onclick*="editEMR"]', 'button[onclick*="amendEMR"]', 'button[onclick*="newEMR"]'
  ];
  function viewOnlySweep(){
    try {
      var role = curRole();
      var mod = window.currentMod;
      if (isSuperRole(role) || !mod) { removeBanner(); return; }
      if (accessFor(role, mod) !== 'view') { removeBanner(); return; }
      var app = document.getElementById('app') || document;
      VIEW_HIDE_SELECTORS.forEach(function(sel){
        Array.prototype.forEach.call(app.querySelectorAll(sel), function(el){ el.style.display='none'; });
      });
      /* keep only "View"/print/export actions; hide any button explicitly labelled edit/delete */
      Array.prototype.forEach.call(app.querySelectorAll('.act-btn'), function(el){
        var t = (el.getAttribute('title')||'').toLowerCase();
        if (/edit|delete|discharge|transfer bed|merge|category/.test(t)) el.style.display='none';
      });
      showBanner(app);
    } catch(e){}
  }
  function showBanner(app){
    if (document.getElementById('v174RoBanner')) return;
    var host = document.getElementById('moduleContent') || app;
    if (!host || !host.insertBefore) return;
    var div = document.createElement('div');
    div.id = 'v174RoBanner';
    div.style.cssText = 'margin:0 0 12px;padding:10px 14px;border-radius:10px;background:linear-gradient(135deg,#fef3c7,#fde68a);color:#78350f;font-size:12px;font-weight:600;display:flex;align-items:center;gap:8px;border:1px solid #f59e0b';
    div.innerHTML = '<i class="fa-solid fa-lock"></i> Read-only view — you can view records for this module but cannot create, edit or delete.';
    host.insertBefore(div, host.firstChild);
  }
  function removeBanner(){ var b=document.getElementById('v174RoBanner'); if(b&&b.parentNode) b.parentNode.removeChild(b); }

  /* ── GRANT create-action sweep (positive counterpart to viewOnlySweep) ──────
     User request:
       "Grant access for front desk office Register Patients on Patient page"
       "Grant access for front desk office new appointment on Appointment page"
     When the current role has FULL access to the patients / appointments module,
     the primary create button on that page (Register Patient / New Appointment)
     MUST be visible and clickable — even if an earlier RBAC sweep hid it. This
     re-shows it. Idempotent + diff-guarded: only clears an inline
     display:none we don't want, so it never fights the DOMBus observer. */
  var GRANT_MAP = {
    patients:     ['button[onclick*="addNewRecord(\'patients\'"]', 'button[onclick*="V25_addHousehold"]'],
    appointments: ['button[onclick*="addNewRecord(\'appointments\'"]', 'button[onclick*="bookAppointment"]', 'button[onclick*="addAppointment"]']
  };
  function grantCreateSweep(){
    try {
      var role = curRole();
      var mod = window.currentMod;
      if (!mod || !GRANT_MAP[mod]) return;
      // Only assert visibility when the role is actually allowed to create here.
      if (!isSuperRole(role) && accessFor(role, mod) !== 'full') return;
      var app = document.getElementById('app') || document;
      GRANT_MAP[mod].forEach(function(sel){
        Array.prototype.forEach.call(app.querySelectorAll(sel), function(el){
          // Un-hide: only write when currently hidden (diff-guarded → no churn).
          if (el.style.display === 'none') el.style.display = '';
          if (el.hasAttribute('disabled')) el.removeAttribute('disabled');
          if (el.style.pointerEvents === 'none') el.style.pointerEvents = '';
        });
      });
    } catch(e){}
  }

  /* ═══════════════════ PART 6 — REPORTS super-role alignment ════════════════
     The v56 pack filters reports for non-full roles. Ensure super roles are
     treated as "full" there too (it already whitelists System Administrator/CEO,
     but Admin/Superadmin should also see everything). We expose a global flag
     the v56 pack's isFull() can't see, so instead we guarantee super-role
     responsibilities include every report sub via hasSubAccess (v173). */
  function ensureReportSubsForSuper(){
    try {
      var d = D(); if (!d) return;
      d.responsibilitySubs = d.responsibilitySubs || {};
      /* leave non-super roles to v173/v56 filtering; nothing to add here. */
    } catch(e){}
  }

  /* ═══════════════════ BOOT / RE-ASSERT ═══════════════════ */
  function apply(){
    ensureRegistry();
    applyGrants();
    ensureReportSubsForSuper();
    relabelSidebar();
    viewOnlySweep();
    grantCreateSweep();
  }

  /* Wrap render so labels + view-only re-apply after every re-render. */
  function wrapRender(){
    if (window.render && !window.render.__v174){
      var _r = window.render;
      window.render = function(){
        var out = _r.apply(this, arguments);
        try { relabelSidebar(); viewOnlySweep(); grantCreateSweep(); } catch(e){}
        return out;
      };
      window.render.__v174 = true;
    }
    if (window.buildNav && !window.buildNav.__v174){
      var _b = window.buildNav;
      window.buildNav = function(){
        var html = _b.apply(this, arguments);
        /* buildNav returns an HTML string; relabel happens on the DOM after render */
        return html;
      };
      window.buildNav.__v174 = true;
    }
  }

  function boot(){
    apply();
    wrapRender();
  }

  [0,300,900,1800,3500].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(function(){ try{ relabelSidebar(); viewOnlySweep(); grantCreateSweep(); }catch(e){} });

  /* MutationObserver: keep sidebar labels / view-only correct on DOM swaps. */
  try {
    var mo = DOMBus.__mo(function(){ relabelSidebar(); });
    if (document.body) mo.observe(document.body, {childList:true, subtree:true});
    else document.addEventListener('DOMContentLoaded', function(){ mo.observe(document.body,{childList:true,subtree:true}); });
  } catch(e){}

  try{ console.log('[v174] dynamic role-based sidebar active'); }catch(e){}
})();


;

/* ==== /js/125-v175-strict-role-allowlist-user-switch-blink-fix.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v175 — STRICT ROLE ALLOWLIST (final authority) + user-switch & blink fixes
   ---------------------------------------------------------------------------
   PROBLEM this fixes:
   Older enhancement packs (v53 "Reports-for-all", v117, v118, v162 grant-all,
   etc.) and the persisted D1 document keep ADDING modules back into
   D.responsibilities[role] on their own timers. So even after v174 sets the
   exact per-role map, extra modules (Medical Records, Prescriptions, Wellness,
   Meal Planner, …) leak into the Front Desk sidebar.

   SOLUTION:
   Make module access a hard ALLOWLIST that does NOT trust D.responsibilities
   for any mapped role. hasModuleAccess(id) for a mapped role returns true iff
   id is in that role's explicit list. Super roles → everything. This is the
   final wrapper (loads last) and cannot be undone by other packs' grant loops
   because it re-derives from the static map on every call.

   Also:
   • Fixes user-switch: on login/user change, force a clean re-derive + single
     re-render so the sidebar immediately reflects the new role.
   • Fixes screen blink: coalesces buildNav/sidebar rebuilds — the sidebar HTML
     is only rewritten when it actually changes (diff guard), killing the
     flicker/mutation loop.

   Idempotent IIFE (__twhV175). Binds to live window.D. Self-reasserting.
   =========================================================================== */
(function(){
  if (window.__twhV175) return;
  window.__twhV175 = true;

  function D(){ return (typeof window.D!=='undefined') ? window.D : (typeof D!=='undefined'?D:null); }

  /* ── super-role detection (case-insensitive) ── */
  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator','super system admin','ceo'];
  function isSuperRole(role){
    return !!role && SUPER_ROLES.indexOf(String(role).trim().toLowerCase()) >= 0;
  }

  /* ── exact per-role module allowlists (mirror v174 ROLE_MODULES ids) ── */
  var ALLOW = {
    'Front Desk Officer': ['dashboard','patients','appointments','laboratory','radiology','receivables','selfservice','reports'],
    'Nurse':              ['dashboard','emr','referrals','appointments','physio','selfservice','reports'],
    'Lab Scientist':      ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Lab Tech':           ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Nutritionist':       ['dashboard','patients','appointments','selfservice','reports','wellness','mealplanner','nutrition'],
    'Pharmacist':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Pharm Tech':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Business Development Manager': ['dashboard','bizdev','crm','appointments','selfservice','reports','emr'],
    'Doctor':             ['dashboard','appointments','laboratory','radiology','selfservice','reports','emr','prescriptions'],
    'Finance Manager':    ['dashboard','transactions','bizdev','fixedassets','accounting','finctl','denialwf','treasury','capitation','assetcap','budgetanalytics','payrollplus','hr','inventory','procurement','apar','receivables','payables','reports','prodcenter','livereports','customrpt','selfservice']
  };
  /* build a fast lookup set per role */
  var ALLOW_SET = {};
  Object.keys(ALLOW).forEach(function(role){
    var s = {}; ALLOW[role].forEach(function(id){ s[id]=true; }); ALLOW_SET[role] = s;
  });
  window.__ROLE_ALLOWLIST = ALLOW; /* expose for debugging/tests */

  function curRole(){
    try {
      var d = D();
      if (window.currentUserObj) { var u = window.currentUserObj(); if (u && u.role) return u.role; }
      if (d && d.currentUser && d.currentUser.role) return d.currentUser.role;
    } catch(e){}
    return 'Staff';
  }

  /* per-user override support: system admin can still explicitly grant extras. */
  function userOverride(modId){
    try {
      var d = D();
      var u = window.currentUserObj ? window.currentUserObj() : (d && d.currentUser);
      if (!u || u.id==null) return undefined;
      var ov = d.userOverrides && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov && (modId in ov)) return !!ov[modId];
    } catch(e){}
    return undefined;
  }

  /* ── THE authoritative access check ── */
  function strictHasAccess(modId){
    var role = curRole();
    if (isSuperRole(role)) return true;               /* admin/superadmin: all */
    var ov = userOverride(modId);                     /* explicit sysadmin grant/deny wins */
    if (ov !== undefined) return ov;
    var set = ALLOW_SET[role] || ALLOW_SET[String(role||'').trim()];
    if (set) return !!set[modId];                     /* mapped role → strict allowlist */
    /* unmapped role: minimal safe default */
    return modId==='dashboard' || modId==='selfservice';
  }

  /* Wrap hasModuleAccess so it is the FINAL word. Re-wrap if a later pack
     replaces it (idempotent via __v175 flag on the wrapper). */
  function installAccessGuard(){
    if (window.hasModuleAccess && window.hasModuleAccess.__v175) return;
    var prev = window.hasModuleAccess;
    var wrapped = function(modId){
      /* honour module-enabled/locked semantics from the core if present */
      try {
        if (typeof window.isModuleEnabled==='function' && !window.isModuleEnabled(modId)) {
          /* locked system modules (config/sysadmin) still visible to super roles */
          if (!isSuperRole(curRole())) return false;
        }
      } catch(e){}
      /* not logged in → let framework handle (login screen) */
      try {
        var u = window.currentUserObj ? window.currentUserObj() : (D() && D().currentUser);
        if (!u) return prev ? prev.apply(this, arguments) : true;
      } catch(e){}
      return strictHasAccess(modId);
    };
    wrapped.__v175 = true;
    window.hasModuleAccess = wrapped;
  }

  /* Keep D.responsibilities in sync with the allowlist too (so any code that
     reads it directly agrees with the guard). Authoritative overwrite. */
  function syncResponsibilities(){
    try {
      var d = D(); if (!d) return;
      d.responsibilities = d.responsibilities || {};
      Object.keys(ALLOW).forEach(function(role){
        var map = {};
        ALLOW[role].forEach(function(id){ map[id]=true; });
        d.responsibilities[role] = map;   /* overwrite — removes leaked extras */
      });
      /* super roles: everything present in the registry */
      if (d.moduleRegistry) {
        var all = {}; Object.keys(d.moduleRegistry).forEach(function(id){ all[id]=true; });
        ['System Administrator','Admin','Superadmin','Super Admin','Administrator','Super System Admin']
          .forEach(function(r){ d.responsibilities[r] = Object.assign({}, all); });
      }
    } catch(e){}
  }

  /* ═══════════════ USER-SWITCH FIX ═══════════════
     When the signed-in user/role changes, re-derive access + rebuild the
     sidebar exactly once so the new role's menu shows immediately. */
  var _lastUserSig = null;
  function userSig(){
    try {
      var u = window.currentUserObj ? window.currentUserObj() : (D() && D().currentUser);
      if (!u) return '__nologin__';
      return String(u.id!=null?u.id:'') + '|' + String(u.role||'');
    } catch(e){ return '__err__'; }
  }
  function onUserMaybeChanged(){
    var sig = userSig();
    if (sig === _lastUserSig) return;
    _lastUserSig = sig;
    installAccessGuard();
    syncResponsibilities();
    rebuildSidebar(true);   /* force one clean rebuild */
  }

  /* ═══════════════ SCREEN-BLINK FIX ═══════════════
     Coalesce sidebar rebuilds: only rewrite the nav DOM when its HTML actually
     changes. This kills the flicker caused by multiple packs re-rendering the
     same sidebar every few seconds. */
  var _lastNavHTML = null;
  function navContainer(){
    return document.getElementById('sidebarNav') ||
           document.querySelector('.sidebar .sb-nav') ||
           document.querySelector('.sidebar nav') ||
           document.querySelector('.sidebar');
  }
  function rebuildSidebar(force){
    try {
      if (typeof window.buildNav !== 'function') return;
      var html = window.buildNav();
      if (!force && html === _lastNavHTML) return;   /* no change → skip (anti-blink) */
      _lastNavHTML = html;
      var host = navContainer();
      if (host && host.innerHTML !== undefined) {
        /* Only touch the nav portion if we can find a dedicated container that
           holds sb-items; otherwise leave the full render to core (avoid nuking
           user card / backup buttons). We detect a nav container by presence of
           .sb-item children or an explicit id. */
        if (host.id==='sidebarNav' || host.querySelector('.sb-item')) {
          if (host.innerHTML !== html) host.innerHTML = html;
        }
      }
    } catch(e){}
  }

  /* ── boot / re-assert ── */
  function apply(){
    installAccessGuard();
    syncResponsibilities();
    onUserMaybeChanged();
  }

  /* Wrap render to re-assert the guard AFTER any core/other-pack render, and to
     coalesce the sidebar (anti-blink). Idempotent. */
  function wrapRender(){
    if (window.render && !window.render.__v175){
      var _r = window.render;
      window.render = function(){
        installAccessGuard();      /* ensure guard survives */
        var out = _r.apply(this, arguments);
        try { onUserMaybeChanged(); } catch(e){}
        return out;
      };
      window.render.__v175 = true;
    }
  }

  /* Hook the login flow: after login the app calls render(); our render wrap +
     the interval below catch the user change. Also patch a known logout reset. */
  function boot(){
    apply();
    wrapRender();
  }

  [0,120,400,900,1800,3500].forEach(function(t){ setTimeout(boot, t); });

  /* Low-frequency watchdog: re-assert guard + detect user switches. Kept light
     and diff-guarded so it never causes blink. */
  DOMBus.register(function(){
    try {
      installAccessGuard();
      onUserMaybeChanged();
      /* periodic responsibilities heal in case a pack re-bloated them */
      syncResponsibilities();
    } catch(e){}
  });

  /* Watch for login/user-card DOM changes to react instantly to user switches. */
  try {
    var mo = DOMBus.__mo(function(){ onUserMaybeChanged(); });
    function startObs(){ if (document.body) mo.observe(document.body, {childList:true, subtree:true}); }
    if (document.body) startObs();
    else document.addEventListener('DOMContentLoaded', startObs);
  } catch(e){}

  try{ console.log('%c✅ v175 — strict role allowlist (final authority) + user-switch/blink fix','background:#991b1b;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/126-v176-identity-reconcile-front-desk-register-pati.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v176 — IDENTITY RECONCILIATION (sidebar ↔ user-card) + Front-Desk Register
          Patient + hard removal of Backup/Restore buttons for every account
   ---------------------------------------------------------------------------
   PROBLEM (from screenshot):
   Header/sidebar said "Signed in as Miracle Oyekanmi — Nutritionist" (Nutritionist
   modules shown) while the bottom-left user card said "Yunusa Lamido — Front Desk
   Officer". Root cause: admin "Simulate user" (saSimulateUser) sets
   window.currentUser to the simulated user but leaves D.currentUser as the real
   logged-in user. currentUserObj()/RBAC read window.currentUser (→ sidebar), the
   user card reads D.currentUser (→ card). The two diverge → mismatch, and the
   role-scoped sidebar shows the wrong person.

   FIX:
   1. Reconcile identity: whenever simulation is active, mirror the simulated
      identity into D.currentUser so the user card, header banner, and the
      RBAC allowlist all agree. When simulation stops, restore the real user.
      Also patch saSimulateUser / saStopSimulate to keep D.currentUser in sync.
   2. The RBAC role source (used by v175) and the user card now always match.
   3. Ensure the Patients page always shows a working "Register Patient" button
      for Front Desk Officer (and any role allowed to create patients).
   4. Remove Backup / Restore buttons everywhere, for every account, and keep
      them removed if a later pack re-injects them (DOM sweep).

   Idempotent IIFE (__twhV176). Self-reasserting.
   =========================================================================== */
(function(){
  if (window.__twhV176) return;
  window.__twhV176 = true;

  function D(){ return (typeof window.D!=='undefined') ? window.D : (typeof D!=='undefined'?D:null); }

  /* ═══════════ 1. IDENTITY RECONCILIATION ═══════════ */
  function resolveEffectiveUser(){
    /* window.currentUser is the authoritative live identity: it is set at login
       and updated on simulate-start AND simulate-stop. Prefer it whenever valid
       so the card/sidebar always follow the true (or simulated) user, and revert
       correctly when simulation stops. Fall back to D.currentUser. */
    try {
      if (window.currentUser && window.currentUser.username) return window.currentUser;
    } catch(e){}
    var d = D();
    return (d && d.currentUser) || null;
  }

  /* Make D.currentUser reflect the *effective* (possibly simulated) identity so
     the user card + header banner match the sidebar. Returns true if it changed. */
  function reconcile(){
    try {
      var d = D(); if (!d) return false;
      var eff = resolveEffectiveUser();
      if (!eff || !eff.username) return false;
      var cur = d.currentUser || {};
      if (cur.username !== eff.username || cur.role !== eff.role || cur.fullName !== eff.fullName) {
        /* preserve branch/other fields from the matching appUser if present */
        var found = (d.appUsers||[]).find(function(x){ return x.username===eff.username; });
        d.currentUser = Object.assign({}, cur, {
          username: eff.username,
          fullName: eff.fullName || (found&&found.fullName) || eff.username,
          role:     eff.role || (found&&found.role) || 'Staff',
          id:       (eff.id!=null?eff.id : (found?found.id:cur.id))
        });
        return true;
      }
    } catch(e){}
    return false;
  }

  /* Patch the admin "Simulate user" flow so D.currentUser is kept in sync. */
  function patchSimulation(){
    if (window.saSimulateUser && !window.saSimulateUser.__v176){
      var _sim = window.saSimulateUser;
      window.saSimulateUser = function(){
        var r = _sim.apply(this, arguments);
        try { reconcile(); if (typeof window.render==='function') window.render(); } catch(e){}
        return r;
      };
      window.saSimulateUser.__v176 = true;
    }
    if (window.saStopSimulate && !window.saStopSimulate.__v176){
      var _stop = window.saStopSimulate;
      window.saStopSimulate = function(){
        var r = _stop.apply(this, arguments);
        try { reconcile(); if (typeof window.render==='function') window.render(); } catch(e){}
        return r;
      };
      window.saStopSimulate.__v176 = true;
    }
  }

  /* ═══════════ 2. FRONT DESK — REGISTER PATIENT BUTTON ═══════════ */
  var CREATE_PATIENT_ROLES = ['front desk officer','system administrator','admin','superadmin',
                              'super admin','administrator','super system admin','doctor','nurse','reception'];
  function canCreatePatient(){
    try {
      var d = D(); var u = d && d.currentUser;
      var role = (u && u.role) ? String(u.role).trim().toLowerCase() : '';
      return CREATE_PATIENT_ROLES.indexOf(role) >= 0;
    } catch(e){ return false; }
  }
  /* Remove any "Register Patient" button that THIS pack injected (data-v176rp)
     if it leaked into a NON-patients module — e.g. a stale injection carried
     over when the module switched from patients to inventory. We strip ONLY the
     data-v176rp button we own, so legitimate patient-create buttons elsewhere
     (dashboard quick-action tiles, the patients page's own button) are never
     touched. Idempotent + diff-guarded. */
  function stripStrayRegisterPatientBtn(){
    try {
      if (window.currentMod === 'patients') return;
      var scope = document.getElementById('moduleContent') || document.getElementById('app') || document.body;
      if (!scope) return;
      var nodes = scope.querySelectorAll('[data-v176rp]');
      Array.prototype.forEach.call(nodes, function(b){
        if (b && b.parentNode) b.parentNode.removeChild(b);
      });
    } catch(e){}
  }
  function ensureRegisterPatientBtn(){
    try {
      if (window.currentMod !== 'patients') { stripStrayRegisterPatientBtn(); return; }
      if (!canCreatePatient()) return;
      var root = document.getElementById('moduleContent') || document.getElementById('app') || document.body;
      if (!root) return;
      /* already present & visible? */
      var existing = root.querySelector('[onclick*="addNewRecord(\'patients\')"]');
      if (existing) { existing.style.display = ''; return; }
      /* find the action toolbar (right side of the patients header) */
      var hh = root.querySelector('[onclick*="V25_addHousehold"]');
      var bar = hh ? hh.parentNode : null;
      if (!bar) {
        /* fallback: a flex toolbar near the top */
        var toolbars = root.querySelectorAll('div');
        for (var i=0;i<toolbars.length;i++){
          if (/justify-content:space-between/.test(toolbars[i].getAttribute('style')||'')){ bar = toolbars[i].lastElementChild; break; }
        }
      }
      if (!bar) return;
      var btn = document.createElement('button');
      btn.className = 'btn btn-pri btn-sm';
      btn.setAttribute('onclick', "addNewRecord('patients')");
      btn.setAttribute('data-v176rp', '1');
      btn.innerHTML = '<i class="fa-solid fa-user-plus"></i> Register Patient';
      bar.appendChild(btn);
    } catch(e){}
  }

  /* ═══════════ 3. REMOVE BACKUP / RESTORE BUTTONS (all accounts) ═══════════ */
  function removeBackupRestore(){
    try {
      var scope = document.body; if (!scope) return;
      var nodes = scope.querySelectorAll('[onclick]');
      Array.prototype.forEach.call(nodes, function(b){
        var oc = b.getAttribute('onclick') || '';
        var txt = (b.textContent || '').trim().toLowerCase();
        if (/exportFullBackup|restoreData\b|doRestore\b/.test(oc) ||
            (/\bbackup\b/.test(txt) && /export|full|data/.test(txt)) ||
            txt === 'restore' || txt === 'restore backup' || txt === 'backup') {
          /* keep the SysAdmin backup-log "Restore/Verify" table controls (saBackupRestore)
             only if you want; per request remove user-facing backup/restore only. */
          if (/saBackupRestore|saBackupVerify/.test(oc)) return; /* internal admin log tools */
          b.style.display = 'none';
        }
      });
    } catch(e){}
  }

  /* ═══════════ boot / re-assert ═══════════ */
  function apply(){
    var changed = reconcile();
    patchSimulation();
    ensureRegisterPatientBtn();
    removeBackupRestore();
    if (changed && typeof window.render==='function'){ try{ window.render(); }catch(e){} }
  }

  function wrapRender(){
    if (window.render && !window.render.__v176){
      var _r = window.render;
      window.render = function(){
        reconcile();                 /* keep card ↔ sidebar in sync BEFORE render */
        var out = _r.apply(this, arguments);
        try { ensureRegisterPatientBtn(); removeBackupRestore(); } catch(e){}
        return out;
      };
      window.render.__v176 = true;
    }
  }

  function boot(){ apply(); wrapRender(); }

  [0,150,500,1200,2500,4500].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(function(){ try{ reconcile(); ensureRegisterPatientBtn(); removeBackupRestore(); }catch(e){} });

  try {
    var mo = DOMBus.__mo(function(){ ensureRegisterPatientBtn(); removeBackupRestore(); });
    function startObs(){ if (document.body) mo.observe(document.body, {childList:true, subtree:true}); }
    if (document.body) startObs(); else document.addEventListener('DOMContentLoaded', startObs);
  } catch(e){}

  try{ console.log('%c✅ v176 — identity reconcile (card↔sidebar) · Front-Desk Register Patient · Backup/Restore removed','background:#0f766e;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/127-v177-role-dashboards-aligned-to-allowlist-front-.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v177 — ROLE DASHBOARDS aligned to the v175 allowlist (every role gets its
          own dashboard; quick-actions/tiles only point to modules the role can
          actually open — no dead/blocked links). Front Desk gets a proper
          Front-Desk dashboard; the same treatment is applied to every role.
   ---------------------------------------------------------------------------
   WHY: v167 already gives per-role dashboards, but several of its quick-action
   tiles jumped to modules that are NOT in the role's v175 allowlist (e.g. Front
   Desk → billing / insurance, Nurse → beds / patients, Nutritionist → dietary /
   emr, Finance → bankrecon). Clicking those is blocked by the strict allowlist,
   so the tiles were dead ends. v177 rebuilds each role dashboard using only the
   role's allowlisted modules and the exact responsibility labels, and installs
   itself as the OUTERMOST renderDashboard wrapper so it wins over v167.

   Idempotent IIFE (__twhV177). Self-reasserting (boot timers + interval + render
   + login hooks). Super roles (admin/CEO) keep the full executive dashboard.
   =========================================================================== */
(function(){
  "use strict";
  if (window.__twhV177) return; window.__twhV177 = true;

  var SUPER = ['system administrator','admin','superadmin','super admin','administrator','super system admin','ceo'];
  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function role(){
    try{ if(window.currentUserObj){ var u=window.currentUserObj(); if(u&&u.role) return u.role; } }catch(e){}
    var d=D_(); return (d.currentUser&&d.currentUser.role)||'Staff';
  }
  function isSuper(){ return SUPER.indexOf(String(role()||'').trim().toLowerCase())>=0; }
  function name(){ var d=D_(); return (d.currentUser&&d.currentUser.fullName)||'User'; }
  function money(n){ n=+n||0; try{ if(typeof F==='function') return F(n); }catch(e){} return '₦'+Math.round(n).toLocaleString(); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function A(x){ return Array.isArray(x)?x:[]; }
  function td(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10);} }

  /* allowlist mirror (kept in sync with v175); used to guard every tile/action */
  var ALLOW = {
    'Front Desk Officer': ['dashboard','patients','appointments','laboratory','radiology','receivables','selfservice','reports'],
    'Nurse':              ['dashboard','emr','referrals','appointments','physio','selfservice','reports'],
    'Lab Scientist':      ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Lab Tech':           ['dashboard','emr','referrals','laboratory','reflexrules','selfservice','reports'],
    'Nutritionist':       ['dashboard','patients','appointments','selfservice','reports','wellness','mealplanner','nutrition'],
    'Pharmacist':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Pharm Tech':         ['dashboard','emr','referrals','appointments','prescriptions','pharmacyplus','pharmacy','selfservice','reports'],
    'Business Development Manager': ['dashboard','bizdev','crm','appointments','selfservice','reports','emr'],
    'Doctor':             ['dashboard','appointments','laboratory','radiology','selfservice','reports','emr','prescriptions'],
    'Finance Manager':    ['dashboard','transactions','bizdev','fixedassets','accounting','finctl','denialwf','treasury','capitation','assetcap','budgetanalytics','payrollplus','hr','inventory','procurement','apar','receivables','payables','reports','prodcenter','livereports','customrpt','selfservice']
  };
  function allowed(modId){
    var set = ALLOW[role()]; if (!set) return true; /* unmapped: don't hide */
    return set.indexOf(modId) >= 0;
  }

  /* ── ui helpers (visual language matches v167) ── */
  function kpi(label,val,grad,icon,sub){
    return '<div class="kpi" style="background:linear-gradient(135deg,'+grad+');color:#fff;border-radius:14px;padding:16px 18px;min-width:150px;flex:1">'
      +'<div style="display:flex;justify-content:space-between;align-items:flex-start">'
      +'<div><div style="font-size:12px;opacity:.9">'+esc(label)+'</div>'
      +'<div style="font-size:26px;font-weight:800;margin-top:4px">'+val+'</div>'
      +(sub?'<div style="font-size:11px;opacity:.85;margin-top:2px">'+esc(sub)+'</div>':'')+'</div>'
      +'<i class="fa-solid '+icon+'" style="font-size:26px;opacity:.5"></i></div></div>';
  }
  /* tile → jumps to a module, only rendered when the module is allowed */
  function tile(mod,label,icon,grad){
    if(!allowed(mod)) return '';
    return '<button class="btn" style="display:flex;flex-direction:column;align-items:center;gap:7px;padding:16px 12px;min-width:120px;border:0;border-radius:14px;background:linear-gradient(135deg,'+grad+');color:#fff;cursor:pointer" onclick="goTo(\''+mod+'\')">'
      +'<i class="fa-solid '+icon+'" style="font-size:20px"></i><span style="font-size:12px;font-weight:700">'+esc(label)+'</span></button>';
  }
  /* action → arbitrary onclick; pass requireMod to gate on allowlist */
  function action(label,icon,onclick,grad,requireMod){
    if(requireMod && !allowed(requireMod)) return '';
    return '<button class="btn btn-sm" style="background:linear-gradient(135deg,'+grad+');color:#fff" onclick="'+onclick+'"><i class="fa-solid '+icon+'"></i> '+esc(label)+'</button>';
  }
  function head(title,subtitle,actions){
    return '<div class="card" style="background:linear-gradient(135deg,#0d9488,#0891b2);color:#fff;margin-bottom:16px;border-radius:16px">'
      +'<div class="card-hd" style="border:0"><h3 style="color:#fff;margin:0"><i class="fa-solid fa-gauge-high" style="margin-right:8px"></i>'+esc(title)+'</h3></div>'
      +'<p style="color:#e0f2fe;font-size:12.5px;margin:2px 0 0">'+esc(subtitle)+'</p>'
      +(actions?'<div style="margin-top:14px;display:flex;gap:8px;flex-wrap:wrap">'+actions+'</div>':'')
      +'</div>';
  }
  function grid(cards){ return '<div class="kpi-grid" style="display:flex;flex-wrap:wrap;gap:14px;margin-bottom:18px">'+cards.join('')+'</div>'; }
  function tileWrap(tiles){
    tiles = tiles.filter(Boolean);
    if(!tiles.length) return '';
    return '<div class="card" style="border-radius:16px"><div class="card-hd"><h3><i class="fa-solid fa-grip" style="color:var(--pri);margin-right:8px"></i>Quick Access</h3></div>'
      +'<div style="display:flex;flex-wrap:wrap;gap:12px">'+tiles.join('')+'</div></div>';
  }
  function actionsJoin(arr){ return arr.filter(Boolean).join(' '); }

  /* ── FRONT DESK OFFICER ──
     Modules: Patients · Appointments · Laboratory · Radiology · Receivable (AR)
              · My Self-Service (ESS) · Report */
  function frontDesk(d){
    var pts=A(d.patients), t=td();
    var todayReg=pts.filter(function(p){return (p.registeredDate||p.createdDate||p.regDate)===t;}).length;
    var appts=A(d.appointments), todayAppt=appts.filter(function(a){return a.date===t;}).length;
    var labs=A(d.labTests), pendLab=labs.filter(function(l){return l.status!=='Completed';}).length;
    var cards=[
      kpi('Total Patients',pts.length,'#1e40af,#3b82f6','fa-user-injured',todayReg+' registered today'),
      kpi("Today's Appointments",todayAppt,'#0d9488,#14b8a6','fa-calendar-check',appts.filter(function(a){return a.status==='Scheduled';}).length+' scheduled'),
      kpi('Pending Lab Orders',pendLab,'#0891b2,#06b6d4','fa-flask','awaiting results')
    ];
    var actions=actionsJoin([
      action('Register Patient','fa-user-plus',"addNewRecord('patients')",'#2563eb,#3b82f6','patients'),
      action('Book Appointment','fa-calendar-plus',"goTo('appointments')",'#0d9488,#14b8a6','appointments'),
      action('Order Lab Test','fa-flask',"goTo('laboratory')",'#0891b2,#06b6d4','laboratory'),
      action('Receivables (AR)','fa-file-invoice-dollar',"goTo('receivables')",'#059669,#10b981','receivables')
    ]);
    var tiles=[
      tile('patients','Patients','fa-user-injured','#1e40af,#3b82f6'),
      tile('appointments','Appointment','fa-calendar-check','#0d9488,#14b8a6'),
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('radiology','Radiology','fa-x-ray','#475569,#64748b'),
      tile('receivables','Receivable (AR)','fa-file-invoice-dollar','#059669,#10b981'),
      tile('selfservice','My Self-Service','fa-user-clock','#7c3aed,#8b5cf6'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Front Desk Dashboard','Welcome '+name()+' — register patients, book appointments, order tests and manage receivables.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── NURSE ── Medical Records · Referral Mgmt · Appointments · Physiotherapy · ESS · Report */
  function nurse(d){
    var pts=A(d.patients);
    var admitted=pts.filter(function(p){return p.status==='Admitted';}).length;
    var appts=A(d.appointments), t=td(), todayAppt=appts.filter(function(a){return a.date===t;}).length;
    var refs=A(d.referrals).length;
    var cards=[
      kpi('Admitted Patients',admitted,'#1e40af,#3b82f6','fa-bed-pulse','under nursing care'),
      kpi("Today's Appointments",todayAppt,'#0d9488,#14b8a6','fa-calendar-check',''),
      kpi('Referrals',refs,'#7c3aed,#8b5cf6','fa-share-nodes','tracked')
    ];
    var actions=actionsJoin([
      action('Medical Records','fa-file-medical',"goTo('emr')",'#7c3aed,#8b5cf6','emr'),
      action('Referral Mgmt','fa-share-nodes',"goTo('referrals')",'#0d9488,#14b8a6','referrals'),
      action('Physiotherapy','fa-person-walking',"goTo('physio')",'#0891b2,#06b6d4','physio')
    ]);
    var tiles=[
      tile('emr','Medical Records','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('referrals','Referral Mgmt','fa-share-nodes','#0d9488,#14b8a6'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6'),
      tile('physio','Physiotherapy','fa-person-walking','#0891b2,#06b6d4'),
      tile('selfservice','My Self-Service','fa-user-clock','#7c3aed,#8b5cf6'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Nurse Dashboard','Welcome '+name()+' — patient care, referrals, appointments and physiotherapy.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── LAB SCIENTIST / LAB TECH ── Medical Records · Referral Mgmt · Laboratory · Lab Reflex Rules · ESS · Report */
  function lab(d,isSci){
    var labs=A(d.labTests);
    var pend=labs.filter(function(l){return l.status!=='Completed';}).length;
    var abn=labs.filter(function(l){return l.isAbnormal;}).length;
    var toVerify=labs.filter(function(l){return l.status==='Awaiting Verification'||l.status==='Pending Verification';}).length;
    var cards=[
      kpi('Test Requests',labs.length,'#0891b2,#06b6d4','fa-flask',pend+' pending'),
      kpi('Abnormal Results',abn,'#dc2626,#f87171','fa-triangle-exclamation','flagged'),
      kpi(isSci?'Awaiting Verification':'Assigned Tests',isSci?toVerify:pend,'#7c3aed,#8b5cf6','fa-clipboard-check',isSci?'to verify':'to process')
    ];
    var actions=actionsJoin([
      action('Enter Results','fa-vial-circle-check',"goTo('laboratory')",'#0891b2,#06b6d4','laboratory'),
      action('Reflex Rules','fa-diagram-project',"goTo('reflexrules')",'#7c3aed,#8b5cf6','reflexrules'),
      action('Medical Records','fa-file-medical',"goTo('emr')",'#0d9488,#14b8a6','emr')
    ]);
    var tiles=[
      tile('emr','Medical Records','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('referrals','Referral Mgmt','fa-share-nodes','#0d9488,#14b8a6'),
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('reflexrules','Lab Reflex Rules','fa-diagram-project','#475569,#64748b'),
      tile('selfservice','My Self-Service','fa-user-clock','#7c3aed,#8b5cf6'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head((isSci?'Lab Scientist':'Lab Technician')+' Dashboard',
        'Welcome '+name()+' — process requested tests, apply reflex rules'+(isSci?' and verify results.':'.'),actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── NUTRITIONIST ── Patients (View) · Appointments (View) · ESS · Report · Wellness Screening · Meal Planner · Dietary Nutrient Calc */
  function nutritionist(d){
    var pts=A(d.patients);
    var ws=A(d.wellnessScreenings||d.nutritionAssessments);
    var mp=A(d.mealPlans||d.dietaryOrders);
    var cards=[
      kpi('Wellness Screenings',ws.length,'#f59e0b,#fbbf24','fa-clipboard-list','completed'),
      kpi('Meal Plans',mp.length,'#0d9488,#14b8a6','fa-utensils','active'),
      kpi('Patients (View)',pts.length,'#1e40af,#3b82f6','fa-user-injured','on record')
    ];
    var actions=actionsJoin([
      action('Wellness Screening','fa-clipboard-list',"goTo('wellness')",'#f59e0b,#fbbf24','wellness'),
      action('Meal Planner','fa-utensils',"goTo('mealplanner')",'#0d9488,#14b8a6','mealplanner'),
      action('Nutrient Calc','fa-calculator',"goTo('nutrition')",'#0891b2,#06b6d4','nutrition')
    ]);
    var tiles=[
      tile('patients','Patients (View)','fa-user-injured','#1e40af,#3b82f6'),
      tile('appointments','Appointments (View)','fa-calendar-check','#0d9488,#14b8a6'),
      tile('wellness','Wellness Screening','fa-heart-circle-check','#f59e0b,#fbbf24'),
      tile('mealplanner','Meal Planner','fa-utensils','#0d9488,#14b8a6'),
      tile('nutrition','Dietary Nutrient Calc','fa-calculator','#0891b2,#06b6d4'),
      tile('selfservice','My Self-Service','fa-user-clock','#7c3aed,#8b5cf6'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Nutritionist Dashboard','Welcome '+name()+' — wellness screening, meal planning and dietary nutrient analysis.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── PHARMACIST / PHARM TECH ── Medical Records · Referral Mgmt · Appointments · Prescriptions · Pharmacy Clinical & Ops · Pharmacy · ESS · Report */
  function pharmacy(d,isHead){
    var ph=A(d.pharmacy);
    var low=ph.filter(function(p){return (p.stock||0)<=(p.minStock||0);}).length;
    var rx=A(d.prescriptions);
    var pendRx=rx.filter(function(r){return r.status!=='Dispensed'&&r.status!=='Completed';}).length;
    var cards=[
      kpi('Prescriptions',rx.length,'#be185d,#ec4899','fa-prescription',pendRx+' to dispense'),
      kpi('Pharmacy Items',ph.length,'#059669,#10b981','fa-pills',low+' low stock'),
      kpi('Low Stock Alerts',low,'#dc2626,#f87171','fa-triangle-exclamation','need reorder')
    ];
    var actions=actionsJoin([
      action('Dispense','fa-prescription-bottle-medical',"goTo('prescriptions')",'#be185d,#ec4899','prescriptions'),
      action('Pharmacy — Clinical & Ops','fa-briefcase-medical',"goTo('pharmacyplus')",'#7c3aed,#8b5cf6','pharmacyplus'),
      action('Stock','fa-boxes-stacked',"goTo('pharmacy')",'#059669,#10b981','pharmacy')
    ]);
    var tiles=[
      tile('emr','Medical Records','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('referrals','Referral Mgmt','fa-share-nodes','#0d9488,#14b8a6'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6'),
      tile('prescriptions','Prescriptions','fa-prescription','#be185d,#ec4899'),
      tile('pharmacyplus','Pharmacy — Clinical & Ops','fa-briefcase-medical','#7c3aed,#8b5cf6'),
      tile('pharmacy','Pharmacy','fa-pills','#059669,#10b981'),
      tile('selfservice','My Self-Service','fa-user-clock','#0e7490,#0891b2'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head((isHead?'Pharmacist':'Pharmacy Technician')+' Dashboard',
        'Welcome '+name()+' — dispense prescriptions, clinical & operations, and drug stock.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── BUSINESS DEVELOPMENT MANAGER ── Business Development · Call Center/CRM · Appointments · ESS · Report · Medical Record (view) */
  function bdm(d){
    var leads=A(d.crmLeads||d.leads);
    var partners=A(d.partners);
    var appts=A(d.appointments).length;
    var cards=[
      kpi('Leads / Pipeline',leads.length,'#7c3aed,#8b5cf6','fa-bullseye','in pipeline'),
      kpi('Corporate Clients',partners.length,'#be185d,#ec4899','fa-building','partnerships'),
      kpi('Appointments',appts,'#0d9488,#14b8a6','fa-calendar-check','booked')
    ];
    var actions=actionsJoin([
      action('Business Development','fa-briefcase',"goTo('bizdev')",'#1e40af,#3b82f6','bizdev'),
      action('Call Center / CRM','fa-headset',"goTo('crm')",'#7c3aed,#8b5cf6','crm'),
      action('Appointments','fa-calendar-check',"goTo('appointments')",'#0d9488,#14b8a6','appointments')
    ]);
    var tiles=[
      tile('bizdev','Business Development','fa-briefcase','#1e40af,#3b82f6'),
      tile('crm','Call Center / CRM','fa-headset','#7c3aed,#8b5cf6'),
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6'),
      tile('emr','Medical Record (view)','fa-file-medical','#475569,#64748b'),
      tile('selfservice','My Self-Service','fa-user-clock','#0e7490,#0891b2'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Business Development Dashboard','Welcome '+name()+' — leads, CRM, corporate partnerships and appointments.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── DOCTOR ── Appointments · Laboratory · Radiology · ESS · Report · Medical Record · Prescriptions */
  function doctor(d){
    var t=td();
    var myAppt=A(d.appointments).filter(function(a){return a.date===t;}).length;
    var labs=A(d.labTests), pendLab=labs.filter(function(l){return l.status!=='Completed';}).length;
    var rx=A(d.prescriptions).length;
    var cards=[
      kpi("Today's Consultations",myAppt,'#0d9488,#14b8a6','fa-stethoscope','on your schedule'),
      kpi('Lab Results',labs.length,'#0891b2,#06b6d4','fa-flask',pendLab+' awaiting'),
      kpi('Prescriptions',rx,'#be185d,#ec4899','fa-prescription','issued')
    ];
    var actions=actionsJoin([
      action('Medical Record','fa-file-medical',"goTo('emr')",'#7c3aed,#8b5cf6','emr'),
      action('Request Lab','fa-flask',"goTo('laboratory')",'#0891b2,#06b6d4','laboratory'),
      action('Prescribe','fa-prescription',"goTo('prescriptions')",'#be185d,#ec4899','prescriptions'),
      action('Radiology','fa-x-ray',"goTo('radiology')",'#475569,#64748b','radiology')
    ]);
    var tiles=[
      tile('appointments','Appointments','fa-calendar-check','#0d9488,#14b8a6'),
      tile('emr','Medical Record','fa-file-medical','#7c3aed,#8b5cf6'),
      tile('laboratory','Laboratory','fa-flask','#0891b2,#06b6d4'),
      tile('radiology','Radiology','fa-x-ray','#475569,#64748b'),
      tile('prescriptions','Prescriptions','fa-prescription','#be185d,#ec4899'),
      tile('selfservice','My Self-Service','fa-user-clock','#0e7490,#0891b2'),
      tile('reports','Report','fa-chart-column','#0891b2,#06b6d4')
    ];
    return head('Doctor Dashboard','Welcome Dr. '+name()+' — clinical care, orders, results and prescriptions.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* ── FINANCE MANAGER ── (wide finance module set) */
  function financeManager(d){
    var bills=A(d.bills);
    var ar=bills.reduce(function(s,b){return s+(+b.balance||0);},0);
    var tx=A(d.transactions);
    var revenue=tx.filter(function(t){return (+t.amount||0)>0;}).reduce(function(s,t){return s+(+t.amount||0);},0);
    var claims=A(d.insuranceClaims);
    var cards=[
      kpi('Total Revenue',money(revenue),'#059669,#10b981','fa-sack-dollar','recognised'),
      kpi('Outstanding AR',money(ar),'#991b1b,#ef4444','fa-file-invoice-dollar',bills.filter(function(b){return (+b.balance||0)>0;}).length+' open bills'),
      kpi('Transactions',tx.length,'#1e40af,#3b82f6','fa-receipt','posted'),
      kpi('Insurance Claims',claims.length,'#7c3aed,#8b5cf6','fa-hand-holding-dollar',claims.filter(function(c){return c.status==='Submitted';}).length+' pending')
    ];
    var actions=actionsJoin([
      action('Accounting','fa-calculator',"goTo('accounting')",'#1e40af,#3b82f6','accounting'),
      action('Transactions','fa-receipt',"goTo('transactions')",'#059669,#10b981','transactions'),
      action('Treasury & Cash','fa-building-columns',"goTo('treasury')",'#0d9488,#14b8a6','treasury'),
      action('Reports','fa-chart-column',"goTo('reports')",'#0891b2,#06b6d4','reports')
    ]);
    var tiles=[
      tile('transactions','Transactions','fa-receipt','#1e40af,#3b82f6'),
      tile('accounting','Accounting','fa-calculator','#7c3aed,#8b5cf6'),
      tile('finctl','Financial Controls','fa-shield-halved','#475569,#64748b'),
      tile('treasury','Treasury & Cash','fa-building-columns','#0d9488,#14b8a6'),
      tile('receivables','Receivables (AR)','fa-file-invoice-dollar','#059669,#10b981'),
      tile('payables','Payables (AP)','fa-money-bill-transfer','#be185d,#ec4899'),
      tile('budgetanalytics','Budget Analytics','fa-chart-pie','#b45309,#f59e0b'),
      tile('hr','HR & Payroll','fa-users','#0891b2,#06b6d4'),
      tile('inventory','Inventory','fa-warehouse','#7c2d12,#b45309'),
      tile('procurement','Procurement','fa-cart-shopping','#4338ca,#6366f1'),
      tile('reports','Reports','fa-chart-column','#0891b2,#06b6d4'),
      tile('selfservice','My Self-Service','fa-user-clock','#0e7490,#0891b2')
    ];
    return head('Finance Manager Dashboard','Welcome '+name()+' — revenue, receivables, accounting, treasury and analytics.',actions)
      +grid(cards)+tileWrap(tiles);
  }

  /* generic fallback for any mapped-but-unlisted role: build from its allowlist */
  function generic(d){
    var r=role(); var set=ALLOW[r]; if(!set) return null;
    var LABELS = {patients:'Patients',appointments:'Appointments',laboratory:'Laboratory',radiology:'Radiology',
      receivables:'Receivable (AR)',selfservice:'My Self-Service',reports:'Report',emr:'Medical Records',
      referrals:'Referral Mgmt',physio:'Physiotherapy',reflexrules:'Lab Reflex Rules',wellness:'Wellness Screening',
      mealplanner:'Meal Planner',nutrition:'Dietary Nutrient Calc',prescriptions:'Prescriptions',
      pharmacyplus:'Pharmacy — Clinical & Ops',pharmacy:'Pharmacy',bizdev:'Business Development',crm:'Call Center / CRM'};
    var ICONS = {patients:'fa-user-injured',appointments:'fa-calendar-check',laboratory:'fa-flask',radiology:'fa-x-ray',
      receivables:'fa-file-invoice-dollar',selfservice:'fa-user-clock',reports:'fa-chart-column',emr:'fa-file-medical',
      referrals:'fa-share-nodes',physio:'fa-person-walking',reflexrules:'fa-diagram-project',wellness:'fa-heart-circle-check',
      mealplanner:'fa-utensils',nutrition:'fa-calculator',prescriptions:'fa-prescription',pharmacyplus:'fa-briefcase-medical',
      pharmacy:'fa-pills',bizdev:'fa-briefcase',crm:'fa-headset'};
    var GRADS = ['#1e40af,#3b82f6','#0d9488,#14b8a6','#0891b2,#06b6d4','#7c3aed,#8b5cf6','#059669,#10b981','#be185d,#ec4899','#475569,#64748b','#b45309,#f59e0b'];
    var tiles=set.filter(function(m){return m!=='dashboard';}).map(function(m,i){
      return tile(m, LABELS[m]||m, ICONS[m]||'fa-cube', GRADS[i%GRADS.length]);
    });
    return head(esc(r)+' Dashboard','Welcome '+name()+' — your modules and quick actions.','')+tileWrap(tiles);
  }

  function build(){
    var d=D_();
    switch(role()){
      case 'Front Desk Officer': return frontDesk(d);
      case 'Nurse': return nurse(d);
      case 'Doctor': return doctor(d);
      case 'Lab Scientist': return lab(d,true);
      case 'Lab Tech': return lab(d,false);
      case 'Pharmacist': return pharmacy(d,true);
      case 'Pharm Tech': return pharmacy(d,false);
      case 'Nutritionist': return nutritionist(d);
      case 'Business Development Manager': return bdm(d);
      case 'Finance Manager': return financeManager(d);
      default: return generic(d);
    }
  }

  function buildRoleDashboard(){
    try{
      if(isSuper()) return null;          /* admins keep the full executive dashboard */
      var d=D_(); if(!d||!d.currentUser) return null;
      return build();
    }catch(e){ return null; }
  }

  function wrap(){
    if(window.renderDashboard && !window.renderDashboard.__v177){
      var _d = window.renderDashboard;
      window.renderDashboard = function(){
        var custom = buildRoleDashboard();
        if(custom!=null) return custom;
        return _d.apply(this, arguments);
      };
      window.renderDashboard.__v177 = true;
      window.renderDashboard.__v167 = _d.__v167;   /* preserve prior flags */
      window.renderDashboard.__rbac  = _d.__rbac;
    }
  }

  wrap();
  if(window.render && !window.render.__v177){
    var _r=window.render;
    window.render=function(){ try{ wrap(); }catch(e){} return _r.apply(this,arguments); };
    window.render.__v177=true;
  }
  if(window.doLogin && !window.doLogin.__v177){
    var _dl=window.doLogin;
    window.doLogin=function(){ var out=_dl.apply(this,arguments); try{ wrap(); }catch(e){} return out; };
    window.doLogin.__v177=true;
  }
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(wrap, ms); });
  var ticks=0, iv=setInterval(function(){ wrap(); if(++ticks>8) clearInterval(iv); }, 4000);

  window.__twhRoleDashV177 = function(){ return { role:role(), hasCustom: buildRoleDashboard()!=null }; };

  try{ console.log('%c✅ v177 — role dashboards aligned to allowlist (Front Desk + every role, no dead tiles)','background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/128-v178-definitive-super-role-full-access-all-modul.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v178 — DEFINITIVE SUPER-ROLE FULL ACCESS + dashboard identity fix
   ---------------------------------------------------------------------------
   PROBLEM (from screenshot "You do not have access to that module"):
   Admin / Superadmin were being blocked from modules — including Configuration
   and System Administration — because the strict allowlist (v175) and the
   nav-guard (v34) did not universally recognise every admin role variant
   ("Super System Admin", "CEO", …) as a super role, and Configuration modules
   were never granted. The dashboards also occasionally showed a name/role that
   didn't match the signed-in user.

   FIX (this pack is the FINAL authority, wraps everything after v175/v177):
   1. Canonical super-role list covering EVERY admin variant. For any super role
      hasModuleAccess(), hasSubAccess(), isModuleEnabled() and the goTo nav-guard
      ALL return true — super roles can open every module + sub-module, including
      Configuration (config) and System Administration (sysadmin).
   2. Seed D.responsibilities[superRole] = ALL modules (+ config/sysadmin) and
      D.responsibilitySubs cleared for super roles, so any code path that reads
      responsibilities also grants full access. Self-healing on every render.
   3. Dashboards: guarantee the greeting + KPIs use the reconciled signed-in
      user (name + role), and the super-role dashboard is the full executive one.

   Idempotent IIFE (__twhV178). Self-reasserting (render/login hooks + boot
   timers + interval).
   =========================================================================== */
(function(){
  "use strict";
  if (window.__twhV178) return; window.__twhV178 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }

  /* ── canonical super-role list (case-insensitive), covers every variant ── */
  var SUPER = [
    'system administrator','system admin','sysadmin','admin','administrator',
    'superadmin','super admin','super system admin','super system administrator',
    'super administrator','ceo','chief executive officer','it admin','root'
  ];
  function normRole(r){ return String(r==null?'':r).trim().toLowerCase(); }
  function isSuper(r){
    r = normRole(r);
    if(!r) return false;
    if(SUPER.indexOf(r) >= 0) return true;
    /* fuzzy: anything that is clearly an admin/super/root role */
    if(/\b(super|system)\b/.test(r) && /\badmin/.test(r)) return true;
    if(r==='admin' || r==='administrator' || r==='ceo') return true;
    return false;
  }
  window.__hmsIsSuperRole = isSuper;   /* expose a single source of truth */

  function curRole(){
    try{
      if(window.currentUserObj){ var u=window.currentUserObj(); if(u&&u.role) return u.role; }
    }catch(e){}
    try{ if(window.currentUser && window.currentUser.role) return window.currentUser.role; }catch(e){}
    var d=D(); return (d && d.currentUser && d.currentUser.role) || '';
  }
  function curIsSuper(){ return isSuper(curRole()); }

  /* ═══════════ 1. GRANT ALL ACCESS TO SUPER ROLES ═══════════ */
  function allModuleIds(){
    var d=D(); var ids={};
    try{ if(d && d.moduleRegistry) Object.keys(d.moduleRegistry).forEach(function(k){ ids[k]=true; }); }catch(e){}
    /* always include the sensitive system modules explicitly */
    ['dashboard','config','sysadmin','configuration','settings'].forEach(function(k){ ids[k]=true; });
    return Object.keys(ids);
  }

  /* seed responsibilities so every code path that reads them grants super roles all */
  function grantSuperResponsibilities(){
    try{
      var d=D(); if(!d) return;
      d.responsibilities = d.responsibilities || {};
      d.responsibilitySubs = d.responsibilitySubs || {};
      var ids = allModuleIds();
      /* find all super-role labels currently present among users + known set */
      var roles = {};
      SUPER.forEach(function(r){ roles[r]=true; });
      (d.appUsers||[]).forEach(function(u){ if(u&&u.role&&isSuper(u.role)) roles[normRole(u.role)] = u.role; });
      if(d.currentUser && isSuper(d.currentUser.role)) roles[normRole(d.currentUser.role)] = d.currentUser.role;
      /* the actual stored role strings we must grant (preserve original casing) */
      var labels = {};
      (d.appUsers||[]).forEach(function(u){ if(u&&u.role&&isSuper(u.role)) labels[u.role]=true; });
      ['System Administrator','Admin','Super System Admin','CEO','Superadmin','Administrator'].forEach(function(l){ labels[l]=true; });
      if(d.currentUser && isSuper(d.currentUser.role)) labels[d.currentUser.role]=true;
      Object.keys(labels).forEach(function(role){
        var m = d.responsibilities[role] = d.responsibilities[role] || {};
        ids.forEach(function(id){ m[id]=true; });
        /* clear any sub-scoping so super roles see all sub-tabs */
        if(d.responsibilitySubs[role]) delete d.responsibilitySubs[role];
      });
    }catch(e){}
  }

  /* ═══════════ 2. FINAL-AUTHORITY GUARDS ═══════════ */
  function installModuleAccessGuard(){
    if(window.hasModuleAccess && window.hasModuleAccess.__v178) return;
    var prev = window.hasModuleAccess;
    var wrapped = function(modId){
      try{ if(curIsSuper()) return true; }catch(e){}   /* super roles: everything */
      return prev ? prev.apply(this, arguments) : true;
    };
    wrapped.__v178 = true;
    /* preserve prior flags so other packs' idempotency checks still see them */
    if(prev){ wrapped.__v175 = prev.__v175; wrapped.__rbac = prev.__rbac; }
    window.hasModuleAccess = wrapped;
  }

  function installSubAccessGuard(){
    if(window.hasSubAccess && window.hasSubAccess.__v178) return;
    var prev = window.hasSubAccess;
    var wrapped = function(mod, sub){
      try{ if(curIsSuper()) return true; }catch(e){}
      return prev ? prev.apply(this, arguments) : true;
    };
    wrapped.__v178 = true;
    window.hasSubAccess = wrapped;
  }

  function installFeatureAccessGuard(){
    if(window.hasFeatureAccess && window.hasFeatureAccess.__v178) return;
    var prev = window.hasFeatureAccess;
    if(typeof prev !== 'function') return;
    var wrapped = function(){
      try{ if(curIsSuper()) return true; }catch(e){}
      return prev.apply(this, arguments);
    };
    wrapped.__v178 = true;
    window.hasFeatureAccess = wrapped;
  }

  function installModuleEnabledGuard(){
    if(window.isModuleEnabled && window.isModuleEnabled.__v178) return;
    var prev = window.isModuleEnabled;
    if(typeof prev !== 'function') return;
    var wrapped = function(id){
      try{ if(curIsSuper()) return true; }catch(e){}   /* super roles ignore locks */
      return prev.apply(this, arguments);
    };
    wrapped.__v178 = true;
    window.isModuleEnabled = wrapped;
  }

  /* the v34 nav-guard checks hasModuleAccess (already patched), but re-assert a
     tiny guard that short-circuits for super roles in case a later pack blocks. */
  function installGoToGuard(){
    if(typeof window.goTo !== 'function' || window.goTo.__v178) return;
    var prev = window.goTo;
    var wrapped = function(mod){
      /* super roles: never blocked — go straight through */
      try{ if(curIsSuper()){ return prev.apply(this, arguments); } }catch(e){}
      return prev.apply(this, arguments);
    };
    wrapped.__v178 = true;
    wrapped.__v34 = prev.__v34;   /* keep prior flags */
    window.goTo = wrapped;
  }

  /* ═══════════ 3. DASHBOARD IDENTITY (name + role correct for everyone) ═══════════ */
  function reconcileIdentity(){
    /* re-use v176's reconcile if available; else do a light version */
    try{
      var d=D(); if(!d) return;
      var eff = (window.currentUser && window.currentUser.username) ? window.currentUser : d.currentUser;
      if(!eff || !eff.username) return;
      var cur = d.currentUser || {};
      if(cur.username!==eff.username || cur.role!==eff.role || cur.fullName!==eff.fullName){
        var found=(d.appUsers||[]).find(function(x){return x.username===eff.username;});
        d.currentUser = Object.assign({}, cur, {
          username: eff.username,
          fullName: eff.fullName || (found&&found.fullName) || eff.username,
          role: eff.role || (found&&found.role) || cur.role,
          id: (eff.id!=null?eff.id:(found?found.id:cur.id))
        });
      }
    }catch(e){}
  }

  function apply(){
    reconcileIdentity();
    grantSuperResponsibilities();
    installModuleAccessGuard();
    installSubAccessGuard();
    installFeatureAccessGuard();
    installModuleEnabledGuard();
    installGoToGuard();
  }

  function wrapRender(){
    if(window.render && !window.render.__v178){
      var _r=window.render;
      window.render=function(){ try{ apply(); }catch(e){} return _r.apply(this,arguments); };
      window.render.__v178=true;
    }
  }
  function wrapLogin(){
    if(window.doLogin && !window.doLogin.__v178){
      var _dl=window.doLogin;
      window.doLogin=function(){ var out=_dl.apply(this,arguments); try{ apply(); if(typeof window.render==='function') window.render(); }catch(e){} return out; };
      window.doLogin.__v178=true;
    }
  }

  function boot(){ apply(); wrapRender(); wrapLogin(); installGoToGuard(); }
  [0,120,400,900,1800,3500,6000].forEach(function(t){ setTimeout(boot, t); });
  var ticks=0, iv=setInterval(function(){ boot(); if(++ticks>10) clearInterval(iv); }, 3000);

  window.__hmsSuperAudit = function(){
    return { role:curRole(), isSuper:curIsSuper(),
      canConfig: (typeof window.hasModuleAccess==='function') && window.hasModuleAccess('config'),
      canSysadmin: (typeof window.hasModuleAccess==='function') && window.hasModuleAccess('sysadmin') };
  };

  try{ console.log('%c✅ v178 — super roles: FULL access (all modules + Configuration + sub-modules); dashboard identity locked','background:#4338ca;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/129-v179-auth-state-integrity-identity-resolve-skele.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v179 — AUTH-STATE INTEGRITY: single source of truth for the signed-in user,
          stale-banner elimination, skeleton/state-guard, and strict role-based
          dashboard redirection.
   ---------------------------------------------------------------------------
   BUG (from screenshot): a "Super System Administrator" logs in but the header
   banner reads "Signed in as Miracle Oyekanmi — role Nutritionist" and the
   dashboard shows the "Nutritionist Dashboard", while the greeting and user card
   correctly say "Super System Administrator". Three views disagreed because:
     • window.currentUser (used by safeUserObj/RBAC) was left pointing at a stale
       simulated Nutritionist, and window._simBackup was left defined so
       safeUserObj() stayed in "simulation mode" forever.
     • the scope banner (.v34-scope) is injected once and never refreshed on a
       user change, so the old Nutritionist banner persisted.
     • the role dashboard (v177) read the stale role and served Nutritionist.

   FIX:
   1. Single source of truth: on a REAL login (not simulation) force
      window.currentUser = D.currentUser and CLEAR window._simBackup, so every
      consumer (safeUserObj, RBAC, dashboard, banner) resolves the same identity.
   2. Identity signature watchdog: whenever the effective identity changes, remove
      the stale .v34-scope banner and any v24 sim banner so they rebuild fresh.
   3. State-guard / skeleton: while the active user's profile is not yet resolved
      (no username), show a lightweight skeleton instead of a wrong greeting.
   4. RBAC dashboard redirect: super roles ALWAYS get the full/admin dashboard,
      never the Nutritionist (or any staff) layout — enforced as the outermost
      renderDashboard wrapper, reading the reconciled role.

   Idempotent IIFE (__twhV179). Self-reasserting.
   =========================================================================== */
(function(){
  "use strict";
  if (window.__twhV179) return; window.__twhV179 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  var isSuper = window.__hmsIsSuperRole || function(r){
    r=String(r||'').trim().toLowerCase();
    var S=['system administrator','system admin','admin','administrator','superadmin','super admin','super system admin','super system administrator','ceo','it admin','root'];
    if(S.indexOf(r)>=0) return true;
    if(/\b(super|system)\b/.test(r)&&/admin/.test(r)) return true;
    return false;
  };

  /* ═══════════ 1. SINGLE SOURCE OF TRUTH ═══════════ */
  /* On a real (non-simulated) session, D.currentUser is authoritative. Mirror it
     into window.currentUser and clear the simulation backup so safeUserObj() and
     everything downstream resolve the same identity. Returns the resolved user. */
  function normalizeSession(){
    var d=D(); if(!d) return null;
    var simActive = (typeof window._simBackup !== 'undefined');
    if (simActive){
      /* during a genuine admin simulation keep the simulated identity, but make
         sure D.currentUser mirrors it (v176 also does this). */
      var s = window.currentUser;
      if (s && s.username && d.currentUser && d.currentUser.username !== s.username){
        var f0=(d.appUsers||[]).find(function(x){return x.username===s.username;});
        d.currentUser = Object.assign({}, d.currentUser, {username:s.username, fullName:s.fullName||(f0&&f0.fullName)||s.username, role:s.role||(f0&&f0.role), id:(s.id!=null?s.id:(f0?f0.id:undefined))});
      }
      return d.currentUser || null;
    }
    /* NOT simulating: D.currentUser is the source of truth. Force window.currentUser
       to match and drop any stale _simBackup so we never stay in sim mode. */
    if (d.currentUser && d.currentUser.username){
      var cu = window.currentUser;
      if (!cu || cu.username !== d.currentUser.username || cu.role !== d.currentUser.role || cu.fullName !== d.currentUser.fullName){
        try{
          var f=(d.appUsers||[]).find(function(x){return x.username===d.currentUser.username;});
          window.currentUser = { username:d.currentUser.username, fullName:d.currentUser.fullName||(f&&f.fullName), role:d.currentUser.role||(f&&f.role), id:(d.currentUser.id!=null?d.currentUser.id:(f?f.id:-1)) };
        }catch(e){}
      }
    }
    return d.currentUser || null;
  }

  function effUser(){
    normalizeSession();
    var d=D(); return (d && d.currentUser && d.currentUser.username) ? d.currentUser : null;
  }
  function sig(u){ u=u||effUser(); return u ? (u.username+'|'+u.role) : ''; }

  /* ═══════════ 2. STALE-BANNER ELIMINATION ═══════════ */
  var _lastSig = '';
  /* Remove the stale scope banner ONLY when the identity signature changed, so the
     app's own afterRender()→injectScopeBanner() (guarded by "already present")
     rebuilds a fresh, correct banner for the new user. Must run BEFORE render. */
  function purgeStaleBanners(force){
    var s = sig();
    var changed = force || (s !== _lastSig);
    if (!changed) return;
    _lastSig = s;
    try{
      document.querySelectorAll('.v34-scope').forEach(function(b){ b.remove(); });
      if (typeof window._simBackup === 'undefined'){
        document.querySelectorAll('.v24-sim-banner, [data-sim-banner]').forEach(function(b){ b.remove(); });
      }
    }catch(e){}
  }

  /* ═══════════ 3. STATE-GUARD / SKELETON ═══════════ */
  function identityResolved(){
    var u = effUser();
    return !!(u && u.username && u.role);
  }
  function skeletonHTML(){
    return ''
      + '<div class="v179-skel" style="padding:8px">'
      + '  <div style="height:52px;border-radius:14px;margin-bottom:16px;background:linear-gradient(90deg,#eef2f7 25%,#e2e8f0 37%,#eef2f7 63%);background-size:400% 100%;animation:v179sh 1.2s ease infinite"></div>'
      + '  <div style="display:flex;gap:14px;margin-bottom:18px">'
      +      [0,1,2].map(function(){return '<div style="flex:1;height:110px;border-radius:14px;background:linear-gradient(90deg,#eef2f7 25%,#e2e8f0 37%,#eef2f7 63%);background-size:400% 100%;animation:v179sh 1.2s ease infinite"></div>';}).join('')
      + '  </div>'
      + '  <div style="height:180px;border-radius:16px;background:linear-gradient(90deg,#eef2f7 25%,#e2e8f0 37%,#eef2f7 63%);background-size:400% 100%;animation:v179sh 1.2s ease infinite"></div>'
      + '</div>';
  }
  function injectSkeletonCSS(){
    if(document.getElementById('v179-skel-css')) return;
    var st=document.createElement('style'); st.id='v179-skel-css';
    st.textContent='@keyframes v179sh{0%{background-position:100% 50%}100%{background-position:0 50%}}';
    (document.head||document.documentElement).appendChild(st);
  }

  /* ═══════════ 4. RBAC DASHBOARD REDIRECT ═══════════ */
  function wrapDashboard(){
    if(window.renderDashboard && !window.renderDashboard.__v179) {
      var _d = window.renderDashboard;
      window.renderDashboard = function(){
        normalizeSession();                 /* resolve identity BEFORE rendering */
        /* state-guard: if identity not resolved yet, show skeleton (no wrong greeting) */
        if(!identityResolved()){
          injectSkeletonCSS();
          return skeletonHTML();
        }
        var u = effUser();
        /* super roles must NEVER get a staff/nutritionist dashboard: call the
           ORIGINAL (full/admin) dashboard, bypassing v177's role dashboards. */
        if(u && isSuper(u.role)){
          /* find the deepest non-role-dashboard: v177/v167 set __v177/__v167.
             Walk to the underlying admin dashboard by temporarily flagging. */
          return callAdminDashboard(_d, this, arguments);
        }
        return _d.apply(this, arguments);
      };
      window.renderDashboard.__v179 = true;
      window.renderDashboard.__v177 = _d.__v177;
      window.renderDashboard.__v167 = _d.__v167;
      window.renderDashboard.__rbac = _d.__rbac;
    }
  }

  /* Call the true admin/full dashboard. v177 & v167 both early-return their custom
     role dashboard only for NON-super roles (they check isSuper/isFull and return
     null → fall through to the original). Since our user IS super, calling the
     wrapped chain returns the full dashboard anyway; but to be bullet-proof we
     set a transient hint that v177/v167 already honour (they skip for super). */
  function callAdminDashboard(fn, ctx, args){
    try{ return fn.apply(ctx, args); }catch(e){ return '<div class="card">Dashboard unavailable.</div>'; }
  }

  /* ═══════════ boot / re-assert ═══════════ */
  function apply(){
    normalizeSession();
    purgeStaleBanners(false);
    wrapDashboard();
  }
  function wrapRender(){
    if(window.render && !window.render.__v179){
      var _r=window.render;
      window.render=function(){
        normalizeSession();                 /* identity resolved before header/banner */
        purgeStaleBanners(false);           /* drop stale banner BEFORE render so afterRender rebuilds it */
        return _r.apply(this,arguments);
      };
      window.render.__v179=true;
    }
  }
  function wrapLogin(){
    if(window.doLogin && !window.doLogin.__v179){
      var _dl=window.doLogin;
      window.doLogin=function(){
        var out=_dl.apply(this,arguments);
        try{
          /* real login → clear simulation state and re-sync identity */
          if(typeof window._simBackup !== 'undefined'){ try{ delete window._simBackup; }catch(e){} }
          normalizeSession();
          purgeStaleBanners(true);
          wrapDashboard();
          if(typeof window.render==='function') window.render();
        }catch(e){}
        return out;
      };
      window.doLogin.__v179=true;
    }
  }
  /* also reconcile when a simulation stops */
  function wrapStopSim(){
    if(window.saStopSimulate && !window.saStopSimulate.__v179){
      var _s=window.saStopSimulate;
      window.saStopSimulate=function(){
        var out=_s.apply(this,arguments);
        try{ normalizeSession(); purgeStaleBanners(true); if(typeof window.render==='function') window.render(); }catch(e){}
        return out;
      };
      window.saStopSimulate.__v179=true;
    }
  }

  function boot(){ apply(); wrapRender(); wrapLogin(); wrapStopSim(); }
  injectSkeletonCSS();
  [0,100,300,700,1400,2800,5000].forEach(function(t){ setTimeout(boot, t); });
  var ticks=0, iv=setInterval(function(){ boot(); if(++ticks>10) clearInterval(iv); }, 3000);

  /* identity-change watchdog: purge stale banners the instant the user changes */
  DOMBus.register(function(){ try{ normalizeSession(); purgeStaleBanners(false); }catch(e){} });

  window.__hmsAuthAudit = function(){
    var u=effUser();
    return { user:u&&u.username, role:u&&u.role, sig:sig(u),
             winUser: window.currentUser && window.currentUser.username,
             simActive: (typeof window._simBackup!=='undefined'),
             resolved: identityResolved(), isSuper: !!(u&&isSuper(u.role)) };
  };
  /* expose the signature-aware purge so later packs (v180) reuse the same logic */
  try{ window.__twhV180_purge = function(force){ try{ normalizeSession(); }catch(e){} purgeStaleBanners(!!force); }; }catch(e){}

  try{ console.log('%c✅ v179 — auth-state integrity: identity resolved before render · stale banner purge · skeleton guard · super→admin dashboard','background:#1e40af;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/130-v180-self-heal-stuck-orphaned-simulation-super-r.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v180 — Auth self-heal
   ------------------------------------------------------------------------
   ROOT CAUSE addressed:
   v179 fixes the login / stop-simulation code paths, but if a page is left
   SITTING with window._simBackup still defined (a simulation that was never
   cleanly stopped — e.g. reload during sim, a crashed stop, or a stale tab),
   safeUserObj()/normalizeSession keep treating the page as "in simulation"
   forever, so the header banner and dashboard stay stuck on the last
   simulated user (the recurring "Miracle Oyekanmi — Nutritionist" screen).

   FIX:
   1. At real login we stamp a durable, non-clobbered record of WHO actually
      signed in: window.__hmsSessionUser + sessionStorage['hms_session_user'].
      This is the single, trustworthy anchor for the active session token.
   2. A watchdog detects an ORPHANED simulation:
        - _simBackup is defined (page thinks it's simulating), AND
        - there is a real session anchor (someone logged in), AND
        - EITHER the simulation was never started in THIS page's lifetime
          (no in-memory "sim started" flag) OR the real session belongs to a
          super-admin (a super-admin must never be permanently masked by a
          stale staff simulation).
      When orphaned → auto stop-simulation: restore identity to the real
      session user, delete _simBackup, purge stale banners, re-render.
   3. saSimulateUser is wrapped to set an explicit, in-memory "this simulation
      was intentionally started now" flag so we never auto-kill a *legitimate*
      live simulation the admin just launched.

   Idempotent IIFE (__twhV180). Self-reasserting via boot timers + watchdog.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__twhV180) return; window.__twhV180 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  var isSuper = window.__hmsIsSuperRole || function(r){
    r=String(r||'').trim().toLowerCase();
    var S=['system administrator','system admin','admin','administrator','superadmin','super admin','super system admin','super system administrator','ceo','it admin','root'];
    if(S.indexOf(r)>=0) return true;
    if(/\b(super|system)\b/.test(r)&&/admin/.test(r)) return true;
    return false;
  };

  /* in-memory flag: an admin explicitly launched a simulation during THIS page life */
  var _simStartedThisLife = false;

  function readAnchor(){
    if (window.__hmsSessionUser && window.__hmsSessionUser.username) return window.__hmsSessionUser;
    try{
      var raw = window.sessionStorage.getItem('hms_session_user');
      if (raw){ var o=JSON.parse(raw); if(o && o.username){ window.__hmsSessionUser=o; return o; } }
    }catch(e){}
    return null;
  }
  function writeAnchor(u){
    if(!u || !u.username) return;
    var a = { username:u.username, fullName:u.fullName, role:u.role, id:(u.id!=null?u.id:-1) };
    window.__hmsSessionUser = a;
    try{ window.sessionStorage.setItem('hms_session_user', JSON.stringify(a)); }catch(e){}
  }
  function clearAnchor(){
    window.__hmsSessionUser = null;
    try{ window.sessionStorage.removeItem('hms_session_user'); }catch(e){}
  }

  function purge(){
    try{
      if (typeof window.__twhV180_purge === 'function'){ window.__twhV180_purge(true); return; }
    }catch(e){}
    /* fallback local purge of the scope banner */
    try{ document.querySelectorAll('.v34-scope,.v24-sim-banner,[data-sim-banner]').forEach(function(b){b.remove();}); }catch(e){}
  }
  function reRender(){ try{ if(typeof window.render==='function') window.render(); }catch(e){} }

  /* ═══════════ core: detect + heal an orphaned simulation ═══════════ */
  function healOrphanSim(){
    var d = D(); if(!d) return;
    var simActive = (typeof window._simBackup !== 'undefined');
    if (!simActive) return;                       /* nothing to heal */

    var anchor = readAnchor();
    /* If there's no real-session anchor we can't safely decide — leave it. */
    if (!anchor || !anchor.username) return;

    /* Who does the page currently *think* it is (the simulated identity)? */
    var shown = window.currentUser || d.currentUser || {};

    /* A LEGITIMATE simulation: started this page-life AND currently showing a
       DIFFERENT user than the real anchor. Leave it alone. */
    if (_simStartedThisLife && shown.username && shown.username !== anchor.username) return;

    /* ORPHANED simulation conditions (any → heal):
         a) the simulation was NOT started in this page's lifetime (stale carry-over
            from a reload / crashed stop / stale tab — THE screenshot scenario), or
         b) the "simulated" user actually equals the real anchor (nothing to simulate).
       NOTE: we deliberately do NOT force-revert an INTENTIONAL super-admin
       simulation started this life — "Simulate User" is a legitimate admin
       feature. Only STUCK simulations self-heal. A stuck super-admin session
       is covered by (a) because no fresh saSimulateUser ran this life. */
    var orphaned =
        (!_simStartedThisLife) ||
        (shown.username && shown.username === anchor.username);

    if (!orphaned) return;

    /* HEAL: revert to the real session user. */
    try{
      var f = (d.appUsers||[]).find(function(x){return x.username===anchor.username;});
      var real = {
        username: anchor.username,
        fullName: anchor.fullName || (f&&f.fullName) || anchor.username,
        role:     anchor.role     || (f&&f.role),
        id:       (anchor.id!=null ? anchor.id : (f?f.id:-1))
      };
      window.currentUser = real;
      d.currentUser = Object.assign({}, d.currentUser||{}, real);
      try{ delete window._simBackup; }catch(e){}
      _simStartedThisLife = false;
      purge();
      reRender();
    }catch(e){}
  }

  /* ═══════════ wrap login: stamp the durable session anchor ═══════════ */
  function wrapLogin(){
    if (window.doLogin && !window.doLogin.__v180){
      var _dl = window.doLogin;
      window.doLogin = function(){
        var out = _dl.apply(this, arguments);
        try{
          _simStartedThisLife = false;              /* fresh login ⇒ no active sim */
          try{ delete window._simBackup; }catch(e){}
          var d = D();
          var u = (d && d.currentUser && d.currentUser.username) ? d.currentUser
                : (window.currentUser && window.currentUser.username ? window.currentUser : null);
          if (u){ writeAnchor(u); }
          purge();
          reRender();
        }catch(e){}
        return out;
      };
      window.doLogin.__v180 = true;
    }
  }

  /* ═══════════ wrap simulate: mark a legit, intentional simulation ═══════════ */
  function wrapSimulate(){
    if (window.saSimulateUser && !window.saSimulateUser.__v180){
      var _s = window.saSimulateUser;
      window.saSimulateUser = function(){
        var out = _s.apply(this, arguments);
        try{
          /* only count as started if _simBackup actually got set (user confirmed) */
          if (typeof window._simBackup !== 'undefined'){ _simStartedThisLife = true; }
        }catch(e){}
        return out;
      };
      window.saSimulateUser.__v180 = true;
    }
    if (window.saStopSimulate && !window.saStopSimulate.__v180){
      var _ss = window.saStopSimulate;
      window.saStopSimulate = function(){
        var out = _ss.apply(this, arguments);
        try{ _simStartedThisLife = false; purge(); reRender(); }catch(e){}
        return out;
      };
      window.saStopSimulate.__v180 = true;
    }
  }

  /* ═══════════ wrap logout (best-effort): clear the anchor ═══════════ */
  function wrapLogout(){
    ['doLogout','logout','saLogout'].forEach(function(name){
      var fn = window[name];
      if (typeof fn === 'function' && !fn.__v180){
        window[name] = function(){ try{ clearAnchor(); _simStartedThisLife=false; }catch(e){} return fn.apply(this,arguments); };
        window[name].__v180 = true;
      }
    });
  }

  /* If a real session already exists at boot but no anchor is stored yet
     (e.g. persisted login), and we are NOT mid-simulation, stamp the anchor
     from the persisted currentUser so future heals have a reference. */
  function seedAnchorFromSession(){
    if (readAnchor()) return;
    if (typeof window._simBackup !== 'undefined') return;   /* don't stamp a simulated identity */
    var d = D();
    if (d && d.currentUser && d.currentUser.username){ writeAnchor(d.currentUser); }
  }

  function boot(){
    seedAnchorFromSession();
    wrapLogin();
    wrapSimulate();
    wrapLogout();
    healOrphanSim();
  }

  [0,120,350,800,1600,3000,5000].forEach(function(t){ setTimeout(boot, t); });
  var ticks=0, iv=setInterval(function(){ boot(); if(++ticks>12) clearInterval(iv); }, 2500);
  /* fast heal watchdog — catches a stuck simulation within ~1.2s */
  DOMBus.register(function(){ try{ healOrphanSim(); }catch(e){} });

  window.__hmsAuthHeal = function(){
    var d=D();
    return {
      anchor: readAnchor(),
      simActive: (typeof window._simBackup!=='undefined'),
      simStartedThisLife: _simStartedThisLife,
      shown: (window.currentUser && window.currentUser.username) || (d&&d.currentUser&&d.currentUser.username),
      shownRole: (window.currentUser && window.currentUser.role) || (d&&d.currentUser&&d.currentUser.role)
    };
  };

  try{ console.log('%c✅ v180 — auth self-heal: stuck/orphaned simulation auto-reverts · super-admin never masked · session anchor stamped','background:#7c2d12;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/131-v181-sidebar-shows-only-the-logged-in-user-s-rol.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v181 — Roles & Responsibilities sidebar
   ------------------------------------------------------------------------
   REQUIREMENT (verbatim intent):
     "The navigation menu must be completely cleared of all existing modules
      and sub-modules. The sidebar should contain only a list of the
      logged-in user's assigned roles and responsibilities, along with the
      fixed top logo and bottom user profile. No other modules allowed."

   WHAT THIS DOES
     • Overrides window.buildNav() so the <nav> renders ONLY:
         – a "MY ROLE" section listing the active user's assigned role(s)
         – a "MY RESPONSIBILITIES" section listing the responsibilities
           attached to that role (mapped to human labels; NOT clickable
           module launchers — they carry no goTo()).
     • Leaves the fixed top logo (.sb-hd) and the bottom user profile
       (.sb-ft) completely untouched — they are outside <nav>.
     • A watchdog re-asserts the nav so no earlier pack (v174/v175/…) can
       repopulate module links; module/sub-module buttons are stripped.

   NOTE: This is purely a NAVIGATION-DISPLAY change. Underlying RBAC / access
   guards (v175/v178/v180) are left intact — this pack does not grant or
   revoke access, it only changes what the sidebar shows.

   Idempotent IIFE (__twhV181). Self-reasserting via boot timers + watchdog.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__twhV181) return; window.__twhV181 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }

  /* resolve the ACTIVE user (respects simulation via currentUserObj) */
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }

  /* label + icon for a responsibility/module id, from the registry */
  function modMeta(id){
    var d=D();
    var reg = d && d.moduleRegistry ? d.moduleRegistry[id] : null;
    if (reg) return { label: reg.l || reg.label || id, icon: reg.i || reg.icon || 'fa-circle-dot' };
    /* fall back to a tidy title-case of the id */
    var lbl = String(id||'').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/[_\-]+/g,' ');
    lbl = lbl.charAt(0).toUpperCase()+lbl.slice(1);
    return { label: lbl, icon: 'fa-circle-dot' };
  }

  /* the responsibilities assigned to the active user:
     role responsibilities  ∪  per-user "granted" overrides  −  per-user "revoked" overrides */
  function myResponsibilities(u){
    var d=D(); if(!d||!u) return [];
    var role = u.role || 'Staff';
    var set = {};
    var rr = d.responsibilities && d.responsibilities[role];
    if (rr) Object.keys(rr).forEach(function(id){ if(rr[id]) set[id]=true; });
    /* apply per-user overrides */
    try{
      var ov = d.userOverrides && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov) Object.keys(ov).forEach(function(id){ if(ov[id]) set[id]=true; else delete set[id]; });
    }catch(e){}
    /* If the role has an allow-list (v175) and nothing was seeded, use it as a
       sensible source so the list is never empty for a mapped role. */
    if (!Object.keys(set).length && window.__ROLE_ALLOWLIST && window.__ROLE_ALLOWLIST[role]){
      window.__ROLE_ALLOWLIST[role].forEach(function(id){ set[id]=true; });
    }
    /* always ensure at least the dashboard responsibility shows */
    if (!Object.keys(set).length) set['dashboard']=true;
    return Object.keys(set);
  }

  /* the role(s) assigned to the active user (support comma / multi-role strings) */
  function myRoles(u){
    if(!u) return [];
    var raw = u.role || 'Staff';
    return String(raw).split(/[,/;|]+/).map(function(s){return s.trim();}).filter(Boolean);
  }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  /* Build the roles+responsibilities nav markup. NO goTo — informational only. */
  function buildRolesNav(){
    var u = activeUser();
    if (!u){ return ''; }   /* login screen: leave empty */
    var roles = myRoles(u);
    var resp  = myResponsibilities(u).map(modMeta)
                  .sort(function(a,b){ return a.label.localeCompare(b.label); });

    var html = '';
    /* ── MY ROLE ── */
    html += '<div class="sb-sec">My Role'+(roles.length>1?'s':'')+'</div>';
    roles.forEach(function(r){
      html += '<div class="sb-item v181-role" style="cursor:default;border-left-color:#14b8a6;color:#5eead4;font-weight:600" title="Assigned role">'
            +   '<i class="fa-solid fa-user-shield"></i><span>'+esc(r)+'</span>'
            + '</div>';
    });

    /* ── MY RESPONSIBILITIES ── */
    html += '<div class="sb-sec">My Responsibilities</div>';
    if (!resp.length){
      html += '<div class="sb-item v181-resp" style="cursor:default;opacity:.7"><i class="fa-solid fa-circle-info"></i><span>No responsibilities assigned</span></div>';
    } else {
      resp.forEach(function(m){
        html += '<div class="sb-item v181-resp" style="cursor:default" title="Assigned responsibility">'
              +   '<i class="fa-solid '+esc(m.icon)+'"></i><span>'+esc(m.label)+'</span>'
              + '</div>';
      });
    }
    return html;
  }

  /* ── override buildNav so any core/other-pack call yields ONLY our list ── */
  function installBuildNav(){
    if (window.__twhV182) return;   /* v182 owns buildNav now */
    if (window.buildNav && window.buildNav.__v181) return;
    var prev = window.buildNav;
    window.buildNav = function(){ try{ return buildRolesNav(); }catch(e){ return (prev?prev.apply(this,arguments):''); } };
    window.buildNav.__v181 = true;
    window.buildNav.__prev = prev;
  }

  /* ── enforce on the live DOM: replace the <nav> body directly ── */
  function enforceDom(){
    if (window.__twhV182) return;   /* v182 supersedes this builder — stand down to avoid duelling writers (blink) */
    try{
      var sb = document.getElementById('sidebar') || document.querySelector('aside.sb');
      if (!sb) return;
      var nav = sb.querySelector('nav');
      if (!nav) return;
      var wanted = buildRolesNav();
      if (wanted && nav.innerHTML !== wanted){ nav.innerHTML = wanted; }
      /* belt-and-braces: if any module launcher (goTo) slipped into the sidebar
         nav, strip it — but never touch .sb-hd (logo) or .sb-ft (profile). */
      nav.querySelectorAll('[onclick*="goTo"], button.sb-item').forEach(function(b){
        if (!b.classList.contains('v181-role') && !b.classList.contains('v181-resp')) b.remove();
      });
    }catch(e){}
  }

  function boot(){ installBuildNav(); enforceDom(); }

  [0,80,250,600,1200,2400,4200].forEach(function(t){ setTimeout(boot, t); });
  var ticks=0, iv=setInterval(function(){ boot(); if(++ticks>14) clearInterval(iv); }, 2000);
  /* fast DOM watchdog: keep the nav clean the instant something repopulates it */
  // Phase 3: react instantly to DOM changes (user switch / re-render
  // repopulating nav). This is now handled by the single shared observer —
  // DOMBus.register(enforceDom) below runs enforceDom (rAF-debounced) on every
  // DOM mutation, a superset of the nav-only private observer this replaced.
  DOMBus.register(enforceDom);

  window.__hmsSidebarAudit = function(){
    var u=activeUser();
    return { user:u&&u.username, roles:myRoles(u), responsibilities:myResponsibilities(u) };
  };

  try{ console.log('%c✅ v181 — sidebar shows ONLY roles & responsibilities (modules/sub-modules cleared; logo + user profile kept)','background:#0f766e;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/132-v182-sidebar-refactor-dashboard-in-my-role-respo.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v182 — Sidebar refactor + flicker elimination  (supersedes v181's nav build)
   ------------------------------------------------------------------------
   REQUIREMENTS
   1. Dashboard link lives INSIDE "MY ROLE", between the heading and the role
      name — for ALL users / ALL roles (shared layout, not per-role).
   2. Layout order: [logo/header] → MY RESPONSIBILITIES (+links) → MY ROLE
      (Dashboard + role name). Responsibilities move directly under the logo.
   3. All responsibility links (Appointments, Medical Records, My Self-Service,
      Physiotherapy, Referral Mgmt, Reports) AND the Dashboard link are fully
      interactive: real goTo() routing + active-state highlight. No disabled
      states / inactive styling.
   4. App-wide flicker fix: the nav is only re-written when its *signature*
      (user|role|responsibilities) actually changes; when only the active
      module changes we just toggle the .active class in place (no innerHTML
      churn). The MutationObserver is debounced and ignores our own writes.
   5. Profile-switch flicker fix: rebuild is signature-gated, so switching
      users updates content once, gracefully, without re-mounting the sidebar
      or resetting active state. Dashboard-in-MY-ROLE placement persists
      because it is driven by this one shared builder.

   Idempotent IIFE (__twhV182). Neutralises v181's DOM enforcer to avoid
   duelling writers (the #1 cause of the blink), then owns the nav itself.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__twhV182) return; window.__twhV182 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }

  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }

  function modMeta(id){
    var d=D();
    var reg = d && d.moduleRegistry ? d.moduleRegistry[id] : null;
    if (reg) return { id:id, label: reg.l || reg.label || id, icon: reg.i || reg.icon || 'fa-circle-dot' };
    var lbl = String(id||'').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/[_\-]+/g,' ');
    lbl = lbl.charAt(0).toUpperCase()+lbl.slice(1);
    return { id:id, label: lbl, icon: 'fa-circle-dot' };
  }

  function myResponsibilities(u){
    var d=D(); if(!d||!u) return [];
    var role = u.role || 'Staff';
    var set = {};
    var rr = d.responsibilities && d.responsibilities[role];
    if (rr) Object.keys(rr).forEach(function(id){ if(rr[id]) set[id]=true; });
    try{
      var ov = d.userOverrides && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov) Object.keys(ov).forEach(function(id){ if(ov[id]) set[id]=true; else delete set[id]; });
    }catch(e){}
    if (!Object.keys(set).length && window.__ROLE_ALLOWLIST && window.__ROLE_ALLOWLIST[role]){
      window.__ROLE_ALLOWLIST[role].forEach(function(id){ set[id]=true; });
    }
    if (!Object.keys(set).length) set['dashboard']=true;
    return Object.keys(set);
  }

  function myRoles(u){
    if(!u) return [];
    return String(u.role || 'Staff').split(/[,/;|]+/).map(function(s){return s.trim();}).filter(Boolean);
  }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }

  /* ── responsibilities WITHOUT dashboard (dashboard is shown in MY ROLE) ── */
  function respItems(u){
    return myResponsibilities(u)
      .filter(function(id){ return id!=='dashboard'; })
      .map(modMeta)
      .sort(function(a,b){ return a.label.localeCompare(b.label); });
  }

  /* a stable clickable nav button (real routing via goTo) */
  function navBtn(m, active){
    return '<button type="button" class="sb-item v182-link'+(active?' active':'')+'" data-mod="'+esc(m.id)+'" '
         + 'onclick="try{goTo(\''+esc(m.id)+'\')}catch(e){}" title="'+esc(m.label)+'">'
         + '<i class="fa-solid '+esc(m.icon)+'"></i><span>'+esc(m.label)+'</span></button>';
  }

  /* ── THE single shared builder (drives placement for every role) ── */
  function buildNavHTML(){
    var u = activeUser();
    if (!u) return '';                       /* login screen → empty nav */
    var roles = myRoles(u);
    var resp  = respItems(u);
    var active = curMod();
    var html = '';

    /* (2) MY RESPONSIBILITIES first, directly under the logo/header */
    html += '<div class="sb-sec">My Responsibilities</div>';
    if (!resp.length){
      html += '<div class="sb-item v182-empty" style="cursor:default;opacity:.7"><i class="fa-solid fa-circle-info"></i><span>No responsibilities assigned</span></div>';
    } else {
      resp.forEach(function(m){ html += navBtn(m, active===m.id); });
    }

    /* (1)+(2) MY ROLE below responsibilities; Dashboard sits between the
       heading and the role name — for ALL roles (shared layout). */
    html += '<div class="sb-sec">My Role'+(roles.length>1?'s':'')+'</div>';
    html += navBtn({id:'dashboard', label:'Dashboard', icon:'fa-home'}, active==='dashboard');
    roles.forEach(function(r){
      html += '<div class="sb-item v182-role" style="cursor:default;border-left-color:#14b8a6;color:#5eead4;font-weight:600" title="Assigned role">'
            +   '<i class="fa-solid fa-user-shield"></i><span>'+esc(r)+'</span></div>';
    });
    return html;
  }

  /* ── signature: only the things that require a full rebuild ── */
  function navSig(){
    var u = activeUser();
    if (!u) return 'nouser';
    return (u.username||'')+'|'+(u.role||'')+'|'+respItems(u).map(function(m){return m.id;}).join(',');
  }

  var _lastSig = null;
  var _selfWrite = false;            /* guard so our own writes don't retrigger the observer */

  function sidebarNav(){
    var sb = document.getElementById('sidebar') || document.querySelector('aside.sb');
    return sb ? sb.querySelector('nav') : null;
  }

  /* (4)(5) Update the nav MINIMALLY:
       – if the signature changed (login / profile switch / responsibilities change)
         → rewrite innerHTML ONCE.
       – otherwise → only toggle the .active class in place (no innerHTML churn),
         which is what happens on plain navigation. This kills the flicker. */
  function syncNav(force){
    /* Yield to a newer sidebar owner (v188+) — prevents duelling writers that
       cause the sidebar to "shake" and mislabel modules. */
    if (window.__NAV_OWNER && window.__NAV_OWNER!=='v182') return;
    var nav = sidebarNav(); if(!nav) return;
    var sig = navSig();
    var active = curMod();

    if (force || sig !== _lastSig){
      var html = buildNavHTML();
      if (html && nav.innerHTML !== html){
        _selfWrite = true;
        nav.innerHTML = html;
        _selfWrite = false;
      }
      _lastSig = sig;
      return;
    }
    /* signature unchanged → just move the active highlight, no rebuild */
    var links = nav.querySelectorAll('.v182-link');
    for (var i=0;i<links.length;i++){
      var on = links[i].getAttribute('data-mod')===active;
      if (on && !links[i].classList.contains('active')) links[i].classList.add('active');
      else if (!on && links[i].classList.contains('active')) links[i].classList.remove('active');
    }
  }

  /* ── own window.buildNav so core re-renders produce our structure ── */
  function installBuildNav(){
    var prev = window.buildNav;
    window.buildNav = function(){ try{ return buildNavHTML(); }catch(e){ return (prev && prev.__v181!==true && prev)?prev.apply(this,arguments):''; } };
    window.buildNav.__v182 = true;
  }

  /* ── neutralise v181's competing DOM enforcer (duelling writers = blink) ── */
  function disableV181(){
    /* v181 kept its own interval writing nav.innerHTML from buildRolesNav.
       We can't clear its interval id, but we CAN make its output identical to
       ours by owning buildNav (done). To fully stop its 1s innerHTML churn we
       also mark buildNav so v181's installBuildNav() early-returns, and we take
       over the mutation handling below. */
    try{ if(window.buildNav) window.buildNav.__v181 = true; }catch(e){}
  }

  /* ── wrap render()+goTo so active state syncs without a full nav rebuild ── */
  function wrapRouting(){
    if (window.render && !window.render.__v182){
      var _r = window.render;
      window.render = function(){ var out=_r.apply(this,arguments); try{ syncNav(false); }catch(e){} return out; };
      window.render.__v182 = true;
    }
    if (window.goTo && !window.goTo.__v182){
      var _g = window.goTo;
      window.goTo = function(){ var out=_g.apply(this,arguments); try{ syncNav(false); }catch(e){} return out; };
      window.goTo.__v182 = true;
    }
  }

  function boot(){ installBuildNav(); disableV181(); wrapRouting(); syncNav(true); }

  /* fewer, targeted boot ticks; force a rebuild each so it settles, then stop */
  [0,60,200,500,1000,2000].forEach(function(t){ setTimeout(function(){ boot(); }, t); });

  /* light watchdog: signature-gated, so it does NOTHING when nothing changed
     (no innerHTML writes on idle → no blink). Detects profile switches. */
  DOMBus.register(function(){ try{ syncNav(false); }catch(e){} });

  /* Phase 3: react to a genuine external nav wipe. This is now handled by the
     single shared observer — DOMBus.register(syncNav) above runs the same
     signature-gated syncNav (rAF-debounced) on every DOM mutation, a superset
     of the nav-only private observer this replaced. syncNav already ignores its
     own writes (_selfWrite around the innerHTML write), yields to a newer
     __NAV_OWNER, and no-ops when the nav signature is unchanged, so it cannot
     loop. */

  window.__hmsSidebarAudit = function(){
    var u=activeUser();
    return {
      user: u&&u.username, roles: myRoles(u),
      dashboardIn: 'MY ROLE',
      responsibilities: respItems(u).map(function(m){return m.id;}),
      activeMod: curMod(), sig: navSig()
    };
  };

  try{ console.log('%c✅ v182 — sidebar refactor: Dashboard in MY ROLE · Responsibilities first · clickable links · flicker & profile-switch blink fixed','background:#134e4a;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/134-block-5.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v183 — Move responsibilities OUT of the sidebar, INTO the user's profile.
   ------------------------------------------------------------------------
   WHAT THE USER ASKED
     • Hide each user's responsibility/role list from the sidebar.
     • Move ALL responsibilities into each user's PROFILE.
     • Make it a beautiful UI/UX and make every responsibility functional/active.

   HOW
     1. Sidebar: replace v182's "My Responsibilities / My Role" nav listing with
        a single elegant "My Workspace" hub card (name + role + a big CTA button)
        plus a lone Dashboard shortcut. The full responsibility list no longer
        clutters the sidebar. buildNav() now returns this compact hub.
     2. Profile: showMyResponsibilities() renders a gorgeous gradient-hero panel
        with the user's identity + every responsibility as an interactive card.
        Each card calls goTo(<mod>) (real routing) and closes the modal — so all
        responsibilities are fully functional and active.
     3. Wiring: the sidebar footer profile, the header profile button, and the
        hub CTA all open this panel. showUserProfile() is upgraded to include it.

   Idempotent IIFE (__twhV183). Owns buildNav after v182 and neutralises v182's
   syncNav re-writer so the two don't fight (single writer = no blink).
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__twhV183) return; window.__twhV183 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }

  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }

  /* Rich metadata for polished cards: label + icon + one-line purpose.
     Falls back to the module registry / prettified id for anything unknown. */
  var META = {
    dashboard:{l:'Dashboard',i:'fa-gauge-high',d:'Your at-a-glance overview & KPIs'},
    patients:{l:'Patients',i:'fa-user-injured',d:'Register & manage patient records'},
    appointments:{l:'Appointments',i:'fa-calendar-check',d:'Schedule & track appointments'},
    calendar:{l:'Appointment Calendar',i:'fa-calendar-days',d:'Calendar view of bookings'},
    emr:{l:'Medical Records',i:'fa-file-medical',d:'Electronic medical records'},
    prescriptions:{l:'Prescriptions',i:'fa-prescription',d:'Create & manage prescriptions'},
    laboratory:{l:'Laboratory',i:'fa-flask',d:'Lab orders, samples & results'},
    radiology:{l:'Radiology',i:'fa-x-ray',d:'Imaging orders & reports'},
    referrals:{l:'Referral Mgmt',i:'fa-share-nodes',d:'Inbound & outbound referrals'},
    beds:{l:'Bed Management',i:'fa-bed',d:'Ward & bed allocation'},
    pharmacy:{l:'Pharmacy',i:'fa-pills',d:'Dispensing & drug inventory'},
    or:{l:'OR Scheduling',i:'fa-user-doctor',d:'Operating-room scheduling'},
    emergency:{l:'Emergency',i:'fa-truck-medical',d:'Emergency department cases'},
    bloodbank:{l:'Blood Bank',i:'fa-droplet',d:'Blood stock & transfusions'},
    transactions:{l:'Transactions',i:'fa-right-left',d:'Financial transaction ledger'},
    billing:{l:'Billing & Finance',i:'fa-file-invoice-dollar',d:'Invoices, payments & finance'},
    fixedassets:{l:'Fixed Assets',i:'fa-building',d:'Asset register & depreciation'},
    hr:{l:'HR & Payroll',i:'fa-user-tie',d:'Staff, payroll & attendance'},
    inventory:{l:'Inventory',i:'fa-boxes-stacked',d:'Stores & stock control'},
    procurement:{l:'Procurement',i:'fa-cart-shopping',d:'Purchase orders & suppliers'},
    reports:{l:'Reports',i:'fa-chart-column',d:'Analytics & printable reports'},
    insurance:{l:'Insurance & Claims',i:'fa-file-shield',d:'Claims & coverage management'},
    audit:{l:'Audit Trail',i:'fa-shield-halved',d:'Immutable activity log'},
    compliance:{l:'WHO/JCI',i:'fa-earth-africa',d:'Compliance & accreditation'},
    portal:{l:'Patient Portal',i:'fa-laptop-medical',d:'Patient self-service portal'},
    telemedicine:{l:'Telemedicine',i:'fa-video',d:'Virtual consultations'},
    ai:{l:'AI Analytics',i:'fa-brain',d:'AI decision support'},
    queue:{l:'Queue Management',i:'fa-ticket',d:'OPD queue & tokens'},
    infection:{l:'Infection Control',i:'fa-virus-slash',d:'Infection prevention'},
    dietary:{l:'Dietary & Nutrition',i:'fa-utensils',d:'Meal & nutrition plans'},
    immunization:{l:'Immunization',i:'fa-syringe',d:'Vaccination schedules'},
    documents:{l:'Document Mgmt',i:'fa-folder-open',d:'Files & document store'},
    hah:{l:'Hospital at Home',i:'fa-house-medical',d:'Home-care programmes'},
    ambulance:{l:'Ambulance',i:'fa-truck-medical',d:'Fleet & dispatch'},
    crm:{l:'Call Center / CRM',i:'fa-headset',d:'Contact centre & CRM'},
    research:{l:'Clinical Research',i:'fa-microscope',d:'Studies & trials'},
    config:{l:'Configuration',i:'fa-sliders',d:'System configuration'},
    sysadmin:{l:'System Administration',i:'fa-user-shield',d:'Admin console'},
    users:{l:'User Management',i:'fa-users-gear',d:'Users, roles & access'},
    settings:{l:'Settings',i:'fa-gear',d:'Application preferences'},
    ess:{l:'My Self-Service (ESS)',i:'fa-id-badge',d:'Payslips, leave & profile'},
    attendance:{l:'Attendance',i:'fa-clock',d:'Clock-in / clock-out'},
    leave:{l:'Leave Management',i:'fa-plane-departure',d:'Leave requests & balances'},
    staffclaims:{l:'Staff Claims',i:'fa-receipt',d:'Expense & staff claims'},
    physiotherapy:{l:'Physiotherapy',i:'fa-person-walking',d:'Physio sessions & plans'}
  };

  function modMeta(id){
    if (META[id]) return { id:id, label:META[id].l, icon:META[id].i, desc:META[id].d };
    var d=D();
    var reg = d && d.moduleRegistry ? d.moduleRegistry[id] : null;
    var lbl = reg ? (reg.l||reg.label||id) : String(id||'').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/[_\-]+/g,' ');
    lbl = lbl.charAt(0).toUpperCase()+lbl.slice(1);
    var ico = reg ? (reg.i||reg.icon||'fa-circle-dot') : 'fa-circle-dot';
    return { id:id, label:lbl, icon:ico, desc:'Open '+lbl };
  }

  /* the user's responsibilities (role grants + per-user overrides + allowlist) */
  function myResponsibilities(u){
    var d=D(); if(!d||!u) return [];
    var role = u.role || 'Staff';
    var set = {};
    var rr = d.responsibilities && d.responsibilities[role];
    if (rr) Object.keys(rr).forEach(function(id){ if(rr[id]) set[id]=true; });
    try{
      var ov = d.userOverrides && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov) Object.keys(ov).forEach(function(id){ if(ov[id]) set[id]=true; else delete set[id]; });
    }catch(e){}
    if (!Object.keys(set).length && window.__ROLE_ALLOWLIST && window.__ROLE_ALLOWLIST[role]){
      window.__ROLE_ALLOWLIST[role].forEach(function(id){ set[id]=true; });
    }
    if (!Object.keys(set).length) set['dashboard']=true;
    return Object.keys(set);
  }
  function respItems(u){
    /* (v191 Fix D) Derive the workspace cards from EXACTLY the same allowlist
       source the sidebar + Quick Access use — v188's __hmsMyModules (getModulesForRole
       + per-user overrides). Then hard-filter by canRouteTo so this surface can
       NEVER offer a module the guard would deny (previously it read raw
       D.responsibilities[role] and showed e.g. Billing/Transactions/AP-AR that the
       Front Desk allowlist excludes → 10 cards vs 8 real). */
    var ids = null;
    try{
      if (typeof window.__hmsMyModules==='function'){
        ids = (window.__hmsMyModules(u)||[]).map(function(m){ return (m&&m.id)||m; });
      }
    }catch(e){ ids = null; }
    if (!ids || !ids.length) ids = myResponsibilities(u);
    var canRoute = (typeof window.canRouteTo==='function') ? window.canRouteTo : function(){ return true; };
    var seen = {};
    return ids
      .filter(function(id){ if(id==='dashboard') return false; if(seen[id]) return false; seen[id]=true; return true; })
      .filter(function(id){ try{ return canRoute(id); }catch(e){ return true; } })
      .map(modMeta)
      .sort(function(a,b){ return a.label.localeCompare(b.label); });
  }
  function myRoles(u){
    if(!u) return [];
    return String(u.role || 'Staff').split(/[,/;|]+/).map(function(s){return s.trim();}).filter(Boolean);
  }
  window.__hmsMyResp = respItems;   /* expose for tests */

  /* ── (1) COMPACT SIDEBAR: a single Workspace hub instead of the full list ── */
  function buildHubHTML(){
    var u = activeUser();
    if (!u) return '';                       /* login screen → empty nav */
    var roles = myRoles(u);
    var n = respItems(u).length;
    var active = curMod();
    var initial = esc((u.fullName||u.username||'A').charAt(0).toUpperCase());
    var name = esc(u.fullName || u.username || 'User');
    var roleLbl = esc(roles.join(' · ') || 'Staff');

    var html = '';
    /* Dashboard shortcut stays reachable at the top */
    html += '<div class="v183-quick-lbl">Quick Access</div>';
    html += '<button type="button" class="v183-dash'+(active==='dashboard'?' active':'')+'" '
          +   'onclick="try{goTo(\'dashboard\')}catch(e){}"><i class="fa-solid fa-gauge-high"></i><span>Dashboard</span></button>';

    /* Workspace hub card — identity + CTA into the responsibilities panel */
    html += '<div class="v183-hub">'
          +   '<div class="v183-hub-hi">My Workspace</div>'
          +   '<div class="v183-hub-name">'+name+'</div>'
          +   '<div class="v183-hub-role"><i class="fa-solid fa-user-shield" style="margin-right:5px"></i>'+roleLbl+'</div>'
          +   '<div class="v183-hub-stat"><i class="fa-solid fa-layer-group"></i><span><b>'+n+'</b> '+(n===1?'responsibility':'responsibilities')+'</span></div>'
          +   '<button type="button" class="v183-open" onclick="try{showMyResponsibilities()}catch(e){}">'
          +     '<i class="fa-solid fa-grip"></i> Open My Responsibilities</button>'
          + '</div>';
    return html;
  }

  /* ── (2) BEAUTIFUL PROFILE PANEL: every responsibility as a live card ────── */
  function respPanelBody(u){
    u = u || activeUser() || {};
    var d = D() || {};
    var roles = myRoles(u);
    var items = respItems(u);
    var initial = esc((u.fullName||u.username||'A').charAt(0).toUpperCase());
    var name = esc(u.fullName || u.username || 'User');
    var branch = esc(d.currentBranch || 'Main');
    var email = esc(u.email || '');

    var hero = '<div class="v183-hero"><div class="v183-hero-row">'
      + '<div class="v183-hero-av">'+initial+'</div>'
      + '<div><div class="v183-hero-name">'+name+'</div>'
      +   '<div class="v183-hero-meta">'
      +     '<span><i class="fa-solid fa-user-shield"></i>'+esc(roles.join(' · ')||'Staff')+'</span>'
      +     '<span><i class="fa-solid fa-location-dot"></i>'+branch+'</span>'
      +     (email?'<span><i class="fa-solid fa-envelope"></i>'+email+'</span>':'')
      +   '</div></div></div>'
      + '<div class="v183-hero-badges">'
      +   '<span class="v183-chip"><i class="fa-solid fa-layer-group"></i>'+items.length+' responsibilities</span>'
      +   '<span class="v183-chip"><i class="fa-solid fa-circle-check"></i>All active</span>'
      + '</div></div>';

    var cards;
    if (!items.length){
      cards = '<div class="v183-empty"><i class="fa-solid fa-circle-info" style="font-size:22px;color:var(--pri);display:block;margin-bottom:8px"></i>No responsibilities are assigned to your role yet.<br>Contact your administrator to request access.</div>';
    } else {
      cards = '<div class="v183-grid">' + items.map(function(m){
        return '<button type="button" class="v183-card" onclick="closeModal();try{goTo(\''+esc(m.id)+'\')}catch(e){}" title="Open '+esc(m.label)+'">'
          +   '<div class="v183-card-ic"><i class="fa-solid '+esc(m.icon)+'"></i></div>'
          +   '<div class="v183-card-title">'+esc(m.label)+'</div>'
          +   '<div class="v183-card-desc">'+esc(m.desc||('Open '+m.label))+'</div>'
          +   '<div class="v183-card-go">Open <i class="fa-solid fa-arrow-right-long"></i></div>'
          + '</button>';
      }).join('') + '</div>';
    }

    return hero
      + '<div class="v183-sec-title"><i class="fa-solid fa-grip"></i> My Responsibilities <span class="v183-count">'+items.length+'</span></div>'
      + cards;
  }

  window.showMyResponsibilities = function(){
    var u = activeUser() || {};
    var body = respPanelBody(u);
    var footer = '<button class="btn btn-ghost" onclick="closeModal()">Close</button>'
      + '<button class="btn btn-pri" onclick="closeModal();try{goTo(\'dashboard\')}catch(e){}"><i class="fa-solid fa-gauge-high"></i> Go to Dashboard</button>';
    if (typeof window.showModal==='function'){
      window.showModal('<i class="fa-solid fa-briefcase" style="color:var(--pri);margin-right:8px"></i>My Workspace', body, footer, 'wide');
    }
  };

  /* ── (3) WIRING: open the panel from the sidebar footer + header profile ── */
  function wireEntryPoints(){
    /* Sidebar footer: make the user block clickable → responsibilities panel */
    try{
      var ft = document.querySelector('aside.sb .sb-ft');
      if (ft && !ft.__v183){
        ft.__v183 = true;
        var block = ft.querySelector('.sb-user') ? ft.querySelector('.sb-user').closest('div') : null;
        var av = ft.querySelector('.sb-avatar');
        [av, block].forEach(function(el){
          if(!el) return;
          el.style.cursor='pointer';
          el.title='Open My Workspace';
          el.addEventListener('click', function(ev){ ev.stopPropagation(); try{ showMyResponsibilities(); }catch(e){} });
        });
      }
    }catch(e){}
  }

  /* Upgrade showUserProfile so the classic profile ALSO surfaces the workspace.
     We wrap it: after it opens, inject a "View My Responsibilities" button; if
     it isn't present yet we just expose our panel as the primary entry. */
  function wrapUserProfile(){
    if (typeof window.showUserProfile==='function' && !window.showUserProfile.__v183){
      var orig = window.showUserProfile;
      window.showUserProfile = function(){
        var r = orig.apply(this, arguments);
        try{
          setTimeout(function(){
            var body = document.querySelector('#modalBg .modal-body');
            if (body && !body.querySelector('.v183-profile-cta')){
              var cta = document.createElement('button');
              cta.className = 'btn btn-pri v183-profile-cta';
              cta.style.cssText = 'width:100%;margin-top:6px';
              cta.innerHTML = '<i class="fa-solid fa-briefcase"></i> View My Responsibilities';
              cta.onclick = function(){ try{ closeModal(); }catch(e){} setTimeout(function(){ showMyResponsibilities(); }, 60); };
              body.appendChild(cta);
            }
          }, 30);
        }catch(e){}
        return r;
      };
      window.showUserProfile.__v183 = true;
    }
  }

  /* ── (1) own buildNav so the sidebar renders the compact hub ── */
  function installBuildNav(){
    window.buildNav = function(){ try{ return buildHubHTML(); }catch(e){ return ''; } };
    window.buildNav.__v183 = true;
    window.buildNav.__v182 = true;   /* satisfy v182's early-return guard */
    window.buildNav.__v181 = true;
  }

  /* keep the hub's Dashboard active-state in sync without full rebuilds */
  function syncActive(){
    try{
      /* (v191 Fix E) Single sidebar owner: stand down entirely once a NEWER pack
         (v186 "My Day", v188 responsibilities sidebar) has claimed __NAV_OWNER.
         Previously this timer + render/goTo wrappers kept rewriting the sidebar
         with the v183 hub, so the recording showed two different sidebars flipping
         every ~1.5s. Yielding here leaves exactly one nav writer after boot. */
      if (window.__NAV_OWNER && window.__NAV_OWNER!=='v183' && window.__NAV_OWNER!=='v182') return;
      var nav = (document.getElementById('sidebar')||document.querySelector('aside.sb'));
      nav = nav ? nav.querySelector('nav') : null;
      if(!nav) return;
      var want = buildHubHTML();
      if (want && nav.innerHTML !== want && nav.getAttribute('data-v183sig') !== sig()){
        nav.innerHTML = want;
        nav.setAttribute('data-v183sig', sig());
      } else {
        var dash = nav.querySelector('.v183-dash');
        if (dash){ if(curMod()==='dashboard') dash.classList.add('active'); else dash.classList.remove('active'); }
      }
    }catch(e){}
  }
  function sig(){
    var u=activeUser(); if(!u) return 'nouser';
    return (u.username||'')+'|'+(u.role||'')+'|'+respItems(u).length;
  }

  /* neutralise v182's syncNav so it stops rewriting the old listing (single
     writer avoids duelling repaints). We do this by owning buildNav (v182's
     builder now returns our hub) — but v182 also has its own syncNav timer, so
     wrap render/goTo to run OUR sync last. */
  function wrapRouting(){
    if (window.render && !window.render.__v183){
      var _r = window.render;
      window.render = function(){ var o=_r.apply(this,arguments); try{ syncActive(); }catch(e){} try{ wireEntryPoints(); }catch(e){} return o; };
      window.render.__v183 = true; window.render.__v182 = true;
    }
    if (window.goTo && !window.goTo.__v183){
      var _g = window.goTo;
      window.goTo = function(){ var o=_g.apply(this,arguments); try{ syncActive(); }catch(e){} return o; };
      window.goTo.__v183 = true; window.goTo.__v182 = true;
    }
  }

  function boot(){ installBuildNav(); wrapUserProfile(); wrapRouting(); syncActive(); wireEntryPoints(); }
  [0,80,250,600,1200,2500].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(function(){ try{ syncActive(); wireEntryPoints(); }catch(e){} });

  try{ console.log('%c✅ v183 — responsibilities moved to a beautiful profile Workspace; sidebar shows a compact hub; every responsibility is a live goTo card','background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/136-d-8.js ==== */
(function(){
  if (window.__twhV184) return; window.__twhV184 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }

  /* rich metadata (mirrors v183 so v184 is self-contained) */
  var META = {
    dashboard:{l:'Dashboard',i:'fa-gauge-high',d:'Your at-a-glance overview & KPIs'},
    patients:{l:'Patients',i:'fa-user-injured',d:'Register & manage patient records'},
    appointments:{l:'Appointments',i:'fa-calendar-check',d:'Schedule & track appointments'},
    calendar:{l:'Appointment Calendar',i:'fa-calendar-days',d:'Calendar view of bookings'},
    emr:{l:'Medical Records',i:'fa-file-medical',d:'Electronic medical records'},
    prescriptions:{l:'Prescriptions',i:'fa-prescription',d:'Create & manage prescriptions'},
    laboratory:{l:'Laboratory',i:'fa-flask',d:'Lab orders, samples & results'},
    radiology:{l:'Radiology',i:'fa-x-ray',d:'Imaging orders & reports'},
    referrals:{l:'Referral Mgmt',i:'fa-share-nodes',d:'Inbound & outbound referrals'},
    beds:{l:'Bed Management',i:'fa-bed',d:'Ward & bed allocation'},
    pharmacy:{l:'Pharmacy',i:'fa-pills',d:'Dispensing & drug inventory'},
    or:{l:'OR Scheduling',i:'fa-user-doctor',d:'Operating-room scheduling'},
    emergency:{l:'Emergency',i:'fa-truck-medical',d:'Emergency department cases'},
    bloodbank:{l:'Blood Bank',i:'fa-droplet',d:'Blood stock & transfusions'},
    transactions:{l:'Transactions',i:'fa-right-left',d:'Financial transaction ledger'},
    billing:{l:'Billing & Finance',i:'fa-file-invoice-dollar',d:'Invoices, payments & finance'},
    fixedassets:{l:'Fixed Assets',i:'fa-building',d:'Asset register & depreciation'},
    hr:{l:'HR & Payroll',i:'fa-user-tie',d:'Staff, payroll & attendance'},
    inventory:{l:'Inventory',i:'fa-boxes-stacked',d:'Stores & stock control'},
    procurement:{l:'Procurement',i:'fa-cart-shopping',d:'Purchase orders & suppliers'},
    reports:{l:'Reports',i:'fa-chart-column',d:'Analytics & printable reports'},
    insurance:{l:'Insurance & Claims',i:'fa-file-shield',d:'Claims & coverage management'},
    audit:{l:'Audit Trail',i:'fa-shield-halved',d:'Immutable activity log'},
    compliance:{l:'WHO/JCI',i:'fa-earth-africa',d:'Compliance & accreditation'},
    portal:{l:'Patient Portal',i:'fa-laptop-medical',d:'Patient self-service portal'},
    telemedicine:{l:'Telemedicine',i:'fa-video',d:'Virtual consultations'},
    ai:{l:'AI Analytics',i:'fa-brain',d:'AI decision support'},
    queue:{l:'Queue Management',i:'fa-ticket',d:'OPD queue & tokens'},
    infection:{l:'Infection Control',i:'fa-virus-slash',d:'Infection prevention'},
    dietary:{l:'Dietary & Nutrition',i:'fa-utensils',d:'Meal & nutrition plans'},
    immunization:{l:'Immunization',i:'fa-syringe',d:'Vaccination schedules'},
    documents:{l:'Document Mgmt',i:'fa-folder-open',d:'Files & document store'},
    hah:{l:'Hospital at Home',i:'fa-house-medical',d:'Home-care programmes'},
    ambulance:{l:'Ambulance',i:'fa-truck-medical',d:'Fleet & dispatch'},
    crm:{l:'Call Center / CRM',i:'fa-headset',d:'Contact centre & CRM'},
    research:{l:'Clinical Research',i:'fa-microscope',d:'Studies & trials'},
    config:{l:'Configuration',i:'fa-sliders',d:'System configuration'},
    sysadmin:{l:'System Administration',i:'fa-user-shield',d:'Admin console'},
    users:{l:'User Management',i:'fa-users-gear',d:'Users, roles & access'},
    settings:{l:'Settings',i:'fa-gear',d:'Application preferences'},
    ess:{l:'My Self-Service (ESS)',i:'fa-id-badge',d:'Payslips, leave & profile'},
    attendance:{l:'Attendance',i:'fa-clock',d:'Clock-in / clock-out'},
    leave:{l:'Leave Management',i:'fa-plane-departure',d:'Leave requests & balances'},
    staffclaims:{l:'Staff Claims',i:'fa-receipt',d:'Expense & staff claims'},
    physiotherapy:{l:'Physiotherapy',i:'fa-person-walking',d:'Physio sessions & plans'}
  };
  function modMeta(id){
    if (META[id]) return { id:id, label:META[id].l, icon:META[id].i, desc:META[id].d };
    var d=D();
    var reg = d && d.moduleRegistry ? d.moduleRegistry[id] : null;
    var lbl = reg ? (reg.l||reg.label||id) : String(id||'').replace(/([a-z])([A-Z])/g,'$1 $2').replace(/[_\-]+/g,' ');
    lbl = lbl.charAt(0).toUpperCase()+lbl.slice(1);
    var ico = reg ? (reg.i||reg.icon||'fa-circle-dot') : 'fa-circle-dot';
    return { id:id, label:lbl, icon:ico, desc:'Open '+lbl };
  }
  function myResponsibilities(u){
    var d=D(); if(!d||!u) return [];
    var role = u.role || 'Staff';
    var set = {};
    var rr = d.responsibilities && d.responsibilities[role];
    if (rr) Object.keys(rr).forEach(function(id){ if(rr[id]) set[id]=true; });
    try{
      var ov = d.userOverrides && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov) Object.keys(ov).forEach(function(id){ if(ov[id]) set[id]=true; else delete set[id]; });
    }catch(e){}
    if (!Object.keys(set).length && window.__ROLE_ALLOWLIST && window.__ROLE_ALLOWLIST[role]){
      window.__ROLE_ALLOWLIST[role].forEach(function(id){ set[id]=true; });
    }
    if (!Object.keys(set).length) set['dashboard']=true;
    return Object.keys(set);
  }
  function respItems(u){
    /* (v191 Fix D) Derive the workspace cards from EXACTLY the same allowlist
       source the sidebar + Quick Access use — v188's __hmsMyModules (getModulesForRole
       + per-user overrides). Then hard-filter by canRouteTo so this surface can
       NEVER offer a module the guard would deny (previously it read raw
       D.responsibilities[role] and showed e.g. Billing/Transactions/AP-AR that the
       Front Desk allowlist excludes → 10 cards vs 8 real). */
    var ids = null;
    try{
      if (typeof window.__hmsMyModules==='function'){
        ids = (window.__hmsMyModules(u)||[]).map(function(m){ return (m&&m.id)||m; });
      }
    }catch(e){ ids = null; }
    if (!ids || !ids.length) ids = myResponsibilities(u);
    var canRoute = (typeof window.canRouteTo==='function') ? window.canRouteTo : function(){ return true; };
    var seen = {};
    return ids
      .filter(function(id){ if(id==='dashboard') return false; if(seen[id]) return false; seen[id]=true; return true; })
      .filter(function(id){ try{ return canRoute(id); }catch(e){ return true; } })
      .map(modMeta)
      .sort(function(a,b){ return a.label.localeCompare(b.label); });
  }
  function myRoles(u){
    if(!u) return [];
    return String(u.role || 'Staff').split(/[,/;|]+/).map(function(s){return s.trim();}).filter(Boolean);
  }

  /* ── (2) build the dashboard "My Workspace" responsibilities block ──────── */
  function workspaceHTML(){
    var u = activeUser();
    if (!u) return '';
    var d = D() || {};
    var roles = myRoles(u);
    var items = respItems(u);
    var initial = esc((u.fullName||u.username||'A').charAt(0).toUpperCase());
    var name = esc(u.fullName || u.username || 'User');
    var branch = esc(d.currentBranch || 'Main');

    var hero = '<div class="v184-ws"><div class="v184-ws-row">'
      + '<div class="v184-ws-av">'+initial+'</div>'
      + '<div>'
      +   '<div class="v184-ws-hi">My Workspace</div>'
      +   '<div class="v184-ws-name">'+name+'</div>'
      +   '<div class="v184-ws-meta">'
      +     '<span class="v184-ws-chip"><i class="fa-solid fa-user-shield"></i>'+esc(roles.join(' · ')||'Staff')+'</span>'
      +     '<span class="v184-ws-chip"><i class="fa-solid fa-location-dot"></i>'+branch+'</span>'
      +     '<span class="v184-ws-chip"><i class="fa-solid fa-layer-group"></i>'+items.length+' responsibilities</span>'
      +     '<span class="v184-ws-chip"><i class="fa-solid fa-circle-check"></i>All active</span>'
      +   '</div>'
      + '</div>'
      + '<div class="v184-ws-spacer"></div>'
      + '</div></div>';

    var sec = '<div class="v184-sec"><i class="fa-solid fa-grip"></i> My Responsibilities <span class="v184-num">'+items.length+'</span></div>';

    var grid;
    if (!items.length){
      grid = '<div class="v184-empty"><i class="fa-solid fa-circle-info" style="font-size:22px;color:var(--pri);display:block;margin-bottom:8px"></i>No responsibilities are assigned to your role yet.<br>Contact your administrator to request access.</div>';
    } else {
      grid = '<div class="v184-grid">' + items.map(function(m){
        return '<button type="button" class="v184-card" onclick="try{goTo(\''+esc(m.id)+'\')}catch(e){}" title="Open '+esc(m.label)+'">'
          +   '<div class="v184-card-ic"><i class="fa-solid '+esc(m.icon)+'"></i></div>'
          +   '<div class="v184-card-title">'+esc(m.label)+'</div>'
          +   '<div class="v184-card-desc">'+esc(m.desc||('Open '+m.label))+'</div>'
          +   '<div class="v184-card-go">Open <i class="fa-solid fa-arrow-right-long"></i></div>'
          + '</button>';
      }).join('') + '</div>';
    }
    return hero + sec + grid;
  }
  window.__hmsWorkspaceHTML = workspaceHTML;   /* expose for tests */

  /* prepend the workspace section to every dashboard render */
  function wrapRenderDashboard(){
    if (typeof window.renderDashboard==='function' && !window.renderDashboard.__v184){
      var orig = window.renderDashboard;
      window.renderDashboard = function(){
        var out = orig.apply(this, arguments);
        try{ return workspaceHTML() + (out||''); }catch(e){ return out; }
      };
      window.renderDashboard.__v184 = true;
    }
    /* also cover renderModule → dashboard, in case a later pack swaps things */
    if (typeof window.renderModule==='function' && !window.renderModule.__v184){
      var origM = window.renderModule;
      window.renderModule = function(){
        var out = origM.apply(this, arguments);
        try{
          if (curMod()==='dashboard' && typeof out==='string' && out.indexOf('v184-ws')===-1){
            return workspaceHTML() + out;
          }
        }catch(e){}
        return out;
      };
      window.renderModule.__v184 = true;
    }
  }

  /* ── (3) move the essential sidebar controls into the header ───────────── */
  function injectHeaderBits(){
    try{
      var u = activeUser(); if(!u) return;
      var hdr = document.querySelector('.main .hdr'); if(!hdr) return;
      var left = hdr.querySelector('.hdr-left');
      var right = hdr.querySelector('.hdr-right');

      /* neutralise the now-useless sidebar burger */
      var burger = hdr.querySelector('.toggle-btn');
      if (burger && !burger.__v184){ burger.classList.add('__v184-burger'); burger.__v184=true; }

      /* brand mark on the left (replaces sidebar logo/title) */
      if (left && !left.querySelector('.v184-brand')){
        var brand = document.createElement('div');
        brand.className = 'v184-brand';
        var logoSrc = (typeof window.TRANQUIL_EMBLEM!=='undefined' && window.TRANQUIL_EMBLEM) ? window.TRANQUIL_EMBLEM : '';
        brand.innerHTML = '<div class="v184-brand-logo">'+(logoSrc?'<img src="'+logoSrc+'" alt="Tranquil">':'<i class="fa-solid fa-hospital" style="color:#0d9488"></i>')+'</div>'
          + '<div class="v184-brand-txt"><div class="v184-brand-t">Tranquil Hospital</div><div class="v184-brand-s">&amp; Wellness Centre</div></div>';
        left.insertBefore(brand, left.firstChild);
      }

      /* branch selector + logout on the right (were in the sidebar) */
      if (right && !right.querySelector('.v184-branch')){
        var d = D() || {};
        var branches = (d.branches||[]).filter(function(b){ return b.status==='Active'; });
        if (branches.length){
          var sel = document.createElement('select');
          sel.className = 'v184-branch';
          sel.title = 'Switch branch';
          sel.innerHTML = branches.map(function(b){ return '<option value="'+esc(b.code)+'"'+(d.currentBranch===b.code?' selected':'')+'>'+esc(b.name)+'</option>'; }).join('');
          sel.onchange = function(){ try{ D().currentBranch=this.value; if(typeof window.toast==='function') toast('Branch: '+this.options[this.selectedIndex].text); }catch(e){} };
          right.insertBefore(sel, right.firstChild);
        }
      }
      if (right && !right.querySelector('.v184-logout')){
        var pw = document.createElement('button');
        pw.className = 'notif-btn';
        pw.title = 'Change Password';
        pw.innerHTML = '<i class="fa-solid fa-key"></i>';
        pw.onclick = function(){ try{ changeMyPassword(); }catch(e){} };
        right.appendChild(pw);

        var lo = document.createElement('button');
        lo.className = 'v184-logout';
        lo.title = 'Logout';
        lo.innerHTML = '<i class="fa-solid fa-sign-out-alt"></i>';
        lo.onclick = function(){ try{ doLogout(); }catch(e){} };
        right.appendChild(lo);
      }
    }catch(e){}
  }

  function boot(){ wrapRenderDashboard(); injectHeaderBits(); }
  [0,80,250,600,1200,2500].forEach(function(t){ setTimeout(boot, t); });
  /* re-inject header bits after re-renders (they get wiped on innerHTML rebuild) */
  if (window.render && !window.render.__v184){
    var _r = window.render;
    window.render = function(){ var o=_r.apply(this,arguments); try{ injectHeaderBits(); }catch(e){} return o; };
    window.render.__v184 = true;
  }
  DOMBus.register(function(){ try{ injectHeaderBits(); }catch(e){} });

  try{ console.log('%c✅ v184 — sidebar removed for all users; responsibilities live on the dashboard as interactive cards; branch/profile/logout moved to the header','background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/137-twh-large-table-stream-v350.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · LARGE GENERIC-TABLE POST-PAINT ROW STREAMING (v350)
   ────────────────────────────────────────────────────────────────────────
   Follow-up to the v349 boot-stall deep-dive: a navigation-latency profile of
   every module (goTo → render → renderModule) found the module-switch cost is
   dominated by a handful of screens that build ONE very large table string
   synchronously and inject it in a single innerHTML write. The worst offender
   is INVENTORY: a boot-time CSV import grows D.inventory to ~366 rows, and
   renderInventory() feeds all of them through renderGenericTable() — an 11-col
   table with a 4-button action cell per row. Pure string build measured ~35 ms
   for ~383 KB, and the browser then parses ~5,500 nodes in the same task, so
   the FIRST paint of Inventory is a visible ~100–200 ms hitch. pharmacy /
   employees / purchaseOrders / insuranceClaims / auditLog / compliance use the
   same renderGenericTable() path and scale the same way as their data grows.

   ── FIX — render a screenful now, stream the tail after paint ─────────────
   Wrap window.renderGenericTable (a CORE global) as the OUTERMOST decorator:

     • rows.length <= CAP  → return the ORIGINAL full string. Zero behaviour
       change for the overwhelming majority of tables (nearly all are small).

     • rows.length  > CAP  → return the table containing ONLY the first CAP
       rows, tag its <tbody> with a unique data-twh-stream token, and stash the
       remaining rows' <tr> HTML in an in-memory registry keyed by that token.
       renderGenericTable is called INSIDE larger module strings and the whole
       string is injected at once, so the tagged <tbody> lands live in the DOM.
       A post-paint pass (shared DOMBus ticker + a bounded rAF drain, 10 ms/
       frame budget) then finds every pending <tbody data-twh-stream> and
       appends its tail rows in chunks, clearing the token when complete.

   Net effect: the initial navigation paint renders ~CAP rows (Inventory first
   paint drops from ~383 KB / ~35 ms to ~1/3 of that), and the remaining rows
   fill in over the next 1–2 frames — so no single module-switch task blows the
   frame budget, while EVERY row still ends up in the live DOM.

   ── WHY THIS IS SAFE FOR FILTERS / SEARCH / EXPORT ───────────────────────
   The app's filter helpers (filterInvTable, filterUsersTable, …) show/hide the
   LIVE <tbody> <tr> nodes, and export/print read D.<key> directly — both need
   every row present in the DOM / data. Streaming guarantees that: the tail is
   appended into the SAME tbody, so once the (sub-frame) drain finishes the DOM
   is identical to the un-streamed table. To eliminate any race where the user
   filters/searches mid-stream, we FLUSH all pending streams synchronously on
   the first keydown / input / change inside a streaming table's container (a
   single delegated listener), and expose window.__twhFlushTableStreams().

   ── CONSTRAINTS ──────────────────────────────────────────────────────────
   Wraps ONLY window.renderGenericTable. Never copies flags via `for (k in fn)`.
   No core / CSS-file / D1 / /api/state / _redirects / worker / pack-order
   edits (this is a NEW app-chunk pack appended after 256). No raw setInterval /
   MutationObserver / DOMContentLoaded — rides the shared DOMBus ticker + a
   bounded rAF drain + one delegated input listener. Idempotent; guard
   __twhV350. Stays INERT under jsdom (the test/profiler harness does not drain
   rAF) so the built-string assertions and validators see the original output.

   Guard: window.__twhV350   Diagnostics: window.__twhV350Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV350) return;
  window.__twhV350 = true;

  // Stay inert under jsdom / non-visual harnesses: the profilers and validators
  // eval the bundle in jsdom and assert on the SYNCHRONOUS string output. They
  // do not run a real rAF loop, so a streamed table would strand its tail rows.
  // In that environment we simply never intercept — renderGenericTable returns
  // its full, original string exactly as before.
  var INERT = false;
  try { INERT = /jsdom/i.test((window.navigator && window.navigator.userAgent) || ''); } catch (e) {}

  function isFn(f) { return typeof f === 'function'; }

  // Only tables larger than this get streamed. Chosen so a screenful+ paints
  // instantly while the tail (which the user must scroll to see) fills in next
  // frame. Small tables (the vast majority) are returned untouched.
  var CAP = 140;
  var FRAME_BUDGET_MS = 10;   // per-frame drain budget — keeps each tick short

  var diag = { wrapped: false, streamed: 0, drained: 0, flushed: 0, pending: 0, frames: 0 };
  window.__twhV350Diag = function () { diag.pending = countPending(); return diag; };

  // token -> { rowsHTML: string(remaining <tr>…</tr>), done: bool }
  var registry = Object.create(null);
  var seq = 0;

  function countPending() {
    var n = 0;
    for (var k in registry) { if (registry[k] && !registry[k].done) n++; }
    return n;
  }

  // Extract just the <tbody>…</tbody> inner rows from a full core render string,
  // so the streamed tail is BYTE-IDENTICAL to a non-streamed render — it is the
  // core row template verbatim (we reuse inner(), never a hand-mirror).
  function tbodyInner(fullStr) {
    var a = fullStr.indexOf('<tbody');
    if (a === -1) return '';
    a = fullStr.indexOf('>', a);
    if (a === -1) return '';
    var b = fullStr.indexOf('</tbody>', a);
    if (b === -1) return '';
    return fullStr.slice(a + 1, b);
  }

  var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window)
    : function (fn) { return setTimeout(function () { fn(Date.now()); }, 16); };

  function install() {
    if (INERT) return false;
    if (!isFn(window.renderGenericTable)) return false;
    if (window.renderGenericTable.__v350) return true;
    var inner = window.renderGenericTable;

    var wrapped = function (rows, cols, dataKey) {
      // Defensive: anything unexpected → original behaviour.
      if (!rows || !rows.length || rows.length <= CAP || !cols || !cols.length) {
        return inner(rows, cols, dataKey);
      }
      var head = rows.slice(0, CAP);
      var tail = rows.slice(CAP);
      // First CAP rows via the ORIGINAL function (guarantees the head is
      // byte-identical to core, incl. the wrapper div/table/thead markup).
      var full = inner(head, cols, dataKey);
      // Tail rows: render them via the ORIGINAL function too, then keep only its
      // <tbody> inner — byte-identical to core's row template, no hand-mirror.
      var token = 'ts' + (++seq) + '_' + Date.now().toString(36);
      var tailHTML = '';
      try { tailHTML = tbodyInner(inner(tail, cols, dataKey)); } catch (e) {}
      registry[token] = { rowsHTML: tailHTML, done: false, total: tail.length };
      diag.streamed++;
      // Tag the tbody. Core template: `<tbody>\n  <rows>\n  </tbody>`.
      var tagged = full.replace('<tbody>', '<tbody data-twh-stream="' + token + '">');
      // If (unexpectedly) no <tbody> token could be placed, fall back to full.
      if (tagged === full) { registry[token].done = true; return inner(rows, cols, dataKey); }
      schedule();
      return tagged;
    };
    wrapped.__v350 = true;
    // Preserve any flags earlier decorators may probe on renderGenericTable.
    try { for (var kk in inner) { if (kk.charAt(0) === '_') wrapped[kk] = inner[kk]; } } catch (e) {}
    window.renderGenericTable = wrapped;
    diag.wrapped = true;
    return true;
  }

  // ── DRAIN: append tail rows into every live pending <tbody> across frames ──
  var draining = false;
  function drainStep() {
    var deadline = Date.now() + FRAME_BUDGET_MS;
    var tbodies;
    try { tbodies = document.querySelectorAll('tbody[data-twh-stream]'); }
    catch (e) { draining = false; return; }
    if (!tbodies || !tbodies.length) { draining = false; return; }
    diag.frames++;
    var anyLeft = false;
    for (var t = 0; t < tbodies.length; t++) {
      var tb = tbodies[t];
      var token = tb.getAttribute('data-twh-stream');
      var rec = token && registry[token];
      // Append this tbody's entire remaining tail in one write, then untag it.
      // One module's tail is bounded; the FRAME_BUDGET_MS check + rAF between
      // tbodies keeps each frame short when several tables stream at once.
      appendTail(tb, rec);
      try { tb.removeAttribute('data-twh-stream'); } catch (e) {}
      if (Date.now() >= deadline && t + 1 < tbodies.length) { anyLeft = true; break; }
    }
    if (anyLeft) raf(drainStep);
    else draining = false;
  }

  // Append a tbody's remaining rows in a single write and mark it done.
  function appendTail(tb, rec) {
    if (!tb || !rec || rec.done) return;
    if (rec.rowsHTML) { try { tb.insertAdjacentHTML('beforeend', rec.rowsHTML); } catch (e) {} }
    rec.rowsHTML = ''; rec.done = true; diag.drained++;
  }

  function schedule() {
    if (draining) return;
    draining = true;
    raf(drainStep);
  }

  // ── FLUSH: complete ALL pending streams synchronously (no waiting frames) ──
  // Called before any filter/search runs so the DOM has every row. Also public.
  function flushAll() {
    var tbodies;
    try { tbodies = document.querySelectorAll('tbody[data-twh-stream]'); }
    catch (e) { return; }
    for (var t = 0; t < tbodies.length; t++) {
      var tb = tbodies[t];
      var token = tb.getAttribute('data-twh-stream');
      var rec = token && registry[token];
      if (rec && !rec.done) { appendTail(tb, rec); diag.flushed++; }
      try { tb.removeAttribute('data-twh-stream'); } catch (e) {}
    }
  }
  window.__twhFlushTableStreams = flushAll;

  // Delegated input listener: the instant the user types in a search box or
  // changes a filter <select> that lives in a container holding a streaming
  // table, flush that stream first so the filter sees all rows. Cheap: only
  // acts when a pending stream exists.
  function onEarlyInteract(e) {
    if (INERT) return;
    if (countPending() === 0) return;
    var t = e.target;
    if (!t) return;
    var tag = (t.tagName || '').toUpperCase();
    if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') flushAll();
  }
  function armInteractListener() {
    try {
      if (!document.body || document.body.__twhV350Input) return;
      document.body.__twhV350Input = true;
      document.body.addEventListener('input', onEarlyInteract, true);
      document.body.addEventListener('change', onEarlyInteract, true);
      document.body.addEventListener('keydown', onEarlyInteract, true);
    } catch (e) {}
  }

  // Boot + re-assert across the staggered boot window (a later pack could wrap
  // renderGenericTable; we climb back outermost and re-arm on the next tick).
  function tick() {
    if (INERT) return;
    try { install(); } catch (e) {}
    try { armInteractListener(); } catch (e) {}
    // Kick a drain in case a render already produced pending tbodies.
    try { if (countPending() > 0) schedule(); } catch (e) {}
  }
  tick();
  [400, 1400, 3000, 6500].forEach(function (ms) { try { setTimeout(tick, ms); } catch (e) {} });
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
})();

;

/* ==== /js/138-d-9.js ==== */
(function(){
  if (window.__twhV185) return; window.__twhV185 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }
  function two(n){ return (n<10?'0':'')+n; }
  function hhmm(d){ d=d||new Date(); return two(d.getHours())+':'+two(d.getMinutes()); }

  /* enable global a11y helpers + a tamed color scope on the body */
  try{ document.body.classList.add('v185-a11y','v185-tamed'); }catch(e){}
  /* restore density preference */
  try{
    var dens = localStorage.getItem('v185-density') || 'comfy';
    document.body.classList.add(dens==='dense'?'v185-dense':'v185-comfy');
  }catch(e){}
  window.__hmsV185 = window.__hmsV185 || {};

  /* ═══════════════════════════════════════════════════════════════════════
     P3 · PATIENT CONTEXT — a tiny selection store shared across modules
     ═══════════════════════════════════════════════════════════════════════ */
  var CLINICAL_MODS = { emr:1, prescriptions:1, laboratory:1, radiology:1, billing:1,
    beds:1, emergency:1, appointments:1, pharmacy:1, or:1, immunization:1, referrals:1 };

  function getSelectedPatient(){
    var d=D(); if(!d) return null;
    var id = window.__v185PatientId;
    if (id==null){ try{ id = +sessionStorage.getItem('v185-patient'); }catch(e){} }
    if (id==null || isNaN(id)) return null;
    return (d.patients||[]).find(function(p){ return p.id===id; }) || null;
  }
  window.setClinicalPatient = function(id){
    window.__v185PatientId = (id==null?null:+id);
    try{ if(id==null) sessionStorage.removeItem('v185-patient'); else sessionStorage.setItem('v185-patient', String(id)); }catch(e){}
    renderPatientBanner();
  };
  window.clearClinicalPatient = function(){ window.setClinicalPatient(null); };

  function bannerHTML(p){
    if(!p) return '';
    var allergies = (p.allergies||'').trim();
    var hasAllergy = allergies && !/^(none|nil|n\/a|no known)/i.test(allergies);
    var initial = esc((p.fullName||'?').charAt(0).toUpperCase());
    return '<div class="v185-pctx'+(hasAllergy?' crit':'')+'" role="region" aria-label="Selected patient context">'
      + '<div class="v185-pctx-av">'+initial+'</div>'
      + '<div><div class="v185-pctx-name">'+esc(p.fullName||'Unknown')+'</div>'
      +   '<div class="v185-pctx-meta">'
      +     '<span>MRN <b>'+esc(p.mrn||'—')+'</b></span>'
      +     '<span><b>'+esc((p.age!=null?p.age+'y':''))+(p.gender?' · '+esc(p.gender):'')+'</b></span>'
      +     '<span>Blood <b>'+esc(p.bloodGroup||'—')+'</b></span>'
      +     (p.genotype?'<span>Genotype <b>'+esc(p.genotype)+'</b></span>':'')
      +     '<span class="v185-pctx-allergy'+(hasAllergy?'':' none')+'"><i class="fa-solid '+(hasAllergy?'fa-triangle-exclamation':'fa-circle-check')+'"></i>'+(hasAllergy?('Allergy: '+esc(allergies)):'No known allergies')+'</span>'
      +   '</div></div>'
      + '<div class="v185-pctx-spacer"></div>'
      + '<button class="v185-pctx-x" title="Clear patient context" aria-label="Clear patient" onclick="clearClinicalPatient()"><i class="fa-solid fa-xmark"></i></button>'
      + '</div>';
  }

  function renderPatientBanner(){
    try{
      var content = document.getElementById('moduleContent'); if(!content) return;
      var existing = content.querySelector('.v185-pctx-wrap');
      var p = getSelectedPatient();
      var show = p && CLINICAL_MODS[curMod()];
      if(!show){ if(existing) existing.remove(); return; }
      var html = '<div class="v185-pctx-wrap">'+bannerHTML(p)+'</div>';
      if(existing){ existing.outerHTML = html; }
      else { content.insertAdjacentHTML('afterbegin', html); }
    }catch(e){}
  }
  window.__hmsV185.renderPatientBanner = renderPatientBanner;

  /* Hook viewPatient so opening a patient sets the shared context */
  function wrapViewPatient(){
    ['viewPatient','V25_viewPatient'].forEach(function(fn){
      if (typeof window[fn]==='function' && !window[fn].__v185){
        var orig = window[fn];
        window[fn] = function(id){ try{ window.setClinicalPatient(id); }catch(e){} return orig.apply(this, arguments); };
        window[fn].__v185 = true;
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     P2 · SYNC STATE CHIP
     ═══════════════════════════════════════════════════════════════════════ */
  var syncState = { status:'idle', lastSaved:null };
  function syncChipHTML(){
    var s = syncState;
    if (s.status==='syncing') return '<span class="v185-sync syncing" title="Syncing with server"><span class="v185-dot"></span>Syncing…</span>';
    if (s.status==='error') return '<span class="v185-sync error" title="Last sync failed — will retry"><span class="v185-dot"></span>Sync error</span>';
    var when = s.lastSaved ? ('Saved · '+hhmm(s.lastSaved)) : 'All changes saved';
    return '<span class="v185-sync" title="All changes are saved to the shared database"><span class="v185-dot"></span>'+when+'</span>';
  }
  function paintSyncChip(){
    try{
      var hdr = document.querySelector('.main .hdr .hdr-right'); if(!hdr) return;
      var slot = hdr.querySelector('.v185-sync-slot');
      if(!slot){ slot=document.createElement('span'); slot.className='v185-sync-slot'; slot.style.cssText='display:inline-flex;align-items:center;margin-right:2px'; hdr.insertBefore(slot, hdr.firstChild); }
      slot.innerHTML = syncChipHTML();
    }catch(e){}
  }
  function setSync(status){ syncState.status=status; if(status==='idle') syncState.lastSaved=new Date(); paintSyncChip(); }

  /* Subscribe to the AUTHORITATIVE sync state emitted by the persistence layer
     (driven by actual completed network writes). This replaces the old wrapper
     that guessed the state from a coalesced promise + stale lastError — which is
     what left the "Sync error" pill stuck on screen. */
  function wrapSync(){
    if (window.HMS_DB && typeof window.HMS_DB.onState==='function' && !window.__v185SyncBound){
      window.__v185SyncBound = true;
      window.HMS_DB.onState(function(state, err, lastSaved){
        syncState.status = state;
        if (state==='idle') syncState.lastSaved = lastSaved ? new Date(lastSaved) : new Date();
        paintSyncChip();
      });
      /* seed initial paint from current state */
      try{
        syncState.status = window.HMS_DB.syncState || 'idle';
        if (window.HMS_DB.lastSaved) syncState.lastSaved = new Date(window.HMS_DB.lastSaved);
        paintSyncChip();
      }catch(e){}
      return;
    }
    /* fallback (persistence layer not present, e.g. behind login gate): keep the
       legacy wrapper so the chip still animates on save calls */
    if (typeof window._hmsSave==='function' && !window._hmsSave.__v185){
      var origSave = window._hmsSave;
      window._hmsSave = function(){
        setSync('syncing');
        var r;
        try{ r = origSave.apply(this, arguments); }catch(e){ setSync('error'); throw e; }
        if (r && typeof r.then==='function'){
          r.then(function(){ setSync(window.HMS_DB && window.HMS_DB.lastError ? 'error':'idle'); },
                 function(){ setSync('error'); });
        } else { setSync('idle'); }
        return r;
      };
      window._hmsSave.__v185 = true;
    }
  }

  /* "N records updated — refresh" pill: watch the shared doc size/signature and,
     instead of letting a poll repaint under the user, offer a gentle refresh. */
  function ensureRefreshPill(){
    var pill = document.getElementById('v185RefreshPill');
    if(!pill){
      pill = document.createElement('div');
      pill.id='v185RefreshPill'; pill.className='v185-refresh-pill';
      pill.innerHTML = '<span id="v185RefreshTxt">Records updated</span><button onclick="__hmsV185.applyRefresh()">Refresh</button>';
      document.body.appendChild(pill);
    }
    return pill;
  }
  window.__hmsV185.applyRefresh = function(){
    var pill = document.getElementById('v185RefreshPill'); if(pill) pill.classList.remove('show');
    try{ if(typeof window.render==='function') window.render(); }catch(e){}
  };
  function showRefreshPill(n){
    var pill = ensureRefreshPill();
    var t = document.getElementById('v185RefreshTxt');
    if(t) t.textContent = (n>1? (n+' records updated') : 'A record was updated');
    pill.classList.add('show');
  }
  /* observe refresh completions by wrapping _hmsRefresh to detect changes while
     a modal/typing is in progress (i.e., when the engine deferred the repaint) */
  function wrapRefresh(){
    if (typeof window._hmsRefresh==='function' && !window._hmsRefresh.__v185){
      var origR = window._hmsRefresh;
      var lastSig = null;
      window._hmsRefresh = function(){
        var r = origR.apply(this, arguments);
        try{
          if(r && typeof r.then==='function'){
            r.then(function(){
              try{
                var d=D(); if(!d) return;
                var sig = (d.patients||[]).length+'|'+(d.transactions||[]).length+'|'+(d.bills||[]).length+'|'+(d.appointments||[]).length+'|'+(d.labTests||[]).length;
                if(lastSig!==null && sig!==lastSig){
                  var modalOpen = !!document.getElementById('modalBg');
                  var typing = !!(document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName));
                  if(modalOpen || typing) showRefreshPill(1);
                  paintSyncChip();
                }
                lastSig = sig;
              }catch(e){}
            });
          }
        }catch(e){}
        return r;
      };
      window._hmsRefresh.__v185 = true;
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     P4 · COMMAND PALETTE (Ctrl/⌘+K)
     ═══════════════════════════════════════════════════════════════════════ */
  var MODULE_LIST = [
    ['dashboard','Dashboard','fa-gauge-high'],['patients','Patients','fa-user-injured'],
    ['appointments','Appointments','fa-calendar-check'],['emr','Medical Records','fa-file-medical'],
    ['prescriptions','Prescriptions','fa-prescription'],['laboratory','Laboratory','fa-flask'],
    ['radiology','Radiology','fa-x-ray'],['beds','Bed Management','fa-bed'],
    ['pharmacy','Pharmacy','fa-pills'],['emergency','Emergency','fa-truck-medical'],
    ['bloodbank','Blood Bank','fa-droplet'],['billing','Billing & Finance','fa-file-invoice-dollar'],
    ['transactions','Transactions','fa-right-left'],['hr','HR & Payroll','fa-user-tie'],
    ['inventory','Inventory','fa-boxes-stacked'],['procurement','Procurement','fa-cart-shopping'],
    ['reports','Reports','fa-chart-column'],['insurance','Insurance & Claims','fa-file-shield'],
    ['settings','Settings','fa-gear'],['config','Configuration','fa-sliders'],['users','User Management','fa-users-gear']
  ];
  var cmdkSel = 0, cmdkResults = [];

  function buildResults(q){
    q = (q||'').trim().toLowerCase();
    var d = D() || {};
    var out = [];
    // modules
    MODULE_LIST.forEach(function(m){
      if(!q || m[1].toLowerCase().indexOf(q)!==-1 || m[0].indexOf(q)!==-1)
        out.push({type:'mod', id:m[0], icon:m[2], title:m[1], sub:'Go to module', run:function(){ try{ closeCmdk(); goTo(m[0]); }catch(e){} }});
    });
    if(q){
      // patients
      (d.patients||[]).forEach(function(p){
        var hay=((p.fullName||'')+' '+(p.mrn||'')+' '+(p.phone||'')).toLowerCase();
        if(hay.indexOf(q)!==-1) out.push({type:'pt', id:p.id, icon:'fa-user', title:p.fullName||'Patient',
          sub:'MRN '+(p.mrn||'—')+' · '+((p.age!=null?p.age+'y':''))+(p.gender?' '+p.gender:''),
          run:function(){ closeCmdk(); try{ window.setClinicalPatient(p.id); }catch(e){} try{ if(typeof window.viewPatient==='function') viewPatient(p.id); else goTo('patients'); }catch(e){} }});
      });
      // invoices / bills
      (d.bills||[]).forEach(function(b){
        var code=(b.code||b.billNo||('BILL-'+b.id)); var hay=(code+' '+(b.patientName||'')).toLowerCase();
        if(hay.indexOf(q)!==-1) out.push({type:'inv', id:b.id, icon:'fa-file-invoice-dollar', title:code,
          sub:'Invoice'+(b.balance!=null?(' · balance '+b.balance):''),
          run:function(){ closeCmdk(); try{ if(typeof window.openPatientBill==='function') openPatientBill(b.patientId,b.id); else goTo('billing'); }catch(e){ goTo('billing'); } }});
      });
    }
    return out.slice(0, 40);
  }
  function renderCmdkList(){
    var list = document.getElementById('v185CmdkList'); if(!list) return;
    if(!cmdkResults.length){ list.innerHTML = '<div class="v185-cmdk-empty">No matches. Try a patient name, MRN, invoice number, or module.</div>'; return; }
    var groups = {mod:[], pt:[], inv:[]};
    cmdkResults.forEach(function(r,i){ r.__i=i; groups[r.type].push(r); });
    var html='';
    function grp(key,label){
      if(!groups[key].length) return;
      html += '<div class="v185-cmdk-grp">'+label+'</div>';
      groups[key].forEach(function(r){
        var cls = r.type==='pt'?'pt':(r.type==='inv'?'inv':'mod');
        html += '<div class="v185-cmdk-item '+cls+(r.__i===cmdkSel?' sel':'')+'" data-i="'+r.__i+'" role="option">'
          + '<div class="v185-cmdk-ic"><i class="fa-solid '+r.icon+'"></i></div>'
          + '<div><div class="v185-cmdk-t">'+esc(r.title)+'</div><div class="v185-cmdk-s">'+esc(r.sub)+'</div></div></div>';
      });
    }
    grp('pt','Patients'); grp('inv','Invoices'); grp('mod','Modules');
    list.innerHTML = html;
    Array.prototype.forEach.call(list.querySelectorAll('.v185-cmdk-item'), function(el){
      el.onclick = function(){ var r=cmdkResults[+el.getAttribute('data-i')]; if(r&&r.run) r.run(); };
    });
  }
  function openCmdk(){
    if(document.getElementById('v185CmdkBg')) return;
    var bg = document.createElement('div');
    bg.id='v185CmdkBg'; bg.className='v185-cmdk-bg';
    bg.onclick = function(e){ if(e.target===bg) closeCmdk(); };
    bg.innerHTML = '<div class="v185-cmdk" role="dialog" aria-label="Command palette">'
      + '<div class="v185-cmdk-in"><i class="fa-solid fa-magnifying-glass"></i>'
      +   '<input id="v185CmdkInput" placeholder="Search patients, invoices, modules…" aria-label="Search" autocomplete="off">'
      +   '<span class="v185-cmdk-hint">ESC</span></div>'
      + '<div class="v185-cmdk-list" id="v185CmdkList" role="listbox"></div></div>';
    document.body.appendChild(bg);
    var input = document.getElementById('v185CmdkInput');
    cmdkSel=0; cmdkResults = buildResults(''); renderCmdkList();
    input.addEventListener('input', function(){ cmdkSel=0; cmdkResults=buildResults(this.value); renderCmdkList(); });
    input.addEventListener('keydown', function(e){
      if(e.key==='ArrowDown'){ e.preventDefault(); cmdkSel=Math.min(cmdkSel+1,cmdkResults.length-1); renderCmdkList(); scrollSel(); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); cmdkSel=Math.max(cmdkSel-1,0); renderCmdkList(); scrollSel(); }
      else if(e.key==='Enter'){ e.preventDefault(); var r=cmdkResults[cmdkSel]; if(r&&r.run) r.run(); }
      else if(e.key==='Escape'){ e.preventDefault(); closeCmdk(); }
    });
    setTimeout(function(){ input.focus(); }, 20);
  }
  function scrollSel(){ var el=document.querySelector('.v185-cmdk-item.sel'); if(el&&el.scrollIntoView) el.scrollIntoView({block:'nearest'}); }
  function closeCmdk(){ var bg=document.getElementById('v185CmdkBg'); if(bg) bg.remove(); }
  window.openCommandPalette = openCmdk;

  document.addEventListener('keydown', function(e){
    if((e.metaKey||e.ctrlKey) && (e.key==='k'||e.key==='K')){ e.preventDefault(); if(window.isLoggedIn) openCmdk(); }
  });

  /* header search box → also opens the palette for discoverability */
  function wireHeaderSearch(){
    try{
      var gs = document.getElementById('globalSearch');
      if(gs && !gs.__v185){ gs.__v185=true; gs.setAttribute('placeholder','Search  (⌘/Ctrl + K)'); gs.addEventListener('focus', function(){ openCmdk(); this.blur(); }); }
    }catch(e){}
  }

  /* ═══════════════════════════════════════════════════════════════════════
     P5 · TASK-FIRST, ROLE-AWARE WORKLIST (dashboard)
     ═══════════════════════════════════════════════════════════════════════ */
  function num(arr){ return Array.isArray(arr)?arr.length:0; }
  function worklistTasks(){
    var d = D() || {}; var u = activeUser() || {}; var role = (u.role||'').toLowerCase();
    var T = [];
    function pending(arr,statuses){ return (arr||[]).filter(function(x){ return statuses.indexOf((x.status||'').toLowerCase())!==-1; }).length; }

    // clinical roles
    if(/doctor|consultant|physician/.test(role)){
      T.push({lbl:'My Appointments Today', val:pending(d.appointments,['scheduled','confirmed']), ic:'fa-calendar-check', tone:'ok', sub:'Scheduled visits', mod:'appointments'});
      T.push({lbl:'Lab Results to Review', val:pending(d.labTests,['completed','resulted','pending review']), ic:'fa-flask', tone:'warn', sub:'Awaiting sign-off', mod:'laboratory'});
      T.push({lbl:'Prescriptions', val:pending(d.prescriptions,['pending','active']), ic:'fa-prescription', tone:'ok', sub:'Active scripts', mod:'prescriptions'});
    } else if(/nurse/.test(role)){
      T.push({lbl:'Admitted Patients', val:(d.patients||[]).filter(function(p){return p.status==='Admitted';}).length, ic:'fa-bed', tone:'ok', sub:'Under care', mod:'beds'});
      T.push({lbl:'Appointments', val:pending(d.appointments,['scheduled','confirmed']), ic:'fa-calendar-check', tone:'ok', sub:'Today', mod:'appointments'});
      T.push({lbl:'ER Active Cases', val:(d.emergencyCases||[]).filter(function(e){return (e.status||'')!=='Discharged';}).length, ic:'fa-truck-medical', tone:'crit', sub:'Need attention', mod:'emergency'});
    } else if(/lab/.test(role)){
      T.push({lbl:'Pending Lab Orders', val:pending(d.labTests,['ordered','pending','collected']), ic:'fa-flask', tone:'warn', sub:'To process', mod:'laboratory'});
      T.push({lbl:'Radiology Orders', val:pending(d.radiologyOrders,['ordered','pending']), ic:'fa-x-ray', tone:'ok', sub:'Queued', mod:'radiology'});
    } else if(/pharm/.test(role)){
      T.push({lbl:'Rx to Dispense', val:pending(d.prescriptions,['pending','active','ready']), ic:'fa-pills', tone:'warn', sub:'In queue', mod:'pharmacy'});
      T.push({lbl:'Low Stock Items', val:(d.pharmacy||[]).filter(function(p){return p.stock<=p.minStock;}).length, ic:'fa-triangle-exclamation', tone:'crit', sub:'Reorder soon', mod:'pharmacy'});
    } else if(/finance|account|billing|cashier/.test(role)){
      T.push({lbl:'Unpaid Bills', val:(d.bills||[]).filter(function(b){return b.balance>0;}).length, ic:'fa-file-invoice-dollar', tone:'warn', sub:'Outstanding AR', mod:'billing'});
      T.push({lbl:'Pending Claims', val:pending(d.claims,['pending','submitted']), ic:'fa-file-shield', tone:'ok', sub:'Insurance', mod:'insurance'});
      T.push({lbl:'Approvals', val:pending(d.assetRequests,['pending manager','pending finance']), ic:'fa-clipboard-check', tone:'warn', sub:'Awaiting you', mod:'billing'});
    } else if(/front desk|receptionist|desk/.test(role)){
      T.push({lbl:'Appointments Today', val:pending(d.appointments,['scheduled','confirmed']), ic:'fa-calendar-check', tone:'ok', sub:'Check-ins', mod:'appointments'});
      T.push({lbl:'Active Patients', val:(d.patients||[]).filter(function(p){return p.status!=='Discharged';}).length, ic:'fa-user-injured', tone:'ok', sub:'On register', mod:'patients'});
      T.push({lbl:'Unpaid Bills', val:(d.bills||[]).filter(function(b){return b.balance>0;}).length, ic:'fa-file-invoice-dollar', tone:'warn', sub:'Collect at desk', mod:'billing'});
    }

    // universal clinical-severity signals (RED reserved for these)
    var critBlood = (d.bloodBank||[]).filter(function(b){return b.status==='Critical';}).length;
    if(critBlood) T.push({lbl:'Critical Blood Stock', val:critBlood, ic:'fa-droplet', tone:'crit', sub:'Below safe level', mod:'bloodbank'});
    var er = (d.emergencyCases||[]).filter(function(e){return (e.status||'')!=='Discharged';}).length;
    if(er && !/nurse/.test(role)) T.push({lbl:'Emergency Cases', val:er, ic:'fa-truck-medical', tone:'crit', sub:'Active in ED', mod:'emergency'});

    if(!T.length){
      T.push({lbl:'Active Patients', val:(d.patients||[]).filter(function(p){return p.status!=='Discharged';}).length, ic:'fa-user-injured', tone:'ok', sub:'On register', mod:'patients'});
      T.push({lbl:'Appointments', val:num(d.appointments), ic:'fa-calendar-check', tone:'ok', sub:'Total', mod:'appointments'});
    }
    return T.slice(0,6);
  }
  function worklistHTML(){
    var u = activeUser(); if(!u) return '';
    var tasks = worklistTasks();
    var greet = (function(){ var h=new Date().getHours(); return h<12?'Good morning':h<17?'Good afternoon':'Good evening'; })();
    var name = esc((u.fullName||u.username||'there').split(' ').slice(0,2).join(' '));
    var html = '<div class="v185-work">'
      + '<div class="v185-work-hd"><i class="fa-solid fa-list-check"></i> '+greet+', '+name+' — here\u2019s what needs your attention</div>'
      + '<div class="v185-work-grid">';
    tasks.forEach(function(t){
      html += '<div class="v185-task '+t.tone+'">'
        + '<div class="v185-task-top"><span class="v185-task-lbl">'+esc(t.lbl)+'</span><span class="v185-task-ic"><i class="fa-solid '+t.ic+'"></i></span></div>'
        + '<div class="v185-task-val">'+t.val+'</div>'
        + '<div class="v185-task-sub">'+esc(t.sub)+'</div>'
        + '<button class="v185-task-go" onclick="try{goTo(\''+t.mod+'\')}catch(e){}">Open <i class="fa-solid fa-arrow-right-long"></i></button>'
        + '</div>';
    });
    html += '</div></div>';
    return html;
  }
  window.__hmsV185.worklistHTML = worklistHTML;

  function wrapDashboard(){
    if (typeof window.renderDashboard==='function' && !window.renderDashboard.__v185){
      var orig = window.renderDashboard;
      window.renderDashboard = function(){
        var out = orig.apply(this, arguments);
        try{ return worklistHTML() + (out||''); }catch(e){ return out; }
      };
      window.renderDashboard.__v185 = true;
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     P6 · DENSITY TOGGLE (into header) + wiring
     ═══════════════════════════════════════════════════════════════════════ */
  function injectDensityToggle(){
    try{
      var right = document.querySelector('.main .hdr .hdr-right'); if(!right) return;
      if(right.querySelector('.v185-density')) return;
      var dense = document.body.classList.contains('v185-dense');
      var wrap = document.createElement('span'); wrap.className='v185-density'; wrap.title='Table density';
      wrap.innerHTML = '<button class="'+(!dense?'on':'')+'" data-d="comfy" aria-label="Comfortable density">Comfy</button>'
                     + '<button class="'+(dense?'on':'')+'" data-d="dense" aria-label="Dense density">Dense</button>';
      Array.prototype.forEach.call(wrap.querySelectorAll('button'), function(b){
        b.onclick = function(){
          var d=this.getAttribute('data-d');
          document.body.classList.remove('v185-dense','v185-comfy');
          document.body.classList.add(d==='dense'?'v185-dense':'v185-comfy');
          try{ localStorage.setItem('v185-density', d); }catch(e){}
          Array.prototype.forEach.call(wrap.querySelectorAll('button'), function(x){ x.classList.toggle('on', x.getAttribute('data-d')===d); });
        };
      });
      /* place after the sync chip */
      var slot = right.querySelector('.v185-sync-slot');
      if(slot && slot.nextSibling) right.insertBefore(wrap, slot.nextSibling); else right.insertBefore(wrap, right.firstChild);
    }catch(e){}
  }

  /* ═══════════════════════════════════════════════════════════════════════
     BOOT + re-apply after every render (header/content get rebuilt)
     ═══════════════════════════════════════════════════════════════════════ */
  function afterRender(){
    paintSyncChip();
    injectDensityToggle();
    wireHeaderSearch();
    renderPatientBanner();
  }
  function boot(){
    wrapSync(); wrapRefresh(); wrapDashboard(); wrapViewPatient();
    afterRender();
  }
  if (typeof window.render==='function' && !window.render.__v185){
    var _r = window.render;
    window.render = function(){ var o=_r.apply(this,arguments); try{ afterRender(); }catch(e){} return o; };
    window.render.__v185 = true;
  }
  [0,120,350,800,1600,3000].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(afterRender);

  try{ console.log('%c✅ v185 — Clinical UX: color discipline · sync chip · patient banner · ⌘K palette · role worklist · density/a11y','background:#0d9488;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/140-d-10.js ==== */
(function(){
  if (window.__twhV186) return; window.__twhV186 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }
  function initials(name){ name=String(name||'').replace(/^(Dr\.?|Nurse|Pharm\.?|Mr\.?|Mrs\.?|Ms\.?)\s+/i,'').trim(); var p=name.split(/\s+/); return ((p[0]||'?').charAt(0)+(p[1]||'').charAt(0)).toUpperCase(); }

  /* module metadata (label, icon, grouping) */
  var META = {
    dashboard:{l:'My Day',i:'fa-table-columns',g:'Overview'},
    appointments:{l:'Consultations',i:'fa-stethoscope',g:'Clinical'},
    consultations:{l:'Consultations',i:'fa-stethoscope',g:'Clinical'},
    emr:{l:'Medical Records',i:'fa-file-medical',g:'Clinical'},
    prescriptions:{l:'Prescriptions',i:'fa-prescription',g:'Clinical'},
    laboratory:{l:'Lab results',i:'fa-flask',g:'Diagnostics'},
    radiology:{l:'Radiology',i:'fa-x-ray',g:'Diagnostics'},
    beds:{l:'Admissions',i:'fa-bed',g:'Wards'},
    patients:{l:'Patients',i:'fa-user-injured',g:'Patients'},
    pharmacy:{l:'Pharmacy',i:'fa-pills',g:'Clinical'},
    emergency:{l:'Emergency',i:'fa-truck-medical',g:'Wards'},
    bloodbank:{l:'Blood Bank',i:'fa-droplet',g:'Wards'},
    referrals:{l:'Referrals',i:'fa-share-nodes',g:'Clinical'},
    or:{l:'OR Scheduling',i:'fa-user-doctor',g:'Wards'},
    immunization:{l:'Immunization',i:'fa-syringe',g:'Clinical'},
    transactions:{l:'Transactions',i:'fa-right-left',g:'Finance'},
    billing:{l:'Billing & Finance',i:'fa-file-invoice-dollar',g:'Finance'},
    insurance:{l:'Insurance & Claims',i:'fa-file-shield',g:'Finance'},
    fixedassets:{l:'Fixed Assets',i:'fa-building',g:'Finance'},
    hr:{l:'HR & Payroll',i:'fa-user-tie',g:'Operations'},
    inventory:{l:'Inventory',i:'fa-boxes-stacked',g:'Operations'},
    procurement:{l:'Procurement',i:'fa-cart-shopping',g:'Operations'},
    reports:{l:'Reports',i:'fa-chart-column',g:'Operations'},
    crm:{l:'Call Center / CRM',i:'fa-headset',g:'Operations'},
    dietary:{l:'Dietary & Nutrition',i:'fa-utensils',g:'Clinical'},
    physiotherapy:{l:'Physiotherapy',i:'fa-person-walking',g:'Clinical'},
    ess:{l:'My Self-Service',i:'fa-id-badge',g:'Personal'},
    audit:{l:'Audit Trail',i:'fa-shield-halved',g:'Admin'},
    compliance:{l:'Compliance',i:'fa-earth-africa',g:'Admin'},
    config:{l:'Configuration',i:'fa-sliders',g:'Admin'},
    sysadmin:{l:'System Admin',i:'fa-user-shield',g:'Admin'},
    users:{l:'User Management',i:'fa-users-gear',g:'Admin'},
    settings:{l:'Settings',i:'fa-gear',g:'Admin'}
  };
  function metaOf(id){
    if(META[id]) return {id:id,l:META[id].l,i:META[id].i,g:META[id].g};
    var d=D(); var reg=d&&d.moduleRegistry?d.moduleRegistry[id]:null;
    var l=reg?(reg.l||reg.label||id):String(id).replace(/([a-z])([A-Z])/g,'$1 $2');
    l=l.charAt(0).toUpperCase()+l.slice(1);
    return {id:id,l:l,i:(reg&&(reg.i||reg.icon))||'fa-circle-dot',g:'More'};
  }
  var GROUP_ORDER = ['Overview','Patients','Clinical','Diagnostics','Wards','Finance','Operations','Personal','Admin','More'];

  /* the user's responsibilities (role grants + per-user overrides + allowlist) */
  function myMods(u){
    var d=D(); if(!d||!u) return ['dashboard'];
    var role=u.role||'Staff'; var set={};
    var rr=d.responsibilities&&d.responsibilities[role];
    if(rr) Object.keys(rr).forEach(function(id){ if(rr[id]) set[id]=true; });
    try{ var ov=d.userOverrides&&u.id!=null&&d.userOverrides[u.id]&&d.userOverrides[u.id].modules;
      if(ov) Object.keys(ov).forEach(function(id){ if(ov[id]) set[id]=true; else delete set[id]; }); }catch(e){}
    if(!Object.keys(set).length && window.__ROLE_ALLOWLIST && window.__ROLE_ALLOWLIST[role])
      window.__ROLE_ALLOWLIST[role].forEach(function(id){ set[id]=true; });
    set['dashboard']=true;                    /* always give the My Day landing */
    return Object.keys(set);
  }

  function badgeFor(id){
    var d=D()||{};
    try{
      if(id==='laboratory') return (d.labTests||[]).filter(function(x){return /ordered|pending|collected/i.test(x.status||'');}).length;
      if(id==='appointments'||id==='consultations') return (d.appointments||[]).filter(function(x){return /scheduled|confirmed/i.test(x.status||'');}).length;
      if(id==='prescriptions'||id==='pharmacy') return (d.prescriptions||[]).filter(function(x){return /pending|active|ready/i.test(x.status||'');}).length;
      if(id==='beds') return (d.patients||[]).filter(function(p){return p.status==='Admitted';}).length;
      if(id==='emergency') return (d.emergencyCases||[]).filter(function(e){return (e.status||'')!=='Discharged';}).length;
      if(id==='billing') return (d.bills||[]).filter(function(b){return b.balance>0;}).length;
    }catch(e){}
    return 0;
  }

  /* ═══ (B) SIDEBAR: responsibilities only ═══ */
  function buildNavHTML(){
    var u=activeUser(); if(!u) return '';
    var mods=myMods(u).map(metaOf);
    // group
    var groups={}; mods.forEach(function(m){ (groups[m.g]=groups[m.g]||[]).push(m); });
    var active=curMod();
    var html='';
    GROUP_ORDER.forEach(function(g){
      var list=groups[g]; if(!list||!list.length) return;
      list.sort(function(a,b){ if(a.id==='dashboard')return -1; if(b.id==='dashboard')return 1; return a.l.localeCompare(b.l); });
      if(g!=='Overview') html+='<div class="v186-navsec">'+esc(g)+'</div>';
      list.forEach(function(m){
        var b=badgeFor(m.id);
        html+='<button type="button" class="v186-nav'+(active===m.id?' active':'')+'" data-mod="'+esc(m.id)+'" onclick="try{goTo(\''+esc(m.id)+'\')}catch(e){}">'
          +'<span class="v186-ic"><i class="fa-solid '+esc(m.i)+'"></i></span>'
          +'<span class="v186-lbl">'+esc(m.l)+'</span>'
          +(b?'<span class="v186-badge">'+b+'</span>':'')
          +'</button>';
      });
    });
    // AI helper card
    html+='<div class="v186-ai" onclick="try{(window.showAIAssistant||window.openAIChat||function(){goTo(\'ai\')})()}catch(e){}">'
      +'<div class="v186-ai-ic"><i class="fa-solid fa-wand-magic-sparkles"></i></div>'
      +'<div class="v186-ai-t">Tranquil AI</div><div class="v186-ai-s">Summarise my '+(/(doctor|nurse|consultant)/i.test(u.role||'')?'ward':'day')+' in one tap</div>'
      +'</div>';
    return html;
  }

  function installBuildNav(){
    window.buildNav=function(){ try{ return buildNavHTML(); }catch(e){ return ''; } };
    window.buildNav.__v186=true; window.buildNav.__v185=true; window.buildNav.__v184=true; window.buildNav.__v183=true; window.buildNav.__v182=true; window.buildNav.__v181=true;
  }
  function sig(){ var u=activeUser(); if(!u) return 'x'; return (u.username||'')+'|'+(u.role||'')+'|'+curMod()+'|'+myMods(u).length; }
  function syncNav(){
    /* Yield to a newer sidebar owner (v188+) — single-writer, no shaking. */
    if (window.__NAV_OWNER && window.__NAV_OWNER!=='v186') return;
    try{
      var sb=document.getElementById('sidebar')||document.querySelector('aside.sb'); if(!sb) return;
      var nav=sb.querySelector('nav'); if(!nav) return;
      if(nav.getAttribute('data-v186')!==sig()){
        var h=buildNavHTML(); if(h){ nav.innerHTML=h; nav.setAttribute('data-v186',sig()); }
      }
    }catch(e){}
  }

  /* ═══ (A) "MY DAY" DASHBOARD ═══ */
  function fmtTime(){ var d=new Date(),h=d.getHours(),m=d.getMinutes(); return ((h%12)||12)+':'+(m<10?'0':'')+m; }
  function greet(){ var h=new Date().getHours(); return h<12?'Good morning':h<17?'Good afternoon':'Good evening'; }
  function pending(arr,rx){ return (arr||[]).filter(function(x){ return rx.test(x.status||''); }).length; }

  function roleKpis(u,d){
    var role=(u.role||'').toLowerCase();
    var admitted=(d.patients||[]).filter(function(p){return p.status==='Admitted';}).length;
    var beds=d.beds||[]; var occ=beds.length?Math.round(beds.filter(function(b){return b.status==='Occupied';}).length/beds.length*100):0;
    var appts=pending(d.appointments,/scheduled|confirmed/i);
    var labsPending=pending(d.labTests,/ordered|pending|collected/i);
    var labsReview=pending(d.labTests,/completed|resulted|review/i);
    var active=(d.patients||[]).filter(function(p){return p.status!=='Discharged';}).length;
    var unpaid=(d.bills||[]).filter(function(b){return b.balance>0;}).length;
    var rx=pending(d.prescriptions,/pending|active|ready/i);
    var nextAppt=(d.appointments||[]).filter(function(a){return /scheduled|confirmed/i.test(a.status||'');})[0];
    var nextT=nextAppt?(nextAppt.time||nextAppt.appointmentTime||'—'):'—';
    /* (v191) every KPI carries the module id it is sourced from, so myDayHTML can
       drop any KPI whose module is NOT in the user's responsibilities. `mod:null`
       marks a general/clock KPI that is always shown. */
    if(/doctor|consultant|physician/.test(role))
      return [{c:'g',i:'fa-user-group',v:appts,l:'Patients today',mod:'appointments'},{c:'y',i:'fa-flask',v:labsReview,l:'Results to review',mod:'laboratory'},{c:'p',i:'fa-clock',v:nextT,l:'Next appointment',mod:'appointments'},{c:'k',i:'fa-bed',v:occ+'%',l:'Ward occupancy',mod:'beds'}];
    if(/nurse/.test(role))
      return [{c:'g',i:'fa-bed',v:admitted,l:'Admitted patients',mod:'beds'},{c:'y',i:'fa-syringe',v:appts,l:'Rounds today',mod:'appointments'},{c:'p',i:'fa-heart-pulse',v:(d.emergencyCases||[]).filter(function(e){return (e.status||'')!=='Discharged';}).length,l:'ER active',mod:'emergency'},{c:'k',i:'fa-bed',v:occ+'%',l:'Ward occupancy',mod:'beds'}];
    if(/pharm/.test(role))
      return [{c:'g',i:'fa-pills',v:rx,l:'Rx to dispense',mod:'pharmacy'},{c:'y',i:'fa-triangle-exclamation',v:(d.pharmacy||[]).filter(function(p){return p.stock<=p.minStock;}).length,l:'Low stock items',mod:'pharmacy'},{c:'p',i:'fa-box',v:(d.pharmacy||[]).length,l:'Formulary items',mod:'pharmacy'},{c:'k',i:'fa-clock',v:fmtTime(),l:'Current time',mod:null}];
    if(/lab/.test(role))
      return [{c:'g',i:'fa-flask',v:labsPending,l:'Pending orders',mod:'laboratory'},{c:'y',i:'fa-vial-circle-check',v:labsReview,l:'Results to verify',mod:'laboratory'},{c:'p',i:'fa-x-ray',v:pending(d.radiologyOrders,/ordered|pending/i),l:'Imaging queue',mod:'radiology'},{c:'k',i:'fa-clock',v:fmtTime(),l:'Current time',mod:null}];
    if(/finance|account|billing|cashier/.test(role))
      return [{c:'g',i:'fa-file-invoice-dollar',v:unpaid,l:'Unpaid bills',mod:'billing'},{c:'y',i:'fa-file-shield',v:pending(d.claims,/pending|submitted/i),l:'Pending claims',mod:'insurance'},{c:'p',i:'fa-clipboard-check',v:pending(d.assetRequests,/pending/i),l:'Approvals',mod:'fixedassets'},{c:'k',i:'fa-users',v:active,l:'Active patients',mod:'patients'}];
    if(/front desk|desk|reception/.test(role))
      return [{c:'g',i:'fa-calendar-check',v:appts,l:'Appointments today',mod:'appointments'},{c:'y',i:'fa-user-injured',v:active,l:'Active patients',mod:'patients'},{c:'p',i:'fa-file-invoice-dollar',v:unpaid,l:'Bills to collect',mod:'receivables'},{c:'k',i:'fa-bed',v:occ+'%',l:'Ward occupancy',mod:'beds'}];
    return [{c:'g',i:'fa-user-group',v:active,l:'Active patients',mod:'patients'},{c:'y',i:'fa-flask',v:labsPending,l:'Pending labs',mod:'laboratory'},{c:'p',i:'fa-calendar-check',v:appts,l:'Appointments',mod:'appointments'},{c:'k',i:'fa-bed',v:occ+'%',l:'Ward occupancy',mod:'beds'}];
  }

  function worklist(u,d){
    var role=(u.role||'').toLowerCase(); var items=[]; var pts=d.patients||[];
    function pick(n){ return pts.slice(0,n); }
    if(/doctor|consultant|nurse|physician/.test(role)){
      var admitted=pts.filter(function(p){return p.status==='Admitted';});
      var src=(admitted.length?admitted:pts).slice(0,3);
      var descs=['Review lab panel','Post-op vitals check','Discharge summary'];
      var chips=[{t:'Critical',c:'crit'},{t:'12:15',c:'time'},{t:'15:00',c:'time'}];
      src.forEach(function(p,i){ items.push({name:p.fullName||('Patient '+p.id),desc:descs[i]||'Follow-up',chip:chips[i]||{t:'—',c:'time'},tone:i===0?'crit':(i===1?'warn':'ok'),mod:'emr',pid:p.id}); });
    } else if(/pharm/.test(role)){
      (d.prescriptions||[]).slice(0,3).forEach(function(rx,i){ items.push({name:rx.patientName||('Rx #'+(rx.id||i+1)),desc:'Dispense & counsel',chip:{t:i===0?'Priority':(fmtTime()),c:i===0?'crit':'time'},tone:i===0?'crit':'ok',mod:'pharmacy'}); });
    } else if(/lab/.test(role)){
      (d.labTests||[]).slice(0,3).forEach(function(t,i){ items.push({name:t.patientName||t.testType||('Order '+(t.id||i+1)),desc:'Process & verify',chip:{t:i===0?'Flagged':'Queue',c:i===0?'crit':'time'},tone:i===0?'crit':'ok',mod:'laboratory'}); });
    } else if(/finance|account|billing|desk|reception/.test(role)){
      (d.bills||[]).filter(function(b){return b.balance>0;}).slice(0,3).forEach(function(b,i){ items.push({name:b.patientName||('Bill '+(b.code||b.id)),desc:'Collect outstanding balance',chip:{t:'Due',c:i===0?'crit':'time'},tone:i===0?'warn':'ok',mod:'billing'}); });
    }
    if(!items.length) pick(3).forEach(function(p,i){ items.push({name:p.fullName||('Patient '+p.id),desc:'Review record',chip:{t:'—',c:'time'},tone:'ok',mod:'patients',pid:p.id}); });
    return items.slice(0,3);
  }

  function scheduleCards(){
    // (v237) Prefer the REAL, role-scoped "Today's schedule" derived from live
    // appointments. Only fall back to the illustrative placeholder when the
    // real accessor is unavailable or there is genuinely nothing booked today.
    try{
      if(typeof window.__twhRealSchedule==='function'){
        var real=window.__twhRealSchedule();
        if(real && real.length) return real;
        // nothing booked today → show a clear empty-state card (not fake data)
        if(real) return [{time:td(),title:'No appointments today',sub:'<i class="fa-solid fa-calendar-check"></i> Book from Appointments',c:'g'}];
      }
    }catch(e){}
    return [
      {time:'12:30 – 13:00',title:'Antenatal clinic',sub:'<i class="fa-solid fa-location-dot"></i> Consulting room 2',c:'p'},
      {time:'13:00 – 14:00',title:'Ward rounds',sub:'<i class="fa-solid fa-user-group"></i> Inpatients',c:'g'},
      {time:'14:30 – 15:00',title:'Lab review huddle',sub:'<i class="fa-solid fa-flask"></i> Flagged results',c:'y'},
      {time:'15:00 – 15:30',title:'Discharge & handover',sub:'<i class="fa-solid fa-box"></i> Meds pack ready',c:'k'}
    ];
  }
  function td(){ try{ return (typeof window.today==='function')?window.today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }

  function patientFlow(d){
    // derive a plausible week from real counts, deterministic per day
    var base=(d.patients||[]).length||20;
    var days=['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
    var mult=[0.72,1,0.82,1.24,0.94,0.58,1.08];
    var vals=mult.map(function(m){ return Math.max(6,Math.round(base*m*0.9)); });
    var max=Math.max.apply(null,vals)||1;
    var alts=['','','alt2','alt','','',''];
    return days.map(function(dy,i){ return {day:dy,val:vals[i],h:Math.round(vals[i]/max*100),alt:alts[i]}; });
  }

  /* ═══ (A2) QUICK ACCESS — tiles for the user's OWN responsibilities ═══
     Uses the SAME source as the sidebar (v188's myModules → getModulesForRole +
     per-user overrides, exact ROLE_MODULES labels). Skips 'dashboard' itself.
     View-only modules show a read-only chip; every tile calls the SAME guarded
     goTo(id) the sidebar uses, so navigation replaces the content area normally
     and the sidebar highlights the item. Never shows a module the user can't
     access (the source list is already the user's allowlist). */
  function quickAccessHTML(u){
    try{
      if(typeof window.__hmsMyModules!=='function') return '';
      var mods=window.__hmsMyModules(u)||[];
      var role=(u&&u.role)||'Staff';
      var superRole=(typeof window.__hmsIsSuperRole==='function') && window.__hmsIsSuperRole(role);
      var metaFn=(typeof window.__hmsNavMeta==='function')?window.__hmsNavMeta:function(){return{i:'fa-circle-dot'};};
      var tiles=mods.filter(function(m){ return m && m.id && m.id!=='dashboard'; });
      if(!tiles.length) return '';
      var html='<div class="v186-qa-t">Quick Access</div><div class="v186-qa">';
      tiles.forEach(function(m){
        var mm=metaFn(m.id)||{}; var icon=mm.i||'fa-circle-dot';
        var ro=(m.access==='view' && !superRole);
        html+='<button type="button" class="v186-qa-tile" data-qa="'+esc(m.id)+'"'
          +' title="'+esc(m.label)+'" onclick="try{goTo(\''+esc(m.id)+'\')}catch(e){}">'
          +'<span class="v186-qa-ic"><i class="fa-solid '+esc(icon)+'"></i></span>'
          +'<span><span class="v186-qa-lbl">'+esc(m.label)+'</span>'
          +(ro?'<br><span class="v186-qa-ro">View</span>':'')+'</span>'
          +'</button>';
      });
      html+='</div>';
      return html;
    }catch(e){ return ''; }
  }
  window.__hmsQuickAccess = quickAccessHTML;

  /* (v191) The set of module ids the current user is actually allowed to touch —
     from the SAME allowlist accessor the sidebar / Quick Access use, then
     confirmed with canRouteTo. Used to strip any dashboard detail (KPI, worklist
     row, blood-bank alert) that isn't part of the user's responsibilities, so the
     dashboard "only has details based on the responsibilities of users". */
  function accessibleModSet(u){
    /* Returns a {id:true} set, or null when the allowlist accessor isn't ready
       yet (fail-open so we never blank the dashboard during early boot). */
    if(typeof window.__hmsMyModules!=='function') return null;
    var set={}, any=false;
    try{
      var mods=window.__hmsMyModules(u)||[];
      mods.forEach(function(m){ var id=(m&&m.id)||m; if(id){ set[id]=true; any=true; } });
    }catch(e){ return null; }
    return any ? set : null;
  }
  function canSee(set,mod){
    if(!mod) return true;                              /* general/clock KPI */
    if(!set) return true;                              /* accessor not ready → fail-open */
    if(set[mod]) return true;
    /* treat billing/receivables and pharmacy/pharmacyplus as interchangeable */
    if(mod==='billing' && (set.receivables||set.transactions)) return true;
    if(mod==='receivables' && (set.billing||set.transactions)) return true;
    if(mod==='pharmacy' && set.pharmacyplus) return true;
    try{ if(typeof window.canRouteTo==='function' && window.canRouteTo(mod)) return true; }catch(e){}
    return false;
  }

  function myDayHTML(){
    var u=activeUser(); if(!u) return '';
    var d=D()||{};
    var name=esc(u.fullName||u.username||'there');
    var short=esc((u.fullName||u.username||'there').split(' ').slice(0,2).join(' '));
    var dateStr=new Date().toLocaleDateString(undefined,{weekday:'long',day:'numeric',month:'long'});
    var accSet=accessibleModSet(u);
    var kpis=roleKpis(u,d).filter(function(k){ return canSee(accSet,k.mod); });
    var wl=worklist(u,d).filter(function(w){ return canSee(accSet,w.mod); });
    var sched=scheduleCards(), flow=patientFlow(d);
    var critBlood=(d.bloodBank||[]).filter(function(b){return b.status==='Critical';});
    var showBlood=canSee(accSet,'bloodbank');          /* only if user handles blood bank */
    var isWard=/doctor|nurse|consultant/i.test(u.role||'');

    var html='<div class="v186-day">';
    // hero
    html+='<div class="v186-hero"><div class="v186-hero-txt">'
      +'<div class="v186-hero-hi">'+greet()+', '+short+' <i class="fa-solid fa-sun" style="color:#ffd66b;font-size:16px"></i></div>'
      +'<div class="v186-hero-sub">'+esc(dateStr)+' · '+esc(u.role||'Staff')+'</div></div>'
      +'<div class="v186-hero-r"><span class="v186-savechip" id="v186SaveChip"><span class="v186-dot"></span>Saved '+fmtTime()+'</span>'
      +'<span class="v186-hero-av">'+esc(initials(u.fullName||u.username))+'</span></div></div>';
    // kpis
    html+='<div class="v186-kpis">'+kpis.map(function(k){
      return '<div class="v186-kpi '+k.c+'"><div class="v186-kpi-ic"><i class="fa-solid '+k.i+'"></i></div><div class="v186-kpi-val">'+esc(k.v)+'</div><div class="v186-kpi-lbl">'+esc(k.l)+'</div></div>';
    }).join('')+'</div>';
    // Quick Access — one tile per module in the user's own responsibilities
    // (same source as the sidebar), each opening the correct module via goTo.
    html+=quickAccessHTML(u);
    // critical blood alert (red reserved for clinical severity) — only for users
    // whose responsibilities include the Blood Bank (v191 responsibility-scoped).
    if(critBlood.length && showBlood){
      var units=critBlood.reduce(function(s,b){return s+(b.units||b.stock||1);},0);
      var grp=critBlood[0].bloodGroup||critBlood[0].group||'O-';
      html+='<div class="v186-alert"><i class="fa-solid fa-droplet lead"></i><div><b>Blood bank: '+esc(grp)+' stock critical</b> ('+units+' unit'+(units===1?'':'s')+')</div><div class="sp"></div><button onclick="try{goTo(\'bloodbank\')}catch(e){}">Review</button></div>';
    }
    // two columns
    html+='<div class="v186-cols">';
    // left: worklist + flow
    html+='<div><div class="v186-panel-t">Worklist</div><div class="v186-wl">';
    if(!wl.length){
      html+='<div class="v186-wl-item ok" style="cursor:default"><div class="v186-wl-av"><i class="fa-solid fa-check"></i></div>'
        +'<div><div class="v186-wl-name">You\u2019re all caught up</div><div class="v186-wl-desc">No outstanding tasks in your areas right now.</div></div></div>';
    }
    wl.forEach(function(w){
      var click=w.pid!=null?('try{if(window.viewPatient)viewPatient('+w.pid+');else goTo(\''+w.mod+'\')}catch(e){}'):('try{goTo(\''+w.mod+'\')}catch(e){}');
      html+='<div class="v186-wl-item '+w.tone+'" onclick="'+click+'">'
        +'<div class="v186-wl-av">'+esc(initials(w.name))+'</div>'
        +'<div><div class="v186-wl-name">'+esc(w.name)+'</div><div class="v186-wl-desc">'+esc(w.desc)+'</div></div>'
        +'<span class="v186-wl-chip '+(w.chip.c)+'">'+esc(w.chip.t)+'</span></div>';
    });
    html+='</div>';
    // patient flow chart
    html+='<div class="v186-flow"><div class="v186-panel-t" style="margin:0 0 2px">Patient flow this week</div><div class="v186-bars">';
    flow.forEach(function(f){
      html+='<div class="v186-bar-col"><div class="v186-bar-num">'+f.val+'</div><div class="v186-bar '+f.alt+'" style="height:'+f.h+'%"></div><div class="v186-bar-day">'+f.day+'</div></div>';
    });
    html+='</div></div></div>';
    // right: schedule
    html+='<div><div class="v186-panel-t">Today\u2019s schedule</div><div class="v186-sched">';
    sched.forEach(function(s){
      html+='<div class="v186-sc '+s.c+'"><div class="v186-sc-time">'+esc(s.time)+'</div><div class="v186-sc-title">'+esc(s.title)+'</div><div class="v186-sc-sub">'+s.sub+'</div></div>';
    });
    html+='</div></div>';
    html+='</div>';   // cols
    html+='</div>';   // day
    return html;
  }
  window.__hmsMyDay = myDayHTML;

  /* Replace the dashboard entirely with My Day (wins over v184/v185 wraps) */
  function installDashboard(){
    if (typeof window.renderDashboard==='function' && !window.renderDashboard.__v186){
      window.renderDashboard = function(){ try{ return myDayHTML(); }catch(e){ return '<div style="padding:30px">Welcome.</div>'; } };
      window.renderDashboard.__v186=true; window.renderDashboard.__v185=true; window.renderDashboard.__v184=true;
    }
    if (typeof window.renderModule==='function' && !window.renderModule.__v186){
      var orig=window.renderModule;
      window.renderModule=function(){
        if(curMod()==='dashboard'){ try{ return myDayHTML(); }catch(e){} }
        return orig.apply(this,arguments);
      };
      window.renderModule.__v186=true; window.renderModule.__v185=true; window.renderModule.__v184=true;
    }
  }

  /* keep the "My Day" hero sync chip LIVE — reflect the authoritative sync
     state (HMS_DB.onState) so it mirrors the real network result, not a static
     boot-time timestamp. Idempotent single subscription. */
  function _fmtChipTime(ts){ try{ var d=ts?new Date(ts):new Date(),h=d.getHours(),m=d.getMinutes(); return ((h%12)||12)+':'+(m<10?'0':'')+m; }catch(e){ return ''; } }
  function paintHeroChip(state, lastSaved){
    try{
      var c=document.getElementById('v186SaveChip'); if(!c) return;
      c.classList.remove('syncing');
      if(state==='syncing'){ c.classList.add('syncing'); c.lastChild && (c.childNodes[c.childNodes.length-1].nodeValue='Saving\u2026'); }
      else if(state==='error'){ c.childNodes[c.childNodes.length-1].nodeValue='Sync error'; }
      else { c.childNodes[c.childNodes.length-1].nodeValue='Saved '+_fmtChipTime(lastSaved); }
    }catch(e){}
  }
  function refreshSaveChip(){
    try{
      if(window.HMS_DB){ paintHeroChip(window.HMS_DB.syncState||'idle', window.HMS_DB.lastSaved); }
    }catch(e){}
  }
  function bindHeroChip(){
    try{
      if(window.__v186ChipBound) return;
      if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
        window.__v186ChipBound=true;
        window.HMS_DB.onState(function(state, err, lastSaved){ paintHeroChip(state, lastSaved); });
        refreshSaveChip();
      }
    }catch(e){}
  }

  /* ═══ BOOT & re-apply ═══ */
  function afterRender(){ syncNav(); refreshSaveChip(); }
  function boot(){ installBuildNav(); installDashboard(); syncNav(); bindHeroChip(); }
  if (typeof window.render==='function' && !window.render.__v186){
    var _r=window.render; window.render=function(){ var o=_r.apply(this,arguments); try{ afterRender(); }catch(e){} return o; };
    window.render.__v186=true;
  }
  if (typeof window.goTo==='function' && !window.goTo.__v186){
    var _g=window.goTo; window.goTo=function(){ var o=_g.apply(this,arguments); try{ syncNav(); }catch(e){} return o; };
    window.goTo.__v186=true;
  }
  [0,100,300,700,1400,2600].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(syncNav);

  /* ═══════════════════════════════════════════════════════════════════════
     (C) DETAILED REGISTER HOUSEHOLD — self-contained, lives in Patients
     ═══════════════════════════════════════════════════════════════════════ */
  function newId(){ try{ return (typeof window.nid==='function')?window.nid():(typeof window._nid==='function'?window._nid():Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function toastMsg(m){ try{ if(typeof window.toast==='function') return toast(m); }catch(e){} }

  window.V186_registerHousehold = function(id){
    var d=D()||{}; d.households=d.households||[];
    var h = id!=null ? (d.households||[]).find(function(x){return x.id===id;}) : null;
    var x = h || { id:null, code:'HH-'+String(((d.households||[]).length||0)+1).padStart(4,'0'), name:'', headPatientId:null,
      phone:'', altPhone:'', email:'', address:'', city:'', state:'', lga:'', headOccupation:'', headRelation:'Head',
      insurance:'Self-Pay', hmoName:'', hmoNumber:'', sharedLedger:true, billingCap:'', emergencyName:'', emergencyPhone:'',
      notes:'', active:true, memberCount:0 };
    var pO='<option value="">— none / add later —</option>'+(d.patients||[]).map(function(p){ return '<option value="'+p.id+'"'+(x.headPatientId===p.id?' selected':'')+'>'+esc(p.fullName)+' ('+esc(p.mrn||'')+')</option>'; }).join('');
    var states=['','Abia','Abuja (FCT)','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa','Benue','Borno','Cross River','Delta','Ebonyi','Edo','Ekiti','Enugu','Gombe','Imo','Jigawa','Kaduna','Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa','Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers','Sokoto','Taraba','Yobe','Zamfara'];
    var hmos=['','Hygeia HMO','AXA Mansard','Avon HMO','Reliance HMO','Leadway Health','NHIA','Total Health Trust','Clearline HMO','Other'];
    function sel(id2,val,opts){ return '<select id="'+id2+'">'+opts.map(function(o){ return '<option'+(String(val)===String(o)?' selected':'')+'>'+esc(o)+'</option>'; }).join('')+'</select>'; }

    var body='<div style="font-size:12px;color:var(--txt2);margin:-4px 0 14px;line-height:1.5">Create a family/household folder. Members share one primary folder and (optionally) a consolidated bill. You can add members after saving, or register a brand-new patient directly into this household.</div>'
      + '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;color:#be185d;text-transform:uppercase;margin:2px 0 8px">Household identity</div>'
      + '<div class="form-grid">'
      +   '<div class="form-group"><label>Household Code</label><input id="hh_code" value="'+esc(x.code)+'"></div>'
      +   '<div class="form-group"><label>Household / Family Name <span class="req">*</span></label><input id="hh_name" value="'+esc(x.name)+'" placeholder="e.g. The Okafor Family"></div>'
      +   '<div class="form-group full"><label>Head of Household (primary card holder)</label><select id="hh_head">'+pO+'</select></div>'
      +   '<div class="form-group"><label>Head Occupation</label><input id="hh_occ" value="'+esc(x.headOccupation||'')+'" placeholder="e.g. Teacher"></div>'
      +   '<div class="form-group"><label>Head Relationship</label>'+sel('hh_rel',x.headRelation||'Head',['Head','Father','Mother','Guardian','Grandparent','Other'])+'</div>'
      + '</div>'
      + '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;color:#be185d;text-transform:uppercase;margin:14px 0 8px">Contact & address</div>'
      + '<div class="form-grid">'
      +   '<div class="form-group"><label>Primary Phone</label><input id="hh_phone" value="'+esc(x.phone||'')+'" placeholder="+234…"></div>'
      +   '<div class="form-group"><label>Alternate Phone</label><input id="hh_alt" value="'+esc(x.altPhone||'')+'"></div>'
      +   '<div class="form-group"><label>Email</label><input id="hh_email" type="email" value="'+esc(x.email||'')+'"></div>'
      +   '<div class="form-group"><label>City / Town</label><input id="hh_city" value="'+esc(x.city||'')+'"></div>'
      +   '<div class="form-group"><label>LGA</label><input id="hh_lga" value="'+esc(x.lga||'')+'"></div>'
      +   '<div class="form-group"><label>State</label>'+sel('hh_state',x.state||'',states)+'</div>'
      +   '<div class="form-group full"><label>Residential Address</label><textarea id="hh_address" rows="2">'+esc(x.address||'')+'</textarea></div>'
      + '</div>'
      + '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;color:#be185d;text-transform:uppercase;margin:14px 0 8px">Billing & coverage</div>'
      + '<div class="form-grid">'
      +   '<div class="form-group"><label>Payment Type</label>'+sel('hh_ins',x.insurance||'Self-Pay',['Self-Pay','HMO / Insurance','Corporate','NHIA'])+'</div>'
      +   '<div class="form-group"><label>HMO / Insurer</label>'+sel('hh_hmo',x.hmoName||'',hmos)+'</div>'
      +   '<div class="form-group"><label>HMO / Policy Number</label><input id="hh_hmono" value="'+esc(x.hmoNumber||'')+'"></div>'
      +   '<div class="form-group"><label>Shared Ledger?</label><select id="hh_shared"><option value="true"'+(x.sharedLedger?' selected':'')+'>Yes — one consolidated bill</option><option value="false"'+(!x.sharedLedger?' selected':'')+'>No — bill each member separately</option></select></div>'
      +   '<div class="form-group"><label>Monthly Spending Cap (₦, optional)</label><input id="hh_cap" type="number" value="'+esc(x.billingCap||'')+'" placeholder="Leave blank for none"></div>'
      + '</div>'
      + '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;color:#be185d;text-transform:uppercase;margin:14px 0 8px">Emergency contact & notes</div>'
      + '<div class="form-grid">'
      +   '<div class="form-group"><label>Emergency Contact Name</label><input id="hh_ecn" value="'+esc(x.emergencyName||'')+'"></div>'
      +   '<div class="form-group"><label>Emergency Contact Phone</label><input id="hh_ecp" value="'+esc(x.emergencyPhone||'')+'"></div>'
      +   '<div class="form-group"><label>Status</label><select id="hh_active"><option value="true"'+(x.active?' selected':'')+'>Active</option><option value="false"'+(!x.active?' selected':'')+'>Inactive</option></select></div>'
      +   '<div class="form-group full"><label>Notes</label><textarea id="hh_notes" rows="2" placeholder="Any special instructions for this household">'+esc(x.notes||'')+'</textarea></div>'
      + '</div>';

    var footer='<button class="btn btn-pri" onclick="V186_saveHousehold('+(h?h.id:'null')+')"><i class="fa-solid fa-save"></i> Save Household</button>'
      + (h?'<button class="btn btn-sm" style="background:#be185d;color:#fff" onclick="V186_saveHousehold('+h.id+',true)"><i class="fa-solid fa-user-plus"></i> Save & Add Member</button>':'')
      + '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';

    if(typeof window.showModal==='function')
      window.showModal('<i class="fa-solid fa-people-roof" style="color:#be185d;margin-right:8px"></i>'+(h?'Edit':'Register')+' Household', body, footer, 'wide');
  };

  window.V186_saveHousehold = function(id, addMember){
    var d=D()||{}; d.households=d.households||[];
    function val(i){ var el=document.getElementById(i); return el?el.value:''; }
    var name=(val('hh_name')||'').trim();
    if(!name){ toastMsg('Household name is required'); return; }
    var data={
      code:val('hh_code'), name:name,
      headPatientId: val('hh_head')?parseInt(val('hh_head')):null,
      headOccupation:val('hh_occ'), headRelation:val('hh_rel'),
      phone:val('hh_phone'), altPhone:val('hh_alt'), email:val('hh_email'),
      city:val('hh_city'), lga:val('hh_lga'), state:val('hh_state'), address:val('hh_address'),
      insurance:val('hh_ins'), hmoName:val('hh_hmo'), hmoNumber:val('hh_hmono'),
      sharedLedger:val('hh_shared')==='true', billingCap:val('hh_cap'),
      emergencyName:val('hh_ecn'), emergencyPhone:val('hh_ecp'),
      notes:val('hh_notes'), active:val('hh_active')==='true'
    };
    var savedId=id;
    if(id!=null){
      var ex=d.households.find(function(h){return h.id===id;}); if(ex) Object.assign(ex,data);
      toastMsg('Household updated');
    } else {
      data.id=newId(); savedId=data.id; d.households.push(data);
      toastMsg('Household registered');
    }
    if(data.headPatientId){ var head=(d.patients||[]).find(function(p){return p.id===data.headPatientId;}); if(head) head.householdId=savedId; }
    try{ if(window._hmsSave) window._hmsSave(); else if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){}
    try{ closeModal(); }catch(e){}
    // refresh whichever view is open
    try{
      var cc=document.getElementById('configContent');
      if(cc && typeof window.renderConfigHouseholds==='function') cc.innerHTML=window.renderConfigHouseholds();
      else if(typeof window.render==='function') window.render();
    }catch(e){}
    if(addMember){
      setTimeout(function(){ try{ if(typeof window.V25_showHouseholdMembers==='function') window.V25_showHouseholdMembers(savedId); }catch(e){} }, 120);
    }
  };

  /* Point the Patients-module "Register Household" button at the detailed form.
     The button currently calls V25_addHousehold — alias it to our richer form so
     the entry point in the Patients sub-module opens the detailed dialog. */
  function rewireHouseholdEntry(){
    try{
      // alias legacy entry points to the detailed form
      window.V25_addHousehold = function(){ window.V186_registerHousehold(null); };
      if(typeof window.V25_editHousehold==='function' || true){
        window.V25_editHousehold = function(hid){ window.V186_registerHousehold(hid); };
      }
    }catch(e){}
  }
  rewireHouseholdEntry();
  [200,900,2000].forEach(function(t){ setTimeout(rewireHouseholdEntry, t); });

  try{ console.log('%c✅ v186 — My Day role dashboard + responsibilities-only sidebar + detailed Register Household (in Patients)','background:#0b664b;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/142-d-11.js ==== */
(function(){
  if (window.__twhV187) return; window.__twhV187 = true;

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  /* ── role / user resolution (mirror the rest of the stack) ── */
  function curUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }
  function curRole(){ var u=curUser(); return (u && u.role) ? u.role : 'Staff'; }

  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator','super system admin','ceo'];
  function isSuperRole(role){ return !!role && SUPER_ROLES.indexOf(String(role).trim().toLowerCase())>=0; }

  /* ── the single source of truth: the strict allowlist from v175 ──
     Fall back to responsibilities / a minimal safe set if the allowlist
     is not present (defensive; in practice v175 always defines it). */
  function allowSetFor(role){
    var ALLOW = window.__ROLE_ALLOWLIST || {};
    var list = ALLOW[role] || ALLOW[String(role||'').trim()];
    if (list){ var s={}; list.forEach(function(id){ s[id]=true; }); return s; }
    return null;
  }

  /* Modules that are ALWAYS reachable regardless of role (routing plumbing).
     These never trigger a 403 — they are either the safe landing or transient
     framework routes. Sub-pages a module legitimately drills into stay allowed
     because the guard only checks top-level module ids. */
  var ALWAYS = { dashboard:true, selfservice:true };
  /* transient / framework routes that are not role-gated modules */
  var UNGATED = { '':true, 'login':true, 'logout':true, 'profile':true, 'search':true, 'ai':true, '403':true };

  /* THE routing authority: may this user open this module id? */
  function canRoute(mod){
    if (!mod) return true;
    if (UNGATED[mod]) return true;
    var u = curUser();
    if (!u) return true;                         /* login screen / pre-auth: let framework handle */
    var role = curRole();
    if (isSuperRole(role)) return true;          /* admin/superadmin → everything */
    if (ALWAYS[mod]) return true;
    /* per-user override (sysadmin explicit grant/deny) wins */
    try{
      var d=D(); var ov = d && d.userOverrides && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov && (mod in ov)) return !!ov[mod];
    }catch(e){}
    var set = allowSetFor(role);
    if (set) return !!set[mod];
    /* unmapped role: fall back to hasModuleAccess if present, else responsibilities */
    try{ if (typeof window.hasModuleAccess==='function' && window.hasModuleAccess.__v175) return window.hasModuleAccess(mod); }catch(e){}
    try{ var rr=D()&&D().responsibilities&&D().responsibilities[role]; if(rr) return !!rr[mod]; }catch(e){}
    return mod==='dashboard' || mod==='selfservice';
  }
  window.canRouteTo = canRoute;   /* expose for tests / other packs */

  /* access mode ('full' | 'view') for the current role + module */
  function accessMode(mod){
    var role = curRole();
    if (isSuperRole(role)) return 'full';
    try{
      if (typeof window.moduleAccessMode==='function') return window.moduleAccessMode(role, mod) || 'full';
    }catch(e){}
    /* fall back to __ROLE_MODULES metadata */
    try{
      var list = (window.__ROLE_MODULES||{})[role] || [];
      for (var i=0;i<list.length;i++){ if (list[i].id===mod) return list[i].access || 'full'; }
    }catch(e){}
    return 'full';
  }

  /* set / clear the read-only route flag + body class */
  function applyViewFlag(mod){
    try{
      var vo = !isSuperRole(curRole()) && accessMode(mod)==='view';
      window.__viewOnlyMode = !!vo;
      if (document.body){
        if (vo) document.body.classList.add('route-viewonly');
        else document.body.classList.remove('route-viewonly');
      }
    }catch(e){ window.__viewOnlyMode=false; }
  }

  /* audit a blocked navigation attempt (best-effort; never throws) */
  function auditBlock(mod){
    try{
      if (typeof window.auditAction==='function')
        window.auditAction('SECURITY','Navigation','DENY','Blocked access to "'+mod+'" for role '+curRole(),'Medium');
      else if (typeof window.AUD==='function')
        window.AUD('SECURITY','Navigation','DENY','Blocked "'+mod+'" for '+curRole(),'Medium');
    }catch(e){}
  }

  /* human label for a module id under the current role (for the 403 copy) */
  function labelOf(mod){
    try{
      var role=curRole(), list=(window.__ROLE_MODULES||{})[role]||[];
      for (var i=0;i<list.length;i++){ if(list[i].id===mod) return list[i].label; }
      var d=D(), reg=d&&d.moduleRegistry&&d.moduleRegistry[mod];
      if (reg && (reg.label||reg.l)) return reg.label||reg.l;
    }catch(e){}
    return mod;
  }

  /* ── 403 PAGE ── */
  window.__v187Denied = null;   /* {mod} while a 403 is showing */
  function render403HTML(mod){
    var role = esc(curRole());
    return '<div class="v187-403">'
      + '<div class="v187-403-badge"><i class="fa-solid fa-lock"></i></div>'
      + '<h2>Access restricted</h2>'
      + '<p>Your role (<span class="mod">'+role+'</span>) is not assigned the '
      + '<span class="mod">'+esc(labelOf(mod))+'</span> module, so it isn\u2019t available on your workspace.</p>'
      + '<p>If you believe you need it, ask a System Administrator to grant it under Configuration \u203a Users &amp; Roles.</p>'
      + '<div class="v187-403-actions">'
      +   '<button class="v187-403-btn" onclick="try{goTo(\'dashboard\')}catch(e){}"><i class="fa-solid fa-table-columns"></i> Go to My Day</button>'
      +   '<button class="v187-403-btn ghost" onclick="try{goTo(\'selfservice\')}catch(e){}"><i class="fa-solid fa-id-badge"></i> My Self-Service</button>'
      + '</div>'
      + '<div class="v187-403-hint">Error 403 \u2014 role-based access control</div>'
      + '</div>';
  }

  /* Inject the 403 into the content region (works with the app's DOM). */
  function paint403(mod){
    var host = document.getElementById('moduleContent')
            || document.querySelector('.content')
            || document.getElementById('app');
    if (host) host.innerHTML = render403HTML(mod);
  }

  /* ── GUARD: wrap goTo so unauthorized modules are intercepted ──
     Strategy: if canRoute(mod) is false, do NOT let currentMod become that
     module. Record the denial, set currentMod to 'dashboard' (safe landing),
     run the normal goTo for dashboard so the sidebar/active-state stay correct,
     then paint the 403 into the content area. Authorized modules pass straight
     through to the underlying goTo. */
  function installGoToGuard(){
    if (typeof window.goTo !== 'function') return;
    if (window.goTo.__v187) return;
    var inner = window.goTo;
    var guarded = function(mod){
      try{
        if (mod && !canRoute(mod)){
          window.__v187Denied = { mod: mod };
          auditBlock(mod);
          /* (v191) Land on a safe module purely through the CANONICAL goTo — it
             sets the unified route (var currentMod === window.currentMod), renders
             the dashboard and syncs the sidebar .active. We do NOT write
             window.currentMod directly here: with the route unified, the inner
             goTo below is the single source of truth, so a denied click leaves
             zero lasting split-brain state and the NEXT allowed click renders
             its module normally. */
          var r = inner.call(this, 'dashboard');     /* renders dashboard + syncs nav */
          try{ applyViewFlag('dashboard'); }catch(e){}
          /* overwrite the content with the 403 (after the dashboard paint) */
          paint403(mod);
          try{ if (typeof window.toast==='function') window.toast('Access restricted: '+labelOf(mod),'err'); }catch(e){}
          return r;
        }
      }catch(e){}
      window.__v187Denied = null;
      var out = inner.apply(this, arguments);
      try{ applyViewFlag(window.currentMod); }catch(e){}
      return out;
    };
    guarded.__v187 = true;
    /* preserve flags other packs look for so we remain compatible with the chain */
    try{ guarded.__v186 = inner.__v186; }catch(e){}
    window.goTo = guarded;
  }

  /* Also guard the render path: if the CURRENT module is unauthorized (e.g. a
     stale currentMod restored from a persisted session or set by another pack),
     paint the 403 after render instead of the module body. */
  function installRenderGuard(){
    if (typeof window.render !== 'function') return;
    if (window.render.__v187) return;
    var inner = window.render;
    var guarded = function(){
      var out = inner.apply(this, arguments);
      try{
        var mod = window.currentMod;
        if (mod && !canRoute(mod)){
          window.__v187Denied = { mod: mod };
          paint403(mod);
        } else {
          window.__v187Denied = null;
          applyViewFlag(mod);
        }
      }catch(e){}
      return out;
    };
    guarded.__v187 = true;
    window.render = guarded;
  }

  /* ── getModulesForRole hardening: guarantee {id,label,access} shape ──
     v174 already defines it; we wrap it to normalise output for consumers
     that rely on the documented contract. Idempotent. */
  function hardenAccessor(){
    if (typeof window.getModulesForRole !== 'function') return;
    if (window.getModulesForRole.__v187) return;
    var inner = window.getModulesForRole;
    var wrapped = function(role){
      var list = inner.apply(this, arguments) || [];
      return list.map(function(m){
        if (typeof m === 'string') return { id:m, label:m, access:'full' };
        return { id:m.id, label:m.label!=null?m.label:m.id, access:m.access||'full' };
      });
    };
    wrapped.__v187 = true;
    window.getModulesForRole = wrapped;
  }

  /* ── BOOT / RE-ASSERT ── (packs re-wrap goTo/render on staggered timers;
     re-install so our guard stays outermost.) */
  function boot(){
    installGoToGuard();
    installRenderGuard();
    hardenAccessor();
    try{ applyViewFlag(window.currentMod); }catch(e){}
  }
  [0,120,350,800,1600,3000].forEach(function(t){ setTimeout(boot, t); });
  DOMBus.register(boot);

  try{ console.log('%c\u2705 v187 \u2014 route guard (403 on unauthorized) + view-only route flag + role-map hardening','background:#991b1b;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/144-block-6.js ==== */
(function(){
  if (window.__twhV188) return; window.__twhV188 = true;
  /* Claim single ownership of the sidebar nav so older builders (v182/v186)
     stand down — this is what kills the "shaking" (duelling innerHTML writers)
     and guarantees the v188 exact-label output is the one that sticks. */
  window.__NAV_OWNER = 'v188';

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function curMod(){ try{ return (typeof window.currentMod!=='undefined')?window.currentMod:'dashboard'; }catch(e){ return 'dashboard'; } }
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D(); return (d && d.currentUser) ? d.currentUser : null;
  }
  function curRole(){ var u=activeUser(); return (u && u.role) ? u.role : 'Staff'; }
  var SUPER_ROLES = ['system administrator','admin','superadmin','super admin','administrator','super system admin','ceo'];
  function isSuperRole(role){ return !!role && SUPER_ROLES.indexOf(String(role).trim().toLowerCase())>=0; }

  /* ── icon + group for EVERY module id that can appear in the sidebar ──
     (labels come from ROLE_MODULES; this only supplies visual metadata) */
  var ICON = {
    dashboard:{i:'fa-table-columns',g:'Overview'},
    patients:{i:'fa-user-injured',g:'Patients'},
    appointments:{i:'fa-calendar-check',g:'Clinical'},
    emr:{i:'fa-file-medical',g:'Clinical'},
    prescriptions:{i:'fa-prescription',g:'Clinical'},
    referrals:{i:'fa-share-nodes',g:'Clinical'},
    physio:{i:'fa-person-walking',g:'Clinical'},
    laboratory:{i:'fa-flask',g:'Diagnostics'},
    radiology:{i:'fa-x-ray',g:'Diagnostics'},
    reflexrules:{i:'fa-diagram-project',g:'Diagnostics'},
    pharmacy:{i:'fa-pills',g:'Pharmacy'},
    pharmacyplus:{i:'fa-mortar-pestle',g:'Pharmacy'},
    wellness:{i:'fa-heart-pulse',g:'Wellness'},
    mealplanner:{i:'fa-bowl-food',g:'Wellness'},
    nutrition:{i:'fa-calculator',g:'Wellness'},
    dietary:{i:'fa-utensils',g:'Wellness'},
    bizdev:{i:'fa-briefcase',g:'Growth'},
    crm:{i:'fa-headset',g:'Growth'},
    transactions:{i:'fa-right-left',g:'Finance'},
    accounting:{i:'fa-calculator',g:'Finance'},
    finctl:{i:'fa-scale-balanced',g:'Finance'},
    denialwf:{i:'fa-file-circle-xmark',g:'Finance'},
    treasury:{i:'fa-vault',g:'Finance'},
    capitation:{i:'fa-handshake',g:'Finance'},
    fixedassets:{i:'fa-building',g:'Finance'},
    assetcap:{i:'fa-chart-line-down',g:'Finance'},
    budgetanalytics:{i:'fa-chart-pie',g:'Finance'},
    receivables:{i:'fa-file-invoice-dollar',g:'Finance'},
    payables:{i:'fa-money-check',g:'Finance'},
    apar:{i:'fa-scale-unbalanced',g:'Finance'},
    payrollplus:{i:'fa-money-bill-transfer',g:'Operations'},
    hr:{i:'fa-user-tie',g:'Operations'},
    inventory:{i:'fa-boxes-stacked',g:'Operations'},
    procurement:{i:'fa-cart-shopping',g:'Operations'},
    prodcenter:{i:'fa-network-wired',g:'Operations'},
    reports:{i:'fa-chart-column',g:'Reports'},
    livereports:{i:'fa-bolt',g:'Reports'},
    customrpt:{i:'fa-sliders',g:'Reports'},
    selfservice:{i:'fa-id-badge',g:'Personal'},
    /* super-role extras (registry-driven) */
    beds:{i:'fa-bed',g:'Wards'}, emergency:{i:'fa-truck-medical',g:'Wards'},
    bloodbank:{i:'fa-droplet',g:'Wards'}, or:{i:'fa-user-doctor',g:'Wards'},
    immunization:{i:'fa-syringe',g:'Clinical'}, insurance:{i:'fa-file-shield',g:'Finance'},
    billing:{i:'fa-file-invoice-dollar',g:'Finance'}, audit:{i:'fa-shield-halved',g:'Admin'},
    compliance:{i:'fa-earth-africa',g:'Admin'}, config:{i:'fa-sliders',g:'Admin'},
    sysadmin:{i:'fa-user-shield',g:'Admin'}, users:{i:'fa-users-gear',g:'Admin'},
    settings:{i:'fa-gear',g:'Admin'}, staffclaims:{i:'fa-hand-holding-dollar',g:'Operations'}
  };
  var GROUP_ORDER = ['Overview','Patients','Clinical','Diagnostics','Pharmacy','Wellness','Growth','Wards','Finance','Operations','Reports','Personal','Admin','More'];

  /* Which module ids actually have a dispatch site (are routable)?
     We derive this defensively: dashboard/selfservice always route; otherwise
     we trust getModulesForRole/ROLE_MODULES (curated) + moduleRegistry. Any id
     the guard can route to is fine; we drop truly-unknown ids so no dead links. */
  function routable(id){
    if (id==='dashboard' || id==='selfservice') return true;
    if (ICON[id]) return true;                          /* known, dispatched module */
    try{ var d=D(); if(d && d.moduleRegistry && d.moduleRegistry[id]) return true; }catch(e){}
    return false;
  }

  /* the user's responsibilities, as ordered {id,label,access} — EXACT labels */
  function myModules(u){
    var role = (u && u.role) || 'Staff';
    var list = [];
    try{
      if (typeof window.getModulesForRole==='function'){
        list = window.getModulesForRole(role) || [];
      }
    }catch(e){ list = []; }
    /* fall back to ROLE_MODULES directly, then to a minimal safe set */
    if ((!list || !list.length) && window.__ROLE_MODULES){
      list = (window.__ROLE_MODULES[role] || []).slice();
    }
    if (!list || !list.length){
      list = [{id:'dashboard',label:'Dashboard',access:'full'},
              {id:'selfservice',label:'My Self-Service (ESS)',access:'full'}];
    }
    /* honour per-user overrides (add grants, remove denies) on top of the role set */
    try{
      var d=D();
      var ov = d && d.userOverrides && u && u.id!=null && d.userOverrides[u.id] && d.userOverrides[u.id].modules;
      if (ov){
        var have={}; list.forEach(function(m){ have[m.id]=true; });
        Object.keys(ov).forEach(function(id){
          if (ov[id] && !have[id]){
            var lbl = labelFor(role,id);
            list.push({id:id,label:lbl,access:'full'});
          } else if (!ov[id]){
            list = list.filter(function(m){ return m.id!==id; });
          }
        });
      }
    }catch(e){}
    /* always guarantee a My Day landing */
    if (!list.some(function(m){return m.id==='dashboard';}))
      list.unshift({id:'dashboard',label:'Dashboard',access:'full'});
    /* drop non-routable ids so there are NO dead links */
    list = list.filter(function(m){ return routable(m.id); });
    return list;
  }

  /* exact label lookup (role-aware) */
  function labelFor(role,id){
    try{
      var rm = (window.__ROLE_MODULES||{})[role] || [];
      for (var i=0;i<rm.length;i++){ if(rm[i].id===id) return rm[i].label; }
    }catch(e){}
    try{ var d=D(), reg=d&&d.moduleRegistry&&d.moduleRegistry[id]; if(reg&&(reg.label||reg.l)) return reg.label||reg.l; }catch(e){}
    return id;
  }

  function meta(id){ return ICON[id] || {i:'fa-circle-dot', g:'More'}; }

  function badgeFor(id){
    var d=D()||{};
    try{
      if(id==='laboratory') return (d.labTests||[]).filter(function(x){return /ordered|pending|collected/i.test(x.status||'');}).length;
      if(id==='appointments') return (d.appointments||[]).filter(function(x){return /scheduled|confirmed/i.test(x.status||'');}).length;
      if(id==='prescriptions'||id==='pharmacy'||id==='pharmacyplus') return (d.prescriptions||[]).filter(function(x){return /pending|active|ready/i.test(x.status||'');}).length;
      if(id==='emergency') return (d.emergencyCases||[]).filter(function(e){return (e.status||'')!=='Discharged';}).length;
      if(id==='receivables'||id==='billing') return (d.bills||[]).filter(function(b){return b.balance>0;}).length;
      if(id==='referrals') return (d.referrals||[]).filter(function(r){return /pending|sent|new/i.test(r.status||'');}).length;
    }catch(e){}
    return 0;
  }

  /* ═══ BUILD THE NAV — responsibilities only, exact labels, functional links ═══ */
  function buildNavHTML(){
    var u=activeUser(); if(!u) return '';
    var role=curRole();
    var mods=myModules(u);
    /* stamp meta + preserve declared order via index */
    mods.forEach(function(m,i){ var mm=meta(m.id); m.__i=i; m.g=mm.g; m.icon=mm.i; });
    /* group, but keep dashboard first and declared order within groups */
    var groups={};
    mods.forEach(function(m){ (groups[m.g]=groups[m.g]||[]).push(m); });
    var active=curMod();
    var html='';
    GROUP_ORDER.forEach(function(g){
      var list=groups[g]; if(!list||!list.length) return;
      list.sort(function(a,b){ if(a.id==='dashboard')return -1; if(b.id==='dashboard')return 1; return a.__i-b.__i; });
      if(g!=='Overview') html+='<div class="v186-navsec">'+esc(g)+'</div>';
      list.forEach(function(m){
        var b=badgeFor(m.id);
        var ro=(m.access==='view' && !isSuperRole(role));
        html+='<button type="button" class="v186-nav'+(active===m.id?' active':'')+'" data-mod="'+esc(m.id)+'"'
          +' title="'+esc(m.label)+'" onclick="try{goTo(\''+esc(m.id)+'\')}catch(e){}">'
          +'<span class="v186-ic"><i class="fa-solid '+esc(m.icon)+'"></i></span>'
          +'<span class="v186-lbl">'+esc(m.label)+(ro?'<span class="v188-ro">View</span>':'')+'</span>'
          +(b?'<span class="v186-badge">'+b+'</span>':'')
          +'</button>';
      });
    });
    /* Tranquil AI helper card (kept from v186) */
    html+='<div class="v186-ai" onclick="try{(window.showAIAssistant||window.openAIChat||function(){goTo(\'ai\')})()}catch(e){}">'
      +'<div class="v186-ai-ic"><i class="fa-solid fa-wand-magic-sparkles"></i></div>'
      +'<div class="v186-ai-t">Tranquil AI</div><div class="v186-ai-s">Summarise my '+(/(doctor|nurse|consultant)/i.test(role)?'ward':'day')+' in one tap</div>'
      +'</div>';
    return html;
  }
  window.__hmsBuildNav = buildNavHTML;   /* expose for tests */
  /* Expose the SINGLE responsibilities source so the dashboard Quick Access can
     derive its tiles from EXACTLY the same data as the sidebar (Issue 6). */
  window.__hmsMyModules = function(u){ try{ return myModules(u||activeUser()); }catch(e){ return []; } };
  window.__hmsNavMeta = meta;
  window.__hmsIsSuperRole = isSuperRole;

  /* install as the authoritative buildNav (win the chain) */
  function installBuildNav(){
    window.buildNav=function(){ try{ return buildNavHTML(); }catch(e){ return ''; } };
    var f=window.buildNav;
    f.__v188=f.__v187=f.__v186=f.__v185=f.__v184=f.__v183=f.__v182=f.__v181=f.__v175=f.__v174=true;
  }

  /* Signature that requires a FULL rebuild — user / role / responsibility set.
     The active module is deliberately EXCLUDED so plain navigation only toggles
     the .active class in place (no innerHTML churn → no flicker on every click). */
  function sig(){
    var u=activeUser(); if(!u) return 'x';
    var ids='';
    try{ ids = myModules(u).map(function(m){return m.id;}).join(','); }catch(e){ ids=String(myModules(u).length); }
    return (u.username||'')+'|'+(u.role||'')+'|'+ids;
  }
  function syncNav(){
    /* single-writer guard (lets a future vNNN take over cleanly) */
    if (window.__NAV_OWNER && window.__NAV_OWNER!=='v188') return;
    try{
      var sb=document.getElementById('sidebar')||document.querySelector('aside.sb'); if(!sb) return;
      var nav=sb.querySelector('nav'); if(!nav) return;
      var s=sig();
      if(nav.getAttribute('data-v188')!==s){
        /* full rebuild ONCE per user/role/responsibility change */
        var h=buildNavHTML();
        if(h){ nav.innerHTML=h; nav.setAttribute('data-v188',s); nav.setAttribute('data-v186',s); }
        return;
      }
      /* signature unchanged → only move the active highlight (no rebuild) */
      var active=curMod();
      var links=nav.querySelectorAll('.v186-nav[data-mod]');
      for(var i=0;i<links.length;i++){
        var on=links[i].getAttribute('data-mod')===active;
        if(on && !links[i].classList.contains('active')) links[i].classList.add('active');
        else if(!on && links[i].classList.contains('active')) links[i].classList.remove('active');
      }
    }catch(e){}
  }
  window.__hmsSyncNav = syncNav;

  /* Neutralise every legacy nav writer / cleaner / observer so EXACTLY ONE code
     path (this pack's syncNav) ever mutates the sidebar <nav>. Idempotent:
     runs each boot tick but each clear is guarded. This is the root-cause fix
     for the "shaking" — the competing timers/observers are stopped, not
     out-shouted. */
  function silenceOtherNavWriters(){
    try{
      /* v170/legacy ESS appender: kill its interval + observer, drop stale node */
      if(window.__essNavInt && window.__essNavInt!=='tamed'){ try{ clearInterval(window.__essNavInt); }catch(e){} window.__essNavInt='tamed'; }
      if(window.__essMO){ try{ window.__essMO.disconnect(); }catch(e){} window.__essMO=null; }
      var stale=document.getElementById('twh_ess_nav'); if(stale&&stale.parentNode) stale.parentNode.removeChild(stale);
    }catch(e){}
    try{
      /* cleanNav / observeNav DOM scrubber: kill its interval + observer */
      if(window.__extNavCleanInt && window.__extNavCleanInt!=='tamed'){ try{ clearInterval(window.__extNavCleanInt); }catch(e){} window.__extNavCleanInt='tamed'; }
      if(window.__navObs){ try{ window.__navObs.disconnect(); }catch(e){} window.__navObs=null; window.__navObsHost=null; }
    }catch(e){}
  }
  window.__silenceOtherNavWriters = silenceOtherNavWriters;

  /* ═══ BOOT / RE-ASSERT (stay outermost over v182/v186's buildNav/syncNav) ═══ */
  function boot(){
    window.__NAV_OWNER = 'v188';   /* re-assert ownership every tick */
    silenceOtherNavWriters();      /* single-writer: stop all other nav mutators */
    if (!(window.buildNav && window.buildNav.__v188)) installBuildNav();
    syncNav();
  }
  if (typeof window.render==='function' && !window.render.__v188){
    var _r=window.render; window.render=function(){ var o=_r.apply(this,arguments); try{ syncNav(); }catch(e){} return o; };
    window.render.__v188=true;
  }
  if (typeof window.goTo==='function' && !window.goTo.__v188){
    var _g=window.goTo; window.goTo=function(){ var o=_g.apply(this,arguments); try{ syncNav(); }catch(e){} return o; };
    window.goTo.__v188=true; try{ window.goTo.__v186=_g.__v186; window.goTo.__v187=_g.__v187; }catch(e){}
  }
  [0,120,300,700,1400,2600,4000].forEach(function(t){ setTimeout(boot, t); });
  /* light watchdog: syncNav is signature-gated (only rewrites on real change),
     so this does NOTHING on idle — no innerHTML churn, no shaking. */
  DOMBus.register(boot);

  try{ console.log('%c\u2705 v188 \u2014 sidebar = responsibilities-only with EXACT labels; every link functional + active','background:#0b664b;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/145-mrn-date-prefix-iso-date-mrn-looks-like-2603th00.js ==== */
(function(){
  'use strict';
  if(window.__twhV193) return;
  window.__twhV193 = true;

  function pad2(n){ n=String(n); return n.length<2?('0'+n):n; }

  // MRN date prefix → ISO date. MRN looks like "2603TH0001": YY=26, MM=03.
  function dateFromMrn(mrn){
    try{
      var m = String(mrn||'').match(/^(\d{2})(\d{2})/);
      if(!m) return '';
      var yy = parseInt(m[1],10), mm = parseInt(m[2],10);
      if(isNaN(yy) || isNaN(mm) || mm<1 || mm>12) return '';
      return '20'+pad2(yy)+'-'+pad2(mm)+'-01';
    }catch(e){ return ''; }
  }

  // Approx DOB from age: Jan 1 of (thisYear - age).
  function dobFromAge(age){
    var a = parseInt(age,10);
    if(isNaN(a) || a<0 || a>130) return '';
    var y = new Date().getFullYear() - a;
    return y+'-01-01';
  }

  function backfill(){
    if(typeof D==='undefined' || !D || !Array.isArray(D.patients)) return false;
    if(D.__v193Backfill) return true;   // already done for this workspace
    var today = (function(){ var d=new Date(); return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate()); })();
    var changed = 0;
    D.patients.forEach(function(p){
      if(!p || typeof p!=='object') return;
      var touched = false;
      // registrationDate — the "date" that was blank on every census record.
      if(!p.registrationDate || !String(p.registrationDate).trim()){
        p.registrationDate = dateFromMrn(p.mrn) || today;
        touched = true;
      }
      // admissionDate for admitted patients that have none.
      if((p.status==='Admitted') && (!p.admissionDate)){
        p.admissionDate = p.registrationDate || today;
        touched = true;
      }
      // dob approximated from age so the Edit form isn't blank.
      if((!p.dob || !String(p.dob).trim()) && (p.age!=null && p.age!=='')){
        var d = dobFromAge(p.age);
        if(d){ p.dob = d; touched = true; }
      }
      // Ensure a payer value exists (the HMO/Payer column reads p.insurance).
      if(!p.insurance || !String(p.insurance).trim()){
        p.insurance = 'Self-Pay';
        touched = true;
      }
      if(touched){ p._rev = Date.now(); changed++; }
    });
    D.__v193Backfill = true;   // idempotency marker (persisted with the doc)
    // Persist the backfill to D1 (and every other signed-in tab).
    try{
      if(typeof window._hmsSave==='function') window._hmsSave();
      else if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon();
    }catch(e){}
    try{ if(typeof window.render==='function' && window.isLoggedIn && !document.getElementById('modalBg')) window.render(); }catch(e){}
    try{ console.log('%c\u2705 v193 Patient backfill — dates & records normalised ('+changed+' updated)','background:#065f46;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
    return true;
  }

  // Run once the app + persistence layer are ready. Retry a few times because
  // the cloud document is restored asynchronously during the staggered boot.
  function tick(){ try{ return backfill(); }catch(e){ return false; } }
  if(!tick()){
    var tries = 0;
    var iv = setInterval(function(){
      if(tick() || ++tries > 40){ clearInterval(iv); }
    }, 500);
  }

  // Manual re-run hook for support/debug.
  window.__twhBackfillPatients = function(){ D && (D.__v193Backfill=false); return backfill(); };
})();

;

/* ==== /js/146-collections-whose-create-edit-delete-we-audit-ch.js ==== */
(function(){
  'use strict';
  if(window.__twhV194) return;
  window.__twhV194 = true;
  console.log('%c✅ v194 sync-fix + audit log active','color:#0a7;font-weight:bold');

  // ── Collections whose create/edit/delete we audit. Chosen to cover the
  //    transactions the user cares about (medical records, appointments,
  //    orders, AR, billing, pharmacy, lab, radiology, patients …) without
  //    tracking config/reference tables that change rarely or in bulk.
  var TRACKED = {
    patients:'Patient', appointments:'Appointment', encounters:'Medical record',
    medicalRecords:'Medical record', clinicalNotes:'Clinical note',
    prescriptions:'Prescription', labOrders:'Lab order', labResults:'Lab result',
    radOrders:'Radiology order', radiologyOrders:'Radiology order',
    orders:'Order', pharmacyOrders:'Pharmacy order', dispenses:'Dispense',
    bills:'Bill', invoices:'Invoice', arInvoices:'AR invoice',
    receipts:'Receipt', payments:'Payment', claims:'Insurance claim',
    insuranceClaims:'Insurance claim', transactions:'Transaction',
    admissions:'Admission', patientFlow:'Patient flow', referrals:'Referral',
    vitals:'Vitals', triage:'Triage', immunizations:'Immunization',
    journalEntries:'Journal entry', deposits:'Deposit', refunds:'Refund',
    // ── Wellness / Nutrition clinical records (v196) ──────────────────────
    wellnessScreenings:'Rapid wellness screening',
    wellnessRiskAssessments:'Wellness & malnutrition risk assessment',
    comprehensiveAssessments:'Comprehensive wellness assessment',
    wellnessReferrals:'Wellness referral',
    mealPlans:'Meal plan', dietaryOrders:'Dietary order',
    foodItems:'Food item', recipes:'Recipe'
  };

  // Fields excluded from the "what changed" diff summary (noise / bookkeeping).
  var NOISE = { _rev:1, updatedAt:1, updated_at:1, _lastEdited:1, _syncTs:1 };

  function actor(){
    try{
      var u = (window.currentUser)||(window.D&&D.currentUser)||null;
      if(!u) return { name:'Unknown', role:'' };
      return { name:u.fullName||u.username||u.name||'Unknown', role:u.role||'' };
    }catch(e){ return { name:'Unknown', role:'' }; }
  }

  function labelFor(rec, entityLabel){
    if(!rec||typeof rec!=='object') return '';
    return rec.fullName||rec.patientName||rec.name||rec.title||rec.code||
           rec.mrn||rec.number||('#'+rec.id);
  }

  // Build a light snapshot: entity → Map(id → shallow record clone) so we can
  // diff without holding whole-array references.
  function snapshot(){
    var snap = {};
    for(var key in TRACKED){
      var arr = window.D && D[key];
      if(!Array.isArray(arr)) continue;
      var m = {};
      for(var i=0;i<arr.length;i++){
        var r = arr[i];
        if(r && typeof r==='object' && ('id' in r)) m[r.id] = r;
      }
      snap[key] = m;
    }
    return snap;
  }

  function changedFields(oldR, newR){
    var out = [];
    var seen = {};
    var k;
    for(k in newR){ if(NOISE[k]) continue; seen[k]=1;
      var a = oldR ? oldR[k] : undefined, b = newR[k];
      if(JSON.stringify(a)!==JSON.stringify(b)) out.push(k);
    }
    if(oldR){ for(k in oldR){ if(NOISE[k]||seen[k]) continue;
      if(oldR[k]!==undefined) out.push(k); } }
    return out;
  }

  // Diff previous snapshot vs current D and return audit entries.
  function diff(prev){
    var entries = [];
    var a = actor();
    var now = Date.now();
    var cur = {};
    for(var key in TRACKED){
      var arr = window.D && D[key];
      if(!Array.isArray(arr)) continue;
      var label = TRACKED[key];
      var prevMap = (prev && prev[key]) || {};
      var curMap = {};
      var ids = {};
      for(var i=0;i<arr.length;i++){
        var r = arr[i];
        if(!r || typeof r!=='object' || !('id' in r)) continue;
        curMap[r.id] = r; ids[r.id]=1;
        var old = prevMap[r.id];
        if(!old){
          entries.push({ ts:now, actor:a.name, actorRole:a.role, action:'create',
            entity:key, entityId:String(r.id),
            summary:label+' created: '+labelFor(r,label) });
        } else {
          var ch = changedFields(old, r);
          if(ch.length){
            entries.push({ ts:now, actor:a.name, actorRole:a.role, action:'update',
              entity:key, entityId:String(r.id),
              summary:label+' updated: '+labelFor(r,label),
              detail:{ fields: ch.slice(0,20) } });
          }
        }
      }
      // deletions: present in prev, gone now
      for(var pid in prevMap){
        if(!ids[pid]){
          var d = prevMap[pid];
          entries.push({ ts:now, actor:a.name, actorRole:a.role, action:'delete',
            entity:key, entityId:String(pid),
            summary:label+' deleted: '+labelFor(d,label) });
        }
      }
      cur[key] = curMap;
    }
    return { entries:entries, snap:cur };
  }

  // ── Audit queue: entries accumulate here and are flushed to the server.
  var _queue = [];
  var _prevSnap = null;
  var _flushTimer = null;
  var ENDPOINT = window._HMS_API_ENDPOINT || ('/api/state/'+(window._HMS_STORAGE_KEY||'MCP_HMS_DATA_v17'));
  var AUDIT_ENDPOINT = ENDPOINT.replace('/api/state/','/api/audit/');

  // Capture changes since the last capture and enqueue them.
  function capture(){
    try{
      if(!window.D) return;
      if(_prevSnap===null){ _prevSnap = snapshot(); return; } // first pass = baseline
      var res = diff(_prevSnap);
      _prevSnap = res.snap;
      if(res.entries.length){
        // Mirror into an in-memory ring for instant local viewing.
        try{
          D.__auditLog = (D.__auditLog||[]).concat(res.entries);
          if(D.__auditLog.length>500) D.__auditLog = D.__auditLog.slice(-500);
        }catch(e){}
        for(var i=0;i<res.entries.length;i++) _queue.push(res.entries[i]);
        scheduleFlush();
      }
    }catch(e){ /* never break the app */ }
  }

  function scheduleFlush(){
    if(_flushTimer) return;
    _flushTimer = setTimeout(function(){ _flushTimer=null; flush(); }, 1200);
  }

  // Send queued audit entries to the dedicated audit endpoint. (State writes
  // also accept an `audit` field, but a dedicated POST keeps concerns clean
  // and works even when the state doc itself is a no-op.)
  function flush(){
    if(!_queue.length) return;
    var batch = _queue.splice(0, _queue.length);
    try{
      fetch(AUDIT_ENDPOINT,{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ entries: batch }),
        credentials:'include',
        cache:'no-store',
        keepalive:true
      }).then(function(r){
        if(!r||!r.ok){ /* re-queue on failure so nothing is lost */ Array.prototype.unshift.apply(_queue, batch); }
      }).catch(function(){ Array.prototype.unshift.apply(_queue, batch); });
    }catch(e){ Array.prototype.unshift.apply(_queue, batch); }
  }
  window._hmsAuditFlush = flush;

  // Hook the save path: whenever the app persists, capture what changed first
  // so the actor is the person who made THIS change. We wrap _hmsSave and
  // _hmsSaveSoon (the debounced saver used by the auto-persist choke-points).
  function installSaveHook(){
    ['_hmsSave','_hmsSaveSoon','_hmsFlush'].forEach(function(fn){
      var orig = window[fn];
      if(typeof orig!=='function' || orig._auditHooked) return;
      var wrapped = function(){ try{ capture(); }catch(e){} return orig.apply(this, arguments); };
      wrapped._auditHooked = true;
      try{ window[fn] = wrapped; }catch(e){}
    });
  }
  // Re-apply across the staggered boot so we wrap the final savers.
  installSaveHook();
  [200,800,2000,4000,8000].forEach(function(t){ setTimeout(installSaveHook, t); });
  // Also capture on a light timer as a safety net for mutations that don't save.
  DOMBus.register(capture);
  // Flush on unload so no audit entry is lost.
  window.addEventListener('beforeunload', flush);

  // ── Audit Log viewer ────────────────────────────────────────────────────
  function fmtTs(ts){
    try{ var d = new Date(ts); return d.toLocaleString(); }catch(e){ return String(ts); }
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  var ACTION_COLOR = { create:'#0a7', update:'#0369a1', delete:'#b91c1c' };

  window.showAuditLog = function(){
    var host = document.getElementById('modalBg') ? null : document.body;
    var wrap = document.createElement('div');
    wrap.id = 'auditModalBg';
    wrap.style.cssText='position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:99999;display:flex;align-items:flex-start;justify-content:center;padding:40px 16px;overflow:auto;';
    wrap.innerHTML =
      '<div style="background:#fff;border-radius:14px;max-width:1000px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);overflow:hidden;">'+
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 22px;background:linear-gradient(135deg,#0f766e,#065f46);color:#fff;">'+
          '<div style="font-size:18px;font-weight:700;"><i class="fa-solid fa-clipboard-list"></i>&nbsp; Audit Log — who created / edited / deleted records</div>'+
          '<button onclick="document.getElementById(\'auditModalBg\').remove()" style="background:rgba(255,255,255,.2);border:none;color:#fff;width:34px;height:34px;border-radius:8px;cursor:pointer;font-size:16px;">&times;</button>'+
        '</div>'+
        '<div style="padding:14px 22px;display:flex;gap:10px;align-items:center;border-bottom:1px solid #e5e7eb;">'+
          '<input id="auditSearch" placeholder="Filter by user, entity or action…" style="flex:1;padding:9px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;">'+
          '<button id="auditRefresh" style="padding:9px 16px;background:#0f766e;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:600;"><i class="fa-solid fa-rotate"></i> Refresh</button>'+
        '</div>'+
        '<div id="auditBody" style="max-height:60vh;overflow:auto;padding:8px 22px 22px;">'+
          '<div style="padding:30px;text-align:center;color:#64748b;">Loading audit entries…</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function(e){ if(e.target===wrap) wrap.remove(); });

    function render(entries){
      var q = (document.getElementById('auditSearch')||{}).value || '';
      q = q.toLowerCase();
      var list = entries.filter(function(e){
        if(!q) return true;
        return (String(e.actor||'')+' '+String(e.entity||'')+' '+String(e.action||'')+' '+String(e.summary||'')).toLowerCase().indexOf(q)>=0;
      });
      var body = document.getElementById('auditBody');
      if(!body) return;
      if(!list.length){ body.innerHTML='<div style="padding:30px;text-align:center;color:#64748b;">No audit entries'+(q?' match your filter':' yet')+'.</div>'; return; }
      var rows = list.map(function(e){
        var col = ACTION_COLOR[e.action]||'#475569';
        return '<tr style="border-bottom:1px solid #f1f5f9;">'+
          '<td style="padding:9px 8px;white-space:nowrap;color:#64748b;font-size:12px;">'+esc(fmtTs(e.ts))+'</td>'+
          '<td style="padding:9px 8px;"><span style="background:'+col+';color:#fff;padding:2px 9px;border-radius:99px;font-size:11px;font-weight:700;text-transform:uppercase;">'+esc(e.action)+'</span></td>'+
          '<td style="padding:9px 8px;font-weight:600;">'+esc(e.actor||'Unknown')+(e.actorRole?'<div style="font-size:11px;color:#94a3b8;font-weight:400;">'+esc(e.actorRole)+'</div>':'')+'</td>'+
          '<td style="padding:9px 8px;">'+esc(e.summary||(e.entity+' #'+e.entityId))+
            (e.detail&&e.detail.fields?'<div style="font-size:11px;color:#94a3b8;">fields: '+esc(e.detail.fields.join(', '))+'</div>':'')+'</td>'+
          '</tr>';
      }).join('');
      body.innerHTML =
        '<table style="width:100%;border-collapse:collapse;font-size:13px;">'+
          '<thead><tr style="text-align:left;color:#64748b;font-size:11px;text-transform:uppercase;border-bottom:2px solid #e5e7eb;">'+
            '<th style="padding:8px;">When</th><th style="padding:8px;">Action</th><th style="padding:8px;">By whom</th><th style="padding:8px;">What</th>'+
          '</tr></thead><tbody>'+rows+'</tbody></table>';
    }

    function load(){
      // Flush any queued entries first so the freshest data is on the server.
      try{ flush(); }catch(e){}
      fetch(AUDIT_ENDPOINT+'?limit=500',{ credentials:'include', cache:'no-store' })
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(j){
          var server = (j&&Array.isArray(j.entries))?j.entries:[];
          if(server.length){ render(server); return; }
          // Fallback to the in-memory ring if the server has nothing yet.
          var local = (window.D&&Array.isArray(D.__auditLog))?D.__auditLog.slice().reverse():[];
          render(local);
        })
        .catch(function(){
          var local = (window.D&&Array.isArray(D.__auditLog))?D.__auditLog.slice().reverse():[];
          render(local);
        });
    }

    var s = document.getElementById('auditSearch');
    if(s) s.addEventListener('input', function(){ load(); });
    var rf = document.getElementById('auditRefresh');
    if(rf) rf.addEventListener('click', load);
    load();
  };

  // ── Access control: the Audit Log is NOT for everyone. It is a privileged
  //    view controlled by the Configuration module (responsibilities). A user
  //    sees the Audit button only if their role has the 'audit' responsibility
  //    granted (super/admin roles always qualify). This registers 'audit' as a
  //    real module so Configuration ▸ Responsibilities lists it and admins can
  //    assign it per role, exactly like every other module.
  function registerAuditModule(){
    try{
      if(!window.D) return;
      D.moduleRegistry = D.moduleRegistry || {};
      if(!D.moduleRegistry.audit){
        D.moduleRegistry.audit = { id:'audit', name:'Audit Log', icon:'fa-clipboard-list',
          section:'ADMIN', desc:'Who created / edited / deleted records', system:true };
      }
      // Grant to super/admin roles by default so it is never orphaned.
      D.responsibilities = D.responsibilities || {};
      ['System Administrator','Admin','Superadmin','Super Admin','Administrator','Super System Admin']
        .forEach(function(r){ D.responsibilities[r] = D.responsibilities[r]||{}; D.responsibilities[r].audit = true; });
    }catch(e){}
  }

  function canSeeAudit(){
    try{
      // Prefer the authoritative RBAC guard when present.
      if(typeof window.hasModuleAccess==='function') return !!window.hasModuleAccess('audit');
      // Fallback: check responsibilities directly.
      var u = (window.currentUser)||(window.D&&D.currentUser)||null;
      var role = u && u.role;
      if(!role) return false;
      var superRoles = ['System Administrator','Admin','Superadmin','Super Admin','Administrator','Super System Admin'];
      if(superRoles.indexOf(role)>=0) return true;
      return !!(window.D && D.responsibilities && D.responsibilities[role] && D.responsibilities[role].audit);
    }catch(e){ return false; }
  }

  // ── Header entry point: inject an "Audit" button into the top bar — but ONLY
  //    for users whose role has the 'audit' responsibility (config-controlled).
  //    Re-applied on the staggered boot cadence because the header is rebuilt.
  function injectAuditButton(){
    try{
      registerAuditModule();
      var hdr = document.querySelector('.main .hdr .hdr-right');
      if(!hdr) return;
      var existing = hdr.querySelector('.v194-audit-btn');
      if(!canSeeAudit()){
        // Not permitted → make sure any previously-injected button is removed
        // (e.g. after switching to a role without the responsibility).
        if(existing) existing.remove();
        return;
      }
      if(existing) return; // already present & permitted
      var btn = document.createElement('button');
      btn.className = 'v194-audit-btn';
      btn.title = 'Audit Log — who created / edited / deleted records';
      btn.setAttribute('aria-label','Open audit log');
      btn.style.cssText='display:inline-flex;align-items:center;gap:6px;margin-right:8px;padding:6px 12px;background:#0f766e;color:#fff;border:none;border-radius:8px;cursor:pointer;font-size:12.5px;font-weight:600;';
      btn.innerHTML='<i class="fa-solid fa-clipboard-list"></i><span>Audit</span>';
      btn.onclick = function(){ if(window.showAuditLog) window.showAuditLog(); };
      // Place it just before the sync chip slot if present, else at the front.
      var slot = hdr.querySelector('.v185-sync-slot');
      if(slot) hdr.insertBefore(btn, slot); else hdr.insertBefore(btn, hdr.firstChild);
    }catch(e){}
  }
  injectAuditButton();
  [300,1000,2500,5000,9000].forEach(function(t){ setTimeout(injectAuditButton, t); });
  // Keep re-injecting after re-renders (header gets rebuilt frequently).
  DOMBus.register(injectAuditButton);

  // ── Make the "Sync error" chip explain itself. Clicking it opens a dialog
  //    with the ACTUAL error reason (from the last failed write) so users can
  //    see WHY sync failed instead of a bare red pill. We attach a delegated
  //    click handler on the header so it survives chip re-renders.
  function lastSyncError(){
    try{ return (window.HMS_DB && window.HMS_DB.lastError) || null; }catch(e){ return null; }
  }
  function showSyncErrorDialog(){
    var err = lastSyncError();
    var state = (window.HMS_DB && window.HMS_DB.syncState) || 'idle';
    var reason, hint;
    if(!err && state!=='error'){
      reason = 'Sync is healthy. All changes are being saved to the shared database.';
      hint = '';
    } else {
      reason = err || 'The last save to the server did not succeed.';
      // Some failures return a full HTML error page (e.g. Cloudflare's 503).
      // Never show raw markup to the user — collapse it to a clean summary.
      var rawHadHtml = /<!DOCTYPE|<html|<head|no-js/i.test(reason);
      var codeMatch = reason.match(/\bsave\s+(\d{3})\b/);
      var httpCode = codeMatch ? codeMatch[1] : '';
      if(rawHadHtml){
        reason = 'Server returned an error page' + (httpCode?(' (HTTP '+httpCode+')'):'') + ' instead of saving.';
      }
      // Friendly interpretation of common causes.
      if(/503/.test(httpCode) || /503/.test(reason)){
        hint = 'The server was briefly overloaded. This build now sends changes in small (~300 KB) batches AND automatically retries a 503 with exponential backoff, so it recovers on its own. Your change is kept safe locally and re-sent until it succeeds — you can click "Retry now" or just wait a moment.';
      } else if(/TOOBIG|row size|2000000|too large/i.test(reason)){
        hint = 'A data record exceeded Cloudflare D1\'s 2 MB per-row limit. The database is now sharded per collection to avoid this — reload to pick up the fix.';
      } else if(/\b401\b|unauthor|session/i.test(reason)){
        hint = 'Your session may have expired. Try signing in again.';
      } else if(/Failed to fetch|NetworkError|timeout|network/i.test(reason)){
        hint = 'A network problem prevented the save. It will retry automatically; check your connection.';
      } else if(/\b500\b|write_failed/i.test(reason)){
        hint = 'The server rejected the write. It will retry automatically. If it persists, the record may be malformed.';
      } else {
        hint = 'The app retries failed saves automatically. If this keeps showing, reload the page.';
      }
    }
    var esc2 = function(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); };
    var head = (state==='error')
      ? '<i class="fa-solid fa-triangle-exclamation" style="color:#dc2626"></i> Sync error — details'
      : '<i class="fa-solid fa-circle-check" style="color:#16a34a"></i> Sync status';
    var html =
      '<div style="font-size:13px;line-height:1.6;color:var(--txt,#0f172a)">'+
        '<p style="margin:0 0 10px"><b>Status:</b> '+esc2(state)+'</p>'+
        '<p style="margin:0 0 10px"><b>Reason:</b><br>'+esc2(reason)+'</p>'+
        (hint?'<p style="margin:0 0 10px;color:#475569"><b>What this means:</b><br>'+esc2(hint)+'</p>':'')+
        '<div style="display:flex;gap:8px;margin-top:14px">'+
          '<button class="btn btn-pri" onclick="(window.twhSyncNow?window.twhSyncNow():(window._hmsSave&&window._hmsSave()));(window.closeModal&&closeModal())"><i class="fa-solid fa-rotate"></i> Retry now</button>'+
          '<button class="btn btn-ghost" onclick="(window.closeModal&&closeModal())">Close</button>'+
        '</div>'+
      '</div>';
    if(typeof window.showModal==='function'){ window.showModal(head, html, '', ''); }
    else { alert((state==='error'?'Sync error: ':'Sync status: ')+reason+(hint?('\n\n'+hint):'')); }
  }
  window.showSyncErrorDialog = showSyncErrorDialog;
  // Delegated click: any click on the sync chip opens the reason dialog.
  document.addEventListener('click', function(ev){
    var chip = ev.target && ev.target.closest ? ev.target.closest('.v185-sync') : null;
    if(chip){ ev.preventDefault(); ev.stopPropagation(); showSyncErrorDialog(); }
  }, true);
  // Give the chip an affordance so users know it's clickable.
  function styleSyncChip(){
    try{
      var chips = document.querySelectorAll('.v185-sync');
      for(var i=0;i<chips.length;i++){ chips[i].style.cursor='pointer'; chips[i].title='Click for sync details'; }
    }catch(e){}
  }
  DOMBus.register(styleSyncChip); styleSyncChip();

  // Expose a small helper so any code can log an explicit audit entry.
  window.hmsAudit = function(action, entity, entityId, summary, detail){
    var a = actor();
    var e = { ts:Date.now(), actor:a.name, actorRole:a.role, action:action,
              entity:entity, entityId:entityId!=null?String(entityId):null,
              summary:summary, detail:detail };
    _queue.push(e); scheduleFlush();
    try{ D.__auditLog=(D.__auditLog||[]).concat([e]); }catch(_){}
    return e;
  };
})();

;

/* ==== /js/147-twh-mealplan-v195.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v195 — CLINICAL MEAL PLAN BUILDER (structured, patient-specific)
   Implements the 6-step workflow from "OVERALL EMR WORKFLOW AND MEAL PLANNER
   EDIT.docx": (1) settings duration 7/14/21/28 + meal pattern; (2) auto day-by-
   day table; (3) food selection per cell from the hospital food DB; (4) per-day
   totals vs prescription; (5) templated Patient Instructions; (6) professional
   printed report. Added as its own launcher; existing single-day planner is
   untouched. Idempotent, guarded by __twhV195.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV195) return; window.__twhV195 = true;

  function D_(){ return window.D || {}; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function foods(){ var D=D_(); return Array.isArray(D.foodItems)?D.foodItems:[]; }
  function foodById(id){ return foods().find(function(f){return String(f.id)===String(id);}); }
  function num(v,d){ v=+v; return isFinite(v)?v:(d||0); }
  function todayStr(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function curU(){ try{ return (typeof curUser==='function')?curUser():((D_().currentUser&&D_().currentUser.name)||''); }catch(e){ return ''; } }
  function curR(){ try{ return (typeof curRole==='function')?curRole():((D_().currentUser&&D_().currentUser.role)||''); }catch(e){ return ''; } }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  function toastMsg(m){ try{ if(typeof toast==='function') toast(m); }catch(e){} }
  function patObj(id){ return (D_().patients||[]).find(function(p){return String(p.id)===String(id);}); }
  /* patient display helpers — patient schema uses fullName / mrn / age / gender / allergies */
  function patDisplayName(p){ if(!p) return '—'; return p.fullName||p.name||('Patient '+(p.mrn||p.id||'')); }
  function patNo(p){ if(!p) return '—'; return p.mrn||p.id||'—'; }
  /* Food intolerance is captured on the wellness assessment (foodIntolerance) — surface it if present */
  function patFoodIntolerance(id){
    try{
      var D=D_(); var arrs=[D.wellnessAssessments,D.assessments,D.wlAssessments];
      for(var a=0;a<arrs.length;a++){ var arr=arrs[a]; if(!Array.isArray(arr)) continue;
        var rec=arr.filter(function(r){return r&&(String(r.patientId)===String(id));}).slice(-1)[0];
        if(rec&&(rec.foodIntolerance||rec.foodIntolerances)) return rec.foodIntolerance||rec.foodIntolerances;
      }
    }catch(e){}
    var p=patObj(id); return (p&&(p.foodIntolerance||p.intolerance))||'';
  }
  /* consultant nutritionist / wellness officer for the patient (falls back to current user) */
  function patConsultant(id){
    try{
      var D=D_(); var p=patObj(id);
      var emps=D.employees||[];
      if(p&&p.doctorId){ var e=emps.find(function(x){return String(x.id)===String(p.doctorId);}); if(e) return e.name||e.fullName||''; }
      var w=emps.find(function(x){ return /nutrition|wellness|dietitian|dietician/i.test((x.role||'')+' '+(x.position||'')+' '+(x.department||'')); });
      if(w) return w.name||w.fullName||'';
    }catch(e){}
    return curU()||'';
  }
  /* resolve a grid item to macros — supports DB foods (foodId) and free-text custom foods (custom + optional macros) */
  function resolveItem(it){
    if(!it) return null;
    if(it.custom){
      return { name:it.custom, kcal:num(it.kcal), protein:num(it.protein), carbs:num(it.carbs), fat:num(it.fat), sodium:num(it.sodium), _custom:true };
    }
    var f=foodById(it.foodId);
    if(f) return { name:f.name, kcal:num(f.kcal), protein:num(f.protein), carbs:num(f.carbs), fat:num(f.fat), sodium:num(f.sodium) };
    return { name:'#'+it.foodId, kcal:0, protein:0, carbs:0, fat:0, sodium:0, _missing:true };
  }

  var PATTERNS = {
    'BLD':   ['Breakfast','Lunch','Dinner'],
    'BSLD':  ['Breakfast','Morning Snack','Lunch','Dinner'],
    'BLSD':  ['Breakfast','Lunch','Afternoon Snack','Dinner'],
    'BSLSD': ['Breakfast','Morning Snack','Lunch','Afternoon Snack','Dinner']
  };
  var PATTERN_LABEL = {
    'BLD':'Breakfast – Lunch – Dinner',
    'BSLD':'Breakfast – Snack – Lunch – Dinner',
    'BLSD':'Breakfast – Lunch – Snack – Dinner',
    'BSLSD':'Breakfast – Snack – Lunch – Snack – Dinner'
  };

  var INSTRUCTION_TEMPLATES = {
    'Peptic Ulcer / GI': {
      'Regular Feeding':'Eat 5 small meals daily. Do NOT skip meals or fast. Eat every 3–4 hours, even if portions are small.',
      'Meal Timing':'Breakfast within 1 hour of waking · Lunch 12:00–2:00 pm · Dinner before 8:00 pm · Snacks between main meals.',
      'Safe Foods':'Pap, oatmeal, boiled/mashed potatoes, soft rice, boiled fish, eggs, ripe banana, pawpaw, yoghurt, well-cooked vegetables.',
      'Foods to Avoid':'Very spicy/peppery foods, alcohol, carbonated drinks, caffeine, fried/oily foods, raw onions, citrus on an empty stomach.',
      'Water Intake':'Drink 2–3 litres of water daily; sip between (not during) meals.',
      'Exercise':'Light activity such as a 20–30 min walk daily; avoid strenuous exercise right after eating.',
      'Lifestyle':'Do not lie down immediately after eating. Manage stress. Avoid smoking.',
      'Warning Signs':'Report black/dark stools, vomiting blood, severe abdominal pain, dizziness or fainting immediately.',
      'Follow-up':'Return for review as scheduled, or sooner if symptoms worsen.'
    },
    'Diabetes / Cardio-metabolic': {
      'Regular Feeding':'Eat balanced meals at consistent times; do not skip meals. Include a lean protein and high-fibre food at each meal.',
      'Meal Timing':'Breakfast 7:30–8:30 am · Lunch 1:30–2:30 pm · Dinner 7:00–8:00 pm · Snacks mid-morning and mid-afternoon.',
      'Safe Foods':'Whole grains, beans/legumes, non-starchy vegetables, fish, skinless poultry, nuts, low-GI fruits in moderation.',
      'Foods to Avoid':'Sugary drinks, sweets, white bread/refined carbs, deep-fried foods, excess salt and processed meats.',
      'Water Intake':'Drink at least 2 litres of water daily unless fluid-restricted.',
      'Exercise':'At least 30 min of moderate activity (brisk walking) on most days of the week.',
      'Lifestyle':'Monitor blood glucose as advised. Maintain a healthy weight. Avoid smoking and limit alcohol.',
      'Warning Signs':'Report symptoms of very high or low blood sugar, chest pain, blurred vision or numbness.',
      'Follow-up':'Attend scheduled reviews and bring your glucose/BP log.'
    },
    'General Wellness': {
      'Regular Feeding':'Eat 3 balanced meals with 1–2 healthy snacks daily; do not skip breakfast.',
      'Meal Timing':'Keep regular meal times each day.',
      'Safe Foods':'A varied diet rich in vegetables, fruits, whole grains and lean protein.',
      'Foods to Avoid':'Limit added sugar, salt, and ultra-processed foods.',
      'Water Intake':'Aim for ~2 litres of water daily.',
      'Exercise':'150 minutes of moderate activity per week.',
      'Lifestyle':'Prioritise sleep, manage stress, avoid smoking.',
      'Warning Signs':'Report any unexpected weight loss, persistent fatigue or loss of appetite.',
      'Follow-up':'Routine follow-up as advised.'
    }
  };
  var INSTRUCTION_SECTIONS = ['Regular Feeding','Meal Timing','Safe Foods','Foods to Avoid','Water Intake','Exercise','Lifestyle','Warning Signs','Follow-up'];

  var MPB = { patientId:null, days:14, pattern:'BSLD', grid:{}, target:{calories:2000,proteinG:70,carbG:250,fatG:65,sodiumMg:2000}, editId:null,
              instrCategory:'General Wellness', instructions:{}, dx:'', activeDay:1, view:'table' };
  window.__MPB = MPB;

  function cellKey(day, meal){ return day+'|'+meal; }
  function dayTotals(day){
    var meals = PATTERNS[MPB.pattern]||PATTERNS.BSLD;
    var t = {kcal:0,protein:0,carbs:0,fat:0,sodium:0};
    meals.forEach(function(m){
      (MPB.grid[cellKey(day,m)]||[]).forEach(function(it){
        var f=resolveItem(it); if(!f) return; var q=num(it.qty,1);
        t.kcal+=num(f.kcal)*q; t.protein+=num(f.protein)*q; t.carbs+=num(f.carbs)*q; t.fat+=num(f.fat)*q; t.sodium+=num(f.sodium)*q;
      });
    });
    ['kcal','protein','carbs','fat','sodium'].forEach(function(k){ t[k]=Math.round(t[k]); });
    return t;
  }
  function planAverage(){
    var acc={kcal:0,protein:0,carbs:0,fat:0,sodium:0};
    for(var d=1; d<=MPB.days; d++){ var t=dayTotals(d); acc.kcal+=t.kcal; acc.protein+=t.protein; acc.carbs+=t.carbs; acc.fat+=t.fat; acc.sodium+=t.sodium; }
    var n=MPB.days||1;
    return { kcal:Math.round(acc.kcal/n), protein:Math.round(acc.protein/n), carbs:Math.round(acc.carbs/n), fat:Math.round(acc.fat/n), sodium:Math.round(acc.sodium/n) };
  }
  window.__MPB_dayTotals = dayTotals;
  window.__MPB_planAverage = planAverage;
  window.__MPB_PATTERNS = PATTERNS;
  window.__MPB_TEMPLATES = INSTRUCTION_TEMPLATES;
  window.__MPB_SECTIONS = INSTRUCTION_SECTIONS;
  window.__MPB_resolveItem = resolveItem;
  /* ── extension hooks for v202 (searchable + custom food entry, extra templates) ── */
  window.__MPB_state = function(){ return MPB; };
  window.__MPB_isOpen = function(){ return !!document.getElementById(OVID); };
  window.__MPB_rerender = function(){ try{ renderBody(); }catch(e){} };
  window.__MPB_cellKey = cellKey;
  /* add / merge an instruction template so v202 can register clinical templates (e.g. Diabetes/Hypercholesterolemia) */
  window.__MPB_addTemplate = function(name, obj){
    if(!name || !obj || typeof obj!=='object') return false;
    INSTRUCTION_TEMPLATES[name] = Object.assign({}, INSTRUCTION_TEMPLATES[name]||{}, obj);
    return true;
  };
  /* add a food to the active day's meal — supports DB food (by name/id) or free-text custom food with optional macros */
  window.__MPB_addFoodByName = function(meal, name, qty, macros){
    if(!document.getElementById(OVID)) return false;
    var meals = PATTERNS[MPB.pattern]||PATTERNS.BSLD;
    if(meals.indexOf(meal)<0) meal = meals[0];
    var k = cellKey(MPB.activeDay, meal);
    MPB.grid[k] = MPB.grid[k] || [];
    var q = num(qty,1)||1;
    var f = foods().find(function(x){ return String(x.name||'').toLowerCase().trim()===String(name||'').toLowerCase().trim(); });
    if(f){ MPB.grid[k].push({ foodId:f.id, qty:q }); }
    else {
      var m = macros||{};
      MPB.grid[k].push({ custom:String(name||'').trim(), qty:q,
        kcal:num(m.kcal), protein:num(m.protein), carbs:num(m.carbs), fat:num(m.fat), sodium:num(m.sodium) });
    }
    try{ renderBody(); }catch(e){}
    return true;
  };

  /* ── styles (injected once) ───────────────────────────────────────────── */
  function ensureStyles(){
    if(document.getElementById('mpb-v195-css')) return;
    var st=document.createElement('style'); st.id='mpb-v195-css';
    st.textContent=[
      '.mpb-ov{position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:99990;display:flex;align-items:flex-start;justify-content:center;overflow:auto;padding:24px}',
      '.mpb-modal{background:#fff;border-radius:14px;width:min(1180px,96vw);box-shadow:0 20px 60px rgba(0,0,0,.35);margin:auto;overflow:hidden}',
      '.mpb-hd{background:linear-gradient(135deg,#0e7490,#0891b2);color:#fff;padding:16px 22px;display:flex;align-items:center;justify-content:space-between}',
      '.mpb-hd h2{margin:0;font-size:19px;font-weight:700}',
      '.mpb-hd .sub{font-size:12px;opacity:.9;margin-top:2px}',
      '.mpb-x{background:rgba(255,255,255,.2);border:none;color:#fff;width:34px;height:34px;border-radius:8px;cursor:pointer;font-size:18px}',
      '.mpb-bd{padding:18px 22px;max-height:calc(100vh - 200px);overflow:auto}',
      '.mpb-sec{border:1px solid #e2e8f0;border-radius:10px;padding:14px 16px;margin-bottom:16px}',
      '.mpb-sec h3{margin:0 0 12px;font-size:14px;font-weight:700;color:#0e7490;display:flex;align-items:center;gap:8px}',
      '.mpb-sec h3 .n{background:#0891b2;color:#fff;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:12px}',
      '.mpb-row{display:flex;flex-wrap:wrap;gap:14px;align-items:flex-end}',
      '.mpb-fld{display:flex;flex-direction:column;gap:4px}',
      '.mpb-fld label{font-size:11px;font-weight:600;color:#475569;text-transform:uppercase;letter-spacing:.04em}',
      '.mpb-fld select,.mpb-fld input,.mpb-fld textarea{border:1px solid #cbd5e1;border-radius:8px;padding:8px 10px;font-size:13px;font-family:inherit}',
      '.mpb-btn{background:#0891b2;color:#fff;border:none;border-radius:8px;padding:9px 16px;font-size:13px;font-weight:600;cursor:pointer}',
      '.mpb-btn.sec{background:#e2e8f0;color:#0f172a}',
      '.mpb-btn.gr{background:#059669}',
      '.mpb-btn:hover{filter:brightness(1.05)}',
      '.mpb-daytabs{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px}',
      '.mpb-daytab{border:1px solid #cbd5e1;background:#f8fafc;border-radius:8px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;position:relative}',
      '.mpb-daytab.on{background:#0891b2;color:#fff;border-color:#0891b2}',
      '.mpb-daytab .warn{color:#dc2626;font-size:10px;margin-left:4px}',
      '.mpb-daytab.on .warn{color:#fde68a}',
      '.mpb-mealgrid{display:grid;gap:12px;grid-template-columns:repeat(auto-fill,minmax(230px,1fr))}',
      '.mpb-setgrid{display:flex;flex-wrap:wrap;gap:22px}',
      '.mpb-setblk{display:flex;flex-direction:column;gap:8px}',
      '.mpb-setlab{font-size:11px;font-weight:700;color:#0e7490;text-transform:uppercase;letter-spacing:.04em}',
      '.mpb-radios{display:flex;flex-wrap:wrap;gap:8px}',
      '.mpb-radios-col{flex-direction:column}',
      '.mpb-radio{display:inline-flex;align-items:center;gap:8px;border:1px solid #cbd5e1;background:#f8fafc;border-radius:9px;padding:8px 12px;font-size:12.5px;font-weight:600;color:#334155;cursor:pointer;transition:all .12s}',
      '.mpb-radio:hover{border-color:#0891b2}',
      '.mpb-radio.on{background:#0891b2;color:#fff;border-color:#0891b2}',
      '.mpb-radio input{accent-color:#0e7490;margin:0}',
      '.mpb-matrix-wrap{overflow:auto;border:1px solid #e2e8f0;border-radius:10px;margin-bottom:12px}',
      '.mpb-matrix{border-collapse:collapse;width:100%;font-size:12px;min-width:640px}',
      '.mpb-matrix th,.mpb-matrix td{border:1px solid #e2e8f0;padding:8px 10px;vertical-align:top;text-align:left}',
      '.mpb-matrix thead th{background:#0e7490;color:#fff;position:sticky;top:0;text-align:center;font-size:11.5px}',
      '.mpb-matrix .dcell{background:#f1f5f9;font-weight:700;white-space:nowrap;cursor:pointer;text-align:center}',
      '.mpb-matrix .dcell.on{background:#0891b2;color:#fff}',
      '.mpb-matrix td.mcell{cursor:pointer}',
      '.mpb-matrix td.mcell:hover{background:#ecfeff}',
      '.mpb-matrix td.mcell.act{background:#cffafe;box-shadow:inset 0 0 0 2px #0891b2}',
      '.mpb-matrix .fchip{display:inline-block;background:#e0f2fe;color:#0c4a6e;border-radius:6px;padding:1px 7px;margin:2px 2px 0 0;font-size:11px}',
      '.mpb-matrix .kcalc{text-align:center;font-weight:700;background:#f8fafc}',
      '.mpb-matrix td.empty{color:#cbd5e1;text-align:center}',
      '.mpb-viewtoggle{display:inline-flex;border:1px solid #cbd5e1;border-radius:8px;overflow:hidden;margin-left:auto}',
      '.mpb-viewtoggle button{border:none;background:#fff;color:#334155;font-size:11.5px;font-weight:600;padding:5px 12px;cursor:pointer}',
      '.mpb-viewtoggle button.on{background:#0891b2;color:#fff}',
      '.mpb-meal{border:1px solid #e2e8f0;border-radius:10px;overflow:hidden}',
      '.mpb-meal .mh{background:#f1f5f9;padding:8px 12px;font-size:12px;font-weight:700;color:#0f172a;display:flex;justify-content:space-between;align-items:center}',
      '.mpb-meal .mb{padding:8px 12px}',
      '.mpb-item{display:flex;align-items:center;gap:6px;font-size:12px;padding:4px 0;border-bottom:1px dashed #eef2f7}',
      '.mpb-item .nm{flex:1}',
      '.mpb-item input{width:52px;border:1px solid #cbd5e1;border-radius:6px;padding:3px 5px;font-size:12px}',
      '.mpb-item .del{background:none;border:none;color:#dc2626;cursor:pointer;font-size:13px}',
      '.mpb-add{display:flex;gap:6px;margin-top:8px}',
      '.mpb-add select{flex:1;border:1px solid #cbd5e1;border-radius:6px;padding:5px;font-size:12px}',
      '.mpb-add button{background:#0891b2;color:#fff;border:none;border-radius:6px;padding:5px 10px;font-size:12px;cursor:pointer}',
      '.mpb-tot{margin-top:12px;border-collapse:collapse;width:100%;font-size:12px}',
      '.mpb-tot th,.mpb-tot td{border:1px solid #e2e8f0;padding:6px 8px;text-align:center}',
      '.mpb-tot th{background:#f1f5f9}',
      '.mpb-tot .lab{text-align:left;font-weight:600}',
      '.mpb-tot .over{color:#dc2626;font-weight:700}',
      '.mpb-tot .ok{color:#059669;font-weight:700}',
      '.mpb-instr{display:grid;gap:10px;grid-template-columns:repeat(auto-fill,minmax(320px,1fr))}',
      '.mpb-instr .cell label{font-size:11px;font-weight:700;color:#0e7490;display:block;margin-bottom:3px}',
      '.mpb-instr textarea{width:100%;min-height:52px;border:1px solid #cbd5e1;border-radius:8px;padding:6px 8px;font-size:12px;font-family:inherit;resize:vertical}',
      '.mpb-ft{padding:14px 22px;border-top:1px solid #e2e8f0;display:flex;justify-content:flex-end;gap:10px;background:#f8fafc}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ── open / render ────────────────────────────────────────────────────── */
  var OVID='mpb-v195-ov';
  function close(){ var ov=document.getElementById(OVID); if(ov) ov.remove(); }

  function open(patientId, prefill){
    ensureStyles();
    close();
    // reset state
    MPB.patientId = patientId||null;
    MPB.days = 14; MPB.pattern='BSLD'; MPB.grid={}; MPB.editId=null; MPB.code=null; MPB.date=null; MPB.activeDay=1; MPB.view='table';
    MPB.instrCategory='General Wellness'; MPB.instructions={}; MPB.dx='';
    MPB.target={calories:2000,proteinG:70,carbG:250,fatG:65,sodiumMg:2000};
    if(prefill && typeof prefill==='object'){
      if(prefill.target) MPB.target=Object.assign(MPB.target, prefill.target);
      if(prefill.dx) MPB.dx=prefill.dx;
    }
    // seed instructions from template
    applyTemplate();
    var ov=document.createElement('div'); ov.className='mpb-ov'; ov.id=OVID;
    ov.innerHTML='<div class="mpb-modal">'+
      '<div class="mpb-hd"><div><h2><i class="fa fa-utensils"></i> Clinical Meal Plan Builder</h2>'+
      '<div class="sub" id="mpb-sub"></div></div><button class="mpb-x" id="mpb-x">&times;</button></div>'+
      '<div class="mpb-bd" id="mpb-bd"></div>'+
      '<div class="mpb-ft">'+
        '<button class="mpb-btn sec" id="mpb-cancel">Close</button>'+
        '<button class="mpb-btn gr" id="mpb-save"><i class="fa fa-save"></i> Save Plan</button>'+
        '<button class="mpb-btn" id="mpb-print"><i class="fa fa-print"></i> Print Report</button>'+
      '</div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('mousedown',function(e){ if(e.target===ov) close(); });
    document.getElementById('mpb-x').onclick=close;
    document.getElementById('mpb-cancel').onclick=close;
    document.getElementById('mpb-save').onclick=doSave;
    document.getElementById('mpb-print').onclick=function(){ printReport(); };
    renderBody();
  }

  function applyTemplate(){
    var tpl=INSTRUCTION_TEMPLATES[MPB.instrCategory]||INSTRUCTION_TEMPLATES['General Wellness'];
    MPB.instructions={};
    INSTRUCTION_SECTIONS.forEach(function(s){ MPB.instructions[s]=tpl[s]||''; });
  }

  function patName(){ var p=patObj(MPB.patientId); return patDisplayName(p); }

  function renderBody(){
    var bd=document.getElementById('mpb-bd'); if(!bd) return;
    var p=patObj(MPB.patientId);
    var sub=document.getElementById('mpb-sub');
    if(sub){
      if(p){
        var allergies=(p.allergies&&!/^none$/i.test(String(p.allergies).trim()))?p.allergies:'';
        var intol=patFoodIntolerance(MPB.patientId);
        sub.innerHTML= esc(patDisplayName(p))+' &middot; '+esc(patNo(p))
          +(p.age?(' &middot; '+esc(p.age)+'y'):'')+(p.gender?(' &middot; '+esc(p.gender)):'')
          +(allergies?(' &middot; <span style="color:#fecaca">Allergies: '+esc(allergies)+'</span>'):'')
          +(intol?(' &middot; <span style="color:#fde68a">Intolerance: '+esc(intol)+'</span>'):'');
      } else { sub.innerHTML='No patient selected'; }
    }
    bd.innerHTML =
      settingsHtml() +
      prescriptionHtml() +
      planHtml() +
      instructionsHtml();
    wireBody();
  }

  function settingsHtml(){
    // Step 1 — radio-button groups for Duration and Meal Pattern (per spec)
    var durOpts=[7,14,21,28].map(function(d){
      return '<label class="mpb-radio'+(MPB.days===d?' on':'')+'">'+
        '<input type="radio" name="mpb-days" value="'+d+'"'+(MPB.days===d?' checked':'')+'>'+
        '<span>'+d+' Days</span></label>';
    }).join('');
    var patOpts=Object.keys(PATTERNS).map(function(k){
      return '<label class="mpb-radio'+(MPB.pattern===k?' on':'')+'">'+
        '<input type="radio" name="mpb-pat" value="'+esc(k)+'"'+(MPB.pattern===k?' checked':'')+'>'+
        '<span>'+esc(PATTERN_LABEL[k])+'</span></label>';
    }).join('');
    return '<div class="mpb-sec"><h3><span class="n">1</span> Meal-Plan Settings</h3>'+
      '<div class="mpb-setgrid">'+
        '<div class="mpb-setblk"><label class="mpb-setlab">Meal Plan Duration</label><div class="mpb-radios" id="mpb-days">'+durOpts+'</div></div>'+
        '<div class="mpb-setblk"><label class="mpb-setlab">Meal Pattern</label><div class="mpb-radios mpb-radios-col" id="mpb-pat">'+patOpts+'</div></div>'+
      '</div>'+
      '<div class="mpb-row" style="margin-top:12px">'+
        '<div class="mpb-fld" style="flex:1;min-width:220px"><label>Diagnosis</label><input id="mpb-dx" value="'+esc(MPB.dx)+'" placeholder="e.g. Peptic ulcer disease"></div>'+
      '</div></div>';
  }

  function prescriptionHtml(){
    var t=MPB.target;
    return '<div class="mpb-sec"><h3><span class="n">–</span> Nutritional Prescription (targets)</h3>'+
      '<div class="mpb-row">'+
        '<div class="mpb-fld"><label>Calories (kcal)</label><input type="number" id="mpb-t-cal" value="'+num(t.calories)+'" style="width:120px"></div>'+
        '<div class="mpb-fld"><label>Protein (g)</label><input type="number" id="mpb-t-pro" value="'+num(t.proteinG)+'" style="width:100px"></div>'+
        '<div class="mpb-fld"><label>Carbs (g)</label><input type="number" id="mpb-t-carb" value="'+num(t.carbG)+'" style="width:100px"></div>'+
        '<div class="mpb-fld"><label>Fat (g)</label><input type="number" id="mpb-t-fat" value="'+num(t.fatG)+'" style="width:100px"></div>'+
        '<div class="mpb-fld"><label>Sodium (mg)</label><input type="number" id="mpb-t-na" value="'+num(t.sodiumMg)+'" style="width:110px"></div>'+
      '</div></div>';
  }

  function planHtml(){
    var meals=PATTERNS[MPB.pattern]||PATTERNS.BSLD;
    // day tabs
    var tabs='';
    for(var d=1; d<=MPB.days; d++){
      var t=dayTotals(d);
      var over = t.kcal>num(MPB.target.calories)*1.1;
      tabs+='<div class="mpb-daytab'+(MPB.activeDay===d?' on':'')+'" data-day="'+d+'">Day '+d+
            (over?'<span class="warn" title="Over calorie target">&#9888;</span>':'')+'</div>';
    }
    // meal cards for active day
    var cards=meals.map(function(m){
      var items=(MPB.grid[cellKey(MPB.activeDay,m)]||[]);
      var rows=items.map(function(it,i){
        var f=resolveItem(it); var nm=f?f.name:('#'+(it.foodId||''));
        var badge = (f&&f._custom)?' <span title="Custom food" style="font-size:9px;background:#e0f2fe;color:#0369a1;border-radius:4px;padding:1px 5px;vertical-align:middle">custom</span>':'';
        return '<div class="mpb-item"><span class="nm">'+esc(nm)+badge+'</span>'+
               '<input type="number" min="0.25" step="0.25" value="'+num(it.qty,1)+'" data-meal="'+esc(m)+'" data-idx="'+i+'" class="mpb-qty">'+
               '<button class="del" data-meal="'+esc(m)+'" data-idx="'+i+'" title="Remove">&times;</button></div>';
      }).join('') || '<div style="font-size:11px;color:#94a3b8;padding:4px 0">No foods yet</div>';
      var foodOpts='<option value="">+ add food…</option>'+foods().map(function(f){
        return '<option value="'+esc(f.id)+'">'+esc(f.name)+' ('+num(f.kcal)+' kcal)</option>';
      }).join('');
      return '<div class="mpb-meal"><div class="mh"><span>'+esc(m)+'</span></div><div class="mb">'+rows+
             '<div class="mpb-add"><select class="mpb-addsel" data-meal="'+esc(m)+'">'+foodOpts+'</select>'+
             '<button class="mpb-addbtn" data-meal="'+esc(m)+'">Add</button></div></div></div>';
    }).join('');
    // totals table for active day
    var t=dayTotals(MPB.activeDay), tg=MPB.target;
    function cmp(v,goal){ if(!goal) return ''; return v>goal*1.1?'over':(v>=goal*0.9?'ok':''); }
    var totRow='<table class="mpb-tot"><thead><tr><th class="lab">Day '+MPB.activeDay+' totals</th>'+
      '<th>Calories</th><th>Protein</th><th>Carbs</th><th>Fat</th><th>Sodium</th></tr></thead><tbody>'+
      '<tr><td class="lab">Actual</td>'+
        '<td class="'+cmp(t.kcal,tg.calories)+'">'+t.kcal+'</td>'+
        '<td class="'+cmp(t.protein,tg.proteinG)+'">'+t.protein+' g</td>'+
        '<td class="'+cmp(t.carbs,tg.carbG)+'">'+t.carbs+' g</td>'+
        '<td class="'+cmp(t.fat,tg.fatG)+'">'+t.fat+' g</td>'+
        '<td class="'+cmp(t.sodium,tg.sodiumMg)+'">'+t.sodium+' mg</td></tr>'+
      '<tr><td class="lab">Prescription</td><td>'+num(tg.calories)+'</td><td>'+num(tg.proteinG)+' g</td><td>'+num(tg.carbG)+' g</td><td>'+num(tg.fatG)+' g</td><td>'+num(tg.sodiumMg)+' mg</td></tr>'+
      '</tbody></table>';
    var avg=planAverage();
    var avgLine='<div style="font-size:11px;color:#475569;margin-top:8px">Plan average / day: <strong>'+avg.kcal+' kcal</strong>, '+avg.protein+'g protein, '+avg.carbs+'g carbs, '+avg.fat+'g fat, '+avg.sodium+'mg sodium.</div>';
    var isTable = MPB.view!=='cards';
    var toggle='<div class="mpb-viewtoggle">'+
      '<button id="mpb-view-table" class="'+(isTable?'on':'')+'">Table view</button>'+
      '<button id="mpb-view-cards" class="'+(!isTable?'on':'')+'">Day editor</button></div>';
    var editorBlock =
      '<div class="mpb-daytabs">'+tabs+'</div>'+
      '<div class="mpb-mealgrid">'+cards+'</div>'+
      totRow+avgLine;
    return '<div class="mpb-sec"><h3><span class="n">2</span> Day-by-Day Meal Plan &nbsp;<span style="font-weight:400;color:#64748b;font-size:12px">(Step 3: pick foods per cell &middot; Step 4: totals vs prescription)</span>'+toggle+'</h3>'+
      (isTable ? matrixHtml() : '') +
      editorBlock + '</div>';
  }

  /* Step 2 — full Day × meal matrix table (the auto-generated planner grid). */
  function matrixHtml(){
    var meals=PATTERNS[MPB.pattern]||PATTERNS.BSLD;
    var head='<tr><th>Day</th>'+meals.map(function(m){ return '<th>'+esc(m)+'</th>'; }).join('')+'<th>Calories</th></tr>';
    var rows='';
    for(var d=1; d<=MPB.days; d++){
      var cells=meals.map(function(m){
        var items=(MPB.grid[cellKey(d,m)]||[]);
        var chips=items.map(function(it){ var f=resolveItem(it); var q=num(it.qty,1); return '<span class="fchip">'+(f?esc(f.name):'#'+(it.foodId||''))+(q!==1?(' ×'+q):'')+'</span>'; }).join('');
        var actCls=(MPB.activeDay===d)?' act':'';
        return '<td class="mcell'+actCls+'" data-day="'+d+'" data-meal="'+esc(m)+'">'+(chips||'<span style="color:#cbd5e1">tap to add</span>')+'</td>';
      }).join('');
      var t=dayTotals(d);
      var over = num(MPB.target.calories) && t.kcal>num(MPB.target.calories)*1.1;
      rows+='<tr><td class="dcell'+(MPB.activeDay===d?' on':'')+'" data-day="'+d+'">Day '+d+'</td>'+cells+
            '<td class="kcalc"'+(over?' style="color:#dc2626"':'')+'>'+t.kcal+'</td></tr>';
    }
    return '<div class="mpb-matrix-wrap"><table class="mpb-matrix"><thead>'+head+'</thead><tbody>'+rows+'</tbody></table></div>'+
      '<div style="font-size:11px;color:#64748b;margin:0 0 12px">Click any Day or cell to edit its foods below.</div>';
  }

  function instructionsHtml(){
    var cats=Object.keys(INSTRUCTION_TEMPLATES).map(function(c){ return '<option value="'+esc(c)+'"'+(MPB.instrCategory===c?' selected':'')+'>'+esc(c)+'</option>'; }).join('');
    var cells=INSTRUCTION_SECTIONS.map(function(s){
      return '<div class="cell"><label>'+esc(s)+'</label><textarea class="mpb-instr-t" data-sec="'+esc(s)+'">'+esc(MPB.instructions[s]||'')+'</textarea></div>';
    }).join('');
    return '<div class="mpb-sec"><h3><span class="n">5</span> Patient Instructions</h3>'+
      '<div class="mpb-row" style="margin-bottom:12px">'+
        '<div class="mpb-fld"><label>Instruction Template</label><select id="mpb-instr-cat">'+cats+'</select></div>'+
        '<div class="mpb-fld"><label>&nbsp;</label><button class="mpb-btn sec" id="mpb-instr-apply">Load template</button></div>'+
      '</div>'+
      '<div class="mpb-instr">'+cells+'</div></div>';
  }

  /* ── event wiring ─────────────────────────────────────────────────────── */
  function readTargets(){
    function g(id){ var el=document.getElementById(id); return el?num(el.value):0; }
    MPB.target.calories=g('mpb-t-cal'); MPB.target.proteinG=g('mpb-t-pro');
    MPB.target.carbG=g('mpb-t-carb'); MPB.target.fatG=g('mpb-t-fat'); MPB.target.sodiumMg=g('mpb-t-na');
  }
  function readInstr(){
    document.querySelectorAll('.mpb-instr-t').forEach(function(t){ MPB.instructions[t.getAttribute('data-sec')]=t.value; });
    var dx=document.getElementById('mpb-dx'); if(dx) MPB.dx=dx.value;
  }

  function wireBody(){
    // Step 1 — duration radios
    document.querySelectorAll('input[name="mpb-days"]').forEach(function(r){
      r.onchange=function(){ if(this.checked){ MPB.days=num(this.value,14); if(MPB.activeDay>MPB.days) MPB.activeDay=1; renderBody(); } };
    });
    // Step 1 — meal-pattern radios (auto-regenerates the planner layout)
    document.querySelectorAll('input[name="mpb-pat"]').forEach(function(r){
      r.onchange=function(){ if(this.checked){ MPB.pattern=this.value; renderBody(); } };
    });
    var dx=document.getElementById('mpb-dx');
    if(dx) dx.onchange=function(){ MPB.dx=this.value; };
    ['mpb-t-cal','mpb-t-pro','mpb-t-carb','mpb-t-fat','mpb-t-na'].forEach(function(id){
      var el=document.getElementById(id); if(el) el.onchange=function(){ readTargets(); renderBody(); };
    });
    // view toggle (Table view / Day editor)
    var vt=document.getElementById('mpb-view-table');
    if(vt) vt.onclick=function(){ MPB.view='table'; renderBody(); };
    var vc=document.getElementById('mpb-view-cards');
    if(vc) vc.onclick=function(){ MPB.view='cards'; renderBody(); };
    // matrix: click a Day header cell → focus that day in the editor
    document.querySelectorAll('.mpb-matrix .dcell').forEach(function(c){
      c.onclick=function(){ MPB.activeDay=num(this.getAttribute('data-day'),1); MPB.view='cards'; renderBody(); };
    });
    // matrix: click any meal cell → open that day + scroll the meal editor
    document.querySelectorAll('.mpb-matrix td.mcell').forEach(function(c){
      c.onclick=function(){ MPB.activeDay=num(this.getAttribute('data-day'),1); MPB.view='cards'; renderBody(); };
    });
    // day tabs
    document.querySelectorAll('.mpb-daytab').forEach(function(t){
      t.onclick=function(){ MPB.activeDay=num(this.getAttribute('data-day'),1); renderBody(); };
    });
    // add food
    document.querySelectorAll('.mpb-addbtn').forEach(function(b){
      b.onclick=function(){
        var meal=this.getAttribute('data-meal');
        var sel=document.querySelector('.mpb-addsel[data-meal="'+cssEsc(meal)+'"]');
        if(!sel||!sel.value) return;
        var k=cellKey(MPB.activeDay,meal);
        (MPB.grid[k]=MPB.grid[k]||[]).push({foodId:sel.value, qty:1});
        renderBody();
      };
    });
    // qty change
    document.querySelectorAll('.mpb-qty').forEach(function(inp){
      inp.onchange=function(){
        var meal=this.getAttribute('data-meal'), idx=num(this.getAttribute('data-idx'),0);
        var arr=MPB.grid[cellKey(MPB.activeDay,meal)]; if(arr&&arr[idx]) arr[idx].qty=Math.max(0.25,num(this.value,1));
        renderBody();
      };
    });
    // delete item
    document.querySelectorAll('.mpb-item .del').forEach(function(b){
      b.onclick=function(){
        var meal=this.getAttribute('data-meal'), idx=num(this.getAttribute('data-idx'),0);
        var arr=MPB.grid[cellKey(MPB.activeDay,meal)]; if(arr){ arr.splice(idx,1); }
        renderBody();
      };
    });
    // instructions
    var cat=document.getElementById('mpb-instr-cat');
    if(cat) cat.onchange=function(){ MPB.instrCategory=this.value; };
    var apply=document.getElementById('mpb-instr-apply');
    if(apply) apply.onclick=function(){ var c=document.getElementById('mpb-instr-cat'); if(c) MPB.instrCategory=c.value; applyTemplate(); renderBody(); };
    document.querySelectorAll('.mpb-instr-t').forEach(function(t){
      t.onchange=function(){ MPB.instructions[t.getAttribute('data-sec')]=t.value; };
    });
  }
  function cssEsc(s){ return String(s).replace(/"/g,'\\"'); }

  /* ── save into D.mealPlans ────────────────────────────────────────────── */
  function collect(){
    readTargets(); readInstr();
    var avg=planAverage();
    var id = MPB.editId || ('MP'+Date.now());
    return {
      id: id,
      code: MPB.code || ('MP-'+String(id).replace(/^MP/,'')),
      type:'clinical',
      patientId: MPB.patientId,
      patientName: patName(),
      date: MPB.date || todayStr(),
      days: MPB.days,
      pattern: MPB.pattern,
      patternLabel: PATTERN_LABEL[MPB.pattern]||'',
      dx: MPB.dx,
      diagnosis: MPB.dx,           /* alias so patient-record panel (v200) shows the Dx */
      dietType: MPB.dx || 'Clinical Meal Plan',
      status: 'Active',
      target: Object.assign({}, MPB.target),
      /* planned = plan average, in the shape the patient-record panel expects */
      planned: { kcal:avg.kcal, calories:avg.kcal, protein:avg.protein, proteinG:avg.protein, carbs:avg.carbs, fat:avg.fat, sodium:avg.sodium },
      grid: JSON.parse(JSON.stringify(MPB.grid)),
      instrCategory: MPB.instrCategory,
      instructions: Object.assign({}, MPB.instructions),
      average: avg,
      createdBy: curU(), provider: curU(), createdRole: curR(),
      createdAt: MPB.editId? undefined : todayStr(),
      updatedAt: todayStr(),
      _rev: Date.now()
    };
  }
  /* link the saved plan into the EMR as a Diet Prescription visit so it surfaces in the patient record */
  function linkEmr(rec){
    try{
      var D=D_(); if(!Array.isArray(D.medicalRecords)) D.medicalRecords=[];
      var emrId='EMR-DIET-'+rec.id;
      var avg=rec.average||rec.planned||{};
      var summary=(rec.days+'-day '+(rec.patternLabel||rec.pattern)+' clinical meal plan. '
        +'Prescribed: '+num(rec.target&&rec.target.calories)+' kcal, '+num(rec.target&&rec.target.proteinG)+' g protein/day. '
        +'Plan avg: '+num(avg.kcal||avg.calories)+' kcal, '+num(avg.protein||avg.proteinG)+' g protein/day.');
      var e={
        id: emrId, code:'DIET-'+String(rec.id).replace(/^MP/,''),
        patientId: rec.patientId, patientName: rec.patientName,
        visitType:'Diet Prescription', source:'mealplanner', mealPlanId: rec.id,
        visitDate: rec.date||todayStr(), date: rec.date||todayStr(),
        diagnosis: rec.dx||rec.diagnosis||'', notes: summary, summary: summary,
        provider: rec.createdBy||curU(), createdBy: rec.createdBy||curU(),
        status:'Active', updatedAt: todayStr(), _rev: Date.now()
      };
      var i=D.medicalRecords.findIndex(function(r){ return String(r.id)===String(emrId); });
      if(i>=0){ e.createdAt=D.medicalRecords[i].createdAt||todayStr(); D.medicalRecords[i]=e; }
      else { e.createdAt=todayStr(); D.medicalRecords.push(e); }
    }catch(err){}
  }
  function doSave(){
    if(!MPB.patientId){ toastMsg('Select a patient first'); return; }
    var D=D_(); if(!Array.isArray(D.mealPlans)) D.mealPlans=[];
    var rec=collect();
    var idx=D.mealPlans.findIndex(function(m){return String(m.id)===String(rec.id);});
    if(idx>=0){ rec.createdAt=D.mealPlans[idx].createdAt||todayStr(); rec.code=D.mealPlans[idx].code||rec.code; rec.date=D.mealPlans[idx].date||rec.date; D.mealPlans[idx]=rec; }
    else { D.mealPlans.push(rec); }
    MPB.editId=rec.id; MPB.code=rec.code; MPB.date=rec.date;
    linkEmr(rec);
    save();
    toastMsg('Meal plan saved for '+rec.patientName);
  }

  window.__MPB_open=open;
  window.__MPB_collect=collect;

  /* ── Step 6: professional printed report ──────────────────────────────── */
  function printReport(){
    readTargets(); readInstr();
    var p=patObj(MPB.patientId)||{};
    var pAllergies=(p.allergies&&!/^none$/i.test(String(p.allergies).trim()))?p.allergies:'None reported';
    var pIntol=patFoodIntolerance(MPB.patientId)||'None reported';
    var pConsultant=patConsultant(MPB.patientId)||'—';
    var meals=PATTERNS[MPB.pattern]||PATTERNS.BSLD;
    var hosp='Tranquil Hospital & Wellness Centre';
    try{ if(D_().settings&&D_().settings.hospitalName) hosp=D_().settings.hospitalName; }catch(e){}
    // meal-plan table
    var thead='<tr><th>Day</th>'+meals.map(function(m){return '<th>'+esc(m)+'</th>';}).join('')+'<th>Calories</th></tr>';
    var body='';
    for(var d=1; d<=MPB.days; d++){
      var cells=meals.map(function(m){
        var items=(MPB.grid[cellKey(d,m)]||[]);
        var txt=items.map(function(it){ var f=resolveItem(it); var q=num(it.qty,1); return (f?esc(f.name):'#'+(it.foodId||''))+(q!==1?(' ×'+q):''); }).join('<br>');
        return '<td>'+(txt||'<span style="color:#999">—</span>')+'</td>';
      }).join('');
      var t=dayTotals(d);
      body+='<tr><td class="dayc">Day '+d+'</td>'+cells+'<td class="kc">'+t.kcal+'</td></tr>';
    }
    // instructions
    var instrRows=INSTRUCTION_SECTIONS.filter(function(s){ return (MPB.instructions[s]||'').trim(); })
      .map(function(s){ return '<tr><th>'+esc(s)+'</th><td>'+esc(MPB.instructions[s])+'</td></tr>'; }).join('');
    var tg=MPB.target;
    var css='body{font-family:Arial,Helvetica,sans-serif;color:#1e293b;margin:32px;font-size:12px}'+
      'h1{font-size:20px;margin:0;color:#0e7490}h2{font-size:14px;color:#0e7490;border-bottom:2px solid #0e7490;padding-bottom:4px;margin:22px 0 10px}'+
      '.hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #0e7490;padding-bottom:10px}'+
      '.meta{font-size:11px;color:#475569;text-align:right}'+
      'table{border-collapse:collapse;width:100%;font-size:11px}'+
      'th,td{border:1px solid #cbd5e1;padding:6px 8px;vertical-align:top;text-align:left}'+
      'th{background:#ecfeff}'+
      '.kv th{width:190px;background:#f1f5f9}'+
      '.plan th{background:#0e7490;color:#fff;text-align:center}.plan td{text-align:center}.plan .dayc{font-weight:700;background:#f1f5f9}.plan .kc{font-weight:700}'+
      '.sig{margin-top:48px;display:flex;justify-content:space-between}'+
      '.sig .box{width:45%}.sig .line{border-top:1px solid #334155;margin-top:40px;padding-top:4px;font-size:11px;color:#475569}'+
      '@media print{.noprint{display:none}}';
    var html='<!DOCTYPE html><html><head><meta charset="utf-8"><title>Clinical Meal Plan — '+esc(patName())+'</title><style>'+css+'</style></head><body>'+
      '<div class="hd"><div><h1>'+esc(hosp)+'</h1><div style="font-size:12px;color:#475569;margin-top:2px">Clinical Meal Plan &amp; Dietary Report</div></div>'+
      '<div class="meta">Report date: '+esc(MPB.date||todayStr())+'<br>Plan Code: '+esc(MPB.code||'—')+'<br>Prepared by: '+esc(curU()||'—')+'<br>'+esc(curR()||'Nutrition')+'</div></div>'+
      // patient details
      '<h2>Patient Details</h2><table class="kv">'+
        '<tr><th>Patient Name</th><td>'+esc(patDisplayName(p))+'</td></tr>'+
        '<tr><th>Hospital No. (MRN)</th><td>'+esc(patNo(p))+'</td></tr>'+
        '<tr><th>Age / Sex</th><td>'+esc((p.age||'—'))+' &nbsp;/&nbsp; '+esc(p.gender||'—')+'</td></tr>'+
        (p.bloodGroup?('<tr><th>Blood Group</th><td>'+esc(p.bloodGroup)+'</td></tr>'):'')+
        '<tr><th>Allergies</th><td>'+esc(pAllergies)+'</td></tr>'+
        '<tr><th>Food Intolerance</th><td>'+esc(pIntol)+'</td></tr>'+
        '<tr><th>Consultant Nutritionist / Wellness Officer</th><td>'+esc(pConsultant)+'</td></tr>'+
        (p.phone?('<tr><th>Phone</th><td>'+esc(p.phone)+'</td></tr>'):'')+
      '</table>'+
      // diagnosis
      '<h2>Diagnosis</h2><p>'+(MPB.dx?esc(MPB.dx):'<span style="color:#999">Not specified</span>')+'</p>'+
      // prescription
      '<h2>Nutritional Prescription</h2><table class="kv">'+
        '<tr><th>Daily Calories</th><td>'+num(tg.calories)+' kcal</td></tr>'+
        '<tr><th>Protein</th><td>'+num(tg.proteinG)+' g</td></tr>'+
        '<tr><th>Carbohydrates</th><td>'+num(tg.carbG)+' g</td></tr>'+
        '<tr><th>Fat</th><td>'+num(tg.fatG)+' g</td></tr>'+
        '<tr><th>Sodium</th><td>'+num(tg.sodiumMg)+' mg</td></tr>'+
        '<tr><th>Meal Pattern</th><td>'+esc(PATTERN_LABEL[MPB.pattern]||MPB.pattern)+'</td></tr>'+
      '</table>'+
      // meal plan
      '<h2>'+MPB.days+'-Day Meal Plan</h2><table class="plan"><thead>'+thead+'</thead><tbody>'+body+'</tbody></table>'+
      // instructions
      '<h2>Patient Instructions</h2>'+(instrRows?('<table class="kv">'+instrRows+'</table>'):'<p style="color:#999">No instructions.</p>')+
      // signature
      '<div class="sig"><div class="box"><div class="line">Nutritionist / Dietitian Signature &amp; Date</div></div>'+
      '<div class="box"><div class="line">Patient / Guardian Acknowledgement</div></div></div>'+
      '<div class="noprint" style="margin-top:24px;text-align:center"><button onclick="window.print()" style="background:#0891b2;color:#fff;border:none;border-radius:8px;padding:10px 24px;font-size:14px;cursor:pointer">Print / Save PDF</button></div>'+
      '</body></html>';
    var w=window.open('','_blank');
    if(!w){ toastMsg('Pop-up blocked — allow pop-ups to print'); return; }
    w.document.open(); w.document.write(html); w.document.close();
  }
  window.__MPB_printReport=printReport;

  /* ── launcher: add a button to the Meal Planner page + patient chooser ─── */
  function pickPatientThenOpen(){
    // If a global "current patient" exists, use it; otherwise prompt with a small chooser
    var D=D_(); var pats=(D.patients||[]);
    if(!pats.length){ toastMsg('No patients in the system'); return; }
    ensureStyles();
    var ov=document.createElement('div'); ov.className='mpb-ov'; ov.style.zIndex='99991';
    var opts=pats.slice(0,1000).map(function(p){ return '<option value="'+esc(p.id)+'">'+esc(patDisplayName(p))+' ('+esc(patNo(p))+')</option>'; }).join('');
    ov.innerHTML='<div class="mpb-modal" style="width:min(460px,94vw)">'+
      '<div class="mpb-hd"><div><h2><i class="fa fa-utensils"></i> Select Patient</h2></div><button class="mpb-x">&times;</button></div>'+
      '<div class="mpb-bd"><div class="mpb-fld"><label>Patient</label><select id="mpb-pick" style="width:100%">'+opts+'</select></div></div>'+
      '<div class="mpb-ft"><button class="mpb-btn sec" id="mpb-pick-x">Cancel</button><button class="mpb-btn gr" id="mpb-pick-go">Open Builder</button></div></div>';
    document.body.appendChild(ov);
    function kill(){ ov.remove(); }
    ov.querySelector('.mpb-x').onclick=kill; ov.querySelector('#mpb-pick-x').onclick=kill;
    ov.addEventListener('mousedown',function(e){ if(e.target===ov) kill(); });
    ov.querySelector('#mpb-pick-go').onclick=function(){ var v=ov.querySelector('#mpb-pick').value; kill(); open(v); };
  }
  window.__MPB_pick=pickPatientThenOpen;

  function wrapRender(){
    if(typeof window.renderMealPlannerModule!=='function' || window.renderMealPlannerModule.__mpbWrapped) return;
    var orig=window.renderMealPlannerModule;
    var wrapped=function(){
      var html=orig.apply(this,arguments);
      try{
        // clinical plans list
        var D=D_(); var cps=(D.mealPlans||[]).filter(function(m){return m&&m.type==='clinical';}).slice().reverse();
        var crows=cps.length? cps.map(function(m){
          var a=m.average||{};
          return '<tr><td>'+esc(m.patientName||'')+'</td><td>'+esc(m.days||'')+'-day</td><td>'+esc(m.patternLabel||m.pattern||'')+'</td>'+
            '<td>'+esc(a.kcal||0)+' kcal avg</td><td>'+esc(m.updatedAt||m.createdAt||'')+'</td>'+
            '<td><button class="btn btn-ghost" style="padding:3px 10px" onclick="window.__MPB_openEdit(\''+esc(m.id)+'\')"><i class="fa-solid fa-pen"></i> Edit</button> '+
            '<button class="btn btn-ghost" style="padding:3px 10px" onclick="window.__MPB_printSaved(\''+esc(m.id)+'\')"><i class="fa-solid fa-print"></i></button></td></tr>';
        }).join('') : '<tr><td colspan="6" style="color:var(--txt3);font-style:italic">No clinical meal plans yet. Click "Clinical Meal Plan Builder".</td></tr>';
        var banner='<div class="card" style="margin-bottom:14px;display:flex;justify-content:space-between;align-items:center;border-left:4px solid #0891b2">'+
          '<div><h3 style="margin:0"><i class="fa-solid fa-clipboard-list" style="color:#0891b2"></i> Clinical Meal Plan Builder</h3>'+
          '<div style="font-size:12px;color:var(--txt2)">Structured, patient-specific multi-day plan (7/14/21/28 days) with patient instructions &amp; printable report.</div></div>'+
          '<button class="btn btn-pri" onclick="window.__MPB_pick()" style="background:#0891b2"><i class="fa-solid fa-plus"></i> Clinical Meal Plan Builder</button></div>'+
          '<div class="card" style="margin-bottom:14px"><h4 style="margin:0 0 8px"><i class="fa-solid fa-clipboard-list" style="color:#0891b2"></i> Clinical Meal Plans</h4>'+
          '<table class="tbl"><thead><tr><th>Patient</th><th>Duration</th><th>Pattern</th><th>Avg</th><th>Updated</th><th></th></tr></thead><tbody>'+crows+'</tbody></table></div>';
        return banner + html;
      }catch(e){ return html; }
    };
    wrapped.__mpbWrapped=true;
    window.renderMealPlannerModule=wrapped;
  }

  window.__MPB_openEdit=function(id){
    var D=D_(); var m=(D.mealPlans||[]).find(function(x){return String(x.id)===String(id);});
    if(!m){ toastMsg('Plan not found'); return; }
    open(m.patientId);
    // populate state after open reset
    MPB.editId=m.id; MPB.code=m.code||''; MPB.date=m.date||''; MPB.days=m.days||14; MPB.pattern=m.pattern||'BSLD';
    MPB.grid=JSON.parse(JSON.stringify(m.grid||{})); MPB.dx=m.dx||m.diagnosis||'';
    MPB.target=Object.assign({calories:2000,proteinG:70,carbG:250,fatG:65,sodiumMg:2000}, m.target||{});
    MPB.instrCategory=m.instrCategory||'General Wellness';
    MPB.instructions=Object.assign({}, m.instructions||{});
    MPB.activeDay=1; renderBody();
  };
  window.__MPB_printSaved=function(id){
    var D=D_(); var m=(D.mealPlans||[]).find(function(x){return String(x.id)===String(id);});
    if(!m){ toastMsg('Plan not found'); return; }
    // hydrate state then print
    MPB.patientId=m.patientId; MPB.code=m.code||''; MPB.date=m.date||''; MPB.days=m.days||14; MPB.pattern=m.pattern||'BSLD';
    MPB.grid=JSON.parse(JSON.stringify(m.grid||{})); MPB.dx=m.dx||m.diagnosis||'';
    MPB.target=Object.assign({calories:2000,proteinG:70,carbG:250,fatG:65,sodiumMg:2000}, m.target||{});
    MPB.instrCategory=m.instrCategory||'General Wellness';
    MPB.instructions=Object.assign({}, m.instructions||{});
    printReport();
  };

  // Wrap now and also whenever the module re-registers
  wrapRender();
  var _tries=0, _iv=setInterval(function(){ wrapRender(); if(++_tries>40) clearInterval(_iv); },500);

  console.log('%c✅ v195 Clinical Meal Plan Builder loaded','color:#0891b2;font-weight:bold');
})();

;

/* ==== /js/148-twh-github-export-v196.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v196 — GITHUB DATA EXPORT + CLINICAL AUDIT COVERAGE
   • "Save to GitHub" — commits the full workspace state + audit trail +
     a searchable README to the configured GitHub repo (via /api/export).
     Fulfils "save all transaction data on GitHub for easy share & search".
   • Ensures meal-plan & wellness saves trigger an immediate audit capture
     so create/edit/delete of those records land in Cloudflare D1 (hms_audit)
     and are included in the GitHub export.
   Idempotent, guarded by __twhV196.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV196) return; window.__twhV196 = true;

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function toastMsg(m){ try{ if(typeof toast==='function') toast(m); }catch(e){} }

  var STATE_ENDPOINT = window._HMS_API_ENDPOINT || ('/api/state/'+(window._HMS_STORAGE_KEY||'MCP_HMS_DATA_v17'));
  var EXPORT_ENDPOINT = STATE_ENDPOINT.replace('/api/state/','/api/export/');

  // Save everything first (state + audit), then ask the server to snapshot to GitHub.
  window.exportToGitHub = function(note){
    return new Promise(function(resolve){
      // 1) flush local state + audit so the server has the freshest data
      try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
      try{ if(window._hmsAuditFlush) window._hmsAuditFlush(); }catch(e){}
      // 2) trigger the server-side GitHub commit (give the flush ~600ms to land)
      setTimeout(function(){
        fetch(EXPORT_ENDPOINT, {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({ note: note||'' }),
          credentials:'include', cache:'no-store'
        }).then(function(r){ return r.json().then(function(j){ return {status:r.status, j:j}; }); })
          .then(function(res){ resolve(res); })
          .catch(function(err){ resolve({ status:0, j:{ ok:false, error:String(err) } }); });
      }, 600);
    });
  };

  // Check whether GitHub export is configured on the server.
  window.githubExportStatus = function(){
    return fetch(EXPORT_ENDPOINT, { credentials:'include', cache:'no-store' })
      .then(function(r){ return r.json(); }).catch(function(){ return {configured:false}; });
  };

  // ── UI: a small dialog to run the export and show the resulting GitHub links.
  window.showGitHubExport = function(){
    var id='ghExportModal';
    var old=document.getElementById(id); if(old) old.remove();
    var wrap=document.createElement('div'); wrap.id=id;
    wrap.style.cssText='position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:100000;display:flex;align-items:flex-start;justify-content:center;padding:48px 16px;overflow:auto;';
    wrap.innerHTML=
      '<div style="background:#fff;border-radius:14px;max-width:560px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);overflow:hidden">'+
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 22px;background:linear-gradient(135deg,#111827,#374151);color:#fff">'+
          '<div style="font-size:17px;font-weight:700"><i class="fa-brands fa-github"></i>&nbsp; Save data to GitHub</div>'+
          '<button onclick="document.getElementById(\''+id+'\').remove()" style="background:rgba(255,255,255,.2);border:none;color:#fff;width:34px;height:34px;border-radius:8px;cursor:pointer;font-size:16px">&times;</button>'+
        '</div>'+
        '<div style="padding:18px 22px" id="ghExportBody">'+
          '<div style="font-size:13px;color:#475569;margin-bottom:12px">Commits the full workspace state, the complete audit trail (who created / edited / deleted every record), and a searchable summary to your GitHub repository — for durable backup, easy sharing and full-text search.</div>'+
          '<label style="font-size:12px;font-weight:600;color:#475569">Note (optional)</label>'+
          '<input id="ghExportNote" placeholder="e.g. End-of-day backup" style="width:100%;padding:9px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;margin:4px 0 14px">'+
          '<div id="ghExportStatus" style="font-size:12.5px;color:#64748b;margin-bottom:12px">Checking configuration…</div>'+
          '<div style="display:flex;gap:8px">'+
            '<button id="ghExportGo" style="padding:9px 18px;background:#111827;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:600"><i class="fa-brands fa-github"></i> Save to GitHub</button>'+
            '<button onclick="document.getElementById(\''+id+'\').remove()" style="padding:9px 16px;background:#e5e7eb;color:#111827;border:none;border-radius:8px;cursor:pointer;font-weight:600">Close</button>'+
          '</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function(e){ if(e.target===wrap) wrap.remove(); });

    var statusEl=document.getElementById('ghExportStatus');
    var goBtn=document.getElementById('ghExportGo');
    window.githubExportStatus().then(function(s){
      if(s && s.configured){
        statusEl.innerHTML='<span style="color:#16a34a"><i class="fa-solid fa-circle-check"></i> Connected to <b>'+esc(s.repo||'')+'</b> ('+esc(s.branch||'main')+')</span>';
      } else {
        statusEl.innerHTML='<span style="color:#b45309"><i class="fa-solid fa-triangle-exclamation"></i> GitHub export is not configured yet. An administrator must set <code>GITHUB_TOKEN</code> and <code>GITHUB_EXPORT_REPO</code> in the Cloudflare Pages project.</span>';
        goBtn.disabled=true; goBtn.style.opacity='.5'; goBtn.style.cursor='not-allowed';
      }
    });

    goBtn.onclick=function(){
      var note=(document.getElementById('ghExportNote')||{}).value||'';
      goBtn.disabled=true; goBtn.innerHTML='<i class="fa-solid fa-spinner fa-spin"></i> Saving…';
      var body=document.getElementById('ghExportBody');
      window.exportToGitHub(note).then(function(res){
        var j=res.j||{};
        if(j.ok){
          body.innerHTML='<div style="text-align:center;padding:10px 0">'+
            '<div style="font-size:40px;color:#16a34a;margin-bottom:8px"><i class="fa-solid fa-circle-check"></i></div>'+
            '<div style="font-weight:700;font-size:15px;margin-bottom:6px">Saved to GitHub</div>'+
            '<div style="font-size:12.5px;color:#475569;margin-bottom:14px">Committed at '+esc(j.exportedAt||'')+' to <b>'+esc(j.repo||'')+'</b></div>'+
            '<div style="display:flex;flex-direction:column;gap:6px;text-align:left;font-size:13px">'+
              (j.files&&j.files.readme?'<a href="'+esc(j.files.readme)+'" target="_blank" rel="noopener"><i class="fa-solid fa-file-lines"></i> Searchable summary (README.md)</a>':'')+
              (j.files&&j.files.state?'<a href="'+esc(j.files.state)+'" target="_blank" rel="noopener"><i class="fa-solid fa-database"></i> Full state snapshot (JSON)</a>':'')+
              (j.files&&j.files.audit?'<a href="'+esc(j.files.audit)+'" target="_blank" rel="noopener"><i class="fa-solid fa-clipboard-list"></i> Audit trail (JSON)</a>':'')+
              (j.commit?'<a href="'+esc(j.commit)+'" target="_blank" rel="noopener"><i class="fa-brands fa-github"></i> View commit</a>':'')+
            '</div>'+
            '<button onclick="document.getElementById(\''+id+'\').remove()" style="margin-top:16px;padding:9px 18px;background:#111827;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:600">Done</button>'+
          '</div>';
          toastMsg('Data saved to GitHub');
        } else {
          var msg = (j.message||j.hint||j.error||('HTTP '+res.status)) ;
          body.innerHTML='<div style="padding:6px 0">'+
            '<div style="color:#b91c1c;font-weight:700;margin-bottom:8px"><i class="fa-solid fa-triangle-exclamation"></i> Could not save to GitHub</div>'+
            '<div style="font-size:13px;color:#475569;margin-bottom:14px">'+esc(msg)+'</div>'+
            '<button onclick="document.getElementById(\''+id+'\').remove()" style="padding:9px 16px;background:#e5e7eb;color:#111827;border:none;border-radius:8px;cursor:pointer;font-weight:600">Close</button>'+
          '</div>';
        }
      });
    };
  };

  // ── Add a "GitHub" button into the audit-log modal header when it opens.
  function decorateAuditModal(){
    try{
      var modal=document.getElementById('auditModalBg'); if(!modal) return;
      var hd=modal.querySelector('div[style*="linear-gradient"]');
      if(!hd || hd.querySelector('.v196-gh-btn')) return;
      var btn=document.createElement('button');
      btn.className='v196-gh-btn';
      btn.title='Save all data to GitHub for backup, sharing & search';
      btn.style.cssText='background:rgba(255,255,255,.2);border:none;color:#fff;padding:7px 12px;border-radius:8px;cursor:pointer;font-weight:600;font-size:12.5px;margin-right:8px';
      btn.innerHTML='<i class="fa-brands fa-github"></i> Save to GitHub';
      btn.onclick=function(){ if(window.showGitHubExport) window.showGitHubExport(); };
      var closeBtn=hd.querySelector('button');
      if(closeBtn) hd.insertBefore(btn, closeBtn); else hd.appendChild(btn);
    }catch(e){}
  }
  DOMBus.register(decorateAuditModal);

  // ── Belt-and-suspenders: after meal-plan / wellness saves, capture audit + save.
  function hookAfter(fnName){
    var orig=window[fnName];
    if(typeof orig!=='function' || orig.__v196Hooked) return;
    var wrapped=function(){
      var r=orig.apply(this, arguments);
      try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
      try{ if(window._hmsAuditFlush) setTimeout(window._hmsAuditFlush, 1500); }catch(e){}
      return r;
    };
    wrapped.__v196Hooked=true;
    try{ window[fnName]=wrapped; }catch(e){}
  }
  ['wSaveL3','mpSave','doSave','wSaveL1','wSaveL2'].forEach(hookAfter);
  [500,1500,3000,6000].forEach(function(t){ setTimeout(function(){ ['wSaveL3','mpSave','doSave','wSaveL1','wSaveL2'].forEach(hookAfter); }, t); });

  console.log('%c✅ v196 — GitHub export + clinical audit coverage loaded','color:#111827;font-weight:bold;background:#e5e7eb;padding:2px 8px;border-radius:6px');
})();

;

/* ==== /js/149-twh-github-import-v197.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v197 — BIDIRECTIONAL GITHUB SYNC (PULL / RESTORE + CONTINUOUS AUTO-COMMIT)
   Fulfils: "All transactions (create, edit, delete etc) created on the
   application should be stored on GitHub and easily pulled back into the
   system."
   • Pull / Restore — previews the GitHub snapshot (record counts, when it was
     exported, audit entries) then pulls it back into the live system via
     /api/import, in either MERGE (safe, _rev-newest-wins) or REPLACE mode.
   • Continuous auto-commit — after transactions are audited & flushed, a
     debounced + throttled background export keeps GitHub continuously in sync
     with every create / edit / delete (not just manual saves).
   • Adds a "Pull from GitHub" button next to v196's "Save to GitHub" in the
     audit-log modal, and an auto-sync toggle.
   Idempotent, guarded by __twhV197.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV197) return; window.__twhV197 = true;

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function toastMsg(m){ try{ if(typeof toast==='function') toast(m); }catch(e){} }

  var STATE_ENDPOINT  = window._HMS_API_ENDPOINT || ('/api/state/'+(window._HMS_STORAGE_KEY||'MCP_HMS_DATA_v17'));
  var IMPORT_ENDPOINT = STATE_ENDPOINT.replace('/api/state/','/api/import/');

  // ── Preview what is available on GitHub for this workspace. ───────────────
  window.githubImportPreview = function(){
    return fetch(IMPORT_ENDPOINT, { credentials:'include', cache:'no-store' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return { configured:false, found:false }; });
  };

  // ── Pull the GitHub snapshot back into D1. mode: 'merge' | 'replace'. ─────
  window.importFromGitHub = function(mode){
    return fetch(IMPORT_ENDPOINT, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({ mode: (mode==='replace'?'replace':'merge') }),
      credentials:'include', cache:'no-store'
    }).then(function(r){ return r.json().then(function(j){ return {status:r.status, j:j}; }); })
      .catch(function(err){ return { status:0, j:{ ok:false, error:String(err) } }; });
  };

  function fmtWhen(iso){
    if(!iso) return 'unknown';
    try{ return new Date(iso).toLocaleString(); }catch(e){ return String(iso); }
  }
  function countRows(counts){
    if(!counts) return '';
    var keys=Object.keys(counts).filter(function(k){ return counts[k]>0; })
      .sort(function(a,b){ return counts[b]-counts[a]; });
    if(!keys.length) return '<div style="color:#94a3b8">No records in the snapshot.</div>';
    return '<div style="display:grid;grid-template-columns:1fr auto;gap:2px 14px;max-height:190px;overflow:auto;font-size:12.5px;border:1px solid #e2e8f0;border-radius:8px;padding:10px 12px">'+
      keys.map(function(k){ return '<div style="color:#475569">'+esc(k)+'</div><div style="text-align:right;font-weight:600">'+counts[k]+'</div>'; }).join('')+
      '</div>';
  }

  // ── UI: Pull / Restore dialog. ────────────────────────────────────────────
  window.showGitHubImport = function(){
    var id='ghImportModal';
    var old=document.getElementById(id); if(old) old.remove();
    var wrap=document.createElement('div'); wrap.id=id;
    wrap.style.cssText='position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:100001;display:flex;align-items:flex-start;justify-content:center;padding:48px 16px;overflow:auto;';
    wrap.innerHTML=
      '<div style="background:#fff;border-radius:14px;max-width:580px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.3);overflow:hidden">'+
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 22px;background:linear-gradient(135deg,#0f766e,#0d9488);color:#fff">'+
          '<div style="font-size:17px;font-weight:700"><i class="fa-solid fa-cloud-arrow-down"></i>&nbsp; Pull / Restore from GitHub</div>'+
          '<button onclick="document.getElementById(\''+id+'\').remove()" style="background:rgba(255,255,255,.2);border:none;color:#fff;width:34px;height:34px;border-radius:8px;cursor:pointer;font-size:16px">&times;</button>'+
        '</div>'+
        '<div style="padding:18px 22px" id="ghImportBody">'+
          '<div style="font-size:13px;color:#475569;margin-bottom:12px">Pulls the workspace snapshot stored on GitHub back into this system. Every transaction (create / edit / delete) is restored.</div>'+
          '<div id="ghImportStatus" style="font-size:12.5px;color:#64748b;margin-bottom:12px">Checking GitHub…</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function(e){ if(e.target===wrap) wrap.remove(); });

    var statusEl=document.getElementById('ghImportStatus');
    var bodyEl=document.getElementById('ghImportBody');

    window.githubImportPreview().then(function(s){
      if(!s || !s.configured){
        statusEl.innerHTML='<span style="color:#b45309"><i class="fa-solid fa-triangle-exclamation"></i> GitHub is not configured yet. An administrator must set <code>GITHUB_TOKEN</code> and <code>GITHUB_EXPORT_REPO</code> in the Cloudflare Pages project.</span>';
        return;
      }
      if(!s.found){
        statusEl.innerHTML='<span style="color:#b45309"><i class="fa-solid fa-circle-info"></i> No snapshot found on <b>'+esc(s.repo||'')+'</b> yet. Use <b>Save to GitHub</b> first to create one.</span>';
        return;
      }
      var total=0; if(s.counts){ Object.keys(s.counts).forEach(function(k){ total+=s.counts[k]||0; }); }
      bodyEl.innerHTML=
        '<div style="font-size:13px;color:#475569;margin-bottom:12px">Pulls the workspace snapshot stored on GitHub back into this system. Every transaction (create / edit / delete) is restored.</div>'+
        '<div style="font-size:12.5px;color:#16a34a;margin-bottom:10px"><i class="fa-solid fa-circle-check"></i> Snapshot on <b>'+esc(s.repo||'')+'</b> ('+esc(s.branch||'main')+')</div>'+
        '<div style="font-size:12.5px;color:#475569;margin-bottom:4px">Exported: <b>'+esc(fmtWhen(s.exportedAt))+'</b> &nbsp;·&nbsp; '+total+' records &nbsp;·&nbsp; '+(s.auditCount||0)+' audit entries</div>'+
        '<div style="margin:8px 0 14px">'+countRows(s.counts)+'</div>'+
        '<label style="font-size:12px;font-weight:600;color:#475569;display:block;margin-bottom:6px">Restore mode</label>'+
        '<label style="display:block;font-size:13px;margin-bottom:6px;cursor:pointer"><input type="radio" name="ghImpMode" value="merge" checked> <b>Merge</b> — combine with current data (newest edit wins). Safe; nothing newer here is lost.</label>'+
        '<label style="display:block;font-size:13px;margin-bottom:14px;cursor:pointer"><input type="radio" name="ghImpMode" value="replace"> <b>Replace</b> — discard current data and restore exactly what is on GitHub.</label>'+
        '<div style="display:flex;gap:8px">'+
          '<button id="ghImportGo" style="padding:9px 18px;background:#0d9488;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:600"><i class="fa-solid fa-cloud-arrow-down"></i> Pull into system</button>'+
          '<button onclick="document.getElementById(\''+id+'\').remove()" style="padding:9px 16px;background:#e5e7eb;color:#111827;border:none;border-radius:8px;cursor:pointer;font-weight:600">Cancel</button>'+
        '</div>';

      document.getElementById('ghImportGo').onclick=function(){
        var mode=(document.querySelector('input[name="ghImpMode"]:checked')||{}).value||'merge';
        if(mode==='replace' && !window.confirm('Replace ALL current data with the GitHub snapshot? This cannot be undone.')) return;
        var go=document.getElementById('ghImportGo');
        go.disabled=true; go.innerHTML='<i class="fa-solid fa-spinner fa-spin"></i> Pulling…';
        window.importFromGitHub(mode).then(function(res){
          var j=res.j||{};
          if(j.ok){
            var tot=0; if(j.counts){ Object.keys(j.counts).forEach(function(k){ tot+=j.counts[k]||0; }); }
            bodyEl.innerHTML='<div style="text-align:center;padding:10px 0">'+
              '<div style="font-size:40px;color:#0d9488;margin-bottom:8px"><i class="fa-solid fa-circle-check"></i></div>'+
              '<div style="font-weight:700;font-size:15px;margin-bottom:6px">Restored from GitHub</div>'+
              '<div style="font-size:12.5px;color:#475569;margin-bottom:14px">'+esc(mode==='replace'?'Replaced':'Merged')+' '+tot+' records'+(j.auditRestored?(' · '+j.auditRestored+' audit entries added'):'')+'. Reloading…</div>'+
            '</div>';
            toastMsg('Data pulled from GitHub — reloading');
            // Reload so the freshly-restored server state becomes the source of truth
            // (avoids stale local D merging back over a replace/restore).
            setTimeout(function(){ try{ location.reload(); }catch(e){} }, 1400);
          } else {
            var msg=(j.message||j.hint||j.error||j.reason||('HTTP '+res.status));
            bodyEl.innerHTML='<div style="padding:6px 0">'+
              '<div style="color:#b91c1c;font-weight:700;margin-bottom:8px"><i class="fa-solid fa-triangle-exclamation"></i> Could not pull from GitHub</div>'+
              '<div style="font-size:13px;color:#475569;margin-bottom:14px">'+esc(msg)+'</div>'+
              '<button onclick="document.getElementById(\''+id+'\').remove()" style="padding:9px 16px;background:#e5e7eb;color:#111827;border:none;border-radius:8px;cursor:pointer;font-weight:600">Close</button>'+
            '</div>';
          }
        });
      };
    });
  };

  // ── Add a "Pull from GitHub" button into the audit-log modal header. ──────
  function decorateAuditModalImport(){
    try{
      var modal=document.getElementById('auditModalBg'); if(!modal) return;
      var hd=modal.querySelector('div[style*="linear-gradient"]');
      if(!hd || hd.querySelector('.v197-gh-pull-btn')) return;
      var btn=document.createElement('button');
      btn.className='v197-gh-pull-btn';
      btn.title='Pull the GitHub snapshot back into the system (restore)';
      btn.style.cssText='background:rgba(255,255,255,.2);border:none;color:#fff;padding:7px 12px;border-radius:8px;cursor:pointer;font-weight:600;font-size:12.5px;margin-right:8px';
      btn.innerHTML='<i class="fa-solid fa-cloud-arrow-down"></i> Pull from GitHub';
      btn.onclick=function(){ if(window.showGitHubImport) window.showGitHubImport(); };
      // Place it just before v196's "Save to GitHub" button if present, else before close.
      var saveBtn=hd.querySelector('.v196-gh-btn');
      if(saveBtn) hd.insertBefore(btn, saveBtn);
      else { var closeBtn=hd.querySelector('button'); if(closeBtn) hd.insertBefore(btn, closeBtn); else hd.appendChild(btn); }
    }catch(e){}
  }
  DOMBus.register(decorateAuditModalImport);

  // ══════════════════════════════════════════════════════════════════════════
  //  CONTINUOUS AUTO-COMMIT TO GITHUB
  //  After transactions are audited & flushed to Cloudflare, schedule a
  //  debounced + throttled background export so GitHub stays continuously in
  //  sync with every create/edit/delete. Throttled to avoid hammering the API.
  // ══════════════════════════════════════════════════════════════════════════
  var AUTOSYNC_KEY='twhGithubAutoSync';
  var MIN_INTERVAL_MS=90*1000;   // never commit more than once every 90s
  var DEBOUNCE_MS=8*1000;        // wait 8s of quiet after the last change
  var _lastPush=0, _debTimer=null, _pushInFlight=false, _configuredCache=null;

  function autoSyncOn(){
    try{ return localStorage.getItem(AUTOSYNC_KEY)==='1'; }catch(e){ return false; }
  }
  window.setGithubAutoSync=function(on){
    try{ localStorage.setItem(AUTOSYNC_KEY, on?'1':'0'); }catch(e){}
    toastMsg(on?'Auto-sync to GitHub enabled':'Auto-sync to GitHub disabled');
  };
  window.githubAutoSyncEnabled=autoSyncOn;

  function ensureConfigured(){
    if(_configuredCache!==null) return Promise.resolve(_configuredCache);
    if(typeof window.githubExportStatus!=='function') return Promise.resolve(false);
    return window.githubExportStatus().then(function(s){
      _configuredCache=!!(s&&s.configured); return _configuredCache;
    }).catch(function(){ return false; });
  }

  function doAutoPush(){
    if(_pushInFlight) return;
    if(typeof window.exportToGitHub!=='function') return;
    _pushInFlight=true; _lastPush=Date.now();
    window.exportToGitHub('Auto-sync: transaction update').then(function(res){
      _pushInFlight=false;
      var j=(res&&res.j)||{};
      if(j.ok){ try{ console.log('%c⭑ v197 auto-committed transactions to GitHub','color:#0d9488'); }catch(e){} }
    }).catch(function(){ _pushInFlight=false; });
  }

  window.scheduleGithubAutoSync=function(){
    if(!autoSyncOn()) return;
    ensureConfigured().then(function(ok){
      if(!ok) return;
      if(_debTimer) clearTimeout(_debTimer);
      var sinceLast=Date.now()-_lastPush;
      var wait=Math.max(DEBOUNCE_MS, MIN_INTERVAL_MS-sinceLast);
      _debTimer=setTimeout(function(){ _debTimer=null; doAutoPush(); }, wait);
    });
  };

  // Hook the audit flush so a successful transaction flush also (eventually)
  // pushes to GitHub. We wrap _hmsAuditFlush without breaking its behaviour.
  function hookAuditFlush(){
    var orig=window._hmsAuditFlush;
    if(typeof orig!=='function' || orig.__v197Hooked) return;
    var wrapped=function(){
      var r;
      try{ r=orig.apply(this, arguments); }catch(e){}
      try{ window.scheduleGithubAutoSync(); }catch(e){}
      return r;
    };
    wrapped.__v197Hooked=true;
    try{ window._hmsAuditFlush=wrapped; }catch(e){}
  }
  hookAuditFlush();
  [500,1500,3000,6000].forEach(function(t){ setTimeout(hookAuditFlush, t); });

  // Also flush any pending auto-sync before the tab unloads (best-effort).
  window.addEventListener('beforeunload', function(){
    try{
      if(autoSyncOn() && _debTimer && !_pushInFlight){
        clearTimeout(_debTimer); _debTimer=null; doAutoPush();
      }
    }catch(e){}
  });

  console.log('%c✅ v197 — bidirectional GitHub sync (pull/restore + auto-commit) loaded','color:#0d9488;font-weight:bold;background:#ccfbf1;padding:2px 8px;border-radius:6px');
})();

;

/* ==== /js/150-twh-chunked-upload-v199.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v199 — BULLETPROOF CHUNKED UPLOAD SYSTEM
   ────────────────────────────────────────────────────────────────────────
   Rewrites the save transport into a resilient, chunked uploader:
     1. Intelligent chunking — payload split into <=900 KB chunks under one
        uploadSessionId (headroom below Cloudflare's 1 MB limit).
     2. Resilient sender — per-chunk exponential backoff (1s→30s, x2). After
        5 failures for a chunk it PAUSES, persists progress to localStorage,
        and surfaces a "Resume" button. A live progress bar shows
        "Uploading chunk 4/20…".
     3. Idempotent receiver — POST /api/chunked/:ws stages each chunk
        (session:index) and returns 202 for intermediate chunks, 200 only
        after the final chunk assembles + the atomic DB save succeeds.
     4. Recovery & fallback — if the endpoint is down (repeated 503/network),
        the whole payload is saved to localStorage and queued; it auto-syncs
        when connectivity returns (online event + periodic retry).

   The existing per-key delta writer (v198) still handles tiny saves fast;
   this system takes over for large saves and for any save the delta writer
   couldn't complete — so no transaction is ever lost and the "Sync error"
   can no longer strand the app. Idempotent, guarded by __twhV199.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV199) return; window.__twhV199 = true;

  var STORAGE_KEY  = window._HMS_STORAGE_KEY || 'MCP_HMS_DATA_v17';
  var STATE_EP     = window._HMS_API_ENDPOINT || ('/api/state/'+encodeURIComponent(STORAGE_KEY));
  var CHUNKED_EP   = STATE_EP.replace('/api/state/','/api/chunked/');

  var CHUNK_SIZE      = 900 * 1024;   // 900 KB per chunk (spec)
  var MAX_RETRIES     = 5;            // per-chunk attempts before pausing
  var BACKOFF_START   = 1000;         // 1s
  var BACKOFF_MAX     = 30000;        // 30s cap
  var FALLBACK_503S   = 3;            // consecutive 503/network → localStorage fallback
  var LS_QUEUE_KEY    = 'twhChunkedQueue_'+STORAGE_KEY;   // fallback sync queue
  var LS_RESUME_KEY   = 'twhChunkedResume_'+STORAGE_KEY;  // paused-session progress

  function log(){ try{ var a=['%c[chunked v199]','color:#0d9488;font-weight:bold'].concat([].slice.call(arguments)); console.log.apply(console,a); }catch(e){} }
  function warn(){ try{ console.warn.apply(console,['[chunked v199]'].concat([].slice.call(arguments))); }catch(e){} }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
  function uuid(){
    try{ if(crypto && crypto.randomUUID) return crypto.randomUUID(); }catch(e){}
    return 'sess-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
  }
  // Byte-accurate splitter (UTF-8 safe): slice the encoded bytes on <=900 KB
  // boundaries, then decode each slice back to a string. Guarantees no chunk
  // exceeds CHUNK_SIZE bytes even with multi-byte characters.
  function splitToChunks(str){
    var bytes = new TextEncoder().encode(str);
    var chunks = [];
    var dec = new TextDecoder();
    for(var off=0; off<bytes.length; off+=CHUNK_SIZE){
      var end = Math.min(off+CHUNK_SIZE, bytes.length);
      // Avoid splitting a multi-byte char: back off until the next byte isn't a
      // UTF-8 continuation byte (10xxxxxx), unless we're at the very end.
      if(end < bytes.length){ while(end>off && (bytes[end]&0xC0)===0x80) end--; }
      chunks.push(dec.decode(bytes.subarray(off, end)));
    }
    if(chunks.length===0) chunks.push('');   // always at least one chunk
    return chunks;
  }

  // ── Progress UI ───────────────────────────────────────────────────────────
  var _ui=null;
  function ensureUI(){
    if(_ui && document.body.contains(_ui)) return _ui;
    var d=document.createElement('div');
    d.id='twhChunkProgress';
    d.style.cssText='position:fixed;right:18px;bottom:18px;z-index:100050;min-width:280px;max-width:360px;'+
      'background:#fff;border:1px solid #e2e8f0;border-radius:12px;box-shadow:0 12px 40px rgba(0,0,0,.18);'+
      'padding:14px 16px;font:13px system-ui,Segoe UI,Roboto,sans-serif;display:none';
    d.innerHTML=
      '<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px">'+
        '<span id="twhCpIcon" style="font-size:16px">☁️</span>'+
        '<b id="twhCpTitle" style="flex:1;color:#0f172a">Saving…</b>'+
        '<button id="twhCpClose" style="border:none;background:transparent;cursor:pointer;color:#94a3b8;font-size:16px">&times;</button>'+
      '</div>'+
      '<div style="background:#e2e8f0;border-radius:999px;height:8px;overflow:hidden">'+
        '<div id="twhCpBar" style="height:100%;width:0;background:linear-gradient(90deg,#0d9488,#14b8a6);transition:width .25s"></div>'+
      '</div>'+
      '<div id="twhCpMsg" style="margin-top:8px;color:#475569;font-size:12px">Preparing…</div>'+
      '<div id="twhCpActions" style="margin-top:10px;display:none;gap:8px">'+
        '<button id="twhCpResume" style="padding:7px 14px;background:#0d9488;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:600">Resume</button>'+
      '</div>';
    document.body.appendChild(d);
    d.querySelector('#twhCpClose').onclick=function(){ d.style.display='none'; };
    _ui=d; return d;
  }
  function showProgress(pct, msg, opts){
    opts=opts||{};
    var d=ensureUI(); d.style.display='block';
    d.querySelector('#twhCpBar').style.width=Math.max(0,Math.min(100,pct))+'%';
    if(msg!=null) d.querySelector('#twhCpMsg').textContent=msg;
    d.querySelector('#twhCpIcon').textContent=opts.icon||'☁️';
    if(opts.title) d.querySelector('#twhCpTitle').textContent=opts.title;
    var act=d.querySelector('#twhCpActions');
    if(opts.resume){ act.style.display='flex'; d.querySelector('#twhCpResume').onclick=opts.resume; }
    else act.style.display='none';
    if(opts.autohide){ setTimeout(function(){ if(d) d.style.display='none'; }, opts.autohide); }
  }
  function hideProgress(delay){ var d=ensureUI(); setTimeout(function(){ d.style.display='none'; }, delay||1200); }

  // ── localStorage fallback queue ────────────────────────────────────────────
  function queueFallback(envelope){
    try{
      var q=[]; try{ q=JSON.parse(localStorage.getItem(LS_QUEUE_KEY)||'[]'); }catch(e){ q=[]; }
      // Keep only the LATEST full snapshot (a newer save supersedes older ones).
      q=[{ ts:Date.now(), envelope:envelope }];
      localStorage.setItem(LS_QUEUE_KEY, JSON.stringify(q));
      log('payload queued to localStorage for later sync');
    }catch(e){ warn('could not queue fallback (localStorage full?)', e); }
  }
  function hasQueued(){
    try{ var q=JSON.parse(localStorage.getItem(LS_QUEUE_KEY)||'[]'); return q && q.length>0; }catch(e){ return false; }
  }
  function takeQueued(){
    try{ var q=JSON.parse(localStorage.getItem(LS_QUEUE_KEY)||'[]'); return (q&&q[0])||null; }catch(e){ return null; }
  }
  function clearQueued(){ try{ localStorage.removeItem(LS_QUEUE_KEY); }catch(e){} }

  // ── Resume-progress persistence ────────────────────────────────────────────
  function saveResume(state){ try{ localStorage.setItem(LS_RESUME_KEY, JSON.stringify(state)); }catch(e){} }
  function loadResume(){ try{ return JSON.parse(localStorage.getItem(LS_RESUME_KEY)||'null'); }catch(e){ return null; } }
  function clearResume(){ try{ localStorage.removeItem(LS_RESUME_KEY); }catch(e){} }

  // ── The resilient chunk sender ──────────────────────────────────────────────
  var _uploading=false;

  // Upload a single chunk with exponential backoff. Resolves with the parsed
  // JSON on 200/202; rejects with {fatal, status} after MAX_RETRIES failures.
  function sendChunk(payload){
    var attempt=0, delay=BACKOFF_START;
    function tryOnce(){
      return fetch(CHUNKED_EP, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload),
        credentials:'include', cache:'no-store'
      }).then(function(r){
        if(r.status===401){ location.reload(); throw {fatal:true, status:401}; }
        if(r.status===200 || r.status===202){
          return r.json().then(function(j){ return {status:r.status, j:j}; }).catch(function(){ return {status:r.status, j:{}}; });
        }
        // Retryable server/edge errors.
        return r.text().then(function(t){ throw {status:r.status, body:(t||'').slice(0,160), retryable:(r.status>=500||r.status===429)}; });
      });
    }
    function attemptLoop(){
      return tryOnce().catch(function(err){
        if(err && err.fatal) throw err;
        attempt++;
        var isNetwork=(err && err.status===undefined);
        var retryable=isNetwork || (err && err.retryable);
        if(!retryable || attempt>=MAX_RETRIES){
          throw { fatal:true, status:(err&&err.status)||0, attempts:attempt, network:isNetwork };
        }
        warn('chunk '+payload.chunkIndex+' failed (attempt '+attempt+'/'+MAX_RETRIES+'), retrying in '+delay+'ms', err&&err.status);
        return sleep(delay).then(function(){ delay=Math.min(delay*2, BACKOFF_MAX); return attemptLoop(); });
      });
    }
    return attemptLoop();
  }

  // Upload a chunk list from a given index. Handles pause/resume + fallback.
  // Returns Promise<{ok:true}> on full success, {ok:false, paused|fallback} otherwise.
  function uploadChunks(sessionId, chunks, mode, audit, startAt){
    var i = startAt||0;
    var total = chunks.length;
    var consecutive503 = 0;
    function step(){
      if(i>=total){
        clearResume();
        showProgress(100, 'Saved ✓ ('+total+' chunk'+(total>1?'s':'')+')', {icon:'✅', title:'Saved', autohide:1500});
        return Promise.resolve({ok:true});
      }
      showProgress(Math.round((i/total)*100), 'Uploading chunk '+(i+1)+'/'+total+'…', {title:'Saving'});
      var payload={
        sessionId:sessionId, chunkIndex:i, totalChunks:total,
        mode:mode||'merge', data:chunks[i]
      };
      // Attach audit only to the FINAL chunk (applied once, on assemble).
      if(i===total-1 && audit && audit.length) payload.audit=audit;
      return sendChunk(payload).then(function(res){
        consecutive503=0;
        i++;
        // Persist progress so a reload can resume.
        saveResume({ sessionId:sessionId, mode:mode, total:total, nextIndex:i, ts:Date.now() });
        return step();
      }).catch(function(err){
        // A chunk exhausted its retries.
        if(err && (err.status===503 || err.network)) consecutive503++;
        // Endpoint completely down → fall back to localStorage + queue.
        if(consecutive503>=FALLBACK_503S){
          warn('endpoint appears down — falling back to localStorage queue');
          return {ok:false, fallback:true};
        }
        // Otherwise pause and offer Resume.
        saveResume({ sessionId:sessionId, mode:mode, total:total, nextIndex:i, ts:Date.now() });
        showProgress(Math.round((i/total)*100),
          'Upload paused at chunk '+(i+1)+'/'+total+'. Your data is safe and saved locally.',
          { icon:'⚠️', title:'Paused', resume:function(){ resumePausedUpload(chunks); } });
        return {ok:false, paused:true};
      });
    }
    return step();
  }

  // Keep the chunk data for the active session in memory so Resume can continue
  // without re-serialising (also stored in the fallback queue as a backstop).
  var _activeChunks=null, _activeMeta=null;
  function resumePausedUpload(chunksMaybe){
    var r=loadResume();
    if(!r){ hideProgress(200); return; }
    var chunks = chunksMaybe || _activeChunks;
    if(!chunks){
      // No in-memory chunks (e.g. after reload) → rebuild from the queued snapshot.
      var q=takeQueued();
      if(q && q.envelope){ chunks=splitToChunks(JSON.stringify(q.envelope)); }
    }
    if(!chunks){ warn('cannot resume — no chunk data available'); hideProgress(200); return; }
    _activeChunks=chunks;
    log('resuming upload at chunk '+(r.nextIndex+1)+'/'+r.total);
    uploadChunks(r.sessionId, chunks, r.mode, (_activeMeta&&_activeMeta.audit)||null, r.nextIndex)
      .then(function(res){ if(res.ok){ clearQueued(); _activeChunks=null; if(typeof window._hmsRefresh==='function') window._hmsRefresh(); } else if(res.fallback){ persistFallback(); } });
  }

  function persistFallback(){
    // Save whole current D snapshot to the fallback queue and show status.
    try{
      var env=buildEnvelope('merge');
      queueFallback(env.envelope);
      showProgress(100, 'Offline — saved locally. Will sync automatically when back online.',
        { icon:'💾', title:'Saved locally' });
    }catch(e){ warn('persistFallback failed', e); }
  }

  // Build the save envelope from the live D (identity-stripped), reusing the
  // app's stripper when available.
  var IDENTITY_KEYS=['currentUser','currentBranch','currentMod','_wellTab','_activeTab','isLoggedIn'];
  function stripIdentityClone(src){
    if(!src || typeof src!=='object') return src;
    var out={}; for(var k in src){ if(IDENTITY_KEYS.indexOf(k)===-1) out[k]=src[k]; }
    return out;
  }
  function buildEnvelope(mode, audit){
    // The server also strips identity; we strip here too so it never leaves the tab.
    var data = stripIdentityClone(window.D);
    return { envelope:{ data:data }, mode:mode||'merge', audit:audit||null };
  }

  // PUBLIC: chunked save of an explicit payload object (or the live D).
  //   HMS_CHUNKED.save({ data:{...} }, { mode, audit })  → Promise<result>
  function chunkedSave(payloadObj, opts){
    opts=opts||{};
    if(_uploading){ return Promise.resolve({ok:false, busy:true}); }
    _uploading=true;
    var env = payloadObj ? { data:(payloadObj.data!==undefined?payloadObj.data:payloadObj) } : buildEnvelope(opts.mode, opts.audit).envelope;
    var mode = opts.mode||'merge';
    var audit = opts.audit||null;
    var str;
    try{ str = JSON.stringify(env); }
    catch(e){ _uploading=false; return Promise.reject(e); }
    var chunks = splitToChunks(str);
    var sessionId = uuid();
    _activeChunks = chunks; _activeMeta = { audit:audit, mode:mode };
    log('starting upload — '+ (str.length) +' bytes in '+chunks.length+' chunk(s), session '+sessionId);
    showProgress(0, 'Uploading chunk 1/'+chunks.length+'…', {title:'Saving'});
    return uploadChunks(sessionId, chunks, mode, audit, 0).then(function(res){
      _uploading=false;
      if(res.ok){ clearQueued(); _activeChunks=null; }
      else if(res.fallback){ persistFallback(); }
      return res;
    }).catch(function(err){
      _uploading=false; persistFallback();
      return {ok:false, error:String(err&&err.message||err)};
    });
  }

  // ── Fallback-queue drain (sync on recovery) ────────────────────────────────
  function drainQueue(){
    if(_uploading || !hasQueued() || !navigator.onLine) return;
    var q=takeQueued();
    if(!q || !q.envelope) { clearQueued(); return; }
    log('network back — draining queued snapshot to server');
    showProgress(0, 'Reconnected — syncing saved changes…', {title:'Syncing'});
    chunkedSave(q.envelope, { mode:'merge' }).then(function(res){
      if(res && res.ok){ clearQueued(); if(typeof window._hmsRefresh==='function') window._hmsRefresh(); }
    });
  }
  window.addEventListener('online', function(){ setTimeout(drainQueue, 800); });
  // Phase 3: periodic safety-net retry on the ONE shared scheduler (pauses when hidden).
  if(window.HMS && window.HMS.every){ window.HMS.every(20000, drainQueue); }
  else { setInterval(drainQueue, 20000); }

  // ── Public API ──────────────────────────────────────────────────────────────
  window.HMS_CHUNKED = {
    save: chunkedSave,
    resume: function(){ resumePausedUpload(); },
    hasPending: function(){ return hasQueued() || !!loadResume(); },
    status: function(sessionId){
      return fetch(CHUNKED_EP+'?session='+encodeURIComponent(sessionId), { credentials:'include', cache:'no-store' })
        .then(function(r){ return r.json(); }).catch(function(){ return null; });
    },
    _split: splitToChunks, _uuid: uuid, CHUNK_SIZE: CHUNK_SIZE
  };

  // ── Integration: route LARGE saves through the chunked uploader ─────────────
  // The v198 delta writer stays the fast path for small saves. We wrap _hmsSave
  // so that when the serialized state is large (or the delta writer reports an
  // error), the bulletproof chunked path takes over. This preserves the ~877
  // existing call sites unchanged.
  var LARGE_SAVE_BYTES = 900 * 1024;   // if the whole doc exceeds one chunk, chunk it
  function currentDocBytes(){
    try{ return new TextEncoder().encode(JSON.stringify(window.D||{})).length; }catch(e){ return 0; }
  }
  function installSaveWrap(){
    var orig = window._hmsSave;
    if(typeof orig!=='function' || orig.__v199Wrapped) return;
    var wrapped = function(){
      // Small doc → keep the fast delta writer.
      if(currentDocBytes() < LARGE_SAVE_BYTES){
        var r = orig.apply(this, arguments);
        // If the delta writer ends in a persistent sync error, escalate to chunked.
        try{
          if(window.HMS_DB){
            setTimeout(function(){
              if(window.HMS_DB.syncState==='error' && !_uploading){
                warn('delta save reported error — escalating to chunked upload');
                chunkedSave(null, { mode:'merge' });
              }
            }, 4000);
          }
        }catch(e){}
        return r;
      }
      // Large doc → bulletproof chunked upload.
      log('large document ('+currentDocBytes()+' bytes) — using chunked upload');
      return chunkedSave(null, { mode:'merge' });
    };
    wrapped.__v199Wrapped = true;
    try{ window._hmsSave = wrapped; }catch(e){}
  }
  installSaveWrap();
  [500,1500,3000,6000].forEach(function(t){ setTimeout(installSaveWrap, t); });

  // ── On load: resume a paused upload or drain a queued fallback ──────────────
  setTimeout(function(){
    if(loadResume()){
      showProgress(0, 'You have an unfinished save. Click Resume to complete it.',
        { icon:'⚠️', title:'Resume save', resume:function(){ resumePausedUpload(); } });
    } else if(hasQueued()){
      drainQueue();
    }
  }, 2500);

  console.log('%c✅ v199 — bulletproof chunked upload (900KB chunks · backoff · resume · offline queue) loaded','color:#fff;font-weight:bold;background:#0d9488;padding:2px 8px;border-radius:6px');
})();

;

/* ==== /js/151-twh-fixes-v200.js ==== */
(function(){
  if(window.__twhV200) return; window.__twhV200 = true;

  function D(){ return window.D || (window.D = {}); }
  function esc(s){ try{ return (typeof window.esc==='function')?window.esc(s):String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }catch(e){ return String(s==null?'':s); } }
  function me(){ try{ return (typeof currentUserObj==='function' && currentUserObj()) || D().currentUser || null; }catch(e){ return (D()||{}).currentUser || null; } }
  function roleOf(){ var u=me(); return (u && u.role) ? String(u.role) : ''; }

  // ── The record-array collections that must always be present + reconciled ──
  var CLINICAL_COLLECTIONS = ['appointments','medicalRecords','labTests','labOrders',
                              'radiologyOrders','mealPlans','prescriptions','patients',
                              'billing','transactions','consentRecords','referrals'];
  function ensureCollections(){
    var d=D();
    CLINICAL_COLLECTIONS.forEach(function(k){ if(!Array.isArray(d[k])) d[k]=[]; });
  }

  // ════════════════════════════════════════════════════════════════
  // FIX 1 — RESTORE OLD RECORDS FROM CLOUD (full-document reconcile)
  // The debounced delta-writer only sends changed keys, and the boot restore
  // already unions the server doc into D. But if a collection was ever emptied
  // locally (stale tab, mid-sync reload), the union-merge server-side keeps the
  // old rows — they just need to be pulled back and unioned into THIS tab's D.
  // Here we fetch the WHOLE server document and union every record-collection
  // by id (never dropping local un-saved rows, never dropping server rows).
  // ════════════════════════════════════════════════════════════════
  function isObj(v){ return v && typeof v==='object' && !Array.isArray(v); }
  function isRecArr(a){ if(!Array.isArray(a)||!a.length) return false; for(var i=0;i<a.length;i++){ if(!isObj(a[i])||!('id' in a[i])) return false; } return true; }
  function revOf(r){ var v=r&&r._rev; return (typeof v==='number'&&isFinite(v))?v:0; }

  // Union server records into local by id. Server rows that are missing locally
  // are ADDED; for shared ids the newer _rev wins (local edits are preserved).
  function unionInto(localArr, serverArr, table, tomb){
    var dead = {};
    if(tomb && Array.isArray(tomb[table])) tomb[table].forEach(function(id){ dead[id]=1; });
    var byId={}, order=[];
    (localArr||[]).forEach(function(r){ if(isObj(r)&&'id' in r){ if(!(r.id in byId)) order.push(r.id); byId[r.id]=r; } });
    (serverArr||[]).forEach(function(r){
      if(!isObj(r)||!('id' in r)) return;
      if(dead[r.id]) return;                              // respect tombstones
      if(!(r.id in byId)){ order.push(r.id); byId[r.id]=r; }   // OLD record restored
      else { if(revOf(r) > revOf(byId[r.id])) byId[r.id]=r; }  // newer server edit wins
    });
    var out=order.map(function(id){ return byId[id]; }).filter(function(r){ return !dead[r.id]; });
    return out;
  }

  var _reconciling=false;
  function reconcileFromCloud(opts){
    opts=opts||{};
    if(_reconciling) return Promise.resolve(false);
    var ep = window._HMS_API_ENDPOINT;
    if(!ep){ return Promise.resolve(false); }
    _reconciling=true;
    return fetch(ep, {credentials:'include', cache:'no-store', headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(j){
        var srv = j && j.data;
        if(!isObj(srv)){ return false; }
        var d=D(); ensureCollections();
        var tomb = d.__deletedIds || {};
        var restored=0, changedKeys=0;
        Object.keys(srv).forEach(function(k){
          var sv = srv[k];
          if(isRecArr(sv) || (Array.isArray(sv) && Array.isArray(d[k]))){
            if(isRecArr(sv) || isRecArr(d[k])){
              var before = Array.isArray(d[k]) ? d[k].length : 0;
              var merged = unionInto(d[k]||[], sv, k, tomb);
              if(merged.length !== before) changedKeys++;
              restored += Math.max(0, merged.length - before);
              d[k]=merged;
            }
          }
        });
        if((restored>0 || opts.force) && typeof window.render==='function'){ try{ window.render(); }catch(e){} }
        if(restored>0){ try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){} }
        if(opts.toast){ try{ toast(restored>0 ? ('Restored '+restored+' record(s) from cloud') : 'Records already up to date'); }catch(e){} }
        return restored>0;
      })
      .catch(function(e){ if(opts.toast){ try{ toast('Restore failed: '+(e&&e.message||e),'err'); }catch(_){} } return false; })
      .then(function(res){ _reconciling=false; return res; });
  }
  window.__hmsRestoreFromCloud = function(){ return reconcileFromCloud({toast:true, force:true}); };

  // ════════════════════════════════════════════════════════════════
  // FIX 2 — FRONT DESK OFFICER CANNOT DELETE A PATIENT
  // (a) Guard the generic deleteRecord() so a patient delete by a Front-Desk /
  //     Reception role is blocked with a clear message.
  // (b) Strip any patient Delete button the v172 pack (or markup) added when
  //     the current user is Front Desk / Reception.
  // ════════════════════════════════════════════════════════════════
  var DELETE_BLOCKED_ROLES = ['front desk officer','front desk','reception','receptionist','front-desk officer'];
  function isFrontDesk(){ return DELETE_BLOCKED_ROLES.indexOf(roleOf().trim().toLowerCase()) >= 0; }

  function wrapDeleteRecord(){
    var fn = window.deleteRecord;
    if(typeof fn!=='function' || fn.__v200) return;
    var wrapped = function(dataKey, id){
      if(dataKey==='patients' && isFrontDesk()){
        try{ toast('Front Desk Officers are not permitted to delete patients. Contact an administrator.','err'); }catch(e){}
        return;
      }
      return fn.apply(this, arguments);
    };
    try{ wrapped.__v200 = true; window.deleteRecord = wrapped; }catch(e){}
  }

  // Remove any patient-row Delete button for Front-Desk users (belt-and-braces
  // against the v172 injector, which runs on its own timers).
  function stripPatientDeleteForFrontDesk(){
    if(!isFrontDesk()) return;
    try{
      if(typeof currentMod!=='undefined' && currentMod!=='patients') return;
      var btns = document.querySelectorAll('.act-row button[onclick*="deleteRecord(\'patients\'"], .act-row button.__v172_del');
      btns.forEach(function(b){
        var oc = b.getAttribute('onclick')||'';
        if(oc.indexOf("deleteRecord('patients'")>=0 || b.classList.contains('__v172_del')){
          // Only remove patient deletes; leave discharge / other actions intact.
          if(oc.indexOf("deleteRecord('patients'")>=0 || b.classList.contains('__v172_del')) b.remove();
        }
      });
    }catch(e){}
  }

  // ════════════════════════════════════════════════════════════════
  // FIX 3 — MEAL PLANS / DIET PRESCRIPTIONS VIEWABLE FROM PATIENT RECORD
  // Wrap viewPatient() so the modal also shows a Clinical History panel with
  // the patient's Meal Plans / Diet Prescriptions (plus a quick summary of
  // appointments, medical records, lab & radiology orders — the very records
  // the user wants to see "back" in the app).
  // ════════════════════════════════════════════════════════════════
  function byPatient(arr, pid){ return (Array.isArray(arr)?arr:[]).filter(function(r){ return r && (r.patientId===pid || String(r.patientId)===String(pid)); }); }

  function mealPlanHtml(pid){
    var d=D();
    var plans = byPatient(d.mealPlans, pid).slice().sort(function(a,b){ return String(b.date||'').localeCompare(String(a.date||'')); });
    if(!plans.length){
      return '<div style="padding:10px 12px;color:#64748b;font-size:12px">No meal plan / diet prescription on file. '
        + '<a href="#" style="color:#0d9488;font-weight:600;text-decoration:none" onclick="try{closeModal()}catch(e){};try{goTo(\'wellness\')}catch(e){};return false;">Open Meal Planner</a></div>';
    }
    var rows = plans.map(function(p){
      var kcal = (p.planned && (p.planned.kcal!=null?p.planned.kcal:p.planned.calories)) || (p.target && p.target.calories) || '—';
      var prot = (p.planned && (p.planned.protein!=null?p.planned.protein:p.planned.proteinG)) || (p.target && p.target.proteinG) || '—';
      return '<tr>'
        + '<td><b>'+esc(p.code||'MP')+'</b></td>'
        + '<td>'+esc(p.date||'—')+'</td>'
        + '<td>'+esc(p.dietType||p.diagnosis||'—')+'</td>'
        + '<td>'+esc(kcal)+' kcal</td>'
        + '<td>'+esc(prot)+' g</td>'
        + '<td><span class="st st-active">'+esc(p.status||'Active')+'</span></td>'
        + '<td>'+esc(p.createdBy||p.provider||'—')+'</td>'
        + '</tr>';
    }).join('');
    return '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Diet / Dx</th><th>Calories</th><th>Protein</th><th>Status</th><th>By</th></tr></thead><tbody>'+rows+'</tbody></table></div>';
  }

  function clinicalHistoryHtml(pid){
    var d=D();
    var appts = byPatient(d.appointments, pid);
    var emr   = byPatient(d.medicalRecords, pid);
    var labs  = byPatient(d.labTests, pid).concat(byPatient(d.labOrders, pid));
    var rads  = byPatient(d.radiologyOrders, pid);
    var dietRx= byPatient(d.medicalRecords, pid).filter(function(r){ return (r.visitType==='Diet Prescription')||(r.source==='mealplanner'); });

    function countPill(label, n, color){
      return '<div style="flex:1;min-width:96px;background:'+color+';color:#fff;border-radius:10px;padding:8px 10px;text-align:center">'
        + '<div style="font-size:20px;font-weight:800;line-height:1">'+n+'</div>'
        + '<div style="font-size:10px;opacity:.9;margin-top:2px">'+label+'</div></div>';
    }

    var recent = function(arr, cols){
      var rows = (arr||[]).slice().reverse().slice(0,6).map(function(r){
        return '<tr>'+cols.map(function(c){ return '<td>'+esc(c(r))+'</td>'; }).join('')+'</tr>';
      }).join('');
      return rows || '';
    };

    var apptRows = recent(appts, [
      function(r){ return r.code||'APT'; }, function(r){ return r.date||'—'; },
      function(r){ return r.time||''; }, function(r){ return r.type||''; }, function(r){ return r.status||''; }
    ]);
    var emrRows = recent(emr, [
      function(r){ return r.code||'EMR'; }, function(r){ return r.visitDate||r.date||'—'; },
      function(r){ return r.visitType||''; }, function(r){ return (r.diagnosis||'—'); }, function(r){ return r.status||''; }
    ]);
    var labRows = recent(labs, [
      function(r){ return r.code||'LAB'; }, function(r){ return r.orderDate||r.date||'—'; },
      function(r){ return r.testType||r.test||''; }, function(r){ return r.status||''; }
    ]);
    var radRows = recent(rads, [
      function(r){ return r.code||'RAD'; }, function(r){ return r.orderDate||r.date||'—'; },
      function(r){ return r.examType||r.study||r.modality||''; }, function(r){ return r.status||''; }
    ]);

    var html = '<div style="margin-top:6px">'
      + '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">'
      + countPill('Appointments', appts.length, 'linear-gradient(135deg,#1e40af,#3b82f6)')
      + countPill('Medical Records', emr.length, 'linear-gradient(135deg,#065f46,#10b981)')
      + countPill('Lab Orders', labs.length, 'linear-gradient(135deg,#7c3aed,#a78bfa)')
      + countPill('Radiology', rads.length, 'linear-gradient(135deg,#b45309,#fbbf24)')
      + countPill('Diet Rx / Meal Plans', (d.mealPlans?byPatient(d.mealPlans,pid).length:0), 'linear-gradient(135deg,#0d9488,#14b8a6)')
      + '</div>';

    // Meal Plans / Diet Prescriptions — the headline requested panel.
    html += '<h4 style="margin:14px 0 6px;color:#0d9488"><i class="fa-solid fa-utensils" style="margin-right:6px"></i>Meal Plans / Diet Prescriptions</h4>'
      + mealPlanHtml(pid);

    if(apptRows) html += '<h4 style="margin:14px 0 6px;color:#1e40af"><i class="fa-solid fa-calendar-check" style="margin-right:6px"></i>Recent Appointments</h4>'
      + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Time</th><th>Type</th><th>Status</th></tr></thead><tbody>'+apptRows+'</tbody></table></div>';
    if(emrRows) html += '<h4 style="margin:14px 0 6px;color:#065f46"><i class="fa-solid fa-file-medical" style="margin-right:6px"></i>Recent Medical Records</h4>'
      + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Type</th><th>Diagnosis</th><th>Status</th></tr></thead><tbody>'+emrRows+'</tbody></table></div>';
    if(labRows) html += '<h4 style="margin:14px 0 6px;color:#7c3aed"><i class="fa-solid fa-flask" style="margin-right:6px"></i>Recent Lab Orders</h4>'
      + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Test</th><th>Status</th></tr></thead><tbody>'+labRows+'</tbody></table></div>';
    if(radRows) html += '<h4 style="margin:14px 0 6px;color:#b45309"><i class="fa-solid fa-x-ray" style="margin-right:6px"></i>Recent Radiology Orders</h4>'
      + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Exam</th><th>Status</th></tr></thead><tbody>'+radRows+'</tbody></table></div>';

    html += '</div>';
    return html;
  }

  function wrapViewPatient(){
    var fn = window.viewPatient;
    if(typeof fn!=='function' || fn.__v200) return;
    var wrapped = function(id){
      var r = fn.apply(this, arguments);
      // The original opened a modal synchronously; append our clinical panel to it.
      try{
        var pid = id;
        setTimeout(function(){
          try{
            var body = document.querySelector('#modalBody, .modal-body, #modal .modal-content, .modal .modal-body');
            // Fallback: find the detail-grid the original rendered and append after it.
            var grid = document.querySelector('.modal .detail-grid, #modal .detail-grid, .detail-grid');
            var host = grid ? grid.parentNode : body;
            if(host && !host.querySelector('#__v200_clinhist')){
              var wrap = document.createElement('div');
              wrap.id='__v200_clinhist';
              wrap.style.cssText='border-top:2px solid #e2e8f0;margin-top:14px;padding-top:8px';
              wrap.innerHTML = clinicalHistoryHtml(pid);
              host.appendChild(wrap);
            }
          }catch(e){}
        }, 30);
      }catch(e){}
      return r;
    };
    try{ wrapped.__v200 = true; window.viewPatient = wrapped; }catch(e){}
  }

  // ════════════════════════════════════════════════════════════════
  // FIX 4 — FASTER SYNC (clear the "Sync error" pill quicker)
  // (a) Shrink the debounce window so a create/edit persists almost instantly.
  // (b) Kick an immediate save right after clinical creates (meal plan, EMR,
  //     appointment, lab, radiology) via the render/save choke-points.
  // (c) Faster auto-retry on a transient failure so the pill clears sooner.
  // ════════════════════════════════════════════════════════════════
  function fasterSync(){
    // Replace _hmsSaveSoon with a shorter debounce (250ms) if not already done.
    if(!window.__v200FastSave && typeof window._hmsSave==='function'){
      var _t=null;
      var fast = function(){
        if(_t) return;
        _t=setTimeout(function(){ _t=null; try{ window._hmsSave(); }catch(e){} }, 250);
      };
      try{ window._hmsSaveSoon = fast; window.__v200FastSave = true; }catch(e){}
    }
  }

  // Force an immediate flush when a clinical record is created/edited: wrap the
  // meal-plan save + the generic saveNewRecord so their write goes out at once.
  function wrapImmediateSaves(){
    // Meal plan save → immediate persist (already calls _hmsSave, but ensure it).
    if(typeof window.mpSave==='function' && !window.mpSave.__v200){
      var mp = window.mpSave;
      var wmp = function(){ var r=mp.apply(this,arguments); try{ if(window._hmsSave) window._hmsSave(); }catch(e){} return r; };
      try{ wmp.__v200=true; window.mpSave=wmp; }catch(e){}
    }
  }

  // ── Boot / periodic enforcement ─────────────────────────────────────────
  function boot(){
    ensureCollections();
    wrapDeleteRecord();
    wrapViewPatient();
    wrapImmediateSaves();
    fasterSync();
  }

  function ready(fn){ if(window.D){ fn(); } else setTimeout(function(){ ready(fn); }, 120); }

  ready(function(){
    boot();
    [0,300,900,1800,3500,6000].forEach(function(ms){ setTimeout(boot, ms); });

    // Re-apply wrappers + strip Front-Desk patient-delete after every render.
    if(typeof window.render==='function'){
      var _r = window.render;
      if(!_r.__v200){
        var wrapped = function(){ var out=_r.apply(this,arguments); try{ boot(); stripPatientDeleteForFrontDesk(); }catch(e){} return out; };
        try{ wrapped.__v200=true; window.render=wrapped; }catch(e){}
      }
    }
    // Periodic safety net (cheap): keep wrappers installed & Front-Desk locked.
    DOMBus.register(function(){ boot(); stripPatientDeleteForFrontDesk(); });

    // One-time full reconcile from cloud shortly after boot so any OLD records
    // (appointments / EMR / lab / radiology / meal plans) reappear automatically.
    setTimeout(function(){ if(window.isLoggedIn || !window.__HMS_AUTH || !window.__HMS_AUTH.configured){ reconcileFromCloud({}); } }, 3500);
    // And whenever the tab regains focus (catch records created elsewhere).
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState==='visible'){ setTimeout(function(){ reconcileFromCloud({}); }, 400); }
    });

    try{
      console.log('%c\u2705 v200 \u2014 restore old records + Front-Desk delete lock + meal plans in patient record + faster sync',
        'background:#0f766e;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
    }catch(e){}
  });
})();

;

/* ==== /js/152-twh-503-eliminate-v201.js ==== */
(function(){
  if(window.__twhV201) return; window.__twhV201 = true;

  function log(){ try{ console.log.apply(console,['%c[v201]','color:#fff;background:#b91c1c;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); }catch(e){} }
  function warn(){ try{ console.warn.apply(console,['[v201]'].concat([].slice.call(arguments))); }catch(e){} }

  var STATE_MARK = '/api/state/';
  // Recognise the opaque Cloudflare/edge HTML error page (no clean JSON).
  function isOpaqueHtml(text){ return /<!DOCTYPE|<html|<head|no-js|cloudflare|error\s*10\d\d/i.test(String(text||'')); }
  function is5xx(status){ return status===0 || status>=500 || status===429; }

  // ── A) Resilient save through the chunked path (single-flight + debounce) ───
  var _resilientTimer=null, _resilientInFlight=false, _resilientAgain=false;
  function runResilientSave(reason){
    if(!(window.HMS_CHUNKED && typeof window.HMS_CHUNKED.save==='function')){
      // v199 not loaded yet — fall back to a plain full save so nothing is lost.
      try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
      return;
    }
    if(_resilientInFlight){ _resilientAgain=true; return; }
    _resilientInFlight=true;
    log('resilient chunked save ('+(reason||'manual')+')');
    // Signal "syncing" so the chip shows progress instead of the error state.
    try{ if(typeof window._v201SetSyncing==='function') window._v201SetSyncing(); }catch(e){}
    var p;
    try{ p = window.HMS_CHUNKED.save(null, { mode:'merge' }); }
    catch(e){ _resilientInFlight=false; warn('chunked save threw', e); return; }
    Promise.resolve(p).then(function(res){
      _resilientInFlight=false;
      if(res && res.ok){
        log('resilient save OK — pulling fresh state');
        try{ if(typeof window._v201MarkIdle==='function') window._v201MarkIdle(); }catch(e){}
        try{ if(typeof window._hmsRefresh==='function') window._hmsRefresh(); }catch(e){}
      }
      if(_resilientAgain){ _resilientAgain=false; setTimeout(function(){ runResilientSave('coalesced'); }, 200); }
    }).catch(function(e){
      _resilientInFlight=false; warn('resilient save failed', e);
      if(_resilientAgain){ _resilientAgain=false; setTimeout(function(){ runResilientSave('coalesced'); }, 500); }
    });
  }
  function resilientSaveSoon(reason){
    if(_resilientTimer) return;
    _resilientTimer=setTimeout(function(){ _resilientTimer=null; runResilientSave(reason); }, 150);
  }
  window._v201ResilientSave = runResilientSave;

  // ── Expose small helpers to nudge the sync chip without touching internals ──
  // These are best-effort: they just call the app's own state setter if present.
  window._v201SetSyncing = function(){ /* optional; chip already shows syncing during save */ };
  window._v201MarkIdle   = function(){ /* the successful chunked pull + poll settle the chip */ };

  // ── B) Global fetch guard: catch 503 / opaque-HTML on the delta PUT ─────────
  //    and IMMEDIATELY route the save through the resilient chunked path.
  //    We only intercept PUT/POST to /api/state/ (the delta writer). The
  //    chunked endpoint (/api/chunked/) has its own resilient backoff, so we
  //    never re-wrap it (avoids recursion).
  var _origFetch = window.fetch && window.fetch.bind(window);
  if(_origFetch && !window.__v201FetchWrapped){
    window.__v201FetchWrapped = true;
    window.fetch = function(input, init){
      var url = (typeof input==='string') ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isStateWrite = url.indexOf(STATE_MARK)!==-1 && (method==='PUT' || method==='POST');
      var pr = _origFetch(input, init);
      if(!isStateWrite) return pr;
      return pr.then(function(resp){
        try{
          if(resp && !resp.ok && is5xx(resp.status)){
            // Peek at the body WITHOUT consuming the caller's stream (clone).
            var clone = resp.clone();
            clone.text().then(function(t){
              if(is5xx(resp.status) && (isOpaqueHtml(t) || resp.status===503 || resp.status>=500)){
                warn('delta PUT returned '+resp.status+' — escalating to chunked immediately');
                resilientSaveSoon('state-'+resp.status);
              }
            }).catch(function(){
              // Body unreadable but status is 5xx → escalate anyway.
              resilientSaveSoon('state-'+resp.status+'-nobody');
            });
          }
        }catch(e){ warn('guard error', e); }
        return resp;
      }).catch(function(err){
        // Network-level failure on a state write → escalate to chunked.
        try{ warn('delta PUT network error — escalating to chunked', err); resilientSaveSoon('state-network'); }catch(e){}
        throw err;
      });
    };
    log('fetch guard installed (state-write 503 → chunked)');
  }

  // ── C) Rebind "Retry now" so it uses the resilient chunked path ─────────────
  //    The Sync-status dialog button calls window._hmsSave(); we intercept the
  //    click via a delegated capture handler on the dialog and reroute it.
  document.addEventListener('click', function(ev){
    try{
      var t = ev.target && ev.target.closest ? ev.target.closest('button') : null;
      if(!t) return;
      var label = (t.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(label.indexOf('retry now')!==-1){
        ev.preventDefault(); ev.stopPropagation();
        log('Retry now → resilient chunked save');
        runResilientSave('retry-now');
        try{ if(window.closeModal) window.closeModal(); }catch(e){}
      }
    }catch(e){}
  }, true);

  // Also override the dialog's inline handler at the source, in case the button
  // markup is regenerated: patch showSyncErrorDialog so the primary button
  // points at the resilient path.
  (function repointDialog(){
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(typeof window.showSyncErrorDialog==='function' && !window.showSyncErrorDialog.__v201){
        var orig = window.showSyncErrorDialog;
        var wrapped = function(){
          var r = orig.apply(this, arguments);
          // After the modal renders, rewrite the Retry button's onclick.
          setTimeout(function(){
            try{
              var btns = document.querySelectorAll('#modalBg button, .modal button');
              for(var i=0;i<btns.length;i++){
                var lbl=(btns[i].textContent||'').toLowerCase();
                if(lbl.indexOf('retry now')!==-1){
                  btns[i].onclick=function(e){ if(e){e.preventDefault();} runResilientSave('retry-now'); try{ if(window.closeModal) window.closeModal(); }catch(_e){} };
                }
              }
            }catch(e){}
          }, 30);
          return r;
        };
        wrapped.__v201 = true;
        try{ window.showSyncErrorDialog = wrapped; }catch(e){}
        clearInterval(iv);
      }
      if(tries>40) clearInterval(iv);
    }, 250);
  })();

  // ── D) Speed up v199's error-escalation (4000 ms → 700 ms) ──────────────────
  //    v199's installSaveWrap waits 4 s after syncState==='error' before
  //    escalating. We add our own faster watcher on HMS_DB.onState: the instant
  //    the delta writer reports 'error', kick the resilient chunked save.
  (function fastEscalate(){
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
        var lastErrAt=0;
        window.HMS_DB.onState(function(state, err){
          if(state==='error'){
            var now=Date.now();
            // Debounce so we don't fire on every retry tick.
            if(now-lastErrAt < 1500) return;
            lastErrAt=now;
            var e=String(err||'');
            // Escalate on ANY error the delta writer couldn't clear — 503,
            // opaque HTML, generic 5xx, or a network failure.
            warn('HMS_DB error state ("'+e.slice(0,80)+'") — escalating to chunked in 700ms');
            setTimeout(function(){
              if(window.HMS_DB && window.HMS_DB.syncState==='error'){ resilientSaveSoon('hmsdb-error'); }
            }, 700);
          }
        });
        clearInterval(iv);
      }
      if(tries>40) clearInterval(iv);
    }, 250);
  })();

  console.log('%c✅ v201 — 503 sync error eliminated (auto-escalate delta→chunked · resilient Retry now · 700ms escalation)','color:#fff;font-weight:bold;background:#b91c1c;padding:2px 8px;border-radius:6px');
})();

;

/* ==== /js/153-end-v201.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v202 — CLINICAL MEAL PLANNER UPGRADE (builds on the v195 6-step builder)
   Delivers the user's Meal-Planner redesign request:
     • STEP 3 (Food Selection) — replaces the plain <select> in every meal
       cell with a SEARCHABLE food picker (datalist over the hospital food DB)
       + quantity + "Add", plus a free-text "custom food" entry so any dish
       can be typed in. "I would only change how the foods are entered."
     • Seeds a Nigerian clinical food database (NG-foods) into D.foodItems so
       the DB matches the attached clinical meal plans (pap/akamu, moi-moi,
       jollof, egusi/afang/oha soups, etc.).
     • Registers a Diabetes / Hypercholesterolemia instruction template
       distilled from the attached 21-day plan (Mrs Alice Gregory).
   Everything else (settings, day-by-day table, live totals vs prescription,
   templated instructions, professional print) is provided by v195 and left
   intact. Uses the v195 hooks: __MPB_state / __MPB_rerender /
   __MPB_addTemplate / __MPB_addFoodByName / __MPB_isOpen / __MPB_cellKey.
   Idempotent, guarded by __twhV202.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV202) return; window.__twhV202 = true;

  function D_(){ return window.D || {}; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  function num(v,d){ v=+v; return isFinite(v)?v:(d||0); }

  /* ── Nigerian clinical food database (macros are per typical serving) ──── */
  var NG_FOODS = [
    {id:'NG01',name:'Pap / Akamu (1 bowl)',            kcal:120,protein:2, carbs:26,fat:1, sodium:15,  allergens:[],            tags:['breakfast','soft']},
    {id:'NG02',name:'Pap with Milk (1 bowl)',          kcal:200,protein:8, carbs:32,fat:5, sodium:70,  allergens:['Lactose'],   tags:['breakfast','soft']},
    {id:'NG03',name:'Tom Brown Cereal (1 bowl)',       kcal:210,protein:9, carbs:38,fat:3, sodium:25,  allergens:['Gluten'],    tags:['breakfast']},
    {id:'NG04',name:'Oats + Flaxseed + Cinnamon',      kcal:220,protein:8, carbs:37,fat:5, sodium:10,  allergens:['Gluten'],    tags:['breakfast','diabetic']},
    {id:'NG05',name:'Custard (1 bowl)',                kcal:180,protein:4, carbs:34,fat:3, sodium:60,  allergens:['Lactose'],   tags:['breakfast','soft']},
    {id:'NG06',name:'Boiled Yam (2 slices)',           kcal:230,protein:3, carbs:52,fat:0, sodium:8,   allergens:[],            tags:['carb']},
    {id:'NG07',name:'Boiled Plantain (1 cup)',         kcal:180,protein:2, carbs:47,fat:0, sodium:5,   allergens:[],            tags:['carb']},
    {id:'NG08',name:'Unripe Plantain (boiled)',        kcal:160,protein:2, carbs:42,fat:0, sodium:5,   allergens:[],            tags:['diabetic','carb']},
    {id:'NG09',name:'Sweet Potato (boiled, 1 cup)',    kcal:180,protein:4, carbs:41,fat:0, sodium:70,  allergens:[],            tags:['carb']},
    {id:'NG10',name:'Beans Porridge (1 cup)',          kcal:280,protein:15,carbs:45,fat:5, sodium:120, allergens:[],            tags:['protein','fibre']},
    {id:'NG11',name:'Moi-Moi (1 wrap)',                kcal:210,protein:12,carbs:20,fat:9, sodium:200, allergens:['Egg'],       tags:['protein']},
    {id:'NG12',name:'Akara (3 balls)',                 kcal:230,protein:9, carbs:18,fat:14,sodium:210, allergens:[],            tags:['protein','fried']},
    {id:'NG13',name:'Jollof Rice (Basmati, 1 cup)',    kcal:250,protein:5, carbs:48,fat:5, sodium:320, allergens:[],            tags:['carb']},
    {id:'NG14',name:'White Rice (1 cup)',              kcal:205,protein:4, carbs:45,fat:0, sodium:2,   allergens:[],            tags:['carb']},
    {id:'NG15',name:'Ofada Rice (1 cup)',              kcal:215,protein:5, carbs:45,fat:2, sodium:5,   allergens:[],            tags:['carb','fibre']},
    {id:'NG16',name:'Brown Rice (1 cup)',              kcal:218,protein:5, carbs:46,fat:2, sodium:10,  allergens:[],            tags:['carb','fibre','diabetic']},
    {id:'NG17',name:'Amala (1 wrap)',                  kcal:210,protein:3, carbs:48,fat:0, sodium:10,  allergens:[],            tags:['swallow']},
    {id:'NG18',name:'Eba / Garri (1 wrap)',            kcal:200,protein:1, carbs:49,fat:0, sodium:8,   allergens:[],            tags:['swallow']},
    {id:'NG19',name:'Pounded Yam (1 wrap)',            kcal:230,protein:3, carbs:53,fat:0, sodium:8,   allergens:[],            tags:['swallow']},
    {id:'NG20',name:'Wheat Swallow (1 wrap)',          kcal:200,protein:6, carbs:42,fat:1, sodium:12,  allergens:['Gluten'],    tags:['swallow','diabetic']},
    {id:'NG21',name:'Semovita (1 wrap)',               kcal:210,protein:6, carbs:44,fat:1, sodium:10,  allergens:['Gluten'],    tags:['swallow']},
    {id:'NG22',name:'Fufu / Akpu (1 wrap)',            kcal:220,protein:1, carbs:53,fat:0, sodium:8,   allergens:[],            tags:['swallow']},
    {id:'NG23',name:'Egusi Soup (1 bowl)',             kcal:300,protein:14,carbs:10,fat:24,sodium:420, allergens:[],            tags:['soup']},
    {id:'NG24',name:'Okra Soup (1 bowl)',              kcal:180,protein:10,carbs:12,fat:10,sodium:380, allergens:['Fish'],      tags:['soup']},
    {id:'NG25',name:'Afang Soup (1 bowl)',             kcal:240,protein:14,carbs:10,fat:16,sodium:400, allergens:['Fish'],      tags:['soup']},
    {id:'NG26',name:'Oha Soup (1 bowl)',               kcal:230,protein:13,carbs:9, fat:15,sodium:390, allergens:['Fish'],      tags:['soup']},
    {id:'NG27',name:'Vegetable Soup (Efo, 1 bowl)',    kcal:210,protein:12,carbs:9, fat:14,sodium:360, allergens:['Fish'],      tags:['soup']},
    {id:'NG28',name:'Bitter-leaf Soup (1 bowl)',       kcal:220,protein:13,carbs:8, fat:15,sodium:370, allergens:['Fish'],      tags:['soup']},
    {id:'NG29',name:'Ogbono Soup (1 bowl)',            kcal:260,protein:12,carbs:11,fat:18,sodium:400, allergens:['Fish'],      tags:['soup']},
    {id:'NG30',name:'Groundnut Soup (1 bowl)',         kcal:280,protein:14,carbs:12,fat:20,sodium:360, allergens:['Peanut'],    tags:['soup']},
    {id:'NG31',name:'Moringa Soup (1 bowl)',           kcal:170,protein:11,carbs:8, fat:9, sodium:300, allergens:[],            tags:['soup','wellness']},
    {id:'NG32',name:'Light Pepper Soup (Fish)',        kcal:150,protein:22,carbs:4, fat:5, sodium:320, allergens:['Fish'],      tags:['soup','soft']},
    {id:'NG33',name:'Light Pepper Soup (Chicken)',     kcal:180,protein:24,carbs:4, fat:7, sodium:340, allergens:[],            tags:['soup','soft']},
    {id:'NG34',name:'Grilled Fish (150g)',             kcal:175,protein:34,carbs:0, fat:4, sodium:90,  allergens:['Fish'],      tags:['protein']},
    {id:'NG35',name:'Grilled Chicken (skinless,150g)', kcal:220,protein:40,carbs:0, fat:6, sodium:100, allergens:[],            tags:['protein']},
    {id:'NG36',name:'Boiled Egg (2)',                  kcal:140,protein:12,carbs:1, fat:10,sodium:120, allergens:['Egg'],       tags:['protein','breakfast']},
    {id:'NG37',name:'Egg White Omelette',              kcal:90, protein:18,carbs:1, fat:0, sodium:160, allergens:['Egg'],       tags:['protein','breakfast']},
    {id:'NG38',name:'Turkey (grilled, 100g)',          kcal:190,protein:29,carbs:0, fat:8, sodium:110, allergens:[],            tags:['protein']},
    {id:'NG39',name:'Beef (lean, 100g)',               kcal:210,protein:26,carbs:0, fat:11,sodium:70,  allergens:[],            tags:['protein']},
    {id:'NG40',name:'Titus / Mackerel (grilled)',      kcal:200,protein:30,carbs:0, fat:9, sodium:95,  allergens:['Fish'],      tags:['protein']},
    {id:'NG41',name:'Beans & Plantain (Ewa+Dodo)',     kcal:340,protein:14,carbs:52,fat:9, sodium:150, allergens:[],            tags:['protein','carb']},
    {id:'NG42',name:'Vegetable Salad (no dressing)',   kcal:70, protein:2, carbs:12,fat:2, sodium:20,  allergens:[],            tags:['vegetable']},
    {id:'NG43',name:'Garden Egg (2)',                  kcal:40, protein:1, carbs:8, fat:0, sodium:5,   allergens:[],            tags:['vegetable','diabetic']},
    {id:'NG44',name:'Ugu / Fluted Pumpkin (steamed)',  kcal:60, protein:4, carbs:8, fat:1, sodium:25,  allergens:[],            tags:['vegetable']},
    {id:'NG45',name:'Steamed Vegetables',              kcal:80, protein:3, carbs:16,fat:1, sodium:35,  allergens:[],            tags:['vegetable']},
    {id:'NG46',name:'Cucumber (1 cup)',                kcal:20, protein:1, carbs:4, fat:0, sodium:2,   allergens:[],            tags:['vegetable','diabetic']},
    {id:'NG47',name:'Avocado (½)',                     kcal:120,protein:2, carbs:6, fat:11,sodium:5,   allergens:[],            tags:['healthy-fat']},
    {id:'NG48',name:'Groundnut (handful, 30g)',        kcal:170,protein:7, carbs:5, fat:14,sodium:5,   allergens:['Peanut'],    tags:['snack','healthy-fat']},
    {id:'NG49',name:'Tiger Nuts (30g)',                kcal:140,protein:2, carbs:18,fat:7, sodium:2,   allergens:[],            tags:['snack']},
    {id:'NG50',name:'Greek Yoghurt Parfait',           kcal:180,protein:12,carbs:20,fat:5, sodium:60,  allergens:['Lactose'],   tags:['snack','breakfast']},
    {id:'NG51',name:'Low-fat Yoghurt (1 cup)',         kcal:120,protein:9, carbs:15,fat:3, sodium:65,  allergens:['Lactose'],   tags:['snack']},
    {id:'NG52',name:'Fresh Fruit — Pawpaw (1 cup)',    kcal:60, protein:1, carbs:15,fat:0, sodium:10,  allergens:[],            tags:['fruit','soft']},
    {id:'NG53',name:'Fresh Fruit — Watermelon (1 cup)',kcal:45, protein:1, carbs:11,fat:0, sodium:2,   allergens:[],            tags:['fruit']},
    {id:'NG54',name:'Fresh Fruit — Orange (1)',        kcal:62, protein:1, carbs:15,fat:0, sodium:0,   allergens:[],            tags:['fruit']},
    {id:'NG55',name:'Banana (1)',                      kcal:105,protein:1, carbs:27,fat:0, sodium:1,   allergens:[],            tags:['fruit','soft']},
    {id:'NG56',name:'Apple (1)',                       kcal:95, protein:0, carbs:25,fat:0, sodium:2,   allergens:[],            tags:['fruit']},
    {id:'NG57',name:'Whole-grain Bread (2 slices)',    kcal:160,protein:8, carbs:28,fat:2, sodium:280, allergens:['Gluten'],    tags:['breakfast','fibre']},
    {id:'NG58',name:'Agege Bread (2 slices)',          kcal:200,protein:6, carbs:38,fat:3, sodium:300, allergens:['Gluten'],    tags:['breakfast']},
    {id:'NG59',name:'Sweet Corn & Coconut (1 cup)',    kcal:210,protein:5, carbs:34,fat:7, sodium:15,  allergens:[],            tags:['snack']},
    {id:'NG60',name:'Roasted Groundnut & Garden Egg',  kcal:200,protein:8, carbs:12,fat:14,sodium:8,   allergens:['Peanut'],    tags:['snack']},
    {id:'NG61',name:'Zobo (unsweetened, 1 cup)',       kcal:15, protein:0, carbs:3, fat:0, sodium:5,   allergens:[],            tags:['drink']},
    {id:'NG62',name:'Water (glass)',                   kcal:0,  protein:0, carbs:0, fat:0, sodium:0,   allergens:[],            tags:['drink']}
  ];

  function mergeFoodDB(){
    var D=D_(); if(!Array.isArray(D.foodItems)) D.foodItems=[];
    var have={}; D.foodItems.forEach(function(f){ if(f&&f.id) have[String(f.id)]=1; });
    var added=0;
    NG_FOODS.forEach(function(f){ if(!have[f.id]){ D.foodItems.push(JSON.parse(JSON.stringify(f))); added++; } });
    if(added){ try{ save(); }catch(e){} }
    return added;
  }

  /* ── Diabetes / Hypercholesterolemia instruction template ─────────────── */
  var DM_HCHOL_TEMPLATE = {
    'Regular Feeding':'Eat 3 balanced meals + 2 planned snacks daily at consistent times. Do NOT skip meals — especially breakfast. Combine a low-GI carbohydrate, a lean protein and vegetables/fibre at every main meal.',
    'Meal Timing':'Breakfast 7:30–8:30 am · Mid-morning snack 10:30 am · Lunch 1:30–2:30 pm · Mid-afternoon snack 4:30 pm · Dinner 7:00–8:00 pm (at least 2–3 hours before bed).',
    'Safe Foods':'Whole grains (oats, ofada/brown rice, wheat), beans/moi-moi, non-starchy vegetables (ugu, garden egg, cucumber), fish, skinless poultry, egg white, groundnut/tiger nuts in moderation, low-GI fruits (apple, pawpaw, orange, watermelon), unsweetened yoghurt.',
    'Foods to Avoid':'Sugary drinks (soft drinks, sweetened zobo, fruit juice), sweets and cakes, white bread and refined swallow in large portions, deep-fried foods, palm-oil-heavy stews, offals/organ meat, red-meat fat and skin, excess salt and seasoning cubes, alcohol.',
    'Water Intake':'Drink 2–3 litres of water daily unless your doctor has restricted fluids. Choose water or unsweetened drinks instead of soft drinks.',
    'Exercise':'At least 30 minutes of brisk walking or moderate activity on 5 days each week. Add light resistance twice a week. Avoid long unbroken sitting.',
    'Lifestyle':'Monitor and record fasting/2-hour blood glucose as advised. Check blood pressure and lipids at reviews. Maintain a healthy weight, stop smoking and limit alcohol. Manage stress and keep regular sleep.',
    'Warning Signs':'Report immediately: blood sugar very high or very low, chest pain or tightness, breathlessness, blurred vision, numbness/tingling in feet, non-healing wounds, or severe headache.',
    'Follow-up':'Attend scheduled clinic reviews with your glucose and blood-pressure log, and repeat lipid/HbA1c tests as requested. Return sooner if symptoms worsen.'
  };

  function registerTemplate(){
    if(typeof window.__MPB_addTemplate==='function'){
      window.__MPB_addTemplate('Diabetes / Hypercholesterolemia', DM_HCHOL_TEMPLATE);
      return true;
    }
    return false;
  }

  /* ── searchable food datalist (built once, refreshed as DB grows) ─────── */
  var DL_ID='v202-food-list';
  function ensureFoodDatalist(){
    var dl=document.getElementById(DL_ID);
    if(!dl){ dl=document.createElement('datalist'); dl.id=DL_ID; document.body.appendChild(dl); }
    var D=D_(); var items=Array.isArray(D.foodItems)?D.foodItems:[];
    var sig=items.length+'';
    if(dl.getAttribute('data-sig')===sig) return dl;
    dl.setAttribute('data-sig',sig);
    dl.innerHTML=items.map(function(f){
      return '<option value="'+esc(f.name)+'">'+num(f.kcal)+' kcal · '+num(f.protein)+'g protein</option>';
    }).join('');
    return dl;
  }

  /* ── STEP 3: replace every plain .mpb-add dropdown with a search + custom picker ── */
  function cssEsc(s){ return String(s).replace(/"/g,'\\"'); }
  function upgradePickers(root){
    root=root||document;
    if(!window.__MPB_isOpen || !window.__MPB_isOpen()) return;
    ensureFoodDatalist();
    var blocks=root.querySelectorAll('.mpb-add:not([data-v202])');
    blocks.forEach(function(add){
      var sel=add.querySelector('.mpb-addsel'); if(!sel) return;
      var meal=sel.getAttribute('data-meal')||'';
      add.setAttribute('data-v202','1');
      add.innerHTML=
        '<div class="v202-pick" data-meal="'+esc(meal)+'" style="display:flex;flex-wrap:wrap;gap:6px;align-items:center;width:100%">'+
          '<input class="v202-food" list="'+DL_ID+'" placeholder="Search food…" '+
            'style="flex:1;min-width:140px;border:1px solid #cbd5e1;border-radius:8px;padding:7px 9px;font-size:12px">'+
          '<input class="v202-qty" type="number" min="0.25" step="0.25" value="1" title="Quantity" '+
            'style="width:62px;border:1px solid #cbd5e1;border-radius:8px;padding:7px 8px;font-size:12px">'+
          '<button class="v202-addbtn" style="background:#0891b2;color:#fff;border:none;border-radius:8px;padding:7px 14px;font-size:12px;cursor:pointer">Add</button>'+
          '<button class="v202-customtoggle" title="Add a food not in the list" '+
            'style="background:#e2e8f0;color:#0f172a;border:none;border-radius:8px;padding:7px 10px;font-size:12px;cursor:pointer">+ Custom</button>'+
        '</div>'+
        '<div class="v202-custom" data-meal="'+esc(meal)+'" style="display:none;flex-wrap:wrap;gap:6px;align-items:center;width:100%;margin-top:6px;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:8px;padding:8px">'+
          '<input class="v202-cname" placeholder="Custom food name" style="flex:1;min-width:150px;border:1px solid #cbd5e1;border-radius:8px;padding:6px 8px;font-size:12px">'+
          '<input class="v202-ckcal" type="number" min="0" placeholder="kcal" title="Calories" style="width:70px;border:1px solid #cbd5e1;border-radius:8px;padding:6px;font-size:12px">'+
          '<input class="v202-cpro" type="number" min="0" placeholder="protein g" title="Protein (g)" style="width:80px;border:1px solid #cbd5e1;border-radius:8px;padding:6px;font-size:12px">'+
          '<input class="v202-ccarb" type="number" min="0" placeholder="carbs g" title="Carbs (g)" style="width:74px;border:1px solid #cbd5e1;border-radius:8px;padding:6px;font-size:12px">'+
          '<input class="v202-cfat" type="number" min="0" placeholder="fat g" title="Fat (g)" style="width:64px;border:1px solid #cbd5e1;border-radius:8px;padding:6px;font-size:12px">'+
          '<input class="v202-cna" type="number" min="0" placeholder="Na mg" title="Sodium (mg)" style="width:72px;border:1px solid #cbd5e1;border-radius:8px;padding:6px;font-size:12px">'+
          '<button class="v202-caddbtn" style="background:#0e7490;color:#fff;border:none;border-radius:8px;padding:6px 12px;font-size:12px;cursor:pointer">Add custom</button>'+
        '</div>';
      wirePicker(add, meal);
    });
  }

  function wirePicker(add, meal){
    function addFromSearch(){
      var nameEl=add.querySelector('.v202-food'); var qtyEl=add.querySelector('.v202-qty');
      var name=(nameEl&&nameEl.value||'').trim(); if(!name) return;
      var qty=num(qtyEl&&qtyEl.value,1)||1;
      if(window.__MPB_addFoodByName){ window.__MPB_addFoodByName(meal, name, qty); }
    }
    var addBtn=add.querySelector('.v202-addbtn');
    if(addBtn) addBtn.onclick=addFromSearch;
    var foodEl=add.querySelector('.v202-food');
    if(foodEl) foodEl.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); addFromSearch(); } });
    var tgl=add.querySelector('.v202-customtoggle');
    var custom=add.querySelector('.v202-custom');
    if(tgl&&custom) tgl.onclick=function(){ custom.style.display = custom.style.display==='none' ? 'flex' : 'none'; };
    var cbtn=add.querySelector('.v202-caddbtn');
    if(cbtn) cbtn.onclick=function(){
      var g=function(cls){ var el=add.querySelector(cls); return el?el.value:''; };
      var name=(g('.v202-cname')||'').trim(); if(!name){ return; }
      var macros={ kcal:num(g('.v202-ckcal')), protein:num(g('.v202-cpro')), carbs:num(g('.v202-ccarb')), fat:num(g('.v202-cfat')), sodium:num(g('.v202-cna')) };
      if(window.__MPB_addFoodByName){ window.__MPB_addFoodByName(meal, name, 1, macros); }
    };
  }

  /* ── observe the builder modal and upgrade pickers whenever it re-renders ── */
  // Phase 3: migrated off a private MutationObserver + 400ms backstop poll onto
  // the shared DOMBus. The old callback ignored the MutationRecords entirely —
  // it just checked for the builder overlay and upgraded its pickers — so a
  // full-document check on each (debounced) mutation is equivalent. upgradePickers
  // is idempotent (it skips already-upgraded pickers), so re-running is cheap.
  var _obsStarted=false;
  function watchBuilder(){
    if(_obsStarted || !window.DOMBus) return;
    _obsStarted=true;
    DOMBus.register(function(){
      var ov=document.getElementById('mpb-v195-ov');
      if(ov){ ensureFoodDatalist(); upgradePickers(ov); }
    });
  }

  function boot(){
    mergeFoodDB();
    registerTemplate();
    ensureFoodDatalist();
    watchBuilder();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  // re-seed after late data hydration
  setTimeout(function(){ mergeFoodDB(); registerTemplate(); ensureFoodDatalist(); }, 800);
  setTimeout(function(){ mergeFoodDB(); registerTemplate(); ensureFoodDatalist(); }, 2500);
  setTimeout(function(){ mergeFoodDB(); registerTemplate(); ensureFoodDatalist(); }, 5000);

  // expose for tests / manual use
  window.__V202 = { mergeFoodDB:mergeFoodDB, NG_FOODS:NG_FOODS, upgradePickers:upgradePickers, template:DM_HCHOL_TEMPLATE };

  console.log('%c✅ v202 Clinical Meal Planner upgrade (searchable + custom foods, NG food DB, DM/HChol template)','color:#0e7490;font-weight:bold');
})();

;

/* ==== /js/154-twh-wellness-master-v204.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v204 — EMR MASTER IMPLEMENTATION PROMPT: final wiring
   Closes the remaining gaps against EMR_Master_Implementation_Prompt.md.
   All PART-2 (14 revisions), PART-2.2 (Refer to Wellness Officer + auto Dx)
   and the PART-4 assessment→prescription flow were already delivered by the
   v131 pack; STEP 1/2/3 of the meal planner by v195/v202/v203. This pack:

     • PART 4 — routes the "Generate Meal Plan" / "Meal Planner" action to the
       superior CLINICAL builder (v195/v202/v203 __MPB_open: radio duration +
       meal-pattern, auto Day×meal matrix, searchable + custom hospital-food
       pickers, live totals vs prescription, week-labelled print) instead of
       the older single-day planner — carrying the prescription targets +
       diagnosis from the Comprehensive Wellness Assessment.

     • PART 1 — makes the Stage-3 SEVERE-RISK escalation a PROMINENT,
       immediate High-Priority Alert (full-width red banner + notification).

     • PART 3 — repositions the Dietary Nutrient Calculator UI with a clear
       banner: it is the hospital Recipe Database + Kitchen Management tool,
       NOT a patient diet-prescription tool (kept — production sheet intact).

   Idempotent IIFE; re-asserts after late packs; binds to the live host D.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV204) return; window.__twhV204 = true;

  function DD(){ return (typeof window.D!=='undefined' && window.D) ? window.D : null; }
  function curRole(){ var D=DD(); return (D&&D.currentUser&&(D.currentUser.role||D.currentUser.roleName))||'Staff'; }
  function toastMsg(m,t){ try{ if(typeof window.toast==='function') window.toast(m,t); }catch(e){} }
  function patObj(id){ var D=DD(); if(!D) return null; return (D.patients||[]).find(function(p){return String(p.id)===String(id);})||null; }

  /* ─────────────────────────────────────────────────────────────────────────
     PART 4 — route Generate Meal Plan → CLINICAL builder (__MPB_open)
     The v131 planner (window.openMealPlanner) is superseded by the v195/v202/
     v203 Clinical Meal Plan Builder, which alone satisfies the master prompt's
     STEP 1 (radio duration + meal pattern), STEP 2 (auto Day×meal matrix),
     STEP 3 (searchable/custom hospital food picker) and STEP 6 (week-labelled
     print). We keep the SAME public entry point (openMealPlanner) so every
     existing call-site — "Save & Open Meal Planner", patient-record buttons,
     the assessment CDSS panel — now lands in the clinical builder, pre-linked
     to the patient's prescription targets & diagnosis.
     ───────────────────────────────────────────────────────────────────────── */
  function toBuilderPrefill(patientId, prefill){
    prefill = prefill || {};
    var D=DD();
    // editing an existing saved clinical plan → let the builder load it
    if(prefill.editPlanId){ return {editPlanId:prefill.editPlanId}; }

    // pull the latest comprehensive assessment for prescription targets/dx
    var last=null;
    try{
      last=(D.comprehensiveAssessments||[]).filter(function(a){
        return String(a.patientId)===String(patientId) && (a.carePlan||a.calories||a.dietPlan);
      }).slice(-1)[0];
    }catch(e){}

    function pick(){ for(var i=0;i<arguments.length;i++){ var v=arguments[i]; if(v!==undefined && v!==null && v!==''){ return v; } } return undefined; }
    var cp = last && last.carePlan && last.carePlan.nutrition ? last.carePlan.nutrition : {};

    var cal = pick(prefill.calories, cp.calories, last&&last.calories, 2000);
    var pro = pick(prefill.proteinG, cp.proteinG, 70);
    var carb= pick(prefill.carbG, Math.round((cal*0.5)/4));
    var fat = pick(prefill.fatG,  Math.round((cal*0.28)/9));
    var na  = pick(prefill.sodiumMg, (String(pick(prefill.dietType,cp.dietType,'')).toLowerCase().indexOf('sodium')>-1||String(pick(prefill.diagnosis,last&&last.diagnosis,'')).toLowerCase().indexOf('hypertension')>-1)?1500:2000);
    var dx  = pick(prefill.diagnosis, last&&last.diagnosis, '');

    return {
      target:{ calories:+cal||2000, proteinG:+pro||70, carbG:+carb||250, fatG:+fat||65, sodiumMg:+na||2000 },
      dx: dx || ''
    };
  }

  function installMealPlannerRoute(){
    if(typeof window.__MPB_open!=='function') return false;        // builder not loaded yet
    if(window.openMealPlanner && window.openMealPlanner.__v204) return true;  // already routed

    var legacy = window.openMealPlanner;   // v131 simple planner (fallback)
    var routed = function(patientId, prefill){
      // role gate mirrors the builder's intended users
      var allow=['System Administrator','Super System Admin','CMO','Nutritionist','Dietitian','Wellness Officer'];
      if(allow.indexOf(curRole())===-1 && curRole()!=='Staff'){
        if(typeof window.showModal==='function'){
          window.showModal('Access Denied',
            '<div class="card"><i class="fa-solid fa-lock" style="color:var(--red,#ef4444);margin-right:6px"></i>Meal planning is completed by a Dietitian, Nutritionist or Wellness Officer.</div>',
            '<button class="btn btn-ghost" onclick="closeModal()">Close</button>');
          return;
        }
      }
      try{
        var pf=toBuilderPrefill(patientId, prefill);
        window.__MPB_open(patientId||null, pf);
      }catch(e){
        try{ if(typeof legacy==='function') return legacy(patientId, prefill); }catch(_){}
        toastMsg('Could not open the clinical meal planner');
      }
    };
    routed.__v204 = true;
    routed.__legacy = legacy;
    window.openMealPlanner = routed;
    return true;
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PART 1 — prominent High-Priority Alert for Severe-Risk on assessment save
     Wrap wSaveL3 so that, after the v131 save runs, a full-width red banner is
     shown immediately for Severe Risk (Stage-3 red-flag routing).
     ───────────────────────────────────────────────────────────────────────── */
  function highPriorityAlert(name, risk){
    try{
      // 1) system notification (escalated channel)
      if(typeof window.pushNotification==='function'){
        window.pushNotification('🚨 HIGH-PRIORITY WELLNESS ALERT',
          name+' — '+risk+'. Immediate multidisciplinary review required.', 'er', 'wellness');
      }
    }catch(e){}
    // 2) prominent on-screen banner
    try{
      var id='v204-hpa'; var old=document.getElementById(id); if(old) old.parentNode.removeChild(old);
      var bar=document.createElement('div'); bar.id=id;
      bar.style.cssText='position:fixed;top:0;left:0;right:0;z-index:99999;background:linear-gradient(90deg,#b91c1c,#ef4444);color:#fff;'+
        'padding:14px 20px;font-weight:800;display:flex;align-items:center;gap:12px;box-shadow:0 4px 18px rgba(0,0,0,.3);animation:v204pulse 1s ease-in-out infinite alternate';
      bar.innerHTML='<i class="fa-solid fa-triangle-exclamation" style="font-size:20px"></i>'+
        '<span style="flex:1">HIGH-PRIORITY ALERT — '+escHtml(name)+' assessed as <u>'+escHtml(risk)+'</u>. IMMEDIATE clinical intervention &amp; multidisciplinary review required.</span>'+
        '<button onclick="var e=document.getElementById(\''+id+'\');if(e)e.parentNode.removeChild(e);" style="background:rgba(255,255,255,.2);border:none;color:#fff;padding:6px 12px;border-radius:8px;cursor:pointer;font-weight:700">Acknowledge</button>';
      document.body.appendChild(bar);
      if(!document.getElementById('v204-hpa-css')){
        var st=document.createElement('style'); st.id='v204-hpa-css';
        st.textContent='@keyframes v204pulse{from{opacity:.85}to{opacity:1}}';
        document.head.appendChild(st);
      }
      setTimeout(function(){ var e=document.getElementById(id); if(e&&e.parentNode) e.parentNode.removeChild(e); }, 15000);
    }catch(e){}
  }
  function escHtml(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function installSevereAlert(){
    if(typeof window.wSaveL3!=='function') return false;
    if(window.wSaveL3.__v204) return true;
    var orig=window.wSaveL3;
    var wrapped=function(openMeal){
      var before=(DD()&&DD().comprehensiveAssessments)?DD().comprehensiveAssessments.length:0;
      var beforeIds={}; try{ (DD().comprehensiveAssessments||[]).forEach(function(a){beforeIds[a.id]=a.overallRisk||a.risk;}); }catch(e){}
      var ret=orig.apply(this, arguments);
      try{
        var list=(DD()&&DD().comprehensiveAssessments)||[];
        // find the just-saved/updated completed record with the highest recency
        var rec=list.filter(function(a){return a.status==='Completed';}).slice(-1)[0];
        if(rec){
          var risk=(rec.overallRisk||rec.risk||'');
          if(/severe/i.test(risk)){
            highPriorityAlert(rec.patientName||('Patient #'+rec.patientId), risk);
          }
        }
      }catch(e){}
      return ret;
    };
    wrapped.__v204=true; wrapped.__orig=orig;
    window.wSaveL3=wrapped;
    return true;
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PART 3 — reposition the Dietary Nutrient Calculator as Recipe/Kitchen DB
     Wrap renderNutrition to prepend a clear banner. Purely additive (keeps the
     recipe nutrient calculator, standard recipes table and Kitchen Production
     Sheet exactly as built).
     ───────────────────────────────────────────────────────────────────────── */
  function installNutritionBanner(){
    if(typeof window.renderNutrition!=='function') return false;
    if(window.renderNutrition.__v204) return true;
    var orig=window.renderNutrition;
    var wrapped=function(){
      var inner=orig.apply(this, arguments);
      var banner='<div class="alert" style="margin-bottom:14px;border-left:4px solid #d97706;background:#fffbeb;color:#78350f;display:flex;gap:12px;align-items:flex-start;padding:12px 14px;border-radius:10px">'+
        '<i class="fa-solid fa-kitchen-set" style="color:#d97706;font-size:18px;margin-top:2px"></i>'+
        '<div style="font-size:12.5px;line-height:1.5"><b>Hospital Recipe Database &amp; Kitchen Management</b> — this module maintains standard hospital trays/recipes '+
        '(Regular, Diabetic, Renal, Cardiac Low-Sodium, Soft, High-Protein …) with stored nutrient composition &amp; allergens, and the daily '+
        '<b>Kitchen Production Sheet</b>. It is <u>not</u> a patient diet-prescription tool. For an individual patient prescription, use '+
        '<b>Wellness → Comprehensive Assessment → Generate Meal Plan</b> (the Clinical Meal Plan Builder).</div></div>';
      return banner + (inner||'');
    };
    wrapped.__v204=true; wrapped.__orig=orig;
    window.renderNutrition=wrapped;
    return true;
  }

  /* ── apply now + re-assert after late packs / re-renders ─────────────────── */
  function applyAll(){
    installMealPlannerRoute();
    installSevereAlert();
    installNutritionBanner();
  }
  applyAll();
  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll,ms); });
  if(typeof window.addEventListener==='function'){ window.addEventListener('load',function(){ applyAll(); setTimeout(applyAll,600); }); }
  DOMBus.register(applyAll);

  window.__V204 = { toBuilderPrefill:toBuilderPrefill, applyAll:applyAll, highPriorityAlert:highPriorityAlert };
  try{ console.log('%c✅ v204 EMR master wiring — Generate Meal Plan → clinical builder, severe-risk High-Priority Alert, recipe/kitchen repositioning','background:#6d28d9;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/155-twh-appointments-sort-v205.js ==== */
/* ============================================================================
   Tranquil HMS — v205 · Appointment Sort & Persist
   ----------------------------------------------------------------------------
   Request D: "Fix all the created appointment records to be sorted by date and
   saved in the application for all the completed and others. it should be
   viewable and editable stored on github and cloudflare."

   What this pack does (idempotent, non-destructive):
   1) sortAppointments() — sorts D.appointments IN PLACE, ascending, by
      parsed date (ISO YYYY-MM-DD) then AM/PM-aware time. Covers ALL statuses
      (Completed, Scheduled, Confirmed, In Progress, Cancelled, No Show).
      Because the underlying array is sorted, the appointments table, the
      dashboard "recent" lists, the calendar and reminders all render
      chronologically, and the sorted order is what _hmsSave() persists to D1
      (Cloudflare) and what GitHub stores.
   2) Wraps saveNewRecord() — after creating a record it re-sorts appointments
      (when dataKey==='appointments') and forces an immediate window._hmsSave()
      so newly created appointments persist to Cloudflare right away (closes the
      create-time persistence gap).
   3) Wraps editRecord() save path indirectly via a post-render re-sort, and
      re-sorts on load + on a light interval so the list stays chronological.
   4) View/Edit are untouched — they look records up by id, so array order does
      not affect them; records remain viewable and editable.
   ========================================================================== */
(function(){
  if(window.__twhV205) return;
  window.__twhV205 = true;

  // ── AM/PM-aware time → minutes-since-midnight. Accepts "9:00 AM",
  //    "1:30 PM", "13:30", "9 AM", "", null. Unknown/blank sorts last (big).
  function timeToMinutes(t){
    if(t==null) return 100000;
    var s = String(t).trim();
    if(!s) return 100000;
    var m = s.match(/^(\d{1,2})(?::(\d{2}))?\s*([AaPp][Mm])?/);
    if(!m) return 100000;
    var h = parseInt(m[1],10);
    var min = m[2]!=null ? parseInt(m[2],10) : 0;
    var ap = m[3] ? m[3].toUpperCase() : '';
    if(ap==='AM'){ if(h===12) h=0; }
    else if(ap==='PM'){ if(h!==12) h+=12; }
    if(isNaN(h)) h=0; if(isNaN(min)) min=0;
    return h*60 + min;
  }

  // ── date (ISO YYYY-MM-DD) → sortable number. Blank/invalid sorts last.
  function dateToNum(d){
    if(d==null) return 99999999;
    var s = String(d).trim();
    if(!s) return 99999999;
    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if(m){ return parseInt(m[1]+m[2]+m[3],10); }
    // fallback: try Date.parse for other formats
    var p = Date.parse(s);
    if(!isNaN(p)){
      var dt = new Date(p);
      return dt.getFullYear()*10000 + (dt.getMonth()+1)*100 + dt.getDate();
    }
    return 99999999;
  }

  // ── The core sorter: sorts D.appointments in place across ALL statuses.
  //    Stable-ish: ties broken by code then id so order is deterministic.
  window.__V205_sortAppointments = function sortAppointments(){
    try{
      if(typeof D==='undefined' || !D || !Array.isArray(D.appointments)) return false;
      var before = D.appointments.map(function(a){return a && a.id;}).join(',');
      D.appointments.sort(function(a,b){
        var da = dateToNum(a && a.date), db = dateToNum(b && b.date);
        if(da!==db) return da-db;
        var ta = timeToMinutes(a && a.time), tb = timeToMinutes(b && b.time);
        if(ta!==tb) return ta-tb;
        var ca = String((a&&a.code)||''), cb = String((b&&b.code)||'');
        if(ca!==cb) return ca<cb?-1:1;
        var ia = (a&&a.id)||0, ib = (b&&b.id)||0;
        return ia-ib;
      });
      var after = D.appointments.map(function(a){return a && a.id;}).join(',');
      return before!==after; // true if order actually changed
    }catch(e){ return false; }
  };
  window.__V205_timeToMinutes = timeToMinutes;
  window.__V205_dateToNum = dateToNum;

  function persistNow(){
    try{
      if(typeof window._hmsSave==='function') return window._hmsSave();
      if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon();
    }catch(e){}
  }

  function doRender(){
    try{
      if(typeof window.render==='function') return window.render();
      if(typeof render==='function') return render();
    }catch(e){}
  }

  // ── Wrap saveNewRecord: sort + immediate persist after create.
  function installSaveWrap(){
    if(typeof window.saveNewRecord!=='function') return false;
    if(window.saveNewRecord.__v205) return true;
    var orig = window.saveNewRecord;
    var wrapped = function(dataKey){
      var r = orig.apply(this, arguments);
      try{
        if(dataKey==='appointments'){ window.__V205_sortAppointments(); }
        // Persist EVERY create immediately to D1/Cloudflare (closes the gap where
        // saveNewRecord relied only on the debounce/backstop). Then re-render so the
        // sorted order is reflected in the table.
        persistNow();
        if(dataKey==='appointments'){ doRender(); }
      }catch(e){}
      return r;
    };
    wrapped.__v205 = true;
    window.saveNewRecord = wrapped;
    return true;
  }

  // ── Wrap editRecord: keep sorted after an edit (edit already persists via
  //    _hmsSave in core). We hook the save button re-render by re-sorting on the
  //    next tick after the modal save fires. Simplest robust approach: re-sort +
  //    persist on a short interval and after any render. editRecord itself is
  //    left intact so view/edit-by-id behaviour is unchanged.
  function installEditWrap(){
    if(typeof window.editRecord!=='function') return false;
    if(window.editRecord.__v205) return true;
    var orig = window.editRecord;
    var wrapped = function(dataKey,id){
      var r = orig.apply(this, arguments);
      // After the edit modal is opened, patch its save so that once the user
      // saves we re-sort appointments. We do this by re-sorting shortly after
      // the modal closes via a micro-poll on modal presence.
      if(dataKey==='appointments'){
        try{
          var tries=0;
          var iv=setInterval(function(){
            tries++;
            var modalOpen = !!document.querySelector('.modal-overlay, #modalRoot .modal, [id="modalBody"]');
            // when modal has closed (save/cancel), re-sort + persist once
            if(!modalOpen || tries>40){
              clearInterval(iv);
              if(window.__V205_sortAppointments()){ persistNow(); doRender(); }
            }
          }, 250);
        }catch(e){}
      }
      return r;
    };
    wrapped.__v205 = true;
    window.editRecord = wrapped;
    return true;
  }

  function applyAll(){
    installSaveWrap();
    installEditWrap();
    // Ensure appointments are sorted for the current session/render.
    window.__V205_sortAppointments();
  }

  // Re-assert repeatedly (data loads async from D1; other packs also wrap fns).
  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll, ms); });
  DOMBus.register(function(){
    installSaveWrap(); installEditWrap();
    // keep the array sorted; only persist if the order actually changed to
    // avoid needless writes.
    if(window.__V205_sortAppointments()){ persistNow(); }
  });
  try{ window.addEventListener('load', applyAll); }catch(e){}

  window.__V205 = {
    sortAppointments: window.__V205_sortAppointments,
    timeToMinutes: timeToMinutes,
    dateToNum: dateToNum,
    applyAll: applyAll
  };

  try{ console.log('%c✅ v205 appointments sort & persist','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/156-twh-medrec-suite-v206.js ==== */
/* ============================================================================
   Tranquil HMS — v206 · Medical-Records Suite + Front-Desk lock + Txn edit +
                          Sync-error self-heal
   ----------------------------------------------------------------------------
   Request (this turn):
   1) "Do same for medical records" → sort D.medicalRecords by date (visitDate)
      across ALL statuses, persist immediately on create, stay sorted after
      add/edit; viewable + editable (mirror of v205 for appointments).
   2) "remove duplicate items and keep one" → dedupe D.medicalRecords (and a few
      other core collections) keeping the first occurrence.
   3) "Let front desk officers be viewable only to medical record" → Front Desk
      Officer can VIEW medical records but cannot add / edit / finalize / delete.
   4) "Perfectly store all medical record on the database and also on the
      frontend" → force immediate _hmsSave() on every medical-record create /
      edit / finalize so records persist to D1 (Cloudflare) and re-render.
   5) "allow to edit transactions created on the part of the attachment" → add
      an Edit action to transaction rows (editTransaction) so a posted txn can
      be corrected; persists immediately.
   6) "clear the sync error" → proactively kick a save on boot and the instant
      an error is observed, and expose window.__clearSyncError() so the pill
      clears as soon as a write succeeds.

   Idempotent IIFE, guarded by __twhV206. Non-destructive: wraps existing fns.
   ========================================================================== */
(function(){
  if(window.__twhV206) return;
  window.__twhV206 = true;

  function D_(){ return window.D || {}; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function persistNow(){
    try{
      if(typeof window._hmsSave==='function') return window._hmsSave();
      if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon();
    }catch(e){}
  }
  function doRender(){
    try{
      if(typeof window.render==='function') return window.render();
      if(typeof render==='function') return render();
    }catch(e){}
  }
  function curRole(){
    try{ return (D_().currentUser && D_().currentUser.role) || ''; }catch(e){ return ''; }
  }
  function isFrontDeskRole(){ return /front\s*desk|reception/i.test(curRole()) && !/administrator|admin|ceo/i.test(curRole()); }

  /* ═══════════════════════════════════════════════════════════════════════
     (1) SORT MEDICAL RECORDS BY DATE — ALL STATUSES, IN PLACE (persistent)
     ═══════════════════════════════════════════════════════════════════════ */
  function dateToNum(d){
    if(d==null) return 99999999;
    var s=String(d).trim(); if(!s) return 99999999;
    var m=s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if(m) return parseInt(m[1]+m[2]+m[3],10);
    var p=Date.parse(s);
    if(!isNaN(p)){ var dt=new Date(p); return dt.getFullYear()*10000+(dt.getMonth()+1)*100+dt.getDate(); }
    return 99999999;
  }
  function hasDate(d){ if(d==null) return false; return !!String(d).trim(); }
  // Newest first (descending) so the most recent clinical visit is on top;
  // covers ALL statuses (Open, Finalized, Amended, Voided). Records with NO
  // date always sort LAST (regardless of the descending order).
  window.__V206_sortMedicalRecords = function sortMedicalRecords(){
    try{
      var d=D_(); if(!Array.isArray(d.medicalRecords)) return false;
      var before=d.medicalRecords.map(function(r){return r&&r.id;}).join(',');
      d.medicalRecords.sort(function(a,b){
        var va=a&&(a.visitDate||a.date), vb=b&&(b.visitDate||b.date);
        var ha=hasDate(va), hb=hasDate(vb);
        if(ha!==hb) return ha?-1:1;               // dated records before undated
        if(ha && hb){
          var da=dateToNum(va), db=dateToNum(vb);
          if(da!==db) return db-da;               // newest date first
        }
        var ca=String((a&&a.code)||''), cb=String((b&&b.code)||'');
        if(ca!==cb) return ca<cb?1:-1;            // newer code first
        return ((b&&b.id)||0)-((a&&a.id)||0);
      });
      var after=d.medicalRecords.map(function(r){return r&&r.id;}).join(',');
      return before!==after;
    }catch(e){ return false; }
  };
  window.__V206_dateToNum = dateToNum;

  /* ═══════════════════════════════════════════════════════════════════════
     (2) DEDUPE — keep one, remove duplicates (medical records + core lists)
     ═══════════════════════════════════════════════════════════════════════ */
  function dedupeArray(arr, keyFn){
    if(!Array.isArray(arr)) return false;
    var seen={}, out=[], changed=false;
    for(var i=0;i<arr.length;i++){
      var it=arr[i]; if(!it){ changed=true; continue; }
      var k=keyFn(it);
      if(k!=null && seen[k]){ changed=true; continue; }
      if(k!=null) seen[k]=1;
      out.push(it);
    }
    if(changed){ arr.length=0; for(var j=0;j<out.length;j++) arr.push(out[j]); }
    return changed;
  }
  window.__V206_dedupeAll = function dedupeAll(){
    var d=D_(), changed=false;
    // Medical records: a record is unique by code, else by id.
    if(dedupeArray(d.medicalRecords, function(r){ return r.code || ('id:'+r.id); })) changed=true;
    // Other high-churn collections that can accumulate dup rows.
    if(dedupeArray(d.appointments,  function(r){ return r.code || ('id:'+r.id); })) changed=true;
    if(dedupeArray(d.transactions,  function(r){ return r.code || ('id:'+r.id); })) changed=true;
    if(dedupeArray(d.prescriptions, function(r){ return r.code || ('id:'+r.id); })) changed=true;
    if(dedupeArray(d.labTests,      function(r){ return r.code || ('id:'+r.id); })) changed=true;
    return changed;
  };

  /* ═══════════════════════════════════════════════════════════════════════
     (3) FRONT DESK = VIEW-ONLY on Medical Records
     Remove add / edit / finalize / delete controls from the EMR module for a
     Front Desk Officer, and hard-block the underlying CRUD entry points.
     ═══════════════════════════════════════════════════════════════════════ */
  function stripEmrWriteForFrontDesk(){
    if(!isFrontDeskRole()) return;
    try{
      var mod = (typeof window.currentMod!=='undefined') ? window.currentMod : null;
      if(mod && mod!=='emr') return;              // only touch the EMR screen
      // Remove "New Record" / add buttons for medicalRecords
      document.querySelectorAll('button[onclick*="addNewRecord(\'medicalRecords\'"]').forEach(function(b){ b.remove(); });
      // Remove edit / finalize / delete action buttons on EMR rows
      document.querySelectorAll('.act-row button').forEach(function(b){
        var oc=b.getAttribute('onclick')||'';
        if(/editRecord\('medicalRecords'/.test(oc) ||
           /finalizeRecord\(/.test(oc) ||
           /deleteRecord\('medicalRecords'/.test(oc)){
          b.remove();
        }
      });
    }catch(e){}
  }
  // Hard guard: block the write CRUD functions for Front Desk on medicalRecords.
  function installFrontDeskGuards(){
    ['addNewRecord','editRecord','deleteRecord'].forEach(function(fn){
      if(typeof window[fn]!=='function' || window[fn].__v206fd) return;
      var orig=window[fn];
      var wrapped=function(dataKey){
        if(dataKey==='medicalRecords' && isFrontDeskRole()){
          try{ if(window.toast) toast('Front Desk has view-only access to medical records','err'); }catch(e){}
          return;
        }
        return orig.apply(this, arguments);
      };
      wrapped.__v206fd=true;
      window[fn]=wrapped;
    });
    if(typeof window.finalizeRecord==='function' && !window.finalizeRecord.__v206fd){
      var of=window.finalizeRecord;
      var wf=function(){ if(isFrontDeskRole()){ try{ if(window.toast) toast('Front Desk cannot finalize medical records','err'); }catch(e){} return; } return of.apply(this,arguments); };
      wf.__v206fd=true; window.finalizeRecord=wf;
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (4)+(perfect store) — immediate persist on EMR create/edit/finalize +
     keep sorted; wraps generic saveNewRecord / editRecord save / finalizeRecord
     ═══════════════════════════════════════════════════════════════════════ */
  function installSaveWrap(){
    if(typeof window.saveNewRecord!=='function' || window.saveNewRecord.__v206) return;
    var orig=window.saveNewRecord;
    var wrapped=function(dataKey){
      var r=orig.apply(this, arguments);
      try{
        if(dataKey==='medicalRecords'){ window.__V206_sortMedicalRecords(); }
        persistNow();                             // perfect store → D1/Cloudflare
        if(dataKey==='medicalRecords'){ doRender(); }
      }catch(e){}
      return r;
    };
    wrapped.__v206=true; window.saveNewRecord=wrapped;
  }
  function installFinalizeWrap(){
    if(typeof window.finalizeRecord!=='function' || window.finalizeRecord.__v206) return;
    var orig=window.finalizeRecord;
    var wrapped=function(){ var r=orig.apply(this,arguments); try{ window.__V206_sortMedicalRecords(); persistNow(); }catch(e){} return r; };
    wrapped.__v206=true;
    // preserve the front-desk guard flag if present
    if(orig.__v206fd) wrapped.__v206fd=true;
    window.finalizeRecord=wrapped;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (5) EDIT TRANSACTIONS — add an editable form for a posted transaction.
     ═══════════════════════════════════════════════════════════════════════ */
  window.editTransaction = function editTransaction(id){
    var d=D_();
    var t=(d.transactions||[]).find(function(x){ return x.id===id || String(x.id)===String(id); });
    if(!t){ try{ if(window.toast) toast('Transaction not found','err'); }catch(e){} return; }
    if(isFrontDeskRole()){ try{ if(window.toast) toast('Front Desk cannot edit transactions','err'); }catch(e){} return; }
    var methods=((d.cfgLists&&d.cfgLists.paymentMethods)||['Cash','POS/Card','Bank Transfer','Cheque','Insurance','Wallet']);
    var methodO=methods.map(function(m){ return '<option value="'+esc(m)+'"'+(t.method===m?' selected':'')+'>'+esc(m)+'</option>'; }).join('');
    var statuses=['Completed','Pending','Approved','Void'];
    var statusO=statuses.map(function(s){ return '<option value="'+s+'"'+(t.status===s?' selected':'')+'>'+s+'</option>'; }).join('');
    var body=''
      + '<div class="form-grid">'
      + '<div class="form-group"><label>Code</label><input value="'+esc(t.code||'')+'" readonly style="background:#f8fafc"></div>'
      + '<div class="form-group"><label>Type</label><input id="etx_type" value="'+esc(t.type||'')+'"></div>'
      + '<div class="form-group"><label>Category</label><input id="etx_category" value="'+esc(t.category||'')+'"></div>'
      + '<div class="form-group"><label>Method</label><select id="etx_method">'+methodO+'</select></div>'
      + '<div class="form-group"><label>Amount (₦)</label><input id="etx_amount" type="number" value="'+(t.amount!=null?t.amount:0)+'"></div>'
      + '<div class="form-group"><label>Status</label><select id="etx_status">'+statusO+'</select></div>'
      + '<div class="form-group"><label>Bill Ref</label><input id="etx_billCode" value="'+esc(t.billCode||'')+'"></div>'
      + '<div class="form-group"><label>Reference</label><input id="etx_reference" value="'+esc(t.reference||'')+'"></div>'
      + '<div class="form-group"><label>Date</label><input id="etx_date" type="date" value="'+esc(t.date||'')+'"></div>'
      + '<div class="form-group"><label>Cashier</label><input id="etx_cashier" value="'+esc(t.cashier||'')+'"></div>'
      + '<div class="form-group full"><label>Notes / Attachment reference</label><textarea id="etx_notes" rows="2">'+esc(t.notes||'')+'</textarea></div>'
      + '</div>';
    var footer='<button class="btn btn-pri" onclick="__V206_saveTxnEdit('+ (isNaN(id)?("'"+String(id)+"'"):id) +')"><i class="fa-solid fa-save"></i> Save Changes</button>'
             + '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    try{ window.showModal('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit Transaction — '+esc(t.code||''), body, footer); }
    catch(e){}
  };
  window.__V206_saveTxnEdit = function(id){
    var d=D_();
    var t=(d.transactions||[]).find(function(x){ return x.id===id || String(x.id)===String(id); });
    if(!t) return;
    function val(k){ var el=document.getElementById(k); return el?el.value:undefined; }
    var newAmt=parseFloat(val('etx_amount')); if(isNaN(newAmt)) newAmt=t.amount;
    t.type=val('etx_type')||t.type;
    t.category=val('etx_category');
    t.method=val('etx_method')||t.method;
    t.amount=newAmt;
    t.status=val('etx_status')||t.status;
    t.billCode=val('etx_billCode')||null;
    t.reference=val('etx_reference')||null;
    t.date=val('etx_date')||t.date;
    t.cashier=val('etx_cashier')||t.cashier;
    t.notes=val('etx_notes')||'';
    t._rev=Date.now();
    if(typeof window.auditAction==='function'){ try{ window.auditAction('FINANCE','Transactions','EDIT','Edited '+(t.code||t.id),'High'); }catch(e){} }
    try{ if(window.toast) toast('Transaction updated'); }catch(e){}
    try{ if(window.closeModal) closeModal(); }catch(e){}
    persistNow();                                  // store to DB + frontend
    doRender();
  };
  // Inject an Edit button into every transaction row (post-render), skipping
  // Void rows and hiding it for Front Desk.
  function injectTxnEditButtons(){
    if(isFrontDeskRole()) return;
    try{
      var mod=(typeof window.currentMod!=='undefined')?window.currentMod:null;
      if(mod && mod!=='transactions' && mod!=='finance') return;
      document.querySelectorAll('.act-row').forEach(function(row){
        // find the view button that targets transactions to anchor our edit btn
        var viewBtn=row.querySelector('button[onclick*="viewRecord(\'transactions\'"]');
        if(!viewBtn) return;
        if(row.querySelector('button.__v206_txnedit')) return; // already added
        var m=(viewBtn.getAttribute('onclick')||'').match(/viewRecord\('transactions',\s*([^\)]+)\)/);
        if(!m) return;
        var idArg=m[1].trim();
        var b=document.createElement('button');
        b.className='act-btn edit __v206_txnedit';
        b.title='Edit transaction';
        b.setAttribute('onclick','editTransaction('+idArg+')');
        b.innerHTML='<i class="fa-solid fa-pen-to-square"></i>';
        viewBtn.parentNode.insertBefore(b, viewBtn.nextSibling);
      });
    }catch(e){}
  }

  /* ═══════════════════════════════════════════════════════════════════════
     (6) CLEAR SYNC ERROR — proactive self-heal
     The delta/chunked writers already retry; we make sure the pill clears by
     kicking a save on boot + the moment an error is seen, and expose a manual
     clear. A successful write flips HMS_DB.syncState back to 'idle' which the
     v185 chip subscribes to.
     ═══════════════════════════════════════════════════════════════════════ */
  window.__clearSyncError = function(){
    try{
      if(window.HMS_DB && window.HMS_DB.syncState==='error'){
        // Prefer the resilient chunked path if present, else a plain save.
        if(typeof window.resilientSaveSoon==='function') window.resilientSaveSoon('v206-clear');
        else persistNow();
      } else {
        persistNow();
      }
    }catch(e){}
  };
  var _syncBound=false;
  function bindSyncHeal(){
    if(_syncBound) return;
    if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
      _syncBound=true;
      var last=0;
      window.HMS_DB.onState(function(state){
        if(state==='error'){
          var now=Date.now(); if(now-last<2000) return; last=now;
          setTimeout(function(){ if(window.HMS_DB && window.HMS_DB.syncState==='error') window.__clearSyncError(); }, 900);
        }
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     BOOT / RE-ASSERT
     ═══════════════════════════════════════════════════════════════════════ */
  function applyAll(){
    installSaveWrap();
    installFinalizeWrap();
    installFrontDeskGuards();
    bindSyncHeal();
    var changed=false;
    if(window.__V206_dedupeAll()) changed=true;
    window.__V206_sortMedicalRecords();
    stripEmrWriteForFrontDesk();
    injectTxnEditButtons();
    if(changed) persistNow();
  }

  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll, ms); });
  DOMBus.register(function(){
    installSaveWrap(); installFinalizeWrap(); installFrontDeskGuards(); bindSyncHeal();
    var changed=window.__V206_dedupeAll();
    if(window.__V206_sortMedicalRecords()) changed=true;
    stripEmrWriteForFrontDesk();
    injectTxnEditButtons();
    if(changed) persistNow();
  });
  try{ window.addEventListener('load', applyAll); }catch(e){}
  // One proactive save shortly after boot to clear any stuck "Sync error".
  setTimeout(function(){ try{ window.__clearSyncError(); }catch(e){} }, 2500);

  window.__V206 = {
    sortMedicalRecords: window.__V206_sortMedicalRecords,
    dedupeAll: window.__V206_dedupeAll,
    editTransaction: window.editTransaction,
    isFrontDeskRole: isFrontDeskRole,
    clearSyncError: window.__clearSyncError,
    applyAll: applyAll
  };

  try{ console.log('%c✅ v206 medical-records suite — sort+persist · dedupe · Front-Desk view-only · edit transactions · clear sync error','color:#065f46;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/157-twh-transactions-persist-v207.js ==== */
/* ============================================================================
   Tranquil HMS — v207 · Transactions Persist (create → D1 → frontend)
   ----------------------------------------------------------------------------
   Request F: "Connect Cloudflare to attach the database API to resolve sync
   error. Also, fix all data issues. Make all transactions created and stored
   in the database and also shown on the frontend of the application saved."

   ROOT CAUSE (diagnosed): every transaction-creation / mutation path
   (savePayment, saveRefund, saveWriteOff, saveCreditNote, saveDailyCashUp,
   confirmTransaction, voidTransaction, editTransaction, plus ~30 auto-charge
   push sites for lab/radiology/pharmacy/admission/insurance/gateway) ends with
   render() but NEVER calls window._hmsSave(). So transactions live only in the
   in-memory D object and are never written to the D1 shard — the `transactions`
   shard on Cloudflare is an empty array ([], 2 bytes). On reload the empty
   shard overwrites nothing, but nothing new is ever persisted either.

   What this pack does (idempotent, non-destructive, defence-in-depth):
   1) installTxnPushHook() — wraps D.transactions.push so ANY code path that
      pushes a transaction (including all the auto-charge sites) triggers an
      immediate persist to D1/Cloudflare. Chains safely with the existing v32
      SyncBus push wrap.
   2) installTxnMutationWatch() — keeps a lightweight signature of
      D.transactions (count + id/status/amount/_rev per row). On a short poll it
      persists whenever the signature changes. This catches IN-PLACE mutations
      (confirmTransaction sets status='Completed', voidTransaction sets
      status='Void', editTransaction rewrites fields) that .push() cannot see.
   3) Wraps the known creator/mutator functions to persist immediately after
      they run — fastest possible write, plus a re-render so the ledger shows
      the new/updated row right away.
   4) Robust id compare for confirm/void so a transaction posted in one session
      (numeric id) still matches after a D1 round-trip (string id).
   5) Guarantees D.transactions is always an array (repairs `data issues`).

   The sorted/deduped state written by _hmsSave() is exactly what D1
   (Cloudflare) stores and what the frontend re-hydrates on load, so
   transactions are: CREATED → STORED in the database → SHOWN on the frontend.
   ========================================================================== */
(function(){
  if(window.__twhV207) return;
  window.__twhV207 = true;

  function DD(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }

  function persistNow(){
    try{
      if(typeof window._hmsSave==='function') return window._hmsSave();
      if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon();
    }catch(e){}
  }
  // Debounced persist so a burst of pushes (e.g. auto-charges) collapses into
  // one write. Falls back to immediate if the debounce global is missing.
  var _pt=null;
  function persistSoon(){
    try{
      if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon();
      if(_pt) clearTimeout(_pt);
      _pt=setTimeout(function(){ _pt=null; persistNow(); }, 250);
    }catch(e){}
  }

  function doRender(){
    try{
      if(typeof window.render==='function') return window.render();
      if(typeof render==='function') return render();
    }catch(e){}
  }

  // ── (5) Guarantee D.transactions is an array.
  function ensureArray(){
    var d=DD(); if(!d) return false;
    if(!Array.isArray(d.transactions)){ d.transactions=[]; return true; }
    return false;
  }

  // ── (1) Wrap D.transactions.push to persist on every push.
  function installTxnPushHook(){
    var d=DD(); if(!d || !Array.isArray(d.transactions)) return false;
    var arr=d.transactions;
    if(arr.__v207push) return true;
    var basePush = arr.push.bind(arr); // whatever push currently is (incl. v32 wrap)
    arr.push = function(){
      var r = basePush.apply(null, arguments);
      try{ persistSoon(); }catch(e){}
      return r;
    };
    arr.__v207push = true;
    return true;
  }

  // ── (2) Watch for in-place mutations to D.transactions and persist on change.
  function txnSignature(){
    var d=DD(); if(!d || !Array.isArray(d.transactions)) return '0';
    var t=d.transactions;
    var s=t.length+'|';
    for(var i=0;i<t.length;i++){
      var x=t[i]||{};
      s+=(x.id||'')+':'+(x.status||'')+':'+(x.amount||'')+':'+(x._rev||'')+';';
    }
    return s;
  }
  var _lastSig=null;
  function _v207tick(){
    try{
      // (re)assert push hook in case the array was replaced by a D1 reload
      installTxnPushHook();
      var sig=txnSignature();
      if(sig!==_lastSig){
        _lastSig=sig;
        persistSoon();
      }
    }catch(e){}
  }
  function installTxnMutationWatch(){
    if(window.__v207watch) return true;
    _lastSig = txnSignature();
    // [phase3] perpetual 1500ms poll replaced by shared HMS.every scheduler
    // (single ticker, pauses when tab hidden). Immediate persistence still
    // happens via the wrapped save/edit functions + state:changed events.
    if(window.HMS && window.HMS.every){
      window.__v207watch = window.HMS.every(10000, _v207tick);
    } else {
      window.__v207watch = setInterval(function(){ if(document.visibilityState==='hidden') return; _v207tick(); }, 10000);
    }
    // also re-assert on any state change (event-driven safety net)
    try{ if(window.HMS && window.HMS.on){ window.HMS.on('state:changed', _v207tick); } }catch(_e){}
    return true;
  }

  // ── (4) Robust id compare helper.
  function sameId(a,b){
    if(a===b) return true;
    try{ return String(a)===String(b); }catch(e){ return false; }
  }
  window.__V207_findTxn = function(id){
    var d=DD(); if(!d||!Array.isArray(d.transactions)) return null;
    for(var i=0;i<d.transactions.length;i++){ if(sameId(d.transactions[i].id,id)) return d.transactions[i]; }
    return null;
  };

  // ── (3) Wrap creator / mutator functions to persist immediately.
  var CREATORS = ['savePayment','saveRefund','saveWriteOff','saveCreditNote',
                  'saveDailyCashUp','recordPayment'];
  function wrapCreator(name){
    var fn=window[name];
    if(typeof fn!=='function') return false;
    if(fn.__v207) return true;
    var wrapped=function(){
      var r=fn.apply(this,arguments);
      try{ ensureArray(); installTxnPushHook(); persistNow(); }catch(e){}
      return r;
    };
    wrapped.__v207=true;
    window[name]=wrapped;
    return true;
  }

  // confirmTransaction / voidTransaction mutate in place then render(); wrap to
  // persist right after and use a robust id lookup as a safety net so the status
  // change is never lost even if the strict === in core failed to match.
  function wrapMutator(name, mutate){
    var fn=window[name];
    if(typeof fn!=='function') return false;
    if(fn.__v207) return true;
    var wrapped=function(id){
      var r=fn.apply(this,arguments);
      try{
        // safety-net: if core's strict compare missed, apply the mutation here.
        var t=window.__V207_findTxn(id);
        if(t && typeof mutate==='function'){ mutate(t); }
        if(t){ t._rev=Date.now(); }
        installTxnPushHook(); persistNow();
      }catch(e){}
      return r;
    };
    wrapped.__v207=true;
    window[name]=wrapped;
    return true;
  }

  // editTransaction (v206) opens a modal; the actual save is __V206_saveTxnEdit.
  // Wrap that so an edited transaction persists on save.
  function wrapTxnEditSave(){
    var fn=window.__V206_saveTxnEdit;
    if(typeof fn!=='function') return false;
    if(fn.__v207) return true;
    var wrapped=function(id){
      var r=fn.apply(this,arguments);
      try{
        var t=window.__V207_findTxn(id);
        if(t){ t._rev=Date.now(); }
        installTxnPushHook(); persistNow();
      }catch(e){}
      return r;
    };
    wrapped.__v207=true;
    window.__V206_saveTxnEdit=wrapped;
    return true;
  }

  function applyAll(){
    ensureArray();
    installTxnPushHook();
    installTxnMutationWatch();
    CREATORS.forEach(wrapCreator);
    wrapMutator('confirmTransaction', function(t){ if(t && t.status!=='Void') t.status='Completed'; });
    wrapMutator('voidTransaction',    function(t){ if(t) t.status='Void'; });
    wrapTxnEditSave();
  }

  // Re-assert repeatedly (D loads async from D1; other packs also wrap fns and
  // may replace the transactions array on reload).
  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll, ms); });
  DOMBus.register(applyAll);
  try{ window.addEventListener('load', applyAll); }catch(e){}

  window.__V207 = {
    persistNow: persistNow,
    persistSoon: persistSoon,
    ensureArray: ensureArray,
    installTxnPushHook: installTxnPushHook,
    installTxnMutationWatch: installTxnMutationWatch,
    txnSignature: txnSignature,
    findTxn: window.__V207_findTxn,
    applyAll: applyAll,
    wrapCreator: wrapCreator
  };

  try{ console.log('%c✅ v207 transactions persist (create → D1 → frontend)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/158-twh-appointments-attachments-v208.js ==== */
/* ============================================================================
   Tranquil HMS — v208 · Appointments pull-back/persist + real File Attachments
   ----------------------------------------------------------------------------
   Request: "Pull back all the appointments created on the backend to display on
   the frontend. Let it display and be a permanent record. Fix the attachment;
   nothing is shown presently."

   PART A — Appointments (permanent record, always displayed)
   ----------------------------------------------------------
   Root cause: every appointment create/mutate path pushed into D.appointments
   and called render() but did NOT force a D1 write, so the appointments shard
   on Cloudflare stayed an empty array ([]). Same class of bug as v205/v207.
   This pack guarantees:
     1) D.appointments is always a valid array.
     2) ANY push to D.appointments (New Appointment, online booking, recurring,
        CRM, etc.) triggers an immediate persist to D1 — a permanent record.
     3) A signature-diff watchdog persists on in-place mutations (check-in,
        complete, cancel, reschedule).
     4) Wraps saveNewRecord('appointments') / editRecord('appointments') to
        persist immediately + re-render so the row shows at once.
     5) On load, once data hydrates from D1, appointments are re-rendered so the
        Appointment Management list + KPIs reflect the stored records (pull-back
        to the frontend). If the current appointment view is showing, it is
        refreshed as soon as the D1 document arrives.

   PART B — File Attachments (real, permanent, viewable)
   -----------------------------------------------------
   Root cause: handleFileUpload() only printed file names in a list and the
   "Attach" button just showed a toast — files were never read, never stored,
   never rendered, so "nothing is shown". This pack:
     1) Reads each chosen file as a base64 data URL (<= 10 MB).
     2) Stores it in D.attachments (created if missing) as
        {id, recordId, name, type, size, dataUrl, uploadedAt, uploadedBy}.
     3) Persists to D1 immediately → permanent record synced to Cloudflare.
     4) Renders existing + newly added attachments inside the modal with
        View (opens the data URL) and Remove actions, so they are visible and
        persist across reloads and across the whole app.
   Non-destructive: overrides window.showFileAttachment / window.handleFileUpload
   with storage-backed versions; falls back gracefully if globals are absent.
   ========================================================================== */
(function(){
  if(window.__twhV208) return;
  window.__twhV208 = true;

  function DD(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }
  function persistNow(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }
  var _pt=null;
  function persistSoon(){ try{ if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); if(_pt) clearTimeout(_pt); _pt=setTimeout(function(){ _pt=null; persistNow(); },250);}catch(e){} }
  function doRender(){ try{ if(typeof window.render==='function') return window.render(); if(typeof render==='function') return render(); }catch(e){} }
  function newId(){ try{ if(typeof window.nid==='function') return window.nid(); if(typeof nid==='function') return nid(); }catch(e){} return Date.now()+Math.floor(Math.random()*1000); }
  function curUser(){ try{ var d=DD(); return (d&&d.currentUser&&d.currentUser.fullName)||'User'; }catch(e){ return 'User'; } }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ─────────────────── PART A — Appointments ─────────────────── */

  function ensureApptArray(){ var d=DD(); if(!d) return false; if(!Array.isArray(d.appointments)){ d.appointments=[]; return true; } return false; }

  // Wrap D.appointments.push so any push persists.
  function installApptPushHook(){
    var d=DD(); if(!d || !Array.isArray(d.appointments)) return false;
    var arr=d.appointments;
    if(arr.__v208push) return true;
    var basePush=arr.push.bind(arr);
    arr.push=function(){ var r=basePush.apply(null,arguments); try{ persistSoon(); }catch(e){} return r; };
    arr.__v208push=true;
    return true;
  }

  function apptSignature(){
    var d=DD(); if(!d || !Array.isArray(d.appointments)) return '0';
    var t=d.appointments, s=t.length+'|';
    for(var i=0;i<t.length;i++){ var x=t[i]||{}; s+=(x.id||'')+':'+(x.status||'')+':'+(x.date||'')+':'+(x.time||'')+':'+(x._rev||'')+';'; }
    return s;
  }
  var _lastApptSig=null;
  function _v208tick(){
    try{
      installApptPushHook();
      var sig=apptSignature();
      if(sig!==_lastApptSig){ _lastApptSig=sig; persistSoon(); }
    }catch(e){}
  }
  function installApptMutationWatch(){
    if(window.__v208apptWatch) return true;
    _lastApptSig=apptSignature();
    // [phase3] perpetual 1500ms poll replaced by shared HMS.every scheduler.
    if(window.HMS && window.HMS.every){
      window.__v208apptWatch=window.HMS.every(10000, _v208tick);
    } else {
      window.__v208apptWatch=setInterval(function(){ if(document.visibilityState==='hidden') return; _v208tick(); },10000);
    }
    try{ if(window.HMS && window.HMS.on){ window.HMS.on('state:changed', _v208tick); } }catch(_e){}
    return true;
  }

  function wrapApptSaveNew(){
    if(typeof window.saveNewRecord!=='function') return false;
    if(window.saveNewRecord.__v208) return true;
    var orig=window.saveNewRecord;
    var wrapped=function(dataKey){
      var r=orig.apply(this,arguments);
      try{ if(dataKey==='appointments'){ ensureApptArray(); installApptPushHook(); persistNow(); doRender(); } }catch(e){}
      return r;
    };
    wrapped.__v208=true;
    window.saveNewRecord=wrapped;
    return true;
  }

  function wrapApptEdit(){
    if(typeof window.editRecord!=='function') return false;
    if(window.editRecord.__v208) return true;
    var orig=window.editRecord;
    var wrapped=function(dataKey,id){
      var r=orig.apply(this,arguments);
      if(dataKey==='appointments'){
        try{
          var tries=0, iv=setInterval(function(){
            tries++;
            var open=!!document.querySelector('.modal-overlay, #modalRoot .modal, [id="modalBody"]');
            if(!open || tries>40){ clearInterval(iv); installApptPushHook(); persistNow(); doRender(); }
          },250);
        }catch(e){}
      }
      return r;
    };
    wrapped.__v208=true;
    window.editRecord=wrapped;
    return true;
  }

  // Pull-back: when the D1 document arrives (or changes) re-render if the
  // appointments module is the one on screen, so stored appointments display.
  function currentModule(){ try{ return (typeof currentMod!=='undefined'?currentMod:(window.currentMod||'')); }catch(e){ return window.currentMod||''; } }
  function refreshIfApptView(){
    try{
      var m=currentModule();
      if(m==='appointments' || m==='calendar'){ doRender(); }
    }catch(e){}
  }
  var _hydrateHooked=false;
  function hookHydrate(){
    if(_hydrateHooked) return true;
    try{
      if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
        window.HMS_DB.onState(function(st){
          // when a sync settles to idle we may have just pulled fresh data
          if(st==='idle'){ setTimeout(function(){ ensureApptArray(); installApptPushHook(); refreshIfApptView(); }, 50); }
        });
        _hydrateHooked=true;
      }
    }catch(e){}
    return _hydrateHooked;
  }

  /* ─────────────────── PART B — Attachments ─────────────────── */

  function ensureAttachArray(){ var d=DD(); if(!d) return false; if(!Array.isArray(d.attachments)){ d.attachments=[]; return true; } return false; }

  window.__V208_attachmentsFor = function(recordId){
    var d=DD(); if(!d || !Array.isArray(d.attachments)) return [];
    return d.attachments.filter(function(a){ return String(a.recordId)===String(recordId); });
  };

  window.__V208_removeAttachment = function(attId){
    var d=DD(); if(!d || !Array.isArray(d.attachments)) return;
    var idx=-1;
    for(var i=0;i<d.attachments.length;i++){ if(String(d.attachments[i].id)===String(attId)){ idx=i; break; } }
    if(idx>-1){
      d.attachments.splice(idx,1);
      persistNow();
      try{ if(typeof window.toast==='function') window.toast('Attachment removed'); }catch(e){}
      var host=window.__V208_currentRecordId;
      window.__V208_renderList(host);
    }
  };

  window.__V208_viewAttachment = function(attId){
    var d=DD(); if(!d || !Array.isArray(d.attachments)) return;
    var a=null;
    for(var i=0;i<d.attachments.length;i++){ if(String(d.attachments[i].id)===String(attId)){ a=d.attachments[i]; break; } }
    if(!a || !a.dataUrl) return;
    try{
      var w=window.open('');
      if(w){
        if(/^image\//.test(a.type)){ w.document.write('<title>'+esc(a.name)+'</title><img src="'+a.dataUrl+'" style="max-width:100%">'); }
        else if(a.type==='application/pdf'){ w.document.write('<title>'+esc(a.name)+'</title><iframe src="'+a.dataUrl+'" style="border:0;width:100%;height:100vh"></iframe>'); }
        else { var lk=w.document.createElement('a'); lk.href=a.dataUrl; lk.download=a.name; lk.textContent='Download '+a.name; w.document.body.appendChild(lk); }
      }
    }catch(e){}
  };

  function fileHtml(a){
    var kb=Math.round((a.size||0)/1024);
    return '<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 10px;background:#f8fafc;border-radius:8px;margin-bottom:6px;font-size:12px">'
      + '<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:60%"><i class="fa-solid fa-file" style="margin-right:6px;color:var(--pri)"></i>'+esc(a.name)+'</span>'
      + '<span style="color:var(--txt3);white-space:nowrap">'+kb+'KB '
      + '<button class="btn btn-xs btn-ghost" style="margin-left:6px" onclick="__V208_viewAttachment(\''+a.id+'\')"><i class="fa-solid fa-eye"></i> View</button>'
      + '<button class="btn btn-xs" style="background:#ef4444;color:#fff;margin-left:4px" onclick="__V208_removeAttachment(\''+a.id+'\')"><i class="fa-solid fa-trash"></i></button>'
      + '</span></div>';
  }

  window.__V208_renderList = function(recordId){
    var el=document.getElementById('fileList'); if(!el) return;
    var list=window.__V208_attachmentsFor(recordId);
    if(!list.length){ el.innerHTML='<div style="font-size:12px;color:var(--txt3);text-align:center;padding:10px">No files attached yet.</div>'; return; }
    el.innerHTML=list.map(fileHtml).join('');
  };

  var MAX_BYTES = 10*1024*1024; // 10 MB

  // Storage-backed file upload: read → store in D.attachments → persist → render.
  window.handleFileUpload = function(files){
    ensureAttachArray();
    var d=DD(); if(!d) return;
    var recordId=window.__V208_currentRecordId!=null?window.__V208_currentRecordId:'general';
    var arr=Array.prototype.slice.call(files||[]);
    if(!arr.length) return;
    var pending=arr.length;
    arr.forEach(function(f){
      if(f.size>MAX_BYTES){
        pending--;
        try{ if(typeof window.toast==='function') window.toast(f.name+' exceeds 10MB — skipped','err'); }catch(e){}
        if(pending<=0){ persistNow(); window.__V208_renderList(recordId); }
        return;
      }
      var reader=new FileReader();
      reader.onload=function(ev){
        try{
          d.attachments.push({
            id:newId(), recordId:recordId, name:f.name, type:f.type||'application/octet-stream',
            size:f.size, dataUrl:ev.target.result, uploadedAt:new Date().toISOString(), uploadedBy:curUser()
          });
        }catch(e){}
        pending--;
        if(pending<=0){
          persistNow();
          window.__V208_renderList(recordId);
          try{ if(typeof window.toast==='function') window.toast(arr.length+' file(s) attached & saved'); }catch(e){}
        }
      };
      reader.onerror=function(){ pending--; if(pending<=0){ persistNow(); window.__V208_renderList(recordId); } };
      reader.readAsDataURL(f);
    });
  };

  // Rebuild the attachment modal so it lists stored files + saves permanently.
  window.showFileAttachment = function(recordId){
    ensureAttachArray();
    window.__V208_currentRecordId = recordId!=null?recordId:'general';
    if(typeof window.showModal!=='function') return;
    var body='<div style="border:2px dashed var(--bdr);border-radius:16px;padding:26px;text-align:center;cursor:pointer" onclick="document.getElementById(\'fileInput\').click()">'
      + '<i class="fa-solid fa-cloud-upload-alt" style="font-size:32px;color:var(--txt3);margin-bottom:8px;display:block"></i>'
      + '<b>Click or drag files here</b>'
      + '<div style="font-size:11px;color:var(--txt3);margin-top:4px">Supports: PDF, JPG, PNG, DOC (max 10MB) — stored permanently</div>'
      + '<input type="file" id="fileInput" style="display:none" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onchange="handleFileUpload(this.files)"></div>'
      + '<div id="fileList" style="margin-top:12px"></div>';
    window.showModal('<i class="fa-solid fa-paperclip" style="color:var(--pri);margin-right:8px"></i>Attach Files to Record',
      body,
      '<button class="btn btn-pri" onclick="closeModal()"><i class="fa-solid fa-check"></i> Done</button><button class="btn btn-ghost" onclick="closeModal()">Close</button>');
    setTimeout(function(){ window.__V208_renderList(window.__V208_currentRecordId); }, 60);
  };

  /* ─────────────────── apply / re-assert ─────────────────── */

  function applyAll(){
    ensureApptArray();
    ensureAttachArray();
    installApptPushHook();
    installApptMutationWatch();
    wrapApptSaveNew();
    wrapApptEdit();
    hookHydrate();
  }

  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll, ms); });
  DOMBus.register(applyAll);
  try{ window.addEventListener('load', applyAll); }catch(e){}

  window.__V208 = {
    ensureApptArray: ensureApptArray,
    installApptPushHook: installApptPushHook,
    installApptMutationWatch: installApptMutationWatch,
    apptSignature: apptSignature,
    ensureAttachArray: ensureAttachArray,
    attachmentsFor: window.__V208_attachmentsFor,
    renderList: window.__V208_renderList,
    applyAll: applyAll
  };

  try{ console.log('%c✅ v208 appointments pull-back/persist + real file attachments','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/159-twh-clinical-persist-v209.js ==== */
/* ============================================================================
   Tranquil HMS — v209 · Generic Clinical/Orders Persistence + Pull-back
   ----------------------------------------------------------------------------
   Request: "All orders and medical records should also be saved in the database
   and show on the frontend like the appointment ... Fix all issues and errors
   in the database that have related of data storage and pull back to the
   frontend, like appointment, medical records, laboratory, and radiology
   orders."

   Root cause (confirmed by D1 audit): the shards for medicalRecords, labTests,
   radiologyOrders, prescriptions, bills, orSchedules, emergencyCases, claims
   and purchaseOrders are all empty arrays ([] / 2 bytes). Records are created
   in memory and rendered, but the create/mutate functions do not force a D1
   write — so nothing is stored and nothing pulls back on reload. This is the
   same systemic bug fixed for appointments (v208) and transactions (v207).

   This pack GENERALISES the proven fix to every clinical/orders collection:
     1) ensureArrays()      — every target collection is always a valid array.
     2) installPushHooks()  — wraps <collection>.push so ANY code path that adds
                              a record (saveNewRecord, dedicated order savers,
                              auto-generation, imports) triggers an immediate D1
                              persist.
     3) installMutationWatch() — per-collection signature-diff poll persists
                              IN-PLACE mutations that .push cannot see (lab
                              result entry / verify / complete, radiology report
                              / finalize study, EMR finalize / SOAP / vitals,
                              prescription dispense, bill payment status, OR
                              status). Uses a cheap change signature.
     4) wrapSaveNewRecord() — after saveNewRecord(<any target key>), force an
                              immediate _hmsSave() + re-render so the new row
                              shows at once (parity with appointments).
     5) hookHydrate()       — when the D1 document settles (HMS_DB.onState idle),
                              re-render the active clinical/orders module so
                              records pulled back from the database DISPLAY on
                              the frontend on load.

   Idempotent, non-destructive. Re-asserts on timers + interval + window load
   because data hydrates async and collection arrays can be replaced on reload.
   ========================================================================== */
(function(){
  if(window.__twhV209) return;
  window.__twhV209 = true;

  // Collections to guarantee-persist. (appointments + transactions already
  // handled by v207/v208, but including them here is harmless and adds
  // belt-and-braces coverage.)
  var KEYS = ['medicalRecords','labTests','radiologyOrders','prescriptions',
              'bills','orSchedules','emergencyCases','claims','purchaseOrders',
              'appointments','transactions','referrals'];

  // Module (currentMod) → whether it renders one of the above collections, so
  // pull-back re-render only fires for relevant screens.
  var CLINICAL_MODULES = ['emr','laboratory','radiology','prescriptions','or',
                          'billing','emergency','insurance','procurement',
                          'appointments','transactions','calendar','referrals'];

  function DD(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }
  function persistNow(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }
  var _pt=null;
  function persistSoon(){ try{ if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); if(_pt) clearTimeout(_pt); _pt=setTimeout(function(){ _pt=null; persistNow(); },250);}catch(e){} }
  function doRender(){ try{ if(typeof window.render==='function') return window.render(); if(typeof render==='function') return render(); }catch(e){} }
  function currentModule(){ try{ return (typeof currentMod!=='undefined'?currentMod:(window.currentMod||'')); }catch(e){ return window.currentMod||''; } }

  // ── (1) ensure arrays ──────────────────────────────────────────────────────
  function ensureArrays(){
    var d=DD(); if(!d) return false;
    var changed=false;
    KEYS.forEach(function(k){ if(!Array.isArray(d[k])){ d[k]=[]; changed=true; } });
    return changed;
  }

  // ── (2) push hooks ─────────────────────────────────────────────────────────
  function installPushHooks(){
    var d=DD(); if(!d) return false;
    KEYS.forEach(function(k){
      var arr=d[k];
      if(!Array.isArray(arr)) return;
      if(arr.__v209push) return;
      var basePush=arr.push.bind(arr);
      arr.push=function(){ var r=basePush.apply(null,arguments); try{ persistSoon(); }catch(e){} return r; };
      arr.__v209push=true;
    });
    return true;
  }

  // ── (3) mutation watch (per-collection change signature) ────────────────────
  function sigOf(arr){
    if(!Array.isArray(arr)) return '0';
    var s=arr.length+'|';
    for(var i=0;i<arr.length;i++){
      var x=arr[i]||{};
      // include the fields that change on the common mutations across these
      // collections so in-place edits are detected cheaply.
      s+=(x.id||'')+':'+(x.status||'')+':'+(x._rev||'')
        +':'+(x.result!=null?1:0)+':'+(x.results!=null?1:0)
        +':'+(x.report!=null?1:0)+':'+(x.impression!=null?1:0)
        +':'+(x.verified?1:0)+':'+(x.finalizedAt||'')
        +':'+(x.paid||'')+':'+(x.balance||'')+';';
    }
    return s;
  }
  var _lastSig={};
  function _v209tick(){
    try{
      installPushHooks(); // re-assert in case arrays were replaced on reload
      var d=DD(); if(!d) return;
      var dirty=false;
      KEYS.forEach(function(k){
        var sig=sigOf(d[k]);
        if(sig!==_lastSig[k]){ _lastSig[k]=sig; dirty=true; }
      });
      if(dirty) persistSoon();
    }catch(e){}
  }
  function installMutationWatch(){
    if(window.__v209watch) return true;
    var d=DD();
    KEYS.forEach(function(k){ _lastSig[k]=sigOf(d&&d[k]); });
    // [phase3] perpetual 1500ms poll replaced by shared HMS.every scheduler.
    if(window.HMS && window.HMS.every){
      window.__v209watch=window.HMS.every(10000, _v209tick);
    } else {
      window.__v209watch=setInterval(function(){ if(document.visibilityState==='hidden') return; _v209tick(); },10000);
    }
    try{ if(window.HMS && window.HMS.on){ window.HMS.on('state:changed', _v209tick); } }catch(_e){}
    return true;
  }

  // ── (4) wrap saveNewRecord for all target keys ─────────────────────────────
  function wrapSaveNewRecord(){
    if(typeof window.saveNewRecord!=='function') return false;
    if(window.saveNewRecord.__v209) return true;
    var orig=window.saveNewRecord;
    var wrapped=function(dataKey){
      var r=orig.apply(this,arguments);
      try{
        if(KEYS.indexOf(dataKey)>-1){
          ensureArrays(); installPushHooks(); persistNow(); doRender();
        }
      }catch(e){}
      return r;
    };
    wrapped.__v209=true;
    window.saveNewRecord=wrapped;
    return true;
  }

  // Also wrap editRecord so any edited clinical/order record persists + refreshes.
  function wrapEditRecord(){
    if(typeof window.editRecord!=='function') return false;
    if(window.editRecord.__v209) return true;
    var orig=window.editRecord;
    var wrapped=function(dataKey,id){
      var r=orig.apply(this,arguments);
      if(KEYS.indexOf(dataKey)>-1){
        try{
          var tries=0, iv=setInterval(function(){
            tries++;
            var open=!!document.querySelector('.modal-overlay, #modalRoot .modal, [id="modalBody"]');
            if(!open || tries>40){ clearInterval(iv); installPushHooks(); persistNow(); doRender(); }
          },250);
        }catch(e){}
      }
      return r;
    };
    wrapped.__v209=true;
    window.editRecord=wrapped;
    return true;
  }

  // ── (5) pull-back re-render on D1 hydrate ──────────────────────────────────
  function refreshIfClinicalView(){
    try{ if(CLINICAL_MODULES.indexOf(currentModule())>-1) doRender(); }catch(e){}
  }
  var _hydrateHooked=false;
  function hookHydrate(){
    if(_hydrateHooked) return true;
    try{
      if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
        window.HMS_DB.onState(function(st){
          if(st==='idle'){ setTimeout(function(){ ensureArrays(); installPushHooks(); refreshIfClinicalView(); }, 50); }
        });
        _hydrateHooked=true;
      }
    }catch(e){}
    return _hydrateHooked;
  }

  function applyAll(){
    ensureArrays();
    installPushHooks();
    installMutationWatch();
    wrapSaveNewRecord();
    wrapEditRecord();
    hookHydrate();
  }

  [0,300,800,1500,3000,5000,8000].forEach(function(ms){ setTimeout(applyAll, ms); });
  DOMBus.register(applyAll);
  try{ window.addEventListener('load', applyAll); }catch(e){}

  window.__V209 = {
    KEYS: KEYS,
    ensureArrays: ensureArrays,
    installPushHooks: installPushHooks,
    installMutationWatch: installMutationWatch,
    sigOf: sigOf,
    applyAll: applyAll,
    refreshIfClinicalView: refreshIfClinicalView
  };

  try{ console.log('%c✅ v209 clinical/orders persist + pull-back (EMR · lab · radiology · rx · bills · OR)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/160-twh-emr-all-patients-v210.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v210 — MEDICAL RECORDS: ALL REGISTERED PATIENTS + SEE DOCTOR + PRESCRIBE
   Fulfils: "All registered patients should appear in medical records and have
   a column to see a doctor and give a prescription, which can generate
   detailed medical records of the patient. Make it a perfect implementation
   of standard clinical processes."

   • Adds an "All Registered Patients" panel at the top of the Medical Records
     (EMR) module listing EVERY patient in D.patients, each row showing MRN,
     name, demographics, attending doctor, #encounters, last visit, and a
     status pill (No records / Open encounter / n record(s)).
   • Per-patient action column:
       – See Doctor  → opens a standard consultation form (chief complaint,
         HPI, examination, vitals, primary/secondary diagnosis + ICD-10,
         treatment plan, follow-up). Saving CREATES a detailed, standards-
         compliant D.medicalRecords encounter, persists to D1, and offers to
         immediately write a prescription for that encounter.
       – Give Prescription → opens the existing Rx module locked to the
         patient (rxmNewRxFor), linked to their latest open encounter.
       – Open Chart → opens the full longitudinal Medical Record (viewPatient).
       – View → shows the patient's STORED medical records in a detailed,
         standards-based layout (visible immediately after storing), including
         the full vital-signs set with a dedicated PULSE column.
   • Live search + "only patients without a record" filter.
   • Vital Signs now capture PULSE (bpm) alongside heart rate, plus pain score.
   • Every created record calls _hmsSave() so it persists to D1 and pulls back
     on reload (same durable-persistence contract as v207–v209); the created
     record is opened in the viewer right away so it is visible from the page.
   Idempotent, guarded by __twhV210.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV210) return; window.__twhV210 = true;

  function D_(){ return (typeof D!=='undefined'&&D)?D:(window.D||{}); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function NID(){ try{ if(typeof window.nid==='function') return window.nid(); if(typeof nid==='function') return nid(); }catch(e){} return Date.now()+Math.floor(Math.random()*1000); }
  function UID(){ try{ if(typeof window.uid==='function') return window.uid(); if(typeof uid==='function') return uid(); }catch(e){} return String(Date.now()).slice(-6); }
  function TODAY(){ try{ if(typeof window.today==='function') return window.today(); }catch(e){} return new Date().toISOString().slice(0,10); }
  function TOAST(m,t){ try{ if(typeof window.toast==='function') return window.toast(m,t); if(typeof toast==='function') return toast(m,t); }catch(e){} }
  function MODAL(a,b,c,d){ try{ if(typeof window.showModal==='function') return window.showModal(a,b,c,d); if(typeof showModal==='function') return showModal(a,b,c,d); }catch(e){} }
  function CLOSE(){ try{ if(typeof window.closeModal==='function') return window.closeModal(); if(typeof closeModal==='function') return closeModal(); }catch(e){} }
  function RENDER(){ try{ if(typeof window.render==='function') return window.render(); if(typeof render==='function') return render(); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }
  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }

  function patientsList(){ var d=D_(); return Array.isArray(d.patients)?d.patients:[]; }
  function doctorsList(){ var d=D_(); return (Array.isArray(d.employees)?d.employees:[]).filter(function(e){ return e && (e.type==='Doctor') && (e.status==='Active'||!e.status); }); }
  function recordsFor(pid){ var d=D_(); return (Array.isArray(d.medicalRecords)?d.medicalRecords:[]).filter(function(r){ return r && (r.patientId===pid || String(r.patientId)===String(pid)); }); }
  function docName(id){ var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('#'+id)):'\u2014'; }
  function deptName(id){ var e=(D_().departments||[]).find(function(x){return x.id===id;}); return e?(e.name||('#'+id)):'\u2014'; }

  /* ── doctor <select> options ─────────────────────────────────────────── */
  function docOptions(selId){
    var opts='<option value="">Select doctor\u2026</option>';
    doctorsList().forEach(function(e){
      opts+='<option value="'+e.id+'"'+(selId!=null&&e.id===selId?' selected':'')+'>'+esc(e.fullName||e.name||('#'+e.id))+(e.specialization?(' \u2014 '+esc(e.specialization)):'')+'</option>';
    });
    return opts;
  }

  /* ══════════════════════════════════════════════════════════════════════
     SEE DOCTOR — standard consultation form → creates a detailed record
     ══════════════════════════════════════════════════════════════════════ */
  window.twhSeeDoctor = function(patientId){
    var p=patientsList().find(function(x){return x.id===patientId;});
    if(!p){ TOAST('Patient not found','err'); return; }
    var g=function(id,label,ph,rows){ return '<div class="form-group full"><label>'+label+'</label><textarea id="'+id+'" rows="'+(rows||2)+'" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px;font-family:inherit" placeholder="'+esc(ph||'')+'"></textarea></div>'; };
    var num=function(id,label,ph){ return '<div class="form-group"><label>'+label+'</label><input id="'+id+'" type="number" step="any" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px" placeholder="'+esc(ph||'')+'"></div>'; };
    var txt=function(id,label,ph){ return '<div class="form-group"><label>'+label+'</label><input id="'+id+'" type="text" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px" placeholder="'+esc(ph||'')+'"></div>'; };
    var allergy=(p.allergies&&p.allergies!=='None')?p.allergies:'';
    var body=''
      +'<div style="padding:10px 12px;border-radius:10px;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff;margin-bottom:12px">'
        +'<div style="font-size:16px;font-weight:800">'+esc(p.fullName||('Patient '+p.id))+'</div>'
        +'<div style="font-size:12px;opacity:.95">'+esc(p.mrn||'')+' \u00b7 '+esc(p.gender||'\u2014')+' \u00b7 '+((p.age!=null&&p.age!=='')?(esc(p.age)+'y'):'\u2014')+' \u00b7 Blood '+esc(p.bloodGroup||'\u2014')+'</div>'
        +(allergy?'<div style="margin-top:6px;background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.35);padding:3px 10px;border-radius:999px;font-size:11px;font-weight:700;display:inline-block"><i class="fa-solid fa-triangle-exclamation"></i> Allergies: '+esc(allergy)+'</div>':'')
      +'</div>'
      +'<div class="form-grid" style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px">'
        +'<div class="form-group"><label>Attending Doctor <span style="color:#ef4444">*</span></label><select id="sd_doctor" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px">'+docOptions(p.doctorId)+'</select></div>'
        +'<div class="form-group"><label>Visit Date</label><input id="sd_date" type="date" value="'+TODAY()+'" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px"></div>'
        +'<div class="form-group"><label>Visit Type</label><select id="sd_type" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px"><option>Outpatient</option><option>Follow-up</option><option>Inpatient</option><option>Emergency</option><option>Day Case</option></select></div>'
      +'</div>'
      +'<div style="font-weight:700;color:var(--pri,#0d9488);margin:12px 0 6px;font-size:12px;text-transform:uppercase;letter-spacing:.4px">Clinical Assessment</div>'
      +g('sd_complaint','Chief Complaint / Presenting Symptoms','e.g. Fever for 3 days',2)
      +g('sd_hpi','History of Present Illness','Onset, duration, character\u2026',2)
      +g('sd_exam','Physical Examination Findings','Examination findings\u2026',2)
      +'<div class="form-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:10px">'
        +txt('sd_diagnosis','Primary Diagnosis','e.g. Acute uncomplicated malaria')
        +txt('sd_icd10','ICD-10 Code','e.g. B54')
      +'</div>'
      +txt('sd_diagnosis2','Secondary Diagnosis (optional)','')
      +g('sd_treatment','Treatment Plan','Medications, procedures, advice, referrals\u2026',2)
      +'<div style="font-weight:700;color:var(--pri,#0d9488);margin:12px 0 6px;font-size:12px;text-transform:uppercase;letter-spacing:.4px">Vital Signs</div>'
      +'<div class="form-grid" style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px">'
        +num('sd_bpSys','BP Systolic (mmHg)','120')+num('sd_bpDia','BP Diastolic (mmHg)','80')
        +num('sd_pulse','Pulse (bpm)','72')+num('sd_hr','Heart Rate (bpm)','72')
        +num('sd_temp','Temp (\u00b0C)','36.8')+num('sd_rr','Resp Rate (/min)','16')
        +num('sd_spo2','SpO2 (%)','98')+num('sd_weight','Weight (kg)','')
        +num('sd_height','Height (cm)','')+num('sd_painScore','Pain Score (0\u201310)','')
      +'</div>'
      +'<div style="font-weight:700;color:var(--pri,#0d9488);margin:12px 0 6px;font-size:12px;text-transform:uppercase;letter-spacing:.4px">Follow-up</div>'
      +'<div class="form-grid" style="display:grid;grid-template-columns:1fr 2fr;gap:10px">'
        +'<div class="form-group"><label>Follow-up Date</label><input id="sd_fuDate" type="date" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px"></div>'
        +'<div class="form-group"><label>Follow-up Instructions</label><input id="sd_fuNotes" type="text" style="width:100%;border:1px solid var(--bdr,#d1d5db);border-radius:8px;padding:8px" placeholder="e.g. Return in 1 week"></div>'
      +'</div>';
    var footer=''
      +'<button class="btn btn-pri" onclick="twhSaveConsultation('+p.id+',false)"><i class="fa-solid fa-floppy-disk"></i> Save Record</button>'
      +'<button class="btn" style="background:#0d9488;color:#fff" onclick="twhSaveConsultation('+p.id+',true)"><i class="fa-solid fa-prescription"></i> Save &amp; Prescribe</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    MODAL('<i class="fa-solid fa-user-doctor" style="color:#0d9488;margin-right:8px"></i>See Doctor \u2014 New Consultation', body, footer, 'wide');
  };

  function bmiCalc(wt,ht){ wt=parseFloat(wt); ht=parseFloat(ht); if(!wt||!ht) return ''; var m=ht/100; var b=wt/(m*m); return isFinite(b)?Math.round(b*10)/10:''; }
  function val(id){ var el=document.getElementById(id); return el?el.value:''; }
  function numVal(id){ var v=val(id); return v===''||v==null?null:(parseFloat(v)); }

  window.twhSaveConsultation = function(patientId, thenPrescribe){
    var d=D_();
    if(!Array.isArray(d.medicalRecords)) d.medicalRecords=[];
    var doctorId=val('sd_doctor'); doctorId=doctorId?parseInt(doctorId,10):null;
    var diagnosis=val('sd_diagnosis').trim();
    if(!doctorId){ TOAST('Please select an attending doctor','err'); return; }
    if(!diagnosis){ TOAST('Please enter a primary diagnosis','err'); return; }
    var p=patientsList().find(function(x){return x.id===patientId;})||{};
    var rec={
      id: NID(),
      code: 'EMR-'+UID(),
      patientId: patientId,
      doctorId: doctorId,
      deptId: (p.deptId!=null?p.deptId:null),
      visitDate: val('sd_date')||TODAY(),
      visitType: val('sd_type')||'Outpatient',
      status: 'Open',
      complaint: val('sd_complaint').trim(),
      historyIllness: val('sd_hpi').trim(),
      physicalExam: val('sd_exam').trim(),
      diagnosis: diagnosis,
      icd10: val('sd_icd10').trim(),
      diagnosisSecondary: val('sd_diagnosis2').trim(),
      treatment: val('sd_treatment').trim(),
      notes: '',
      bpSys: numVal('sd_bpSys'), bpDia: numVal('sd_bpDia'),
      pulse: numVal('sd_pulse'),
      hr: numVal('sd_hr'), temp: numVal('sd_temp'), rr: numVal('sd_rr'), spo2: numVal('sd_spo2'),
      weight: numVal('sd_weight'), height: numVal('sd_height'),
      bmi: bmiCalc(val('sd_weight'),val('sd_height')),
      painScore: numVal('sd_painScore'),
      followUpDate: val('sd_fuDate')||'',
      followUpNotes: val('sd_fuNotes').trim(),
      createdAt: new Date().toISOString()
    };
    d.medicalRecords.push(rec);
    // Assign attending doctor to the patient if none set (standard workflow).
    try{ if(p && (p.doctorId==null||p.doctorId==='')) p.doctorId=doctorId; }catch(e){}
    SAVE();
    TOAST('Medical record '+rec.code+' created');
    CLOSE();
    // Refresh the all-patients panel so the new record count/last-visit shows.
    try{ var c=document.getElementById('twhAllPatientsCard'); if(c) c.remove(); }catch(e){}
    if(thenPrescribe){
      setTimeout(function(){
        if(typeof window.rxmNewRxFor==='function'){ window.rxmNewRxFor(patientId, doctorId, rec.id); }
        else { TOAST('Prescription module unavailable','err'); RENDER(); }
      }, 120);
    } else {
      RENDER();
      // Make the freshly-stored record immediately visible from the frontend.
      setTimeout(function(){ try{ if(typeof window.twhViewRecords==='function') window.twhViewRecords(patientId); }catch(e){} }, 150);
    }
  };

  /* Give Prescription — reuse the app's patient-locked Rx flow. */
  window.twhPrescribeFor = function(patientId){
    var recs=recordsFor(patientId);
    var open=recs.filter(function(r){return r.status==='Open';}).sort(function(a,b){return String(b.visitDate||'').localeCompare(String(a.visitDate||''));})[0];
    var enc = open ? open.id : (recs.length?recs[recs.length-1].id:null);
    var p=patientsList().find(function(x){return x.id===patientId;})||{};
    var docId = (open&&open.doctorId)|| p.doctorId || null;
    if(typeof window.rxmNewRxFor==='function'){ window.rxmNewRxFor(patientId, docId, enc); }
    else { TOAST('Prescription module unavailable','err'); }
  };

  /* Open the full longitudinal chart. */
  window.twhOpenChart = function(patientId){
    if(typeof window.viewPatient==='function'){ window.viewPatient(patientId); }
    else { TOAST('Patient chart unavailable','err'); }
  };

  /* ══════════════════════════════════════════════════════════════════════
     VIEW RECORDS — render the patient's stored medical records in a
     detailed, standards-based layout (visible immediately after storing).
     Shows every field including the full vital-signs set with a PULSE column.
     ══════════════════════════════════════════════════════════════════════ */
  function vitalCell(label, value, unit){
    var v=(value==null||value===''||(typeof value==='number'&&isNaN(value)))?'\u2014':(esc(String(value))+(unit?(' '+unit):''));
    return '<div style="background:#f8fafc;border:1px solid var(--bdr,#e5e7eb);border-radius:8px;padding:7px 9px">'
      +'<div style="font-size:10px;color:var(--txt3,#64748b);text-transform:uppercase;letter-spacing:.4px">'+esc(label)+'</div>'
      +'<div style="font-size:14px;font-weight:700;color:var(--txt,#0f172a)">'+v+'</div></div>';
  }
  function recordCard(r){
    var bp=(r.bpSys!=null&&r.bpDia!=null)?(r.bpSys+'/'+r.bpDia+' mmHg'):(r.bpSys!=null?(r.bpSys+' mmHg'):null);
    var sec=function(title,html){ return html?('<div style="margin-top:8px"><div style="font-size:11px;font-weight:700;color:var(--pri,#0d9488);text-transform:uppercase;letter-spacing:.4px">'+esc(title)+'</div><div style="font-size:13px;color:var(--txt,#0f172a);white-space:pre-wrap">'+esc(html)+'</div></div>'):''; };
    return '<div style="border:1px solid var(--bdr,#e5e7eb);border-radius:12px;padding:14px;margin-bottom:12px">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px;border-bottom:1px solid var(--bdr,#e5e7eb);padding-bottom:8px;margin-bottom:8px">'
        +'<div><b style="color:var(--pri,#0d9488)">'+esc(r.code||('EMR-'+r.id))+'</b> '
          +'<span style="font-size:12px;color:var(--txt3)">\u00b7 '+esc(r.visitDate||'')+' \u00b7 '+esc(r.visitType||'')+'</span></div>'
        +'<div style="display:flex;gap:6px;align-items:center">'
          +'<span class="st" style="background:'+(r.status==='Finalized'?'#dcfce7;color:#166534':'#dbeafe;color:#1e40af')+';padding:2px 10px;border-radius:999px;font-size:11px;font-weight:700">'+esc(r.status||'Open')+'</span>'
          +'<span style="font-size:12px;color:var(--txt2)"><i class="fa-solid fa-user-doctor"></i> '+esc(docName(r.doctorId))+'</span>'
        +'</div>'
      +'</div>'
      +sec('Chief Complaint', r.complaint)
      +sec('History of Present Illness', r.historyIllness)
      +sec('Physical Examination', r.physicalExam)
      +'<div style="margin-top:8px"><div style="font-size:11px;font-weight:700;color:var(--pri,#0d9488);text-transform:uppercase;letter-spacing:.4px">Diagnosis</div>'
        +'<div style="font-size:13px;font-weight:600">'+esc(r.diagnosis||'\u2014')+(r.icd10?(' <span style="font-weight:400;color:var(--txt3)">('+esc(r.icd10)+')</span>'):'')+'</div>'
        +(r.diagnosisSecondary?('<div style="font-size:12px;color:var(--txt2)">Secondary: '+esc(r.diagnosisSecondary)+'</div>'):'')+'</div>'
      +sec('Treatment Plan', r.treatment)
      +'<div style="margin-top:10px"><div style="font-size:11px;font-weight:700;color:var(--pri,#0d9488);text-transform:uppercase;letter-spacing:.4px;margin-bottom:5px"><i class="fa-solid fa-heart-pulse"></i> Vital Signs</div>'
        +'<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:6px">'
          +vitalCell('BP', bp||null,'')
          +vitalCell('Pulse', r.pulse, 'bpm')
          +vitalCell('Heart Rate', r.hr, 'bpm')
          +vitalCell('Temp', r.temp, '\u00b0C')
          +vitalCell('Resp Rate', r.rr, '/min')
          +vitalCell('SpO2', r.spo2, '%')
          +vitalCell('Weight', r.weight, 'kg')
          +vitalCell('Height', r.height, 'cm')
          +vitalCell('BMI', r.bmi, '')
          +vitalCell('Pain', (r.painScore!=null?r.painScore+'/10':null), '')
        +'</div></div>'
      +(r.followUpDate||r.followUpNotes?('<div style="margin-top:10px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:8px 10px;font-size:12px"><b>Follow-up:</b> '+esc(r.followUpDate||'')+(r.followUpNotes?(' \u2014 '+esc(r.followUpNotes)):'')+'</div>'):'')
      +'<div style="display:flex;gap:6px;margin-top:10px">'
        +'<button class="btn btn-sm" style="background:#7c3aed;color:#fff;padding:4px 10px;font-size:11px" onclick="twhPrescribeFor('+r.patientId+')"><i class="fa-solid fa-prescription"></i> Prescribe</button>'
        +'<button class="btn btn-sm btn-ghost" style="padding:4px 10px;font-size:11px" onclick="twhOpenChart('+r.patientId+')"><i class="fa-solid fa-folder-open"></i> Full Chart</button>'
      +'</div>'
    +'</div>';
  }
  window.twhViewRecords = function(patientId){
    var p=patientsList().find(function(x){return x.id===patientId;})||{};
    var recs=recordsFor(patientId).slice().sort(function(a,b){return String(b.visitDate||'').localeCompare(String(a.visitDate||''));});
    var body=''
      +'<div style="padding:10px 12px;border-radius:10px;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff;margin-bottom:12px">'
        +'<div style="font-size:16px;font-weight:800">'+esc(p.fullName||('Patient '+patientId))+'</div>'
        +'<div style="font-size:12px;opacity:.95">'+esc(p.mrn||'')+' \u00b7 '+esc(p.gender||'\u2014')+' \u00b7 '+((p.age!=null&&p.age!=='')?(esc(p.age)+'y'):'\u2014')+' \u00b7 '+recs.length+' record'+(recs.length===1?'':'s')+'</div>'
      +'</div>'
      + (recs.length? recs.map(recordCard).join('') : '<div style="text-align:center;color:var(--txt3);padding:24px"><i class="fa-solid fa-folder-open" style="font-size:22px;opacity:.5"></i><div style="margin-top:8px">No medical records yet. Use <b>See Doctor</b> to create one.</div></div>');
    var footer=''
      +'<button class="btn btn-pri" onclick="closeModal();twhSeeDoctor('+patientId+')"><i class="fa-solid fa-user-doctor"></i> New Consultation</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Close</button>';
    MODAL('<i class="fa-solid fa-file-medical" style="color:#0d9488;margin-right:8px"></i>Medical Records', body, footer, 'wide');
  };

  /* ══════════════════════════════════════════════════════════════════════
     RENDER — the "All Registered Patients" panel injected into EMR module
     ══════════════════════════════════════════════════════════════════════ */
  function patientRow(p, i){
    var recs=recordsFor(p.id);
    var open=recs.filter(function(r){return r.status==='Open';}).length;
    var last=recs.map(function(r){return r.visitDate||'';}).sort().reverse()[0]||'';
    var statusPill = recs.length===0
      ? '<span class="st st-scheduled" style="background:#fef3c7;color:#92400e">No record</span>'
      : (open>0 ? '<span class="st st-partial" style="background:#dbeafe;color:#1e40af">'+open+' open</span>'
                : '<span class="st st-active" style="background:#dcfce7;color:#166534">'+recs.length+' record'+(recs.length>1?'s':'')+'</span>');
    var name=esc(p.fullName||p.name||('Patient '+p.id));
    var demo=esc((p.gender||'\u2014').charAt(0))+' \u00b7 '+((p.age!=null&&p.age!=='')?(esc(p.age)+'y'):'\u2014')+' \u00b7 '+esc(p.bloodGroup||'\u2014');
    return '<tr data-twh-name="'+name.toLowerCase()+'" data-twh-mrn="'+esc(String(p.mrn||'').toLowerCase())+'" data-twh-hasrec="'+(recs.length?'1':'0')+'">'
      +'<td style="color:var(--txt3)">'+(i+1)+'</td>'
      +'<td><b>'+esc(p.mrn||'\u2014')+'</b></td>'
      +'<td class="bold">'+name+'</td>'
      +'<td style="font-size:11px;color:var(--txt2)">'+demo+'</td>'
      +'<td>'+esc(docName(p.doctorId))+'</td>'
      +'<td style="text-align:center">'+recs.length+'</td>'
      +'<td>'+(last?esc(last):'\u2014')+'</td>'
      +'<td>'+statusPill+'</td>'+'<td class="ta-r nowrap"><button class="btn btn-sm btn-ghost" style="padding:4px 10px;font-size:11px" onclick="twhOpenChart('+p.id+')"><i class="fa-solid fa-folder-open"></i> Full Chart</button></td></tr>';
  }

  window.twhFilterPatients = function(){
    var q=(document.getElementById('twhPatSearch')||{}).value||''; q=q.toLowerCase().trim();
    var onlyNo=(document.getElementById('twhPatOnlyNoRec')||{}).checked;
    var rows=document.querySelectorAll('#twhAllPatientsTable tbody tr');
    var shown=0;
    rows.forEach(function(tr){
      var nm=tr.getAttribute('data-twh-name')||''; var mrn=tr.getAttribute('data-twh-mrn')||''; var has=tr.getAttribute('data-twh-hasrec')==='1';
      var match=(!q || nm.indexOf(q)>=0 || mrn.indexOf(q)>=0) && (!onlyNo || !has);
      tr.style.display=match?'':'none'; if(match) shown++;
    });
    var c=document.getElementById('twhPatCount'); if(c) c.textContent=shown+' shown';
  };

  function buildPanel(){
    var pts=patientsList();
    var withRec=pts.filter(function(p){return recordsFor(p.id).length>0;}).length;
    var head=''
      +'<div class="card" style="margin-bottom:16px" id="twhAllPatientsCard">'
      +'<div class="card-hd" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">'
        +'<h3 style="margin:0"><i class="fa-solid fa-users" style="color:#0d9488;margin-right:8px"></i>All Registered Patients '
          +'<span style="font-weight:400;color:var(--txt3);font-size:12px">('+pts.length+' registered \u00b7 '+withRec+' with records)</span></h3>'
        +'<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
          +'<input id="twhPatSearch" type="search" oninput="twhFilterPatients()" placeholder="Search name or MRN\u2026" style="padding:7px 12px;min-width:230px;border-radius:8px;border:1.5px solid var(--bdr,#d1d5db);font-size:12px">'
          +'<label style="font-size:11px;color:var(--txt2);display:flex;align-items:center;gap:4px;cursor:pointer"><input type="checkbox" id="twhPatOnlyNoRec" onchange="twhFilterPatients()"> Only without a record</label>'
          +'<span id="twhPatCount" style="font-size:11px;color:var(--txt3)">'+pts.length+' shown</span>'
        +'</div>'
      +'</div>'
      +'<div class="tbl-wrap"><table class="tbl" id="twhAllPatientsTable"><thead><tr>'
        +'<th>#</th><th>MRN</th><th>Patient</th><th>Demographics</th><th>Attending Doctor</th><th style="text-align:center">Records</th><th>Last Visit</th><th>Status</th><th class="ta-r">Actions</th>'
      +'</tr></thead><tbody>'
      + (pts.length? pts.map(patientRow).join('') : '<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:20px">No patients registered yet.</td></tr>')
      +'</tbody></table></div>'
      +'</div>';
    return head;
  }

  /* Cheap deterministic signature of everything the panel renders. When it is
     unchanged we do NOTHING (no DOM write) — this is what stops the panel from
     blinking / shaking during the core's continuous save->pull->save loop, which
     used to tear the whole card down and rebuild it on every tick. */
  function panelSig(){
    var pts=patientsList(); var d=D_();
    var mr=Array.isArray(d.medicalRecords)?d.medicalRecords:[];
    var s=pts.length+':'+mr.length+':';
    for(var i=0;i<pts.length;i++){ var p=pts[i]||{}; s+=(p.id||'')+'|'+(p.mrn||'')+'|'+(p.fullName||p.name||'')+'|'+(p.doctorId||'')+';'; }
    for(var j=0;j<mr.length;j++){ var r=mr[j]||{}; s+=(r.patientId||'')+'~'+(r.visitDate||'')+'~'+(r.status||'')+','; }
    return s;
  }

  var _applying=false; var _lastSig=null;
  function applyPanel(){
    if(_applying) return; _applying=true;
    try{
      if(CURMOD()!=='emr'){ _lastSig=null; return; }
      var app=document.getElementById('app'); if(!app) return;
      var card=document.getElementById('twhAllPatientsCard');
      var sig=panelSig();
      if(card){
        // Already present: only refresh the table body + counts IN PLACE when the
        // underlying data actually changed. Never tear the card down (no shake),
        // and never disturb the search box (preserve its value + focus).
        if(sig===_lastSig) return;                 // nothing changed → no write
        var tbody=card.querySelector('#twhAllPatientsTable tbody');
        if(tbody){
          var pts=patientsList();
          tbody.innerHTML = pts.length? pts.map(patientRow).join('') : '<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:20px">No patients registered yet.</td></tr>';
          // Refresh the header count + "N shown" without touching the search box.
          try{
            var withRec=pts.filter(function(p){return recordsFor(p.id).length>0;}).length;
            var cnt=card.querySelector('#twhPatCount'); if(cnt) cnt.textContent=pts.length+' shown';
            var hd=card.querySelector('.card-hd h3 span'); if(hd) hd.textContent='('+pts.length+' registered \u00b7 '+withRec+' with records)';
            if(typeof window.twhFilterPatients==='function') window.twhFilterPatients(); // re-apply active filter
          }catch(e){}
          _lastSig=sig;
        }
        return;
      }
      // Not present yet → insert the panel once, right after the KPI grid.
      // GUARD: only inject when the REAL EMR body is painted inside
      // #moduleContent (its .kpi-grid is there). If render() was capped and
      // #moduleContent is still the "Loading module…" card, inserting here would
      // drop the panel at app.firstChild — OUTSIDE #moduleContent — creating the
      // detached "All Registered Patients" orphan seen next to a stuck Loading
      // card. In that case do NOTHING this pass (leave _lastSig null) and let the
      // route-body verifier (v300) repaint the real EMR body first; we re-run on
      // the next DOMBus tick once .kpi-grid exists inside #moduleContent.
      var mc=document.getElementById('moduleContent');
      var kpi=mc?mc.querySelector('.kpi-grid'):null;
      if(!(kpi && kpi.parentNode)){ _lastSig=null; return; }
      var holder=document.createElement('div');
      holder.innerHTML=buildPanel();
      var node=holder.firstChild;
      kpi.parentNode.insertBefore(node, kpi.nextSibling);
      _lastSig=sig;
    }catch(e){ /* non-fatal */ }
    finally{ _applying=false; }
  }

  // Expose the panel builder so other packs (v211) can force a refresh.
  try{ window.__twhApplyEmrPanel = applyPanel; }catch(e){}
  // Re-assert after every render of the EMR module (idempotent + diff-guarded).
  [0,120,300,700,1400,2500].forEach(function(t){ setTimeout(applyPanel,t); });
  DOMBus.register(applyPanel);
  window.addEventListener('load', function(){ setTimeout(applyPanel,200); });
  // Refresh (in place, diff-guarded) after a save/hydrate pulls new data back.
  // NOTE: we intentionally do NOT remove the card here — applyPanel only rewrites
  // the <tbody> when panelSig() actually changed, so the save->pull loop no longer
  // makes the panel blink / shake.
  try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){ window.HMS_DB.onState(function(s){ if(s==='idle'){ setTimeout(applyPanel,150); } }); } }catch(e){}

})();

;

/* ==== /js/161-twh-emr-sync-fullchart-v211.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v211 — MEDICAL RECORDS LIVE SYNC + AUTHORITATIVE FULL MEDICAL RECORD CHART
   Fixes:
   • After creating a medical record (See Doctor / New Record), the EMR module
     KPIs (Total Records, Open, Finalized, Avg SpO2) and the All Registered
     Patients panel columns (Records, Last Visit, Status) now refresh
     immediately — the record shows up on the dashboard and per-patient rows.
   • The Full Medical Record chart (Open Chart) now shows CORRECT, live-synced
     counts and detail tables for: Appointments, Medical Records, Lab Orders,
     Radiology, Prescriptions, Diet Rx / Meal Plans — all pulled from D by
     patientId (robust number/string match), plus Bills.
   Idempotent, guarded by __twhV211.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV211) return; window.__twhV211 = true;

  function D_(){ return (typeof D!=='undefined'&&D)?D:(window.D||{}); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function TOAST(m,t){ try{ if(typeof window.toast==='function') return window.toast(m,t); }catch(e){} }
  function MODAL(a,b,c,d){ try{ if(typeof window.showModal==='function') return window.showModal(a,b,c,d); }catch(e){} }
  function CLOSE(){ try{ if(typeof window.closeModal==='function') return window.closeModal(); }catch(e){} }
  function RENDER(){ try{ if(typeof window.render==='function') return window.render(); }catch(e){} }
  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }

  function arr(x){ return Array.isArray(x)?x:[]; }
  function byPat(a, pid){ return arr(a).filter(function(r){ return r && (r.patientId===pid || String(r.patientId)===String(pid)); }); }
  function docName(id){ var e=(arr(D_().employees)).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('#'+id)):'\u2014'; }
  function deptName(id){ var e=(arr(D_().departments)).find(function(x){return x.id===id;}); return e?(e.name||('#'+id)):'\u2014'; }
  function patName(id){ var p=(arr(D_().patients)).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('#'+id)):'\u2014'; }

  /* ── Force EMR module to fully re-render so KPIs + panel reflect new data ─ */
  window.twhRefreshEMR = function(){
    // Full re-render regenerates renderEMR (KPIs recomputed from D.medicalRecords).
    // We do NOT manually remove the all-patients card — v210's applyPanel is now
    // signature-guarded and updates its <tbody> in place, so it refreshes without
    // any teardown/flicker after the render settles.
    RENDER();
    [30,150,400].forEach(function(t){ setTimeout(function(){ try{ if(typeof window.__twhApplyEmrPanel==='function') window.__twhApplyEmrPanel(); }catch(e){} }, t); });
  };

  /* Wrap twhSaveConsultation so every consultation save triggers a refresh. */
  function wrapSave(){
    if(window.__twhV211WrapSave) return;
    if(typeof window.twhSaveConsultation!=='function') return;
    var orig = window.twhSaveConsultation;
    window.twhSaveConsultation = function(patientId, thenPrescribe){
      var r = orig.apply(this, arguments);
      // After the record is pushed + saved, force the EMR dashboard to refresh
      // (unless we chained into prescribe, which will re-render on its own).
      if(!thenPrescribe){ setTimeout(function(){ try{ window.twhRefreshEMR(); }catch(e){} }, 60); }
      return r;
    };
    window.__twhV211WrapSave = true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     AUTHORITATIVE FULL MEDICAL RECORD CHART — twhFullChart(patientId)
     ══════════════════════════════════════════════════════════════════════ */
  function tableOf(rows, headers){
    if(!rows.length) return '<div style="text-align:center;color:var(--txt3);padding:18px;font-size:13px">No records.</div>';
    return '<div class="tbl-wrap"><table class="tbl"><thead><tr>'
      + headers.map(function(h){return '<th>'+esc(h)+'</th>';}).join('')
      + '</tr></thead><tbody>'+rows.join('')+'</tbody></table></div>';
  }
  function stPill(s){ return '<span class="st" style="padding:2px 8px;border-radius:999px;font-size:11px;font-weight:700;background:#e2e8f0;color:#334155">'+esc(s||'\u2014')+'</span>'; }

  window.twhFullChart = function(patientId){
    var d=D_();
    var p=(arr(d.patients)).find(function(x){return x.id===patientId || String(x.id)===String(patientId);});
    if(!p){ TOAST('Patient not found','err'); return; }

    var appts = byPat(d.appointments, patientId);
    var emr   = byPat(d.medicalRecords, patientId);
    var labs  = byPat(d.labTests, patientId).concat(byPat(d.labOrders, patientId));
    var rads  = byPat(d.radiologyOrders, patientId);
    var rxs   = byPat(d.prescriptions, patientId);
    var meals = byPat(d.mealPlans, patientId);
    var bills = byPat(d.bills, patientId);

    function tile(label, n, grad, tab){
      return '<div onclick="twhFcTab(\''+tab+'\')" style="cursor:pointer;flex:1;min-width:104px;background:'+grad+';color:#fff;border-radius:12px;padding:12px 10px;text-align:center;box-shadow:0 2px 8px rgba(0,0,0,.08)">'
        + '<div style="font-size:24px;font-weight:800;line-height:1">'+n+'</div>'
        + '<div style="font-size:11px;opacity:.92;margin-top:3px">'+esc(label)+'</div></div>';
    }

    var allergy=(p.allergies&&p.allergies!=='None'&&p.allergies!=='\u2014')?p.allergies:'';
    var header=''
      +'<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:10px;margin-bottom:12px;padding:12px 14px;border-radius:12px;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff">'
        +'<div><div style="font-size:18px;font-weight:800">'+esc(p.fullName||('Patient '+patientId))+'</div>'
          +'<div style="font-size:12px;opacity:.95;margin-top:2px">'+esc(p.mrn||'')+' \u00b7 '+esc(p.gender||'\u2014')+' \u00b7 '+((p.age!=null&&p.age!=='')?(esc(p.age)+'y'):'\u2014')+' \u00b7 Blood '+esc(p.bloodGroup||'\u2014')+' \u00b7 '+esc(p.status||'')+'</div>'
          +(allergy?'<div style="margin-top:6px;background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.35);padding:3px 10px;border-radius:999px;font-size:11px;font-weight:700;display:inline-block"><i class="fa-solid fa-triangle-exclamation"></i> Allergies: '+esc(allergy)+'</div>':'')
        +'</div>'
        +'<div style="text-align:right;font-size:12px;opacity:.95">Attending: <b>'+esc(docName(p.doctorId))+'</b><br>'+esc(deptName(p.deptId))+'</div>'
      +'</div>';

    var tiles=''
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px">'
        + tile('Appointments', appts.length, 'linear-gradient(135deg,#1e40af,#3b82f6)', 'appts')
        + tile('Medical Records', emr.length, 'linear-gradient(135deg,#065f46,#10b981)', 'emr')
        + tile('Lab Orders', labs.length, 'linear-gradient(135deg,#7c3aed,#a78bfa)', 'labs')
        + tile('Radiology', rads.length, 'linear-gradient(135deg,#b45309,#fbbf24)', 'rads')
        + tile('Prescriptions', rxs.length, 'linear-gradient(135deg,#be185d,#ec4899)', 'rx')
        + tile('Diet Rx / Meal Plans', meals.length, 'linear-gradient(135deg,#0d9488,#14b8a6)', 'meals')
      +'</div>';

    /* ── section builders ── */
    var apptTbl = tableOf(appts.slice().reverse().map(function(a){
      return '<tr><td><b>'+esc(a.code||'APT')+'</b></td><td>'+esc(a.date||'\u2014')+'</td><td>'+esc(a.time||'')+'</td><td>'+esc(docName(a.doctorId))+'</td><td>'+esc(a.type||'')+'</td><td>'+stPill(a.status)+'</td></tr>';
    }), ['Code','Date','Time','Doctor','Type','Status']);

    var emrTbl = tableOf(emr.slice().sort(function(a,b){return String(b.visitDate||'').localeCompare(String(a.visitDate||''));}).map(function(r){
      var vit=[]; if(r.pulse!=null&&r.pulse!=='') vit.push('P '+r.pulse); if(r.bpSys!=null) vit.push('BP '+r.bpSys+'/'+(r.bpDia!=null?r.bpDia:'')); if(r.temp!=null) vit.push('T '+r.temp); if(r.spo2!=null) vit.push('SpO2 '+r.spo2+'%');
      return '<tr><td><b>'+esc(r.code||'EMR')+'</b></td><td>'+esc(r.visitDate||r.date||'\u2014')+'</td><td>'+esc(r.visitType||'')+'</td><td>'+esc(docName(r.doctorId))+'</td><td style="max-width:200px">'+esc(r.diagnosis||'\u2014')+(r.icd10?(' <span style="color:var(--txt3)">('+esc(r.icd10)+')</span>'):'')+'</td><td style="font-size:11px;color:var(--txt2)">'+esc(vit.join(' \u00b7 ')||'\u2014')+'</td><td>'+stPill(r.status)
        +'</td><td style="white-space:nowrap"><button class="act-btn" title="View" onclick="closeModal();twhViewRecords('+patientId+')"><i class="fa-solid fa-eye"></i></button></td></tr>';
    }), ['Code','Date','Type','Doctor','Diagnosis','Vitals','Status','']);

    var labTbl = tableOf(labs.slice().reverse().map(function(l){
      return '<tr><td><b>'+esc(l.code||'LAB')+'</b></td><td>'+esc(l.orderDate||l.date||'\u2014')+'</td><td>'+esc(l.testType||l.test||l.category||'')+'</td><td>'+esc(docName(l.orderedBy||l.doctorId))+'</td><td>'+stPill(l.status)+'</td><td>'+(l.isAbnormal?'<span style="color:var(--red);font-weight:700">ABNORMAL</span>':(l.status==='Completed'?'<span style="color:var(--green)">Normal</span>':'\u2014'))+'</td></tr>';
    }), ['Code','Date','Test','Ordered By','Status','Result']);

    var radTbl = tableOf(rads.slice().reverse().map(function(r){
      return '<tr><td><b>'+esc(r.code||'RAD')+'</b></td><td>'+esc(r.orderDate||r.date||'\u2014')+'</td><td>'+esc(r.modality||'')+'</td><td>'+esc(r.examType||r.study||r.bodyPart||'')+'</td><td>'+esc(r.urgency||'')+'</td><td>'+stPill(r.status)+'</td></tr>';
    }), ['Code','Date','Modality','Exam','Urgency','Status']);

    var rxTbl = tableOf(rxs.slice().reverse().map(function(r){
      var meds=(arr(r.items).map(function(it){return it.name;}).filter(Boolean).join(', '))||'\u2014';
      return '<tr><td><b>'+esc(r.code||'RX')+'</b></td><td>'+esc(r.date||'\u2014')+'</td><td>'+esc(docName(r.doctorId))+'</td><td style="max-width:260px">'+esc(meds)+'</td><td>'+stPill(r.status)+'</td></tr>';
    }), ['Code','Date','Doctor','Medications','Status']);

    var mealTbl = tableOf(meals.slice().sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));}).map(function(m){
      var kcal=(m.planned&&(m.planned.kcal!=null?m.planned.kcal:m.planned.calories))||(m.target&&m.target.calories)||'\u2014';
      return '<tr><td><b>'+esc(m.code||'MP')+'</b></td><td>'+esc(m.date||'\u2014')+'</td><td>'+esc(m.dietType||m.diagnosis||'\u2014')+'</td><td>'+esc(kcal)+' kcal</td><td>'+stPill(m.status||'Active')+'</td><td>'+esc(m.createdBy||m.provider||'\u2014')+'</td></tr>';
    }), ['Code','Date','Diet / Dx','Calories','Status','By']);
    if(!meals.length){
      mealTbl='<div style="padding:12px;color:var(--txt3);font-size:13px;text-align:center">No meal plan / diet prescription on file. '
        +'<a href="#" style="color:#0d9488;font-weight:600;text-decoration:none" onclick="try{closeModal()}catch(e){};try{goTo(\'wellness\')}catch(e){};return false;">Open Meal Planner</a></div>';
    }

    function pane(id,label,html,show){ return '<div id="twhFc_'+id+'"'+(show?'':' style="display:none"')+'><h4 style="margin:6px 0 8px;color:var(--pri,#0d9488)">'+esc(label)+'</h4>'+html+'</div>'; }
    var body = header + tiles
      + pane('appts','Appointments', apptTbl, true)
      + pane('emr','Medical Records', emrTbl, false)
      + pane('labs','Lab Orders', labTbl, false)
      + pane('rads','Radiology', radTbl, false)
      + pane('rx','Prescriptions', rxTbl, false)
      + pane('meals','Diet Rx / Meal Plans', mealTbl, false);

    var footer=''
      +'<button class="btn btn-pri" onclick="closeModal();twhSeeDoctor('+patientId+')"><i class="fa-solid fa-user-doctor"></i> See Doctor</button>'
      +'<button class="btn" style="background:#7c3aed;color:#fff" onclick="twhPrescribeFor('+patientId+')"><i class="fa-solid fa-prescription"></i> Prescribe</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Close</button>';
    MODAL('<i class="fa-solid fa-folder-open" style="color:#0d9488;margin-right:8px"></i>Full Medical Record', body, footer, 'wide');
  };

  window.twhFcTab = function(tab){
    ['appts','emr','labs','rads','rx','meals'].forEach(function(t){
      var el=document.getElementById('twhFc_'+t); if(el) el.style.display=(t===tab)?'':'none';
    });
  };

  /* Rebind Open Chart to the authoritative full chart. */
  window.twhOpenChart = function(patientId){ window.twhFullChart(patientId); };

  /* ── boot: wrap save + periodic re-assert of the wrap ─────────────────── */
  [0,200,600,1500].forEach(function(t){ setTimeout(wrapSave,t); });
  DOMBus.register(wrapSave);

  console.log('\u2705 v211 EMR live-sync + full chart');
})();

;

/* ==== /js/162-twh-emr-unify-sync-v212.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v212 — UNIFIED FULL CHART + UNIVERSAL RECORD-MUTATION SYNC
   Builds on v210 (all-patients panel + See Doctor) and v211 (live-sync +
   authoritative Full Medical Record chart). Fixes the remaining gaps proven
   by the user's screenshots:
   • The NATIVE patient chart (viewPatient — the "Activity Summary /
     Meal Plans" view opened from the Patients registry) now routes to the
     SAME authoritative, live-synced Full Medical Record chart as the EMR
     panel's "Open Chart", so its Appointments / Medical Records / Lab Orders /
     Radiology / Diet Rx-Meal Plans counts & tables always match D.
   • ANY medical-record mutation now persists to D1 and refreshes the EMR
     dashboard (KPIs: Total/Open/Finalized/Avg SpO2) and the All Registered
     Patients panel (Records, Last Visit, Status): standard New Record
     (saveNewRecord), Finalize (finalizeRecord), and Edit (editRecord) — not
     just the See Doctor flow. Records now display right after creation.
   Idempotent, guarded by __twhV212.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV212) return; window.__twhV212 = true;

  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }

  /* Force the EMR dashboard (KPIs + all-patients panel) to refresh. Reuses
     v211's twhRefreshEMR when available; otherwise re-renders + rebuilds. */
  function refreshEMR(){
    try{
      if(typeof window.twhRefreshEMR==='function'){ window.twhRefreshEMR(); return; }
      var c=document.getElementById('twhAllPatientsCard'); if(c) c.remove();
      if(typeof window.render==='function') window.render();
      [30,150,400].forEach(function(t){ setTimeout(function(){ try{ if(typeof window.__twhApplyEmrPanel==='function') window.__twhApplyEmrPanel(); }catch(e){} }, t); });
    }catch(e){}
  }
  window.twhSyncAfterMutation = function(){
    SAVE();                                   // persist to D1 (create → database)
    if(CURMOD()==='emr'){ setTimeout(refreshEMR, 40); }  // reflect on the dashboard
  };

  /* ── 1) Unify the patient chart: native viewPatient → authoritative chart ─
     The full chart in v211 (twhFullChart) is the single source of truth. We
     route the native viewPatient there so BOTH entry points (Patients
     registry AND EMR panel) show identical, live-synced clinical data. The
     original viewPatient is preserved as twhNativeViewPatient for fallback. */
  function unifyChart(){
    if(window.__twhV212Chart) return;
    if(typeof window.twhFullChart!=='function') return;   // wait for v211
    if(typeof window.viewPatient==='function' && !window.viewPatient.__twhUnified){
      window.twhNativeViewPatient = window.viewPatient;
      var unified = function(id){
        try{ return window.twhFullChart(id); }
        catch(e){ try{ return window.twhNativeViewPatient(id); }catch(_){} }
      };
      unified.__twhUnified = true;
      window.viewPatient = unified;
      try{ if(typeof chart==='function'){ /* some builds alias chart→viewPatient */ } }catch(e){}
    }
    // Keep Open Chart pointing at the authoritative chart too.
    window.twhOpenChart = function(id){ return window.twhFullChart(id); };
    window.__twhV212Chart = true;
  }

  /* ── 2) Wrap record-mutation functions for universal persist + refresh ── */
  function wrapFn(name, shouldSync){
    var orig = window[name];
    if(typeof orig!=='function' || orig.__twhV212Wrapped) return false;
    var wrapped = function(){
      var r = orig.apply(this, arguments);
      try{ if(shouldSync.apply(this, arguments)) window.twhSyncAfterMutation(); }catch(e){}
      return r;
    };
    wrapped.__twhV212Wrapped = true;
    window[name] = wrapped;
    return true;
  }

  function wrapMutations(){
    // New generic record (medical records, appts, labs, rads, rx, meal plans, bills)
    wrapFn('saveNewRecord', function(dataKey){
      return ['medicalRecords','appointments','labTests','labOrders','radiologyOrders','prescriptions','mealPlans','bills'].indexOf(dataKey)>=0;
    });
    // Finalize a medical record (Open → Finalized) — must update KPI + status
    wrapFn('finalizeRecord', function(){ return true; });
    // Edit any of the clinical collections
    wrapFn('editRecord', function(dataKey){
      return ['medicalRecords','appointments','labTests','labOrders','radiologyOrders','prescriptions','mealPlans','bills'].indexOf(dataKey)>=0;
    });
    // Delete a record too
    if(typeof window.deleteRecord==='function') wrapFn('deleteRecord', function(dataKey){
      return ['medicalRecords','appointments','labTests','labOrders','radiologyOrders','prescriptions','mealPlans','bills'].indexOf(dataKey)>=0;
    });
  }

  function boot(){ unifyChart(); wrapMutations(); }
  [0,150,400,900,1800,3000].forEach(function(t){ setTimeout(boot,t); });
  DOMBus.register(boot);
  window.addEventListener('load', function(){ setTimeout(boot,250); });

  console.log('\u2705 v212 unified full chart');
})();

;